//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseAPI {
  constructor(protected configuration: Configuration) {}

  getBaseUrl(prefix: string, baseUrl: string) {
    const finalBaseUrl = baseUrl || this.configuration.basePath || BASE_PATH;
    return `${finalBaseUrl}${prefix}`;
  }
  
  private currentAbortController: AbortController = null;
  
  public abortPendingRequest(){
    this.currentAbortController?.abort();
  }
  
  async transformOptions(options: RequestInit): Promise<RequestInit> {
    const ctrl =  new AbortController();
    options.signal = ctrl.signal;
    this.currentAbortController = ctrl;
    options.headers = {
      ...options.headers,
      ...this.configuration.headers
    };
    
    if(this.configuration.beforeRequest){
      options = await this.configuration.beforeRequest(options);
    }
    return Promise.resolve(options);
  }

  async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => Promise<any>
  ): Promise<any> {
    this.currentAbortController = null;
    if(this.configuration.afterRequest){
      await this.configuration.afterRequest(response);
    }
    return processor(response);
  }
}

export interface IActivityApi {

    baseSearch(sObj: ActivitySearch): Promise<PaginatedResultsOfActivityGridDto>;

    get(activityId: number | undefined): Promise<ActivityDto>;

    save(dto: ActivityDto): Promise<number>;

    delete(activityId: number | undefined): Promise<void>;

    getDisplayName(activityId: number | undefined, languageId: number | undefined): Promise<string>;

    exportXlsFile(sObj: ActivitySearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ActivityApi extends BaseAPI implements IActivityApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ActivitySearch): Promise<PaginatedResultsOfActivityGridDto> {
        let url_ = this.baseUrl + "/api/Activity/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfActivityGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfActivityGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfActivityGridDto>(null as any);
    }

    get(activityId: number | undefined): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/Activity?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(null as any);
    }

    save(dto: ActivityDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Activity/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(activityId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Activity/delete?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDisplayName(activityId: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Activity/displayname?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ActivitySearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Activity/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Activity/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Activity/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IAffixDrupalApi {

    baseSearch(sObj: DrupalAffixSearch): Promise<PaginatedResultsOfAffixGridDto>;

    exportXlsFile(sObj: DrupalAffixSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class AffixDrupalApi extends BaseAPI implements IAffixDrupalApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DrupalAffixSearch): Promise<PaginatedResultsOfAffixGridDto> {
        let url_ = this.baseUrl + "/api/AffixDrupal/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAffixGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAffixGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAffixGridDto>(null as any);
    }

    exportXlsFile(sObj: DrupalAffixSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixDrupal/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AffixDrupal/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/AffixDrupal/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IAffixRequestApi {

    baseSearch(sObj: AffixRequestSearch): Promise<PaginatedResultsOfAffixRequestGridDto>;

    getNewKennelRequest(newKennelRequestId: number | undefined): Promise<NewKennelRequestDto>;

    saveNewKennelRequest(dto: NewKennelRequestDto): Promise<number>;

    getKennelNameChangeRequest(kennelNameChangeRequestId: number | undefined): Promise<KennelNameChangeRequestDto>;

    uploadFciDoc(files: FileParameter[] | null | undefined): Promise<Result>;

    getFciDocuments(requestType: ERequestType | undefined): Promise<FileResponse>;

    getImportKennelRequest(importKennelId: number | undefined): Promise<KennelImportRequestDto>;

    regenKennelApprovedDocument(requestId: number | undefined, type: ERequestType | undefined): Promise<number>;

    getExportKennelRequest(exportKennelRequestId: number | undefined): Promise<KennelExportRequestDto>;

    getKennelOwnershipChangeRequest(kennelOwnershipChangeRequestId: number | undefined): Promise<KennelOwnershipChangeRequestDto>;

    isPersonKennelOwnerQuery(personId: number | undefined): Promise<ResultOfBoolean>;

    isPersonOwnerOfKennelQuery(personId: number | undefined, kennelId: number | undefined): Promise<ResultOfBoolean>;

    isRequestComplete(requestId: number | undefined, requestType: ERequestType | undefined, requestState: ERequestState | undefined): Promise<Result>;

    saveKennelImportRequest(dto: KennelImportRequestDto): Promise<number>;

    saveKennelExportRequest(dto: KennelExportRequestDto): Promise<number>;

    saveKennelNameChangeRequest(dto: KennelNameChangeRequestDto): Promise<number>;

    saveKennelOwnershipChangeRequest(dto: KennelOwnershipChangeRequestDto): Promise<number>;

    closeAffixRequest(requestId: number | undefined): Promise<Result>;

    searchAffixRequestExport(requestType: ERequestType | undefined, sObj: AffixRequestExportSearch): Promise<PaginatedResultsOfAffixExportGridDto>;

    forceExport(requestId: number | undefined, requestType: ERequestType | undefined, value: boolean | undefined): Promise<ResultOfBoolean>;

    exportNewKennelRequests(sObj: AffixRequestExportSearch): Promise<FileResponse>;

    exportKennelImportRequests(sObj: AffixRequestExportSearch): Promise<FileResponse>;

    exportKennelExportRequests(sObj: AffixRequestExportSearch): Promise<FileResponse>;

    exportKennelNameChangeRequests(sObj: AffixRequestExportSearch): Promise<FileResponse>;

    exportOwnershipChangeRequests(sObj: AffixRequestExportSearch): Promise<FileResponse>;

    computeNewKennelImports(file: FileParameter | null | undefined): Promise<NewKennelRequestImportDto[]>;

    saveNewKennelImport(newKennelRequests: NewKennelRequestImportDto[]): Promise<Result>;

    computeImportRequestImports(file: FileParameter | null | undefined): Promise<KennelImportRequestImportDto[]>;

    saveImportRequestImport(importRequests: KennelImportRequestImportDto[]): Promise<Result>;

    computeNameChangeRequestImport(file: FileParameter | null | undefined): Promise<NameChangeRequestImporRequestDto[]>;

    saveNameChangeRequestImport(nameChangeRequests: NameChangeRequestImporRequestDto[]): Promise<Result>;

    computeOwnershipChangeRequestImport(file: FileParameter | null | undefined): Promise<OwnershipChangeRequestImporRequestDto[]>;

    saveOwnershipChangeRequestImport(nameChangeRequests: OwnershipChangeRequestImporRequestDto[]): Promise<Result>;

    exportXlsFile(sObj: AffixRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class AffixRequestApi extends BaseAPI implements IAffixRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: AffixRequestSearch): Promise<PaginatedResultsOfAffixRequestGridDto> {
        let url_ = this.baseUrl + "/api/AffixRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAffixRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAffixRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAffixRequestGridDto>(null as any);
    }

    getNewKennelRequest(newKennelRequestId: number | undefined): Promise<NewKennelRequestDto> {
        let url_ = this.baseUrl + "/api/AffixRequest?";
        if (newKennelRequestId === null)
            throw new Error("The parameter 'newKennelRequestId' cannot be null.");
        else if (newKennelRequestId !== undefined)
            url_ += "newKennelRequestId=" + encodeURIComponent("" + newKennelRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewKennelRequest(_response));
        });
    }

    protected processGetNewKennelRequest(response: Response): Promise<NewKennelRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewKennelRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewKennelRequestDto>(null as any);
    }

    saveNewKennelRequest(dto: NewKennelRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/AffixRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewKennelRequest(_response));
        });
    }

    protected processSaveNewKennelRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getKennelNameChangeRequest(kennelNameChangeRequestId: number | undefined): Promise<KennelNameChangeRequestDto> {
        let url_ = this.baseUrl + "/api/AffixRequest/getKennelNameChange?";
        if (kennelNameChangeRequestId === null)
            throw new Error("The parameter 'kennelNameChangeRequestId' cannot be null.");
        else if (kennelNameChangeRequestId !== undefined)
            url_ += "kennelNameChangeRequestId=" + encodeURIComponent("" + kennelNameChangeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennelNameChangeRequest(_response));
        });
    }

    protected processGetKennelNameChangeRequest(response: Response): Promise<KennelNameChangeRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelNameChangeRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelNameChangeRequestDto>(null as any);
    }

    uploadFciDoc(files: FileParameter[] | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/uploadFciDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFciDoc(_response));
        });
    }

    protected processUploadFciDoc(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getFciDocuments(requestType: ERequestType | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/getFciDocuments?";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFciDocuments(_response));
        });
    }

    protected processGetFciDocuments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getImportKennelRequest(importKennelId: number | undefined): Promise<KennelImportRequestDto> {
        let url_ = this.baseUrl + "/api/AffixRequest/getImportKennel?";
        if (importKennelId === null)
            throw new Error("The parameter 'importKennelId' cannot be null.");
        else if (importKennelId !== undefined)
            url_ += "importKennelId=" + encodeURIComponent("" + importKennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImportKennelRequest(_response));
        });
    }

    protected processGetImportKennelRequest(response: Response): Promise<KennelImportRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelImportRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelImportRequestDto>(null as any);
    }

    regenKennelApprovedDocument(requestId: number | undefined, type: ERequestType | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AffixRequest/regenApprovedDocument?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegenKennelApprovedDocument(_response));
        });
    }

    protected processRegenKennelApprovedDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getExportKennelRequest(exportKennelRequestId: number | undefined): Promise<KennelExportRequestDto> {
        let url_ = this.baseUrl + "/api/AffixRequest/getkennelExport?";
        if (exportKennelRequestId === null)
            throw new Error("The parameter 'exportKennelRequestId' cannot be null.");
        else if (exportKennelRequestId !== undefined)
            url_ += "exportKennelRequestId=" + encodeURIComponent("" + exportKennelRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExportKennelRequest(_response));
        });
    }

    protected processGetExportKennelRequest(response: Response): Promise<KennelExportRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelExportRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelExportRequestDto>(null as any);
    }

    getKennelOwnershipChangeRequest(kennelOwnershipChangeRequestId: number | undefined): Promise<KennelOwnershipChangeRequestDto> {
        let url_ = this.baseUrl + "/api/AffixRequest/getKennelOwnershipChange?";
        if (kennelOwnershipChangeRequestId === null)
            throw new Error("The parameter 'kennelOwnershipChangeRequestId' cannot be null.");
        else if (kennelOwnershipChangeRequestId !== undefined)
            url_ += "kennelOwnershipChangeRequestId=" + encodeURIComponent("" + kennelOwnershipChangeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennelOwnershipChangeRequest(_response));
        });
    }

    protected processGetKennelOwnershipChangeRequest(response: Response): Promise<KennelOwnershipChangeRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelOwnershipChangeRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelOwnershipChangeRequestDto>(null as any);
    }

    isPersonKennelOwnerQuery(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/AffixRequest/isPersonKennelOwner?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonKennelOwnerQuery(_response));
        });
    }

    protected processIsPersonKennelOwnerQuery(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isPersonOwnerOfKennelQuery(personId: number | undefined, kennelId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/AffixRequest/isPersonOwnerOfKennel?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonOwnerOfKennelQuery(_response));
        });
    }

    protected processIsPersonOwnerOfKennelQuery(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isRequestComplete(requestId: number | undefined, requestType: ERequestType | undefined, requestState: ERequestState | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/isRequestComplete?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        if (requestState === null)
            throw new Error("The parameter 'requestState' cannot be null.");
        else if (requestState !== undefined)
            url_ += "requestState=" + encodeURIComponent("" + requestState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsRequestComplete(_response));
        });
    }

    protected processIsRequestComplete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveKennelImportRequest(dto: KennelImportRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveKennelImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveKennelImportRequest(_response));
        });
    }

    protected processSaveKennelImportRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveKennelExportRequest(dto: KennelExportRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveKennelExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveKennelExportRequest(_response));
        });
    }

    protected processSaveKennelExportRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveKennelNameChangeRequest(dto: KennelNameChangeRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveKennelNameChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveKennelNameChangeRequest(_response));
        });
    }

    protected processSaveKennelNameChangeRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveKennelOwnershipChangeRequest(dto: KennelOwnershipChangeRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveKennelOwnershipChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveKennelOwnershipChangeRequest(_response));
        });
    }

    protected processSaveKennelOwnershipChangeRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    closeAffixRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/closeAffixRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseAffixRequest(_response));
        });
    }

    protected processCloseAffixRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    searchAffixRequestExport(requestType: ERequestType | undefined, sObj: AffixRequestExportSearch): Promise<PaginatedResultsOfAffixExportGridDto> {
        let url_ = this.baseUrl + "/api/AffixRequest/searchAffixRequestExport?";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchAffixRequestExport(_response));
        });
    }

    protected processSearchAffixRequestExport(response: Response): Promise<PaginatedResultsOfAffixExportGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAffixExportGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAffixExportGridDto>(null as any);
    }

    forceExport(requestId: number | undefined, requestType: ERequestType | undefined, value: boolean | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/AffixRequest/forceExport?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForceExport(_response));
        });
    }

    protected processForceExport(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportNewKennelRequests(sObj: AffixRequestExportSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/exportNewKennelRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportNewKennelRequests(_response));
        });
    }

    protected processExportNewKennelRequests(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportKennelImportRequests(sObj: AffixRequestExportSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/exportKennelImportRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportKennelImportRequests(_response));
        });
    }

    protected processExportKennelImportRequests(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportKennelExportRequests(sObj: AffixRequestExportSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/exportKennelExportRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportKennelExportRequests(_response));
        });
    }

    protected processExportKennelExportRequests(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportKennelNameChangeRequests(sObj: AffixRequestExportSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/exportKennelNameChangeRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportKennelNameChangeRequests(_response));
        });
    }

    protected processExportKennelNameChangeRequests(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportOwnershipChangeRequests(sObj: AffixRequestExportSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/exportOwnershipChangeRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportOwnershipChangeRequests(_response));
        });
    }

    protected processExportOwnershipChangeRequests(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    computeNewKennelImports(file: FileParameter | null | undefined): Promise<NewKennelRequestImportDto[]> {
        let url_ = this.baseUrl + "/api/AffixRequest/computeNewKennelImports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComputeNewKennelImports(_response));
        });
    }

    protected processComputeNewKennelImports(response: Response): Promise<NewKennelRequestImportDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewKennelRequestImportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewKennelRequestImportDto[]>(null as any);
    }

    saveNewKennelImport(newKennelRequests: NewKennelRequestImportDto[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveNewKennelImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newKennelRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewKennelImport(_response));
        });
    }

    protected processSaveNewKennelImport(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    computeImportRequestImports(file: FileParameter | null | undefined): Promise<KennelImportRequestImportDto[]> {
        let url_ = this.baseUrl + "/api/AffixRequest/computeImportRequestImports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComputeImportRequestImports(_response));
        });
    }

    protected processComputeImportRequestImports(response: Response): Promise<KennelImportRequestImportDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KennelImportRequestImportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelImportRequestImportDto[]>(null as any);
    }

    saveImportRequestImport(importRequests: KennelImportRequestImportDto[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveImportRequestImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveImportRequestImport(_response));
        });
    }

    protected processSaveImportRequestImport(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    computeNameChangeRequestImport(file: FileParameter | null | undefined): Promise<NameChangeRequestImporRequestDto[]> {
        let url_ = this.baseUrl + "/api/AffixRequest/computeNameChangeRequestImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComputeNameChangeRequestImport(_response));
        });
    }

    protected processComputeNameChangeRequestImport(response: Response): Promise<NameChangeRequestImporRequestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameChangeRequestImporRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NameChangeRequestImporRequestDto[]>(null as any);
    }

    saveNameChangeRequestImport(nameChangeRequests: NameChangeRequestImporRequestDto[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveNameChangeRequestImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nameChangeRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNameChangeRequestImport(_response));
        });
    }

    protected processSaveNameChangeRequestImport(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    computeOwnershipChangeRequestImport(file: FileParameter | null | undefined): Promise<OwnershipChangeRequestImporRequestDto[]> {
        let url_ = this.baseUrl + "/api/AffixRequest/computeOwnershipChangeRequestImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComputeOwnershipChangeRequestImport(_response));
        });
    }

    protected processComputeOwnershipChangeRequestImport(response: Response): Promise<OwnershipChangeRequestImporRequestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnershipChangeRequestImporRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OwnershipChangeRequestImporRequestDto[]>(null as any);
    }

    saveOwnershipChangeRequestImport(nameChangeRequests: OwnershipChangeRequestImporRequestDto[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/AffixRequest/saveOwnershipChangeRequestImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nameChangeRequests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveOwnershipChangeRequestImport(_response));
        });
    }

    protected processSaveOwnershipChangeRequestImport(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: AffixRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AffixRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/AffixRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IAffixRequestExportApi {

    baseSearch(sObj: AffixRequestExportSearch): Promise<PaginatedResultsOfAffixExportGridDto>;

    searchAffixRequestExport(requestType: ERequestType | undefined, sObj: AffixRequestExportSearch): Promise<PaginatedResultsOfAffixExportGridDto>;

    exportXlsFile(sObj: AffixRequestExportSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class AffixRequestExportApi extends BaseAPI implements IAffixRequestExportApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: AffixRequestExportSearch): Promise<PaginatedResultsOfAffixExportGridDto> {
        let url_ = this.baseUrl + "/api/AffixRequestExport/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfAffixExportGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAffixExportGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAffixExportGridDto>(null as any);
    }

    searchAffixRequestExport(requestType: ERequestType | undefined, sObj: AffixRequestExportSearch): Promise<PaginatedResultsOfAffixExportGridDto> {
        let url_ = this.baseUrl + "/api/AffixRequestExport/searchAffixRequestExport?";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchAffixRequestExport(_response));
        });
    }

    protected processSearchAffixRequestExport(response: Response): Promise<PaginatedResultsOfAffixExportGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfAffixExportGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfAffixExportGridDto>(null as any);
    }

    exportXlsFile(sObj: AffixRequestExportSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AffixRequestExport/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AffixRequestExport/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/AffixRequestExport/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IAllJudgesForBreedApi {

    baseSearch(sObj: BaseBreedSearch): Promise<PaginatedResultsOfJudgeGridDto>;

    exportXlsFile(sObj: BaseBreedSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class AllJudgesForBreedApi extends BaseAPI implements IAllJudgesForBreedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BaseBreedSearch): Promise<PaginatedResultsOfJudgeGridDto> {
        let url_ = this.baseUrl + "/api/AllJudgesForBreed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeGridDto>(null as any);
    }

    exportXlsFile(sObj: BaseBreedSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AllJudgesForBreed/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AllJudgesForBreed/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/AllJudgesForBreed/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IAllowedColorsForBreedApi {

    baseSearch(sObj: BreedColorSearch): Promise<PaginatedResultsOfBreedColorDto>;

    getIds(sObj: BreedColorSearch): Promise<number[]>;

    save(dto: SaveColorsAllowedBreedsDto): Promise<SaveColorsAllowedBreedsDto>;

    exportXlsFile(sObj: BreedColorSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class AllowedColorsForBreedApi extends BaseAPI implements IAllowedColorsForBreedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedColorSearch): Promise<PaginatedResultsOfBreedColorDto> {
        let url_ = this.baseUrl + "/api/AllowedColorsForBreed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedColorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedColorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedColorDto>(null as any);
    }

    getIds(sObj: BreedColorSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/AllowedColorsForBreed/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    save(dto: SaveColorsAllowedBreedsDto): Promise<SaveColorsAllowedBreedsDto> {
        let url_ = this.baseUrl + "/api/AllowedColorsForBreed/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<SaveColorsAllowedBreedsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveColorsAllowedBreedsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveColorsAllowedBreedsDto>(null as any);
    }

    exportXlsFile(sObj: BreedColorSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AllowedColorsForBreed/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AllowedColorsForBreed/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/AllowedColorsForBreed/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IArticleApi {

    baseSearch(sObj: ArticleSearch): Promise<PaginatedResultsOfArticleGridDto>;

    getArticle(id: number | undefined): Promise<ArticleDto>;

    saveArticle(dto: ArticleDto): Promise<number>;

    saveBcArticle(articleId: number | undefined): Promise<number>;

    getDisplayName(articleId: number | undefined): Promise<string>;

    exportXlsFile(sObj: ArticleSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ArticleApi extends BaseAPI implements IArticleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ArticleSearch): Promise<PaginatedResultsOfArticleGridDto> {
        let url_ = this.baseUrl + "/api/Article/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfArticleGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfArticleGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfArticleGridDto>(null as any);
    }

    getArticle(id: number | undefined): Promise<ArticleDto> {
        let url_ = this.baseUrl + "/api/Article?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArticle(_response));
        });
    }

    protected processGetArticle(response: Response): Promise<ArticleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    saveArticle(dto: ArticleDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveArticle(_response));
        });
    }

    protected processSaveArticle(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveBcArticle(articleId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Article/saveBc?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBcArticle(_response));
        });
    }

    protected processSaveBcArticle(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(articleId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Article/getDisplayName?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ArticleSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Article/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Article/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Article/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IAvailableJudgesApi {

    baseSearch(sObj: ClubJudgeSearch): Promise<PaginatedResultsOfJudgeGridDto>;

    exportXlsFile(sObj: ClubJudgeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class AvailableJudgesApi extends BaseAPI implements IAvailableJudgesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubJudgeSearch): Promise<PaginatedResultsOfJudgeGridDto> {
        let url_ = this.baseUrl + "/api/AvailableJudges/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeGridDto>(null as any);
    }

    exportXlsFile(sObj: ClubJudgeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AvailableJudges/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/AvailableJudges/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/AvailableJudges/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedApi {

    baseSearch(sObj: BreedSearch): Promise<PaginatedResultsOfBreedGridDto>;

    searchUngrouped(sObj: BreedSearch): Promise<PaginatedResultsOfBreedGridDto>;

    get(breedId: number | undefined): Promise<BreedDto>;

    save(dto: BreedDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    getBreedColors(breedId: number | undefined): Promise<BreedColorSaveDto>;

    getBelgianBreeds(): Promise<BreedDto[]>;

    saveBreedColors(toSave: BreedColorSaveDto): Promise<number>;

    officialNameUnique(breedId: number | undefined, officialName: string | null | undefined): Promise<ResultOfBoolean>;

    getAllowedWorkbookType(breedId: number | undefined, languageId: number | undefined): Promise<WorkbookTypeGridDto[]>;

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string>;

    saveWorkbookTypes(dto: BreedWorkbookTypeSaveDto): Promise<BreedWorkbookTypeSaveDto>;

    getIds(sObj: BreedSearch): Promise<number[]>;

    getAllBreeds(): Promise<BreedGridDto[]>;

    createInSharepoint(breedId: number): Promise<string>;

    exportXlsFile(sObj: BreedSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedApi extends BaseAPI implements IBreedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedSearch): Promise<PaginatedResultsOfBreedGridDto> {
        let url_ = this.baseUrl + "/api/Breed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedGridDto>(null as any);
    }

    searchUngrouped(sObj: BreedSearch): Promise<PaginatedResultsOfBreedGridDto> {
        let url_ = this.baseUrl + "/api/Breed/SearchUngrouped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchUngrouped(_response));
        });
    }

    protected processSearchUngrouped(response: Response): Promise<PaginatedResultsOfBreedGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedGridDto>(null as any);
    }

    get(breedId: number | undefined): Promise<BreedDto> {
        let url_ = this.baseUrl + "/api/Breed?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<BreedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedDto>(null as any);
    }

    save(dto: BreedDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Breed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Breed?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getBreedColors(breedId: number | undefined): Promise<BreedColorSaveDto> {
        let url_ = this.baseUrl + "/api/Breed/getBreedColors?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedColors(_response));
        });
    }

    protected processGetBreedColors(response: Response): Promise<BreedColorSaveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedColorSaveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedColorSaveDto>(null as any);
    }

    getBelgianBreeds(): Promise<BreedDto[]> {
        let url_ = this.baseUrl + "/api/Breed/getBelgianBreeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBelgianBreeds(_response));
        });
    }

    protected processGetBelgianBreeds(response: Response): Promise<BreedDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedDto[]>(null as any);
    }

    saveBreedColors(toSave: BreedColorSaveDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Breed/saveBreedColors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBreedColors(_response));
        });
    }

    protected processSaveBreedColors(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    officialNameUnique(breedId: number | undefined, officialName: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Breed/OfficialNameUnique?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        if (officialName !== undefined && officialName !== null)
            url_ += "officialName=" + encodeURIComponent("" + officialName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOfficialNameUnique(_response));
        });
    }

    protected processOfficialNameUnique(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getAllowedWorkbookType(breedId: number | undefined, languageId: number | undefined): Promise<WorkbookTypeGridDto[]> {
        let url_ = this.baseUrl + "/api/Breed/AllowedWorkbookType?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllowedWorkbookType(_response));
        });
    }

    protected processGetAllowedWorkbookType(response: Response): Promise<WorkbookTypeGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkbookTypeGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkbookTypeGridDto[]>(null as any);
    }

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Breed/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveWorkbookTypes(dto: BreedWorkbookTypeSaveDto): Promise<BreedWorkbookTypeSaveDto> {
        let url_ = this.baseUrl + "/api/Breed/SaveWorkbookTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveWorkbookTypes(_response));
        });
    }

    protected processSaveWorkbookTypes(response: Response): Promise<BreedWorkbookTypeSaveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedWorkbookTypeSaveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedWorkbookTypeSaveDto>(null as any);
    }

    getIds(sObj: BreedSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Breed/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getAllBreeds(): Promise<BreedGridDto[]> {
        let url_ = this.baseUrl + "/api/Breed/allBreeds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllBreeds(_response));
        });
    }

    protected processGetAllBreeds(response: Response): Promise<BreedGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreedGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedGridDto[]>(null as any);
    }

    createInSharepoint(breedId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Breed/CreateInSharepoint/{breedId}";
        if (breedId === undefined || breedId === null)
            throw new Error("The parameter 'breedId' must be defined.");
        url_ = url_.replace("{breedId}", encodeURIComponent("" + breedId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: BreedSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Breed/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Breed/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Breed/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedersApi {

    baseSearch(sObj: BreederSearch): Promise<PaginatedResultsOfBreederGridDto>;

    exportXlsFile(sObj: BreederSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedersApi extends BaseAPI implements IBreedersApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreederSearch): Promise<PaginatedResultsOfBreederGridDto> {
        let url_ = this.baseUrl + "/api/Breeders/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreederGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreederGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreederGridDto>(null as any);
    }

    exportXlsFile(sObj: BreederSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Breeders/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Breeders/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Breeders/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedersDogsApi {

    baseSearch(sObj: BreederDogsSearch): Promise<PaginatedResultsOfBreederDogsGridDto>;

    exportXlsFile(sObj: BreederDogsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedersDogsApi extends BaseAPI implements IBreedersDogsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreederDogsSearch): Promise<PaginatedResultsOfBreederDogsGridDto> {
        let url_ = this.baseUrl + "/api/BreedersDogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreederDogsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreederDogsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreederDogsGridDto>(null as any);
    }

    exportXlsFile(sObj: BreederDogsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedersDogs/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedersDogs/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedersDogs/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedExceptionsApi {

    baseSearch(sObj: BreedVarietyAndExceptionSearch): Promise<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto>;

    saveBreedException(dto: SaveBreedVarietyAndExceptionDto): Promise<number>;

    deleteBreedException(currentBreedId: number | undefined, breedVarietyId: number | undefined): Promise<void>;

    exportXlsFile(sObj: BreedVarietyAndExceptionSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedExceptionsApi extends BaseAPI implements IBreedExceptionsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedVarietyAndExceptionSearch): Promise<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto> {
        let url_ = this.baseUrl + "/api/BreedExceptions/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedVarietiesAndExceptionsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto>(null as any);
    }

    saveBreedException(dto: SaveBreedVarietyAndExceptionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BreedExceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBreedException(_response));
        });
    }

    protected processSaveBreedException(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteBreedException(currentBreedId: number | undefined, breedVarietyId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/BreedExceptions?";
        if (currentBreedId === null)
            throw new Error("The parameter 'currentBreedId' cannot be null.");
        else if (currentBreedId !== undefined)
            url_ += "currentBreedId=" + encodeURIComponent("" + currentBreedId) + "&";
        if (breedVarietyId === null)
            throw new Error("The parameter 'breedVarietyId' cannot be null.");
        else if (breedVarietyId !== undefined)
            url_ += "breedVarietyId=" + encodeURIComponent("" + breedVarietyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteBreedException(_response));
        });
    }

    protected processDeleteBreedException(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: BreedVarietyAndExceptionSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedExceptions/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedExceptions/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedExceptions/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedForJudgeApi {

    baseSearch(sObj: BreedForJudgeSearch): Promise<PaginatedResultsOfBreedGridDto>;

    exportXlsFile(sObj: BreedForJudgeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedForJudgeApi extends BaseAPI implements IBreedForJudgeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedForJudgeSearch): Promise<PaginatedResultsOfBreedGridDto> {
        let url_ = this.baseUrl + "/api/BreedForJudge/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedGridDto>(null as any);
    }

    exportXlsFile(sObj: BreedForJudgeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedForJudge/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedForJudge/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedForJudge/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedGroupBreedApi {

    baseSearch(sObj: BreedGroupBreedSearch): Promise<PaginatedResultsOfBreedGroupBreedDto>;

    getIds(sObj: BreedGroupBreedSearch): Promise<number[]>;

    save(dto: BreedGroupBreedSaveDto): Promise<BreedGroupBreedSaveDto>;

    hierarchy(sObj: BreedGroupBreedHierarchySearch): Promise<PaginatedResultsOfBreedGroupBreedHierarchyDto>;

    exportXlsFile(sObj: BreedGroupBreedSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedGroupBreedApi extends BaseAPI implements IBreedGroupBreedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedGroupBreedSearch): Promise<PaginatedResultsOfBreedGroupBreedDto> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedGroupBreedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedGroupBreedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedGroupBreedDto>(null as any);
    }

    getIds(sObj: BreedGroupBreedSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    save(dto: BreedGroupBreedSaveDto): Promise<BreedGroupBreedSaveDto> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<BreedGroupBreedSaveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedGroupBreedSaveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedGroupBreedSaveDto>(null as any);
    }

    hierarchy(sObj: BreedGroupBreedHierarchySearch): Promise<PaginatedResultsOfBreedGroupBreedHierarchyDto> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/Hierarchy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHierarchy(_response));
        });
    }

    protected processHierarchy(response: Response): Promise<PaginatedResultsOfBreedGroupBreedHierarchyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedGroupBreedHierarchyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedGroupBreedHierarchyDto>(null as any);
    }

    exportXlsFile(sObj: BreedGroupBreedSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedGroupBreed/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedGroupApi {

    baseSearch(sObj: BreedGroupSearch): Promise<PaginatedResultsOfBreedGroupGridDto>;

    get(id: number | undefined): Promise<BreedGroupDto>;

    save(dto: BreedGroupDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    isBreedGroupNumberUnique(breedGroupId: number | undefined, breedGroupNumber: number | undefined): Promise<BooleanDto>;

    getDisplayName(id: number | undefined): Promise<string>;

    getIds(sObj: BreedGroupSearch): Promise<number[]>;

    exportXlsFile(sObj: BreedGroupSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedGroupApi extends BaseAPI implements IBreedGroupApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedGroupSearch): Promise<PaginatedResultsOfBreedGroupGridDto> {
        let url_ = this.baseUrl + "/api/BreedGroup/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedGroupGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedGroupGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedGroupGridDto>(null as any);
    }

    get(id: number | undefined): Promise<BreedGroupDto> {
        let url_ = this.baseUrl + "/api/BreedGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<BreedGroupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedGroupDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedGroupDto>(null as any);
    }

    save(dto: BreedGroupDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BreedGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BreedGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isBreedGroupNumberUnique(breedGroupId: number | undefined, breedGroupNumber: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/BreedGroup/IsBreedGroupNumberUnique?";
        if (breedGroupId === null)
            throw new Error("The parameter 'breedGroupId' cannot be null.");
        else if (breedGroupId !== undefined)
            url_ += "breedGroupId=" + encodeURIComponent("" + breedGroupId) + "&";
        if (breedGroupNumber === null)
            throw new Error("The parameter 'breedGroupNumber' cannot be null.");
        else if (breedGroupNumber !== undefined)
            url_ += "breedGroupNumber=" + encodeURIComponent("" + breedGroupNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBreedGroupNumberUnique(_response));
        });
    }

    protected processIsBreedGroupNumberUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getDisplayName(id: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/BreedGroup/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getIds(sObj: BreedGroupSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BreedGroup/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: BreedGroupSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedGroup/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedGroup/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedGroup/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedGroupJudgeApi {

    baseSearch(sObj: BreedGroupJudgeSearch): Promise<PaginatedResultsOfJudgeGridDto>;

    save(dto: BreedGroupJudgeSaveDto): Promise<BreedGroupJudgeSaveDto>;

    searchSelectedIds(sObj: BreedGroupJudgeSearch): Promise<number[]>;

    searchLinkedIdsForPerson(sObj: BreedGroupJudgeForPersonSearch): Promise<number[]>;

    exportXlsFile(sObj: BreedGroupJudgeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedGroupJudgeApi extends BaseAPI implements IBreedGroupJudgeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedGroupJudgeSearch): Promise<PaginatedResultsOfJudgeGridDto> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeGridDto>(null as any);
    }

    save(dto: BreedGroupJudgeSaveDto): Promise<BreedGroupJudgeSaveDto> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<BreedGroupJudgeSaveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedGroupJudgeSaveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedGroupJudgeSaveDto>(null as any);
    }

    searchSelectedIds(sObj: BreedGroupJudgeSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge/SelectedIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchSelectedIds(_response));
        });
    }

    protected processSearchSelectedIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    searchLinkedIdsForPerson(sObj: BreedGroupJudgeForPersonSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge/linkedIdsForPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchLinkedIdsForPerson(_response));
        });
    }

    protected processSearchLinkedIdsForPerson(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: BreedGroupJudgeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedGroupJudge/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedJudgeApi {

    baseSearch(sObj: BreedJudgeSearch): Promise<PaginatedResultsOfBreedJudgeGridDto>;

    saveBreedJudge(dto: SaveBreedJudgeDto): Promise<number>;

    getBreedJudge(breedJudgeId: number | undefined): Promise<SaveBreedJudgeDto>;

    deleteBreedJudge(breedJudgeId: number | undefined): Promise<void>;

    exportXlsFile(sObj: BreedJudgeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedJudgeApi extends BaseAPI implements IBreedJudgeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedJudgeSearch): Promise<PaginatedResultsOfBreedJudgeGridDto> {
        let url_ = this.baseUrl + "/api/BreedJudge/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedJudgeGridDto>(null as any);
    }

    saveBreedJudge(dto: SaveBreedJudgeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BreedJudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBreedJudge(_response));
        });
    }

    protected processSaveBreedJudge(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getBreedJudge(breedJudgeId: number | undefined): Promise<SaveBreedJudgeDto> {
        let url_ = this.baseUrl + "/api/BreedJudge?";
        if (breedJudgeId === null)
            throw new Error("The parameter 'breedJudgeId' cannot be null.");
        else if (breedJudgeId !== undefined)
            url_ += "breedJudgeId=" + encodeURIComponent("" + breedJudgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedJudge(_response));
        });
    }

    protected processGetBreedJudge(response: Response): Promise<SaveBreedJudgeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveBreedJudgeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveBreedJudgeDto>(null as any);
    }

    deleteBreedJudge(breedJudgeId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/BreedJudge?";
        if (breedJudgeId === null)
            throw new Error("The parameter 'breedJudgeId' cannot be null.");
        else if (breedJudgeId !== undefined)
            url_ += "breedJudgeId=" + encodeURIComponent("" + breedJudgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteBreedJudge(_response));
        });
    }

    protected processDeleteBreedJudge(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: BreedJudgeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedJudge/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedJudge/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedJudge/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedsColorsApi {

    baseSearch(sObj: BreedsColorsSearch): Promise<PaginatedResultsOfBreedColorDto>;

    getAvailableColorsForBreed(sObj: AvailableColorForBreedSearch): Promise<PaginatedResultsOfColorDto>;

    addNewColor(dto: SaveBreedAllowedColorsDto): Promise<number>;

    deleteColor(id: number | undefined): Promise<void>;

    exportXlsFile(sObj: BreedsColorsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedsColorsApi extends BaseAPI implements IBreedsColorsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedsColorsSearch): Promise<PaginatedResultsOfBreedColorDto> {
        let url_ = this.baseUrl + "/api/BreedsColors/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedColorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedColorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedColorDto>(null as any);
    }

    getAvailableColorsForBreed(sObj: AvailableColorForBreedSearch): Promise<PaginatedResultsOfColorDto> {
        let url_ = this.baseUrl + "/api/BreedsColors/GetAvailableColorsForBreed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableColorsForBreed(_response));
        });
    }

    protected processGetAvailableColorsForBreed(response: Response): Promise<PaginatedResultsOfColorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfColorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfColorDto>(null as any);
    }

    addNewColor(dto: SaveBreedAllowedColorsDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BreedsColors/addColor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddNewColor(_response));
        });
    }

    protected processAddNewColor(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteColor(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/BreedsColors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteColor(_response));
        });
    }

    protected processDeleteColor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: BreedsColorsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedsColors/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedsColors/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedsColors/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedVarietyApi {

    baseSearch(sObj: BreedVarietyAndExceptionSearch): Promise<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto>;

    saveBreedVariety(dto: SaveBreedVarietyAndExceptionDto): Promise<number>;

    deleteBreedVariety(currentBreedId: number | undefined, breedVarietyId: number | undefined): Promise<void>;

    exportXlsFile(sObj: BreedVarietyAndExceptionSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedVarietyApi extends BaseAPI implements IBreedVarietyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedVarietyAndExceptionSearch): Promise<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto> {
        let url_ = this.baseUrl + "/api/BreedVariety/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedVarietiesAndExceptionsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedVarietiesAndExceptionsGridDto>(null as any);
    }

    saveBreedVariety(dto: SaveBreedVarietyAndExceptionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BreedVariety";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBreedVariety(_response));
        });
    }

    protected processSaveBreedVariety(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteBreedVariety(currentBreedId: number | undefined, breedVarietyId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/BreedVariety?";
        if (currentBreedId === null)
            throw new Error("The parameter 'currentBreedId' cannot be null.");
        else if (currentBreedId !== undefined)
            url_ += "currentBreedId=" + encodeURIComponent("" + currentBreedId) + "&";
        if (breedVarietyId === null)
            throw new Error("The parameter 'breedVarietyId' cannot be null.");
        else if (breedVarietyId !== undefined)
            url_ += "breedVarietyId=" + encodeURIComponent("" + breedVarietyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteBreedVariety(_response));
        });
    }

    protected processDeleteBreedVariety(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: BreedVarietyAndExceptionSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedVariety/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedVariety/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedVariety/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBreedWorkbookTypeApi {

    baseSearch(sObj: BreedWorkbookTypeSearch): Promise<PaginatedResultsOfBreedWorkbookTypeDto>;

    getIds(sObj: BreedWorkbookTypeSearch): Promise<number[]>;

    save(dto: SaveWorkbookTypeAllowedBreedsDto): Promise<SaveWorkbookTypeAllowedBreedsDto>;

    exportXlsFile(sObj: BreedWorkbookTypeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BreedWorkbookTypeApi extends BaseAPI implements IBreedWorkbookTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BreedWorkbookTypeSearch): Promise<PaginatedResultsOfBreedWorkbookTypeDto> {
        let url_ = this.baseUrl + "/api/BreedWorkbookType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBreedWorkbookTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBreedWorkbookTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBreedWorkbookTypeDto>(null as any);
    }

    getIds(sObj: BreedWorkbookTypeSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/BreedWorkbookType/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    save(dto: SaveWorkbookTypeAllowedBreedsDto): Promise<SaveWorkbookTypeAllowedBreedsDto> {
        let url_ = this.baseUrl + "/api/BreedWorkbookType/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<SaveWorkbookTypeAllowedBreedsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveWorkbookTypeAllowedBreedsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveWorkbookTypeAllowedBreedsDto>(null as any);
    }

    exportXlsFile(sObj: BreedWorkbookTypeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreedWorkbookType/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BreedWorkbookType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BreedWorkbookType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBroodRequestApi {

    baseSearch(sObj: BroodRequestSearch): Promise<PaginatedResultsOfBroodRequestGridDto>;

    get(broodRequestId: number | undefined): Promise<BroodRequestDto>;

    save(dto: BroodRequestDto): Promise<number>;

    getPuppyPicture(driveItemIds: string[]): Promise<string[]>;

    generatePedigreeSample(requestId: number | undefined): Promise<Result>;

    resurrectPuppy(dogBroodRequestTransientId: number | undefined): Promise<Result>;

    getDrupal(broodRequestId: number | undefined): Promise<DrupalBroodRequestDto>;

    isGenealogyComplete(broodRequestId: number | undefined): Promise<boolean>;

    isSrshPedigreeWanted(broodRequestId: number | undefined): Promise<boolean>;

    isBrcsRequest(broodRequestId: number | undefined): Promise<boolean>;

    getAs400GenealogyCondition(broodRequestId: number | undefined): Promise<DogAs400ConditionDto[]>;

    switchToLoshPedigree(requestId: number | undefined): Promise<number>;

    reprintPedigrees(broodRequestId: number | undefined): Promise<Result>;

    getFathersName(broodRequestId: number | undefined): Promise<string[]>;

    getWithPuppies(broodRequestId: number | undefined): Promise<BroodRequestDto>;

    isBabyDogAuthorized(broodRequestId: number | undefined): Promise<ResultOfBoolean>;

    getPuppyReport(info: BroodRequesReportDetailDto): Promise<FileDto>;

    getAvailableBabyDog(breedId: number | undefined, isBrcs: boolean | undefined): Promise<BabyDogPublicationDto[]>;

    setPuppyDeceased(dogBroodTransientRequestId: number | undefined, platform: EPlatform | null | undefined): Promise<Result>;

    reprintExecutionLetter(broodRequestId: number | undefined): Promise<Result>;

    closeRequest(requestId: number | undefined): Promise<Result>;

    addPotentialFather(broodRequestId: number | undefined, newFatherId: number | undefined): Promise<Result>;

    computePuppiesPedigree(broodRequestId: number | undefined): Promise<Result>;

    getPuppyFutureGenealogy(broodRequestId: number | undefined, generation: number | undefined): Promise<PuppyGenealogyDto[]>;

    getDogConditions(broodRequestId: number | undefined, languageId: number | undefined): Promise<DogConditionDto[]>;

    checkNeededConditions(broodRequestId: number | undefined, languageId: number | undefined): Promise<ResultOfBoolean>;

    saveDrupalFiles(motherId: number | undefined, broodRequestId: number | undefined, adnProfile: FileParameter | null | undefined, pedigreeFile: FileParameter | null | undefined, fatherId: number | null | undefined, fatherAdnProfile: FileParameter | null | undefined, fatherPedigreeFile: FileParameter | null | undefined, puppyPictures: FileParameter[] | null | undefined): Promise<number>;

    createDogBroodRequestTransient(broodRequestId: number | undefined): Promise<Result>;

    saveDogBroodRequestTransient(toSave: SaveDogBroodRequestTransientDto): Promise<number>;

    createDogBroodRequestPedigree(dogBroodRequestId: number | undefined): Promise<Result>;

    forceDogConditions(dogNeededConditionId: number | undefined, dogId: number | undefined, broodRequestId: number | undefined): Promise<Result>;

    sendProgenusLabOrder(broodRequestId: number | undefined): Promise<Result>;

    getDogBroodRequestTransient(broodRequestId: number | undefined): Promise<DogBroodRequestGetDto>;

    exportXlsFile(sObj: BroodRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BroodRequestApi extends BaseAPI implements IBroodRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BroodRequestSearch): Promise<PaginatedResultsOfBroodRequestGridDto> {
        let url_ = this.baseUrl + "/api/BroodRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfBroodRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfBroodRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfBroodRequestGridDto>(null as any);
    }

    get(broodRequestId: number | undefined): Promise<BroodRequestDto> {
        let url_ = this.baseUrl + "/api/BroodRequest?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<BroodRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BroodRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BroodRequestDto>(null as any);
    }

    save(dto: BroodRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BroodRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPuppyPicture(driveItemIds: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/GetPuppyPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(driveItemIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPuppyPicture(_response));
        });
    }

    protected processGetPuppyPicture(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    generatePedigreeSample(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/GeneratePedigreeSample?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGeneratePedigreeSample(_response));
        });
    }

    protected processGeneratePedigreeSample(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    resurrectPuppy(dogBroodRequestTransientId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/ResurrectPuppy?";
        if (dogBroodRequestTransientId === null)
            throw new Error("The parameter 'dogBroodRequestTransientId' cannot be null.");
        else if (dogBroodRequestTransientId !== undefined)
            url_ += "dogBroodRequestTransientId=" + encodeURIComponent("" + dogBroodRequestTransientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResurrectPuppy(_response));
        });
    }

    protected processResurrectPuppy(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDrupal(broodRequestId: number | undefined): Promise<DrupalBroodRequestDto> {
        let url_ = this.baseUrl + "/api/BroodRequest/GetDrupal?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupal(_response));
        });
    }

    protected processGetDrupal(response: Response): Promise<DrupalBroodRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalBroodRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalBroodRequestDto>(null as any);
    }

    isGenealogyComplete(broodRequestId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BroodRequest/IsGenealogyComplete?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsGenealogyComplete(_response));
        });
    }

    protected processIsGenealogyComplete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isSrshPedigreeWanted(broodRequestId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BroodRequest/IsSrshPedigreeWanted?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsSrshPedigreeWanted(_response));
        });
    }

    protected processIsSrshPedigreeWanted(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isBrcsRequest(broodRequestId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/BroodRequest/IsBrcsRequest?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBrcsRequest(_response));
        });
    }

    protected processIsBrcsRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAs400GenealogyCondition(broodRequestId: number | undefined): Promise<DogAs400ConditionDto[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/GetAs400GenealogyCondition?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAs400GenealogyCondition(_response));
        });
    }

    protected processGetAs400GenealogyCondition(response: Response): Promise<DogAs400ConditionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DogAs400ConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogAs400ConditionDto[]>(null as any);
    }

    switchToLoshPedigree(requestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/BroodRequest/SwitchToLoshPedigree?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSwitchToLoshPedigree(_response));
        });
    }

    protected processSwitchToLoshPedigree(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    reprintPedigrees(broodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/ReprintPedigrees?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintPedigrees(_response));
        });
    }

    protected processReprintPedigrees(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getFathersName(broodRequestId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/GetFathersName?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFathersName(_response));
        });
    }

    protected processGetFathersName(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getWithPuppies(broodRequestId: number | undefined): Promise<BroodRequestDto> {
        let url_ = this.baseUrl + "/api/BroodRequest/getWithPuppies?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWithPuppies(_response));
        });
    }

    protected processGetWithPuppies(response: Response): Promise<BroodRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BroodRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BroodRequestDto>(null as any);
    }

    isBabyDogAuthorized(broodRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/BroodRequest/isBabyDogAuthorized?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBabyDogAuthorized(_response));
        });
    }

    protected processIsBabyDogAuthorized(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getPuppyReport(info: BroodRequesReportDetailDto): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/BroodRequest/getPuppyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(info);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPuppyReport(_response));
        });
    }

    protected processGetPuppyReport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    getAvailableBabyDog(breedId: number | undefined, isBrcs: boolean | undefined): Promise<BabyDogPublicationDto[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/getAvailableBabyDog?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        if (isBrcs === null)
            throw new Error("The parameter 'isBrcs' cannot be null.");
        else if (isBrcs !== undefined)
            url_ += "IsBrcs=" + encodeURIComponent("" + isBrcs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableBabyDog(_response));
        });
    }

    protected processGetAvailableBabyDog(response: Response): Promise<BabyDogPublicationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BabyDogPublicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BabyDogPublicationDto[]>(null as any);
    }

    setPuppyDeceased(dogBroodTransientRequestId: number | undefined, platform: EPlatform | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/setPuppyDeceased?";
        if (dogBroodTransientRequestId === null)
            throw new Error("The parameter 'dogBroodTransientRequestId' cannot be null.");
        else if (dogBroodTransientRequestId !== undefined)
            url_ += "dogBroodTransientRequestId=" + encodeURIComponent("" + dogBroodTransientRequestId) + "&";
        if (platform !== undefined && platform !== null)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetPuppyDeceased(_response));
        });
    }

    protected processSetPuppyDeceased(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    reprintExecutionLetter(broodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/reprintExecutionLetter?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintExecutionLetter(_response));
        });
    }

    protected processReprintExecutionLetter(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    closeRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/CloseRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseRequest(_response));
        });
    }

    protected processCloseRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    addPotentialFather(broodRequestId: number | undefined, newFatherId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/AddPotentialFather?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        if (newFatherId === null)
            throw new Error("The parameter 'newFatherId' cannot be null.");
        else if (newFatherId !== undefined)
            url_ += "newFatherId=" + encodeURIComponent("" + newFatherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddPotentialFather(_response));
        });
    }

    protected processAddPotentialFather(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    computePuppiesPedigree(broodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/computePuppiesPedigree?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processComputePuppiesPedigree(_response));
        });
    }

    protected processComputePuppiesPedigree(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getPuppyFutureGenealogy(broodRequestId: number | undefined, generation: number | undefined): Promise<PuppyGenealogyDto[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/getPuppyFutureGenealogy?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        if (generation === null)
            throw new Error("The parameter 'generation' cannot be null.");
        else if (generation !== undefined)
            url_ += "generation=" + encodeURIComponent("" + generation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPuppyFutureGenealogy(_response));
        });
    }

    protected processGetPuppyFutureGenealogy(response: Response): Promise<PuppyGenealogyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PuppyGenealogyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PuppyGenealogyDto[]>(null as any);
    }

    getDogConditions(broodRequestId: number | undefined, languageId: number | undefined): Promise<DogConditionDto[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/getNeededDogConditions?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogConditions(_response));
        });
    }

    protected processGetDogConditions(response: Response): Promise<DogConditionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DogConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogConditionDto[]>(null as any);
    }

    checkNeededConditions(broodRequestId: number | undefined, languageId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/BroodRequest/checkNeededConditions?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckNeededConditions(_response));
        });
    }

    protected processCheckNeededConditions(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    saveDrupalFiles(motherId: number | undefined, broodRequestId: number | undefined, adnProfile: FileParameter | null | undefined, pedigreeFile: FileParameter | null | undefined, fatherId: number | null | undefined, fatherAdnProfile: FileParameter | null | undefined, fatherPedigreeFile: FileParameter | null | undefined, puppyPictures: FileParameter[] | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/BroodRequest/SaveDrupalFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (motherId === null || motherId === undefined)
            throw new Error("The parameter 'motherId' cannot be null.");
        else
            content_.append("MotherId", motherId.toString());
        if (broodRequestId === null || broodRequestId === undefined)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else
            content_.append("BroodRequestId", broodRequestId.toString());
        if (adnProfile !== null && adnProfile !== undefined)
            content_.append("AdnProfile", adnProfile.data, adnProfile.fileName ? adnProfile.fileName : "AdnProfile");
        if (pedigreeFile !== null && pedigreeFile !== undefined)
            content_.append("PedigreeFile", pedigreeFile.data, pedigreeFile.fileName ? pedigreeFile.fileName : "PedigreeFile");
        if (fatherId !== null && fatherId !== undefined)
            content_.append("FatherId", fatherId.toString());
        if (fatherAdnProfile !== null && fatherAdnProfile !== undefined)
            content_.append("FatherAdnProfile", fatherAdnProfile.data, fatherAdnProfile.fileName ? fatherAdnProfile.fileName : "FatherAdnProfile");
        if (fatherPedigreeFile !== null && fatherPedigreeFile !== undefined)
            content_.append("FatherPedigreeFile", fatherPedigreeFile.data, fatherPedigreeFile.fileName ? fatherPedigreeFile.fileName : "FatherPedigreeFile");
        if (puppyPictures !== null && puppyPictures !== undefined)
            puppyPictures.forEach(item_ => content_.append("PuppyPictures", item_.data, item_.fileName ? item_.fileName : "PuppyPictures") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDrupalFiles(_response));
        });
    }

    protected processSaveDrupalFiles(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createDogBroodRequestTransient(broodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/CreateDogBroodRequestTransient?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDogBroodRequestTransient(_response));
        });
    }

    protected processCreateDogBroodRequestTransient(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveDogBroodRequestTransient(toSave: SaveDogBroodRequestTransientDto): Promise<number> {
        let url_ = this.baseUrl + "/api/BroodRequest/SaveDogBroodRequestTransient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDogBroodRequestTransient(_response));
        });
    }

    protected processSaveDogBroodRequestTransient(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createDogBroodRequestPedigree(dogBroodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/CreateDogBroodRequestPedigree?";
        if (dogBroodRequestId === null)
            throw new Error("The parameter 'dogBroodRequestId' cannot be null.");
        else if (dogBroodRequestId !== undefined)
            url_ += "dogBroodRequestId=" + encodeURIComponent("" + dogBroodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDogBroodRequestPedigree(_response));
        });
    }

    protected processCreateDogBroodRequestPedigree(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    forceDogConditions(dogNeededConditionId: number | undefined, dogId: number | undefined, broodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/ForceDogConditions?";
        if (dogNeededConditionId === null)
            throw new Error("The parameter 'dogNeededConditionId' cannot be null.");
        else if (dogNeededConditionId !== undefined)
            url_ += "dogNeededConditionId=" + encodeURIComponent("" + dogNeededConditionId) + "&";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForceDogConditions(_response));
        });
    }

    protected processForceDogConditions(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    sendProgenusLabOrder(broodRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequest/SendProgenusLabOrder?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendProgenusLabOrder(_response));
        });
    }

    protected processSendProgenusLabOrder(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDogBroodRequestTransient(broodRequestId: number | undefined): Promise<DogBroodRequestGetDto> {
        let url_ = this.baseUrl + "/api/BroodRequest/GetDogBroodRequestTransient?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogBroodRequestTransient(_response));
        });
    }

    protected processGetDogBroodRequestTransient(response: Response): Promise<DogBroodRequestGetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogBroodRequestGetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogBroodRequestGetDto>(null as any);
    }

    exportXlsFile(sObj: BroodRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BroodRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BroodRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IBroodRequestPotentialFathersApi {

    baseSearch(sObj: PotentialFathersSearch): Promise<PaginatedResultsOfPotentialFatherGridDto>;

    deletePotentialFather(broodRequestId: number | undefined, fatherId: number | undefined): Promise<Result>;

    addPotentialFather(broodRequestId: number | undefined, fatherId: number | undefined): Promise<Result>;

    savePotentialFatherOwnerApproval(broodRequestId: number | undefined, potentialFathersAuthorizations: { [key: string]: boolean; }): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: PotentialFathersSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class BroodRequestPotentialFathersApi extends BaseAPI implements IBroodRequestPotentialFathersApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PotentialFathersSearch): Promise<PaginatedResultsOfPotentialFatherGridDto> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPotentialFatherGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPotentialFatherGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPotentialFatherGridDto>(null as any);
    }

    deletePotentialFather(broodRequestId: number | undefined, fatherId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/DeletePotentialFather?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        if (fatherId === null)
            throw new Error("The parameter 'fatherId' cannot be null.");
        else if (fatherId !== undefined)
            url_ += "fatherId=" + encodeURIComponent("" + fatherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePotentialFather(_response));
        });
    }

    protected processDeletePotentialFather(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    addPotentialFather(broodRequestId: number | undefined, fatherId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/AddPotentialFather?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        if (fatherId === null)
            throw new Error("The parameter 'fatherId' cannot be null.");
        else if (fatherId !== undefined)
            url_ += "fatherId=" + encodeURIComponent("" + fatherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddPotentialFather(_response));
        });
    }

    protected processAddPotentialFather(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    savePotentialFatherOwnerApproval(broodRequestId: number | undefined, potentialFathersAuthorizations: { [key: string]: boolean; }): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/SavePotentialFatherOwnerApproval?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(potentialFathersAuthorizations);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePotentialFatherOwnerApproval(_response));
        });
    }

    protected processSavePotentialFatherOwnerApproval(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: PotentialFathersSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/BroodRequestPotentialFathers/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICalendarYearApi {

    baseSearch(sObj: CalendarYearSearch): Promise<PaginatedResultsOfCalendarYearDto>;

    getCalendarYear(calendarYearId: number | undefined): Promise<CalendarYearDto>;

    save(dto: CalendarYearDto): Promise<CalendarYearDto>;

    getCalendarYearUnique(year: number | undefined, calendarYearId: number | undefined): Promise<BooleanDto>;

    getCalendarYearLetter(year: number | undefined): Promise<string>;

    getDisplayName(calendarYearId: number | undefined): Promise<string>;

    exportXlsFile(sObj: CalendarYearSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CalendarYearApi extends BaseAPI implements ICalendarYearApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CalendarYearSearch): Promise<PaginatedResultsOfCalendarYearDto> {
        let url_ = this.baseUrl + "/api/CalendarYear/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCalendarYearDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCalendarYearDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCalendarYearDto>(null as any);
    }

    getCalendarYear(calendarYearId: number | undefined): Promise<CalendarYearDto> {
        let url_ = this.baseUrl + "/api/CalendarYear?";
        if (calendarYearId === null)
            throw new Error("The parameter 'calendarYearId' cannot be null.");
        else if (calendarYearId !== undefined)
            url_ += "calendarYearId=" + encodeURIComponent("" + calendarYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCalendarYear(_response));
        });
    }

    protected processGetCalendarYear(response: Response): Promise<CalendarYearDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarYearDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarYearDto>(null as any);
    }

    save(dto: CalendarYearDto): Promise<CalendarYearDto> {
        let url_ = this.baseUrl + "/api/CalendarYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<CalendarYearDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarYearDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarYearDto>(null as any);
    }

    getCalendarYearUnique(year: number | undefined, calendarYearId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/CalendarYear/IsYearUnique?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (calendarYearId === null)
            throw new Error("The parameter 'calendarYearId' cannot be null.");
        else if (calendarYearId !== undefined)
            url_ += "calendarYearId=" + encodeURIComponent("" + calendarYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCalendarYearUnique(_response));
        });
    }

    protected processGetCalendarYearUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getCalendarYearLetter(year: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/CalendarYear/GetLetter?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCalendarYearLetter(_response));
        });
    }

    protected processGetCalendarYearLetter(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDisplayName(calendarYearId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/CalendarYear/DisplayName?";
        if (calendarYearId === null)
            throw new Error("The parameter 'calendarYearId' cannot be null.");
        else if (calendarYearId !== undefined)
            url_ += "calendarYearId=" + encodeURIComponent("" + calendarYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: CalendarYearSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CalendarYear/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CalendarYear/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/CalendarYear/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICharacteristicApi {

    baseSearch(sObj: CharacteristicSearch): Promise<PaginatedResultsOfCharacteristicsGridDto>;

    getIds(sObj: CharacteristicSearch): Promise<number[]>;

    getHealthValueTypeCode(characteristicId: number | undefined): Promise<EHealthValueType>;

    isCodeUnique(characteristicId: number | undefined, characteristicTypeId: number | undefined, code: string | null | undefined): Promise<BooleanDto>;

    isHealthValueTypeList(healthValueTypeId: number | undefined): Promise<ResultOfBoolean>;

    get(characteristicId: number | undefined): Promise<CharacteristicsDto>;

    save(dto: CharacteristicsDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    isTypeLab(characteristicTypeId: number | undefined): Promise<ResultOfBoolean>;

    isDysplasiaType(characteristicTypeId: number | undefined): Promise<ResultOfBoolean>;

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string>;

    exportXlsFile(sObj: CharacteristicSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CharacteristicApi extends BaseAPI implements ICharacteristicApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CharacteristicSearch): Promise<PaginatedResultsOfCharacteristicsGridDto> {
        let url_ = this.baseUrl + "/api/Characteristic/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCharacteristicsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCharacteristicsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCharacteristicsGridDto>(null as any);
    }

    getIds(sObj: CharacteristicSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Characteristic/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getHealthValueTypeCode(characteristicId: number | undefined): Promise<EHealthValueType> {
        let url_ = this.baseUrl + "/api/Characteristic/getHealthValueTypeCode?";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthValueTypeCode(_response));
        });
    }

    protected processGetHealthValueTypeCode(response: Response): Promise<EHealthValueType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EHealthValueType>(null as any);
    }

    isCodeUnique(characteristicId: number | undefined, characteristicTypeId: number | undefined, code: string | null | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Characteristic/IsCodeUnique?";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        if (characteristicTypeId === null)
            throw new Error("The parameter 'characteristicTypeId' cannot be null.");
        else if (characteristicTypeId !== undefined)
            url_ += "characteristicTypeId=" + encodeURIComponent("" + characteristicTypeId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsCodeUnique(_response));
        });
    }

    protected processIsCodeUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    isHealthValueTypeList(healthValueTypeId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Characteristic/isHealthValueTypeList?";
        if (healthValueTypeId === null)
            throw new Error("The parameter 'healthValueTypeId' cannot be null.");
        else if (healthValueTypeId !== undefined)
            url_ += "healthValueTypeId=" + encodeURIComponent("" + healthValueTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsHealthValueTypeList(_response));
        });
    }

    protected processIsHealthValueTypeList(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    get(characteristicId: number | undefined): Promise<CharacteristicsDto> {
        let url_ = this.baseUrl + "/api/Characteristic?";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CharacteristicsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CharacteristicsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacteristicsDto>(null as any);
    }

    save(dto: CharacteristicsDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Characteristic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Characteristic?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isTypeLab(characteristicTypeId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Characteristic/isTypeLab?";
        if (characteristicTypeId === null)
            throw new Error("The parameter 'characteristicTypeId' cannot be null.");
        else if (characteristicTypeId !== undefined)
            url_ += "characteristicTypeId=" + encodeURIComponent("" + characteristicTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsTypeLab(_response));
        });
    }

    protected processIsTypeLab(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isDysplasiaType(characteristicTypeId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Characteristic/isDysplasiaType?";
        if (characteristicTypeId === null)
            throw new Error("The parameter 'characteristicTypeId' cannot be null.");
        else if (characteristicTypeId !== undefined)
            url_ += "characteristicTypeId=" + encodeURIComponent("" + characteristicTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDysplasiaType(_response));
        });
    }

    protected processIsDysplasiaType(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Characteristic/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: CharacteristicSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Characteristic/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Characteristic/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Characteristic/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICharacteristicValuesApi {

    baseSearch(sObj: CharacteristicValuesSearch): Promise<PaginatedResultsOfCharacteristicValuesGridDto>;

    get(characteristicValueId: number | undefined): Promise<CharacteristicValuesDto>;

    save(dto: CharacteristicValuesDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string>;

    getAllCaracteristicValues(languageId: number | undefined): Promise<CharacteristicValuesGridDto[]>;

    getIds(sObj: CharacteristicValuesSearch): Promise<number[]>;

    exportXlsFile(sObj: CharacteristicValuesSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CharacteristicValuesApi extends BaseAPI implements ICharacteristicValuesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CharacteristicValuesSearch): Promise<PaginatedResultsOfCharacteristicValuesGridDto> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCharacteristicValuesGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCharacteristicValuesGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCharacteristicValuesGridDto>(null as any);
    }

    get(characteristicValueId: number | undefined): Promise<CharacteristicValuesDto> {
        let url_ = this.baseUrl + "/api/CharacteristicValues?";
        if (characteristicValueId === null)
            throw new Error("The parameter 'characteristicValueId' cannot be null.");
        else if (characteristicValueId !== undefined)
            url_ += "characteristicValueId=" + encodeURIComponent("" + characteristicValueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CharacteristicValuesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CharacteristicValuesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacteristicValuesDto>(null as any);
    }

    save(dto: CharacteristicValuesDto): Promise<number> {
        let url_ = this.baseUrl + "/api/CharacteristicValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CharacteristicValues?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAllCaracteristicValues(languageId: number | undefined): Promise<CharacteristicValuesGridDto[]> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/getAllCaracteristicValues?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCaracteristicValues(_response));
        });
    }

    protected processGetAllCaracteristicValues(response: Response): Promise<CharacteristicValuesGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CharacteristicValuesGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacteristicValuesGridDto[]>(null as any);
    }

    getIds(sObj: CharacteristicValuesSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: CharacteristicValuesSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/CharacteristicValues/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IChartSignatureHistoryApi {

    baseSearch(sObj: ChartSignaturesHistorySearch): Promise<PaginatedResultsOfChartSignaturesHistoryDto>;

    saveChartHistorySignature(dto: ChartSignaturesHistoryDto): Promise<number>;

    deleteChartSignatureHistory(id: number | undefined): Promise<void>;

    exportXlsFile(sObj: ChartSignaturesHistorySearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ChartSignatureHistoryApi extends BaseAPI implements IChartSignatureHistoryApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ChartSignaturesHistorySearch): Promise<PaginatedResultsOfChartSignaturesHistoryDto> {
        let url_ = this.baseUrl + "/api/ChartSignatureHistory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfChartSignaturesHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfChartSignaturesHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfChartSignaturesHistoryDto>(null as any);
    }

    saveChartHistorySignature(dto: ChartSignaturesHistoryDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ChartSignatureHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveChartHistorySignature(_response));
        });
    }

    protected processSaveChartHistorySignature(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteChartSignatureHistory(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ChartSignatureHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteChartSignatureHistory(_response));
        });
    }

    protected processDeleteChartSignatureHistory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: ChartSignaturesHistorySearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ChartSignatureHistory/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ChartSignatureHistory/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ChartSignatureHistory/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClinicApi {

    baseSearch(sObj: ClinicSearch): Promise<PaginatedResultsOfClinicGridDto>;

    get(clinicId: number | undefined): Promise<ClinicDto>;

    save(dto: ClinicDto): Promise<number>;

    delete(clinicId: number | undefined): Promise<boolean>;

    getDisplayName(clinicId: number | undefined): Promise<string>;

    exportXlsFile(sObj: ClinicSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClinicApi extends BaseAPI implements IClinicApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClinicSearch): Promise<PaginatedResultsOfClinicGridDto> {
        let url_ = this.baseUrl + "/api/Clinic/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClinicGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClinicGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClinicGridDto>(null as any);
    }

    get(clinicId: number | undefined): Promise<ClinicDto> {
        let url_ = this.baseUrl + "/api/Clinic?";
        if (clinicId === null)
            throw new Error("The parameter 'clinicId' cannot be null.");
        else if (clinicId !== undefined)
            url_ += "clinicId=" + encodeURIComponent("" + clinicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ClinicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicDto>(null as any);
    }

    save(dto: ClinicDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Clinic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(clinicId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Clinic?";
        if (clinicId === null)
            throw new Error("The parameter 'clinicId' cannot be null.");
        else if (clinicId !== undefined)
            url_ += "clinicId=" + encodeURIComponent("" + clinicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDisplayName(clinicId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Clinic/displayName?";
        if (clinicId === null)
            throw new Error("The parameter 'clinicId' cannot be null.");
        else if (clinicId !== undefined)
            url_ += "clinicId=" + encodeURIComponent("" + clinicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ClinicSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Clinic/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Clinic/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Clinic/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubAllowedSectionsApi {

    baseSearch(sObj: ClubAllowedSectionsSearch): Promise<PaginatedResultsOfClubAllowedSectionsDto>;

    getClubAllowedSection(clubSectionId: number | undefined): Promise<SaveNewClubAllowedSectionDto>;

    deleteClubAllowedSection(id: number | undefined): Promise<void>;

    addNewClubAllowedSection(dto: SaveNewClubAllowedSectionDto): Promise<number>;

    exportXlsFile(sObj: ClubAllowedSectionsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubAllowedSectionsApi extends BaseAPI implements IClubAllowedSectionsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubAllowedSectionsSearch): Promise<PaginatedResultsOfClubAllowedSectionsDto> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubAllowedSectionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubAllowedSectionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubAllowedSectionsDto>(null as any);
    }

    getClubAllowedSection(clubSectionId: number | undefined): Promise<SaveNewClubAllowedSectionDto> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections?";
        if (clubSectionId === null)
            throw new Error("The parameter 'clubSectionId' cannot be null.");
        else if (clubSectionId !== undefined)
            url_ += "clubSectionId=" + encodeURIComponent("" + clubSectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubAllowedSection(_response));
        });
    }

    protected processGetClubAllowedSection(response: Response): Promise<SaveNewClubAllowedSectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveNewClubAllowedSectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveNewClubAllowedSectionDto>(null as any);
    }

    deleteClubAllowedSection(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteClubAllowedSection(_response));
        });
    }

    protected processDeleteClubAllowedSection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addNewClubAllowedSection(dto: SaveNewClubAllowedSectionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections/addNewClubAllowedSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddNewClubAllowedSection(_response));
        });
    }

    protected processAddNewClubAllowedSection(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: ClubAllowedSectionsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubAllowedSections/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubBreedApi {

    baseSearch(sObj: ClubBreedSearch): Promise<PaginatedResultsOfClubGridDto>;

    exportXlsFile(sObj: ClubBreedSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubBreedApi extends BaseAPI implements IClubBreedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubBreedSearch): Promise<PaginatedResultsOfClubGridDto> {
        let url_ = this.baseUrl + "/api/ClubBreed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubGridDto>(null as any);
    }

    exportXlsFile(sObj: ClubBreedSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubBreed/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubBreed/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubBreed/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubCompetitionRequestApi {

    baseSearch(sObj: ClubCompetitionRequestsSearch): Promise<PaginatedResultsOfClubCompetitionRequestGridDto>;

    exportXlsFile(sObj: ClubCompetitionRequestsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubCompetitionRequestApi extends BaseAPI implements IClubCompetitionRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubCompetitionRequestsSearch): Promise<PaginatedResultsOfClubCompetitionRequestGridDto> {
        let url_ = this.baseUrl + "/api/ClubCompetitionRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubCompetitionRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubCompetitionRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubCompetitionRequestGridDto>(null as any);
    }

    exportXlsFile(sObj: ClubCompetitionRequestsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubCompetitionRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubCompetitionRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubCompetitionRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubContactApi {

    baseSearch(sObj: ClubContactSearch): Promise<PaginatedResultsOfClubContactGridDto>;

    addNewContact(dto: SaveClubContactDto): Promise<number>;

    deleteClubContact(id: number | undefined): Promise<void>;

    exportXlsFile(sObj: ClubContactSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubContactApi extends BaseAPI implements IClubContactApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubContactSearch): Promise<PaginatedResultsOfClubContactGridDto> {
        let url_ = this.baseUrl + "/api/ClubContact/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubContactGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubContactGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubContactGridDto>(null as any);
    }

    addNewContact(dto: SaveClubContactDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubContact/addContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddNewContact(_response));
        });
    }

    protected processAddNewContact(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteClubContact(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClubContact?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteClubContact(_response));
        });
    }

    protected processDeleteClubContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: ClubContactSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubContact/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubContact/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubContact/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubApi {

    baseSearch(sObj: ClubSearch): Promise<PaginatedResultsOfClubGridDto>;

    searchByBreed(breedId: number | undefined): Promise<PaginatedResultsOfClubGridDto>;

    getDrupalClub(clubId: number | undefined): Promise<DrupalClubDto>;

    get(clubId: number | undefined): Promise<ClubDto>;

    delete(clubId: number | undefined): Promise<boolean>;

    save(dto: ClubDto): Promise<number>;

    getClubsByBreed(breedId: number | undefined, languageId: number | undefined): Promise<DrupalClubDto[]>;

    saveBc(clubId: number | undefined): Promise<string>;

    getDisplayName(clubId: number | undefined): Promise<string>;

    isClubExcluded(clubId: number | undefined): Promise<ResultOfBoolean>;

    getLinkedBreedsIds(clubId: number | undefined): Promise<SaveClubAllowedBreedsDto>;

    saveLinkedBreeds(dto: SaveClubAllowedBreedsDto): Promise<number>;

    getClubEmail(clubId: number | undefined): Promise<string>;

    getClubRemark(clubId: number | undefined): Promise<string>;

    getClubAddress(clubId: number | undefined): Promise<string>;

    createInSharepoint(clubId: number): Promise<string>;

    exportXlsFile(sObj: ClubSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubApi extends BaseAPI implements IClubApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubSearch): Promise<PaginatedResultsOfClubGridDto> {
        let url_ = this.baseUrl + "/api/Club/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubGridDto>(null as any);
    }

    searchByBreed(breedId: number | undefined): Promise<PaginatedResultsOfClubGridDto> {
        let url_ = this.baseUrl + "/api/Club/searchBybreed?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByBreed(_response));
        });
    }

    protected processSearchByBreed(response: Response): Promise<PaginatedResultsOfClubGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubGridDto>(null as any);
    }

    getDrupalClub(clubId: number | undefined): Promise<DrupalClubDto> {
        let url_ = this.baseUrl + "/api/Club/drupalClub?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalClub(_response));
        });
    }

    protected processGetDrupalClub(response: Response): Promise<DrupalClubDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalClubDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalClubDto>(null as any);
    }

    get(clubId: number | undefined): Promise<ClubDto> {
        let url_ = this.baseUrl + "/api/Club?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ClubDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDto>(null as any);
    }

    delete(clubId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Club?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    save(dto: ClubDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Club";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getClubsByBreed(breedId: number | undefined, languageId: number | undefined): Promise<DrupalClubDto[]> {
        let url_ = this.baseUrl + "/api/Club/clubsByBreed?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubsByBreed(_response));
        });
    }

    protected processGetClubsByBreed(response: Response): Promise<DrupalClubDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrupalClubDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalClubDto[]>(null as any);
    }

    saveBc(clubId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Club/saveBc?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBc(_response));
        });
    }

    protected processSaveBc(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDisplayName(clubId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Club/DisplayName?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    isClubExcluded(clubId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Club/isExcluded?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsClubExcluded(_response));
        });
    }

    protected processIsClubExcluded(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getLinkedBreedsIds(clubId: number | undefined): Promise<SaveClubAllowedBreedsDto> {
        let url_ = this.baseUrl + "/api/Club/GetLinkedBreedsIds?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLinkedBreedsIds(_response));
        });
    }

    protected processGetLinkedBreedsIds(response: Response): Promise<SaveClubAllowedBreedsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveClubAllowedBreedsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveClubAllowedBreedsDto>(null as any);
    }

    saveLinkedBreeds(dto: SaveClubAllowedBreedsDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Club/SaveLinkedBreeds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveLinkedBreeds(_response));
        });
    }

    protected processSaveLinkedBreeds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getClubEmail(clubId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Club/email?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubEmail(_response));
        });
    }

    protected processGetClubEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getClubRemark(clubId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Club/remark?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubRemark(_response));
        });
    }

    protected processGetClubRemark(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getClubAddress(clubId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Club/getClubAddress?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubAddress(_response));
        });
    }

    protected processGetClubAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    createInSharepoint(clubId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Club/CreateInSharepoint/{clubId}";
        if (clubId === undefined || clubId === null)
            throw new Error("The parameter 'clubId' must be defined.");
        url_ = url_.replace("{clubId}", encodeURIComponent("" + clubId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ClubSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Club/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Club/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Club/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubJudgeApi {

    baseSearch(sObj: JudgesForClubSearch): Promise<PaginatedResultsOfJudgesForClubGridDto>;

    saveNewJudge(dto: SaveClubJudgeDto): Promise<number>;

    deleteJudgeForClub(clubJudgeId: number | undefined): Promise<void>;

    exportXlsFile(sObj: JudgesForClubSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubJudgeApi extends BaseAPI implements IClubJudgeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: JudgesForClubSearch): Promise<PaginatedResultsOfJudgesForClubGridDto> {
        let url_ = this.baseUrl + "/api/ClubJudge/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgesForClubGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgesForClubGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgesForClubGridDto>(null as any);
    }

    saveNewJudge(dto: SaveClubJudgeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubJudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewJudge(_response));
        });
    }

    protected processSaveNewJudge(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteJudgeForClub(clubJudgeId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClubJudge?";
        if (clubJudgeId === null)
            throw new Error("The parameter 'clubJudgeId' cannot be null.");
        else if (clubJudgeId !== undefined)
            url_ += "clubJudgeId=" + encodeURIComponent("" + clubJudgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteJudgeForClub(_response));
        });
    }

    protected processDeleteJudgeForClub(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: JudgesForClubSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubJudge/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubJudge/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubJudge/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubRoleApi {

    baseSearch(sObj: ClubRoleSearch): Promise<PaginatedResultsOfClubRoleGridDto>;

    getClubRole(id: number | undefined): Promise<ClubRoleDto>;

    saveClubRole(dto: ClubRoleDto): Promise<number>;

    deleteClubRole(id: number | undefined): Promise<void>;

    getDisplayName(clubRoleId: number | undefined, languageCode: string | null | undefined): Promise<string>;

    exportXlsFile(sObj: ClubRoleSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubRoleApi extends BaseAPI implements IClubRoleApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubRoleSearch): Promise<PaginatedResultsOfClubRoleGridDto> {
        let url_ = this.baseUrl + "/api/ClubRole/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubRoleGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubRoleGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubRoleGridDto>(null as any);
    }

    getClubRole(id: number | undefined): Promise<ClubRoleDto> {
        let url_ = this.baseUrl + "/api/ClubRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubRole(_response));
        });
    }

    protected processGetClubRole(response: Response): Promise<ClubRoleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubRoleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubRoleDto>(null as any);
    }

    saveClubRole(dto: ClubRoleDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveClubRole(_response));
        });
    }

    protected processSaveClubRole(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteClubRole(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClubRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteClubRole(_response));
        });
    }

    protected processDeleteClubRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDisplayName(clubRoleId: number | undefined, languageCode: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ClubRole/getDisplayName?";
        if (clubRoleId === null)
            throw new Error("The parameter 'clubRoleId' cannot be null.");
        else if (clubRoleId !== undefined)
            url_ += "clubRoleId=" + encodeURIComponent("" + clubRoleId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ClubRoleSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubRole/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubRole/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubRole/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IClubWorkbookRequestApi {

    baseSearch(sObj: ClubWorkbookRequestSearch): Promise<PaginatedResultsOfClubWorkbookRequestGridDto>;

    exportXlsFile(sObj: ClubWorkbookRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ClubWorkbookRequestApi extends BaseAPI implements IClubWorkbookRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ClubWorkbookRequestSearch): Promise<PaginatedResultsOfClubWorkbookRequestGridDto> {
        let url_ = this.baseUrl + "/api/ClubWorkbookRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfClubWorkbookRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClubWorkbookRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClubWorkbookRequestGridDto>(null as any);
    }

    exportXlsFile(sObj: ClubWorkbookRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClubWorkbookRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ClubWorkbookRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ClubWorkbookRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IColorApi {

    baseSearch(sObj: ColorSearch): Promise<PaginatedResultsOfColorGridDto>;

    searchIds(sObj: ColorSearch): Promise<number[]>;

    getColor(id: number | undefined): Promise<ColorDto>;

    saveColor(dto: ColorDto): Promise<number>;

    deleteColor(id: number | undefined): Promise<void>;

    getDisplayName(colorId: number | undefined, languageCode: string | null | undefined): Promise<string>;

    exportXlsFile(sObj: ColorSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ColorApi extends BaseAPI implements IColorApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ColorSearch): Promise<PaginatedResultsOfColorGridDto> {
        let url_ = this.baseUrl + "/api/Color/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfColorGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfColorGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfColorGridDto>(null as any);
    }

    searchIds(sObj: ColorSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Color/searchIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchIds(_response));
        });
    }

    protected processSearchIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getColor(id: number | undefined): Promise<ColorDto> {
        let url_ = this.baseUrl + "/api/Color?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetColor(_response));
        });
    }

    protected processGetColor(response: Response): Promise<ColorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ColorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ColorDto>(null as any);
    }

    saveColor(dto: ColorDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Color";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveColor(_response));
        });
    }

    protected processSaveColor(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteColor(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Color?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteColor(_response));
        });
    }

    protected processDeleteColor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDisplayName(colorId: number | undefined, languageCode: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Color/getDisplayName?";
        if (colorId === null)
            throw new Error("The parameter 'colorId' cannot be null.");
        else if (colorId !== undefined)
            url_ += "colorId=" + encodeURIComponent("" + colorId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ColorSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Color/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Color/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Color/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICompetitionApi {

    baseSearch(sObj: CompetitionSearch): Promise<PaginatedResultsOfCompetitionGridDto>;

    searchCompetitionByYear(year: number | undefined, includeCoursing: boolean | undefined, activityId: number | null | undefined): Promise<PaginatedResultsOfCompetitionGridDto>;

    getWeekCompetition(languageCode: string | null | undefined): Promise<DrupalDisplayCompetitionDto[]>;

    get(competitionId: number | undefined, languageId: number | undefined): Promise<CompetitionDto>;

    save(dto: CompetitionDto): Promise<number>;

    getDrupalCompetition(competitionId: number | undefined): Promise<DrupalCompetitionDto>;

    getDisplayName(competitionId: number | undefined, languageId: number | undefined): Promise<string>;

    exportXlsFile(sObj: CompetitionSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CompetitionApi extends BaseAPI implements ICompetitionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CompetitionSearch): Promise<PaginatedResultsOfCompetitionGridDto> {
        let url_ = this.baseUrl + "/api/Competition/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCompetitionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCompetitionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCompetitionGridDto>(null as any);
    }

    searchCompetitionByYear(year: number | undefined, includeCoursing: boolean | undefined, activityId: number | null | undefined): Promise<PaginatedResultsOfCompetitionGridDto> {
        let url_ = this.baseUrl + "/api/Competition/searchByYear?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (includeCoursing === null)
            throw new Error("The parameter 'includeCoursing' cannot be null.");
        else if (includeCoursing !== undefined)
            url_ += "includeCoursing=" + encodeURIComponent("" + includeCoursing) + "&";
        if (activityId !== undefined && activityId !== null)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchCompetitionByYear(_response));
        });
    }

    protected processSearchCompetitionByYear(response: Response): Promise<PaginatedResultsOfCompetitionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCompetitionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCompetitionGridDto>(null as any);
    }

    getWeekCompetition(languageCode: string | null | undefined): Promise<DrupalDisplayCompetitionDto[]> {
        let url_ = this.baseUrl + "/api/Competition/getWeekCompetition?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWeekCompetition(_response));
        });
    }

    protected processGetWeekCompetition(response: Response): Promise<DrupalDisplayCompetitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrupalDisplayCompetitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalDisplayCompetitionDto[]>(null as any);
    }

    get(competitionId: number | undefined, languageId: number | undefined): Promise<CompetitionDto> {
        let url_ = this.baseUrl + "/api/Competition?";
        if (competitionId === null)
            throw new Error("The parameter 'competitionId' cannot be null.");
        else if (competitionId !== undefined)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CompetitionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDto>(null as any);
    }

    save(dto: CompetitionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Competition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDrupalCompetition(competitionId: number | undefined): Promise<DrupalCompetitionDto> {
        let url_ = this.baseUrl + "/api/Competition/getDrupalCompetition?";
        if (competitionId === null)
            throw new Error("The parameter 'competitionId' cannot be null.");
        else if (competitionId !== undefined)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalCompetition(_response));
        });
    }

    protected processGetDrupalCompetition(response: Response): Promise<DrupalCompetitionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalCompetitionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalCompetitionDto>(null as any);
    }

    getDisplayName(competitionId: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Competition/displayName?";
        if (competitionId === null)
            throw new Error("The parameter 'competitionId' cannot be null.");
        else if (competitionId !== undefined)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: CompetitionSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Competition/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Competition/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Competition/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICompetitionJudgesRequestApi {

    baseSearch(sObj: JudgeCompetitionRequestSearch): Promise<PaginatedResultsOfJudgeCompetitionRequestGridDto>;

    saveJudgeValidation(judgeValidationDtos: JudgeValidationDto[]): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: JudgeCompetitionRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CompetitionJudgesRequestApi extends BaseAPI implements ICompetitionJudgesRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: JudgeCompetitionRequestSearch): Promise<PaginatedResultsOfJudgeCompetitionRequestGridDto> {
        let url_ = this.baseUrl + "/api/CompetitionJudgesRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgeCompetitionRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeCompetitionRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeCompetitionRequestGridDto>(null as any);
    }

    saveJudgeValidation(judgeValidationDtos: JudgeValidationDto[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/CompetitionJudgesRequest/saveJudgeValidation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(judgeValidationDtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveJudgeValidation(_response));
        });
    }

    protected processSaveJudgeValidation(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: JudgeCompetitionRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CompetitionJudgesRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CompetitionJudgesRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/CompetitionJudgesRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICompetitionRequestApi {

    baseSearch(sObj: CompetitionRequestSearch): Promise<PaginatedResultsOfCompetitionRequestGridDto>;

    get(competitionRequestId: number | undefined): Promise<CompetitionRequestDto>;

    save(dto: CompetitionRequestDto): Promise<number>;

    isWorkOrBeauty(competitionRequestId: number | undefined): Promise<IsWorkOrBeautyDto>;

    getCompetitionRequestExpos(competitionRequestId: number | undefined): Promise<CompetitionRequestExpoDaysDto>;

    saveCompetitionRequestExpos(competitionExposInfos: CompetitionRequestExpoDaysDto): Promise<number>;

    getCompetitionReport(competitionRequestDto: CompetitionReportInfoDto): Promise<FileDto>;

    competitionPersonCheck(clubId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean>;

    competitionSectionCheck(clubId: number | undefined, sectionId: number | undefined): Promise<ResultOfBoolean>;

    isRequestComplete(competitionRequestId: number | undefined): Promise<Result>;

    getLinkedBreedGroupsIds(competitionRequestId: number | undefined): Promise<number[]>;

    saveCompetitionBreedGroups(competitionRequestId: number | undefined, breedGroupsIds: number[]): Promise<number>;

    getLinkedBreedIds(competitionRequestId: number | undefined): Promise<number[]>;

    saveCompetitionBreeds(competitionRequestId: number | undefined, breedIds: number[]): Promise<number>;

    judgesCorrect(subAcivityId: number | undefined, judgeIds: number[]): Promise<ResultOfBoolean>;

    createCompetition(competitionRequestId: number | undefined): Promise<number>;

    saveFile(competitionRequestId: number | undefined, file: FileParameter | null | undefined): Promise<void>;

    close(requestId: number | undefined): Promise<Result>;

    searchCompetitionJudges(sObj: JudgeCompetitionRequestSearch): Promise<PaginatedResultsOfJudgeCompetitionRequestGridDto>;

    sendJudgeValidationEmail(competitionRequestId: number | undefined): Promise<Result>;

    sendAuthorizationReceivedEmail(competitionRequestId: number | undefined): Promise<Result>;

    checkPortalAuthorization(): Promise<Result>;

    exportXlsFile(sObj: CompetitionRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CompetitionRequestApi extends BaseAPI implements ICompetitionRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CompetitionRequestSearch): Promise<PaginatedResultsOfCompetitionRequestGridDto> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCompetitionRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCompetitionRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCompetitionRequestGridDto>(null as any);
    }

    get(competitionRequestId: number | undefined): Promise<CompetitionRequestDto> {
        let url_ = this.baseUrl + "/api/CompetitionRequest?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CompetitionRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionRequestDto>(null as any);
    }

    save(dto: CompetitionRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isWorkOrBeauty(competitionRequestId: number | undefined): Promise<IsWorkOrBeautyDto> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/IsWorkOrBeauty?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsWorkOrBeauty(_response));
        });
    }

    protected processIsWorkOrBeauty(response: Response): Promise<IsWorkOrBeautyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsWorkOrBeautyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsWorkOrBeautyDto>(null as any);
    }

    getCompetitionRequestExpos(competitionRequestId: number | undefined): Promise<CompetitionRequestExpoDaysDto> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/GetCompetitionRequestExpos?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitionRequestExpos(_response));
        });
    }

    protected processGetCompetitionRequestExpos(response: Response): Promise<CompetitionRequestExpoDaysDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionRequestExpoDaysDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionRequestExpoDaysDto>(null as any);
    }

    saveCompetitionRequestExpos(competitionExposInfos: CompetitionRequestExpoDaysDto): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/SaveCompetitionRequestExpos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(competitionExposInfos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveCompetitionRequestExpos(_response));
        });
    }

    protected processSaveCompetitionRequestExpos(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getCompetitionReport(competitionRequestDto: CompetitionReportInfoDto): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/getCompetitionReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(competitionRequestDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitionReport(_response));
        });
    }

    protected processGetCompetitionReport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    competitionPersonCheck(clubId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/competitionPersonCheck?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompetitionPersonCheck(_response));
        });
    }

    protected processCompetitionPersonCheck(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    competitionSectionCheck(clubId: number | undefined, sectionId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/competitionSectionCheck?";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompetitionSectionCheck(_response));
        });
    }

    protected processCompetitionSectionCheck(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isRequestComplete(competitionRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/isRequestComplete?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsRequestComplete(_response));
        });
    }

    protected processIsRequestComplete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getLinkedBreedGroupsIds(competitionRequestId: number | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/getLinkedBreedGroupsIds?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLinkedBreedGroupsIds(_response));
        });
    }

    protected processGetLinkedBreedGroupsIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    saveCompetitionBreedGroups(competitionRequestId: number | undefined, breedGroupsIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/saveCompetitionBreedGroups?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breedGroupsIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveCompetitionBreedGroups(_response));
        });
    }

    protected processSaveCompetitionBreedGroups(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getLinkedBreedIds(competitionRequestId: number | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/getLinkedBreedIds?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLinkedBreedIds(_response));
        });
    }

    protected processGetLinkedBreedIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    saveCompetitionBreeds(competitionRequestId: number | undefined, breedIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/saveCompetitionBreeds?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breedIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveCompetitionBreeds(_response));
        });
    }

    protected processSaveCompetitionBreeds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    judgesCorrect(subAcivityId: number | undefined, judgeIds: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/canJudge?";
        if (subAcivityId === null)
            throw new Error("The parameter 'subAcivityId' cannot be null.");
        else if (subAcivityId !== undefined)
            url_ += "subAcivityId=" + encodeURIComponent("" + subAcivityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(judgeIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processJudgesCorrect(_response));
        });
    }

    protected processJudgesCorrect(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    createCompetition(competitionRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/createCompetition?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCompetition(_response));
        });
    }

    protected processCreateCompetition(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveFile(competitionRequestId: number | undefined, file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/saveFile?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFile(_response));
        });
    }

    protected processSaveFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    searchCompetitionJudges(sObj: JudgeCompetitionRequestSearch): Promise<PaginatedResultsOfJudgeCompetitionRequestGridDto> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/searchCompetitionJudges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchCompetitionJudges(_response));
        });
    }

    protected processSearchCompetitionJudges(response: Response): Promise<PaginatedResultsOfJudgeCompetitionRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeCompetitionRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeCompetitionRequestGridDto>(null as any);
    }

    sendJudgeValidationEmail(competitionRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/sendJudgeValidationEmail?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendJudgeValidationEmail(_response));
        });
    }

    protected processSendJudgeValidationEmail(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    sendAuthorizationReceivedEmail(competitionRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/sendAuthorizationReceivedEmail?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendAuthorizationReceivedEmail(_response));
        });
    }

    protected processSendAuthorizationReceivedEmail(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    checkPortalAuthorization(): Promise<Result> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/CheckPortalAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckPortalAuthorization(_response));
        });
    }

    protected processCheckPortalAuthorization(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: CompetitionRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/CompetitionRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICompetitionResultApi {

    baseSearch(sObj: CompetitionResultSearch): Promise<PaginatedResultsOfCompetitionResultGridDto>;

    get(competitionResultId: number | undefined): Promise<CompetitionResultDto>;

    save(dto: CompetitionResultDto): Promise<number>;

    delete(competitionResultId: number | undefined): Promise<ResultOfBoolean>;

    importCompetitionResultsFromExcel(competitionId: number | undefined, file: FileParameter | null | undefined): Promise<CompetitionImportDto[]>;

    saveImportedDtos(shouldDouble: boolean | undefined, expoId: number | null | undefined, importedDtos: CompetitionImportDto[]): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: CompetitionResultSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CompetitionResultApi extends BaseAPI implements ICompetitionResultApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CompetitionResultSearch): Promise<PaginatedResultsOfCompetitionResultGridDto> {
        let url_ = this.baseUrl + "/api/CompetitionResult/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCompetitionResultGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCompetitionResultGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCompetitionResultGridDto>(null as any);
    }

    get(competitionResultId: number | undefined): Promise<CompetitionResultDto> {
        let url_ = this.baseUrl + "/api/CompetitionResult?";
        if (competitionResultId === null)
            throw new Error("The parameter 'competitionResultId' cannot be null.");
        else if (competitionResultId !== undefined)
            url_ += "competitionResultId=" + encodeURIComponent("" + competitionResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CompetitionResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionResultDto>(null as any);
    }

    save(dto: CompetitionResultDto): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(competitionResultId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/CompetitionResult?";
        if (competitionResultId === null)
            throw new Error("The parameter 'competitionResultId' cannot be null.");
        else if (competitionResultId !== undefined)
            url_ += "competitionResultId=" + encodeURIComponent("" + competitionResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    importCompetitionResultsFromExcel(competitionId: number | undefined, file: FileParameter | null | undefined): Promise<CompetitionImportDto[]> {
        let url_ = this.baseUrl + "/api/CompetitionResult/importCompetitionResults?";
        if (competitionId === null)
            throw new Error("The parameter 'competitionId' cannot be null.");
        else if (competitionId !== undefined)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportCompetitionResultsFromExcel(_response));
        });
    }

    protected processImportCompetitionResultsFromExcel(response: Response): Promise<CompetitionImportDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompetitionImportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionImportDto[]>(null as any);
    }

    saveImportedDtos(shouldDouble: boolean | undefined, expoId: number | null | undefined, importedDtos: CompetitionImportDto[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/CompetitionResult/saveImportedDtos?";
        if (shouldDouble === null)
            throw new Error("The parameter 'shouldDouble' cannot be null.");
        else if (shouldDouble !== undefined)
            url_ += "shouldDouble=" + encodeURIComponent("" + shouldDouble) + "&";
        if (expoId !== undefined && expoId !== null)
            url_ += "expoId=" + encodeURIComponent("" + expoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importedDtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveImportedDtos(_response));
        });
    }

    protected processSaveImportedDtos(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: CompetitionResultSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CompetitionResult/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CompetitionResult/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/CompetitionResult/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICountryApi {

    baseSearch(sObj: CountrySearch): Promise<PaginatedResultsOfCountryGridDto>;

    get(id: number | undefined): Promise<CountryDto>;

    save(dto: CountryDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    isoCodeUnique(countryId: number | undefined, isoCode: string | null | undefined): Promise<BooleanDto>;

    getBelgianId(): Promise<number>;

    getDisplayName(id: number | undefined): Promise<string>;

    isBelgian(id: number | undefined): Promise<BooleanDto>;

    createInSharepoint(countryId: number): Promise<string>;

    exportXlsFile(sObj: CountrySearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CountryApi extends BaseAPI implements ICountryApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CountrySearch): Promise<PaginatedResultsOfCountryGridDto> {
        let url_ = this.baseUrl + "/api/Country/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCountryGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCountryGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCountryGridDto>(null as any);
    }

    get(id: number | undefined): Promise<CountryDto> {
        let url_ = this.baseUrl + "/api/Country?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CountryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto>(null as any);
    }

    save(dto: CountryDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Country?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isoCodeUnique(countryId: number | undefined, isoCode: string | null | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Country/IsoCodeUnique?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (isoCode !== undefined && isoCode !== null)
            url_ += "isoCode=" + encodeURIComponent("" + isoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsoCodeUnique(_response));
        });
    }

    protected processIsoCodeUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getBelgianId(): Promise<number> {
        let url_ = this.baseUrl + "/api/Country/BelgiumId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBelgianId(_response));
        });
    }

    protected processGetBelgianId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Country/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    isBelgian(id: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Country/IsBelgian?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBelgian(_response));
        });
    }

    protected processIsBelgian(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    createInSharepoint(countryId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Country/CreateInSharepoint/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: CountrySearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Country/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Country/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Country/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ICoupleInbreedingApi {

    baseSearch(sObj: CoupleInbreedingSearch): Promise<PaginatedResultsOfCoupleInbreedingGridDto>;

    save(coupleInbreedingId: number | undefined, fatherId: number | undefined, motherId: number | undefined, inbreedingPercentage: number | undefined, inbreedingProof: FileParameter | null | undefined, validated: boolean | undefined): Promise<number>;

    delete(coupleInbreedingId: number | undefined): Promise<boolean>;

    getBroodRequestInbreeding(broodRequestId: number | undefined): Promise<CoupleInbreedingDto[]>;

    getCouplesInbreeding(motherId: number | undefined, fatherIds: number[]): Promise<CoupleInbreedingDto[]>;

    isCoupleInbreedingComplete(motherId: number | undefined, fatherIds: number[]): Promise<boolean>;

    exportXlsFile(sObj: CoupleInbreedingSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class CoupleInbreedingApi extends BaseAPI implements ICoupleInbreedingApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: CoupleInbreedingSearch): Promise<PaginatedResultsOfCoupleInbreedingGridDto> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCoupleInbreedingGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCoupleInbreedingGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCoupleInbreedingGridDto>(null as any);
    }

    save(coupleInbreedingId: number | undefined, fatherId: number | undefined, motherId: number | undefined, inbreedingPercentage: number | undefined, inbreedingProof: FileParameter | null | undefined, validated: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (coupleInbreedingId === null || coupleInbreedingId === undefined)
            throw new Error("The parameter 'coupleInbreedingId' cannot be null.");
        else
            content_.append("CoupleInbreedingId", coupleInbreedingId.toString());
        if (fatherId === null || fatherId === undefined)
            throw new Error("The parameter 'fatherId' cannot be null.");
        else
            content_.append("FatherId", fatherId.toString());
        if (motherId === null || motherId === undefined)
            throw new Error("The parameter 'motherId' cannot be null.");
        else
            content_.append("MotherId", motherId.toString());
        if (inbreedingPercentage === null || inbreedingPercentage === undefined)
            throw new Error("The parameter 'inbreedingPercentage' cannot be null.");
        else
            content_.append("InbreedingPercentage", inbreedingPercentage.toString());
        if (inbreedingProof !== null && inbreedingProof !== undefined)
            content_.append("InbreedingProof", inbreedingProof.data, inbreedingProof.fileName ? inbreedingProof.fileName : "InbreedingProof");
        if (validated === null || validated === undefined)
            throw new Error("The parameter 'validated' cannot be null.");
        else
            content_.append("Validated", validated.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(coupleInbreedingId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding?";
        if (coupleInbreedingId === null)
            throw new Error("The parameter 'coupleInbreedingId' cannot be null.");
        else if (coupleInbreedingId !== undefined)
            url_ += "coupleInbreedingId=" + encodeURIComponent("" + coupleInbreedingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getBroodRequestInbreeding(broodRequestId: number | undefined): Promise<CoupleInbreedingDto[]> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/broodrequest?";
        if (broodRequestId === null)
            throw new Error("The parameter 'broodRequestId' cannot be null.");
        else if (broodRequestId !== undefined)
            url_ += "broodRequestId=" + encodeURIComponent("" + broodRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBroodRequestInbreeding(_response));
        });
    }

    protected processGetBroodRequestInbreeding(response: Response): Promise<CoupleInbreedingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoupleInbreedingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoupleInbreedingDto[]>(null as any);
    }

    getCouplesInbreeding(motherId: number | undefined, fatherIds: number[]): Promise<CoupleInbreedingDto[]> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/getCouplesInbreeding?";
        if (motherId === null)
            throw new Error("The parameter 'motherId' cannot be null.");
        else if (motherId !== undefined)
            url_ += "motherId=" + encodeURIComponent("" + motherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fatherIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCouplesInbreeding(_response));
        });
    }

    protected processGetCouplesInbreeding(response: Response): Promise<CoupleInbreedingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoupleInbreedingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoupleInbreedingDto[]>(null as any);
    }

    isCoupleInbreedingComplete(motherId: number | undefined, fatherIds: number[]): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/isCoupleInbreedingComplete?";
        if (motherId === null)
            throw new Error("The parameter 'motherId' cannot be null.");
        else if (motherId !== undefined)
            url_ += "motherId=" + encodeURIComponent("" + motherId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fatherIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsCoupleInbreedingComplete(_response));
        });
    }

    protected processIsCoupleInbreedingComplete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    exportXlsFile(sObj: CoupleInbreedingSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/CoupleInbreeding/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDashboardApi {

    baseSearch(sObj: DashboardSearch): Promise<PaginatedResultsOfDashboardTaskGridDto>;

    searchByTask(sObj: DashboardSearch): Promise<PaginatedResultsOfDashboardTaskGridDto>;

    getuserDepartements(): Promise<EDepartment[]>;

    close(dashboardTaskId: number | undefined): Promise<Result>;

    closeMultiple(dashboardTaskIds: number[]): Promise<Result>;

    assign(dashboardTaskIds: number[]): Promise<Result>;

    exportXlsFile(sObj: DashboardSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DashboardApi extends BaseAPI implements IDashboardApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DashboardSearch): Promise<PaginatedResultsOfDashboardTaskGridDto> {
        let url_ = this.baseUrl + "/api/Dashboard/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDashboardTaskGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDashboardTaskGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDashboardTaskGridDto>(null as any);
    }

    searchByTask(sObj: DashboardSearch): Promise<PaginatedResultsOfDashboardTaskGridDto> {
        let url_ = this.baseUrl + "/api/Dashboard/searchByTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByTask(_response));
        });
    }

    protected processSearchByTask(response: Response): Promise<PaginatedResultsOfDashboardTaskGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDashboardTaskGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDashboardTaskGridDto>(null as any);
    }

    getuserDepartements(): Promise<EDepartment[]> {
        let url_ = this.baseUrl + "/api/Dashboard/departmentCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetuserDepartements(_response));
        });
    }

    protected processGetuserDepartements(response: Response): Promise<EDepartment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EDepartment[]>(null as any);
    }

    close(dashboardTaskId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Dashboard/close?";
        if (dashboardTaskId === null)
            throw new Error("The parameter 'dashboardTaskId' cannot be null.");
        else if (dashboardTaskId !== undefined)
            url_ += "dashboardTaskId=" + encodeURIComponent("" + dashboardTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    closeMultiple(dashboardTaskIds: number[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/Dashboard/closeMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardTaskIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseMultiple(_response));
        });
    }

    protected processCloseMultiple(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    assign(dashboardTaskIds: number[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/Dashboard/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardTaskIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssign(_response));
        });
    }

    protected processAssign(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: DashboardSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Dashboard/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Dashboard/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDashboardDogsApi {

    baseSearch(sObj: DashboardDogSearch): Promise<PaginatedResultsOfDashboardSubTaskGridDto>;

    exportXlsFile(sObj: DashboardDogSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DashboardDogsApi extends BaseAPI implements IDashboardDogsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DashboardDogSearch): Promise<PaginatedResultsOfDashboardSubTaskGridDto> {
        let url_ = this.baseUrl + "/api/DashboardDogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDashboardSubTaskGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDashboardSubTaskGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDashboardSubTaskGridDto>(null as any);
    }

    exportXlsFile(sObj: DashboardDogSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DashboardDogs/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DashboardDogs/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DashboardDogs/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDocumentTemplateApi {

    baseSearch(sObj: DocumentTemplateSearch): Promise<PaginatedResultsOfDocumentTemplateGridDto>;

    getDisplayName(documentTemplateId: number | undefined): Promise<string>;

    getDocumentTemplate(documentTemplateId: number | undefined): Promise<DocumentTemplateDto>;

    saveDocumentTemplate(toSave: DocumentTemplateDto): Promise<number>;

    exportXlsFile(sObj: DocumentTemplateSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DocumentTemplateApi extends BaseAPI implements IDocumentTemplateApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DocumentTemplateSearch): Promise<PaginatedResultsOfDocumentTemplateGridDto> {
        let url_ = this.baseUrl + "/api/DocumentTemplate/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDocumentTemplateGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDocumentTemplateGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDocumentTemplateGridDto>(null as any);
    }

    getDisplayName(documentTemplateId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DocumentTemplate/displayName?";
        if (documentTemplateId === null)
            throw new Error("The parameter 'documentTemplateId' cannot be null.");
        else if (documentTemplateId !== undefined)
            url_ += "documentTemplateId=" + encodeURIComponent("" + documentTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDocumentTemplate(documentTemplateId: number | undefined): Promise<DocumentTemplateDto> {
        let url_ = this.baseUrl + "/api/DocumentTemplate?";
        if (documentTemplateId === null)
            throw new Error("The parameter 'documentTemplateId' cannot be null.");
        else if (documentTemplateId !== undefined)
            url_ += "documentTemplateId=" + encodeURIComponent("" + documentTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDocumentTemplate(_response));
        });
    }

    protected processGetDocumentTemplate(response: Response): Promise<DocumentTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTemplateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTemplateDto>(null as any);
    }

    saveDocumentTemplate(toSave: DocumentTemplateDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DocumentTemplate/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDocumentTemplate(_response));
        });
    }

    protected processSaveDocumentTemplate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: DocumentTemplateSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DocumentTemplate/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DocumentTemplate/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DocumentTemplate/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogAvailableOwnersApi {

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfPersonGridDto>;

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogAvailableOwnersApi extends BaseAPI implements IDogAvailableOwnersApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfPersonGridDto> {
        let url_ = this.baseUrl + "/api/DogAvailableOwners/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonGridDto>(null as any);
    }

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogAvailableOwners/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogAvailableOwners/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogAvailableOwners/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogBreederApi {

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfDogBreederGridDto>;

    deleteBreeder(breederId: number | undefined): Promise<void>;

    getBreeder(parameters: GetDogBreederParameters): Promise<SaveBreederDto>;

    saveBreeder(dto: SaveBreederDto): Promise<number>;

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogBreederApi extends BaseAPI implements IDogBreederApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfDogBreederGridDto> {
        let url_ = this.baseUrl + "/api/DogBreeder/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogBreederGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogBreederGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogBreederGridDto>(null as any);
    }

    deleteBreeder(breederId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DogBreeder?";
        if (breederId === null)
            throw new Error("The parameter 'breederId' cannot be null.");
        else if (breederId !== undefined)
            url_ += "breederId=" + encodeURIComponent("" + breederId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteBreeder(_response));
        });
    }

    protected processDeleteBreeder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getBreeder(parameters: GetDogBreederParameters): Promise<SaveBreederDto> {
        let url_ = this.baseUrl + "/api/DogBreeder/getBreeder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreeder(_response));
        });
    }

    protected processGetBreeder(response: Response): Promise<SaveBreederDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveBreederDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveBreederDto>(null as any);
    }

    saveBreeder(dto: SaveBreederDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogBreeder/saveBreeder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBreeder(_response));
        });
    }

    protected processSaveBreeder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogBreeder/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogBreeder/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogBreeder/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogBroodRequestApi {

    baseSearch(sObj: DogBroodRequestSearch): Promise<PaginatedResultsOfDogBroodRequestGridDto>;

    exportXlsFile(sObj: DogBroodRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogBroodRequestApi extends BaseAPI implements IDogBroodRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogBroodRequestSearch): Promise<PaginatedResultsOfDogBroodRequestGridDto> {
        let url_ = this.baseUrl + "/api/DogBroodRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogBroodRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogBroodRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogBroodRequestGridDto>(null as any);
    }

    exportXlsFile(sObj: DogBroodRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogBroodRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogBroodRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogBroodRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogChipApi {

    baseSearch(sObj: DogChipSearch): Promise<PaginatedResultsOfDogChipGridDto>;

    getChip(dogChipId: number | undefined): Promise<DogChipDto>;

    delete(dogChipI: number | undefined): Promise<Result>;

    save(dto: DogChipDto): Promise<DogChipDto>;

    isChipUnique(chipNumber: string | null | undefined, dogId: number | undefined): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: DogChipSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogChipApi extends BaseAPI implements IDogChipApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogChipSearch): Promise<PaginatedResultsOfDogChipGridDto> {
        let url_ = this.baseUrl + "/api/DogChip/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogChipGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogChipGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogChipGridDto>(null as any);
    }

    getChip(dogChipId: number | undefined): Promise<DogChipDto> {
        let url_ = this.baseUrl + "/api/DogChip?";
        if (dogChipId === null)
            throw new Error("The parameter 'dogChipId' cannot be null.");
        else if (dogChipId !== undefined)
            url_ += "dogChipId=" + encodeURIComponent("" + dogChipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChip(_response));
        });
    }

    protected processGetChip(response: Response): Promise<DogChipDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogChipDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogChipDto>(null as any);
    }

    delete(dogChipI: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogChip?";
        if (dogChipI === null)
            throw new Error("The parameter 'dogChipI' cannot be null.");
        else if (dogChipI !== undefined)
            url_ += "dogChipI=" + encodeURIComponent("" + dogChipI) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    save(dto: DogChipDto): Promise<DogChipDto> {
        let url_ = this.baseUrl + "/api/DogChip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<DogChipDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogChipDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogChipDto>(null as any);
    }

    isChipUnique(chipNumber: string | null | undefined, dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogChip/isUnique?";
        if (chipNumber !== undefined && chipNumber !== null)
            url_ += "chipNumber=" + encodeURIComponent("" + chipNumber) + "&";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsChipUnique(_response));
        });
    }

    protected processIsChipUnique(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: DogChipSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogChip/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogChip/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogChip/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogApi {

    baseSearch(sObj: DogSearch): Promise<PaginatedResultsOfDogGridDto>;

    searchDogTransient(hideClosed: boolean | undefined, managerId: number | null | undefined, sportSection: boolean | undefined, sObj: DogSearch): Promise<PaginatedResultsOfDogGridDto>;

    dogIsFciRecognizedQuery(dogId: number | undefined): Promise<BooleanDto>;

    getDogSex(dogId: number | undefined): Promise<EDogSex>;

    getDrupalDogFilesList(dogId: number | undefined): Promise<ShpDocumentDto[]>;

    getDogUnicityQuery(dogName: string | null | undefined, kennelId: number | undefined): Promise<ResultOfBoolean>;

    downloadDogDoc(sharepointUri: string | null | undefined, fileName: string | null | undefined): Promise<FileDto>;

    assignManager(managerId: number | undefined, dogTransientId: number[]): Promise<ResultOfBoolean>;

    validateDog(dogTransientId: number[]): Promise<ResultOfBoolean>;

    checkBelgianOwnership(dogId: number | undefined): Promise<ResultOfBoolean>;

    generateDuplicatePedigree(dogId: number | undefined, personId: number | undefined, pedigreeId: number | null | undefined): Promise<Result>;

    checkDogTypeChange(newDogTypeId: number | undefined, currentDogTypeId: number | undefined): Promise<ResultOfBoolean>;

    dogTransientDiscardTask(dogTransientId: number[]): Promise<Result>;

    searchAllIds(sObj: DogSearch): Promise<number[]>;

    getDog(dogId: number | undefined): Promise<DogDto>;

    save(dto: DogDto): Promise<DogDto>;

    delete(dogId: number | undefined): Promise<boolean>;

    getDogFusion(dogId: number | undefined, dogId2: number | undefined): Promise<DogFusionDto>;

    dogFusion(fusion: DogFusionDto): Promise<number>;

    getDogFusionComparisonDogs(dogId1: number | undefined, dogId2: number | undefined): Promise<DogFusionComparisonDto>;

    isDogExport(dogId: number | undefined): Promise<ResultOfBoolean>;

    getDrupalDog(dogId: number | undefined, isBroodRequest: boolean | undefined): Promise<DrupalDogDto>;

    hasAdnProfile(dogId: number | undefined, isBroodRequest: boolean | undefined): Promise<BooleanDto>;

    addCharacteristic(dogId: number | undefined, characteristicId: number | undefined, healthValueId: number | null | undefined, numericValue: number | null | undefined, alphaValue: string | null | undefined, characteristicFile: FileParameter | null | undefined): Promise<Result>;

    getDogType(dogId: number | undefined): Promise<EDogType>;

    getKennelName(kennelId: number | undefined): Promise<FullDogNameKennelDto>;

    hasOwner(dogId: number | undefined): Promise<ResultOfBoolean>;

    isOwner(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean>;

    isDogDeceased(dogId: number | undefined): Promise<ResultOfBoolean>;

    getDogTypeCode(dogTypeId: number | undefined): Promise<EDogType>;

    isDogExcluded(dogId: number | undefined): Promise<ResultOfBoolean>;

    saveDrupal(dog_DogId: number | undefined, dog_IsSportSection: boolean | null | undefined, dog_FirstName: string | null | undefined, dog_BirthDate: Date | null | undefined, dog_DeathDate: Date | null | undefined, dog_PersonId: number | null | undefined, dog_BreedId: number | undefined, dog_DogTypeId: number | null | undefined, dog_ColorId: number | null | undefined, dog_Sex: EDogSex | undefined, dog_SharepointUri: string | null | undefined, dog_DogName: string | null | undefined, dog_Tatoo: string | null | undefined, dog_BreedName: string | null | undefined, dog_ChipNumber: string | null | undefined, dog_CountryPrefixId: number | null | undefined, dog_Pedigree: string | null | undefined, dog_KennelName: string | null | undefined, dog_KennelType: EKennelType | null | undefined, dog_HasAdnProfile: boolean | undefined, dog_WithoutOwnership: boolean | undefined, miscFiles: FileParameter | null | undefined, adnProfile: FileParameter | null | undefined, pedigreeFile: FileParameter | null | undefined, breedingAdmission: FileParameter | null | undefined, healthProfile: FileParameter | null | undefined): Promise<number>;

    getDisplayName(id: number | undefined): Promise<string>;

    hasDogGotChipsOrTattoo(dogId: number | undefined): Promise<boolean>;

    genealogy(dogId: number | undefined, generation: number | undefined, languageId: number | undefined): Promise<DogWithParentsDto[]>;

    isDogOwnerOrBreeder(dogId: number | undefined, personId: number | undefined): Promise<BooleanDto>;

    isDogTemporaryOwner(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean>;

    isDogTemporarilyCeaded(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean>;

    isBelgianDogOwner(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean>;

    updateDogRelative(dogId: number | undefined, dogType: EBroodRequestDogType | undefined, relativeDogId: number | undefined): Promise<void>;

    createInSharepoint(dogId: number): Promise<string>;

    testShpCreateDocumentSet(dogId: number): Promise<string>;

    testShpSendDocument(dogId: number): Promise<string>;

    deleteDocument(dogId: number): Promise<void>;

    deleteDocumentSet(dogId: number): Promise<void>;

    exportXlsFile(sObj: DogSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogApi extends BaseAPI implements IDogApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogSearch): Promise<PaginatedResultsOfDogGridDto> {
        let url_ = this.baseUrl + "/api/Dog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogGridDto>(null as any);
    }

    searchDogTransient(hideClosed: boolean | undefined, managerId: number | null | undefined, sportSection: boolean | undefined, sObj: DogSearch): Promise<PaginatedResultsOfDogGridDto> {
        let url_ = this.baseUrl + "/api/Dog/searchDogTransient?";
        if (hideClosed === null)
            throw new Error("The parameter 'hideClosed' cannot be null.");
        else if (hideClosed !== undefined)
            url_ += "hideClosed=" + encodeURIComponent("" + hideClosed) + "&";
        if (managerId !== undefined && managerId !== null)
            url_ += "managerId=" + encodeURIComponent("" + managerId) + "&";
        if (sportSection === null)
            throw new Error("The parameter 'sportSection' cannot be null.");
        else if (sportSection !== undefined)
            url_ += "sportSection=" + encodeURIComponent("" + sportSection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDogTransient(_response));
        });
    }

    protected processSearchDogTransient(response: Response): Promise<PaginatedResultsOfDogGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogGridDto>(null as any);
    }

    dogIsFciRecognizedQuery(dogId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Dog/isBreedFciRecognized?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDogIsFciRecognizedQuery(_response));
        });
    }

    protected processDogIsFciRecognizedQuery(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getDogSex(dogId: number | undefined): Promise<EDogSex> {
        let url_ = this.baseUrl + "/api/Dog/getDogSex?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogSex(_response));
        });
    }

    protected processGetDogSex(response: Response): Promise<EDogSex> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EDogSex>(null as any);
    }

    getDrupalDogFilesList(dogId: number | undefined): Promise<ShpDocumentDto[]> {
        let url_ = this.baseUrl + "/api/Dog/GetDrupalDogFilesList?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalDogFilesList(_response));
        });
    }

    protected processGetDrupalDogFilesList(response: Response): Promise<ShpDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShpDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShpDocumentDto[]>(null as any);
    }

    getDogUnicityQuery(dogName: string | null | undefined, kennelId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/GetDogUnicity?";
        if (dogName !== undefined && dogName !== null)
            url_ += "dogName=" + encodeURIComponent("" + dogName) + "&";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogUnicityQuery(_response));
        });
    }

    protected processGetDogUnicityQuery(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    downloadDogDoc(sharepointUri: string | null | undefined, fileName: string | null | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/Dog/DownloadDogDoc?";
        if (sharepointUri !== undefined && sharepointUri !== null)
            url_ += "sharepointUri=" + encodeURIComponent("" + sharepointUri) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadDogDoc(_response));
        });
    }

    protected processDownloadDogDoc(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    assignManager(managerId: number | undefined, dogTransientId: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/assignManager?";
        if (managerId === null)
            throw new Error("The parameter 'managerId' cannot be null.");
        else if (managerId !== undefined)
            url_ += "managerId=" + encodeURIComponent("" + managerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dogTransientId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignManager(_response));
        });
    }

    protected processAssignManager(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    validateDog(dogTransientId: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/validateDog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dogTransientId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateDog(_response));
        });
    }

    protected processValidateDog(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    checkBelgianOwnership(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/checkBelgianOwnership?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckBelgianOwnership(_response));
        });
    }

    protected processCheckBelgianOwnership(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    generateDuplicatePedigree(dogId: number | undefined, personId: number | undefined, pedigreeId: number | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Dog/generateDuplicatePedigree?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (pedigreeId !== undefined && pedigreeId !== null)
            url_ += "pedigreeId=" + encodeURIComponent("" + pedigreeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateDuplicatePedigree(_response));
        });
    }

    protected processGenerateDuplicatePedigree(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    checkDogTypeChange(newDogTypeId: number | undefined, currentDogTypeId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/checkDogTypeChange?";
        if (newDogTypeId === null)
            throw new Error("The parameter 'newDogTypeId' cannot be null.");
        else if (newDogTypeId !== undefined)
            url_ += "newDogTypeId=" + encodeURIComponent("" + newDogTypeId) + "&";
        if (currentDogTypeId === null)
            throw new Error("The parameter 'currentDogTypeId' cannot be null.");
        else if (currentDogTypeId !== undefined)
            url_ += "currentDogTypeId=" + encodeURIComponent("" + currentDogTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckDogTypeChange(_response));
        });
    }

    protected processCheckDogTypeChange(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    dogTransientDiscardTask(dogTransientId: number[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/Dog/dogTransientDiscardTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dogTransientId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDogTransientDiscardTask(_response));
        });
    }

    protected processDogTransientDiscardTask(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    searchAllIds(sObj: DogSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Dog/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchAllIds(_response));
        });
    }

    protected processSearchAllIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getDog(dogId: number | undefined): Promise<DogDto> {
        let url_ = this.baseUrl + "/api/Dog?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDog(_response));
        });
    }

    protected processGetDog(response: Response): Promise<DogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogDto>(null as any);
    }

    save(dto: DogDto): Promise<DogDto> {
        let url_ = this.baseUrl + "/api/Dog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<DogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogDto>(null as any);
    }

    delete(dogId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dog?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDogFusion(dogId: number | undefined, dogId2: number | undefined): Promise<DogFusionDto> {
        let url_ = this.baseUrl + "/api/Dog/dogFusion?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (dogId2 === null)
            throw new Error("The parameter 'dogId2' cannot be null.");
        else if (dogId2 !== undefined)
            url_ += "dogId2=" + encodeURIComponent("" + dogId2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogFusion(_response));
        });
    }

    protected processGetDogFusion(response: Response): Promise<DogFusionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogFusionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogFusionDto>(null as any);
    }

    dogFusion(fusion: DogFusionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Dog/dogFusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fusion);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDogFusion(_response));
        });
    }

    protected processDogFusion(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDogFusionComparisonDogs(dogId1: number | undefined, dogId2: number | undefined): Promise<DogFusionComparisonDto> {
        let url_ = this.baseUrl + "/api/Dog/getDogFusionComparison?";
        if (dogId1 === null)
            throw new Error("The parameter 'dogId1' cannot be null.");
        else if (dogId1 !== undefined)
            url_ += "dogId1=" + encodeURIComponent("" + dogId1) + "&";
        if (dogId2 === null)
            throw new Error("The parameter 'dogId2' cannot be null.");
        else if (dogId2 !== undefined)
            url_ += "dogId2=" + encodeURIComponent("" + dogId2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogFusionComparisonDogs(_response));
        });
    }

    protected processGetDogFusionComparisonDogs(response: Response): Promise<DogFusionComparisonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogFusionComparisonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogFusionComparisonDto>(null as any);
    }

    isDogExport(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/isDogExport?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogExport(_response));
        });
    }

    protected processIsDogExport(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getDrupalDog(dogId: number | undefined, isBroodRequest: boolean | undefined): Promise<DrupalDogDto> {
        let url_ = this.baseUrl + "/api/Dog/getDrupalDog?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (isBroodRequest === null)
            throw new Error("The parameter 'isBroodRequest' cannot be null.");
        else if (isBroodRequest !== undefined)
            url_ += "isBroodRequest=" + encodeURIComponent("" + isBroodRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalDog(_response));
        });
    }

    protected processGetDrupalDog(response: Response): Promise<DrupalDogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalDogDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalDogDto>(null as any);
    }

    hasAdnProfile(dogId: number | undefined, isBroodRequest: boolean | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Dog/hasAdnProfile?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (isBroodRequest === null)
            throw new Error("The parameter 'isBroodRequest' cannot be null.");
        else if (isBroodRequest !== undefined)
            url_ += "isBroodRequest=" + encodeURIComponent("" + isBroodRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasAdnProfile(_response));
        });
    }

    protected processHasAdnProfile(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    addCharacteristic(dogId: number | undefined, characteristicId: number | undefined, healthValueId: number | null | undefined, numericValue: number | null | undefined, alphaValue: string | null | undefined, characteristicFile: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Dog/addCharacteristic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dogId === null || dogId === undefined)
            throw new Error("The parameter 'dogId' cannot be null.");
        else
            content_.append("DogId", dogId.toString());
        if (characteristicId === null || characteristicId === undefined)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else
            content_.append("CharacteristicId", characteristicId.toString());
        if (healthValueId !== null && healthValueId !== undefined)
            content_.append("HealthValueId", healthValueId.toString());
        if (numericValue !== null && numericValue !== undefined)
            content_.append("NumericValue", numericValue.toString());
        if (alphaValue !== null && alphaValue !== undefined)
            content_.append("AlphaValue", alphaValue.toString());
        if (characteristicFile !== null && characteristicFile !== undefined)
            content_.append("CharacteristicFile", characteristicFile.data, characteristicFile.fileName ? characteristicFile.fileName : "CharacteristicFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCharacteristic(_response));
        });
    }

    protected processAddCharacteristic(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDogType(dogId: number | undefined): Promise<EDogType> {
        let url_ = this.baseUrl + "/api/Dog/GetDogType?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogType(_response));
        });
    }

    protected processGetDogType(response: Response): Promise<EDogType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EDogType>(null as any);
    }

    getKennelName(kennelId: number | undefined): Promise<FullDogNameKennelDto> {
        let url_ = this.baseUrl + "/api/Dog/getKennelName?";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennelName(_response));
        });
    }

    protected processGetKennelName(response: Response): Promise<FullDogNameKennelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FullDogNameKennelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullDogNameKennelDto>(null as any);
    }

    hasOwner(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/hasOwner?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasOwner(_response));
        });
    }

    protected processHasOwner(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isOwner(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/isOwner?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsOwner(_response));
        });
    }

    protected processIsOwner(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isDogDeceased(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/isDogDeceased?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogDeceased(_response));
        });
    }

    protected processIsDogDeceased(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getDogTypeCode(dogTypeId: number | undefined): Promise<EDogType> {
        let url_ = this.baseUrl + "/api/Dog/GetDogTypeCode?";
        if (dogTypeId === null)
            throw new Error("The parameter 'dogTypeId' cannot be null.");
        else if (dogTypeId !== undefined)
            url_ += "dogTypeId=" + encodeURIComponent("" + dogTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogTypeCode(_response));
        });
    }

    protected processGetDogTypeCode(response: Response): Promise<EDogType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EDogType>(null as any);
    }

    isDogExcluded(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/idDogExcluded?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogExcluded(_response));
        });
    }

    protected processIsDogExcluded(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    saveDrupal(dog_DogId: number | undefined, dog_IsSportSection: boolean | null | undefined, dog_FirstName: string | null | undefined, dog_BirthDate: Date | null | undefined, dog_DeathDate: Date | null | undefined, dog_PersonId: number | null | undefined, dog_BreedId: number | undefined, dog_DogTypeId: number | null | undefined, dog_ColorId: number | null | undefined, dog_Sex: EDogSex | undefined, dog_SharepointUri: string | null | undefined, dog_DogName: string | null | undefined, dog_Tatoo: string | null | undefined, dog_BreedName: string | null | undefined, dog_ChipNumber: string | null | undefined, dog_CountryPrefixId: number | null | undefined, dog_Pedigree: string | null | undefined, dog_KennelName: string | null | undefined, dog_KennelType: EKennelType | null | undefined, dog_HasAdnProfile: boolean | undefined, dog_WithoutOwnership: boolean | undefined, miscFiles: FileParameter | null | undefined, adnProfile: FileParameter | null | undefined, pedigreeFile: FileParameter | null | undefined, breedingAdmission: FileParameter | null | undefined, healthProfile: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Dog/SaveDrupal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dog_DogId === null || dog_DogId === undefined)
            throw new Error("The parameter 'dog_DogId' cannot be null.");
        else
            content_.append("Dog.DogId", dog_DogId.toString());
        if (dog_IsSportSection !== null && dog_IsSportSection !== undefined)
            content_.append("Dog.IsSportSection", dog_IsSportSection.toString());
        if (dog_FirstName !== null && dog_FirstName !== undefined)
            content_.append("Dog.FirstName", dog_FirstName.toString());
        if (dog_BirthDate !== null && dog_BirthDate !== undefined)
            content_.append("Dog.BirthDate", dog_BirthDate.toJSON());
        if (dog_DeathDate !== null && dog_DeathDate !== undefined)
            content_.append("Dog.DeathDate", dog_DeathDate.toJSON());
        if (dog_PersonId !== null && dog_PersonId !== undefined)
            content_.append("Dog.PersonId", dog_PersonId.toString());
        if (dog_BreedId === null || dog_BreedId === undefined)
            throw new Error("The parameter 'dog_BreedId' cannot be null.");
        else
            content_.append("Dog.BreedId", dog_BreedId.toString());
        if (dog_DogTypeId !== null && dog_DogTypeId !== undefined)
            content_.append("Dog.DogTypeId", dog_DogTypeId.toString());
        if (dog_ColorId !== null && dog_ColorId !== undefined)
            content_.append("Dog.ColorId", dog_ColorId.toString());
        if (dog_Sex === null || dog_Sex === undefined)
            throw new Error("The parameter 'dog_Sex' cannot be null.");
        else
            content_.append("Dog.Sex", dog_Sex.toString());
        if (dog_SharepointUri !== null && dog_SharepointUri !== undefined)
            content_.append("Dog.SharepointUri", dog_SharepointUri.toString());
        if (dog_DogName !== null && dog_DogName !== undefined)
            content_.append("Dog.DogName", dog_DogName.toString());
        if (dog_Tatoo !== null && dog_Tatoo !== undefined)
            content_.append("Dog.Tatoo", dog_Tatoo.toString());
        if (dog_BreedName !== null && dog_BreedName !== undefined)
            content_.append("Dog.BreedName", dog_BreedName.toString());
        if (dog_ChipNumber !== null && dog_ChipNumber !== undefined)
            content_.append("Dog.ChipNumber", dog_ChipNumber.toString());
        if (dog_CountryPrefixId !== null && dog_CountryPrefixId !== undefined)
            content_.append("Dog.CountryPrefixId", dog_CountryPrefixId.toString());
        if (dog_Pedigree !== null && dog_Pedigree !== undefined)
            content_.append("Dog.Pedigree", dog_Pedigree.toString());
        if (dog_KennelName !== null && dog_KennelName !== undefined)
            content_.append("Dog.KennelName", dog_KennelName.toString());
        if (dog_KennelType !== null && dog_KennelType !== undefined)
            content_.append("Dog.KennelType", dog_KennelType.toString());
        if (dog_HasAdnProfile === null || dog_HasAdnProfile === undefined)
            throw new Error("The parameter 'dog_HasAdnProfile' cannot be null.");
        else
            content_.append("Dog.HasAdnProfile", dog_HasAdnProfile.toString());
        if (dog_WithoutOwnership === null || dog_WithoutOwnership === undefined)
            throw new Error("The parameter 'dog_WithoutOwnership' cannot be null.");
        else
            content_.append("Dog.WithoutOwnership", dog_WithoutOwnership.toString());
        if (miscFiles !== null && miscFiles !== undefined)
            content_.append("MiscFiles", miscFiles.data, miscFiles.fileName ? miscFiles.fileName : "MiscFiles");
        if (adnProfile !== null && adnProfile !== undefined)
            content_.append("AdnProfile", adnProfile.data, adnProfile.fileName ? adnProfile.fileName : "AdnProfile");
        if (pedigreeFile !== null && pedigreeFile !== undefined)
            content_.append("PedigreeFile", pedigreeFile.data, pedigreeFile.fileName ? pedigreeFile.fileName : "PedigreeFile");
        if (breedingAdmission !== null && breedingAdmission !== undefined)
            content_.append("BreedingAdmission", breedingAdmission.data, breedingAdmission.fileName ? breedingAdmission.fileName : "BreedingAdmission");
        if (healthProfile !== null && healthProfile !== undefined)
            content_.append("HealthProfile", healthProfile.data, healthProfile.fileName ? healthProfile.fileName : "HealthProfile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDrupal(_response));
        });
    }

    protected processSaveDrupal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(id: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Dog/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    hasDogGotChipsOrTattoo(dogId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dog/HasDogGotChipsOrTattoo?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasDogGotChipsOrTattoo(_response));
        });
    }

    protected processHasDogGotChipsOrTattoo(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    genealogy(dogId: number | undefined, generation: number | undefined, languageId: number | undefined): Promise<DogWithParentsDto[]> {
        let url_ = this.baseUrl + "/api/Dog/Genealogy?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (generation === null)
            throw new Error("The parameter 'generation' cannot be null.");
        else if (generation !== undefined)
            url_ += "generation=" + encodeURIComponent("" + generation) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenealogy(_response));
        });
    }

    protected processGenealogy(response: Response): Promise<DogWithParentsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DogWithParentsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogWithParentsDto[]>(null as any);
    }

    isDogOwnerOrBreeder(dogId: number | undefined, personId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Dog/isDogOwnerOrBreeder?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogOwnerOrBreeder(_response));
        });
    }

    protected processIsDogOwnerOrBreeder(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    isDogTemporaryOwner(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/isDogTemporaryOwner?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogTemporaryOwner(_response));
        });
    }

    protected processIsDogTemporaryOwner(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isDogTemporarilyCeaded(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/isDogTemporaryCeaded?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogTemporarilyCeaded(_response));
        });
    }

    protected processIsDogTemporarilyCeaded(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isBelgianDogOwner(dogId: number | undefined, personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Dog/IsBelgianDogOwner?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBelgianDogOwner(_response));
        });
    }

    protected processIsBelgianDogOwner(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    updateDogRelative(dogId: number | undefined, dogType: EBroodRequestDogType | undefined, relativeDogId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dog/UpdateDogRelative?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (dogType === null)
            throw new Error("The parameter 'dogType' cannot be null.");
        else if (dogType !== undefined)
            url_ += "dogType=" + encodeURIComponent("" + dogType) + "&";
        if (relativeDogId === null)
            throw new Error("The parameter 'relativeDogId' cannot be null.");
        else if (relativeDogId !== undefined)
            url_ += "relativeDogId=" + encodeURIComponent("" + relativeDogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDogRelative(_response));
        });
    }

    protected processUpdateDogRelative(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createInSharepoint(dogId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Dog/CreateInSharepoint/{dogId}";
        if (dogId === undefined || dogId === null)
            throw new Error("The parameter 'dogId' must be defined.");
        url_ = url_.replace("{dogId}", encodeURIComponent("" + dogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    testShpCreateDocumentSet(dogId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Dog/test-shp-create-doc-set/{dogId}";
        if (dogId === undefined || dogId === null)
            throw new Error("The parameter 'dogId' must be defined.");
        url_ = url_.replace("{dogId}", encodeURIComponent("" + dogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTestShpCreateDocumentSet(_response));
        });
    }

    protected processTestShpCreateDocumentSet(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    testShpSendDocument(dogId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Dog/test-shp-send-doc/{dogId}";
        if (dogId === undefined || dogId === null)
            throw new Error("The parameter 'dogId' must be defined.");
        url_ = url_.replace("{dogId}", encodeURIComponent("" + dogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTestShpSendDocument(_response));
        });
    }

    protected processTestShpSendDocument(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteDocument(dogId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Dog/test-shp-delete-doc/{dogId}";
        if (dogId === undefined || dogId === null)
            throw new Error("The parameter 'dogId' must be defined.");
        url_ = url_.replace("{dogId}", encodeURIComponent("" + dogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDocument(_response));
        });
    }

    protected processDeleteDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteDocumentSet(dogId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Dog/test-shp-delete-doc-set/{dogId}";
        if (dogId === undefined || dogId === null)
            throw new Error("The parameter 'dogId' must be defined.");
        url_ = url_.replace("{dogId}", encodeURIComponent("" + dogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDocumentSet(_response));
        });
    }

    protected processDeleteDocumentSet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: DogSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dog/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Dog/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Dog/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogDnaApi {

    baseSearch(sObj: DogDnaSearch): Promise<PaginatedResultsOfDogDnaMarkersGridDto>;

    isDogInShp(dogId: number | undefined): Promise<ResultOfBoolean>;

    getDnaMarkerResult(dnaMarkerResultId: number | undefined): Promise<DnaMarkerResultDto>;

    getDnaMarkers(dogId: number | undefined): Promise<MarkerListDto>;

    saveDnaMarkerResult(dnaMarkerResult: DnaMarkerResultDto): Promise<DnaMarkerResultDto>;

    deleteAllDogDna(dogId: number | undefined): Promise<boolean>;

    deleteDogDnaProfile(dogId: number | undefined): Promise<boolean>;

    dogHasOpenBroodRequest(dogId: number | undefined): Promise<boolean>;

    saveNewDnaMarkerResult(dnaMarkerResults: MarkerListDto): Promise<Result>;

    getDnaResult(dogId: number | undefined, isag: EIsagNorm | undefined): Promise<DogDnaResultDto>;

    saveDnaResult(dto: DogDnaResultDto): Promise<number>;

    exportXlsFile(sObj: DogDnaSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogDnaApi extends BaseAPI implements IDogDnaApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogDnaSearch): Promise<PaginatedResultsOfDogDnaMarkersGridDto> {
        let url_ = this.baseUrl + "/api/DogDna/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogDnaMarkersGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogDnaMarkersGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogDnaMarkersGridDto>(null as any);
    }

    isDogInShp(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogDna/isDogInShp?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogInShp(_response));
        });
    }

    protected processIsDogInShp(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getDnaMarkerResult(dnaMarkerResultId: number | undefined): Promise<DnaMarkerResultDto> {
        let url_ = this.baseUrl + "/api/DogDna/getDnaMarkerResult?";
        if (dnaMarkerResultId === null)
            throw new Error("The parameter 'dnaMarkerResultId' cannot be null.");
        else if (dnaMarkerResultId !== undefined)
            url_ += "dnaMarkerResultId=" + encodeURIComponent("" + dnaMarkerResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDnaMarkerResult(_response));
        });
    }

    protected processGetDnaMarkerResult(response: Response): Promise<DnaMarkerResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DnaMarkerResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DnaMarkerResultDto>(null as any);
    }

    getDnaMarkers(dogId: number | undefined): Promise<MarkerListDto> {
        let url_ = this.baseUrl + "/api/DogDna/getDnaMarkers?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDnaMarkers(_response));
        });
    }

    protected processGetDnaMarkers(response: Response): Promise<MarkerListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkerListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarkerListDto>(null as any);
    }

    saveDnaMarkerResult(dnaMarkerResult: DnaMarkerResultDto): Promise<DnaMarkerResultDto> {
        let url_ = this.baseUrl + "/api/DogDna/SaveDnaMarkerResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dnaMarkerResult);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDnaMarkerResult(_response));
        });
    }

    protected processSaveDnaMarkerResult(response: Response): Promise<DnaMarkerResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DnaMarkerResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DnaMarkerResultDto>(null as any);
    }

    deleteAllDogDna(dogId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DogDna/deleteAllDogDna?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAllDogDna(_response));
        });
    }

    protected processDeleteAllDogDna(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteDogDnaProfile(dogId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DogDna/deleteDogDnaProfile?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDogDnaProfile(_response));
        });
    }

    protected processDeleteDogDnaProfile(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    dogHasOpenBroodRequest(dogId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/DogDna/dogHasOpenBroodRequest?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDogHasOpenBroodRequest(_response));
        });
    }

    protected processDogHasOpenBroodRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    saveNewDnaMarkerResult(dnaMarkerResults: MarkerListDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogDna/SaveNewDnaMarkerResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dnaMarkerResults);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewDnaMarkerResult(_response));
        });
    }

    protected processSaveNewDnaMarkerResult(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDnaResult(dogId: number | undefined, isag: EIsagNorm | undefined): Promise<DogDnaResultDto> {
        let url_ = this.baseUrl + "/api/DogDna?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (isag === null)
            throw new Error("The parameter 'isag' cannot be null.");
        else if (isag !== undefined)
            url_ += "isag=" + encodeURIComponent("" + isag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDnaResult(_response));
        });
    }

    protected processGetDnaResult(response: Response): Promise<DogDnaResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogDnaResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogDnaResultDto>(null as any);
    }

    saveDnaResult(dto: DogDnaResultDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogDna";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDnaResult(_response));
        });
    }

    protected processSaveDnaResult(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: DogDnaSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogDna/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogDna/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogDna/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogDysplasiaApi {

    baseSearch(sObj: DogDysplasiaSearch): Promise<PaginatedResultsOfDogDysplasiaGridDto>;

    get(id: number | undefined): Promise<DogDysplasiaDto>;

    delete(dogDysplasiaId: number | undefined): Promise<Result>;

    save(dto: DogDysplasiaDto): Promise<number>;

    exportXlsFile(sObj: DogDysplasiaSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogDysplasiaApi extends BaseAPI implements IDogDysplasiaApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogDysplasiaSearch): Promise<PaginatedResultsOfDogDysplasiaGridDto> {
        let url_ = this.baseUrl + "/api/DogDysplasia/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogDysplasiaGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogDysplasiaGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogDysplasiaGridDto>(null as any);
    }

    get(id: number | undefined): Promise<DogDysplasiaDto> {
        let url_ = this.baseUrl + "/api/DogDysplasia?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DogDysplasiaDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogDysplasiaDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogDysplasiaDto>(null as any);
    }

    delete(dogDysplasiaId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogDysplasia?";
        if (dogDysplasiaId === null)
            throw new Error("The parameter 'dogDysplasiaId' cannot be null.");
        else if (dogDysplasiaId !== undefined)
            url_ += "dogDysplasiaId=" + encodeURIComponent("" + dogDysplasiaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    save(dto: DogDysplasiaDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogDysplasia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: DogDysplasiaSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogDysplasia/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogDysplasia/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogDysplasia/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogHealthTestApi {

    baseSearch(sObj: DogHealthSearch): Promise<PaginatedResultsOfDogHealthTestGridDto>;

    invalidateDogCharacteristicsValue(dogsCharacteristicsValueId: number | undefined): Promise<Result>;

    saveNewCharacteristic(dto: SaveDogCharacteristicDto): Promise<number>;

    delete(dogCharacteristicValueId: number | undefined): Promise<Result>;

    isTestUnique(dogId: number | undefined, characteristicId: number | undefined, characteristicValueId: number | undefined): Promise<BooleanDto>;

    isTestUniqueTransient(dogId: number | undefined, characteristicId: number | undefined, characteristicValueId: number | undefined): Promise<BooleanDto>;

    exportXlsFile(sObj: DogHealthSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogHealthTestApi extends BaseAPI implements IDogHealthTestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogHealthSearch): Promise<PaginatedResultsOfDogHealthTestGridDto> {
        let url_ = this.baseUrl + "/api/DogHealthTest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogHealthTestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogHealthTestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogHealthTestGridDto>(null as any);
    }

    invalidateDogCharacteristicsValue(dogsCharacteristicsValueId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogHealthTest/InvalidateDogCharacteristicValue?";
        if (dogsCharacteristicsValueId === null)
            throw new Error("The parameter 'dogsCharacteristicsValueId' cannot be null.");
        else if (dogsCharacteristicsValueId !== undefined)
            url_ += "dogsCharacteristicsValueId=" + encodeURIComponent("" + dogsCharacteristicsValueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvalidateDogCharacteristicsValue(_response));
        });
    }

    protected processInvalidateDogCharacteristicsValue(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveNewCharacteristic(dto: SaveDogCharacteristicDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogHealthTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewCharacteristic(_response));
        });
    }

    protected processSaveNewCharacteristic(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(dogCharacteristicValueId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogHealthTest/Delete?";
        if (dogCharacteristicValueId === null)
            throw new Error("The parameter 'dogCharacteristicValueId' cannot be null.");
        else if (dogCharacteristicValueId !== undefined)
            url_ += "dogCharacteristicValueId=" + encodeURIComponent("" + dogCharacteristicValueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    isTestUnique(dogId: number | undefined, characteristicId: number | undefined, characteristicValueId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/DogHealthTest/IsUnique?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        if (characteristicValueId === null)
            throw new Error("The parameter 'characteristicValueId' cannot be null.");
        else if (characteristicValueId !== undefined)
            url_ += "characteristicValueId=" + encodeURIComponent("" + characteristicValueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsTestUnique(_response));
        });
    }

    protected processIsTestUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    isTestUniqueTransient(dogId: number | undefined, characteristicId: number | undefined, characteristicValueId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/DogHealthTest/IsUniqueTransient?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        if (characteristicValueId === null)
            throw new Error("The parameter 'characteristicValueId' cannot be null.");
        else if (characteristicValueId !== undefined)
            url_ += "characteristicValueId=" + encodeURIComponent("" + characteristicValueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsTestUniqueTransient(_response));
        });
    }

    protected processIsTestUniqueTransient(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    exportXlsFile(sObj: DogHealthSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogHealthTest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogHealthTest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogHealthTest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogHealthTestValidationApi {

    baseSearch(sObj: DogHealthTestValidationSearch): Promise<PaginatedResultsOfDogHealthTestValidationGridDto>;

    validateTask(validated: boolean | undefined, dogHealthTestValidationIds: number[]): Promise<number>;

    assignTask(dogHealthTestValidationIds: number[]): Promise<number>;

    exportXlsFile(sObj: DogHealthTestValidationSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogHealthTestValidationApi extends BaseAPI implements IDogHealthTestValidationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogHealthTestValidationSearch): Promise<PaginatedResultsOfDogHealthTestValidationGridDto> {
        let url_ = this.baseUrl + "/api/DogHealthTestValidation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogHealthTestValidationGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogHealthTestValidationGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogHealthTestValidationGridDto>(null as any);
    }

    validateTask(validated: boolean | undefined, dogHealthTestValidationIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/DogHealthTestValidation/validateTask?";
        if (validated === null)
            throw new Error("The parameter 'validated' cannot be null.");
        else if (validated !== undefined)
            url_ += "validated=" + encodeURIComponent("" + validated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dogHealthTestValidationIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateTask(_response));
        });
    }

    protected processValidateTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    assignTask(dogHealthTestValidationIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/DogHealthTestValidation/assignTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dogHealthTestValidationIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignTask(_response));
        });
    }

    protected processAssignTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: DogHealthTestValidationSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogHealthTestValidation/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogHealthTestValidation/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogHealthTestValidation/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogHistoryApi {

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfDogHistoryActionGridDto>;

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogHistoryApi extends BaseAPI implements IDogHistoryApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfDogHistoryActionGridDto> {
        let url_ = this.baseUrl + "/api/DogHistory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogHistoryActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogHistoryActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogHistoryActionGridDto>(null as any);
    }

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogHistory/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogHistory/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogHistory/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogLinkedRequestApi {

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfRequestGridDto>;

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogLinkedRequestApi extends BaseAPI implements IDogLinkedRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfRequestGridDto> {
        let url_ = this.baseUrl + "/api/DogLinkedRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfRequestGridDto>(null as any);
    }

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogLinkedRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogLinkedRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogLinkedRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogOwnerApi {

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfDogOwnerGridDto>;

    getIds(sObj: DogBaseSearch): Promise<number[]>;

    saveNewOwner(dto: SaveNewOwnerDto): Promise<number>;

    deleteOwner(ownershipId: number | undefined): Promise<void>;

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogOwnerApi extends BaseAPI implements IDogOwnerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogBaseSearch): Promise<PaginatedResultsOfDogOwnerGridDto> {
        let url_ = this.baseUrl + "/api/DogOwner/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogOwnerGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogOwnerGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogOwnerGridDto>(null as any);
    }

    getIds(sObj: DogBaseSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/DogOwner/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    saveNewOwner(dto: SaveNewOwnerDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewOwner(_response));
        });
    }

    protected processSaveNewOwner(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteOwner(ownershipId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DogOwner?";
        if (ownershipId === null)
            throw new Error("The parameter 'ownershipId' cannot be null.");
        else if (ownershipId !== undefined)
            url_ += "ownershipId=" + encodeURIComponent("" + ownershipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteOwner(_response));
        });
    }

    protected processDeleteOwner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: DogBaseSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogOwner/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogOwner/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogOwner/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogOwnershipChangeRequestApi {

    baseSearch(sObj: DogOwnershipChangeSearch): Promise<PaginatedResultsOfDogOwnershipChangeGridDto>;

    regenExecutionDocuments(rshRequestId: number | undefined): Promise<Result>;

    getParentRequestId(dogOwnershipChangeRequestId: number | undefined): Promise<number>;

    isRequestExport(ownerIds: number[]): Promise<ResultOfBoolean>;

    reprintDocuments(dogOwnershipChangeRequestId: number | undefined): Promise<Result>;

    getDisplayName(dogOwnershipChangeRequestId: number | undefined): Promise<string>;

    isDogAvailable(dogId: number | undefined, dogOwnershipRequestId: number | undefined): Promise<ResultOfBoolean>;

    isDogOwner(dogId: number | undefined, contactId: number | undefined, ownerIds: number[]): Promise<ResultOfBoolean>;

    isRSHCreationAllowed(dogId: number | undefined): Promise<ResultOfBoolean>;

    getDogOwnershipChangeRequest(dogOwnershipChangeRequestId: number | undefined): Promise<DogOwnershipChangeRequestDto>;

    save(dto: DogOwnershipChangeRequestDto): Promise<number>;

    getDogOwnershipChangeRequestDogId(requestId: number | undefined): Promise<number>;

    closeRequest(requestId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: DogOwnershipChangeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogOwnershipChangeRequestApi extends BaseAPI implements IDogOwnershipChangeRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogOwnershipChangeSearch): Promise<PaginatedResultsOfDogOwnershipChangeGridDto> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogOwnershipChangeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogOwnershipChangeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogOwnershipChangeGridDto>(null as any);
    }

    regenExecutionDocuments(rshRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/RegenExecutionDocuments?";
        if (rshRequestId === null)
            throw new Error("The parameter 'rshRequestId' cannot be null.");
        else if (rshRequestId !== undefined)
            url_ += "rshRequestId=" + encodeURIComponent("" + rshRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegenExecutionDocuments(_response));
        });
    }

    protected processRegenExecutionDocuments(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getParentRequestId(dogOwnershipChangeRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/GetParentRequestId?";
        if (dogOwnershipChangeRequestId === null)
            throw new Error("The parameter 'dogOwnershipChangeRequestId' cannot be null.");
        else if (dogOwnershipChangeRequestId !== undefined)
            url_ += "dogOwnershipChangeRequestId=" + encodeURIComponent("" + dogOwnershipChangeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParentRequestId(_response));
        });
    }

    protected processGetParentRequestId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isRequestExport(ownerIds: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/IsRequestExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ownerIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsRequestExport(_response));
        });
    }

    protected processIsRequestExport(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    reprintDocuments(dogOwnershipChangeRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/reprint?";
        if (dogOwnershipChangeRequestId === null)
            throw new Error("The parameter 'dogOwnershipChangeRequestId' cannot be null.");
        else if (dogOwnershipChangeRequestId !== undefined)
            url_ += "dogOwnershipChangeRequestId=" + encodeURIComponent("" + dogOwnershipChangeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintDocuments(_response));
        });
    }

    protected processReprintDocuments(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDisplayName(dogOwnershipChangeRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/getDisplayName?";
        if (dogOwnershipChangeRequestId === null)
            throw new Error("The parameter 'dogOwnershipChangeRequestId' cannot be null.");
        else if (dogOwnershipChangeRequestId !== undefined)
            url_ += "dogOwnershipChangeRequestId=" + encodeURIComponent("" + dogOwnershipChangeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    isDogAvailable(dogId: number | undefined, dogOwnershipRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/isDogAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (dogOwnershipRequestId === null)
            throw new Error("The parameter 'dogOwnershipRequestId' cannot be null.");
        else if (dogOwnershipRequestId !== undefined)
            url_ += "dogOwnershipRequestId=" + encodeURIComponent("" + dogOwnershipRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isDogOwner(dogId: number | undefined, contactId: number | undefined, ownerIds: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/isDogOwner?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ownerIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogOwner(_response));
        });
    }

    protected processIsDogOwner(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isRSHCreationAllowed(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/isRSHCreationAllowed?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsRSHCreationAllowed(_response));
        });
    }

    protected processIsRSHCreationAllowed(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getDogOwnershipChangeRequest(dogOwnershipChangeRequestId: number | undefined): Promise<DogOwnershipChangeRequestDto> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest?";
        if (dogOwnershipChangeRequestId === null)
            throw new Error("The parameter 'dogOwnershipChangeRequestId' cannot be null.");
        else if (dogOwnershipChangeRequestId !== undefined)
            url_ += "dogOwnershipChangeRequestId=" + encodeURIComponent("" + dogOwnershipChangeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogOwnershipChangeRequest(_response));
        });
    }

    protected processGetDogOwnershipChangeRequest(response: Response): Promise<DogOwnershipChangeRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DogOwnershipChangeRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DogOwnershipChangeRequestDto>(null as any);
    }

    save(dto: DogOwnershipChangeRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDogOwnershipChangeRequestDogId(requestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/getDogId?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogOwnershipChangeRequestDogId(_response));
        });
    }

    protected processGetDogOwnershipChangeRequestDogId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    closeRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/closeDogOwnershipChangeRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseRequest(_response));
        });
    }

    protected processCloseRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: DogOwnershipChangeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogOwnershipChangeRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogPedigreeApi {

    baseSearch(sObj: DogPedigreeSearch): Promise<PaginatedResultsOfDogPedigreeGridDto>;

    addOrEditPedigree(dto: SaveNewPedigreeDto): Promise<number>;

    getDogPedigree(pedigreeId: number | undefined): Promise<SaveNewPedigreeDto>;

    deleteDogPedigree(pedigreeId: number | undefined): Promise<void>;

    pedigreeUnique(pedigree: string | null | undefined): Promise<ResultOfBoolean>;

    testPedigreeExists(pedigreePrefixId: number | undefined, no: number | undefined): Promise<BooleanDto>;

    exportXlsFile(sObj: DogPedigreeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogPedigreeApi extends BaseAPI implements IDogPedigreeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogPedigreeSearch): Promise<PaginatedResultsOfDogPedigreeGridDto> {
        let url_ = this.baseUrl + "/api/DogPedigree/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogPedigreeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogPedigreeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogPedigreeGridDto>(null as any);
    }

    addOrEditPedigree(dto: SaveNewPedigreeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogPedigree/AddOrEditPedigree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrEditPedigree(_response));
        });
    }

    protected processAddOrEditPedigree(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDogPedigree(pedigreeId: number | undefined): Promise<SaveNewPedigreeDto> {
        let url_ = this.baseUrl + "/api/DogPedigree/GetDogPedigree?";
        if (pedigreeId === null)
            throw new Error("The parameter 'pedigreeId' cannot be null.");
        else if (pedigreeId !== undefined)
            url_ += "pedigreeId=" + encodeURIComponent("" + pedigreeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogPedigree(_response));
        });
    }

    protected processGetDogPedigree(response: Response): Promise<SaveNewPedigreeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveNewPedigreeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveNewPedigreeDto>(null as any);
    }

    deleteDogPedigree(pedigreeId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DogPedigree?";
        if (pedigreeId === null)
            throw new Error("The parameter 'pedigreeId' cannot be null.");
        else if (pedigreeId !== undefined)
            url_ += "pedigreeId=" + encodeURIComponent("" + pedigreeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDogPedigree(_response));
        });
    }

    protected processDeleteDogPedigree(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pedigreeUnique(pedigree: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogPedigree/PedigreeUnique?";
        if (pedigree !== undefined && pedigree !== null)
            url_ += "pedigree=" + encodeURIComponent("" + pedigree) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPedigreeUnique(_response));
        });
    }

    protected processPedigreeUnique(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    testPedigreeExists(pedigreePrefixId: number | undefined, no: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/DogPedigree/PedigreeExists?";
        if (pedigreePrefixId === null)
            throw new Error("The parameter 'pedigreePrefixId' cannot be null.");
        else if (pedigreePrefixId !== undefined)
            url_ += "pedigreePrefixId=" + encodeURIComponent("" + pedigreePrefixId) + "&";
        if (no === null)
            throw new Error("The parameter 'no' cannot be null.");
        else if (no !== undefined)
            url_ += "no=" + encodeURIComponent("" + no) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTestPedigreeExists(_response));
        });
    }

    protected processTestPedigreeExists(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    exportXlsFile(sObj: DogPedigreeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogPedigree/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogPedigree/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogPedigree/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogPersonRelatedApi {

    getDogOwnership(dogOwnershipId: number | undefined): Promise<SaveNewOwnerDto>;

    saveNewOwner(dto: SaveNewOwnerDto): Promise<number>;

    deleteOwner(ownershipId: number | undefined): Promise<void>;

    baseSearch(sObj: DogPersonRelatedSearch): Promise<PaginatedResultsOfDogPersonRelatedGridDto>;

    exportXlsFile(sObj: DogPersonRelatedSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogPersonRelatedApi extends BaseAPI implements IDogPersonRelatedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDogOwnership(dogOwnershipId: number | undefined): Promise<SaveNewOwnerDto> {
        let url_ = this.baseUrl + "/api/DogPersonRelated?";
        if (dogOwnershipId === null)
            throw new Error("The parameter 'dogOwnershipId' cannot be null.");
        else if (dogOwnershipId !== undefined)
            url_ += "dogOwnershipId=" + encodeURIComponent("" + dogOwnershipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogOwnership(_response));
        });
    }

    protected processGetDogOwnership(response: Response): Promise<SaveNewOwnerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveNewOwnerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveNewOwnerDto>(null as any);
    }

    saveNewOwner(dto: SaveNewOwnerDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogPersonRelated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewOwner(_response));
        });
    }

    protected processSaveNewOwner(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteOwner(ownershipId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DogPersonRelated?";
        if (ownershipId === null)
            throw new Error("The parameter 'ownershipId' cannot be null.");
        else if (ownershipId !== undefined)
            url_ += "ownershipId=" + encodeURIComponent("" + ownershipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteOwner(_response));
        });
    }

    protected processDeleteOwner(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    baseSearch(sObj: DogPersonRelatedSearch): Promise<PaginatedResultsOfDogPersonRelatedGridDto> {
        let url_ = this.baseUrl + "/api/DogPersonRelated/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogPersonRelatedGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogPersonRelatedGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogPersonRelatedGridDto>(null as any);
    }

    exportXlsFile(sObj: DogPersonRelatedSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogPersonRelated/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogPersonRelated/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogPersonRelated/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogResultsApi {

    baseSearch(sObj: DogCompetitionResultSearch): Promise<PaginatedResultsOfDogCompetitionResultGridDto>;

    getIds(sObj: DogCompetitionResultSearch): Promise<number[]>;

    getDogCompetitionResult(competitionResultId: number | undefined): Promise<SaveNewResultDto>;

    saveNewResult(dto: SaveNewResultDto): Promise<number>;

    deleteResult(resultId: number | undefined): Promise<void>;

    exportXlsFile(sObj: DogCompetitionResultSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogResultsApi extends BaseAPI implements IDogResultsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogCompetitionResultSearch): Promise<PaginatedResultsOfDogCompetitionResultGridDto> {
        let url_ = this.baseUrl + "/api/DogResults/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogCompetitionResultGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogCompetitionResultGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogCompetitionResultGridDto>(null as any);
    }

    getIds(sObj: DogCompetitionResultSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/DogResults/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getDogCompetitionResult(competitionResultId: number | undefined): Promise<SaveNewResultDto> {
        let url_ = this.baseUrl + "/api/DogResults?";
        if (competitionResultId === null)
            throw new Error("The parameter 'competitionResultId' cannot be null.");
        else if (competitionResultId !== undefined)
            url_ += "competitionResultId=" + encodeURIComponent("" + competitionResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogCompetitionResult(_response));
        });
    }

    protected processGetDogCompetitionResult(response: Response): Promise<SaveNewResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveNewResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveNewResultDto>(null as any);
    }

    saveNewResult(dto: SaveNewResultDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewResult(_response));
        });
    }

    protected processSaveNewResult(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteResult(resultId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DogResults?";
        if (resultId === null)
            throw new Error("The parameter 'resultId' cannot be null.");
        else if (resultId !== undefined)
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteResult(_response));
        });
    }

    protected processDeleteResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: DogCompetitionResultSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogResults/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogResults/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogResults/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogsBreederApi {

    baseSearch(sObj: DogsBreederSearch): Promise<PaginatedResultsOfDogsBreederGridDto>;

    saveDogsBreeder(toSave: DogBreederSaveDto): Promise<number>;

    deleteDogsBreeder(dogsBreederId: number | undefined): Promise<Result>;

    getAvailablePeople(sObj: AvailablePeopleSearch): Promise<PaginatedResultsOfPersonGridDto>;

    exportXlsFile(sObj: DogsBreederSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogsBreederApi extends BaseAPI implements IDogsBreederApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogsBreederSearch): Promise<PaginatedResultsOfDogsBreederGridDto> {
        let url_ = this.baseUrl + "/api/DogsBreeder/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogsBreederGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogsBreederGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogsBreederGridDto>(null as any);
    }

    saveDogsBreeder(toSave: DogBreederSaveDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogsBreeder/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDogsBreeder(_response));
        });
    }

    protected processSaveDogsBreeder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDogsBreeder(dogsBreederId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogsBreeder?";
        if (dogsBreederId === null)
            throw new Error("The parameter 'dogsBreederId' cannot be null.");
        else if (dogsBreederId !== undefined)
            url_ += "dogsBreederId=" + encodeURIComponent("" + dogsBreederId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDogsBreeder(_response));
        });
    }

    protected processDeleteDogsBreeder(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getAvailablePeople(sObj: AvailablePeopleSearch): Promise<PaginatedResultsOfPersonGridDto> {
        let url_ = this.baseUrl + "/api/DogsBreeder/availablePeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailablePeople(_response));
        });
    }

    protected processGetAvailablePeople(response: Response): Promise<PaginatedResultsOfPersonGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonGridDto>(null as any);
    }

    exportXlsFile(sObj: DogsBreederSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogsBreeder/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogsBreeder/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogsBreeder/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogsTransientCharacteristicsApi {

    baseSearch(sObj: TransientCharacteristicsSearch): Promise<PaginatedResultsOfTransientCharacteristicGridDto>;

    create(dogId: number | undefined, characteristicId: number | undefined, healthValueId: number | null | undefined, numericValue: number | null | undefined, alphaValue: string | null | undefined, characteristicFile: FileParameter | null | undefined): Promise<Result>;

    searchByDog(sObj: TransientCharacteristicByDogSearch): Promise<PaginatedResultsOfDogHealthTestGridDto>;

    close(idsToValidate: number[]): Promise<Result>;

    assign(idsToAssign: number[]): Promise<ResultOfBoolean>;

    validate(idsToValidate: number[]): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: TransientCharacteristicsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogsTransientCharacteristicsApi extends BaseAPI implements IDogsTransientCharacteristicsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TransientCharacteristicsSearch): Promise<PaginatedResultsOfTransientCharacteristicGridDto> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTransientCharacteristicGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTransientCharacteristicGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTransientCharacteristicGridDto>(null as any);
    }

    create(dogId: number | undefined, characteristicId: number | undefined, healthValueId: number | null | undefined, numericValue: number | null | undefined, alphaValue: string | null | undefined, characteristicFile: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dogId === null || dogId === undefined)
            throw new Error("The parameter 'dogId' cannot be null.");
        else
            content_.append("DogId", dogId.toString());
        if (characteristicId === null || characteristicId === undefined)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else
            content_.append("CharacteristicId", characteristicId.toString());
        if (healthValueId !== null && healthValueId !== undefined)
            content_.append("HealthValueId", healthValueId.toString());
        if (numericValue !== null && numericValue !== undefined)
            content_.append("NumericValue", numericValue.toString());
        if (alphaValue !== null && alphaValue !== undefined)
            content_.append("AlphaValue", alphaValue.toString());
        if (characteristicFile !== null && characteristicFile !== undefined)
            content_.append("CharacteristicFile", characteristicFile.data, characteristicFile.fileName ? characteristicFile.fileName : "CharacteristicFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    searchByDog(sObj: TransientCharacteristicByDogSearch): Promise<PaginatedResultsOfDogHealthTestGridDto> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/searchByDog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByDog(_response));
        });
    }

    protected processSearchByDog(response: Response): Promise<PaginatedResultsOfDogHealthTestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogHealthTestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogHealthTestGridDto>(null as any);
    }

    close(idsToValidate: number[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/close";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToValidate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    assign(idsToAssign: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToAssign);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssign(_response));
        });
    }

    protected processAssign(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    validate(idsToValidate: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToValidate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: TransientCharacteristicsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogsTransientCharacteristics/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogTitlesApi {

    baseSearch(sObj: DogTitleSearch): Promise<PaginatedResultsOfDogTitlesGridDto>;

    isTitleAvailable(dogId: number | undefined, titleId: number | undefined, year: number | undefined): Promise<ResultOfBoolean>;

    getdogTitleAs400(dogId: number | undefined): Promise<As400TitleDto>;

    saveNewDogTitle(dto: SaveNewDogTitleDto): Promise<number>;

    deleteDogTitle(titleId: number | undefined): Promise<void>;

    updateDogTitleAs400(dogId: number | undefined, as400Ttile: string | null | undefined): Promise<number>;

    exportXlsFile(sObj: DogTitleSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogTitlesApi extends BaseAPI implements IDogTitlesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogTitleSearch): Promise<PaginatedResultsOfDogTitlesGridDto> {
        let url_ = this.baseUrl + "/api/DogTitles/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDogTitlesGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogTitlesGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogTitlesGridDto>(null as any);
    }

    isTitleAvailable(dogId: number | undefined, titleId: number | undefined, year: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogTitles/isTitleAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsTitleAvailable(_response));
        });
    }

    protected processIsTitleAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getdogTitleAs400(dogId: number | undefined): Promise<As400TitleDto> {
        let url_ = this.baseUrl + "/api/DogTitles/getdogTitleAs400?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetdogTitleAs400(_response));
        });
    }

    protected processGetdogTitleAs400(response: Response): Promise<As400TitleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = As400TitleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<As400TitleDto>(null as any);
    }

    saveNewDogTitle(dto: SaveNewDogTitleDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewDogTitle(_response));
        });
    }

    protected processSaveNewDogTitle(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDogTitle(titleId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DogTitles?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDogTitle(_response));
        });
    }

    protected processDeleteDogTitle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDogTitleAs400(dogId: number | undefined, as400Ttile: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DogTitles/updateDogTitleAS400?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (as400Ttile !== undefined && as400Ttile !== null)
            url_ += "as400Ttile=" + encodeURIComponent("" + as400Ttile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDogTitleAs400(_response));
        });
    }

    protected processUpdateDogTitleAs400(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: DogTitleSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogTitles/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogTitles/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogTitles/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogTransientOwnersApi {

    baseSearch(sObj: TransientOwnerSearch): Promise<PaginatedResultsOfTransientOwnerGridDto>;

    getIds(sObj: TransientOwnerSearch): Promise<number[]>;

    exportXlsFile(sObj: TransientOwnerSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogTransientOwnersApi extends BaseAPI implements IDogTransientOwnersApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TransientOwnerSearch): Promise<PaginatedResultsOfTransientOwnerGridDto> {
        let url_ = this.baseUrl + "/api/DogTransientOwners/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTransientOwnerGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTransientOwnerGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTransientOwnerGridDto>(null as any);
    }

    getIds(sObj: TransientOwnerSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/DogTransientOwners/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: TransientOwnerSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogTransientOwners/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogTransientOwners/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogTransientOwners/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDogWorkbookApi {

    baseSearch(sObj: DogWorkbookSearch): Promise<PaginatedResultsOfWorkbookGridDto>;

    saveNewWorkbook(dto: SaveNewWorkbookDto): Promise<number>;

    dogWorkbookAvailable(dogId: number | undefined): Promise<ResultOfBoolean>;

    getWorkbook(workbookId: number | undefined): Promise<SaveNewWorkbookDto>;

    getWorkbookInformation(workbookTypeId: number | undefined, dogId: number | undefined, isWorkbookRequest: boolean | undefined): Promise<NewWorkbookInformationDto>;

    isWorkbookRequestOngoing(workbookTypeId: number | undefined, dogId: number | undefined): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: DogWorkbookSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DogWorkbookApi extends BaseAPI implements IDogWorkbookApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogWorkbookSearch): Promise<PaginatedResultsOfWorkbookGridDto> {
        let url_ = this.baseUrl + "/api/DogWorkbook/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfWorkbookGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfWorkbookGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfWorkbookGridDto>(null as any);
    }

    saveNewWorkbook(dto: SaveNewWorkbookDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DogWorkbook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewWorkbook(_response));
        });
    }

    protected processSaveNewWorkbook(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    dogWorkbookAvailable(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogWorkbook/testWorkbookAvailability?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDogWorkbookAvailable(_response));
        });
    }

    protected processDogWorkbookAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getWorkbook(workbookId: number | undefined): Promise<SaveNewWorkbookDto> {
        let url_ = this.baseUrl + "/api/DogWorkbook/getWorkbook?";
        if (workbookId === null)
            throw new Error("The parameter 'workbookId' cannot be null.");
        else if (workbookId !== undefined)
            url_ += "workbookId=" + encodeURIComponent("" + workbookId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbook(_response));
        });
    }

    protected processGetWorkbook(response: Response): Promise<SaveNewWorkbookDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveNewWorkbookDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveNewWorkbookDto>(null as any);
    }

    getWorkbookInformation(workbookTypeId: number | undefined, dogId: number | undefined, isWorkbookRequest: boolean | undefined): Promise<NewWorkbookInformationDto> {
        let url_ = this.baseUrl + "/api/DogWorkbook/getWorkbookInformation?";
        if (workbookTypeId === null)
            throw new Error("The parameter 'workbookTypeId' cannot be null.");
        else if (workbookTypeId !== undefined)
            url_ += "workbookTypeId=" + encodeURIComponent("" + workbookTypeId) + "&";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (isWorkbookRequest === null)
            throw new Error("The parameter 'isWorkbookRequest' cannot be null.");
        else if (isWorkbookRequest !== undefined)
            url_ += "isWorkbookRequest=" + encodeURIComponent("" + isWorkbookRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbookInformation(_response));
        });
    }

    protected processGetWorkbookInformation(response: Response): Promise<NewWorkbookInformationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewWorkbookInformationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewWorkbookInformationDto>(null as any);
    }

    isWorkbookRequestOngoing(workbookTypeId: number | undefined, dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DogWorkbook/workbookOngoing?";
        if (workbookTypeId === null)
            throw new Error("The parameter 'workbookTypeId' cannot be null.");
        else if (workbookTypeId !== undefined)
            url_ += "workbookTypeId=" + encodeURIComponent("" + workbookTypeId) + "&";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsWorkbookRequestOngoing(_response));
        });
    }

    protected processIsWorkbookRequestOngoing(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: DogWorkbookSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DogWorkbook/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DogWorkbook/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DogWorkbook/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDysplasiaApi {

    baseSearch(sObj: DysplasiaSearch): Promise<PaginatedResultsOfDysplasiaGridDto>;

    get(dysplasiaRequestId: number | undefined, languageId: number | undefined): Promise<DysplasiaDto>;

    saveDysplasiaEvaluation(dto: DysplasiaDto): Promise<number>;

    getAllDysplasiaTypes(): Promise<DysplasiaTypeDto[]>;

    getComissionPageInfo(dysplasiaRequestId: number | undefined): Promise<ComissionPageInfoDto>;

    getDysplasiaReport(dto: DysplasiaReportInfoDto): Promise<FileDto>;

    searchDysplasiaUserResult(sObj: UserDysplasiaResultSearch): Promise<PaginatedResultsOfUserDysplasiaResultGridDto>;

    exportXlsFile(sObj: DysplasiaSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DysplasiaApi extends BaseAPI implements IDysplasiaApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DysplasiaSearch): Promise<PaginatedResultsOfDysplasiaGridDto> {
        let url_ = this.baseUrl + "/api/Dysplasia/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDysplasiaGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDysplasiaGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDysplasiaGridDto>(null as any);
    }

    get(dysplasiaRequestId: number | undefined, languageId: number | undefined): Promise<DysplasiaDto> {
        let url_ = this.baseUrl + "/api/Dysplasia?";
        if (dysplasiaRequestId === null)
            throw new Error("The parameter 'dysplasiaRequestId' cannot be null.");
        else if (dysplasiaRequestId !== undefined)
            url_ += "dysplasiaRequestId=" + encodeURIComponent("" + dysplasiaRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DysplasiaDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DysplasiaDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DysplasiaDto>(null as any);
    }

    saveDysplasiaEvaluation(dto: DysplasiaDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Dysplasia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDysplasiaEvaluation(_response));
        });
    }

    protected processSaveDysplasiaEvaluation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAllDysplasiaTypes(): Promise<DysplasiaTypeDto[]> {
        let url_ = this.baseUrl + "/api/Dysplasia/getAllDysplasiaTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllDysplasiaTypes(_response));
        });
    }

    protected processGetAllDysplasiaTypes(response: Response): Promise<DysplasiaTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DysplasiaTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DysplasiaTypeDto[]>(null as any);
    }

    getComissionPageInfo(dysplasiaRequestId: number | undefined): Promise<ComissionPageInfoDto> {
        let url_ = this.baseUrl + "/api/Dysplasia/getComissionPageInfo?";
        if (dysplasiaRequestId === null)
            throw new Error("The parameter 'dysplasiaRequestId' cannot be null.");
        else if (dysplasiaRequestId !== undefined)
            url_ += "dysplasiaRequestId=" + encodeURIComponent("" + dysplasiaRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetComissionPageInfo(_response));
        });
    }

    protected processGetComissionPageInfo(response: Response): Promise<ComissionPageInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComissionPageInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ComissionPageInfoDto>(null as any);
    }

    getDysplasiaReport(dto: DysplasiaReportInfoDto): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/Dysplasia/getDysplasiaReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDysplasiaReport(_response));
        });
    }

    protected processGetDysplasiaReport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    searchDysplasiaUserResult(sObj: UserDysplasiaResultSearch): Promise<PaginatedResultsOfUserDysplasiaResultGridDto> {
        let url_ = this.baseUrl + "/api/Dysplasia/searchDysplasiaUserResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDysplasiaUserResult(_response));
        });
    }

    protected processSearchDysplasiaUserResult(response: Response): Promise<PaginatedResultsOfUserDysplasiaResultGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserDysplasiaResultGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserDysplasiaResultGridDto>(null as any);
    }

    exportXlsFile(sObj: DysplasiaSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dysplasia/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Dysplasia/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Dysplasia/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IDysplasiaRequestApi {

    baseSearch(sObj: DysplasiaRequestSearch): Promise<PaginatedResultsOfDysplasiaRequestGridDto>;

    get(dysplasiaRequestId: number | undefined): Promise<DysplasiaRequestDto>;

    save(toSave: DysplasiaRequestDto): Promise<number>;

    downloadDysplasiaFile(sharepointUri: string | null | undefined, fileName: string | null | undefined): Promise<FileDto>;

    getDysplasiaFileList(sharepointUri: string | null | undefined): Promise<ShpDocumentDto[]>;

    getAppealRequest(requestId: number | undefined): Promise<DysplasiaRequestDto>;

    getSubRequest(masterRequestId: number | undefined, languageId: number | undefined): Promise<DysplasiaRequestDto>;

    regenerateDysplasiaCertificate(requestId: number | undefined): Promise<Result>;

    close(requestId: number | undefined): Promise<Result>;

    isDogAvailable(dogId: number | undefined, dysplasiaRequestId: number | undefined): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: DysplasiaRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class DysplasiaRequestApi extends BaseAPI implements IDysplasiaRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DysplasiaRequestSearch): Promise<PaginatedResultsOfDysplasiaRequestGridDto> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfDysplasiaRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDysplasiaRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDysplasiaRequestGridDto>(null as any);
    }

    get(dysplasiaRequestId: number | undefined): Promise<DysplasiaRequestDto> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest?";
        if (dysplasiaRequestId === null)
            throw new Error("The parameter 'dysplasiaRequestId' cannot be null.");
        else if (dysplasiaRequestId !== undefined)
            url_ += "DysplasiaRequestId=" + encodeURIComponent("" + dysplasiaRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DysplasiaRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DysplasiaRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DysplasiaRequestDto>(null as any);
    }

    save(toSave: DysplasiaRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadDysplasiaFile(sharepointUri: string | null | undefined, fileName: string | null | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/DownloadDysplasiaDoc?";
        if (sharepointUri !== undefined && sharepointUri !== null)
            url_ += "sharepointUri=" + encodeURIComponent("" + sharepointUri) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadDysplasiaFile(_response));
        });
    }

    protected processDownloadDysplasiaFile(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    getDysplasiaFileList(sharepointUri: string | null | undefined): Promise<ShpDocumentDto[]> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/GetDysplasiaFileList?";
        if (sharepointUri !== undefined && sharepointUri !== null)
            url_ += "sharepointUri=" + encodeURIComponent("" + sharepointUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDysplasiaFileList(_response));
        });
    }

    protected processGetDysplasiaFileList(response: Response): Promise<ShpDocumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShpDocumentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShpDocumentDto[]>(null as any);
    }

    getAppealRequest(requestId: number | undefined): Promise<DysplasiaRequestDto> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/getAppealRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAppealRequest(_response));
        });
    }

    protected processGetAppealRequest(response: Response): Promise<DysplasiaRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DysplasiaRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DysplasiaRequestDto>(null as any);
    }

    getSubRequest(masterRequestId: number | undefined, languageId: number | undefined): Promise<DysplasiaRequestDto> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/getSubRequest?";
        if (masterRequestId === null)
            throw new Error("The parameter 'masterRequestId' cannot be null.");
        else if (masterRequestId !== undefined)
            url_ += "masterRequestId=" + encodeURIComponent("" + masterRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubRequest(_response));
        });
    }

    protected processGetSubRequest(response: Response): Promise<DysplasiaRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DysplasiaRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DysplasiaRequestDto>(null as any);
    }

    regenerateDysplasiaCertificate(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/RegenerateDysplasiaCertificate?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegenerateDysplasiaCertificate(_response));
        });
    }

    protected processRegenerateDysplasiaCertificate(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    isDogAvailable(dogId: number | undefined, dysplasiaRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/dogAvailability?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (dysplasiaRequestId === null)
            throw new Error("The parameter 'dysplasiaRequestId' cannot be null.");
        else if (dysplasiaRequestId !== undefined)
            url_ += "dysplasiaRequestId=" + encodeURIComponent("" + dysplasiaRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: DysplasiaRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/DysplasiaRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IEmailApi {

    baseSearch(sObj: EmailSearch): Promise<PaginatedResultsOfEmailGridDto>;

    getDisplayName(mailTemplateId: number | undefined): Promise<string>;

    getEmail(mailTemplateId: number | undefined): Promise<EmailDto>;

    saveEmail(toSave: EmailDto): Promise<number>;

    export(): Promise<FileDownload>;

    upload(file: FileParameter | null | undefined): Promise<void>;

    exportXlsFile(sObj: EmailSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class EmailApi extends BaseAPI implements IEmailApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: EmailSearch): Promise<PaginatedResultsOfEmailGridDto> {
        let url_ = this.baseUrl + "/api/Email/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfEmailGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfEmailGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfEmailGridDto>(null as any);
    }

    getDisplayName(mailTemplateId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Email/displayName?";
        if (mailTemplateId === null)
            throw new Error("The parameter 'mailTemplateId' cannot be null.");
        else if (mailTemplateId !== undefined)
            url_ += "mailTemplateId=" + encodeURIComponent("" + mailTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getEmail(mailTemplateId: number | undefined): Promise<EmailDto> {
        let url_ = this.baseUrl + "/api/Email?";
        if (mailTemplateId === null)
            throw new Error("The parameter 'mailTemplateId' cannot be null.");
        else if (mailTemplateId !== undefined)
            url_ += "mailTemplateId=" + encodeURIComponent("" + mailTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmail(_response));
        });
    }

    protected processGetEmail(response: Response): Promise<EmailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailDto>(null as any);
    }

    saveEmail(toSave: EmailDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Email/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveEmail(_response));
        });
    }

    protected processSaveEmail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    export(): Promise<FileDownload> {
        let url_ = this.baseUrl + "/api/Email/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownload.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDownload>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: EmailSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Email/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Email/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Email/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IExpatriationRequestApi {

    baseSearch(sObj: ExpatriationRequestSearchDto): Promise<PaginatedResultsOfExpatriationRequestGridDto>;

    getExpatriationRequest(expatriationRequestId: number | undefined): Promise<ExpatriationRequestDto>;

    save(toSave: ExpatriationRequestDto): Promise<number>;

    getExpatriationRequestIsForeignDog(expatRequestId: number | undefined): Promise<BooleanDto>;

    closeExpatriationRequest(requestId: number | undefined): Promise<Result>;

    getDisplayName(expatriationRequestId: number | undefined): Promise<string>;

    exportXlsFile(sObj: ExpatriationRequestSearchDto): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ExpatriationRequestApi extends BaseAPI implements IExpatriationRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ExpatriationRequestSearchDto): Promise<PaginatedResultsOfExpatriationRequestGridDto> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfExpatriationRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfExpatriationRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfExpatriationRequestGridDto>(null as any);
    }

    getExpatriationRequest(expatriationRequestId: number | undefined): Promise<ExpatriationRequestDto> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest?";
        if (expatriationRequestId === null)
            throw new Error("The parameter 'expatriationRequestId' cannot be null.");
        else if (expatriationRequestId !== undefined)
            url_ += "expatriationRequestId=" + encodeURIComponent("" + expatriationRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExpatriationRequest(_response));
        });
    }

    protected processGetExpatriationRequest(response: Response): Promise<ExpatriationRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpatriationRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpatriationRequestDto>(null as any);
    }

    save(toSave: ExpatriationRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getExpatriationRequestIsForeignDog(expatRequestId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/is-foreign-dog?";
        if (expatRequestId === null)
            throw new Error("The parameter 'expatRequestId' cannot be null.");
        else if (expatRequestId !== undefined)
            url_ += "expatRequestId=" + encodeURIComponent("" + expatRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExpatriationRequestIsForeignDog(_response));
        });
    }

    protected processGetExpatriationRequestIsForeignDog(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    closeExpatriationRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/CloseExpatriationRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseExpatriationRequest(_response));
        });
    }

    protected processCloseExpatriationRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDisplayName(expatriationRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/GetDisplayName?";
        if (expatriationRequestId === null)
            throw new Error("The parameter 'expatriationRequestId' cannot be null.");
        else if (expatriationRequestId !== undefined)
            url_ += "expatriationRequestId=" + encodeURIComponent("" + expatriationRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: ExpatriationRequestSearchDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ExpatriationRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IHealthPackApi {

    baseSearch(sObj: HealthPackSearch): Promise<PaginatedResultsOfHealthPackGridDto>;

    getHealthPack(healthPackId: number | undefined): Promise<HealthPackDto>;

    save(dto: HealthPackDto): Promise<number>;

    delete(id: number | undefined): Promise<Result>;

    getIds(sObj: HealthPackSearch): Promise<number[]>;

    getDisplayName(healthPackId: number | undefined): Promise<string>;

    exportXlsFile(sObj: HealthPackSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class HealthPackApi extends BaseAPI implements IHealthPackApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: HealthPackSearch): Promise<PaginatedResultsOfHealthPackGridDto> {
        let url_ = this.baseUrl + "/api/HealthPack/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfHealthPackGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfHealthPackGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfHealthPackGridDto>(null as any);
    }

    getHealthPack(healthPackId: number | undefined): Promise<HealthPackDto> {
        let url_ = this.baseUrl + "/api/HealthPack?";
        if (healthPackId === null)
            throw new Error("The parameter 'healthPackId' cannot be null.");
        else if (healthPackId !== undefined)
            url_ += "healthPackId=" + encodeURIComponent("" + healthPackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthPack(_response));
        });
    }

    protected processGetHealthPack(response: Response): Promise<HealthPackDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthPackDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthPackDto>(null as any);
    }

    save(dto: HealthPackDto): Promise<number> {
        let url_ = this.baseUrl + "/api/HealthPack";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/HealthPack?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getIds(sObj: HealthPackSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/HealthPack/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getDisplayName(healthPackId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/HealthPack/DisplayName?";
        if (healthPackId === null)
            throw new Error("The parameter 'healthPackId' cannot be null.");
        else if (healthPackId !== undefined)
            url_ += "healthPackId=" + encodeURIComponent("" + healthPackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: HealthPackSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/HealthPack/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/HealthPack/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/HealthPack/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IHealthTestRequestApi {

    baseSearch(sObj: HealthTestRequestSearch): Promise<PaginatedResultsOfHealthTestRequestGridDto>;

    searchLinkedSingleHealthTests(sObj: BaseHealthTestRequestSearch): Promise<PaginatedResultsOfCharacteristicsGridDto>;

    get(healthTestRequestId: number | undefined): Promise<HealthTestRequestDto>;

    save(dto: HealthTestRequestDto): Promise<number>;

    getBlockedHealthTests(healthTestRequestId: number | undefined, dogId: number | null | undefined): Promise<BlockedHealthTestDto>;

    getLab(healthTestRequestId: number | undefined): Promise<ELab>;

    getSubRequest(masterRequestId: number | undefined): Promise<HealthTestRequestDto>;

    close(requestId: number | undefined): Promise<Result>;

    createProgenusOrder(healthTestRequestId: number | undefined): Promise<ResultOfBoolean>;

    createZoolyxOrder(healthTestRequestId: number | undefined): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: HealthTestRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class HealthTestRequestApi extends BaseAPI implements IHealthTestRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: HealthTestRequestSearch): Promise<PaginatedResultsOfHealthTestRequestGridDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfHealthTestRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfHealthTestRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfHealthTestRequestGridDto>(null as any);
    }

    searchLinkedSingleHealthTests(sObj: BaseHealthTestRequestSearch): Promise<PaginatedResultsOfCharacteristicsGridDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/searchLinkedSingleHealthTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchLinkedSingleHealthTests(_response));
        });
    }

    protected processSearchLinkedSingleHealthTests(response: Response): Promise<PaginatedResultsOfCharacteristicsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCharacteristicsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCharacteristicsGridDto>(null as any);
    }

    get(healthTestRequestId: number | undefined): Promise<HealthTestRequestDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequest?";
        if (healthTestRequestId === null)
            throw new Error("The parameter 'healthTestRequestId' cannot be null.");
        else if (healthTestRequestId !== undefined)
            url_ += "healthTestRequestId=" + encodeURIComponent("" + healthTestRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<HealthTestRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTestRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthTestRequestDto>(null as any);
    }

    save(dto: HealthTestRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/HealthTestRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getBlockedHealthTests(healthTestRequestId: number | undefined, dogId: number | null | undefined): Promise<BlockedHealthTestDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/getBlockedHealthTests?";
        if (healthTestRequestId === null)
            throw new Error("The parameter 'healthTestRequestId' cannot be null.");
        else if (healthTestRequestId !== undefined)
            url_ += "healthTestRequestId=" + encodeURIComponent("" + healthTestRequestId) + "&";
        if (dogId !== undefined && dogId !== null)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBlockedHealthTests(_response));
        });
    }

    protected processGetBlockedHealthTests(response: Response): Promise<BlockedHealthTestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlockedHealthTestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlockedHealthTestDto>(null as any);
    }

    getLab(healthTestRequestId: number | undefined): Promise<ELab> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/getLab?";
        if (healthTestRequestId === null)
            throw new Error("The parameter 'healthTestRequestId' cannot be null.");
        else if (healthTestRequestId !== undefined)
            url_ += "healthTestRequestId=" + encodeURIComponent("" + healthTestRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLab(_response));
        });
    }

    protected processGetLab(response: Response): Promise<ELab> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ELab>(null as any);
    }

    getSubRequest(masterRequestId: number | undefined): Promise<HealthTestRequestDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/getSubRequest?";
        if (masterRequestId === null)
            throw new Error("The parameter 'masterRequestId' cannot be null.");
        else if (masterRequestId !== undefined)
            url_ += "masterRequestId=" + encodeURIComponent("" + masterRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubRequest(_response));
        });
    }

    protected processGetSubRequest(response: Response): Promise<HealthTestRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthTestRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthTestRequestDto>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    createProgenusOrder(healthTestRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/createProgenusOrder?";
        if (healthTestRequestId === null)
            throw new Error("The parameter 'healthTestRequestId' cannot be null.");
        else if (healthTestRequestId !== undefined)
            url_ += "healthTestRequestId=" + encodeURIComponent("" + healthTestRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProgenusOrder(_response));
        });
    }

    protected processCreateProgenusOrder(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    createZoolyxOrder(healthTestRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/createZoolyxOrder?";
        if (healthTestRequestId === null)
            throw new Error("The parameter 'healthTestRequestId' cannot be null.");
        else if (healthTestRequestId !== undefined)
            url_ += "healthTestRequestId=" + encodeURIComponent("" + healthTestRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateZoolyxOrder(_response));
        });
    }

    protected processCreateZoolyxOrder(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: HealthTestRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/HealthTestRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IHealthTestRequestHealthPacksApi {

    baseSearch(sObj: HealthRequestPacksSearch): Promise<PaginatedResultsOfHealthTestRequestPackGridDto>;

    searchLinkedHealthPacks(sObj: HealthRequestPacksSearch): Promise<PaginatedResultsOfHealthTestRequestPackGridDto>;

    exportXlsFile(sObj: HealthRequestPacksSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class HealthTestRequestHealthPacksApi extends BaseAPI implements IHealthTestRequestHealthPacksApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: HealthRequestPacksSearch): Promise<PaginatedResultsOfHealthTestRequestPackGridDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequestHealthPacks/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfHealthTestRequestPackGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfHealthTestRequestPackGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfHealthTestRequestPackGridDto>(null as any);
    }

    searchLinkedHealthPacks(sObj: HealthRequestPacksSearch): Promise<PaginatedResultsOfHealthTestRequestPackGridDto> {
        let url_ = this.baseUrl + "/api/HealthTestRequestHealthPacks/searchLinkedHalthPacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchLinkedHealthPacks(_response));
        });
    }

    protected processSearchLinkedHealthPacks(response: Response): Promise<PaginatedResultsOfHealthTestRequestPackGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfHealthTestRequestPackGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfHealthTestRequestPackGridDto>(null as any);
    }

    exportXlsFile(sObj: HealthRequestPacksSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/HealthTestRequestHealthPacks/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/HealthTestRequestHealthPacks/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/HealthTestRequestHealthPacks/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IImportRequestApi {

    baseSearch(sObj: ImportRequestSearch): Promise<PaginatedResultsOfImportRequestGridDto>;

    get(importRequestId: number | undefined): Promise<ImportRequestDto>;

    save(dto: ImportRequestDto): Promise<number>;

    regenExecutionDocuments(importRequestId: number | undefined): Promise<Result>;

    isDogAvailable(dogId: number | undefined, importRequestId: number | undefined): Promise<ResultOfBoolean>;

    checkOnDogPedigree(dogId: number | undefined): Promise<ResultOfBoolean>;

    checkTransientOwnerCountries(ownerIds: number[]): Promise<ResultOfBoolean>;

    close(requestId: number | undefined): Promise<Result>;

    reprintDocument(importRequestId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: ImportRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ImportRequestApi extends BaseAPI implements IImportRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ImportRequestSearch): Promise<PaginatedResultsOfImportRequestGridDto> {
        let url_ = this.baseUrl + "/api/ImportRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfImportRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfImportRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfImportRequestGridDto>(null as any);
    }

    get(importRequestId: number | undefined): Promise<ImportRequestDto> {
        let url_ = this.baseUrl + "/api/ImportRequest?";
        if (importRequestId === null)
            throw new Error("The parameter 'importRequestId' cannot be null.");
        else if (importRequestId !== undefined)
            url_ += "importRequestId=" + encodeURIComponent("" + importRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ImportRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportRequestDto>(null as any);
    }

    save(dto: ImportRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/ImportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    regenExecutionDocuments(importRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ImportRequest/regenExecution?";
        if (importRequestId === null)
            throw new Error("The parameter 'importRequestId' cannot be null.");
        else if (importRequestId !== undefined)
            url_ += "importRequestId=" + encodeURIComponent("" + importRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegenExecutionDocuments(_response));
        });
    }

    protected processRegenExecutionDocuments(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    isDogAvailable(dogId: number | undefined, importRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/ImportRequest/isDogAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (importRequestId === null)
            throw new Error("The parameter 'importRequestId' cannot be null.");
        else if (importRequestId !== undefined)
            url_ += "importRequestId=" + encodeURIComponent("" + importRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    checkOnDogPedigree(dogId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/ImportRequest/checkOnDogPedigree?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckOnDogPedigree(_response));
        });
    }

    protected processCheckOnDogPedigree(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    checkTransientOwnerCountries(ownerIds: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/ImportRequest/checkTransientOwnerCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ownerIds);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckTransientOwnerCountries(_response));
        });
    }

    protected processCheckTransientOwnerCountries(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ImportRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    reprintDocument(importRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ImportRequest/reprintDocument?";
        if (importRequestId === null)
            throw new Error("The parameter 'importRequestId' cannot be null.");
        else if (importRequestId !== undefined)
            url_ += "importRequestId=" + encodeURIComponent("" + importRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintDocument(_response));
        });
    }

    protected processReprintDocument(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: ImportRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ImportRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ImportRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ImportRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IImportRequestTransientOwnersApi {

    baseSearch(sObj: ImportRequestTransientOwnersSearch): Promise<PaginatedResultsOfImportRequestTransientOwnersGridDto>;

    getIds(sObj: ImportRequestTransientOwnersSearch): Promise<number[]>;

    exportXlsFile(sObj: ImportRequestTransientOwnersSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ImportRequestTransientOwnersApi extends BaseAPI implements IImportRequestTransientOwnersApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ImportRequestTransientOwnersSearch): Promise<PaginatedResultsOfImportRequestTransientOwnersGridDto> {
        let url_ = this.baseUrl + "/api/ImportRequestTransientOwners/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfImportRequestTransientOwnersGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfImportRequestTransientOwnersGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfImportRequestTransientOwnersGridDto>(null as any);
    }

    getIds(sObj: ImportRequestTransientOwnersSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/ImportRequestTransientOwners/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: ImportRequestTransientOwnersSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ImportRequestTransientOwners/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ImportRequestTransientOwners/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ImportRequestTransientOwners/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IIngenicoApi {

    ok(): Promise<Result>;

    nok(): Promise<Result>;
}

export class IngenicoApi extends BaseAPI implements IIngenicoApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    ok(): Promise<Result> {
        let url_ = this.baseUrl + "/api/Ingenico/ok";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOk(_response));
        });
    }

    protected processOk(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    nok(): Promise<Result> {
        let url_ = this.baseUrl + "/api/Ingenico/nok";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNok(_response));
        });
    }

    protected processNok(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export interface IJudgeApi {

    baseSearch(sObj: JudgeSearch): Promise<PaginatedResultsOfJudgeGridDto>;

    judgeInformations(personId: number | undefined): Promise<JudgeInformationDto>;

    saveJudgeInformations(judgeInformationDto: JudgeInformationDto): Promise<number>;

    searchJudgeByBreed(breedId: number | undefined): Promise<PaginatedResultsOfJudgeGridDto>;

    searchAllIds(sObj: JudgeSearch): Promise<number[]>;

    exportXlsFile(sObj: JudgeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class JudgeApi extends BaseAPI implements IJudgeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: JudgeSearch): Promise<PaginatedResultsOfJudgeGridDto> {
        let url_ = this.baseUrl + "/api/Judge/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeGridDto>(null as any);
    }

    judgeInformations(personId: number | undefined): Promise<JudgeInformationDto> {
        let url_ = this.baseUrl + "/api/Judge/judge?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processJudgeInformations(_response));
        });
    }

    protected processJudgeInformations(response: Response): Promise<JudgeInformationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JudgeInformationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JudgeInformationDto>(null as any);
    }

    saveJudgeInformations(judgeInformationDto: JudgeInformationDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Judge/saveJudgeInformations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(judgeInformationDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveJudgeInformations(_response));
        });
    }

    protected processSaveJudgeInformations(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    searchJudgeByBreed(breedId: number | undefined): Promise<PaginatedResultsOfJudgeGridDto> {
        let url_ = this.baseUrl + "/api/Judge/SearchByBreed?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchJudgeByBreed(_response));
        });
    }

    protected processSearchJudgeByBreed(response: Response): Promise<PaginatedResultsOfJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeGridDto>(null as any);
    }

    searchAllIds(sObj: JudgeSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Judge/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchAllIds(_response));
        });
    }

    protected processSearchAllIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: JudgeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Judge/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Judge/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Judge/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IJudgeTransientBreedApi {

    baseSearch(sObj: JudgeTransientBreedSearch): Promise<PaginatedResultsOfJudgeTransientBreedGridDto>;

    removeJudgeTransientBreeds(breedJudgeTransientIds: number[]): Promise<number>;

    validateJudgeTransientBreeds(breedJudgeTransientIds: number[]): Promise<number>;

    exportXlsFile(sObj: JudgeTransientBreedSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class JudgeTransientBreedApi extends BaseAPI implements IJudgeTransientBreedApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: JudgeTransientBreedSearch): Promise<PaginatedResultsOfJudgeTransientBreedGridDto> {
        let url_ = this.baseUrl + "/api/JudgeTransientBreed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfJudgeTransientBreedGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfJudgeTransientBreedGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfJudgeTransientBreedGridDto>(null as any);
    }

    removeJudgeTransientBreeds(breedJudgeTransientIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/JudgeTransientBreed/RemoveJudgeTransientBreeds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breedJudgeTransientIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveJudgeTransientBreeds(_response));
        });
    }

    protected processRemoveJudgeTransientBreeds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    validateJudgeTransientBreeds(breedJudgeTransientIds: number[]): Promise<number> {
        let url_ = this.baseUrl + "/api/JudgeTransientBreed/ValidateJudgeTransientBreeds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breedJudgeTransientIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateJudgeTransientBreeds(_response));
        });
    }

    protected processValidateJudgeTransientBreeds(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: JudgeTransientBreedSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/JudgeTransientBreed/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/JudgeTransientBreed/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/JudgeTransientBreed/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IKennelApi {

    baseSearch(sObj: KennelSearch): Promise<PaginatedResultsOfKennelGridDto>;

    get(id: number | undefined): Promise<KennelDto>;

    save(dto: KennelDto): Promise<KennelDto>;

    delete(id: number | undefined): Promise<boolean>;

    getDisplayName(id: number | undefined): Promise<string>;

    isKennelExcluded(id: number | undefined): Promise<BooleanDto>;

    getKennelType(id: number | undefined): Promise<EKennelType>;

    getKennelOwnership(kennelOwnershipId: number | undefined): Promise<SaveKennelOwnerDto>;

    addNewKennelOwner(dto: SaveKennelOwnerDto): Promise<number>;

    getAllowedBreedsIds(kennelId: number | undefined): Promise<KennelSaveBreedsDto>;

    isKennelBelgian(kennelId: number | undefined): Promise<ResultOfBoolean>;

    saveLinkedBreeds(dto: KennelSaveBreedsDto): Promise<KennelSaveBreedsDto>;

    closeKennel(kennelId: number | undefined): Promise<Result>;

    createInSharepoint(kennelId: number): Promise<string>;

    exportXlsFile(sObj: KennelSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class KennelApi extends BaseAPI implements IKennelApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: KennelSearch): Promise<PaginatedResultsOfKennelGridDto> {
        let url_ = this.baseUrl + "/api/Kennel/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfKennelGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfKennelGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfKennelGridDto>(null as any);
    }

    get(id: number | undefined): Promise<KennelDto> {
        let url_ = this.baseUrl + "/api/Kennel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<KennelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelDto>(null as any);
    }

    save(dto: KennelDto): Promise<KennelDto> {
        let url_ = this.baseUrl + "/api/Kennel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<KennelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelDto>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Kennel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDisplayName(id: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Kennel/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    isKennelExcluded(id: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Kennel/kennelExcluded?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsKennelExcluded(_response));
        });
    }

    protected processIsKennelExcluded(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getKennelType(id: number | undefined): Promise<EKennelType> {
        let url_ = this.baseUrl + "/api/Kennel/GetKennelType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennelType(_response));
        });
    }

    protected processGetKennelType(response: Response): Promise<EKennelType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EKennelType>(null as any);
    }

    getKennelOwnership(kennelOwnershipId: number | undefined): Promise<SaveKennelOwnerDto> {
        let url_ = this.baseUrl + "/api/Kennel/getKennelOwnership?";
        if (kennelOwnershipId === null)
            throw new Error("The parameter 'kennelOwnershipId' cannot be null.");
        else if (kennelOwnershipId !== undefined)
            url_ += "kennelOwnershipId=" + encodeURIComponent("" + kennelOwnershipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennelOwnership(_response));
        });
    }

    protected processGetKennelOwnership(response: Response): Promise<SaveKennelOwnerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveKennelOwnerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveKennelOwnerDto>(null as any);
    }

    addNewKennelOwner(dto: SaveKennelOwnerDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Kennel/saveNewKennelOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddNewKennelOwner(_response));
        });
    }

    protected processAddNewKennelOwner(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAllowedBreedsIds(kennelId: number | undefined): Promise<KennelSaveBreedsDto> {
        let url_ = this.baseUrl + "/api/Kennel/GetAllowedBreedsIds?";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllowedBreedsIds(_response));
        });
    }

    protected processGetAllowedBreedsIds(response: Response): Promise<KennelSaveBreedsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelSaveBreedsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelSaveBreedsDto>(null as any);
    }

    isKennelBelgian(kennelId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Kennel/IsKennelBelgian?";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsKennelBelgian(_response));
        });
    }

    protected processIsKennelBelgian(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    saveLinkedBreeds(dto: KennelSaveBreedsDto): Promise<KennelSaveBreedsDto> {
        let url_ = this.baseUrl + "/api/Kennel/SaveAllowedBreeds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveLinkedBreeds(_response));
        });
    }

    protected processSaveLinkedBreeds(response: Response): Promise<KennelSaveBreedsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KennelSaveBreedsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KennelSaveBreedsDto>(null as any);
    }

    closeKennel(kennelId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Kennel/CloseKennel?";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseKennel(_response));
        });
    }

    protected processCloseKennel(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    createInSharepoint(kennelId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Kennel/CreateInSharepoint/{kennelId}";
        if (kennelId === undefined || kennelId === null)
            throw new Error("The parameter 'kennelId' must be defined.");
        url_ = url_.replace("{kennelId}", encodeURIComponent("" + kennelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: KennelSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Kennel/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Kennel/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Kennel/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IKennelDogApi {

    baseSearch(sObj: KennelDogSearch): Promise<PaginatedResultsOfKennelDogDto>;

    exportXlsFile(sObj: KennelDogSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class KennelDogApi extends BaseAPI implements IKennelDogApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: KennelDogSearch): Promise<PaginatedResultsOfKennelDogDto> {
        let url_ = this.baseUrl + "/api/KennelDog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfKennelDogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfKennelDogDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfKennelDogDto>(null as any);
    }

    exportXlsFile(sObj: KennelDogSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/KennelDog/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/KennelDog/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/KennelDog/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IKennelOwnerApi {

    baseSearch(sObj: KennelOwnerSearch): Promise<PaginatedResultsOfKennelOwnerDto>;

    getIds(sObj: KennelOwnerSearch): Promise<number[]>;

    exportXlsFile(sObj: KennelOwnerSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class KennelOwnerApi extends BaseAPI implements IKennelOwnerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: KennelOwnerSearch): Promise<PaginatedResultsOfKennelOwnerDto> {
        let url_ = this.baseUrl + "/api/KennelOwner/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfKennelOwnerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfKennelOwnerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfKennelOwnerDto>(null as any);
    }

    getIds(sObj: KennelOwnerSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/KennelOwner/Ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: KennelOwnerSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/KennelOwner/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/KennelOwner/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/KennelOwner/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ILanguageApi {

    getLanguages(hasTranslation: boolean | undefined): Promise<LanguageDto[]>;

    getByLanguageId(languageId: number | undefined): Promise<LanguageDto>;

    getDisplayName(languageId: number | undefined): Promise<string>;

    deleteLanguage(languageId: number | undefined): Promise<number>;

    save(dto: LanguageDto): Promise<number>;

    baseSearch(sObj: LanguageSearchDto): Promise<PaginatedResultsOfLanguageGridDto>;

    exportXlsFile(sObj: LanguageSearchDto): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class LanguageApi extends BaseAPI implements ILanguageApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLanguages(hasTranslation: boolean | undefined): Promise<LanguageDto[]> {
        let url_ = this.baseUrl + "/api/Language/languages?";
        if (hasTranslation === null)
            throw new Error("The parameter 'hasTranslation' cannot be null.");
        else if (hasTranslation !== undefined)
            url_ += "hasTranslation=" + encodeURIComponent("" + hasTranslation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<LanguageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto[]>(null as any);
    }

    getByLanguageId(languageId: number | undefined): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/Language/GetByLanguageId?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByLanguageId(_response));
        });
    }

    protected processGetByLanguageId(response: Response): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto>(null as any);
    }

    getDisplayName(languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Language/GetDisplayName?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteLanguage(languageId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Language?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteLanguage(_response));
        });
    }

    protected processDeleteLanguage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    save(dto: LanguageDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    baseSearch(sObj: LanguageSearchDto): Promise<PaginatedResultsOfLanguageGridDto> {
        let url_ = this.baseUrl + "/api/Language/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfLanguageGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfLanguageGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfLanguageGridDto>(null as any);
    }

    exportXlsFile(sObj: LanguageSearchDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Language/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Language/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Language/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ILinkedRequestsApi {

    baseSearch(sObj: LinkedRequestsSearch): Promise<PaginatedResultsOfRequestGridDto>;

    exportXlsFile(sObj: LinkedRequestsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class LinkedRequestsApi extends BaseAPI implements ILinkedRequestsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: LinkedRequestsSearch): Promise<PaginatedResultsOfRequestGridDto> {
        let url_ = this.baseUrl + "/api/LinkedRequests/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfRequestGridDto>(null as any);
    }

    exportXlsFile(sObj: LinkedRequestsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/LinkedRequests/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/LinkedRequests/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/LinkedRequests/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IMailAdminApi {

    baseSearch(sObj: MailSearch): Promise<PaginatedResultsOfMailLogGridDto>;

    exportXlsFile(sObj: MailSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class MailAdminApi extends BaseAPI implements IMailAdminApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: MailSearch): Promise<PaginatedResultsOfMailLogGridDto> {
        let url_ = this.baseUrl + "/api/MailAdmin/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMailLogGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMailLogGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMailLogGridDto>(null as any);
    }

    exportXlsFile(sObj: MailSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MailAdmin/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MailAdmin/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/MailAdmin/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IMembershipHIstoryApi {

    baseSearch(sObj: BasePersonSearch): Promise<PaginatedResultsOfPersonMembershipHistoryGridDto>;

    saveMembershipHistory(dto: SaveMembershipHistoryDto): Promise<number>;

    deleteMembershipHistory(membershipHistoryId: number | undefined): Promise<void>;

    disableRenewal(membershipHistoryId: number | undefined): Promise<void>;

    testMembershipHistoryExistance(dateTo: Date | undefined, dateFrom: Date | undefined, personId: number | undefined): Promise<BooleanDto>;

    exportXlsFile(sObj: BasePersonSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class MembershipHIstoryApi extends BaseAPI implements IMembershipHIstoryApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BasePersonSearch): Promise<PaginatedResultsOfPersonMembershipHistoryGridDto> {
        let url_ = this.baseUrl + "/api/MembershipHIstory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonMembershipHistoryGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonMembershipHistoryGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonMembershipHistoryGridDto>(null as any);
    }

    saveMembershipHistory(dto: SaveMembershipHistoryDto): Promise<number> {
        let url_ = this.baseUrl + "/api/MembershipHIstory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMembershipHistory(_response));
        });
    }

    protected processSaveMembershipHistory(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteMembershipHistory(membershipHistoryId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MembershipHIstory?";
        if (membershipHistoryId === null)
            throw new Error("The parameter 'membershipHistoryId' cannot be null.");
        else if (membershipHistoryId !== undefined)
            url_ += "membershipHistoryId=" + encodeURIComponent("" + membershipHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMembershipHistory(_response));
        });
    }

    protected processDeleteMembershipHistory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    disableRenewal(membershipHistoryId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MembershipHIstory/disableRenewal?";
        if (membershipHistoryId === null)
            throw new Error("The parameter 'membershipHistoryId' cannot be null.");
        else if (membershipHistoryId !== undefined)
            url_ += "membershipHistoryId=" + encodeURIComponent("" + membershipHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisableRenewal(_response));
        });
    }

    protected processDisableRenewal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    testMembershipHistoryExistance(dateTo: Date | undefined, dateFrom: Date | undefined, personId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/MembershipHIstory/HistoryTest?";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTestMembershipHistoryExistance(_response));
        });
    }

    protected processTestMembershipHistoryExistance(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    exportXlsFile(sObj: BasePersonSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MembershipHIstory/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MembershipHIstory/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/MembershipHIstory/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IMembershipRenewalApi {

    baseSearch(sObj: MembershipRenewalSearch): Promise<PaginatedResultsOfMembershipRenewalGridDto>;

    forceRenewal(memberId: number | undefined, value: boolean | undefined): Promise<Result>;

    createRequests(): Promise<Result>;

    exportXlsFile(sObj: MembershipRenewalSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class MembershipRenewalApi extends BaseAPI implements IMembershipRenewalApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: MembershipRenewalSearch): Promise<PaginatedResultsOfMembershipRenewalGridDto> {
        let url_ = this.baseUrl + "/api/MembershipRenewal/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMembershipRenewalGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMembershipRenewalGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMembershipRenewalGridDto>(null as any);
    }

    forceRenewal(memberId: number | undefined, value: boolean | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/MembershipRenewal/forceRenewal?";
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForceRenewal(_response));
        });
    }

    protected processForceRenewal(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    createRequests(): Promise<Result> {
        let url_ = this.baseUrl + "/api/MembershipRenewal/createRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateRequests(_response));
        });
    }

    protected processCreateRequests(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: MembershipRenewalSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MembershipRenewal/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MembershipRenewal/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/MembershipRenewal/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IMembershipRequestApi {

    baseSearch(sObj: MembershipRequestSearch): Promise<PaginatedResultsOfMembershipRequestGridDto>;

    get(membershipRequestId: number | undefined): Promise<MembershipRequestDto>;

    save(dto: MembershipRequestDto): Promise<number>;

    getMembershipDisplayName(membershipRequestId: number | undefined): Promise<string>;

    billedMembershipReqhestsExport(): Promise<FileDto>;

    executedMembershipReqhestsExport(): Promise<FileDto>;

    close(id: number | undefined): Promise<Result>;

    createMembershipTask(id: number | undefined): Promise<ResultOfBoolean>;

    getMembershipDecisionCode(membershipRequestDecisionId: number | undefined): Promise<EMembershipRequestDecision>;

    getMembershipRequestTypeCodeFromRequestId(membershipRequestId: number | undefined): Promise<EMembershipRequestType>;

    getMembershipRequestTypeCode(membershipmembershipRequestTypeCode: number | undefined): Promise<EMembershipRequestType>;

    isUserAvailable(personId: number | undefined, membershipRequestId: number | undefined): Promise<ResultOfBoolean>;

    isUserRenewed(personId: number | undefined): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: MembershipRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class MembershipRequestApi extends BaseAPI implements IMembershipRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: MembershipRequestSearch): Promise<PaginatedResultsOfMembershipRequestGridDto> {
        let url_ = this.baseUrl + "/api/MembershipRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMembershipRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMembershipRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMembershipRequestGridDto>(null as any);
    }

    get(membershipRequestId: number | undefined): Promise<MembershipRequestDto> {
        let url_ = this.baseUrl + "/api/MembershipRequest?";
        if (membershipRequestId === null)
            throw new Error("The parameter 'membershipRequestId' cannot be null.");
        else if (membershipRequestId !== undefined)
            url_ += "membershipRequestId=" + encodeURIComponent("" + membershipRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MembershipRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MembershipRequestDto>(null as any);
    }

    save(dto: MembershipRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/MembershipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getMembershipDisplayName(membershipRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/MembershipRequest/displayName?";
        if (membershipRequestId === null)
            throw new Error("The parameter 'membershipRequestId' cannot be null.");
        else if (membershipRequestId !== undefined)
            url_ += "membershipRequestId=" + encodeURIComponent("" + membershipRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipDisplayName(_response));
        });
    }

    protected processGetMembershipDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    billedMembershipReqhestsExport(): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/MembershipRequest/billedMembershipReqhestsExport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBilledMembershipReqhestsExport(_response));
        });
    }

    protected processBilledMembershipReqhestsExport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    executedMembershipReqhestsExport(): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/MembershipRequest/executedMembershipReqhestsExport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecutedMembershipReqhestsExport(_response));
        });
    }

    protected processExecutedMembershipReqhestsExport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    close(id: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/MembershipRequest/CloseRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    createMembershipTask(id: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/MembershipRequest/createMembershipTask?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMembershipTask(_response));
        });
    }

    protected processCreateMembershipTask(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getMembershipDecisionCode(membershipRequestDecisionId: number | undefined): Promise<EMembershipRequestDecision> {
        let url_ = this.baseUrl + "/api/MembershipRequest/DecisionCode?";
        if (membershipRequestDecisionId === null)
            throw new Error("The parameter 'membershipRequestDecisionId' cannot be null.");
        else if (membershipRequestDecisionId !== undefined)
            url_ += "membershipRequestDecisionId=" + encodeURIComponent("" + membershipRequestDecisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipDecisionCode(_response));
        });
    }

    protected processGetMembershipDecisionCode(response: Response): Promise<EMembershipRequestDecision> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EMembershipRequestDecision>(null as any);
    }

    getMembershipRequestTypeCodeFromRequestId(membershipRequestId: number | undefined): Promise<EMembershipRequestType> {
        let url_ = this.baseUrl + "/api/MembershipRequest/TypeCodeFromRequestId?";
        if (membershipRequestId === null)
            throw new Error("The parameter 'membershipRequestId' cannot be null.");
        else if (membershipRequestId !== undefined)
            url_ += "membershipRequestId=" + encodeURIComponent("" + membershipRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipRequestTypeCodeFromRequestId(_response));
        });
    }

    protected processGetMembershipRequestTypeCodeFromRequestId(response: Response): Promise<EMembershipRequestType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EMembershipRequestType>(null as any);
    }

    getMembershipRequestTypeCode(membershipmembershipRequestTypeCode: number | undefined): Promise<EMembershipRequestType> {
        let url_ = this.baseUrl + "/api/MembershipRequest/TypeCode?";
        if (membershipmembershipRequestTypeCode === null)
            throw new Error("The parameter 'membershipmembershipRequestTypeCode' cannot be null.");
        else if (membershipmembershipRequestTypeCode !== undefined)
            url_ += "membershipmembershipRequestTypeCode=" + encodeURIComponent("" + membershipmembershipRequestTypeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipRequestTypeCode(_response));
        });
    }

    protected processGetMembershipRequestTypeCode(response: Response): Promise<EMembershipRequestType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EMembershipRequestType>(null as any);
    }

    isUserAvailable(personId: number | undefined, membershipRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/MembershipRequest/IsUserAvailable?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (membershipRequestId === null)
            throw new Error("The parameter 'membershipRequestId' cannot be null.");
        else if (membershipRequestId !== undefined)
            url_ += "membershipRequestId=" + encodeURIComponent("" + membershipRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsUserAvailable(_response));
        });
    }

    protected processIsUserAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isUserRenewed(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/MembershipRequest/isUserRenwed?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsUserRenewed(_response));
        });
    }

    protected processIsUserRenewed(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: MembershipRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MembershipRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MembershipRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/MembershipRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IMiscellaneousRequestApi {

    baseSearch(sObj: MiscellaneousRequestSearch): Promise<PaginatedResultsOfMiscellaneousRequestGridDto>;

    get(miscellaneousRequestId: number | undefined): Promise<MiscellaneousRequestDto>;

    save(dto: MiscellaneousRequestDto): Promise<number>;

    getSubRequests(masterRequestId: number | undefined): Promise<MiscellaneousRequestDto>;

    close(requestId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: MiscellaneousRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class MiscellaneousRequestApi extends BaseAPI implements IMiscellaneousRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: MiscellaneousRequestSearch): Promise<PaginatedResultsOfMiscellaneousRequestGridDto> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfMiscellaneousRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfMiscellaneousRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfMiscellaneousRequestGridDto>(null as any);
    }

    get(miscellaneousRequestId: number | undefined): Promise<MiscellaneousRequestDto> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest?";
        if (miscellaneousRequestId === null)
            throw new Error("The parameter 'miscellaneousRequestId' cannot be null.");
        else if (miscellaneousRequestId !== undefined)
            url_ += "miscellaneousRequestId=" + encodeURIComponent("" + miscellaneousRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MiscellaneousRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MiscellaneousRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscellaneousRequestDto>(null as any);
    }

    save(dto: MiscellaneousRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSubRequests(masterRequestId: number | undefined): Promise<MiscellaneousRequestDto> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest/GetSubRequests?";
        if (masterRequestId === null)
            throw new Error("The parameter 'masterRequestId' cannot be null.");
        else if (masterRequestId !== undefined)
            url_ += "masterRequestId=" + encodeURIComponent("" + masterRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubRequests(_response));
        });
    }

    protected processGetSubRequests(response: Response): Promise<MiscellaneousRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MiscellaneousRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MiscellaneousRequestDto>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: MiscellaneousRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/MiscellaneousRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPasswordApi {

    getNewPassword(): Promise<string>;
}

export class PasswordApi extends BaseAPI implements IPasswordApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getNewPassword(): Promise<string> {
        let url_ = this.baseUrl + "/api/Password/newPassword";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewPassword(_response));
        });
    }

    protected processGetNewPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IPedigreeDuplicataRequestApi {

    baseSearch(sObj: PedigreeDuplicataRequestSearch): Promise<PaginatedResultsOfPedigreeDuplicataRequestGridDto>;

    getPedigreeDuplicataRequest(pedigreeDuplicataRequestId: number | undefined): Promise<PedigreeDuplicataRequestDto>;

    savePedigreeDuplicataRequest(dto: PedigreeDuplicataRequestDto): Promise<number>;

    getDrupalPedigreeDuplicataRequest(pedigreeDuplicataRequestId: number | undefined): Promise<DrupalPedigreeDuplicataRequestDto>;

    getDisplayName(pedigreeDuplicataRequestId: number | undefined): Promise<string>;

    getParentRequestId(pedigreeDuplicataRequestId: number | undefined): Promise<number>;

    isDogAvailable(dogId: number | undefined, pedigreeDuplicataRequestId: number | undefined): Promise<ResultOfBoolean>;

    pedigreeDuplicataReprint(pedigreeDuplicataId: number | undefined): Promise<Result>;

    saveDrupalPedigreeDuplicataRequest(dto: DrupalPedigreeDuplicataRequestDto): Promise<number>;

    closeRequest(requestId: number | undefined): Promise<void>;

    exportXlsFile(sObj: PedigreeDuplicataRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PedigreeDuplicataRequestApi extends BaseAPI implements IPedigreeDuplicataRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PedigreeDuplicataRequestSearch): Promise<PaginatedResultsOfPedigreeDuplicataRequestGridDto> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPedigreeDuplicataRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPedigreeDuplicataRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPedigreeDuplicataRequestGridDto>(null as any);
    }

    getPedigreeDuplicataRequest(pedigreeDuplicataRequestId: number | undefined): Promise<PedigreeDuplicataRequestDto> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest?";
        if (pedigreeDuplicataRequestId === null)
            throw new Error("The parameter 'pedigreeDuplicataRequestId' cannot be null.");
        else if (pedigreeDuplicataRequestId !== undefined)
            url_ += "pedigreeDuplicataRequestId=" + encodeURIComponent("" + pedigreeDuplicataRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPedigreeDuplicataRequest(_response));
        });
    }

    protected processGetPedigreeDuplicataRequest(response: Response): Promise<PedigreeDuplicataRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PedigreeDuplicataRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PedigreeDuplicataRequestDto>(null as any);
    }

    savePedigreeDuplicataRequest(dto: PedigreeDuplicataRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePedigreeDuplicataRequest(_response));
        });
    }

    protected processSavePedigreeDuplicataRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDrupalPedigreeDuplicataRequest(pedigreeDuplicataRequestId: number | undefined): Promise<DrupalPedigreeDuplicataRequestDto> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/GetDrupalPedigreeDuplicataRequest?";
        if (pedigreeDuplicataRequestId === null)
            throw new Error("The parameter 'pedigreeDuplicataRequestId' cannot be null.");
        else if (pedigreeDuplicataRequestId !== undefined)
            url_ += "pedigreeDuplicataRequestId=" + encodeURIComponent("" + pedigreeDuplicataRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalPedigreeDuplicataRequest(_response));
        });
    }

    protected processGetDrupalPedigreeDuplicataRequest(response: Response): Promise<DrupalPedigreeDuplicataRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalPedigreeDuplicataRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalPedigreeDuplicataRequestDto>(null as any);
    }

    getDisplayName(pedigreeDuplicataRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/getDisplayName?";
        if (pedigreeDuplicataRequestId === null)
            throw new Error("The parameter 'pedigreeDuplicataRequestId' cannot be null.");
        else if (pedigreeDuplicataRequestId !== undefined)
            url_ += "pedigreeDuplicataRequestId=" + encodeURIComponent("" + pedigreeDuplicataRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getParentRequestId(pedigreeDuplicataRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/getParentRequestId?";
        if (pedigreeDuplicataRequestId === null)
            throw new Error("The parameter 'pedigreeDuplicataRequestId' cannot be null.");
        else if (pedigreeDuplicataRequestId !== undefined)
            url_ += "pedigreeDuplicataRequestId=" + encodeURIComponent("" + pedigreeDuplicataRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParentRequestId(_response));
        });
    }

    protected processGetParentRequestId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isDogAvailable(dogId: number | undefined, pedigreeDuplicataRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/isDogAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (pedigreeDuplicataRequestId === null)
            throw new Error("The parameter 'pedigreeDuplicataRequestId' cannot be null.");
        else if (pedigreeDuplicataRequestId !== undefined)
            url_ += "pedigreeDuplicataRequestId=" + encodeURIComponent("" + pedigreeDuplicataRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    pedigreeDuplicataReprint(pedigreeDuplicataId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/reprint?";
        if (pedigreeDuplicataId === null)
            throw new Error("The parameter 'pedigreeDuplicataId' cannot be null.");
        else if (pedigreeDuplicataId !== undefined)
            url_ += "pedigreeDuplicataId=" + encodeURIComponent("" + pedigreeDuplicataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPedigreeDuplicataReprint(_response));
        });
    }

    protected processPedigreeDuplicataReprint(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveDrupalPedigreeDuplicataRequest(dto: DrupalPedigreeDuplicataRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/SaveDrupalPedigreeDuplicataRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDrupalPedigreeDuplicataRequest(_response));
        });
    }

    protected processSaveDrupalPedigreeDuplicataRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    closeRequest(requestId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/closeRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseRequest(_response));
        });
    }

    protected processCloseRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: PedigreeDuplicataRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PedigreeDuplicataRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPedigreePrefixApi {

    baseSearch(sObj: PedigreePrefixSearch): Promise<PaginatedResultsOfCountryPedigreePrefixGridDto>;

    saveNewPedigreePrefix(dto: SavePedigreePrefixDto): Promise<number>;

    deletePedigreePrefix(pedigreePrefixId: number | undefined): Promise<void>;

    isPrefixUnique(countryId: number | undefined, prefix: string | null | undefined): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: PedigreePrefixSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PedigreePrefixApi extends BaseAPI implements IPedigreePrefixApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PedigreePrefixSearch): Promise<PaginatedResultsOfCountryPedigreePrefixGridDto> {
        let url_ = this.baseUrl + "/api/PedigreePrefix/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfCountryPedigreePrefixGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfCountryPedigreePrefixGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfCountryPedigreePrefixGridDto>(null as any);
    }

    saveNewPedigreePrefix(dto: SavePedigreePrefixDto): Promise<number> {
        let url_ = this.baseUrl + "/api/PedigreePrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNewPedigreePrefix(_response));
        });
    }

    protected processSaveNewPedigreePrefix(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deletePedigreePrefix(pedigreePrefixId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PedigreePrefix?";
        if (pedigreePrefixId === null)
            throw new Error("The parameter 'pedigreePrefixId' cannot be null.");
        else if (pedigreePrefixId !== undefined)
            url_ += "pedigreePrefixId=" + encodeURIComponent("" + pedigreePrefixId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePedigreePrefix(_response));
        });
    }

    protected processDeletePedigreePrefix(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    isPrefixUnique(countryId: number | undefined, prefix: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/PedigreePrefix/PrefixUnique?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (prefix !== undefined && prefix !== null)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPrefixUnique(_response));
        });
    }

    protected processIsPrefixUnique(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: PedigreePrefixSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PedigreePrefix/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PedigreePrefix/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PedigreePrefix/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPedigreeRequestApi {

    baseSearch(sObj: PedigreeRequestSearch): Promise<PaginatedResultsOfPedigreeRequestGridDto>;

    getPedigreeRequest(pedigreeRequestId: number | undefined): Promise<PedigreeRequestDto>;

    save(toSave: PedigreeRequestDto): Promise<number>;

    isDogAvailable(dogId: number | undefined, pedigreeRequestController: number | undefined): Promise<ResultOfBoolean>;

    closePedigreeRequest(requestId: number | undefined): Promise<Result>;

    getDisplayName(pedigreeRequestId: number | undefined): Promise<string>;

    getParentRequestId(pedigreeRequestId: number | undefined): Promise<number>;

    exportXlsFile(sObj: PedigreeRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PedigreeRequestApi extends BaseAPI implements IPedigreeRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PedigreeRequestSearch): Promise<PaginatedResultsOfPedigreeRequestGridDto> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPedigreeRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPedigreeRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPedigreeRequestGridDto>(null as any);
    }

    getPedigreeRequest(pedigreeRequestId: number | undefined): Promise<PedigreeRequestDto> {
        let url_ = this.baseUrl + "/api/PedigreeRequest?";
        if (pedigreeRequestId === null)
            throw new Error("The parameter 'pedigreeRequestId' cannot be null.");
        else if (pedigreeRequestId !== undefined)
            url_ += "pedigreeRequestId=" + encodeURIComponent("" + pedigreeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPedigreeRequest(_response));
        });
    }

    protected processGetPedigreeRequest(response: Response): Promise<PedigreeRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PedigreeRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PedigreeRequestDto>(null as any);
    }

    save(toSave: PedigreeRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/PedigreeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isDogAvailable(dogId: number | undefined, pedigreeRequestController: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/isDogAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (pedigreeRequestController === null)
            throw new Error("The parameter 'pedigreeRequestController' cannot be null.");
        else if (pedigreeRequestController !== undefined)
            url_ += "pedigreeRequestController=" + encodeURIComponent("" + pedigreeRequestController) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    closePedigreeRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/ClosePedigreeRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClosePedigreeRequest(_response));
        });
    }

    protected processClosePedigreeRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDisplayName(pedigreeRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/GetDisplayName?";
        if (pedigreeRequestId === null)
            throw new Error("The parameter 'pedigreeRequestId' cannot be null.");
        else if (pedigreeRequestId !== undefined)
            url_ += "pedigreeRequestId=" + encodeURIComponent("" + pedigreeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getParentRequestId(pedigreeRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/ParentRequestId?";
        if (pedigreeRequestId === null)
            throw new Error("The parameter 'pedigreeRequestId' cannot be null.");
        else if (pedigreeRequestId !== undefined)
            url_ += "pedigreeRequestId=" + encodeURIComponent("" + pedigreeRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParentRequestId(_response));
        });
    }

    protected processGetParentRequestId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: PedigreeRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PedigreeRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPermissionApi {

    baseSearch(sObj: UserProfileActionSearch): Promise<PaginatedResultsOfUserProfileActionGridDto>;

    savePermission(dto: UserProfileActionGridDto): Promise<Result>;

    exportXlsFile(sObj: UserProfileActionSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PermissionApi extends BaseAPI implements IPermissionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: UserProfileActionSearch): Promise<PaginatedResultsOfUserProfileActionGridDto> {
        let url_ = this.baseUrl + "/api/Permission/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserProfileActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserProfileActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserProfileActionGridDto>(null as any);
    }

    savePermission(dto: UserProfileActionGridDto): Promise<Result> {
        let url_ = this.baseUrl + "/api/Permission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePermission(_response));
        });
    }

    protected processSavePermission(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: UserProfileActionSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Permission/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Permission/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Permission/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPersonActionApi {

    baseSearch(sObj: BasePersonSearch): Promise<PaginatedResultsOfPersonActionGridDto>;

    exportXlsFile(sObj: BasePersonSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PersonActionApi extends BaseAPI implements IPersonActionApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BasePersonSearch): Promise<PaginatedResultsOfPersonActionGridDto> {
        let url_ = this.baseUrl + "/api/PersonAction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonActionGridDto>(null as any);
    }

    exportXlsFile(sObj: BasePersonSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PersonAction/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PersonAction/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PersonAction/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPersonApi {

    baseSearch(sObj: PersonSearch): Promise<PaginatedResultsOfPersonGridDto>;

    saveBc(personId: number | undefined): Promise<string>;

    searchWithValidations(sObj: PersonSearch): Promise<PaginatedResultsOfPersonWithValidationsGridDto>;

    getMemberReport(): Promise<FileDto>;

    searchDogs(sObj: PersonDogsSearch): Promise<PaginatedResultsOfDogPersonGridDto>;

    getDrupalPersonProfile(): Promise<PersonDto>;

    getPersonRemark(personId: number | undefined): Promise<string>;

    getLinkedClubs(): Promise<number[]>;

    getIds(sObj: PersonSearch): Promise<number[]>;

    getPersonCommissioner(personId: number | undefined): Promise<CommissionerDto>;

    saveCommissioner(toSave: CommissionerDto): Promise<number>;

    getByVetId(vetId: number | undefined): Promise<number>;

    getEmail(personId: number | undefined): Promise<string>;

    kennelOwnershipUniqueCheck(personId: number | undefined): Promise<ResultOfBoolean>;

    getDisplayName(personId: number | undefined): Promise<string>;

    getPersonByEmail(email: string | null | undefined): Promise<PersonDto[]>;

    missingPhoneNumberCheck(personId: number | undefined): Promise<ResultOfBoolean>;

    missingAddressInformationCheck(personId: number | undefined): Promise<ResultOfBoolean>;

    hasCountry(personId: number | undefined): Promise<ResultOfBoolean>;

    isKennelOwner(personId: number | undefined, kennelId: number | undefined, dateFrom: Date | undefined, dateTo: Date | null | undefined): Promise<ResultOfBoolean>;

    checkIfOwnerofExcludedKennel(personId: number | undefined): Promise<ResultOfBoolean>;

    getPersonAddress(personId: number | undefined, currentLanguageId: number | undefined): Promise<string>;

    getSplitPerson(originalPersonId: number | undefined): Promise<SplitPersonDto>;

    getPersonFusion(personId1: number | undefined, personId2: number | undefined): Promise<PersonFusionDto>;

    getPersonFusionComparison(personId1: number | undefined, personId2: number | undefined): Promise<PersonFusionComparisonDto>;

    get(personId: number | undefined): Promise<PersonDto>;

    save(platform: EPlatform | undefined, dto: PersonDto): Promise<number>;

    delete(personId: number | undefined): Promise<boolean>;

    saveSplitPerson(dto: SplitPersonDto): Promise<number>;

    savePersonFusion(dto: PersonFusionDto): Promise<number>;

    isEmailUnique(email: string | null | undefined, personId: number | undefined): Promise<BooleanDto>;

    getMembership(personId: number | undefined): Promise<MembershipDto>;

    getCurrentMembership(personId: number | undefined): Promise<number>;

    getPastYearMembership(personId: number | undefined): Promise<number>;

    saveMembership(dto: MembershipDto): Promise<number>;

    getVeterinaryInformation(personId: number | undefined): Promise<VeterinaryDto>;

    isPersonWaloon(personId: number | undefined): Promise<ResultOfBoolean>;

    isPostalCodeFlemish(postalCode: number | undefined): Promise<ResultOfBoolean>;

    isPersonFlemish(email: string | null | undefined): Promise<ResultOfBoolean>;

    isPersonFlemishById(personId: number | undefined): Promise<ResultOfBoolean>;

    isDeceased(personId: number | undefined): Promise<ResultOfBoolean>;

    isPersonExcludedQuery(personId: number | undefined): Promise<ResultOfBoolean>;

    isPersonBelgian(personId: number | undefined): Promise<ResultOfBoolean>;

    saveVeterinaryInformation(dto: VeterinaryDto): Promise<number>;

    deleteVeterinaryInformation(veterinaryId: number | undefined): Promise<void>;

    saveBreedGroupsForJudge(dto: BreedGroupsJudgeSaveDto): Promise<BreedGroupsJudgeSaveDto>;

    getJudgeLinkedBreedsIds(personId: number | undefined): Promise<BreedGroupsJudgeSaveDto>;

    getPersonIdByByEmail(email: string | null | undefined): Promise<number>;

    createInSharepoint(personId: number): Promise<string>;

    getBrcsUrl(): Promise<string>;

    exportXlsFile(sObj: PersonSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PersonApi extends BaseAPI implements IPersonApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PersonSearch): Promise<PaginatedResultsOfPersonGridDto> {
        let url_ = this.baseUrl + "/api/Person/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonGridDto>(null as any);
    }

    saveBc(personId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/bcSave?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBc(_response));
        });
    }

    protected processSaveBc(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchWithValidations(sObj: PersonSearch): Promise<PaginatedResultsOfPersonWithValidationsGridDto> {
        let url_ = this.baseUrl + "/api/Person/searchWithValidations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchWithValidations(_response));
        });
    }

    protected processSearchWithValidations(response: Response): Promise<PaginatedResultsOfPersonWithValidationsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonWithValidationsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonWithValidationsGridDto>(null as any);
    }

    getMemberReport(): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/Person/getMemberReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberReport(_response));
        });
    }

    protected processGetMemberReport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    searchDogs(sObj: PersonDogsSearch): Promise<PaginatedResultsOfDogPersonGridDto> {
        let url_ = this.baseUrl + "/api/Person/searchDogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDogs(_response));
        });
    }

    protected processSearchDogs(response: Response): Promise<PaginatedResultsOfDogPersonGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogPersonGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogPersonGridDto>(null as any);
    }

    getDrupalPersonProfile(): Promise<PersonDto> {
        let url_ = this.baseUrl + "/api/Person/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalPersonProfile(_response));
        });
    }

    protected processGetDrupalPersonProfile(response: Response): Promise<PersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDto>(null as any);
    }

    getPersonRemark(personId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/remark?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonRemark(_response));
        });
    }

    protected processGetPersonRemark(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getLinkedClubs(): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Person/getLinkedClubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLinkedClubs(_response));
        });
    }

    protected processGetLinkedClubs(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getIds(sObj: PersonSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Person/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getPersonCommissioner(personId: number | undefined): Promise<CommissionerDto> {
        let url_ = this.baseUrl + "/api/Person/getPersonCommissioner?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonCommissioner(_response));
        });
    }

    protected processGetPersonCommissioner(response: Response): Promise<CommissionerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommissionerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionerDto>(null as any);
    }

    saveCommissioner(toSave: CommissionerDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/saveCommissioner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveCommissioner(_response));
        });
    }

    protected processSaveCommissioner(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getByVetId(vetId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/getByVetId?";
        if (vetId === null)
            throw new Error("The parameter 'vetId' cannot be null.");
        else if (vetId !== undefined)
            url_ += "vetId=" + encodeURIComponent("" + vetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByVetId(_response));
        });
    }

    protected processGetByVetId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getEmail(personId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/getEmail?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmail(_response));
        });
    }

    protected processGetEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    kennelOwnershipUniqueCheck(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/KennelOwnershipUniqueCheck?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processKennelOwnershipUniqueCheck(_response));
        });
    }

    protected processKennelOwnershipUniqueCheck(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getDisplayName(personId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/displayName?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getPersonByEmail(email: string | null | undefined): Promise<PersonDto[]> {
        let url_ = this.baseUrl + "/api/Person/getByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonByEmail(_response));
        });
    }

    protected processGetPersonByEmail(response: Response): Promise<PersonDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDto[]>(null as any);
    }

    missingPhoneNumberCheck(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/missingPhoneNumberCheck?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMissingPhoneNumberCheck(_response));
        });
    }

    protected processMissingPhoneNumberCheck(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    missingAddressInformationCheck(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/missingInformationCheck?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMissingAddressInformationCheck(_response));
        });
    }

    protected processMissingAddressInformationCheck(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    hasCountry(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/hasCountry?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasCountry(_response));
        });
    }

    protected processHasCountry(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isKennelOwner(personId: number | undefined, kennelId: number | undefined, dateFrom: Date | undefined, dateTo: Date | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isKennelOwner?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsKennelOwner(_response));
        });
    }

    protected processIsKennelOwner(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    checkIfOwnerofExcludedKennel(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/checkIfOwnerofExcludedKennel?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckIfOwnerofExcludedKennel(_response));
        });
    }

    protected processCheckIfOwnerofExcludedKennel(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getPersonAddress(personId: number | undefined, currentLanguageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/getPersonAddress?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (currentLanguageId === null)
            throw new Error("The parameter 'currentLanguageId' cannot be null.");
        else if (currentLanguageId !== undefined)
            url_ += "currentLanguageId=" + encodeURIComponent("" + currentLanguageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonAddress(_response));
        });
    }

    protected processGetPersonAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSplitPerson(originalPersonId: number | undefined): Promise<SplitPersonDto> {
        let url_ = this.baseUrl + "/api/Person/getSplitPerson?";
        if (originalPersonId === null)
            throw new Error("The parameter 'originalPersonId' cannot be null.");
        else if (originalPersonId !== undefined)
            url_ += "originalPersonId=" + encodeURIComponent("" + originalPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSplitPerson(_response));
        });
    }

    protected processGetSplitPerson(response: Response): Promise<SplitPersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplitPersonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SplitPersonDto>(null as any);
    }

    getPersonFusion(personId1: number | undefined, personId2: number | undefined): Promise<PersonFusionDto> {
        let url_ = this.baseUrl + "/api/Person/getFusionPerson?";
        if (personId1 === null)
            throw new Error("The parameter 'personId1' cannot be null.");
        else if (personId1 !== undefined)
            url_ += "personId1=" + encodeURIComponent("" + personId1) + "&";
        if (personId2 === null)
            throw new Error("The parameter 'personId2' cannot be null.");
        else if (personId2 !== undefined)
            url_ += "personId2=" + encodeURIComponent("" + personId2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonFusion(_response));
        });
    }

    protected processGetPersonFusion(response: Response): Promise<PersonFusionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonFusionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonFusionDto>(null as any);
    }

    getPersonFusionComparison(personId1: number | undefined, personId2: number | undefined): Promise<PersonFusionComparisonDto> {
        let url_ = this.baseUrl + "/api/Person/getPersonFusionComparison?";
        if (personId1 === null)
            throw new Error("The parameter 'personId1' cannot be null.");
        else if (personId1 !== undefined)
            url_ += "personId1=" + encodeURIComponent("" + personId1) + "&";
        if (personId2 === null)
            throw new Error("The parameter 'personId2' cannot be null.");
        else if (personId2 !== undefined)
            url_ += "personId2=" + encodeURIComponent("" + personId2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonFusionComparison(_response));
        });
    }

    protected processGetPersonFusionComparison(response: Response): Promise<PersonFusionComparisonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonFusionComparisonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonFusionComparisonDto>(null as any);
    }

    get(personId: number | undefined): Promise<PersonDto> {
        let url_ = this.baseUrl + "/api/Person?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PersonDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonDto>(null as any);
    }

    save(platform: EPlatform | undefined, dto: PersonDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Person?";
        if (platform === null)
            throw new Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(personId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Person?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    saveSplitPerson(dto: SplitPersonDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/SaveSplitPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSplitPerson(_response));
        });
    }

    protected processSaveSplitPerson(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    savePersonFusion(dto: PersonFusionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/SaveFusePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSavePersonFusion(_response));
        });
    }

    protected processSavePersonFusion(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isEmailUnique(email: string | null | undefined, personId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Person/getUniqueEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsEmailUnique(_response));
        });
    }

    protected processIsEmailUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getMembership(personId: number | undefined): Promise<MembershipDto> {
        let url_ = this.baseUrl + "/api/Person/getMembership?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembership(_response));
        });
    }

    protected processGetMembership(response: Response): Promise<MembershipDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MembershipDto>(null as any);
    }

    getCurrentMembership(personId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/getCurrentMembership?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCurrentMembership(_response));
        });
    }

    protected processGetCurrentMembership(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPastYearMembership(personId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/getPastYearMembership?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPastYearMembership(_response));
        });
    }

    protected processGetPastYearMembership(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveMembership(dto: MembershipDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/saveMembership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMembership(_response));
        });
    }

    protected processSaveMembership(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getVeterinaryInformation(personId: number | undefined): Promise<VeterinaryDto> {
        let url_ = this.baseUrl + "/api/Person/getVeterinaryInfomation?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVeterinaryInformation(_response));
        });
    }

    protected processGetVeterinaryInformation(response: Response): Promise<VeterinaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VeterinaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VeterinaryDto>(null as any);
    }

    isPersonWaloon(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isWalloon?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonWaloon(_response));
        });
    }

    protected processIsPersonWaloon(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isPostalCodeFlemish(postalCode: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isPostalCodeFlemisb?";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPostalCodeFlemish(_response));
        });
    }

    protected processIsPostalCodeFlemish(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isPersonFlemish(email: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isFlemish?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonFlemish(_response));
        });
    }

    protected processIsPersonFlemish(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isPersonFlemishById(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isFlemishById?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonFlemishById(_response));
        });
    }

    protected processIsPersonFlemishById(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isDeceased(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isDeceased?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDeceased(_response));
        });
    }

    protected processIsDeceased(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isPersonExcludedQuery(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isPersonExcludedQuery?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonExcludedQuery(_response));
        });
    }

    protected processIsPersonExcludedQuery(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isPersonBelgian(personId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Person/isBelgian?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsPersonBelgian(_response));
        });
    }

    protected processIsPersonBelgian(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    saveVeterinaryInformation(dto: VeterinaryDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/saveVeterinaryInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveVeterinaryInformation(_response));
        });
    }

    protected processSaveVeterinaryInformation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteVeterinaryInformation(veterinaryId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Person/deleteVetInformation?";
        if (veterinaryId === null)
            throw new Error("The parameter 'veterinaryId' cannot be null.");
        else if (veterinaryId !== undefined)
            url_ += "veterinaryId=" + encodeURIComponent("" + veterinaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteVeterinaryInformation(_response));
        });
    }

    protected processDeleteVeterinaryInformation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveBreedGroupsForJudge(dto: BreedGroupsJudgeSaveDto): Promise<BreedGroupsJudgeSaveDto> {
        let url_ = this.baseUrl + "/api/Person/SaveBreedGroupsForJudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBreedGroupsForJudge(_response));
        });
    }

    protected processSaveBreedGroupsForJudge(response: Response): Promise<BreedGroupsJudgeSaveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedGroupsJudgeSaveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedGroupsJudgeSaveDto>(null as any);
    }

    getJudgeLinkedBreedsIds(personId: number | undefined): Promise<BreedGroupsJudgeSaveDto> {
        let url_ = this.baseUrl + "/api/Person/GetJudgeLinkedBreedsIds?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJudgeLinkedBreedsIds(_response));
        });
    }

    protected processGetJudgeLinkedBreedsIds(response: Response): Promise<BreedGroupsJudgeSaveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BreedGroupsJudgeSaveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BreedGroupsJudgeSaveDto>(null as any);
    }

    getPersonIdByByEmail(email: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/getPersonIdByEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonIdByByEmail(_response));
        });
    }

    protected processGetPersonIdByByEmail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createInSharepoint(personId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/CreateInSharepoint/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getBrcsUrl(): Promise<string> {
        let url_ = this.baseUrl + "/api/Person/BrcsUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBrcsUrl(_response));
        });
    }

    protected processGetBrcsUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: PersonSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Person/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Person/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPersonFilesApi {

    baseSearch(sObj: PersonFileSearch): Promise<PaginatedResultsOfPersonFileGridDto>;

    exportXlsFile(sObj: PersonFileSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PersonFilesApi extends BaseAPI implements IPersonFilesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PersonFileSearch): Promise<PaginatedResultsOfPersonFileGridDto> {
        let url_ = this.baseUrl + "/api/PersonFiles/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonFileGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonFileGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonFileGridDto>(null as any);
    }

    exportXlsFile(sObj: PersonFileSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PersonFiles/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PersonFiles/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PersonFiles/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPersonsDogsApi {

    baseSearch(sObj: PersonDogsSearch): Promise<PaginatedResultsOfPersonDogsGridDto>;

    exportXlsFile(sObj: PersonDogsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PersonsDogsApi extends BaseAPI implements IPersonsDogsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PersonDogsSearch): Promise<PaginatedResultsOfPersonDogsGridDto> {
        let url_ = this.baseUrl + "/api/PersonsDogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonDogsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonDogsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonDogsGridDto>(null as any);
    }

    exportXlsFile(sObj: PersonDogsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PersonsDogs/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PersonsDogs/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PersonsDogs/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPersonsJudgesApi {

    baseSearch(sObj: PersonDogsSearch): Promise<PaginatedResultsOfPersonJudgesGridDto>;

    exportXlsFile(sObj: PersonDogsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PersonsJudgesApi extends BaseAPI implements IPersonsJudgesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PersonDogsSearch): Promise<PaginatedResultsOfPersonJudgesGridDto> {
        let url_ = this.baseUrl + "/api/PersonsJudges/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonJudgesGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonJudgesGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonJudgesGridDto>(null as any);
    }

    exportXlsFile(sObj: PersonDogsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PersonsJudges/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PersonsJudges/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PersonsJudges/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IPersonsKennelsApi {

    baseSearch(sObj: PersonKennelsSearch): Promise<PaginatedResultsOfPersonKennelsGridDto>;

    exportXlsFile(sObj: PersonKennelsSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class PersonsKennelsApi extends BaseAPI implements IPersonsKennelsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: PersonKennelsSearch): Promise<PaginatedResultsOfPersonKennelsGridDto> {
        let url_ = this.baseUrl + "/api/PersonsKennels/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfPersonKennelsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPersonKennelsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPersonKennelsGridDto>(null as any);
    }

    exportXlsFile(sObj: PersonKennelsSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PersonsKennels/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/PersonsKennels/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PersonsKennels/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IReferentialApi {

    getJudges(competitionId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getHealthValueTypes(canBeUsedForDysplasia: boolean | undefined): Promise<ReferentialItemDto[]>;

    getCommissionerExperience(): Promise<ReferentialItemDto[]>;

    getCompetitionRequestSubActivities(competitionRequestId: number | undefined): Promise<ReferentialItemDto[]>;

    getCompetitionStatuses(): Promise<ReferentialItemDto[]>;

    getPaperDecorations(): Promise<ReferentialItemDto[]>;

    getLabNames(): Promise<ReferentialItemDto[]>;

    getMonths(): Promise<ReferentialItemDto[]>;

    getAuthorizedColors(breedId: number | undefined, recognized: boolean | null | undefined): Promise<ReferentialItemDto[]>;

    getOwnedDogs(webUserId: number | undefined, dogId: number | undefined, sex: EDogSex | null | undefined, forBroodRequest: boolean | null | undefined, forHealthTest: boolean | null | undefined): Promise<ReferentialItemDto[]>;

    getLabStatuses(): Promise<ReferentialItemDto[]>;

    getVets(): Promise<ReferentialItemDto[]>;

    getBreedAuthorizedVets(): Promise<ReferentialItemDto[]>;

    getCommissionTypes(): Promise<ReferentialItemDto[]>;

    getOpenedKennels(kennelId: number | undefined): Promise<ReferentialItemDto[]>;

    getAffixRequestTypes(): Promise<ReferentialItemDto[]>;

    getHealthPacks(): Promise<ReferentialItemDto[]>;

    getArticles(withCode: boolean | undefined): Promise<ReferentialItemDto[]>;

    getPuppyPedigrees(): Promise<ReferentialItemDto[]>;

    getVetsByClinicId(clinicId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getHealthPackGroups(): Promise<ReferentialItemDto[]>;

    getStringifiedBelgianPostalCodes(): Promise<ReferentialItemDto[]>;

    getStringifiedBelgianLocalityFromPostalCode(postalCode: string | null | undefined): Promise<ReferentialItemDto[]>;

    searchPeople(query: SearchPeopleReferentialQuery): Promise<PaginatedResultsOfPeopleReferentialItem>;

    getResults(): Promise<ReferentialItemDto[]>;

    getQualifications(): Promise<ReferentialItemDto[]>;

    getShowClasses(): Promise<ReferentialItemDto[]>;

    getCompetitionJudges(competitionRequestId: number | undefined): Promise<ReferentialItemDto[]>;

    getDysplasiaTypes(isDysplasiaRequest: boolean | undefined, appealDysplasiaId: number | undefined): Promise<ReferentialItemDto[]>;

    getClinics(): Promise<ReferentialItemDto[]>;

    getDysplasiaPositions(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getActivities(sectionId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getSubActivities(activityId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getFluxStatuses(requestId: number | undefined, languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getBelgianTitles(languageId: number | undefined, dogId: number | null | undefined, titleId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getBreeds(dogId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getBabyDogBreedsQuery(dogId: number | null | undefined, brcs: boolean | undefined): Promise<ReferentialItemDto[]>;

    getBreedExceptions(currentBreedId: number | undefined): Promise<ReferentialItemDto[]>;

    getBreedGroups(): Promise<ReferentialItemDto[]>;

    getVolunteerProfiles(): Promise<ReferentialItemDto[]>;

    getBreedVarieties(currentBreedId: number | undefined): Promise<ReferentialItemDto[]>;

    getBreedVarietiesWithCurrentBreed(currentBreedId: number | undefined): Promise<ReferentialItemDto[]>;

    getCharacteristics(isDysplasia: boolean | undefined, languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getCharacteristicTypes(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getDepartments(): Promise<ReferentialItemDto[]>;

    getHealthValues(characteristicId: number | undefined): Promise<ReferentialItemDto[]>;

    getCharacteristicValues(characteristicId: number | undefined): Promise<ReferentialItemDto[]>;

    getClubs(personId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getColors(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getColorsByBreed(breedId: number | undefined): Promise<ReferentialItemDto[]>;

    getCountries(query: GetCountriesReferentialQuery): Promise<ReferentialItemDto[]>;

    getDysplasiaRequests(): Promise<ReferentialItemDto[]>;

    getOwnDysplasiaRequests(dogId: number | undefined): Promise<ReferentialItemDto[]>;

    getDogsForWorkbookRequest(): Promise<ReferentialItemDto[]>;

    getAllDogTypes(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getDogTypes(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getDogsWithPedigrees(): Promise<ReferentialItemDto[]>;

    getUserProfiles(): Promise<ReferentialItemDto[]>;

    getKennels(): Promise<ReferentialItemDto[]>;

    getKennelTypes(): Promise<ReferentialItemDto[]>;

    getLanguages(): Promise<ReferentialItemDto[]>;

    getAllLanguages(): Promise<ReferentialItemDto[]>;

    getRequestStates(): Promise<ReferentialItemDto[]>;

    getRequestTypes(): Promise<ReferentialItemDto[]>;

    getSections(): Promise<ReferentialItemDto[]>;

    getSectionsForClub(clubId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getPostalCodes(): Promise<ReferentialItemDto[]>;

    getSex(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getVatCode(): Promise<ReferentialItemDto[]>;

    getWorkbookColors(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    searchDogs(query: SearchDogReferentialQuery): Promise<PaginatedResultsOfDogReferentialItem>;

    getAgility(): Promise<ReferentialItemDto[]>;

    getJudgeType(): Promise<ReferentialItemDto[]>;

    getGrooming(): Promise<ReferentialItemDto[]>;

    getPedigreePrefixesByCountry(countryId: number | undefined, dogId: number | null | undefined): Promise<ReferentialItemDto[]>;

    getAllPedigreePrefixes(): Promise<ReferentialItemDto[]>;

    getAllForeignPedigreePrefixes(): Promise<ReferentialItemDto[]>;

    getClubRoles(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getClubRolesForContact(languageId: number | undefined, clubId: number | undefined, personId: number | undefined): Promise<ReferentialItemDto[]>;

    getCompetitions(): Promise<ReferentialItemDto[]>;

    getTitles(languageId: number | undefined, platform: EPlatform | undefined, countryId: number | null | undefined, canBeUsed: boolean | null | undefined): Promise<ReferentialItemDto[]>;

    getWorkbookTypes(languageId: number | undefined, dogId: number | undefined): Promise<ReferentialItemDto[]>;

    getTitleTypes(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getPersonSalutations(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getMembershipTypes(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getRequestDogs(): Promise<ReferentialItemDto[]>;

    getRequestDogsWithoutPedigree(): Promise<ReferentialItemDto[]>;

    getRequestDogsWithPedigree(): Promise<ReferentialItemDto[]>;

    getSubFilesRequestTypes(requestTypeCode: ERequestType | undefined, languageId: number | undefined, requestId: number | undefined): Promise<ReferentialItemDto[]>;

    getMembershipRequestType(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getMembershipDecisions(languageId: number | undefined): Promise<ReferentialItemDto[]>;

    getLabs(): Promise<ReferentialItemDto[]>;

    getCompetitionExpos(competitionId: number | undefined): Promise<ReferentialItemDto[]>;
}

export class ReferentialApi extends BaseAPI implements IReferentialApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getJudges(competitionId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getJudges?";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJudges(_response));
        });
    }

    protected processGetJudges(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getHealthValueTypes(canBeUsedForDysplasia: boolean | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getHealthValueTypes?";
        if (canBeUsedForDysplasia === null)
            throw new Error("The parameter 'canBeUsedForDysplasia' cannot be null.");
        else if (canBeUsedForDysplasia !== undefined)
            url_ += "canBeUsedForDysplasia=" + encodeURIComponent("" + canBeUsedForDysplasia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthValueTypes(_response));
        });
    }

    protected processGetHealthValueTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCommissionerExperience(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCommissionerExperience";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCommissionerExperience(_response));
        });
    }

    protected processGetCommissionerExperience(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCompetitionRequestSubActivities(competitionRequestId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCompetitionRequestSubActivities?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitionRequestSubActivities(_response));
        });
    }

    protected processGetCompetitionRequestSubActivities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCompetitionStatuses(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCompetitionStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitionStatuses(_response));
        });
    }

    protected processGetCompetitionStatuses(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getPaperDecorations(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getPaperDecorationsQuery";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaperDecorations(_response));
        });
    }

    protected processGetPaperDecorations(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getLabNames(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getLabs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabNames(_response));
        });
    }

    protected processGetLabNames(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getMonths(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getMonths";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMonths(_response));
        });
    }

    protected processGetMonths(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getAuthorizedColors(breedId: number | undefined, recognized: boolean | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAuthorizedColors?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        if (recognized !== undefined && recognized !== null)
            url_ += "recognized=" + encodeURIComponent("" + recognized) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthorizedColors(_response));
        });
    }

    protected processGetAuthorizedColors(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getOwnedDogs(webUserId: number | undefined, dogId: number | undefined, sex: EDogSex | null | undefined, forBroodRequest: boolean | null | undefined, forHealthTest: boolean | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getOwnedDogs?";
        if (webUserId === null)
            throw new Error("The parameter 'webUserId' cannot be null.");
        else if (webUserId !== undefined)
            url_ += "webUserId=" + encodeURIComponent("" + webUserId) + "&";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (sex !== undefined && sex !== null)
            url_ += "sex=" + encodeURIComponent("" + sex) + "&";
        if (forBroodRequest !== undefined && forBroodRequest !== null)
            url_ += "forBroodRequest=" + encodeURIComponent("" + forBroodRequest) + "&";
        if (forHealthTest !== undefined && forHealthTest !== null)
            url_ += "forHealthTest=" + encodeURIComponent("" + forHealthTest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOwnedDogs(_response));
        });
    }

    protected processGetOwnedDogs(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getLabStatuses(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getLabStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabStatuses(_response));
        });
    }

    protected processGetLabStatuses(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getVets(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getVets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVets(_response));
        });
    }

    protected processGetVets(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBreedAuthorizedVets(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBreedAuthorizedVets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedAuthorizedVets(_response));
        });
    }

    protected processGetBreedAuthorizedVets(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCommissionTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCommissionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCommissionTypes(_response));
        });
    }

    protected processGetCommissionTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getOpenedKennels(kennelId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getOpeneKennels?";
        if (kennelId === null)
            throw new Error("The parameter 'kennelId' cannot be null.");
        else if (kennelId !== undefined)
            url_ += "kennelId=" + encodeURIComponent("" + kennelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOpenedKennels(_response));
        });
    }

    protected processGetOpenedKennels(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getAffixRequestTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAffixRequestTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAffixRequestTypes(_response));
        });
    }

    protected processGetAffixRequestTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getHealthPacks(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getHealthPacks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthPacks(_response));
        });
    }

    protected processGetHealthPacks(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getArticles(withCode: boolean | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getArticles?";
        if (withCode === null)
            throw new Error("The parameter 'withCode' cannot be null.");
        else if (withCode !== undefined)
            url_ += "withCode=" + encodeURIComponent("" + withCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArticles(_response));
        });
    }

    protected processGetArticles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getPuppyPedigrees(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getPuppyPedigrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPuppyPedigrees(_response));
        });
    }

    protected processGetPuppyPedigrees(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getVetsByClinicId(clinicId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getVetsByClinicId?";
        if (clinicId !== undefined && clinicId !== null)
            url_ += "clinicId=" + encodeURIComponent("" + clinicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVetsByClinicId(_response));
        });
    }

    protected processGetVetsByClinicId(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getHealthPackGroups(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getHealthPackGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthPackGroups(_response));
        });
    }

    protected processGetHealthPackGroups(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getStringifiedBelgianPostalCodes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getStringifiedBelgianPostalCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStringifiedBelgianPostalCodes(_response));
        });
    }

    protected processGetStringifiedBelgianPostalCodes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getStringifiedBelgianLocalityFromPostalCode(postalCode: string | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getStringifiedBelgianLocalityFromPostalCode?";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStringifiedBelgianLocalityFromPostalCode(_response));
        });
    }

    protected processGetStringifiedBelgianLocalityFromPostalCode(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    searchPeople(query: SearchPeopleReferentialQuery): Promise<PaginatedResultsOfPeopleReferentialItem> {
        let url_ = this.baseUrl + "/api/Referential/searchPeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchPeople(_response));
        });
    }

    protected processSearchPeople(response: Response): Promise<PaginatedResultsOfPeopleReferentialItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfPeopleReferentialItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfPeopleReferentialItem>(null as any);
    }

    getResults(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getResults";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetResults(_response));
        });
    }

    protected processGetResults(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getQualifications(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getQualifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetQualifications(_response));
        });
    }

    protected processGetQualifications(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getShowClasses(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getShowClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShowClasses(_response));
        });
    }

    protected processGetShowClasses(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCompetitionJudges(competitionRequestId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCompetitionJudges?";
        if (competitionRequestId === null)
            throw new Error("The parameter 'competitionRequestId' cannot be null.");
        else if (competitionRequestId !== undefined)
            url_ += "competitionRequestId=" + encodeURIComponent("" + competitionRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitionJudges(_response));
        });
    }

    protected processGetCompetitionJudges(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDysplasiaTypes(isDysplasiaRequest: boolean | undefined, appealDysplasiaId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getDysplasiaTypes?";
        if (isDysplasiaRequest === null)
            throw new Error("The parameter 'isDysplasiaRequest' cannot be null.");
        else if (isDysplasiaRequest !== undefined)
            url_ += "isDysplasiaRequest=" + encodeURIComponent("" + isDysplasiaRequest) + "&";
        if (appealDysplasiaId === null)
            throw new Error("The parameter 'appealDysplasiaId' cannot be null.");
        else if (appealDysplasiaId !== undefined)
            url_ += "appealDysplasiaId=" + encodeURIComponent("" + appealDysplasiaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDysplasiaTypes(_response));
        });
    }

    protected processGetDysplasiaTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getClinics(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getClinics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClinics(_response));
        });
    }

    protected processGetClinics(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDysplasiaPositions(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getDysplasiaPositions?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDysplasiaPositions(_response));
        });
    }

    protected processGetDysplasiaPositions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getActivities(sectionId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getActivities?";
        if (sectionId !== undefined && sectionId !== null)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getSubActivities(activityId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getSubActivities?";
        if (activityId !== undefined && activityId !== null)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubActivities(_response));
        });
    }

    protected processGetSubActivities(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getFluxStatuses(requestId: number | undefined, languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getFluxStatuses?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFluxStatuses(_response));
        });
    }

    protected processGetFluxStatuses(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBelgianTitles(languageId: number | undefined, dogId: number | null | undefined, titleId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBelgianTitles?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (dogId !== undefined && dogId !== null)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (titleId !== undefined && titleId !== null)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBelgianTitles(_response));
        });
    }

    protected processGetBelgianTitles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBreeds(dogId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBreeds?";
        if (dogId !== undefined && dogId !== null)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreeds(_response));
        });
    }

    protected processGetBreeds(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBabyDogBreedsQuery(dogId: number | null | undefined, brcs: boolean | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBabyDogBreeds?";
        if (dogId !== undefined && dogId !== null)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (brcs === null)
            throw new Error("The parameter 'brcs' cannot be null.");
        else if (brcs !== undefined)
            url_ += "brcs=" + encodeURIComponent("" + brcs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBabyDogBreedsQuery(_response));
        });
    }

    protected processGetBabyDogBreedsQuery(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBreedExceptions(currentBreedId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBreedExceptions?";
        if (currentBreedId === null)
            throw new Error("The parameter 'currentBreedId' cannot be null.");
        else if (currentBreedId !== undefined)
            url_ += "currentBreedId=" + encodeURIComponent("" + currentBreedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedExceptions(_response));
        });
    }

    protected processGetBreedExceptions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBreedGroups(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBreedGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedGroups(_response));
        });
    }

    protected processGetBreedGroups(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getVolunteerProfiles(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getVolunteerProfiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVolunteerProfiles(_response));
        });
    }

    protected processGetVolunteerProfiles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBreedVarieties(currentBreedId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBreedVarieties?";
        if (currentBreedId === null)
            throw new Error("The parameter 'currentBreedId' cannot be null.");
        else if (currentBreedId !== undefined)
            url_ += "currentBreedId=" + encodeURIComponent("" + currentBreedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedVarieties(_response));
        });
    }

    protected processGetBreedVarieties(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getBreedVarietiesWithCurrentBreed(currentBreedId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getBreedVarietiesWithCurrentBreed?";
        if (currentBreedId === null)
            throw new Error("The parameter 'currentBreedId' cannot be null.");
        else if (currentBreedId !== undefined)
            url_ += "currentBreedId=" + encodeURIComponent("" + currentBreedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBreedVarietiesWithCurrentBreed(_response));
        });
    }

    protected processGetBreedVarietiesWithCurrentBreed(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCharacteristics(isDysplasia: boolean | undefined, languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCharacteristics?";
        if (isDysplasia === null)
            throw new Error("The parameter 'isDysplasia' cannot be null.");
        else if (isDysplasia !== undefined)
            url_ += "isDysplasia=" + encodeURIComponent("" + isDysplasia) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCharacteristics(_response));
        });
    }

    protected processGetCharacteristics(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCharacteristicTypes(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCharacteristicTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCharacteristicTypes(_response));
        });
    }

    protected processGetCharacteristicTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDepartments(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDepartments(_response));
        });
    }

    protected processGetDepartments(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getHealthValues(characteristicId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getHealthValues?";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthValues(_response));
        });
    }

    protected processGetHealthValues(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCharacteristicValues(characteristicId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCharacteristicValues?";
        if (characteristicId === null)
            throw new Error("The parameter 'characteristicId' cannot be null.");
        else if (characteristicId !== undefined)
            url_ += "characteristicId=" + encodeURIComponent("" + characteristicId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCharacteristicValues(_response));
        });
    }

    protected processGetCharacteristicValues(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getClubs(personId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getClubs?";
        if (personId !== undefined && personId !== null)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubs(_response));
        });
    }

    protected processGetClubs(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getColors(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getColors?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetColors(_response));
        });
    }

    protected processGetColors(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getColorsByBreed(breedId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getColorsByBreeds?";
        if (breedId === null)
            throw new Error("The parameter 'breedId' cannot be null.");
        else if (breedId !== undefined)
            url_ += "breedId=" + encodeURIComponent("" + breedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetColorsByBreed(_response));
        });
    }

    protected processGetColorsByBreed(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCountries(query: GetCountriesReferentialQuery): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountries(_response));
        });
    }

    protected processGetCountries(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDysplasiaRequests(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getDysplasiaRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDysplasiaRequests(_response));
        });
    }

    protected processGetDysplasiaRequests(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getOwnDysplasiaRequests(dogId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getOwnDysplasiaRequests?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOwnDysplasiaRequests(_response));
        });
    }

    protected processGetOwnDysplasiaRequests(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDogsForWorkbookRequest(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getDogsForWorkbookRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogsForWorkbookRequest(_response));
        });
    }

    protected processGetDogsForWorkbookRequest(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getAllDogTypes(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAllDogTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllDogTypes(_response));
        });
    }

    protected processGetAllDogTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDogTypes(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAllowedDogTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogTypes(_response));
        });
    }

    protected processGetDogTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getDogsWithPedigrees(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getDogsWithPedigrees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDogsWithPedigrees(_response));
        });
    }

    protected processGetDogsWithPedigrees(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getUserProfiles(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getUserProfiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserProfiles(_response));
        });
    }

    protected processGetUserProfiles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getKennels(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getKennels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennels(_response));
        });
    }

    protected processGetKennels(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getKennelTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getKennelTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKennelTypes(_response));
        });
    }

    protected processGetKennelTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getLanguages(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLanguages(_response));
        });
    }

    protected processGetLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getAllLanguages(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAllLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllLanguages(_response));
        });
    }

    protected processGetAllLanguages(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getRequestStates(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getRequestStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestStates(_response));
        });
    }

    protected processGetRequestStates(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getRequestTypes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/GetRequestTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestTypes(_response));
        });
    }

    protected processGetRequestTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getSections(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getSections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSections(_response));
        });
    }

    protected processGetSections(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getSectionsForClub(clubId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getSectionsForClub?";
        if (clubId !== undefined && clubId !== null)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSectionsForClub(_response));
        });
    }

    protected processGetSectionsForClub(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getPostalCodes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getPostalCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPostalCodes(_response));
        });
    }

    protected processGetPostalCodes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getSex(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getSex?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSex(_response));
        });
    }

    protected processGetSex(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getVatCode(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getVatCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVatCode(_response));
        });
    }

    protected processGetVatCode(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getWorkbookColors(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getWorkbookColors?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbookColors(_response));
        });
    }

    protected processGetWorkbookColors(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    searchDogs(query: SearchDogReferentialQuery): Promise<PaginatedResultsOfDogReferentialItem> {
        let url_ = this.baseUrl + "/api/Referential/searchDogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDogs(_response));
        });
    }

    protected processSearchDogs(response: Response): Promise<PaginatedResultsOfDogReferentialItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogReferentialItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogReferentialItem>(null as any);
    }

    getAgility(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAgility";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAgility(_response));
        });
    }

    protected processGetAgility(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getJudgeType(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getJudgeType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJudgeType(_response));
        });
    }

    protected processGetJudgeType(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getGrooming(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getGrooming";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetGrooming(_response));
        });
    }

    protected processGetGrooming(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getPedigreePrefixesByCountry(countryId: number | undefined, dogId: number | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getPedigreePrefixesByCountry?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (dogId !== undefined && dogId !== null)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPedigreePrefixesByCountry(_response));
        });
    }

    protected processGetPedigreePrefixesByCountry(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getAllPedigreePrefixes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAllPedigreePrefixes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllPedigreePrefixes(_response));
        });
    }

    protected processGetAllPedigreePrefixes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getAllForeignPedigreePrefixes(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getAllForeignPedigreePrefixes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllForeignPedigreePrefixes(_response));
        });
    }

    protected processGetAllForeignPedigreePrefixes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getClubRoles(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getClubRoles?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubRoles(_response));
        });
    }

    protected processGetClubRoles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getClubRolesForContact(languageId: number | undefined, clubId: number | undefined, personId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getClubRolesForContact?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (clubId === null)
            throw new Error("The parameter 'clubId' cannot be null.");
        else if (clubId !== undefined)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClubRolesForContact(_response));
        });
    }

    protected processGetClubRolesForContact(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCompetitions(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCompetitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitions(_response));
        });
    }

    protected processGetCompetitions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getTitles(languageId: number | undefined, platform: EPlatform | undefined, countryId: number | null | undefined, canBeUsed: boolean | null | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getTitles?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (platform === null)
            throw new Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (countryId !== undefined && countryId !== null)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (canBeUsed !== undefined && canBeUsed !== null)
            url_ += "canBeUsed=" + encodeURIComponent("" + canBeUsed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTitles(_response));
        });
    }

    protected processGetTitles(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getWorkbookTypes(languageId: number | undefined, dogId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getWorkbookTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbookTypes(_response));
        });
    }

    protected processGetWorkbookTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getTitleTypes(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getTitleTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTitleTypes(_response));
        });
    }

    protected processGetTitleTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getPersonSalutations(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getPersonSalutations?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonSalutations(_response));
        });
    }

    protected processGetPersonSalutations(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getMembershipTypes(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getMembershipTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipTypes(_response));
        });
    }

    protected processGetMembershipTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getRequestDogs(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getRequestDogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestDogs(_response));
        });
    }

    protected processGetRequestDogs(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getRequestDogsWithoutPedigree(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getRequestDogsWithoutPedigree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestDogsWithoutPedigree(_response));
        });
    }

    protected processGetRequestDogsWithoutPedigree(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getRequestDogsWithPedigree(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getRequestDogsWithPedigree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestDogsWithPedigree(_response));
        });
    }

    protected processGetRequestDogsWithPedigree(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getSubFilesRequestTypes(requestTypeCode: ERequestType | undefined, languageId: number | undefined, requestId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getSubFilesRequestTypes?";
        if (requestTypeCode === null)
            throw new Error("The parameter 'requestTypeCode' cannot be null.");
        else if (requestTypeCode !== undefined)
            url_ += "requestTypeCode=" + encodeURIComponent("" + requestTypeCode) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubFilesRequestTypes(_response));
        });
    }

    protected processGetSubFilesRequestTypes(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getMembershipRequestType(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getMembershipRequestType?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipRequestType(_response));
        });
    }

    protected processGetMembershipRequestType(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getMembershipDecisions(languageId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getMembershipDecisions?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMembershipDecisions(_response));
        });
    }

    protected processGetMembershipDecisions(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getLabs(): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/geLabs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabs(_response));
        });
    }

    protected processGetLabs(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }

    getCompetitionExpos(competitionId: number | undefined): Promise<ReferentialItemDto[]> {
        let url_ = this.baseUrl + "/api/Referential/getCompetitionExpos?";
        if (competitionId === null)
            throw new Error("The parameter 'competitionId' cannot be null.");
        else if (competitionId !== undefined)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompetitionExpos(_response));
        });
    }

    protected processGetCompetitionExpos(response: Response): Promise<ReferentialItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferentialItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferentialItemDto[]>(null as any);
    }
}

export interface IReprintPedigreeApi {

    baseSearch(sObj: ReprintPuppiesSearch): Promise<PaginatedResultsOfReprintPedigreePuppiesGridDto>;

    reprintPedigrees(): Promise<Result>;

    exportXlsFile(sObj: ReprintPuppiesSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class ReprintPedigreeApi extends BaseAPI implements IReprintPedigreeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: ReprintPuppiesSearch): Promise<PaginatedResultsOfReprintPedigreePuppiesGridDto> {
        let url_ = this.baseUrl + "/api/ReprintPedigree/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfReprintPedigreePuppiesGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfReprintPedigreePuppiesGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfReprintPedigreePuppiesGridDto>(null as any);
    }

    reprintPedigrees(): Promise<Result> {
        let url_ = this.baseUrl + "/api/ReprintPedigree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintPedigrees(_response));
        });
    }

    protected processReprintPedigrees(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: ReprintPuppiesSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReprintPedigree/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/ReprintPedigree/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/ReprintPedigree/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IRequestActionHistoryApi {

    baseSearch(sObj: BaseRequestSearch): Promise<PaginatedResultsOfRequestHistoryActionGridDto>;

    exportXlsFile(sObj: BaseRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class RequestActionHistoryApi extends BaseAPI implements IRequestActionHistoryApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: BaseRequestSearch): Promise<PaginatedResultsOfRequestHistoryActionGridDto> {
        let url_ = this.baseUrl + "/api/RequestActionHistory/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfRequestHistoryActionGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfRequestHistoryActionGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfRequestHistoryActionGridDto>(null as any);
    }

    exportXlsFile(sObj: BaseRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RequestActionHistory/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/RequestActionHistory/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/RequestActionHistory/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IRequestApi {

    baseSearch(sObj: RequestSearch): Promise<PaginatedResultsOfRequestGridDto>;

    getTurnOverReport(month: number | undefined, year: number | undefined): Promise<FileDto>;

    downloadRequestDocument(sharepointUri: string | null | undefined, fileName: string | null | undefined): Promise<FileDto>;

    getRequestRemark(requestId: number | undefined): Promise<ResultOfString>;

    getSharepointDoc(requestId: number | undefined): Promise<ShpDocumentContentDto[]>;

    drupalSearch(sobj: DrupalRequestSearch): Promise<PaginatedResultsOfDrupalRequestGridDto>;

    saveRequestComment(requestId: number | undefined, comment: string | null | undefined): Promise<Result>;

    printInvoice(requestId: number | undefined): Promise<FileResponse>;

    uncancelRequest(requestId: number | undefined): Promise<Result>;

    updateInvoicePaiementType(requestId: number | undefined, method: string | null | undefined): Promise<ResultOfBoolean>;

    resendInvoice(requestId: number | undefined): Promise<ResultOfBoolean>;

    getRequestInvoice(requestId: number | undefined): Promise<InvoiceDto>;

    getRequestPayementInfo(requestId: number | undefined): Promise<PaymentInfoDto>;

    isSyncedWithParent(requestId: number | undefined): Promise<ResultOfBoolean>;

    getRequestStatus(requestStatusId: number | undefined): Promise<ERequestState>;

    getDisplayName(requestId: number | undefined, languageId: number | undefined): Promise<string>;

    getDrupalRequestTypes(isBrcs: boolean | undefined): Promise<DrupalRequestTypeDto[]>;

    checkAllVerifications(requestId: number | undefined): Promise<ResultOfBoolean>;

    getStatusCurrentRequest(requestId: number | undefined): Promise<ERequestState>;

    closeRequest(requestId: number | undefined): Promise<void>;

    createCreditMemo(requestId: number | undefined, invoiceItemIds: number[]): Promise<Result>;

    updateRequestBlockedStatus(requestId: number | undefined): Promise<void>;

    updateRequestStatus(requestId: number | undefined, requestStatusId: number | undefined, platform: EPlatform | undefined): Promise<void>;

    quickUpdateRequestStatus(command: QuickUpdateRequestStatusIdCommand): Promise<void>;

    updateRequestStatusWithCommand(command: UpdateRequestStatusIdCommand): Promise<void>;

    getRequestMenu(requestId: number | undefined, languageId: number | undefined): Promise<RequestMenuDto>;

    getCurrentRequest(requestId: number | undefined): Promise<ERequestState>;

    getStatusId(code: ERequestState | undefined): Promise<number>;

    getByRequestNumberOrInvoice(requestInformation: string | null | undefined): Promise<SubRequestInfoDto>;

    getSubRequestTypeId(requestId: number | undefined, requestTypeCode: ERequestType | undefined): Promise<number>;

    getSubRequestCount(requestId: number | undefined): Promise<number>;

    getRequestInfo(requestTypeCode: ERequestType | undefined, requestId: number | null | undefined, masterRequestId: number | null | undefined, languageId: number | undefined): Promise<RequestInfoDto>;

    getVerifications(requestId: number | undefined): Promise<VerificationsValueDto[]>;

    saveVerifications(requestId: number | undefined, values: VerificationsValueDto[]): Promise<number>;

    getConditions(requestId: number | undefined): Promise<NeededConditionDto[]>;

    forceCondition(neededConditionId: number | undefined, requestId: number | undefined): Promise<Result>;

    askInfos(requestId: number | undefined): Promise<boolean>;

    createInSharepoint(requestId: number): Promise<string>;

    testShpGetFiles(id: number): Promise<ShpDocumentContentDto[]>;

    exportXlsFile(sObj: RequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class RequestApi extends BaseAPI implements IRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: RequestSearch): Promise<PaginatedResultsOfRequestGridDto> {
        let url_ = this.baseUrl + "/api/Request/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfRequestGridDto>(null as any);
    }

    getTurnOverReport(month: number | undefined, year: number | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/Request/getTurnOverReport?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTurnOverReport(_response));
        });
    }

    protected processGetTurnOverReport(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    downloadRequestDocument(sharepointUri: string | null | undefined, fileName: string | null | undefined): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/Request/DownloadRequestDocument?";
        if (sharepointUri !== undefined && sharepointUri !== null)
            url_ += "sharepointUri=" + encodeURIComponent("" + sharepointUri) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadRequestDocument(_response));
        });
    }

    protected processDownloadRequestDocument(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    getRequestRemark(requestId: number | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/Request?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestRemark(_response));
        });
    }

    protected processGetRequestRemark(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfString.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    getSharepointDoc(requestId: number | undefined): Promise<ShpDocumentContentDto[]> {
        let url_ = this.baseUrl + "/api/Request/GetRequestSharepointDocs?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSharepointDoc(_response));
        });
    }

    protected processGetSharepointDoc(response: Response): Promise<ShpDocumentContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShpDocumentContentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShpDocumentContentDto[]>(null as any);
    }

    drupalSearch(sobj: DrupalRequestSearch): Promise<PaginatedResultsOfDrupalRequestGridDto> {
        let url_ = this.baseUrl + "/api/Request/drupalSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sobj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDrupalSearch(_response));
        });
    }

    protected processDrupalSearch(response: Response): Promise<PaginatedResultsOfDrupalRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDrupalRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDrupalRequestGridDto>(null as any);
    }

    saveRequestComment(requestId: number | undefined, comment: string | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Request/SaveRequestComment?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRequestComment(_response));
        });
    }

    protected processSaveRequestComment(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    printInvoice(requestId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Request/printInvoice?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintInvoice(_response));
        });
    }

    protected processPrintInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uncancelRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Request/unCancelRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUncancelRequest(_response));
        });
    }

    protected processUncancelRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    updateInvoicePaiementType(requestId: number | undefined, method: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Request/updateInvoicePaiementType?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (method !== undefined && method !== null)
            url_ += "method=" + encodeURIComponent("" + method) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateInvoicePaiementType(_response));
        });
    }

    protected processUpdateInvoicePaiementType(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    resendInvoice(requestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Request/resendInvoice?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendInvoice(_response));
        });
    }

    protected processResendInvoice(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getRequestInvoice(requestId: number | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Request/getRequestInvoice?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestInvoice(_response));
        });
    }

    protected processGetRequestInvoice(response: Response): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    getRequestPayementInfo(requestId: number | undefined): Promise<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/Request/getRequestPayementInfo?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestPayementInfo(_response));
        });
    }

    protected processGetRequestPayementInfo(response: Response): Promise<PaymentInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentInfoDto>(null as any);
    }

    isSyncedWithParent(requestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Request/isSyncedWithParent?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsSyncedWithParent(_response));
        });
    }

    protected processIsSyncedWithParent(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getRequestStatus(requestStatusId: number | undefined): Promise<ERequestState> {
        let url_ = this.baseUrl + "/api/Request/getRequestStatus?";
        if (requestStatusId === null)
            throw new Error("The parameter 'requestStatusId' cannot be null.");
        else if (requestStatusId !== undefined)
            url_ += "requestStatusId=" + encodeURIComponent("" + requestStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestStatus(_response));
        });
    }

    protected processGetRequestStatus(response: Response): Promise<ERequestState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ERequestState>(null as any);
    }

    getDisplayName(requestId: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Request/getDisplayName?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDrupalRequestTypes(isBrcs: boolean | undefined): Promise<DrupalRequestTypeDto[]> {
        let url_ = this.baseUrl + "/api/Request/drupalRequestTypes?";
        if (isBrcs === null)
            throw new Error("The parameter 'isBrcs' cannot be null.");
        else if (isBrcs !== undefined)
            url_ += "isBrcs=" + encodeURIComponent("" + isBrcs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalRequestTypes(_response));
        });
    }

    protected processGetDrupalRequestTypes(response: Response): Promise<DrupalRequestTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrupalRequestTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalRequestTypeDto[]>(null as any);
    }

    checkAllVerifications(requestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Request/checkAllVerifications?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckAllVerifications(_response));
        });
    }

    protected processCheckAllVerifications(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    getStatusCurrentRequest(requestId: number | undefined): Promise<ERequestState> {
        let url_ = this.baseUrl + "/api/Request/getStatusCurrentRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatusCurrentRequest(_response));
        });
    }

    protected processGetStatusCurrentRequest(response: Response): Promise<ERequestState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ERequestState>(null as any);
    }

    closeRequest(requestId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Request/closeRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseRequest(_response));
        });
    }

    protected processCloseRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createCreditMemo(requestId: number | undefined, invoiceItemIds: number[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/Request/createCreditMemo?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceItemIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCreditMemo(_response));
        });
    }

    protected processCreateCreditMemo(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    updateRequestBlockedStatus(requestId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Request/updateRequestBlockedStatus?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRequestBlockedStatus(_response));
        });
    }

    protected processUpdateRequestBlockedStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRequestStatus(requestId: number | undefined, requestStatusId: number | undefined, platform: EPlatform | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Request/updateRequestStatus?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (requestStatusId === null)
            throw new Error("The parameter 'requestStatusId' cannot be null.");
        else if (requestStatusId !== undefined)
            url_ += "requestStatusId=" + encodeURIComponent("" + requestStatusId) + "&";
        if (platform === null)
            throw new Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRequestStatus(_response));
        });
    }

    protected processUpdateRequestStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    quickUpdateRequestStatus(command: QuickUpdateRequestStatusIdCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Request/quickUpdateRequestStatusWithCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQuickUpdateRequestStatus(_response));
        });
    }

    protected processQuickUpdateRequestStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRequestStatusWithCommand(command: UpdateRequestStatusIdCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Request/updateRequestStatusWithCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRequestStatusWithCommand(_response));
        });
    }

    protected processUpdateRequestStatusWithCommand(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRequestMenu(requestId: number | undefined, languageId: number | undefined): Promise<RequestMenuDto> {
        let url_ = this.baseUrl + "/api/Request/getRequestMenu?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestMenu(_response));
        });
    }

    protected processGetRequestMenu(response: Response): Promise<RequestMenuDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestMenuDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestMenuDto>(null as any);
    }

    getCurrentRequest(requestId: number | undefined): Promise<ERequestState> {
        let url_ = this.baseUrl + "/api/Request/getCurrentRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCurrentRequest(_response));
        });
    }

    protected processGetCurrentRequest(response: Response): Promise<ERequestState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ERequestState>(null as any);
    }

    getStatusId(code: ERequestState | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Request/getStatusId?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatusId(_response));
        });
    }

    protected processGetStatusId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getByRequestNumberOrInvoice(requestInformation: string | null | undefined): Promise<SubRequestInfoDto> {
        let url_ = this.baseUrl + "/api/Request/getByRequestNumber?";
        if (requestInformation !== undefined && requestInformation !== null)
            url_ += "requestInformation=" + encodeURIComponent("" + requestInformation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByRequestNumberOrInvoice(_response));
        });
    }

    protected processGetByRequestNumberOrInvoice(response: Response): Promise<SubRequestInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubRequestInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubRequestInfoDto>(null as any);
    }

    getSubRequestTypeId(requestId: number | undefined, requestTypeCode: ERequestType | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Request/getSubRequestId?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (requestTypeCode === null)
            throw new Error("The parameter 'requestTypeCode' cannot be null.");
        else if (requestTypeCode !== undefined)
            url_ += "requestTypeCode=" + encodeURIComponent("" + requestTypeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubRequestTypeId(_response));
        });
    }

    protected processGetSubRequestTypeId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSubRequestCount(requestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Request/getSubRequestCount?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubRequestCount(_response));
        });
    }

    protected processGetSubRequestCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getRequestInfo(requestTypeCode: ERequestType | undefined, requestId: number | null | undefined, masterRequestId: number | null | undefined, languageId: number | undefined): Promise<RequestInfoDto> {
        let url_ = this.baseUrl + "/api/Request/getRequestInfo?";
        if (requestTypeCode === null)
            throw new Error("The parameter 'requestTypeCode' cannot be null.");
        else if (requestTypeCode !== undefined)
            url_ += "requestTypeCode=" + encodeURIComponent("" + requestTypeCode) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (masterRequestId !== undefined && masterRequestId !== null)
            url_ += "masterRequestId=" + encodeURIComponent("" + masterRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestInfo(_response));
        });
    }

    protected processGetRequestInfo(response: Response): Promise<RequestInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestInfoDto>(null as any);
    }

    getVerifications(requestId: number | undefined): Promise<VerificationsValueDto[]> {
        let url_ = this.baseUrl + "/api/Request/getVerifications?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVerifications(_response));
        });
    }

    protected processGetVerifications(response: Response): Promise<VerificationsValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VerificationsValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationsValueDto[]>(null as any);
    }

    saveVerifications(requestId: number | undefined, values: VerificationsValueDto[]): Promise<number> {
        let url_ = this.baseUrl + "/api/Request/saveVerifications?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(values);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveVerifications(_response));
        });
    }

    protected processSaveVerifications(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getConditions(requestId: number | undefined): Promise<NeededConditionDto[]> {
        let url_ = this.baseUrl + "/api/Request/getConditions?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConditions(_response));
        });
    }

    protected processGetConditions(response: Response): Promise<NeededConditionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NeededConditionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NeededConditionDto[]>(null as any);
    }

    forceCondition(neededConditionId: number | undefined, requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Request/forceCondition?";
        if (neededConditionId === null)
            throw new Error("The parameter 'neededConditionId' cannot be null.");
        else if (neededConditionId !== undefined)
            url_ += "neededConditionId=" + encodeURIComponent("" + neededConditionId) + "&";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForceCondition(_response));
        });
    }

    protected processForceCondition(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    askInfos(requestId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Request/askInfos?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAskInfos(_response));
        });
    }

    protected processAskInfos(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createInSharepoint(requestId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Request/CreateInSharepoint/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInSharepoint(_response));
        });
    }

    protected processCreateInSharepoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    testShpGetFiles(id: number): Promise<ShpDocumentContentDto[]> {
        let url_ = this.baseUrl + "/api/Request/test-shp-get-files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTestShpGetFiles(_response));
        });
    }

    protected processTestShpGetFiles(response: Response): Promise<ShpDocumentContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShpDocumentContentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShpDocumentContentDto[]>(null as any);
    }

    exportXlsFile(sObj: RequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Request/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Request/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Request/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ISectionLinkedActivitiesApi {

    baseSearch(sObj: SectionLinkedActivitiesSearch): Promise<PaginatedResultsOfSectionLinkedActivitiesDto>;

    getIds(sObj: SectionLinkedActivitiesSearch): Promise<number[]>;

    exportXlsFile(sObj: SectionLinkedActivitiesSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class SectionLinkedActivitiesApi extends BaseAPI implements ISectionLinkedActivitiesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: SectionLinkedActivitiesSearch): Promise<PaginatedResultsOfSectionLinkedActivitiesDto> {
        let url_ = this.baseUrl + "/api/SectionLinkedActivities/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSectionLinkedActivitiesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSectionLinkedActivitiesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSectionLinkedActivitiesDto>(null as any);
    }

    getIds(sObj: SectionLinkedActivitiesSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/SectionLinkedActivities/getIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    exportXlsFile(sObj: SectionLinkedActivitiesSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SectionLinkedActivities/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/SectionLinkedActivities/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/SectionLinkedActivities/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ISectionsApi {

    baseSearch(sObj: SectionSearch): Promise<PaginatedResultsOfSectionsGridDto>;

    getSection(id: number | undefined): Promise<SectionDto>;

    saveSection(dto: SectionDto): Promise<number>;

    deleteSection(id: number | undefined): Promise<void>;

    isSectionUnique(sectionCode: string | null | undefined, sectionId: number | undefined): Promise<BooleanDto>;

    getDisplayName(sectionId: number | undefined, languageCode: string | null | undefined): Promise<string>;

    exportXlsFile(sObj: SectionSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class SectionsApi extends BaseAPI implements ISectionsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: SectionSearch): Promise<PaginatedResultsOfSectionsGridDto> {
        let url_ = this.baseUrl + "/api/Sections/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSectionsGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSectionsGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSectionsGridDto>(null as any);
    }

    getSection(id: number | undefined): Promise<SectionDto> {
        let url_ = this.baseUrl + "/api/Sections?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSection(_response));
        });
    }

    protected processGetSection(response: Response): Promise<SectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionDto>(null as any);
    }

    saveSection(dto: SectionDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Sections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSection(_response));
        });
    }

    protected processSaveSection(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSection(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSection(_response));
        });
    }

    protected processDeleteSection(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    isSectionUnique(sectionCode: string | null | undefined, sectionId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/Sections/IsSectionUnique?";
        if (sectionCode !== undefined && sectionCode !== null)
            url_ += "sectionCode=" + encodeURIComponent("" + sectionCode) + "&";
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsSectionUnique(_response));
        });
    }

    protected processIsSectionUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getDisplayName(sectionId: number | undefined, languageCode: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Sections/displayname?";
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: SectionSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Sections/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Sections/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Sections/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IStripeApi {

    getStripeSessionLink(item: CheckoutItemDto): Promise<StripeSessionDto>;

    triggerStripeWebHook(): Promise<number>;
}

export class StripeApi extends BaseAPI implements IStripeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getStripeSessionLink(item: CheckoutItemDto): Promise<StripeSessionDto> {
        let url_ = this.baseUrl + "/api/Stripe/GetStripeSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStripeSessionLink(_response));
        });
    }

    protected processGetStripeSessionLink(response: Response): Promise<StripeSessionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeSessionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StripeSessionDto>(null as any);
    }

    triggerStripeWebHook(): Promise<number> {
        let url_ = this.baseUrl + "/api/Stripe/WebHook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTriggerStripeWebHook(_response));
        });
    }

    protected processTriggerStripeWebHook(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ISubActivityApi {

    baseSearch(sObj: SubActivitySearch): Promise<PaginatedResultsOfSubActivityGridDto>;

    get(id: number | undefined): Promise<SubActivityDetailDto>;

    save(dto: SubActivityDetailDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    getDisplayName(id: number | undefined, languageCode: string | null | undefined): Promise<string>;

    exportXlsFile(sObj: SubActivitySearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class SubActivityApi extends BaseAPI implements ISubActivityApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: SubActivitySearch): Promise<PaginatedResultsOfSubActivityGridDto> {
        let url_ = this.baseUrl + "/api/SubActivity/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSubActivityGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSubActivityGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSubActivityGridDto>(null as any);
    }

    get(id: number | undefined): Promise<SubActivityDetailDto> {
        let url_ = this.baseUrl + "/api/SubActivity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SubActivityDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubActivityDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubActivityDetailDto>(null as any);
    }

    save(dto: SubActivityDetailDto): Promise<number> {
        let url_ = this.baseUrl + "/api/SubActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SubActivity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDisplayName(id: number | undefined, languageCode: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/SubActivity/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: SubActivitySearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SubActivity/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/SubActivity/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/SubActivity/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ISubActivityJudgeApi {

    baseSearch(sObj: SubActivityJudgeSearch): Promise<PaginatedResultsOfSubActivityJudgeGridDto>;

    getIds(sObj: SubActivityJudgeSearch): Promise<number[]>;

    saveSubActivityJudge(dto: SaveSubActivityJudgeDto): Promise<number>;

    deleteSubActivityJudge(breedJudgeId: number | undefined): Promise<void>;

    exportXlsFile(sObj: SubActivityJudgeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class SubActivityJudgeApi extends BaseAPI implements ISubActivityJudgeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: SubActivityJudgeSearch): Promise<PaginatedResultsOfSubActivityJudgeGridDto> {
        let url_ = this.baseUrl + "/api/SubActivityJudge/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfSubActivityJudgeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfSubActivityJudgeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfSubActivityJudgeGridDto>(null as any);
    }

    getIds(sObj: SubActivityJudgeSearch): Promise<number[]> {
        let url_ = this.baseUrl + "/api/SubActivityJudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIds(_response));
        });
    }

    protected processGetIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    saveSubActivityJudge(dto: SaveSubActivityJudgeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/SubActivityJudge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSubActivityJudge(_response));
        });
    }

    protected processSaveSubActivityJudge(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSubActivityJudge(breedJudgeId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SubActivityJudge?";
        if (breedJudgeId === null)
            throw new Error("The parameter 'breedJudgeId' cannot be null.");
        else if (breedJudgeId !== undefined)
            url_ += "breedJudgeId=" + encodeURIComponent("" + breedJudgeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSubActivityJudge(_response));
        });
    }

    protected processDeleteSubActivityJudge(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: SubActivityJudgeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SubActivityJudge/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/SubActivityJudge/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/SubActivityJudge/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ISystemApi {

    get(): Promise<SystemVersionDto>;

    checkException(): Promise<ErrorDetails>;

    ingenicoSettings(): Promise<IngenicoSettings>;

    forceUpdateVersion(): Promise<FileResponse>;

    availableTypes(inbreeding: CoupleInbreedingDto): Promise<FileResponse>;
}

export class SystemApi extends BaseAPI implements ISystemApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<SystemVersionDto> {
        let url_ = this.baseUrl + "/api/System";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SystemVersionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemVersionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemVersionDto>(null as any);
    }

    checkException(): Promise<ErrorDetails> {
        let url_ = this.baseUrl + "/api/System/fail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckException(_response));
        });
    }

    protected processCheckException(response: Response): Promise<ErrorDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorDetails>(null as any);
    }

    ingenicoSettings(): Promise<IngenicoSettings> {
        let url_ = this.baseUrl + "/api/System/IngenicoSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIngenicoSettings(_response));
        });
    }

    protected processIngenicoSettings(response: Response): Promise<IngenicoSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngenicoSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IngenicoSettings>(null as any);
    }

    forceUpdateVersion(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/System/ForceUpdateVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForceUpdateVersion(_response));
        });
    }

    protected processForceUpdateVersion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    availableTypes(inbreeding: CoupleInbreedingDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/System/availableTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inbreeding);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableTypes(_response));
        });
    }

    protected processAvailableTypes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITempRSHRequestApi {

    baseSearch(sObj: TempRSHRequestSearch): Promise<PaginatedResultsOfTempRSHRequestGridDto>;

    get(tempRSHRequestId: number | undefined): Promise<TempRSHRequestDto>;

    save(dto: TempRSHRequestDto): Promise<number>;

    isDogAvailable(dogId: number | undefined, tempRSHRequestId: number | undefined): Promise<ResultOfBoolean>;

    close(requestId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: TempRSHRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TempRSHRequestApi extends BaseAPI implements ITempRSHRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TempRSHRequestSearch): Promise<PaginatedResultsOfTempRSHRequestGridDto> {
        let url_ = this.baseUrl + "/api/TempRSHRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTempRSHRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTempRSHRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTempRSHRequestGridDto>(null as any);
    }

    get(tempRSHRequestId: number | undefined): Promise<TempRSHRequestDto> {
        let url_ = this.baseUrl + "/api/TempRSHRequest?";
        if (tempRSHRequestId === null)
            throw new Error("The parameter 'tempRSHRequestId' cannot be null.");
        else if (tempRSHRequestId !== undefined)
            url_ += "tempRSHRequestId=" + encodeURIComponent("" + tempRSHRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TempRSHRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TempRSHRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TempRSHRequestDto>(null as any);
    }

    save(dto: TempRSHRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/TempRSHRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isDogAvailable(dogId: number | undefined, tempRSHRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/TempRSHRequest/isDogAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (tempRSHRequestId === null)
            throw new Error("The parameter 'tempRSHRequestId' cannot be null.");
        else if (tempRSHRequestId !== undefined)
            url_ += "tempRSHRequestId=" + encodeURIComponent("" + tempRSHRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/TempRSHRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: TempRSHRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TempRSHRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TempRSHRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/TempRSHRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ITitlesApi {

    baseSearch(sObj: TitleSearch): Promise<PaginatedResultsOfTitlesGridDto>;

    get(titleId: number | undefined): Promise<TitleDto>;

    save(dto: TitleDto): Promise<number>;

    delete(titleId: number | undefined): Promise<boolean>;

    getDisplayName(titleId: number | undefined, languageCode: string | null | undefined): Promise<string>;

    exportXlsFile(sObj: TitleSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TitlesApi extends BaseAPI implements ITitlesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TitleSearch): Promise<PaginatedResultsOfTitlesGridDto> {
        let url_ = this.baseUrl + "/api/Titles/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTitlesGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTitlesGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTitlesGridDto>(null as any);
    }

    get(titleId: number | undefined): Promise<TitleDto> {
        let url_ = this.baseUrl + "/api/Titles?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TitleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TitleDto>(null as any);
    }

    save(dto: TitleDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Titles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(titleId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Titles?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDisplayName(titleId: number | undefined, languageCode: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Titles/displayName?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: TitleSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Titles/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Titles/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Titles/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ITitlesRequestApi {

    baseSearch(sObj: TitlesRequestSearch): Promise<PaginatedResultsOfTitlesRequestGridDto>;

    getTitleRequest(titleRequestId: number | undefined): Promise<TitleRequestDto>;

    save(dto: TitleRequestDto): Promise<number>;

    getDrupalTitleRequest(titleRequestId: number | undefined): Promise<DrupalTitleRequestDto>;

    regenAndReprintDiploma(titleRequestId: number | undefined): Promise<Result>;

    getParentRequestId(titleRequestId: number | undefined): Promise<number>;

    getDisplayName(titleRequestId: number | undefined): Promise<string>;

    importFile(titleRequestId: number | undefined, files: FileParameter[] | null | undefined): Promise<Result>;

    close(requestId: number | undefined): Promise<Result>;

    saveDrupalTitleRequest(dto: DrupalTitleRequestDto): Promise<TitleRequestDto>;

    exportXlsFile(sObj: TitlesRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TitlesRequestApi extends BaseAPI implements ITitlesRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TitlesRequestSearch): Promise<PaginatedResultsOfTitlesRequestGridDto> {
        let url_ = this.baseUrl + "/api/TitlesRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTitlesRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTitlesRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTitlesRequestGridDto>(null as any);
    }

    getTitleRequest(titleRequestId: number | undefined): Promise<TitleRequestDto> {
        let url_ = this.baseUrl + "/api/TitlesRequest?";
        if (titleRequestId === null)
            throw new Error("The parameter 'titleRequestId' cannot be null.");
        else if (titleRequestId !== undefined)
            url_ += "titleRequestId=" + encodeURIComponent("" + titleRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTitleRequest(_response));
        });
    }

    protected processGetTitleRequest(response: Response): Promise<TitleRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TitleRequestDto>(null as any);
    }

    save(dto: TitleRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/TitlesRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDrupalTitleRequest(titleRequestId: number | undefined): Promise<DrupalTitleRequestDto> {
        let url_ = this.baseUrl + "/api/TitlesRequest/getDrupalTitleRequest?";
        if (titleRequestId === null)
            throw new Error("The parameter 'titleRequestId' cannot be null.");
        else if (titleRequestId !== undefined)
            url_ += "titleRequestId=" + encodeURIComponent("" + titleRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalTitleRequest(_response));
        });
    }

    protected processGetDrupalTitleRequest(response: Response): Promise<DrupalTitleRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalTitleRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalTitleRequestDto>(null as any);
    }

    regenAndReprintDiploma(titleRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/TitlesRequest/regenAndReprintDiploma?";
        if (titleRequestId === null)
            throw new Error("The parameter 'titleRequestId' cannot be null.");
        else if (titleRequestId !== undefined)
            url_ += "titleRequestId=" + encodeURIComponent("" + titleRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegenAndReprintDiploma(_response));
        });
    }

    protected processRegenAndReprintDiploma(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getParentRequestId(titleRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/TitlesRequest/GetParentRequestId?";
        if (titleRequestId === null)
            throw new Error("The parameter 'titleRequestId' cannot be null.");
        else if (titleRequestId !== undefined)
            url_ += "titleRequestId=" + encodeURIComponent("" + titleRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParentRequestId(_response));
        });
    }

    protected processGetParentRequestId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(titleRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/TitlesRequest/getDisplayName?";
        if (titleRequestId === null)
            throw new Error("The parameter 'titleRequestId' cannot be null.");
        else if (titleRequestId !== undefined)
            url_ += "titleRequestId=" + encodeURIComponent("" + titleRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    importFile(titleRequestId: number | undefined, files: FileParameter[] | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/TitlesRequest/importFile?";
        if (titleRequestId === null)
            throw new Error("The parameter 'titleRequestId' cannot be null.");
        else if (titleRequestId !== undefined)
            url_ += "titleRequestId=" + encodeURIComponent("" + titleRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportFile(_response));
        });
    }

    protected processImportFile(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/TitlesRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    saveDrupalTitleRequest(dto: DrupalTitleRequestDto): Promise<TitleRequestDto> {
        let url_ = this.baseUrl + "/api/TitlesRequest/saveDrupalTitleRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDrupalTitleRequest(_response));
        });
    }

    protected processSaveDrupalTitleRequest(response: Response): Promise<TitleRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TitleRequestDto>(null as any);
    }

    exportXlsFile(sObj: TitlesRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TitlesRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TitlesRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/TitlesRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ITitleTypeApi {

    baseSearch(sObj: TitleTypeSearch): Promise<PaginatedResultsOfTitleTypeGridDto>;

    get(titleTypeId: number | undefined): Promise<TitleTypeDto>;

    save(dto: TitleTypeDto): Promise<number>;

    delete(titleTypeId: number | undefined): Promise<boolean>;

    getDisplayName(titleTypeId: number | undefined, languageId: number | undefined): Promise<string>;

    exportXlsFile(sObj: TitleTypeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TitleTypeApi extends BaseAPI implements ITitleTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TitleTypeSearch): Promise<PaginatedResultsOfTitleTypeGridDto> {
        let url_ = this.baseUrl + "/api/TitleType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTitleTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTitleTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTitleTypeGridDto>(null as any);
    }

    get(titleTypeId: number | undefined): Promise<TitleTypeDto> {
        let url_ = this.baseUrl + "/api/TitleType?";
        if (titleTypeId === null)
            throw new Error("The parameter 'titleTypeId' cannot be null.");
        else if (titleTypeId !== undefined)
            url_ += "titleTypeId=" + encodeURIComponent("" + titleTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TitleTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TitleTypeDto>(null as any);
    }

    save(dto: TitleTypeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/TitleType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(titleTypeId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/TitleType?";
        if (titleTypeId === null)
            throw new Error("The parameter 'titleTypeId' cannot be null.");
        else if (titleTypeId !== undefined)
            url_ += "titleTypeId=" + encodeURIComponent("" + titleTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getDisplayName(titleTypeId: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/TitleType/getDisplayName?";
        if (titleTypeId === null)
            throw new Error("The parameter 'titleTypeId' cannot be null.");
        else if (titleTypeId !== undefined)
            url_ += "titleTypeId=" + encodeURIComponent("" + titleTypeId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportXlsFile(sObj: TitleTypeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TitleType/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TitleType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/TitleType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ITransientDogTitlesApi {

    baseSearch(sObj: DogsTransientTitlesSearch): Promise<PaginatedResultsOfTransientDogTitleGridDto>;

    assign(idsToAssign: number[]): Promise<ResultOfBoolean>;

    create(dogTitlesTransientId: number | undefined, dogId: number | undefined, titleId: number | undefined, year: number | undefined, managerId: number | null | undefined, countryId: number | null | undefined, titleFile: FileParameter | null | undefined): Promise<Result>;

    searchByDog(sObj: TransientDogTitleByDogSearch): Promise<PaginatedResultsOfDogTitlesGridDto>;

    close(idsToValidate: number[]): Promise<Result>;

    validate(idsToValidate: number[]): Promise<ResultOfBoolean>;

    exportXlsFile(sObj: DogsTransientTitlesSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TransientDogTitlesApi extends BaseAPI implements ITransientDogTitlesApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: DogsTransientTitlesSearch): Promise<PaginatedResultsOfTransientDogTitleGridDto> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTransientDogTitleGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTransientDogTitleGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTransientDogTitleGridDto>(null as any);
    }

    assign(idsToAssign: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToAssign);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssign(_response));
        });
    }

    protected processAssign(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    create(dogTitlesTransientId: number | undefined, dogId: number | undefined, titleId: number | undefined, year: number | undefined, managerId: number | null | undefined, countryId: number | null | undefined, titleFile: FileParameter | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dogTitlesTransientId === null || dogTitlesTransientId === undefined)
            throw new Error("The parameter 'dogTitlesTransientId' cannot be null.");
        else
            content_.append("DogTitlesTransientId", dogTitlesTransientId.toString());
        if (dogId === null || dogId === undefined)
            throw new Error("The parameter 'dogId' cannot be null.");
        else
            content_.append("DogId", dogId.toString());
        if (titleId === null || titleId === undefined)
            throw new Error("The parameter 'titleId' cannot be null.");
        else
            content_.append("TitleId", titleId.toString());
        if (year === null || year === undefined)
            throw new Error("The parameter 'year' cannot be null.");
        else
            content_.append("Year", year.toString());
        if (managerId !== null && managerId !== undefined)
            content_.append("ManagerId", managerId.toString());
        if (countryId !== null && countryId !== undefined)
            content_.append("CountryId", countryId.toString());
        if (titleFile !== null && titleFile !== undefined)
            content_.append("TitleFile", titleFile.data, titleFile.fileName ? titleFile.fileName : "TitleFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    searchByDog(sObj: TransientDogTitleByDogSearch): Promise<PaginatedResultsOfDogTitlesGridDto> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/searchByDog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchByDog(_response));
        });
    }

    protected processSearchByDog(response: Response): Promise<PaginatedResultsOfDogTitlesGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfDogTitlesGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfDogTitlesGridDto>(null as any);
    }

    close(idsToValidate: number[]): Promise<Result> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/close";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToValidate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    validate(idsToValidate: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idsToValidate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    exportXlsFile(sObj: DogsTransientTitlesSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/TransientDogTitles/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ITransientWorkbookApi {

    baseSearch(sObj: TransientWorkbookSearch): Promise<PaginatedResultsOfTransientWorkbookGridDto>;

    getWorkbookDescription(workbookTypeId: number | undefined, languageId: number | undefined): Promise<string>;

    getCounter(dogId: number | undefined, workbookTypeId: number | undefined): Promise<number>;

    exportXlsFile(sObj: TransientWorkbookSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TransientWorkbookApi extends BaseAPI implements ITransientWorkbookApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: TransientWorkbookSearch): Promise<PaginatedResultsOfTransientWorkbookGridDto> {
        let url_ = this.baseUrl + "/api/TransientWorkbook/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTransientWorkbookGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTransientWorkbookGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTransientWorkbookGridDto>(null as any);
    }

    getWorkbookDescription(workbookTypeId: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/TransientWorkbook/getWorkbookDescription?";
        if (workbookTypeId === null)
            throw new Error("The parameter 'workbookTypeId' cannot be null.");
        else if (workbookTypeId !== undefined)
            url_ += "workbookTypeId=" + encodeURIComponent("" + workbookTypeId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbookDescription(_response));
        });
    }

    protected processGetWorkbookDescription(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCounter(dogId: number | undefined, workbookTypeId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/TransientWorkbook/getCounter?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (workbookTypeId === null)
            throw new Error("The parameter 'workbookTypeId' cannot be null.");
        else if (workbookTypeId !== undefined)
            url_ += "workbookTypeId=" + encodeURIComponent("" + workbookTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCounter(_response));
        });
    }

    protected processGetCounter(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportXlsFile(sObj: TransientWorkbookSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TransientWorkbook/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/TransientWorkbook/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/TransientWorkbook/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface ITranslationsApi {

    getTranslations(languageCode: string | null | undefined): Promise<TranslationDto[]>;

    saveTranslation(languageCode: string | null, text: string | null | undefined, translationCode: string | null | undefined): Promise<Result>;

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand): Promise<void>;

    baseSearch(sObj: TranslationSearch): Promise<PaginatedResultsOfTranslationDto>;

    export(): Promise<FileDownload>;

    upload(file: FileParameter | null | undefined): Promise<void>;

    exportXlsFile(sObj: TranslationSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class TranslationsApi extends BaseAPI implements ITranslationsApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTranslations(languageCode: string | null | undefined): Promise<TranslationDto[]> {
        let url_ = this.baseUrl + "/api/Translations?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslations(_response));
        });
    }

    protected processGetTranslations(response: Response): Promise<TranslationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDto[]>(null as any);
    }

    saveTranslation(languageCode: string | null, text: string | null | undefined, translationCode: string | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Translations/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (text !== null && text !== undefined)
            content_.append("text", text.toString());
        if (translationCode !== null && translationCode !== undefined)
            content_.append("translationCode", translationCode.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveTranslation(_response));
        });
    }

    protected processSaveTranslation(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    updateTranslation(updateTranslationCommand: UpdateTranslationCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Translations/UpdateTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTranslationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTranslation(_response));
        });
    }

    protected processUpdateTranslation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    baseSearch(sObj: TranslationSearch): Promise<PaginatedResultsOfTranslationDto> {
        let url_ = this.baseUrl + "/api/Translations/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfTranslationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfTranslationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfTranslationDto>(null as any);
    }

    export(): Promise<FileDownload> {
        let url_ = this.baseUrl + "/api/Translations/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownload.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDownload>(null as any);
    }

    upload(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Translations/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportXlsFile(sObj: TranslationSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Translations/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Translations/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Translations/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IUnassignedRequestApi {

    assignRequests(isAccounting: boolean | undefined, requestIdsToAssign: number[]): Promise<ResultOfBoolean>;
}

export class UnassignedRequestApi extends BaseAPI implements IUnassignedRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    assignRequests(isAccounting: boolean | undefined, requestIdsToAssign: number[]): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/UnassignedRequest/assignRequests?";
        if (isAccounting === null)
            throw new Error("The parameter 'isAccounting' cannot be null.");
        else if (isAccounting !== undefined)
            url_ += "isAccounting=" + encodeURIComponent("" + isAccounting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestIdsToAssign);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignRequests(_response));
        });
    }

    protected processAssignRequests(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }
}

export interface IUsersApi {

    baseSearch(sObj: UserSearch): Promise<PaginatedResultsOfUserGridDto>;

    getDisplayName(userId: number | undefined): Promise<string>;

    resetPassword(email: string | null | undefined, platform: EPlatform | undefined, isBrcs: boolean | undefined): Promise<ResultOfBoolean>;

    get(userId: number | undefined): Promise<UserDto>;

    save(dto: UserDto): Promise<UserDto>;

    delete(userId: number | undefined): Promise<ResultOfBoolean>;

    isEmailUnique(email: string | null | undefined): Promise<ResultOfBoolean>;

    authenticate(auth: AuthenticateCommand): Promise<UserDto>;

    getUserProfileActions(): Promise<UserProfileActionDto[]>;

    changePassword(password: string | null | undefined): Promise<UserDto>;

    changeUserLanguage(userId: number | undefined, languageId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: UserSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class UsersApi extends BaseAPI implements IUsersApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: UserSearch): Promise<PaginatedResultsOfUserGridDto> {
        let url_ = this.baseUrl + "/api/Users/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfUserGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfUserGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfUserGridDto>(null as any);
    }

    getDisplayName(userId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/displayName?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    resetPassword(email: string | null | undefined, platform: EPlatform | undefined, isBrcs: boolean | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Users/ResetPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (platform === null)
            throw new Error("The parameter 'platform' cannot be null.");
        else if (platform !== undefined)
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (isBrcs === null)
            throw new Error("The parameter 'isBrcs' cannot be null.");
        else if (isBrcs !== undefined)
            url_ += "isBrcs=" + encodeURIComponent("" + isBrcs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    get(userId: number | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    save(dto: UserDto): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    delete(userId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Users?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    isEmailUnique(email: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/Users/getUniqueEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsEmailUnique(_response));
        });
    }

    protected processIsEmailUnique(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    authenticate(auth: AuthenticateCommand): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auth);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthenticate(_response));
        });
    }

    protected processAuthenticate(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getUserProfileActions(): Promise<UserProfileActionDto[]> {
        let url_ = this.baseUrl + "/api/Users/GetUserProfileActions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserProfileActions(_response));
        });
    }

    protected processGetUserProfileActions(response: Response): Promise<UserProfileActionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfileActionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileActionDto[]>(null as any);
    }

    changePassword(password: string | null | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/ChangePassword?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    changeUserLanguage(userId: number | undefined, languageId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Users/ChangeUserLanguage?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeUserLanguage(_response));
        });
    }

    protected processChangeUserLanguage(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: UserSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Users/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Users/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IVeterinaryClinicApi {

    baseSearch(sObj: VeterinaryClinicSearch): Promise<PaginatedResultsOfVeterinaryClinicDto>;

    deleteVeterinaryClinic(id: number | undefined): Promise<void>;

    addNewVeterinary(dto: SaveVeterinaryClinicDto): Promise<number>;

    getAvailableVeterinaryForClinic(sObj: AvailableVeterinaryForClinicSearch): Promise<PaginatedResultsOfVeterinaryGridDto>;

    getClinicFromVeterinary(sObj: VeterinaryClinicSearch): Promise<PaginatedResultsOfVeterinaryClinicDto>;

    getAvailableClinicForVeterinary(sObj: AvailableVeterinaryForClinicSearch): Promise<PaginatedResultsOfClinicDto>;

    exportXlsFile(sObj: VeterinaryClinicSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class VeterinaryClinicApi extends BaseAPI implements IVeterinaryClinicApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: VeterinaryClinicSearch): Promise<PaginatedResultsOfVeterinaryClinicDto> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfVeterinaryClinicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfVeterinaryClinicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfVeterinaryClinicDto>(null as any);
    }

    deleteVeterinaryClinic(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteVeterinaryClinic(_response));
        });
    }

    protected processDeleteVeterinaryClinic(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addNewVeterinary(dto: SaveVeterinaryClinicDto): Promise<number> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/addNewVeterinary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddNewVeterinary(_response));
        });
    }

    protected processAddNewVeterinary(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAvailableVeterinaryForClinic(sObj: AvailableVeterinaryForClinicSearch): Promise<PaginatedResultsOfVeterinaryGridDto> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/GetAvailableVeterinaryForClinic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableVeterinaryForClinic(_response));
        });
    }

    protected processGetAvailableVeterinaryForClinic(response: Response): Promise<PaginatedResultsOfVeterinaryGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfVeterinaryGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfVeterinaryGridDto>(null as any);
    }

    getClinicFromVeterinary(sObj: VeterinaryClinicSearch): Promise<PaginatedResultsOfVeterinaryClinicDto> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/GetClinicFromVeterinary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetClinicFromVeterinary(_response));
        });
    }

    protected processGetClinicFromVeterinary(response: Response): Promise<PaginatedResultsOfVeterinaryClinicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfVeterinaryClinicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfVeterinaryClinicDto>(null as any);
    }

    getAvailableClinicForVeterinary(sObj: AvailableVeterinaryForClinicSearch): Promise<PaginatedResultsOfClinicDto> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/GetAvailableClinicForVeterinary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableClinicForVeterinary(_response));
        });
    }

    protected processGetAvailableClinicForVeterinary(response: Response): Promise<PaginatedResultsOfClinicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfClinicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfClinicDto>(null as any);
    }

    exportXlsFile(sObj: VeterinaryClinicSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/VeterinaryClinic/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IVeterinaryApi {

    baseSearch(sObj: VeterinarySearch): Promise<PaginatedResultsOfVeterinaryGridDto>;

    exportXlsFile(sObj: VeterinarySearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class VeterinaryApi extends BaseAPI implements IVeterinaryApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: VeterinarySearch): Promise<PaginatedResultsOfVeterinaryGridDto> {
        let url_ = this.baseUrl + "/api/Veterinary/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfVeterinaryGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfVeterinaryGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfVeterinaryGridDto>(null as any);
    }

    exportXlsFile(sObj: VeterinarySearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Veterinary/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/Veterinary/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/Veterinary/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IWebUserApi {

    get(personId: number | undefined): Promise<WebUserDto>;

    save(dto: WebUserDto): Promise<number>;

    getDrupalWebUser(personId: number | undefined): Promise<DrupalWebUserDto>;

    isBelgian(webUserId: number | undefined): Promise<ResultOfBoolean>;

    saveDrupalWebUser(toSave: DrupalWebUserDto): Promise<DrupalWebUserDto>;

    getEmail(webUserId: number | undefined): Promise<string>;

    checkEmail(email: string | null | undefined): Promise<ResultOfBoolean>;

    changeEmail(newEmail: string | null | undefined, webUserId: number | undefined): Promise<Result>;

    webUserChangePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined): Promise<Result>;
}

export class WebUserApi extends BaseAPI implements IWebUserApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(personId: number | undefined): Promise<WebUserDto> {
        let url_ = this.baseUrl + "/api/WebUser?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<WebUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebUserDto>(null as any);
    }

    save(dto: WebUserDto): Promise<number> {
        let url_ = this.baseUrl + "/api/WebUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDrupalWebUser(personId: number | undefined): Promise<DrupalWebUserDto> {
        let url_ = this.baseUrl + "/api/WebUser/getDrupalWebUser?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalWebUser(_response));
        });
    }

    protected processGetDrupalWebUser(response: Response): Promise<DrupalWebUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalWebUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalWebUserDto>(null as any);
    }

    isBelgian(webUserId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/WebUser/isWebUserBelgian?";
        if (webUserId === null)
            throw new Error("The parameter 'webUserId' cannot be null.");
        else if (webUserId !== undefined)
            url_ += "webUserId=" + encodeURIComponent("" + webUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsBelgian(_response));
        });
    }

    protected processIsBelgian(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    saveDrupalWebUser(toSave: DrupalWebUserDto): Promise<DrupalWebUserDto> {
        let url_ = this.baseUrl + "/api/WebUser/saveDrupalWebUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDrupalWebUser(_response));
        });
    }

    protected processSaveDrupalWebUser(response: Response): Promise<DrupalWebUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalWebUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalWebUserDto>(null as any);
    }

    getEmail(webUserId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/WebUser/email?";
        if (webUserId === null)
            throw new Error("The parameter 'webUserId' cannot be null.");
        else if (webUserId !== undefined)
            url_ += "webUserId=" + encodeURIComponent("" + webUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmail(_response));
        });
    }

    protected processGetEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    checkEmail(email: string | null | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/WebUser/checkEmailExists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckEmail(_response));
        });
    }

    protected processCheckEmail(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    changeEmail(newEmail: string | null | undefined, webUserId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/WebUser/ChangeEmail?";
        if (newEmail !== undefined && newEmail !== null)
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        if (webUserId === null)
            throw new Error("The parameter 'webUserId' cannot be null.");
        else if (webUserId !== undefined)
            url_ += "webUserId=" + encodeURIComponent("" + webUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeEmail(_response));
        });
    }

    protected processChangeEmail(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    webUserChangePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/WebUser/ChangePassword?";
        if (oldPassword !== undefined && oldPassword !== null)
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword !== undefined && newPassword !== null)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWebUserChangePassword(_response));
        });
    }

    protected processWebUserChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export interface IWorkAttestationRequestApi {

    baseSearch(sObj: WorkAttestRequestSearch): Promise<PaginatedResultsOfWorkAttestRequestGridDto>;

    getWorkAttestationRequest(workAttestationRequestId: number | undefined): Promise<WorkAttestationRequestDto>;

    saveWorkAttestationRequest(dto: WorkAttestationRequestDto): Promise<number>;

    getDisplayName(workAttestationRequestId: number | undefined): Promise<string>;

    getParentRequestId(workAttestationRequestId: number | undefined): Promise<number>;

    isDogAvailable(dogId: number | undefined, workAttestationRequestId: number | undefined): Promise<ResultOfBoolean>;

    closeRequest(requestId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: WorkAttestRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class WorkAttestationRequestApi extends BaseAPI implements IWorkAttestationRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: WorkAttestRequestSearch): Promise<PaginatedResultsOfWorkAttestRequestGridDto> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfWorkAttestRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfWorkAttestRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfWorkAttestRequestGridDto>(null as any);
    }

    getWorkAttestationRequest(workAttestationRequestId: number | undefined): Promise<WorkAttestationRequestDto> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest?";
        if (workAttestationRequestId === null)
            throw new Error("The parameter 'workAttestationRequestId' cannot be null.");
        else if (workAttestationRequestId !== undefined)
            url_ += "workAttestationRequestId=" + encodeURIComponent("" + workAttestationRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkAttestationRequest(_response));
        });
    }

    protected processGetWorkAttestationRequest(response: Response): Promise<WorkAttestationRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkAttestationRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkAttestationRequestDto>(null as any);
    }

    saveWorkAttestationRequest(dto: WorkAttestationRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveWorkAttestationRequest(_response));
        });
    }

    protected processSaveWorkAttestationRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(workAttestationRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/getDisplayName?";
        if (workAttestationRequestId === null)
            throw new Error("The parameter 'workAttestationRequestId' cannot be null.");
        else if (workAttestationRequestId !== undefined)
            url_ += "workAttestationRequestId=" + encodeURIComponent("" + workAttestationRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getParentRequestId(workAttestationRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/getParentRequestId?";
        if (workAttestationRequestId === null)
            throw new Error("The parameter 'workAttestationRequestId' cannot be null.");
        else if (workAttestationRequestId !== undefined)
            url_ += "workAttestationRequestId=" + encodeURIComponent("" + workAttestationRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParentRequestId(_response));
        });
    }

    protected processGetParentRequestId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    isDogAvailable(dogId: number | undefined, workAttestationRequestId: number | undefined): Promise<ResultOfBoolean> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/isDogAvailable?";
        if (dogId === null)
            throw new Error("The parameter 'dogId' cannot be null.");
        else if (dogId !== undefined)
            url_ += "dogId=" + encodeURIComponent("" + dogId) + "&";
        if (workAttestationRequestId === null)
            throw new Error("The parameter 'workAttestationRequestId' cannot be null.");
        else if (workAttestationRequestId !== undefined)
            url_ += "workAttestationRequestId=" + encodeURIComponent("" + workAttestationRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsDogAvailable(_response));
        });
    }

    protected processIsDogAvailable(response: Response): Promise<ResultOfBoolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultOfBoolean.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfBoolean>(null as any);
    }

    closeRequest(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/closeRequest?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCloseRequest(_response));
        });
    }

    protected processCloseRequest(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: WorkAttestRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/WorkAttestationRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IWorkbookApi {

    getWorkbookIconInformation(workbookTypeId: number | undefined): Promise<WorkbookIconDto>;

    reprintWorkbook(workbookId: number | undefined, personId: number | undefined): Promise<Result>;
}

export class WorkbookApi extends BaseAPI implements IWorkbookApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getWorkbookIconInformation(workbookTypeId: number | undefined): Promise<WorkbookIconDto> {
        let url_ = this.baseUrl + "/api/Workbook?";
        if (workbookTypeId === null)
            throw new Error("The parameter 'workbookTypeId' cannot be null.");
        else if (workbookTypeId !== undefined)
            url_ += "workbookTypeId=" + encodeURIComponent("" + workbookTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbookIconInformation(_response));
        });
    }

    protected processGetWorkbookIconInformation(response: Response): Promise<WorkbookIconDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbookIconDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkbookIconDto>(null as any);
    }

    reprintWorkbook(workbookId: number | undefined, personId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Workbook?";
        if (workbookId === null)
            throw new Error("The parameter 'workbookId' cannot be null.");
        else if (workbookId !== undefined)
            url_ += "workbookId=" + encodeURIComponent("" + workbookId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintWorkbook(_response));
        });
    }

    protected processReprintWorkbook(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export interface IWorkbookRequestApi {

    baseSearch(sObj: WorkbookRequestSearch): Promise<PaginatedResultsOfWorkbookRequestGridDto>;

    getWorkbooks(workbookRequestId: number | undefined, sObj: PaginatedSearch): Promise<PaginatedResultsOfWorkbookGridDto>;

    saveRequestFiles(workbookRequestId: number | undefined, files: FileParameter[] | null | undefined): Promise<Result>;

    reprintWorkbook(workbookId: number | undefined, workbookRequestId: number | undefined): Promise<Result>;

    get(workbookRequestId: number | undefined, languageId: number | undefined): Promise<WorkbookRequestDto>;

    save(dto: WorkbookRequestDto): Promise<number>;

    getSubRequest(masterRequestId: number | undefined, languageId: number | undefined): Promise<WorkbookRequestDto>;

    getDrupalWorkbookRequest(workbookRequestId: number | undefined): Promise<DrupalWorkbookRequestDto>;

    saveDrupalWorkbookRequest(toSave: DrupalWorkbookRequestDto): Promise<number>;

    getParentRequestId(workbookRequestId: number | undefined): Promise<number>;

    getDisplayName(workbookRequestId: number | undefined): Promise<string>;

    close(requestId: number | undefined): Promise<Result>;

    exportXlsFile(sObj: WorkbookRequestSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class WorkbookRequestApi extends BaseAPI implements IWorkbookRequestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: WorkbookRequestSearch): Promise<PaginatedResultsOfWorkbookRequestGridDto> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfWorkbookRequestGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfWorkbookRequestGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfWorkbookRequestGridDto>(null as any);
    }

    getWorkbooks(workbookRequestId: number | undefined, sObj: PaginatedSearch): Promise<PaginatedResultsOfWorkbookGridDto> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/getWorkbooks?";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkbooks(_response));
        });
    }

    protected processGetWorkbooks(response: Response): Promise<PaginatedResultsOfWorkbookGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfWorkbookGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfWorkbookGridDto>(null as any);
    }

    saveRequestFiles(workbookRequestId: number | undefined, files: FileParameter[] | null | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/saveRequestFiles?";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRequestFiles(_response));
        });
    }

    protected processSaveRequestFiles(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    reprintWorkbook(workbookId: number | undefined, workbookRequestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/reprintWorkbook?";
        if (workbookId === null)
            throw new Error("The parameter 'workbookId' cannot be null.");
        else if (workbookId !== undefined)
            url_ += "workbookId=" + encodeURIComponent("" + workbookId) + "&";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReprintWorkbook(_response));
        });
    }

    protected processReprintWorkbook(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    get(workbookRequestId: number | undefined, languageId: number | undefined): Promise<WorkbookRequestDto> {
        let url_ = this.baseUrl + "/api/WorkbookRequest?";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<WorkbookRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbookRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkbookRequestDto>(null as any);
    }

    save(dto: WorkbookRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkbookRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSubRequest(masterRequestId: number | undefined, languageId: number | undefined): Promise<WorkbookRequestDto> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/getSubRequest?";
        if (masterRequestId === null)
            throw new Error("The parameter 'masterRequestId' cannot be null.");
        else if (masterRequestId !== undefined)
            url_ += "masterRequestId=" + encodeURIComponent("" + masterRequestId) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubRequest(_response));
        });
    }

    protected processGetSubRequest(response: Response): Promise<WorkbookRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbookRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkbookRequestDto>(null as any);
    }

    getDrupalWorkbookRequest(workbookRequestId: number | undefined): Promise<DrupalWorkbookRequestDto> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/getDrupalWorkbookRequest?";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDrupalWorkbookRequest(_response));
        });
    }

    protected processGetDrupalWorkbookRequest(response: Response): Promise<DrupalWorkbookRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrupalWorkbookRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrupalWorkbookRequestDto>(null as any);
    }

    saveDrupalWorkbookRequest(toSave: DrupalWorkbookRequestDto): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/saveDrupalWorkbookRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(toSave);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDrupalWorkbookRequest(_response));
        });
    }

    protected processSaveDrupalWorkbookRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getParentRequestId(workbookRequestId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/GetParentRequestId?";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParentRequestId(_response));
        });
    }

    protected processGetParentRequestId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDisplayName(workbookRequestId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/getDisplayName?";
        if (workbookRequestId === null)
            throw new Error("The parameter 'workbookRequestId' cannot be null.");
        else if (workbookRequestId !== undefined)
            url_ += "workbookRequestId=" + encodeURIComponent("" + workbookRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    close(requestId: number | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/close?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClose(_response));
        });
    }

    protected processClose(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    exportXlsFile(sObj: WorkbookRequestSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/WorkbookRequest/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IWorkbookTypeApi {

    baseSearch(sObj: WorkbookTypeSearch): Promise<PaginatedResultsOfWorkbookTypeGridDto>;

    get(id: number | undefined): Promise<WorkbookTypeDto>;

    save(dto: WorkbookTypeDto): Promise<number>;

    delete(id: number | undefined): Promise<boolean>;

    isWorkbookTypeUnique(colorId: number | undefined, hasPedigree: boolean | undefined, workbookTypeId: number | undefined): Promise<BooleanDto>;

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string>;

    getAllWorkbookTypes(languageId: number | undefined): Promise<WorkbookTypeGridDto[]>;

    exportXlsFile(sObj: WorkbookTypeSearch): Promise<FileResponse>;

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]>;

    getSelectItems(searchField: string | null): Promise<SelectItem[]>;
}

export class WorkbookTypeApi extends BaseAPI implements IWorkbookTypeApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    baseSearch(sObj: WorkbookTypeSearch): Promise<PaginatedResultsOfWorkbookTypeGridDto> {
        let url_ = this.baseUrl + "/api/WorkbookType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBaseSearch(_response));
        });
    }

    protected processBaseSearch(response: Response): Promise<PaginatedResultsOfWorkbookTypeGridDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultsOfWorkbookTypeGridDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedResultsOfWorkbookTypeGridDto>(null as any);
    }

    get(id: number | undefined): Promise<WorkbookTypeDto> {
        let url_ = this.baseUrl + "/api/WorkbookType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<WorkbookTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkbookTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkbookTypeDto>(null as any);
    }

    save(dto: WorkbookTypeDto): Promise<number> {
        let url_ = this.baseUrl + "/api/WorkbookType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/WorkbookType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isWorkbookTypeUnique(colorId: number | undefined, hasPedigree: boolean | undefined, workbookTypeId: number | undefined): Promise<BooleanDto> {
        let url_ = this.baseUrl + "/api/WorkbookType/IsWorkbookTypeUnique?";
        if (colorId === null)
            throw new Error("The parameter 'colorId' cannot be null.");
        else if (colorId !== undefined)
            url_ += "colorId=" + encodeURIComponent("" + colorId) + "&";
        if (hasPedigree === null)
            throw new Error("The parameter 'hasPedigree' cannot be null.");
        else if (hasPedigree !== undefined)
            url_ += "hasPedigree=" + encodeURIComponent("" + hasPedigree) + "&";
        if (workbookTypeId === null)
            throw new Error("The parameter 'workbookTypeId' cannot be null.");
        else if (workbookTypeId !== undefined)
            url_ += "workbookTypeId=" + encodeURIComponent("" + workbookTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsWorkbookTypeUnique(_response));
        });
    }

    protected processIsWorkbookTypeUnique(response: Response): Promise<BooleanDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanDto>(null as any);
    }

    getDisplayName(id: number | undefined, languageId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/WorkbookType/DisplayName?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDisplayName(_response));
        });
    }

    protected processGetDisplayName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAllWorkbookTypes(languageId: number | undefined): Promise<WorkbookTypeGridDto[]> {
        let url_ = this.baseUrl + "/api/WorkbookType/allWorkbookTypes?";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllWorkbookTypes(_response));
        });
    }

    protected processGetAllWorkbookTypes(response: Response): Promise<WorkbookTypeGridDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkbookTypeGridDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkbookTypeGridDto[]>(null as any);
    }

    exportXlsFile(sObj: WorkbookTypeSearch): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/WorkbookType/export-xls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sObj);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportXlsFile(_response));
        });
    }

    protected processExportXlsFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSearchCriterias(includeListsValues: boolean | undefined): Promise<FilterCriteriaInfo[]> {
        let url_ = this.baseUrl + "/api/WorkbookType/criterias?";
        if (includeListsValues === null)
            throw new Error("The parameter 'includeListsValues' cannot be null.");
        else if (includeListsValues !== undefined)
            url_ += "includeListsValues=" + encodeURIComponent("" + includeListsValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSearchCriterias(_response));
        });
    }

    protected processGetSearchCriterias(response: Response): Promise<FilterCriteriaInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCriteriaInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterCriteriaInfo[]>(null as any);
    }

    getSelectItems(searchField: string | null): Promise<SelectItem[]> {
        let url_ = this.baseUrl + "/api/WorkbookType/criteriaList/{searchField}";
        if (searchField === undefined || searchField === null)
            throw new Error("The parameter 'searchField' must be defined.");
        url_ = url_.replace("{searchField}", encodeURIComponent("" + searchField));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSelectItems(_response));
        });
    }

    protected processGetSelectItems(response: Response): Promise<SelectItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectItem[]>(null as any);
    }
}

export interface IZoolyxAuthentificationApi {

    authenticate(auth: ZoolyxAuthenticateCommand): Promise<string>;
}

export class ZoolyxAuthentificationApi extends BaseAPI implements IZoolyxAuthentificationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    authenticate(auth: ZoolyxAuthenticateCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/ZoolyxAuthentification/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auth);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthenticate(_response));
        });
    }

    protected processAuthenticate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IZoolyxNotificationApi {

    notify(): Promise<Result>;
}

export class ZoolyxNotificationApi extends BaseAPI implements IZoolyxNotificationApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    notify(): Promise<Result> {
        let url_ = this.baseUrl + "/api/ZoolyxNotification/notify";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotify(_response));
        });
    }

    protected processNotify(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export interface ISystemTestApi {

    post(data: TestDateDto): Promise<TestDateDto>;

    get(): Promise<TestDateDto>;
}

export class SystemTestApi extends BaseAPI implements ISystemTestApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    post(data: TestDateDto): Promise<TestDateDto> {
        let url_ = this.baseUrl + "/api/SystemTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<TestDateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestDateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestDateDto>(null as any);
    }

    get(): Promise<TestDateDto> {
        let url_ = this.baseUrl + "/api/SystemTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TestDateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestDateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestDateDto>(null as any);
    }
}

export interface IHealthCheckApi {

    getHealthCheck(): Promise<HealthCheckViewModel>;

    getStartupHealthCheck(): Promise<HealthCheckViewModel>;

    getReadyHealthCheck(): Promise<HealthCheckViewModel>;

    getLiveHealthCheck(): Promise<HealthCheckViewModel>;
}

export class HealthCheckApi extends BaseAPI implements IHealthCheckApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealthCheck(_response));
        });
    }

    protected processGetHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getStartupHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/startup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStartupHealthCheck(_response));
        });
    }

    protected processGetStartupHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getReadyHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/ready";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReadyHealthCheck(_response));
        });
    }

    protected processGetReadyHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }

    getLiveHealthCheck(): Promise<HealthCheckViewModel> {
        let url_ = this.baseUrl + "/monitoring/_hc/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLiveHealthCheck(_response));
        });
    }

    protected processGetLiveHealthCheck(response: Response): Promise<HealthCheckViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCheckViewModel>(null as any);
    }
}

export interface IApiKeyApi {

    getApiKey(clientName: string | null | undefined): Promise<ClientApiKey>;
}

export class ApiKeyApi extends BaseAPI implements IApiKeyApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Configuration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getApiKey(clientName: string | null | undefined): Promise<ClientApiKey> {
        let url_ = this.baseUrl + "/apikey?";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiKey(_response));
        });
    }

    protected processGetApiKey(response: Response): Promise<ClientApiKey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientApiKey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientApiKey>(null as any);
    }
}

export class PaginatedResultsOfActivityGridDto implements IPaginatedResultsOfActivityGridDto {
    totalCount?: number;
    results?: ActivityGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfActivityGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActivityGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfActivityGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfActivityGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfActivityGridDto {
    totalCount?: number;
    results?: ActivityGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ActivityGridDto implements IActivityGridDto {
    activityId?: number;
    section?: string | undefined;
    sectionId?: number;
    name?: string | undefined;

    constructor(data?: IActivityGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.section = _data["section"];
            this.sectionId = _data["sectionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["section"] = this.section;
        data["sectionId"] = this.sectionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IActivityGridDto {
    activityId?: number;
    section?: string | undefined;
    sectionId?: number;
    name?: string | undefined;
}

export abstract class IAggregateResult implements IIAggregateResult {
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;

    constructor(data?: IIAggregateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IAggregateResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IAggregateResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }
}

export interface IIAggregateResult {
    key?: string | undefined;
    text?: string | undefined;
    value?: number | undefined;
}

export class FilterSearch implements IFilterSearch {
    filter?: string | undefined;

    constructor(data?: IFilterSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FilterSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FilterSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFilterSearch {
    filter?: string | undefined;
}

export class PaginatedSearch extends FilterSearch implements IPaginatedSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;

    constructor(data?: IPaginatedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sortKey"])) {
                this.sortKey = [] as any;
                for (let item of _data["sortKey"])
                    this.sortKey!.push(item);
            }
            if (Array.isArray(_data["aggregateKeys"])) {
                this.aggregateKeys = [] as any;
                for (let item of _data["aggregateKeys"])
                    this.aggregateKeys!.push(AggregateKeyInfo.fromJS(item));
            }
            this.forceSkip = _data["forceSkip"];
            this.forceTake = _data["forceTake"];
            this.parameters = _data["parameters"];
        }
    }

    static fromJS(data: any): PaginatedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortKey)) {
            data["sortKey"] = [];
            for (let item of this.sortKey)
                data["sortKey"].push(item);
        }
        if (Array.isArray(this.aggregateKeys)) {
            data["aggregateKeys"] = [];
            for (let item of this.aggregateKeys)
                data["aggregateKeys"].push(item.toJSON());
        }
        data["forceSkip"] = this.forceSkip;
        data["forceTake"] = this.forceTake;
        data["parameters"] = this.parameters;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedSearch extends IFilterSearch {
    sortKey?: string[] | undefined;
    aggregateKeys?: AggregateKeyInfo[] | undefined;
    forceSkip?: number | undefined;
    forceTake?: number | undefined;
    parameters?: any | undefined;
}

export class ActivitySearch extends PaginatedSearch implements IActivitySearch {
    languageId?: number;
    name?: TextSearch | undefined;
    section?: TextSearch | undefined;

    constructor(data?: IActivitySearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.section = _data["section"] ? TextSearch.fromJS(_data["section"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivitySearch {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IActivitySearch extends IPaginatedSearch {
    languageId?: number;
    name?: TextSearch | undefined;
    section?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfETextSearchTypeAndString implements IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfETextSearchTypeAndString.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfETextSearchTypeAndString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfETextSearchTypeAndString {
    criterias?: CombinableCriteriaOfETextSearchTypeAndString[] | undefined;
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class TextSearch extends FilterCriteriaBaseOfETextSearchTypeAndString implements ITextSearch {

    constructor(data?: ITextSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TextSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TextSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITextSearch extends IFilterCriteriaBaseOfETextSearchTypeAndString {
}

export class CombinableCriteriaOfETextSearchTypeAndString implements ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;

    constructor(data?: ICombinableCriteriaOfETextSearchTypeAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfETextSearchTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfETextSearchTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfETextSearchTypeAndString {
    searchMode?: ETextSearchType;
    value?: string | undefined;
    secondaryValue?: string | undefined;
}

export enum ETextSearchType {
    StartWith = "StartWith",
    EndWith = "EndWith",
    Contains = "Contains",
    NotContains = "NotContains",
    Equals = "Equals",
    NotEquals = "NotEquals",
}

export class AggregateKeyInfo implements IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;

    constructor(data?: IAggregateKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.aggregateType = _data["aggregateType"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AggregateKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["aggregateType"] = this.aggregateType;
        data["text"] = this.text;
        return data;
    }
}

export interface IAggregateKeyInfo {
    key?: string | undefined;
    aggregateType?: EAggregateType;
    text?: string | undefined;
}

export enum EAggregateType {
    Sum = "Sum",
    Avg = "Avg",
    Min = "Min",
    Max = "Max",
}

export class ActivityDto implements IActivityDto {
    activityId?: number;
    sectionId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    activityTranslations?: ActivityTranslationDto[] | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.sectionId = _data["sectionId"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            if (Array.isArray(_data["activityTranslations"])) {
                this.activityTranslations = [] as any;
                for (let item of _data["activityTranslations"])
                    this.activityTranslations!.push(ActivityTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["sectionId"] = this.sectionId;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        if (Array.isArray(this.activityTranslations)) {
            data["activityTranslations"] = [];
            for (let item of this.activityTranslations)
                data["activityTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityDto {
    activityId?: number;
    sectionId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    activityTranslations?: ActivityTranslationDto[] | undefined;
}

export class ActivityTranslationDto implements IActivityTranslationDto {
    languageId?: number;
    activityId?: number;
    text?: string | undefined;
    activityTranslationId?: number;

    constructor(data?: IActivityTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.activityId = _data["activityId"];
            this.text = _data["text"];
            this.activityTranslationId = _data["activityTranslationId"];
        }
    }

    static fromJS(data: any): ActivityTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["activityId"] = this.activityId;
        data["text"] = this.text;
        data["activityTranslationId"] = this.activityTranslationId;
        return data;
    }
}

export interface IActivityTranslationDto {
    languageId?: number;
    activityId?: number;
    text?: string | undefined;
    activityTranslationId?: number;
}

export class FilterCriteriaInfo implements IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;

    constructor(data?: IFilterCriteriaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criteria = _data["criteria"];
            this.type = _data["type"];
            if (Array.isArray(_data["searchModes"])) {
                this.searchModes = [] as any;
                for (let item of _data["searchModes"])
                    this.searchModes!.push(item);
            }
            this.defaultSearchMode = _data["defaultSearchMode"];
            if (Array.isArray(_data["listValues"])) {
                this.listValues = [] as any;
                for (let item of _data["listValues"])
                    this.listValues!.push(SelectItem.fromJS(item));
            }
            this.isMultipleOr = _data["isMultipleOr"];
        }
    }

    static fromJS(data: any): FilterCriteriaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCriteriaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria;
        data["type"] = this.type;
        if (Array.isArray(this.searchModes)) {
            data["searchModes"] = [];
            for (let item of this.searchModes)
                data["searchModes"].push(item);
        }
        data["defaultSearchMode"] = this.defaultSearchMode;
        if (Array.isArray(this.listValues)) {
            data["listValues"] = [];
            for (let item of this.listValues)
                data["listValues"].push(item.toJSON());
        }
        data["isMultipleOr"] = this.isMultipleOr;
        return data;
    }
}

export interface IFilterCriteriaInfo {
    criteria?: string | undefined;
    type?: ECriteriaType;
    searchModes?: string[] | undefined;
    defaultSearchMode?: string | undefined;
    listValues?: SelectItem[] | undefined;
    isMultipleOr?: boolean;
}

export enum ECriteriaType {
    Text = "Text",
    List = "List",
    Date = "Date",
    Boolean = "Boolean",
    Numeric = "Numeric",
    Float = "Float",
}

export class SelectItem implements ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idValue = _data["idValue"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idValue"] = this.idValue;
        data["displayValue"] = this.displayValue;
        return data;
    }
}

export interface ISelectItem {
    idValue?: string | undefined;
    displayValue?: string | undefined;
}

export class PaginatedResultsOfAffixGridDto implements IPaginatedResultsOfAffixGridDto {
    totalCount?: number;
    results?: AffixGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAffixGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AffixGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAffixGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAffixGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfAffixGridDto {
    totalCount?: number;
    results?: AffixGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class AffixGridDto implements IAffixGridDto {
    attributionDate?: Date | undefined;
    name?: string | undefined;

    constructor(data?: IAffixGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AffixGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffixGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IAffixGridDto {
    attributionDate?: Date | undefined;
    name?: string | undefined;
}

export class DrupalAffixSearch extends PaginatedSearch implements IDrupalAffixSearch {
    attributionDate?: DateSearch | undefined;
    name?: TextSearch | undefined;

    constructor(data?: IDrupalAffixSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attributionDate = _data["attributionDate"] ? DateSearch.fromJS(_data["attributionDate"]) : <any>undefined;
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DrupalAffixSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalAffixSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toJSON() : <any>undefined;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDrupalAffixSearch extends IPaginatedSearch {
    attributionDate?: DateSearch | undefined;
    name?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime implements IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime {
    criterias?: CombinableCriteriaOfEDateSearchTypeAndNullableDateTime[] | undefined;
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEDateSearchTypeAndNullableDateTime.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.secondaryValue = _data["secondaryValue"] ? new Date(_data["secondaryValue"].toString()) : <any>undefined;
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["secondaryValue"] = this.secondaryValue ? this.secondaryValue.toISOString() : <any>undefined;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime {
    criterias?: CombinableCriteriaOfEDateSearchTypeAndNullableDateTime[] | undefined;
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class DateSearch extends FilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime implements IDateSearch {

    constructor(data?: IDateSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DateSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DateSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDateSearch extends IFilterCriteriaBaseOfEDateSearchTypeAndNullableDateTime {
}

export class CombinableCriteriaOfEDateSearchTypeAndNullableDateTime implements ICombinableCriteriaOfEDateSearchTypeAndNullableDateTime {
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;

    constructor(data?: ICombinableCriteriaOfEDateSearchTypeAndNullableDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.secondaryValue = _data["secondaryValue"] ? new Date(_data["secondaryValue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEDateSearchTypeAndNullableDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEDateSearchTypeAndNullableDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["secondaryValue"] = this.secondaryValue ? this.secondaryValue.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICombinableCriteriaOfEDateSearchTypeAndNullableDateTime {
    searchMode?: EDateSearchType;
    value?: Date | undefined;
    secondaryValue?: Date | undefined;
}

export enum EDateSearchType {
    Between = "Between",
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    LessThan = "LessThan",
}

export class PaginatedResultsOfAffixRequestGridDto implements IPaginatedResultsOfAffixRequestGridDto {
    totalCount?: number;
    results?: AffixRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAffixRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AffixRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAffixRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAffixRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfAffixRequestGridDto {
    totalCount?: number;
    results?: AffixRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class AffixRequestGridDto implements IAffixRequestGridDto {
    requestId?: number;
    requestTypeId?: number;
    requestType?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestStateId?: number;
    requestState?: string | undefined;
    requestStateCode?: ERequestState;
    requestTypeCode?: ERequestType;
    contact?: string | undefined;
    personId?: number;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IAffixRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestType = _data["requestType"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.contact = _data["contact"];
            this.personId = _data["personId"];
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): AffixRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffixRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestType"] = this.requestType;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["requestStateCode"] = this.requestStateCode;
        data["requestTypeCode"] = this.requestTypeCode;
        data["contact"] = this.contact;
        data["personId"] = this.personId;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IAffixRequestGridDto {
    requestId?: number;
    requestTypeId?: number;
    requestType?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestStateId?: number;
    requestState?: string | undefined;
    requestStateCode?: ERequestState;
    requestTypeCode?: ERequestType;
    contact?: string | undefined;
    personId?: number;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export enum ERequestState {
    REQUESTED = "REQUESTED",
    BILLED = "BILLED",
    PAID = "PAID",
    EXECUTED = "EXECUTED",
    CANCELLED = "CANCELLED",
    TO_EVALUATE = "TO_EVALUATE",
    EVALUATED = "EVALUATED",
    AUTHORIZED = "AUTHORIZED",
    TO_EVALUATE_FCI = "TO_EVALUATE_FCI",
    AWAITING_APPLICANT_REACTION = "AWAITING_APPLICANT_REACTION",
    REFUSED_BY_FCI = "REFUSED_BY_FCI",
    JUDGE_VALIDATION = "JUDGE_VALIDATION",
    DOG_VALIDATION = "DOG_VALIDATION",
    GESTATION = "GESTATION",
    LAB_WORK = "LAB_WORK",
    LAB_RESULTS_RECEIVED = "LAB_RESULTS_RECEIVED",
    EXECUTED_AWAITING_DOCUMENTS = "EXECUTED_AWAITING_DOCUMENTS",
    AC_DECISION = "AC_DECISION",
    BEING_PROCESSED = "BEING_PROCESSED",
    PAYMENT_PROCESS = "PAYMENT_PROCESS",
    AWAITING_DECISION = "AWAITING_DECISION",
    AWAITING_CATALOG = "AWAITING_CATALOG",
    PUPPIES_COMPLETE = "PUPPIES_COMPLETE",
    PAYMENT_REFUSED = "PAYMENT_REFUSED",
    READY_FOR_CONFIGURATION = "READY_FOR_CONFIGURATION",
    CATALOG_JUDGE_VALIDATION = "CATALOG_JUDGE_VALIDATION",
    REFUSED = "REFUSED",
}

export enum ERequestType {
    WorkAttestRequest = "WorkAttestRequest",
    WorkbookRequest = "WorkbookRequest",
    DogOwnershipChangeRequest = "DogOwnershipChangeRequest",
    NewKennelRequest = "NewKennelRequest",
    KennelOwnershipChangeRequest = "KennelOwnershipChangeRequest",
    KennelImportRequest = "KennelImportRequest",
    KennelExportRequest = "KennelExportRequest",
    KennelNameChangeRequest = "KennelNameChangeRequest",
    DogTempOwnershipChangeRequest = "DogTempOwnershipChangeRequest",
    CompetitionRequest = "CompetitionRequest",
    PedigreeRequest = "PedigreeRequest",
    PedigreeDuplicataRequest = "PedigreeDuplicataRequest",
    DysplasiaRequest = "DysplasiaRequest",
    ImportRequest = "ImportRequest",
    BroodRequest = "BroodRequest",
    HealthTestRequest = "HealthTestRequest",
    TitleRequest = "TitleRequest",
    MembershipRequest = "MembershipRequest",
    MiscellaneousRequest = "MiscellaneousRequest",
    ExpatriationRequest = "ExpatriationRequest",
}

export class AffixRequestSearch extends PaginatedSearch implements IAffixRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IAffixRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.requestTypeId = _data["requestTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["requestTypeId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AffixRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new AffixRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["requestTypeId"] = this.requestTypeId ? this.requestTypeId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAffixRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableInteger implements IFilterCriteriaBaseOfEListSearchTypeAndNullableInteger {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableInteger[] | undefined;
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableInteger.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableInteger {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableInteger[] | undefined;
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfNullableInteger extends FilterCriteriaBaseOfEListSearchTypeAndNullableInteger implements IListSearchOfNullableInteger {

    constructor(data?: IListSearchOfNullableInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfNullableInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfNullableInteger extends IFilterCriteriaBaseOfEListSearchTypeAndNullableInteger {
}

export class CombinableCriteriaOfEListSearchTypeAndNullableInteger implements ICombinableCriteriaOfEListSearchTypeAndNullableInteger {
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableInteger {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableInteger {
    searchMode?: EListSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
}

export enum EListSearchType {
    Equals = "Equals",
    NotEquals = "NotEquals",
    NestedDefault = "NestedDefault",
}

export abstract class FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean implements IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
    criterias?: CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean[] | undefined;
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
    criterias?: CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean[] | undefined;
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class BooleanSearch extends FilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean implements IBooleanSearch {

    constructor(data?: IBooleanSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BooleanSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanSearch extends IFilterCriteriaBaseOfEBooleanSearchTypesAndNullableBoolean {
}

export class CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean implements ICombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;

    constructor(data?: ICombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEBooleanSearchTypesAndNullableBoolean {
    searchMode?: EBooleanSearchTypes;
    value?: boolean | undefined;
    secondaryValue?: boolean | undefined;
}

export enum EBooleanSearchTypes {
    Equals = "Equals",
    NotEquals = "NotEquals",
}

export class NewKennelRequestDto implements INewKennelRequestDto {
    newKennelRequestId?: number;
    requestId?: number;
    request?: RequestDto | undefined;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    nameOffer2?: string | undefined;
    nameOffer2Type?: EKennelType;
    nameOffer3?: string | undefined;
    nameOffer3Type?: EKennelType;
    nameOffer4?: string | undefined;
    nameOffer4Type?: EKennelType;
    nameOffer5?: string | undefined;
    nameOffer5Type?: EKennelType;
    transientOwnerIds?: number[] | undefined;
    transientBreedIds?: number[] | undefined;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;

    constructor(data?: INewKennelRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newKennelRequestId = _data["newKennelRequestId"];
            this.requestId = _data["requestId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.nameOffer1 = _data["nameOffer1"];
            this.nameOffer1Type = _data["nameOffer1Type"];
            this.nameOffer2 = _data["nameOffer2"];
            this.nameOffer2Type = _data["nameOffer2Type"];
            this.nameOffer3 = _data["nameOffer3"];
            this.nameOffer3Type = _data["nameOffer3Type"];
            this.nameOffer4 = _data["nameOffer4"];
            this.nameOffer4Type = _data["nameOffer4Type"];
            this.nameOffer5 = _data["nameOffer5"];
            this.nameOffer5Type = _data["nameOffer5Type"];
            if (Array.isArray(_data["transientOwnerIds"])) {
                this.transientOwnerIds = [] as any;
                for (let item of _data["transientOwnerIds"])
                    this.transientOwnerIds!.push(item);
            }
            if (Array.isArray(_data["transientBreedIds"])) {
                this.transientBreedIds = [] as any;
                for (let item of _data["transientBreedIds"])
                    this.transientBreedIds!.push(item);
            }
            this.finalName = _data["finalName"];
            this.finalType = _data["finalType"];
            this.fciNumber = _data["fciNumber"];
        }
    }

    static fromJS(data: any): NewKennelRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewKennelRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newKennelRequestId"] = this.newKennelRequestId;
        data["requestId"] = this.requestId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["nameOffer1"] = this.nameOffer1;
        data["nameOffer1Type"] = this.nameOffer1Type;
        data["nameOffer2"] = this.nameOffer2;
        data["nameOffer2Type"] = this.nameOffer2Type;
        data["nameOffer3"] = this.nameOffer3;
        data["nameOffer3Type"] = this.nameOffer3Type;
        data["nameOffer4"] = this.nameOffer4;
        data["nameOffer4Type"] = this.nameOffer4Type;
        data["nameOffer5"] = this.nameOffer5;
        data["nameOffer5Type"] = this.nameOffer5Type;
        if (Array.isArray(this.transientOwnerIds)) {
            data["transientOwnerIds"] = [];
            for (let item of this.transientOwnerIds)
                data["transientOwnerIds"].push(item);
        }
        if (Array.isArray(this.transientBreedIds)) {
            data["transientBreedIds"] = [];
            for (let item of this.transientBreedIds)
                data["transientBreedIds"].push(item);
        }
        data["finalName"] = this.finalName;
        data["finalType"] = this.finalType;
        data["fciNumber"] = this.fciNumber;
        return data;
    }
}

export interface INewKennelRequestDto {
    newKennelRequestId?: number;
    requestId?: number;
    request?: RequestDto | undefined;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    nameOffer2?: string | undefined;
    nameOffer2Type?: EKennelType;
    nameOffer3?: string | undefined;
    nameOffer3Type?: EKennelType;
    nameOffer4?: string | undefined;
    nameOffer4Type?: EKennelType;
    nameOffer5?: string | undefined;
    nameOffer5Type?: EKennelType;
    transientOwnerIds?: number[] | undefined;
    transientBreedIds?: number[] | undefined;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
}

export class RequestDto implements IRequestDto {
    requestId?: number;
    billRemark?: string | undefined;
    billPrestationDate?: string | undefined;
    platform?: EPlatform | undefined;
    managerId?: number | undefined;
    requestTypeId?: number;
    parentRequestId?: number | undefined;
    requestStateId?: number;
    status?: ERequestState;
    type?: ERequestType;
    personId?: number;
    personEmail?: string | undefined;
    personComputedName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    sharepointUri?: string | undefined;
    isOnline?: boolean;
    remark?: string | undefined;
    isBlocked?: boolean;
    executionDate?: Date | undefined;
    manager?: string | undefined;
    personBcIdentifier?: string | undefined;
    lastStatusChangeDate?: Date | undefined;

    constructor(data?: IRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.billRemark = _data["billRemark"];
            this.billPrestationDate = _data["billPrestationDate"];
            this.platform = _data["platform"];
            this.managerId = _data["managerId"];
            this.requestTypeId = _data["requestTypeId"];
            this.parentRequestId = _data["parentRequestId"];
            this.requestStateId = _data["requestStateId"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.personId = _data["personId"];
            this.personEmail = _data["personEmail"];
            this.personComputedName = _data["personComputedName"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.sharepointUri = _data["sharepointUri"];
            this.isOnline = _data["isOnline"];
            this.remark = _data["remark"];
            this.isBlocked = _data["isBlocked"];
            this.executionDate = _data["executionDate"] ? new Date(_data["executionDate"].toString()) : <any>undefined;
            this.manager = _data["manager"];
            this.personBcIdentifier = _data["personBcIdentifier"];
            this.lastStatusChangeDate = _data["lastStatusChangeDate"] ? new Date(_data["lastStatusChangeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["billRemark"] = this.billRemark;
        data["billPrestationDate"] = this.billPrestationDate;
        data["platform"] = this.platform;
        data["managerId"] = this.managerId;
        data["requestTypeId"] = this.requestTypeId;
        data["parentRequestId"] = this.parentRequestId;
        data["requestStateId"] = this.requestStateId;
        data["status"] = this.status;
        data["type"] = this.type;
        data["personId"] = this.personId;
        data["personEmail"] = this.personEmail;
        data["personComputedName"] = this.personComputedName;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["sharepointUri"] = this.sharepointUri;
        data["isOnline"] = this.isOnline;
        data["remark"] = this.remark;
        data["isBlocked"] = this.isBlocked;
        data["executionDate"] = this.executionDate ? this.executionDate.toISOString() : <any>undefined;
        data["manager"] = this.manager;
        data["personBcIdentifier"] = this.personBcIdentifier;
        data["lastStatusChangeDate"] = this.lastStatusChangeDate ? this.lastStatusChangeDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRequestDto {
    requestId?: number;
    billRemark?: string | undefined;
    billPrestationDate?: string | undefined;
    platform?: EPlatform | undefined;
    managerId?: number | undefined;
    requestTypeId?: number;
    parentRequestId?: number | undefined;
    requestStateId?: number;
    status?: ERequestState;
    type?: ERequestType;
    personId?: number;
    personEmail?: string | undefined;
    personComputedName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    sharepointUri?: string | undefined;
    isOnline?: boolean;
    remark?: string | undefined;
    isBlocked?: boolean;
    executionDate?: Date | undefined;
    manager?: string | undefined;
    personBcIdentifier?: string | undefined;
    lastStatusChangeDate?: Date | undefined;
}

export enum EPlatform {
    CARE4DOGS = "CARE4DOGS",
    PORTAL = "PORTAL",
    MYDOGEVENT = "MYDOGEVENT",
}

export enum EKennelType {
    Suffix = "Suffix",
    Prefix = "Prefix",
}

export class KennelNameChangeRequestDto implements IKennelNameChangeRequestDto {
    kennelNameChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    request?: RequestDto | undefined;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    nameOffer2?: string | undefined;
    nameOffer2Type?: EKennelType;
    nameOffer3?: string | undefined;
    nameOffer3Type?: EKennelType;
    nameOffer4?: string | undefined;
    nameOffer4Type?: EKennelType;
    nameOffer5?: string | undefined;
    nameOffer5Type?: EKennelType;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    newKennelId?: number;

    constructor(data?: IKennelNameChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelNameChangeRequestId = _data["kennelNameChangeRequestId"];
            this.requestId = _data["requestId"];
            this.kennelId = _data["kennelId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.nameOffer1 = _data["nameOffer1"];
            this.nameOffer1Type = _data["nameOffer1Type"];
            this.nameOffer2 = _data["nameOffer2"];
            this.nameOffer2Type = _data["nameOffer2Type"];
            this.nameOffer3 = _data["nameOffer3"];
            this.nameOffer3Type = _data["nameOffer3Type"];
            this.nameOffer4 = _data["nameOffer4"];
            this.nameOffer4Type = _data["nameOffer4Type"];
            this.nameOffer5 = _data["nameOffer5"];
            this.nameOffer5Type = _data["nameOffer5Type"];
            this.finalName = _data["finalName"];
            this.finalType = _data["finalType"];
            this.fciNumber = _data["fciNumber"];
            this.newKennelId = _data["newKennelId"];
        }
    }

    static fromJS(data: any): KennelNameChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelNameChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelNameChangeRequestId"] = this.kennelNameChangeRequestId;
        data["requestId"] = this.requestId;
        data["kennelId"] = this.kennelId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["nameOffer1"] = this.nameOffer1;
        data["nameOffer1Type"] = this.nameOffer1Type;
        data["nameOffer2"] = this.nameOffer2;
        data["nameOffer2Type"] = this.nameOffer2Type;
        data["nameOffer3"] = this.nameOffer3;
        data["nameOffer3Type"] = this.nameOffer3Type;
        data["nameOffer4"] = this.nameOffer4;
        data["nameOffer4Type"] = this.nameOffer4Type;
        data["nameOffer5"] = this.nameOffer5;
        data["nameOffer5Type"] = this.nameOffer5Type;
        data["finalName"] = this.finalName;
        data["finalType"] = this.finalType;
        data["fciNumber"] = this.fciNumber;
        data["newKennelId"] = this.newKennelId;
        return data;
    }
}

export interface IKennelNameChangeRequestDto {
    kennelNameChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    request?: RequestDto | undefined;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    nameOffer2?: string | undefined;
    nameOffer2Type?: EKennelType;
    nameOffer3?: string | undefined;
    nameOffer3Type?: EKennelType;
    nameOffer4?: string | undefined;
    nameOffer4Type?: EKennelType;
    nameOffer5?: string | undefined;
    nameOffer5Type?: EKennelType;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    newKennelId?: number;
}

export class Result implements IResult {
    isFailure?: boolean;
    isSuccess?: boolean;
    error?: string | undefined;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFailure = _data["IsFailure"];
            this.isSuccess = _data["IsSuccess"];
            this.error = _data["Error"];
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsFailure"] = this.isFailure;
        data["IsSuccess"] = this.isSuccess;
        data["Error"] = this.error;
        return data;
    }
}

export interface IResult {
    isFailure?: boolean;
    isSuccess?: boolean;
    error?: string | undefined;
}

export class KennelImportRequestDto implements IKennelImportRequestDto {
    kennelImportRequestId?: number;
    requestId?: number;
    request?: RequestDto | undefined;
    countryId?: number;
    nameOffer?: string | undefined;
    nameOfferType?: EKennelType;
    transientOwnerIds?: number[] | undefined;
    transientBreedIds?: number[] | undefined;
    fciNumber?: string | undefined;

    constructor(data?: IKennelImportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelImportRequestId = _data["kennelImportRequestId"];
            this.requestId = _data["requestId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.nameOffer = _data["nameOffer"];
            this.nameOfferType = _data["nameOfferType"];
            if (Array.isArray(_data["transientOwnerIds"])) {
                this.transientOwnerIds = [] as any;
                for (let item of _data["transientOwnerIds"])
                    this.transientOwnerIds!.push(item);
            }
            if (Array.isArray(_data["transientBreedIds"])) {
                this.transientBreedIds = [] as any;
                for (let item of _data["transientBreedIds"])
                    this.transientBreedIds!.push(item);
            }
            this.fciNumber = _data["fciNumber"];
        }
    }

    static fromJS(data: any): KennelImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelImportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelImportRequestId"] = this.kennelImportRequestId;
        data["requestId"] = this.requestId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["nameOffer"] = this.nameOffer;
        data["nameOfferType"] = this.nameOfferType;
        if (Array.isArray(this.transientOwnerIds)) {
            data["transientOwnerIds"] = [];
            for (let item of this.transientOwnerIds)
                data["transientOwnerIds"].push(item);
        }
        if (Array.isArray(this.transientBreedIds)) {
            data["transientBreedIds"] = [];
            for (let item of this.transientBreedIds)
                data["transientBreedIds"].push(item);
        }
        data["fciNumber"] = this.fciNumber;
        return data;
    }
}

export interface IKennelImportRequestDto {
    kennelImportRequestId?: number;
    requestId?: number;
    request?: RequestDto | undefined;
    countryId?: number;
    nameOffer?: string | undefined;
    nameOfferType?: EKennelType;
    transientOwnerIds?: number[] | undefined;
    transientBreedIds?: number[] | undefined;
    fciNumber?: string | undefined;
}

export class KennelExportRequestDto implements IKennelExportRequestDto {
    kennelExportRequestId?: number;
    requestId?: number;
    countryId?: number;
    kennelId?: number;
    request?: RequestDto | undefined;

    constructor(data?: IKennelExportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelExportRequestId = _data["kennelExportRequestId"];
            this.requestId = _data["requestId"];
            this.countryId = _data["countryId"];
            this.kennelId = _data["kennelId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KennelExportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelExportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelExportRequestId"] = this.kennelExportRequestId;
        data["requestId"] = this.requestId;
        data["countryId"] = this.countryId;
        data["kennelId"] = this.kennelId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKennelExportRequestDto {
    kennelExportRequestId?: number;
    requestId?: number;
    countryId?: number;
    kennelId?: number;
    request?: RequestDto | undefined;
}

export class KennelOwnershipChangeRequestDto implements IKennelOwnershipChangeRequestDto {
    kennelOwnershipChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    request?: RequestDto | undefined;
    transientOwnerIds?: number[] | undefined;

    constructor(data?: IKennelOwnershipChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelOwnershipChangeRequestId = _data["kennelOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.kennelId = _data["kennelId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientOwnerIds"])) {
                this.transientOwnerIds = [] as any;
                for (let item of _data["transientOwnerIds"])
                    this.transientOwnerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): KennelOwnershipChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelOwnershipChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelOwnershipChangeRequestId"] = this.kennelOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["kennelId"] = this.kennelId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientOwnerIds)) {
            data["transientOwnerIds"] = [];
            for (let item of this.transientOwnerIds)
                data["transientOwnerIds"].push(item);
        }
        return data;
    }
}

export interface IKennelOwnershipChangeRequestDto {
    kennelOwnershipChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    request?: RequestDto | undefined;
    transientOwnerIds?: number[] | undefined;
}

export class ResultOfBoolean implements IResultOfBoolean {
    isFailure?: boolean;
    isSuccess?: boolean;
    error?: string | undefined;
    value?: boolean;

    constructor(data?: IResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFailure = _data["IsFailure"];
            this.isSuccess = _data["IsSuccess"];
            this.error = _data["Error"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): ResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsFailure"] = this.isFailure;
        data["IsSuccess"] = this.isSuccess;
        data["Error"] = this.error;
        data["Value"] = this.value;
        return data;
    }
}

export interface IResultOfBoolean {
    isFailure?: boolean;
    isSuccess?: boolean;
    error?: string | undefined;
    value?: boolean;
}

export class PaginatedResultsOfAffixExportGridDto implements IPaginatedResultsOfAffixExportGridDto {
    totalCount?: number;
    results?: AffixExportGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfAffixExportGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AffixExportGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfAffixExportGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfAffixExportGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfAffixExportGridDto {
    totalCount?: number;
    results?: AffixExportGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class AffixExportGridDto implements IAffixExportGridDto {
    requestId?: number;
    requestNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    originCountry?: string | undefined;
    affix?: EKennelType;
    kennelName?: string | undefined;
    oldKennelName?: string | undefined;
    oldAffix?: EKennelType;
    month?: number;
    year?: number;
    toExport?: boolean;

    constructor(data?: IAffixExportGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.exportDate = _data["exportDate"] ? new Date(_data["exportDate"].toString()) : <any>undefined;
            this.exportForcedValue = _data["exportForcedValue"];
            this.originCountry = _data["originCountry"];
            this.affix = _data["affix"];
            this.kennelName = _data["kennelName"];
            this.oldKennelName = _data["oldKennelName"];
            this.oldAffix = _data["oldAffix"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.toExport = _data["toExport"];
        }
    }

    static fromJS(data: any): AffixExportGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffixExportGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["exportDate"] = this.exportDate ? this.exportDate.toISOString() : <any>undefined;
        data["exportForcedValue"] = this.exportForcedValue;
        data["originCountry"] = this.originCountry;
        data["affix"] = this.affix;
        data["kennelName"] = this.kennelName;
        data["oldKennelName"] = this.oldKennelName;
        data["oldAffix"] = this.oldAffix;
        data["month"] = this.month;
        data["year"] = this.year;
        data["toExport"] = this.toExport;
        return data;
    }
}

export interface IAffixExportGridDto {
    requestId?: number;
    requestNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    originCountry?: string | undefined;
    affix?: EKennelType;
    kennelName?: string | undefined;
    oldKennelName?: string | undefined;
    oldAffix?: EKennelType;
    month?: number;
    year?: number;
    toExport?: boolean;
}

export class AffixRequestExportSearch extends PaginatedSearch implements IAffixRequestExportSearch {
    month?: ListSearchOfNullableInteger | undefined;
    year?: NumericSearch | undefined;

    constructor(data?: IAffixRequestExportSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.month = _data["month"] ? ListSearchOfNullableInteger.fromJS(_data["month"]) : <any>undefined;
            this.year = _data["year"] ? NumericSearch.fromJS(_data["year"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AffixRequestExportSearch {
        data = typeof data === 'object' ? data : {};
        let result = new AffixRequestExportSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month ? this.month.toJSON() : <any>undefined;
        data["year"] = this.year ? this.year.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAffixRequestExportSearch extends IPaginatedSearch {
    month?: ListSearchOfNullableInteger | undefined;
    year?: NumericSearch | undefined;
}

export abstract class FilterCriteriaBaseOfENumericSearchTypeAndNullableLong implements IFilterCriteriaBaseOfENumericSearchTypeAndNullableLong {
    criterias?: CombinableCriteriaOfENumericSearchTypeAndNullableLong[] | undefined;
    searchMode?: ENumericSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfENumericSearchTypeAndNullableLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfENumericSearchTypeAndNullableLong.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfENumericSearchTypeAndNullableLong {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfENumericSearchTypeAndNullableLong' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfENumericSearchTypeAndNullableLong {
    criterias?: CombinableCriteriaOfENumericSearchTypeAndNullableLong[] | undefined;
    searchMode?: ENumericSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class NumericSearch extends FilterCriteriaBaseOfENumericSearchTypeAndNullableLong implements INumericSearch {

    constructor(data?: INumericSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): NumericSearch {
        data = typeof data === 'object' ? data : {};
        let result = new NumericSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INumericSearch extends IFilterCriteriaBaseOfENumericSearchTypeAndNullableLong {
}

export class CombinableCriteriaOfENumericSearchTypeAndNullableLong implements ICombinableCriteriaOfENumericSearchTypeAndNullableLong {
    searchMode?: ENumericSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;

    constructor(data?: ICombinableCriteriaOfENumericSearchTypeAndNullableLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfENumericSearchTypeAndNullableLong {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfENumericSearchTypeAndNullableLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfENumericSearchTypeAndNullableLong {
    searchMode?: ENumericSearchType;
    value?: number | undefined;
    secondaryValue?: number | undefined;
}

export enum ENumericSearchType {
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    GreaterThanOrEquals = "GreaterThanOrEquals",
    LessThan = "LessThan",
    LessThanOrEquals = "LessThanOrEquals",
}

export class NewKennelRequestImportDto implements INewKennelRequestImportDto {
    requestNumber?: string | undefined;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    importable?: boolean;
    accepted?: boolean;

    constructor(data?: INewKennelRequestImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.finalName = _data["finalName"];
            this.finalType = _data["finalType"];
            this.fciNumber = _data["fciNumber"];
            this.importable = _data["importable"];
            this.accepted = _data["accepted"];
        }
    }

    static fromJS(data: any): NewKennelRequestImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewKennelRequestImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["finalName"] = this.finalName;
        data["finalType"] = this.finalType;
        data["fciNumber"] = this.fciNumber;
        data["importable"] = this.importable;
        data["accepted"] = this.accepted;
        return data;
    }
}

export interface INewKennelRequestImportDto {
    requestNumber?: string | undefined;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    importable?: boolean;
    accepted?: boolean;
}

export class KennelImportRequestImportDto implements IKennelImportRequestImportDto {
    requestNumber?: string | undefined;
    fciNumber?: string | undefined;
    importable?: boolean;
    accepted?: boolean;
    fciAnswer?: string | undefined;
    originCountry?: string | undefined;
    affix?: EKennelType;
    kennelName?: string | undefined;

    constructor(data?: IKennelImportRequestImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.fciNumber = _data["fciNumber"];
            this.importable = _data["importable"];
            this.accepted = _data["accepted"];
            this.fciAnswer = _data["fciAnswer"];
            this.originCountry = _data["originCountry"];
            this.affix = _data["affix"];
            this.kennelName = _data["kennelName"];
        }
    }

    static fromJS(data: any): KennelImportRequestImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelImportRequestImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["fciNumber"] = this.fciNumber;
        data["importable"] = this.importable;
        data["accepted"] = this.accepted;
        data["fciAnswer"] = this.fciAnswer;
        data["originCountry"] = this.originCountry;
        data["affix"] = this.affix;
        data["kennelName"] = this.kennelName;
        return data;
    }
}

export interface IKennelImportRequestImportDto {
    requestNumber?: string | undefined;
    fciNumber?: string | undefined;
    importable?: boolean;
    accepted?: boolean;
    fciAnswer?: string | undefined;
    originCountry?: string | undefined;
    affix?: EKennelType;
    kennelName?: string | undefined;
}

export class NameChangeRequestImporRequestDto implements INameChangeRequestImporRequestDto {
    requestNumber?: string | undefined;
    fciNumber?: string | undefined;
    fciAnswer?: string | undefined;
    finalType?: EKennelType;
    finalName?: string | undefined;
    importable?: boolean;
    oldKennelName?: string | undefined;
    oldAffix?: EKennelType;
    accepted?: boolean;

    constructor(data?: INameChangeRequestImporRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.fciNumber = _data["fciNumber"];
            this.fciAnswer = _data["fciAnswer"];
            this.finalType = _data["finalType"];
            this.finalName = _data["finalName"];
            this.importable = _data["importable"];
            this.oldKennelName = _data["oldKennelName"];
            this.oldAffix = _data["oldAffix"];
            this.accepted = _data["accepted"];
        }
    }

    static fromJS(data: any): NameChangeRequestImporRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameChangeRequestImporRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["fciNumber"] = this.fciNumber;
        data["fciAnswer"] = this.fciAnswer;
        data["finalType"] = this.finalType;
        data["finalName"] = this.finalName;
        data["importable"] = this.importable;
        data["oldKennelName"] = this.oldKennelName;
        data["oldAffix"] = this.oldAffix;
        data["accepted"] = this.accepted;
        return data;
    }
}

export interface INameChangeRequestImporRequestDto {
    requestNumber?: string | undefined;
    fciNumber?: string | undefined;
    fciAnswer?: string | undefined;
    finalType?: EKennelType;
    finalName?: string | undefined;
    importable?: boolean;
    oldKennelName?: string | undefined;
    oldAffix?: EKennelType;
    accepted?: boolean;
}

export class OwnershipChangeRequestImporRequestDto implements IOwnershipChangeRequestImporRequestDto {
    requestNumber?: string | undefined;
    fciAnswer?: string | undefined;
    importable?: boolean;
    affix?: EKennelType;
    kennelName?: string | undefined;
    accepted?: boolean;

    constructor(data?: IOwnershipChangeRequestImporRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.fciAnswer = _data["fciAnswer"];
            this.importable = _data["importable"];
            this.affix = _data["affix"];
            this.kennelName = _data["kennelName"];
            this.accepted = _data["accepted"];
        }
    }

    static fromJS(data: any): OwnershipChangeRequestImporRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipChangeRequestImporRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["fciAnswer"] = this.fciAnswer;
        data["importable"] = this.importable;
        data["affix"] = this.affix;
        data["kennelName"] = this.kennelName;
        data["accepted"] = this.accepted;
        return data;
    }
}

export interface IOwnershipChangeRequestImporRequestDto {
    requestNumber?: string | undefined;
    fciAnswer?: string | undefined;
    importable?: boolean;
    affix?: EKennelType;
    kennelName?: string | undefined;
    accepted?: boolean;
}

export class PaginatedResultsOfJudgeGridDto implements IPaginatedResultsOfJudgeGridDto {
    totalCount?: number;
    results?: JudgeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfJudgeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(JudgeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfJudgeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfJudgeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfJudgeGridDto {
    totalCount?: number;
    results?: JudgeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class JudgeGridDto implements IJudgeGridDto {
    judgeId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    name?: string | undefined;
    isDeceased?: boolean;

    constructor(data?: IJudgeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.name = _data["name"];
            this.isDeceased = _data["isDeceased"];
        }
    }

    static fromJS(data: any): JudgeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["name"] = this.name;
        data["isDeceased"] = this.isDeceased;
        return data;
    }
}

export interface IJudgeGridDto {
    judgeId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    name?: string | undefined;
    isDeceased?: boolean;
}

export class BaseBreedSearch extends PaginatedSearch implements IBaseBreedSearch {
    breedId?: number;
    languageId?: number;

    constructor(data?: IBaseBreedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.breedId = _data["breedId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): BaseBreedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BaseBreedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseBreedSearch extends IPaginatedSearch {
    breedId?: number;
    languageId?: number;
}

export class PaginatedResultsOfBreedColorDto implements IPaginatedResultsOfBreedColorDto {
    totalCount?: number;
    results?: BreedColorDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedColorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedColorDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedColorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedColorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedColorDto {
    totalCount?: number;
    results?: BreedColorDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedColorDto implements IBreedColorDto {
    breedColorId?: number;
    colorId?: number;
    breedId?: number;
    colorName?: string | undefined;
    breedName?: string | undefined;
    recognizedColor?: boolean;
    authorizedBreeding?: boolean;

    constructor(data?: IBreedColorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedColorId = _data["breedColorId"];
            this.colorId = _data["colorId"];
            this.breedId = _data["breedId"];
            this.colorName = _data["colorName"];
            this.breedName = _data["breedName"];
            this.recognizedColor = _data["recognizedColor"];
            this.authorizedBreeding = _data["authorizedBreeding"];
        }
    }

    static fromJS(data: any): BreedColorDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedColorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedColorId"] = this.breedColorId;
        data["colorId"] = this.colorId;
        data["breedId"] = this.breedId;
        data["colorName"] = this.colorName;
        data["breedName"] = this.breedName;
        data["recognizedColor"] = this.recognizedColor;
        data["authorizedBreeding"] = this.authorizedBreeding;
        return data;
    }
}

export interface IBreedColorDto {
    breedColorId?: number;
    colorId?: number;
    breedId?: number;
    colorName?: string | undefined;
    breedName?: string | undefined;
    recognizedColor?: boolean;
    authorizedBreeding?: boolean;
}

export class BreedColorSearch extends PaginatedSearch implements IBreedColorSearch {
    languageCode?: string | undefined;
    colorId?: number;
    recognizedColor?: BooleanSearch | undefined;
    authorizedBreeding?: BooleanSearch | undefined;

    constructor(data?: IBreedColorSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.colorId = _data["colorId"];
            this.recognizedColor = _data["recognizedColor"] ? BooleanSearch.fromJS(_data["recognizedColor"]) : <any>undefined;
            this.authorizedBreeding = _data["authorizedBreeding"] ? BooleanSearch.fromJS(_data["authorizedBreeding"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreedColorSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedColorSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["colorId"] = this.colorId;
        data["recognizedColor"] = this.recognizedColor ? this.recognizedColor.toJSON() : <any>undefined;
        data["authorizedBreeding"] = this.authorizedBreeding ? this.authorizedBreeding.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedColorSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    colorId?: number;
    recognizedColor?: BooleanSearch | undefined;
    authorizedBreeding?: BooleanSearch | undefined;
}

export class SaveColorsAllowedBreedsDto implements ISaveColorsAllowedBreedsDto {
    colorId?: number;
    breedIds?: number[] | undefined;

    constructor(data?: ISaveColorsAllowedBreedsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorId = _data["colorId"];
            if (Array.isArray(_data["breedIds"])) {
                this.breedIds = [] as any;
                for (let item of _data["breedIds"])
                    this.breedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveColorsAllowedBreedsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveColorsAllowedBreedsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorId"] = this.colorId;
        if (Array.isArray(this.breedIds)) {
            data["breedIds"] = [];
            for (let item of this.breedIds)
                data["breedIds"].push(item);
        }
        return data;
    }
}

export interface ISaveColorsAllowedBreedsDto {
    colorId?: number;
    breedIds?: number[] | undefined;
}

export class PaginatedResultsOfArticleGridDto implements IPaginatedResultsOfArticleGridDto {
    totalCount?: number;
    results?: ArticleGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfArticleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ArticleGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfArticleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfArticleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfArticleGridDto {
    totalCount?: number;
    results?: ArticleGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ArticleGridDto implements IArticleGridDto {
    articleId?: number;
    articleNumber?: number;
    bcIdentifier?: string | undefined;
    description?: string | undefined;
    price?: number;

    constructor(data?: IArticleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.articleNumber = _data["articleNumber"];
            this.bcIdentifier = _data["bcIdentifier"];
            this.description = _data["description"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ArticleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["articleNumber"] = this.articleNumber;
        data["bcIdentifier"] = this.bcIdentifier;
        data["description"] = this.description;
        data["price"] = this.price;
        return data;
    }
}

export interface IArticleGridDto {
    articleId?: number;
    articleNumber?: number;
    bcIdentifier?: string | undefined;
    description?: string | undefined;
    price?: number;
}

export class ArticleSearch extends PaginatedSearch implements IArticleSearch {
    bcIdentifier?: TextSearch | undefined;
    articleNumber?: NumericSearch | undefined;
    description?: TextSearch | undefined;

    constructor(data?: IArticleSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bcIdentifier = _data["bcIdentifier"] ? TextSearch.fromJS(_data["bcIdentifier"]) : <any>undefined;
            this.articleNumber = _data["articleNumber"] ? NumericSearch.fromJS(_data["articleNumber"]) : <any>undefined;
            this.description = _data["description"] ? TextSearch.fromJS(_data["description"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticleSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcIdentifier"] = this.bcIdentifier ? this.bcIdentifier.toJSON() : <any>undefined;
        data["articleNumber"] = this.articleNumber ? this.articleNumber.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IArticleSearch extends IPaginatedSearch {
    bcIdentifier?: TextSearch | undefined;
    articleNumber?: NumericSearch | undefined;
    description?: TextSearch | undefined;
}

export class ArticleDto implements IArticleDto {
    articleId?: number;
    articleNumber?: number;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    code?: EArticleCodes | undefined;
    price?: number;
    vatCode?: EVat;
    isMiscelaneous?: boolean;
    articleTranslations?: ArticleTranslationDto[] | undefined;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.articleNumber = _data["articleNumber"];
            this.bcIdentifier = _data["bcIdentifier"];
            this.brcsBcIdentifier = _data["brcsBcIdentifier"];
            this.code = _data["code"];
            this.price = _data["price"];
            this.vatCode = _data["vatCode"];
            this.isMiscelaneous = _data["isMiscelaneous"];
            if (Array.isArray(_data["articleTranslations"])) {
                this.articleTranslations = [] as any;
                for (let item of _data["articleTranslations"])
                    this.articleTranslations!.push(ArticleTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["articleNumber"] = this.articleNumber;
        data["bcIdentifier"] = this.bcIdentifier;
        data["brcsBcIdentifier"] = this.brcsBcIdentifier;
        data["code"] = this.code;
        data["price"] = this.price;
        data["vatCode"] = this.vatCode;
        data["isMiscelaneous"] = this.isMiscelaneous;
        if (Array.isArray(this.articleTranslations)) {
            data["articleTranslations"] = [];
            for (let item of this.articleTranslations)
                data["articleTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArticleDto {
    articleId?: number;
    articleNumber?: number;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    code?: EArticleCodes | undefined;
    price?: number;
    vatCode?: EVat;
    isMiscelaneous?: boolean;
    articleTranslations?: ArticleTranslationDto[] | undefined;
}

export enum EArticleCodes {
    ProgenusManualDnaEncoding = "ProgenusManualDnaEncoding",
    GenealogyCompletion = "GenealogyCompletion",
    WorkAttestRequest = "WorkAttestRequest",
    WorkbookRequest = "WorkbookRequest",
    DogOwnershipChangeRequest = "DogOwnershipChangeRequest",
    NewKennelRequest = "NewKennelRequest",
    KennelOwnershipChangeRequest = "KennelOwnershipChangeRequest",
    KennelImportRequest = "KennelImportRequest",
    DogTempOwnershipChangeRequest = "DogTempOwnershipChangeRequest",
    CompetitionRequest = "CompetitionRequest",
    PedigreeRequest = "PedigreeRequest",
    DysplasiaRequest = "DysplasiaRequest",
    PedigreeDuplicataRequest = "PedigreeDuplicataRequest",
    ImportRequest = "ImportRequest",
    BroodRequest = "BroodRequest",
    HealthTestRequest = "HealthTestRequest",
    TitleRequest = "TitleRequest",
    ProgenusCombiPatent = "ProgenusCombiPatent",
    AdministrativeFee = "AdministrativeFee",
    KennelExportRequest = "KennelExportRequest",
    KennelNameChangeRequest = "KennelNameChangeRequest",
    MembershipRequest = "MembershipRequest",
    PuppyTest = "PuppyTest",
    Fine = "Fine",
    LateBirthDeclaration = "LateBirthDeclaration",
    MaleDogTooYoung = "MaleDogTooYoung",
    FemaleDogTooYoung = "FemaleDogTooYoung",
    TooManyFathers = "TooManyFathers",
    WrongFather = "WrongFather",
    MembershipEffective = "MembershipEffective",
    MembershipProtected = "MembershipProtected",
    MembershipAcceded = "MembershipAcceded",
    WorkbookBlueWithPedigree = "WorkbookBlueWithPedigree",
    WorkbookGreenWithPedigree = "WorkbookGreenWithPedigree",
    WorkbookLightBlueWithPedigree = "WorkbookLightBlueWithPedigree",
    WorkbookOrangeWithPedigree = "WorkbookOrangeWithPedigree",
    WorkbookPurpleWithPedigree = "WorkbookPurpleWithPedigree",
    WorkbookRedWithPedigree = "WorkbookRedWithPedigree",
    WorkbookWhiteWithPedigree = "WorkbookWhiteWithPedigree",
    WorkbookBlueWithoutPedigree = "WorkbookBlueWithoutPedigree",
    WorkbookGreenWithoutPedigree = "WorkbookGreenWithoutPedigree",
    WorkbookLightBlueWithoutPedigree = "WorkbookLightBlueWithoutPedigree",
    WorkbookOrangeWithoutPedigree = "WorkbookOrangeWithoutPedigree",
    WorkbookPurpleWithoutPedigree = "WorkbookPurpleWithoutPedigree",
    WorkbookRedWithoutPedigree = "WorkbookRedWithoutPedigree",
    AppealDysplasiaRequest = "AppealDysplasiaRequest",
    EdDysplasia = "EdDysplasia",
    HdDysplasia = "HdDysplasia",
    SdDysplasia = "SdDysplasia",
    EdSdDysplasia = "EdSdDysplasia",
    HdEdDysplasia = "HdEdDysplasia",
    HdSdDysplasia = "HdSdDysplasia",
    HdEdSdDysplasia = "HdEdSdDysplasia",
    MembershipChangeTypeRequest = "MembershipChangeTypeRequest",
    BroodRequestPremium = "BroodRequestPremium",
    BroodRequestPremiumDnaAnalysis = "BroodRequestPremiumDnaAnalysis",
    BroodRequestDnaAnalysis = "BroodRequestDnaAnalysis",
    TitleBeCoursing = "TitleBeCoursing",
    TitleBeExpo = "TitleBeExpo",
    TitleBeBeautyNoWork = "TitleBeBeautyNoWork",
    TitleBeBeautyWork = "TitleBeBeautyWork",
    TitleBeFull = "TitleBeFull",
    TitleBeRacing = "TitleBeRacing",
    TitleBeWork = "TitleBeWork",
    TitleBeYoung = "TitleBeYoung",
    TitleBeOld = "TitleBeOld",
    ProgenusQuickDelivery = "ProgenusQuickDelivery",
    RegisteredLetter = "RegisteredLetter",
    LAB = "LAB",
    LAB1002 = "LAB1002",
    LAB1003 = "LAB1003",
    LAB1004 = "LAB1004",
    LAB1005 = "LAB1005",
    LAB1006 = "LAB1006",
    LAB1007 = "LAB1007",
    LAB1008 = "LAB1008",
    LAB1009 = "LAB1009",
    LAB1010 = "LAB1010",
    LAB1011 = "LAB1011",
    LAB1012 = "LAB1012",
    LAB1013 = "LAB1013",
    LAB1014 = "LAB1014",
    LAB1015 = "LAB1015",
    LAB1016 = "LAB1016",
    LAB1017 = "LAB1017",
    LAB1018 = "LAB1018",
    LAB1019 = "LAB1019",
    LAB1020 = "LAB1020",
    LAB1021 = "LAB1021",
    LAB1022 = "LAB1022",
    LAB1023 = "LAB1023",
    LAB1024 = "LAB1024",
    LAB1025 = "LAB1025",
    LAB1026 = "LAB1026",
    LAB1027 = "LAB1027",
    LAB1028 = "LAB1028",
    LAB1029 = "LAB1029",
    LAB1030 = "LAB1030",
    LAB1031 = "LAB1031",
    LAB1032 = "LAB1032",
    LAB1033 = "LAB1033",
    LAB1034 = "LAB1034",
    LAB1035 = "LAB1035",
    LAB1036 = "LAB1036",
    LAB1037 = "LAB1037",
    LAB1038 = "LAB1038",
    LAB1039 = "LAB1039",
    LAB1040 = "LAB1040",
    LAB1041 = "LAB1041",
    LAB1042 = "LAB1042",
    LAB1043 = "LAB1043",
    LAB1044 = "LAB1044",
    LAB1045 = "LAB1045",
    LAB1046 = "LAB1046",
    LAB1047 = "LAB1047",
    LAB1048 = "LAB1048",
    LAB1049 = "LAB1049",
    LAB1050 = "LAB1050",
    LAB1051 = "LAB1051",
    LAB1052 = "LAB1052",
    LAB1053 = "LAB1053",
    LAB1054 = "LAB1054",
    LAB1055 = "LAB1055",
    LAB1056 = "LAB1056",
    LAB1057 = "LAB1057",
    LAB1058 = "LAB1058",
    LAB1059 = "LAB1059",
    LAB1060 = "LAB1060",
    LAB1061 = "LAB1061",
    LAB1062 = "LAB1062",
    LAB1063 = "LAB1063",
    LAB1064 = "LAB1064",
    LAB1065 = "LAB1065",
    LAB1066 = "LAB1066",
    LAB1067 = "LAB1067",
    LAB1068 = "LAB1068",
    LAB1069 = "LAB1069",
    LAB1070 = "LAB1070",
    LAB1071 = "LAB1071",
    LAB1072 = "LAB1072",
    LAB1073 = "LAB1073",
    LAB1074 = "LAB1074",
    LAB1075 = "LAB1075",
    LAB1076 = "LAB1076",
    LAB1077 = "LAB1077",
    LAB1078 = "LAB1078",
    LAB1079 = "LAB1079",
    LAB1080 = "LAB1080",
    LAB1081 = "LAB1081",
    LAB1082 = "LAB1082",
    LAB1083 = "LAB1083",
    LAB1084 = "LAB1084",
    LAB1085 = "LAB1085",
    LAB1086 = "LAB1086",
    LAB1087 = "LAB1087",
    LAB1088 = "LAB1088",
    LAB1089 = "LAB1089",
    LAB1090 = "LAB1090",
    LAB1091 = "LAB1091",
    LAB1092 = "LAB1092",
    LAB1093 = "LAB1093",
    LAB1094 = "LAB1094",
    LAB1095 = "LAB1095",
    LAB1096 = "LAB1096",
    LAB1097 = "LAB1097",
    LAB1098 = "LAB1098",
    LAB1099 = "LAB1099",
    LAB1100 = "LAB1100",
    LAB1101 = "LAB1101",
    LAB1102 = "LAB1102",
    LAB1103 = "LAB1103",
    LAB1104 = "LAB1104",
    LAB1105 = "LAB1105",
    LAB1106 = "LAB1106",
    LAB1107 = "LAB1107",
    LAB1108 = "LAB1108",
    LAB1109 = "LAB1109",
    LAB1110 = "LAB1110",
    LAB1111 = "LAB1111",
    LAB1112 = "LAB1112",
    LAB1113 = "LAB1113",
    LAB1114 = "LAB1114",
    LAB1115 = "LAB1115",
    LAB1116 = "LAB1116",
    LAB1117 = "LAB1117",
    LAB1118 = "LAB1118",
    LAB1119 = "LAB1119",
    LAB1120 = "LAB1120",
    LAB1121 = "LAB1121",
    LAB1122 = "LAB1122",
    LAB1123 = "LAB1123",
    LAB1124 = "LAB1124",
    LAB1125 = "LAB1125",
    LAB1126 = "LAB1126",
    LAB1127 = "LAB1127",
    LAB1128 = "LAB1128",
    LAB1129 = "LAB1129",
    LAB1130 = "LAB1130",
    LAB1131 = "LAB1131",
    LAB1132 = "LAB1132",
    LAB1133 = "LAB1133",
    LAB1134 = "LAB1134",
    LAB1135 = "LAB1135",
    LAB1136 = "LAB1136",
    LAB1137 = "LAB1137",
    LAB1138 = "LAB1138",
    LAB1139 = "LAB1139",
    LAB1140 = "LAB1140",
    LAB1141 = "LAB1141",
    LAB1142 = "LAB1142",
    LAB1143 = "LAB1143",
    LAB1144 = "LAB1144",
    LAB1145 = "LAB1145",
    LAB1146 = "LAB1146",
    LAB1147 = "LAB1147",
    LAB1148 = "LAB1148",
    LAB1149 = "LAB1149",
    LAB1150 = "LAB1150",
    LAB1151 = "LAB1151",
    LAB1152 = "LAB1152",
    LAB1153 = "LAB1153",
    LAB1154 = "LAB1154",
    LAB1155 = "LAB1155",
    LAB1156 = "LAB1156",
    LAB1157 = "LAB1157",
    LAB1158 = "LAB1158",
    LAB1159 = "LAB1159",
    LAB1160 = "LAB1160",
    LAB1161 = "LAB1161",
    LAB1162 = "LAB1162",
    LAB1163 = "LAB1163",
    LAB1164 = "LAB1164",
    LAB1165 = "LAB1165",
    LAB1166 = "LAB1166",
    LAB1167 = "LAB1167",
    LAB1168 = "LAB1168",
    LAB1169 = "LAB1169",
    LAB1170 = "LAB1170",
    LAB1171 = "LAB1171",
    LAB1172 = "LAB1172",
    LAB1173 = "LAB1173",
    LAB1174 = "LAB1174",
    LAB1175 = "LAB1175",
    LAB1176 = "LAB1176",
    LAB1177 = "LAB1177",
    LAB1178 = "LAB1178",
    LAB1179 = "LAB1179",
    LAB1180 = "LAB1180",
    LAB1181 = "LAB1181",
    LAB1182 = "LAB1182",
    LAB1183 = "LAB1183",
    LAB1184 = "LAB1184",
    LAB1185 = "LAB1185",
    LAB1186 = "LAB1186",
    LAB1187 = "LAB1187",
    LAB1188 = "LAB1188",
    LAB1189 = "LAB1189",
    LAB1190 = "LAB1190",
    LAB1191 = "LAB1191",
    LAB1192 = "LAB1192",
    LAB1193 = "LAB1193",
    LAB1194 = "LAB1194",
    LAB1195 = "LAB1195",
    LAB1196 = "LAB1196",
    LAB1197 = "LAB1197",
    LAB1198 = "LAB1198",
    LAB1199 = "LAB1199",
    LAB1200 = "LAB1200",
    LAB1201 = "LAB1201",
    LAB1202 = "LAB1202",
    LAB1203 = "LAB1203",
    LAB1204 = "LAB1204",
    LAB1205 = "LAB1205",
    LAB1206 = "LAB1206",
    LAB1207 = "LAB1207",
    LAB1208 = "LAB1208",
    LAB1209 = "LAB1209",
    LAB1210 = "LAB1210",
    LAB1211 = "LAB1211",
    LAB1212 = "LAB1212",
    LAB1213 = "LAB1213",
    LAB1214 = "LAB1214",
    LAB1215 = "LAB1215",
    LAB1216 = "LAB1216",
    LAB1217 = "LAB1217",
    LAB1218 = "LAB1218",
    LAB1219 = "LAB1219",
    LAB1220 = "LAB1220",
    LAB1221 = "LAB1221",
    LAB1222 = "LAB1222",
    LAB1223 = "LAB1223",
    LAB1224 = "LAB1224",
    LAB1225 = "LAB1225",
    LAB1226 = "LAB1226",
    LAB1227 = "LAB1227",
    LAB1228 = "LAB1228",
    LAB1229 = "LAB1229",
    LAB1230 = "LAB1230",
    LAB1231 = "LAB1231",
    LAB1232 = "LAB1232",
    LAB1233 = "LAB1233",
    LAB1234 = "LAB1234",
    LAB1235 = "LAB1235",
    LAB1236 = "LAB1236",
    LAB1237 = "LAB1237",
    LAB1238 = "LAB1238",
    LAB1239 = "LAB1239",
    LAB1240 = "LAB1240",
    LAB1241 = "LAB1241",
    LAB1242 = "LAB1242",
    LAB1243 = "LAB1243",
    LAB1244 = "LAB1244",
    LAB1245 = "LAB1245",
    LAB1246 = "LAB1246",
    LAB1247 = "LAB1247",
    LAB1248 = "LAB1248",
    LAB1249 = "LAB1249",
    LAB1250 = "LAB1250",
    LAB1251 = "LAB1251",
    LAB1252 = "LAB1252",
    LAB1253 = "LAB1253",
    LAB1254 = "LAB1254",
    LAB1255 = "LAB1255",
    LAB1256 = "LAB1256",
    LAB1257 = "LAB1257",
    LAB1258 = "LAB1258",
    LAB1259 = "LAB1259",
    LAB1260 = "LAB1260",
    LAB1261 = "LAB1261",
    LAB1262 = "LAB1262",
    LAB1263 = "LAB1263",
    LAB1264 = "LAB1264",
    LAB1265 = "LAB1265",
    LAB1266 = "LAB1266",
    LAB1267 = "LAB1267",
    LAB1268 = "LAB1268",
    LAB1269 = "LAB1269",
    LAB1270 = "LAB1270",
    LAB1271 = "LAB1271",
    LAB1272 = "LAB1272",
    LAB1273 = "LAB1273",
    LAB1274 = "LAB1274",
    LAB1275 = "LAB1275",
    LAB1276 = "LAB1276",
    LAB1277 = "LAB1277",
    LAB1278 = "LAB1278",
    LAB1279 = "LAB1279",
    LAB1280 = "LAB1280",
    LAB1281 = "LAB1281",
    LAB1282 = "LAB1282",
    LAB1283 = "LAB1283",
    LAB1284 = "LAB1284",
    LAB1285 = "LAB1285",
    LAB1286 = "LAB1286",
    LAB1287 = "LAB1287",
    LAB1288 = "LAB1288",
    LAB1289 = "LAB1289",
    LAB1290 = "LAB1290",
    LAB1291 = "LAB1291",
    LAB1292 = "LAB1292",
    LAB1293 = "LAB1293",
    LAB1294 = "LAB1294",
    LAB1295 = "LAB1295",
    LAB1296 = "LAB1296",
    LAB1297 = "LAB1297",
    LAB1298 = "LAB1298",
    LAB1299 = "LAB1299",
    LAB1300 = "LAB1300",
    LAB1301 = "LAB1301",
    LAB1302 = "LAB1302",
    LAB1303 = "LAB1303",
    LAB1304 = "LAB1304",
    LAB1305 = "LAB1305",
    LAB1306 = "LAB1306",
    LAB1307 = "LAB1307",
    LAB1308 = "LAB1308",
    LAB1309 = "LAB1309",
    LAB1310 = "LAB1310",
    LAB1311 = "LAB1311",
    LAB1312 = "LAB1312",
    LAB1313 = "LAB1313",
    LAB1314 = "LAB1314",
    LAB1315 = "LAB1315",
    LAB1316 = "LAB1316",
    LAB1317 = "LAB1317",
    LAB1318 = "LAB1318",
    LAB1319 = "LAB1319",
    LAB1320 = "LAB1320",
    LAB1321 = "LAB1321",
    LAB1322 = "LAB1322",
    LAB1323 = "LAB1323",
    LAB1324 = "LAB1324",
    LAB1325 = "LAB1325",
    LAB1326 = "LAB1326",
    LAB1327 = "LAB1327",
    LAB1328 = "LAB1328",
    LAB1329 = "LAB1329",
    LAB1330 = "LAB1330",
    LAB1331 = "LAB1331",
    LAB1332 = "LAB1332",
    LAB1333 = "LAB1333",
    LAB1334 = "LAB1334",
    LAB1335 = "LAB1335",
    LAB1336 = "LAB1336",
    LAB1337 = "LAB1337",
    LAB1338 = "LAB1338",
    LAB1339 = "LAB1339",
    LAB1340 = "LAB1340",
    LAB1341 = "LAB1341",
    LAB1342 = "LAB1342",
    LAB1343 = "LAB1343",
    LAB1344 = "LAB1344",
    LAB1345 = "LAB1345",
    LABAnalyse = "LABAnalyse",
    DOG_ACMHB = "DOG_ACMHB",
    DOG_ACMHL = "DOG_ACMHL",
    DOG_AMSTAFF = "DOG_AMSTAFF",
    DOG_AMPN = "DOG_AMPN",
    DOG_ARCI = "DOG_ARCI",
    DOG_ARHN = "DOG_ARHN",
    DOG_BERGER = "DOG_BERGER",
    DOG_BFJE = "DOG_BFJE",
    DOG_BGAUST = "DOG_BGAUST",
    DOG_BGAUST_E = "DOG_BGAUST_E",
    DOG_BGBLCH = "DOG_BGBLCH",
    DOG_BGDEBRIE = "DOG_BGDEBRIE",
    DOG_BNAT = "DOG_BNAT",
    DOG_BOUVIER = "DOG_BOUVIER",
    DOG_BRQALLD = "DOG_BRQALLD",
    DOG_BULLFR_E = "DOG_BULLFR_E",
    DOG_CA = "DOG_CA",
    DOG_CEA_CH = "DOG_CEA_CH",
    DOG_CHI = "DOG_CHI",
    DOG_CHI_E = "DOG_CHI_E",
    DOG_CKCSID = "DOG_CKCSID",
    DOG_CLAD1 = "DOG_CLAD1",
    DOG_CLAD3 = "DOG_CLAD3",
    DOG_CMR1 = "DOG_CMR1",
    DOG_CMR2 = "DOG_CMR2",
    DOG_CMS = "DOG_CMS",
    DOG_CN = "DOG_CN",
    DOG_CNM = "DOG_CNM",
    DOG_COLLIE = "DOG_COLLIE",
    DOG_COLLIE_E = "DOG_COLLIE_E",
    DOG_CRD_SWHD = "DOG_CRD_SWHD",
    DOG_CSNB = "DOG_CSNB",
    DOG_CSS = "DOG_CSS",
    DOG_CT = "DOG_CT",
    DOG_CTULEAR = "DOG_CTULEAR",
    DOG_CUR = "DOG_CUR",
    DOG_CYST1A1 = "DOG_CYST1A1",
    DOG_CYST1A2 = "DOG_CYST1A2",
    DOG_CYST2A = "DOG_CYST2A",
    DOG_CYST2B = "DOG_CYST2B",
    DOG_DEB = "DOG_DEB",
    DOG_DM1 = "DOG_DM1",
    DOG_DM2 = "DOG_DM2",
    DOG_DOBER_E = "DOG_DOBER_E",
    DOG_EAUPORT = "DOG_EAUPORT",
    DOG_EAUPORT_E = "DOG_EAUPORT_E",
    DOG_EFS = "DOG_EFS",
    DOG_EIC = "DOG_EIC",
    DOG_EIMM = "DOG_EIMM",
    DOG_EPI = "DOG_EPI",
    DOG_F7 = "DOG_F7",
    DOG_FIL = "DOG_FIL",
    DOG_FUCA = "DOG_FUCA",
    DOG_FUR = "DOG_FUR",
    DOG_GLDS = "DOG_GLDS",
    DOG_GLDT = "DOG_GLDT",
    DOG_GM1H = "DOG_GM1H",
    DOG_GM1P = "DOG_GM1P",
    DOG_GM1S = "DOG_GM1S",
    DOG_GRMD = "DOG_GRMD",
    DOG_HEB = "DOG_HEB",
    DOG_HNPK = "DOG_HNPK",
    DOG_HSF4_T = "DOG_HSF4_T",
    DOG_HSF4_BA = "DOG_HSF4_BA",
    DOG_HUU = "DOG_HUU",
    DOG_HYM = "DOG_HYM",
    DOG_ICH = "DOG_ICH",
    DOG_ICHGR = "DOG_ICHGR",
    DOG_IGSB = "DOG_IGSB",
    DOG_IPD = "DOG_IPD",
    DOG_IVDD = "DOG_IVDD",
    DOG_JAGDT = "DOG_JAGDT",
    DOG_JEB = "DOG_JEB",
    DOG_JLPP = "DOG_JLPP",
    DOG_JLPPTNR = "DOG_JLPPTNR",
    DOG_L_2_HGA = "DOG_L_2_HGA",
    DOG_LAD = "DOG_LAD",
    DOG_LEMP = "DOG_LEMP",
    DOG_LEON = "DOG_LEON",
    DOG_LH = "DOG_LH",
    DOG_LHA = "DOG_LHA",
    DOG_LNP1 = "DOG_LNP1",
    DOG_LNP2 = "DOG_LNP2",
    DOG_LOCUS_A = "DOG_LOCUS_A",
    DOG_LOCUS_B = "DOG_LOCUS_B",
    DOG_LOCUS_D = "DOG_LOCUS_D",
    DOG_LOCUS_E = "DOG_LOCUS_E",
    DOG_LOCUS_Em = "DOG_LOCUS_Em",
    DOG_LOCUS_K = "DOG_LOCUS_K",
    DOG_LOCUS_M = "DOG_LOCUS_M",
    DOG_MC = "DOG_MC",
    DOG_MDR1 = "DOG_MDR1",
    DOG_MDU = "DOG_MDU",
    DOG_MH = "DOG_MH",
    DOG_MPSVII = "DOG_MPSVII",
    DOG_MTM1 = "DOG_MTM1",
    DOG_NAN = "DOG_NAN",
    DOG_NARC1 = "DOG_NARC1",
    DOG_NARC2 = "DOG_NARC2",
    DOG_NARC3 = "DOG_NARC3",
    DOG_NCL10 = "DOG_NCL10",
    DOG_NCL5 = "DOG_NCL5",
    DOG_NCL5GR = "DOG_NCL5GR",
    DOG_NCL6 = "DOG_NCL6",
    DOG_NCL7 = "DOG_NCL7",
    DOG_NCLA = "DOG_NCLA",
    DOG_NEWS = "DOG_NEWS",
    DOG_OSD1 = "DOG_OSD1",
    DOG_OSTEO = "DOG_OSTEO",
    DOG_PAP_PRA = "DOG_PAP_PRA",
    DOG_PDHD = "DOG_PDHD",
    DOG_PFKM = "DOG_PFKM",
    DOG_PKDEFC = "DOG_PKDEFC",
    DOG_PKDEFL = "DOG_PKDEFL",
    DOG_PLL = "DOG_PLL",
    DOG_PRA1_GR = "DOG_PRA1_GR",
    DOG_PRA_CNGA1 = "DOG_PRA_CNGA1",
    DOG_PRA_CRD1 = "DOG_PRA_CRD1",
    DOG_PRA_CRD4 = "DOG_PRA_CRD4",
    DOG_PRA_PRCD = "DOG_PRA_PRCD",
    DOG_PRA_RCD1 = "DOG_PRA_RCD1",
    DOG_QU = "DOG_QU",
    DOG_RAINE = "DOG_RAINE",
    DOG_RCND = "DOG_RCND",
    DOG_RETRIEVER = "DOG_RETRIEVER",
    DOG_RETRIEVER_E = "DOG_RETRIEVER_E",
    DOG_ROTT_E = "DOG_ROTT_E",
    DOG_SCA = "DOG_SCA",
    DOG_SD = "DOG_SD",
    DOG_SD2 = "DOG_SD2",
    DOG_SDCA1 = "DOG_SDCA1",
    DOG_SHP = "DOG_SHP",
    DOG_SPAID = "DOG_SPAID",
    DOG_STAFF = "DOG_STAFF",
    DOG_TNS = "DOG_TNS",
    DOG_VWD1 = "DOG_VWD1",
    DOG_VWD2 = "DOG_VWD2",
    DOG_XHED = "DOG_XHED",
    DOG_CRD4 = "DOG_CRD4",
    DOG_D_Q = "DOG_D_Q",
    DOG_DET = "DOG_DET",
    DOG_ESS = "DOG_ESS",
    DOG_HSF4 = "DOG_HSF4",
    DOG_ID22 = "DOG_ID22",
    DOG_IGSBA = "DOG_IGSBA",
    DOG_NCL1 = "DOG_NCL1",
    DOG_NCL2 = "DOG_NCL2",
    DOG_PAP_PRA1 = "DOG_PAP_PRA1",
    DOG_PN = "DOG_PN",
    DOG_PRA3 = "DOG_PRA3",
    DOG_PRA_CRD2 = "DOG_PRA_CRD2",
    DOG_PRA_CRD3 = "DOG_PRA_CRD3",
    DOG_PRA_RCD2 = "DOG_PRA_RCD2",
    DOG_PRA_RCD4 = "DOG_PRA_RCD4",
    DOG_PRCD_PRA = "DOG_PRCD_PRA",
    DOG_RAIN = "DOG_RAIN",
    DOG_RCD1 = "DOG_RCD1",
    DOG_RCD4 = "DOG_RCD4",
    DOG_AMS = "DOG_AMS",
    PedigreeDuplicataRenewalRequest = "PedigreeDuplicataRenewalRequest",
    BillReminderFee = "BillReminderFee",
    BroodRequestBillReminderFee = "BroodRequestBillReminderFee",
    BroodRequestSrshPedigreeAddition = "BroodRequestSrshPedigreeAddition",
}

export enum EVat {
    S0 = "S0",
    S1 = "S1",
    S3 = "S3",
}

export class ArticleTranslationDto implements IArticleTranslationDto {
    articleId?: number;
    languageId?: number;
    bcLanguageCode?: string | undefined;
    text?: string | undefined;
    articleTranslationId?: number;

    constructor(data?: IArticleTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.languageId = _data["languageId"];
            this.bcLanguageCode = _data["bcLanguageCode"];
            this.text = _data["text"];
            this.articleTranslationId = _data["articleTranslationId"];
        }
    }

    static fromJS(data: any): ArticleTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["languageId"] = this.languageId;
        data["bcLanguageCode"] = this.bcLanguageCode;
        data["text"] = this.text;
        data["articleTranslationId"] = this.articleTranslationId;
        return data;
    }
}

export interface IArticleTranslationDto {
    articleId?: number;
    languageId?: number;
    bcLanguageCode?: string | undefined;
    text?: string | undefined;
    articleTranslationId?: number;
}

export class ClubJudgeSearch extends PaginatedSearch implements IClubJudgeSearch {
    clubId?: number;
    languageId?: number;

    constructor(data?: IClubJudgeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clubId = _data["clubId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): ClubJudgeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubJudgeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IClubJudgeSearch extends IPaginatedSearch {
    clubId?: number;
    languageId?: number;
}

export class PaginatedResultsOfBreedGridDto implements IPaginatedResultsOfBreedGridDto {
    totalCount?: number;
    results?: BreedGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedGridDto {
    totalCount?: number;
    results?: BreedGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedGridDto implements IBreedGridDto {
    breedId?: number;
    code?: string | undefined;
    name?: string | undefined;
    breedGroupId?: number;
    breedGroupLabel?: string | undefined;
    breedGroupNumber?: number;
    breedFciNumber?: number;
    country?: string | undefined;
    breedGroupFullName?: string | undefined;
    breedComputedLabel?: string | undefined;

    constructor(data?: IBreedGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupLabel = _data["breedGroupLabel"];
            this.breedGroupNumber = _data["breedGroupNumber"];
            this.breedFciNumber = _data["breedFciNumber"];
            this.country = _data["country"];
            this.breedGroupFullName = _data["breedGroupFullName"];
            this.breedComputedLabel = _data["breedComputedLabel"];
        }
    }

    static fromJS(data: any): BreedGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupLabel"] = this.breedGroupLabel;
        data["breedGroupNumber"] = this.breedGroupNumber;
        data["breedFciNumber"] = this.breedFciNumber;
        data["country"] = this.country;
        data["breedGroupFullName"] = this.breedGroupFullName;
        data["breedComputedLabel"] = this.breedComputedLabel;
        return data;
    }
}

export interface IBreedGridDto {
    breedId?: number;
    code?: string | undefined;
    name?: string | undefined;
    breedGroupId?: number;
    breedGroupLabel?: string | undefined;
    breedGroupNumber?: number;
    breedFciNumber?: number;
    country?: string | undefined;
    breedGroupFullName?: string | undefined;
    breedComputedLabel?: string | undefined;
}

export class BreedSearch extends PaginatedSearch implements IBreedSearch {
    name?: TextSearch | undefined;
    breedGroupLabel?: TextSearch | undefined;
    country?: TextSearch | undefined;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IBreedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.breedGroupLabel = _data["breedGroupLabel"] ? TextSearch.fromJS(_data["breedGroupLabel"]) : <any>undefined;
            this.country = _data["country"] ? TextSearch.fromJS(_data["country"]) : <any>undefined;
            this.languageId = _data["languageId"];
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): BreedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["breedGroupLabel"] = this.breedGroupLabel ? this.breedGroupLabel.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedSearch extends IPaginatedSearch {
    name?: TextSearch | undefined;
    breedGroupLabel?: TextSearch | undefined;
    country?: TextSearch | undefined;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class BreedDto implements IBreedDto {
    code?: string | undefined;
    knownBreed?: boolean;
    knownAt?: Date | undefined;
    subjectToWork?: boolean;
    remark?: string | undefined;
    fciNumber?: number | undefined;
    agility?: EDifficulty;
    grooming?: EDifficulty;
    standardConfirmation?: boolean;
    shortenedTail?: boolean;
    merleColorAuthorized?: boolean;
    number?: number;
    sizeMin?: number | undefined;
    sizeMax?: number | undefined;
    weightMin?: number | undefined;
    weightMax?: number | undefined;
    varietyNumber?: number | undefined;
    userId?: number | undefined;
    healthPackIds?: number[] | undefined;
    minDysplasiaAgeInMonths?: number;
    breeding?: boolean;
    breedId?: number;
    breedGroupId?: number;
    countryId?: number;
    breedNumber?: number;
    internship?: boolean;
    internshipDate?: Date | undefined;
    officialName?: string | undefined;
    sharepointUri?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    breedTranslations?: BreedTranslationDto[] | undefined;

    constructor(data?: IBreedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.knownBreed = _data["knownBreed"];
            this.knownAt = _data["knownAt"] ? new Date(_data["knownAt"].toString()) : <any>undefined;
            this.subjectToWork = _data["subjectToWork"];
            this.remark = _data["remark"];
            this.fciNumber = _data["fciNumber"];
            this.agility = _data["agility"];
            this.grooming = _data["grooming"];
            this.standardConfirmation = _data["standardConfirmation"];
            this.shortenedTail = _data["shortenedTail"];
            this.merleColorAuthorized = _data["merleColorAuthorized"];
            this.number = _data["number"];
            this.sizeMin = _data["sizeMin"];
            this.sizeMax = _data["sizeMax"];
            this.weightMin = _data["weightMin"];
            this.weightMax = _data["weightMax"];
            this.varietyNumber = _data["varietyNumber"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["healthPackIds"])) {
                this.healthPackIds = [] as any;
                for (let item of _data["healthPackIds"])
                    this.healthPackIds!.push(item);
            }
            this.minDysplasiaAgeInMonths = _data["minDysplasiaAgeInMonths"];
            this.breeding = _data["breeding"];
            this.breedId = _data["breedId"];
            this.breedGroupId = _data["breedGroupId"];
            this.countryId = _data["countryId"];
            this.breedNumber = _data["breedNumber"];
            this.internship = _data["internship"];
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.officialName = _data["officialName"];
            this.sharepointUri = _data["sharepointUri"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["breedTranslations"])) {
                this.breedTranslations = [] as any;
                for (let item of _data["breedTranslations"])
                    this.breedTranslations!.push(BreedTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["knownBreed"] = this.knownBreed;
        data["knownAt"] = this.knownAt ? this.knownAt.toISOString() : <any>undefined;
        data["subjectToWork"] = this.subjectToWork;
        data["remark"] = this.remark;
        data["fciNumber"] = this.fciNumber;
        data["agility"] = this.agility;
        data["grooming"] = this.grooming;
        data["standardConfirmation"] = this.standardConfirmation;
        data["shortenedTail"] = this.shortenedTail;
        data["merleColorAuthorized"] = this.merleColorAuthorized;
        data["number"] = this.number;
        data["sizeMin"] = this.sizeMin;
        data["sizeMax"] = this.sizeMax;
        data["weightMin"] = this.weightMin;
        data["weightMax"] = this.weightMax;
        data["varietyNumber"] = this.varietyNumber;
        data["userId"] = this.userId;
        if (Array.isArray(this.healthPackIds)) {
            data["healthPackIds"] = [];
            for (let item of this.healthPackIds)
                data["healthPackIds"].push(item);
        }
        data["minDysplasiaAgeInMonths"] = this.minDysplasiaAgeInMonths;
        data["breeding"] = this.breeding;
        data["breedId"] = this.breedId;
        data["breedGroupId"] = this.breedGroupId;
        data["countryId"] = this.countryId;
        data["breedNumber"] = this.breedNumber;
        data["internship"] = this.internship;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["officialName"] = this.officialName;
        data["sharepointUri"] = this.sharepointUri;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.breedTranslations)) {
            data["breedTranslations"] = [];
            for (let item of this.breedTranslations)
                data["breedTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreedDto {
    code?: string | undefined;
    knownBreed?: boolean;
    knownAt?: Date | undefined;
    subjectToWork?: boolean;
    remark?: string | undefined;
    fciNumber?: number | undefined;
    agility?: EDifficulty;
    grooming?: EDifficulty;
    standardConfirmation?: boolean;
    shortenedTail?: boolean;
    merleColorAuthorized?: boolean;
    number?: number;
    sizeMin?: number | undefined;
    sizeMax?: number | undefined;
    weightMin?: number | undefined;
    weightMax?: number | undefined;
    varietyNumber?: number | undefined;
    userId?: number | undefined;
    healthPackIds?: number[] | undefined;
    minDysplasiaAgeInMonths?: number;
    breeding?: boolean;
    breedId?: number;
    breedGroupId?: number;
    countryId?: number;
    breedNumber?: number;
    internship?: boolean;
    internshipDate?: Date | undefined;
    officialName?: string | undefined;
    sharepointUri?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    breedTranslations?: BreedTranslationDto[] | undefined;
}

export enum EDifficulty {
    Easy = "Easy",
    Medium = "Medium",
    Hard = "Hard",
}

export class BreedTranslationDto implements IBreedTranslationDto {
    breedTranslationId?: number;
    languageId?: number;
    breedId?: number;
    text?: string | undefined;
    code?: string | undefined;

    constructor(data?: IBreedTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedTranslationId = _data["breedTranslationId"];
            this.languageId = _data["languageId"];
            this.breedId = _data["breedId"];
            this.text = _data["text"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): BreedTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedTranslationId"] = this.breedTranslationId;
        data["languageId"] = this.languageId;
        data["breedId"] = this.breedId;
        data["text"] = this.text;
        data["code"] = this.code;
        return data;
    }
}

export interface IBreedTranslationDto {
    breedTranslationId?: number;
    languageId?: number;
    breedId?: number;
    text?: string | undefined;
    code?: string | undefined;
}

export class BreedColorSaveDto implements IBreedColorSaveDto {
    breedId?: number;
    colorIds?: number[] | undefined;

    constructor(data?: IBreedColorSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            if (Array.isArray(_data["colorIds"])) {
                this.colorIds = [] as any;
                for (let item of _data["colorIds"])
                    this.colorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BreedColorSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedColorSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        if (Array.isArray(this.colorIds)) {
            data["colorIds"] = [];
            for (let item of this.colorIds)
                data["colorIds"].push(item);
        }
        return data;
    }
}

export interface IBreedColorSaveDto {
    breedId?: number;
    colorIds?: number[] | undefined;
}

export class WorkbookTypeGridDto implements IWorkbookTypeGridDto {
    workbookTypeId?: number;
    workbookColor?: string | undefined;
    hasPedigree?: boolean;
    canGiveWorkCertificate?: boolean;
    description?: string | undefined;
    sociabilityTest?: boolean;

    constructor(data?: IWorkbookTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeId = _data["workbookTypeId"];
            this.workbookColor = _data["workbookColor"];
            this.hasPedigree = _data["hasPedigree"];
            this.canGiveWorkCertificate = _data["canGiveWorkCertificate"];
            this.description = _data["description"];
            this.sociabilityTest = _data["sociabilityTest"];
        }
    }

    static fromJS(data: any): WorkbookTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeId"] = this.workbookTypeId;
        data["workbookColor"] = this.workbookColor;
        data["hasPedigree"] = this.hasPedigree;
        data["canGiveWorkCertificate"] = this.canGiveWorkCertificate;
        data["description"] = this.description;
        data["sociabilityTest"] = this.sociabilityTest;
        return data;
    }
}

export interface IWorkbookTypeGridDto {
    workbookTypeId?: number;
    workbookColor?: string | undefined;
    hasPedigree?: boolean;
    canGiveWorkCertificate?: boolean;
    description?: string | undefined;
    sociabilityTest?: boolean;
}

export class BreedWorkbookTypeSaveDto implements IBreedWorkbookTypeSaveDto {
    breedId?: number;
    workbookTypeIds?: number[] | undefined;

    constructor(data?: IBreedWorkbookTypeSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            if (Array.isArray(_data["workbookTypeIds"])) {
                this.workbookTypeIds = [] as any;
                for (let item of _data["workbookTypeIds"])
                    this.workbookTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BreedWorkbookTypeSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedWorkbookTypeSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        if (Array.isArray(this.workbookTypeIds)) {
            data["workbookTypeIds"] = [];
            for (let item of this.workbookTypeIds)
                data["workbookTypeIds"].push(item);
        }
        return data;
    }
}

export interface IBreedWorkbookTypeSaveDto {
    breedId?: number;
    workbookTypeIds?: number[] | undefined;
}

export class PaginatedResultsOfBreederGridDto implements IPaginatedResultsOfBreederGridDto {
    totalCount?: number;
    results?: BreederGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreederGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreederGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreederGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreederGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreederGridDto {
    totalCount?: number;
    results?: BreederGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreederGridDto implements IBreederGridDto {
    breederId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;

    constructor(data?: IBreederGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breederId = _data["breederId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): BreederGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreederGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breederId"] = this.breederId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface IBreederGridDto {
    breederId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export class BreederSearch extends PaginatedSearch implements IBreederSearch {
    languageId?: number;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;

    constructor(data?: IBreederSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreederSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreederSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBreederSearch extends IPaginatedSearch {
    languageId?: number;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;
}

export class PaginatedResultsOfBreederDogsGridDto implements IPaginatedResultsOfBreederDogsGridDto {
    totalCount?: number;
    results?: BreederDogsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreederDogsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreederDogsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreederDogsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreederDogsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreederDogsGridDto {
    totalCount?: number;
    results?: BreederDogsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreederDogsGridDto implements IBreederDogsGridDto {
    dogId?: number;
    firstName?: string | undefined;
    kennelName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date;
    breed?: string | undefined;
    breedId?: number;
    color?: string | undefined;
    colorId?: number;
    primaryIdentificationNumber?: string | undefined;
    pedigree?: string | undefined;

    constructor(data?: IBreederDogsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.firstName = _data["firstName"];
            this.kennelName = _data["kennelName"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.breed = _data["breed"];
            this.breedId = _data["breedId"];
            this.color = _data["color"];
            this.colorId = _data["colorId"];
            this.primaryIdentificationNumber = _data["primaryIdentificationNumber"];
            this.pedigree = _data["pedigree"];
        }
    }

    static fromJS(data: any): BreederDogsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreederDogsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["firstName"] = this.firstName;
        data["kennelName"] = this.kennelName;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["breed"] = this.breed;
        data["breedId"] = this.breedId;
        data["color"] = this.color;
        data["colorId"] = this.colorId;
        data["primaryIdentificationNumber"] = this.primaryIdentificationNumber;
        data["pedigree"] = this.pedigree;
        return data;
    }
}

export interface IBreederDogsGridDto {
    dogId?: number;
    firstName?: string | undefined;
    kennelName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date;
    breed?: string | undefined;
    breedId?: number;
    color?: string | undefined;
    colorId?: number;
    primaryIdentificationNumber?: string | undefined;
    pedigree?: string | undefined;
}

export class BreederDogsSearch extends PaginatedSearch implements IBreederDogsSearch {
    languageId?: number;
    personId?: number;
    firstName?: TextSearch | undefined;
    ownerFrom?: DateSearch | undefined;
    ownerTo?: DateSearch | undefined;

    constructor(data?: IBreederDogsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.ownerFrom = _data["ownerFrom"] ? DateSearch.fromJS(_data["ownerFrom"]) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? DateSearch.fromJS(_data["ownerTo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreederDogsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreederDogsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toJSON() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBreederDogsSearch extends IPaginatedSearch {
    languageId?: number;
    personId?: number;
    firstName?: TextSearch | undefined;
    ownerFrom?: DateSearch | undefined;
    ownerTo?: DateSearch | undefined;
}

export class PaginatedResultsOfBreedVarietiesAndExceptionsGridDto implements IPaginatedResultsOfBreedVarietiesAndExceptionsGridDto {
    totalCount?: number;
    results?: BreedVarietiesAndExceptionsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedVarietiesAndExceptionsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedVarietiesAndExceptionsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedVarietiesAndExceptionsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedVarietiesAndExceptionsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedVarietiesAndExceptionsGridDto {
    totalCount?: number;
    results?: BreedVarietiesAndExceptionsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedVarietiesAndExceptionsGridDto implements IBreedVarietiesAndExceptionsGridDto {
    breedId?: number;
    text?: string | undefined;
    breedNames?: VarietyBreedNameDto[] | undefined;
    breedGroupId?: number;
    breedGroupLabel?: string | undefined;

    constructor(data?: IBreedVarietiesAndExceptionsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.text = _data["text"];
            if (Array.isArray(_data["breedNames"])) {
                this.breedNames = [] as any;
                for (let item of _data["breedNames"])
                    this.breedNames!.push(VarietyBreedNameDto.fromJS(item));
            }
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupLabel = _data["breedGroupLabel"];
        }
    }

    static fromJS(data: any): BreedVarietiesAndExceptionsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedVarietiesAndExceptionsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["text"] = this.text;
        if (Array.isArray(this.breedNames)) {
            data["breedNames"] = [];
            for (let item of this.breedNames)
                data["breedNames"].push(item.toJSON());
        }
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupLabel"] = this.breedGroupLabel;
        return data;
    }
}

export interface IBreedVarietiesAndExceptionsGridDto {
    breedId?: number;
    text?: string | undefined;
    breedNames?: VarietyBreedNameDto[] | undefined;
    breedGroupId?: number;
    breedGroupLabel?: string | undefined;
}

export class VarietyBreedNameDto implements IVarietyBreedNameDto {
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: IVarietyBreedNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): VarietyBreedNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new VarietyBreedNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["text"] = this.text;
        return data;
    }
}

export interface IVarietyBreedNameDto {
    code?: string | undefined;
    text?: string | undefined;
}

export class BreedVarietyAndExceptionSearch extends PaginatedSearch implements IBreedVarietyAndExceptionSearch {
    currentBreedId?: number;
    languageId?: number;
    isVariety?: boolean;
    name?: TextSearch | undefined;
    breedGroup?: TextSearch | undefined;

    constructor(data?: IBreedVarietyAndExceptionSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentBreedId = _data["currentBreedId"];
            this.languageId = _data["languageId"];
            this.isVariety = _data["isVariety"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.breedGroup = _data["breedGroup"] ? TextSearch.fromJS(_data["breedGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreedVarietyAndExceptionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedVarietyAndExceptionSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentBreedId"] = this.currentBreedId;
        data["languageId"] = this.languageId;
        data["isVariety"] = this.isVariety;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["breedGroup"] = this.breedGroup ? this.breedGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedVarietyAndExceptionSearch extends IPaginatedSearch {
    currentBreedId?: number;
    languageId?: number;
    isVariety?: boolean;
    name?: TextSearch | undefined;
    breedGroup?: TextSearch | undefined;
}

export class SaveBreedVarietyAndExceptionDto implements ISaveBreedVarietyAndExceptionDto {
    sourceBreedId?: number;
    destinationBreedId?: number;

    constructor(data?: ISaveBreedVarietyAndExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceBreedId = _data["sourceBreedId"];
            this.destinationBreedId = _data["destinationBreedId"];
        }
    }

    static fromJS(data: any): SaveBreedVarietyAndExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBreedVarietyAndExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceBreedId"] = this.sourceBreedId;
        data["destinationBreedId"] = this.destinationBreedId;
        return data;
    }
}

export interface ISaveBreedVarietyAndExceptionDto {
    sourceBreedId?: number;
    destinationBreedId?: number;
}

export class BreedForJudgeSearch extends PaginatedSearch implements IBreedForJudgeSearch {
    breedGroupLabel?: TextSearch | undefined;
    name?: TextSearch | undefined;
    personId?: number;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IBreedForJudgeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.breedGroupLabel = _data["breedGroupLabel"] ? TextSearch.fromJS(_data["breedGroupLabel"]) : <any>undefined;
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.personId = _data["personId"];
            this.languageId = _data["languageId"];
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): BreedForJudgeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedForJudgeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupLabel"] = this.breedGroupLabel ? this.breedGroupLabel.toJSON() : <any>undefined;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["languageId"] = this.languageId;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedForJudgeSearch extends IPaginatedSearch {
    breedGroupLabel?: TextSearch | undefined;
    name?: TextSearch | undefined;
    personId?: number;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class PaginatedResultsOfBreedGroupBreedDto implements IPaginatedResultsOfBreedGroupBreedDto {
    totalCount?: number;
    results?: BreedGroupBreedDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedGroupBreedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedGroupBreedDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedGroupBreedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedGroupBreedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedGroupBreedDto {
    totalCount?: number;
    results?: BreedGroupBreedDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedGroupBreedDto implements IBreedGroupBreedDto {
    breedId?: number;
    name?: string | undefined;
    code?: string | undefined;
    breedGroupId?: number;
    countryId?: number;
    country?: string | undefined;

    constructor(data?: IBreedGroupBreedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.breedGroupId = _data["breedGroupId"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): BreedGroupBreedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupBreedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["breedGroupId"] = this.breedGroupId;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface IBreedGroupBreedDto {
    breedId?: number;
    name?: string | undefined;
    code?: string | undefined;
    breedGroupId?: number;
    countryId?: number;
    country?: string | undefined;
}

export class BreedGroupBreedSearch extends PaginatedSearch implements IBreedGroupBreedSearch {
    languageCode?: string | undefined;
    breedGroupId?: number;

    constructor(data?: IBreedGroupBreedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.breedGroupId = _data["breedGroupId"];
        }
    }

    static fromJS(data: any): BreedGroupBreedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupBreedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["breedGroupId"] = this.breedGroupId;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedGroupBreedSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    breedGroupId?: number;
}

export class BreedGroupBreedSaveDto implements IBreedGroupBreedSaveDto {
    breedGroupId?: number;
    breedIds?: number[] | undefined;

    constructor(data?: IBreedGroupBreedSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            if (Array.isArray(_data["breedIds"])) {
                this.breedIds = [] as any;
                for (let item of _data["breedIds"])
                    this.breedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BreedGroupBreedSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupBreedSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        if (Array.isArray(this.breedIds)) {
            data["breedIds"] = [];
            for (let item of this.breedIds)
                data["breedIds"].push(item);
        }
        return data;
    }
}

export interface IBreedGroupBreedSaveDto {
    breedGroupId?: number;
    breedIds?: number[] | undefined;
}

export class PaginatedResultsOfBreedGroupBreedHierarchyDto implements IPaginatedResultsOfBreedGroupBreedHierarchyDto {
    totalCount?: number;
    results?: BreedGroupBreedHierarchyDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedGroupBreedHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedGroupBreedHierarchyDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedGroupBreedHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedGroupBreedHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedGroupBreedHierarchyDto {
    totalCount?: number;
    results?: BreedGroupBreedHierarchyDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedGroupBreedHierarchyDto implements IBreedGroupBreedHierarchyDto {
    breedGroupId?: number;
    breedGroupNumber?: number;
    remark?: string | undefined;
    breedGroupFullName?: string | undefined;
    breedGroupTranslations?: BreedGroupTranslationDto[] | undefined;
    breeds?: BreedHierarchyDto[] | undefined;
    breedGroupsJudges?: BreedGroupHierarchyJudgeDto[] | undefined;

    constructor(data?: IBreedGroupBreedHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupNumber = _data["breedGroupNumber"];
            this.remark = _data["remark"];
            this.breedGroupFullName = _data["breedGroupFullName"];
            if (Array.isArray(_data["breedGroupTranslations"])) {
                this.breedGroupTranslations = [] as any;
                for (let item of _data["breedGroupTranslations"])
                    this.breedGroupTranslations!.push(BreedGroupTranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["breeds"])) {
                this.breeds = [] as any;
                for (let item of _data["breeds"])
                    this.breeds!.push(BreedHierarchyDto.fromJS(item));
            }
            if (Array.isArray(_data["breedGroupsJudges"])) {
                this.breedGroupsJudges = [] as any;
                for (let item of _data["breedGroupsJudges"])
                    this.breedGroupsJudges!.push(BreedGroupHierarchyJudgeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreedGroupBreedHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupBreedHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupNumber"] = this.breedGroupNumber;
        data["remark"] = this.remark;
        data["breedGroupFullName"] = this.breedGroupFullName;
        if (Array.isArray(this.breedGroupTranslations)) {
            data["breedGroupTranslations"] = [];
            for (let item of this.breedGroupTranslations)
                data["breedGroupTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.breeds)) {
            data["breeds"] = [];
            for (let item of this.breeds)
                data["breeds"].push(item.toJSON());
        }
        if (Array.isArray(this.breedGroupsJudges)) {
            data["breedGroupsJudges"] = [];
            for (let item of this.breedGroupsJudges)
                data["breedGroupsJudges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreedGroupBreedHierarchyDto {
    breedGroupId?: number;
    breedGroupNumber?: number;
    remark?: string | undefined;
    breedGroupFullName?: string | undefined;
    breedGroupTranslations?: BreedGroupTranslationDto[] | undefined;
    breeds?: BreedHierarchyDto[] | undefined;
    breedGroupsJudges?: BreedGroupHierarchyJudgeDto[] | undefined;
}

export class BreedGroupTranslationDto implements IBreedGroupTranslationDto {
    languageId?: number;
    breedGroupId?: number;
    text?: string | undefined;
    breedGroupTranslationId?: number;

    constructor(data?: IBreedGroupTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.breedGroupId = _data["breedGroupId"];
            this.text = _data["text"];
            this.breedGroupTranslationId = _data["breedGroupTranslationId"];
        }
    }

    static fromJS(data: any): BreedGroupTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["breedGroupId"] = this.breedGroupId;
        data["text"] = this.text;
        data["breedGroupTranslationId"] = this.breedGroupTranslationId;
        return data;
    }
}

export interface IBreedGroupTranslationDto {
    languageId?: number;
    breedGroupId?: number;
    text?: string | undefined;
    breedGroupTranslationId?: number;
}

export class BreedHierarchyDto implements IBreedHierarchyDto {
    code?: string | undefined;
    knownBreed?: boolean;
    subjectToWork?: boolean;
    remark?: string | undefined;
    agility?: EDifficulty;
    grooming?: EDifficulty;
    standardConfirmation?: boolean;
    shortenedTail?: boolean;
    merleColorAuthorized?: boolean;
    number?: number;
    sizeMin?: string | undefined;
    sizeMax?: string | undefined;
    breedId?: number;
    breedGroupId?: number;
    countryId?: number;
    breedTranslations?: BreedTranslationDto[] | undefined;
    breedsJudges?: BreedJudgeHierarchyDto[] | undefined;

    constructor(data?: IBreedHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.knownBreed = _data["knownBreed"];
            this.subjectToWork = _data["subjectToWork"];
            this.remark = _data["remark"];
            this.agility = _data["agility"];
            this.grooming = _data["grooming"];
            this.standardConfirmation = _data["standardConfirmation"];
            this.shortenedTail = _data["shortenedTail"];
            this.merleColorAuthorized = _data["merleColorAuthorized"];
            this.number = _data["number"];
            this.sizeMin = _data["sizeMin"];
            this.sizeMax = _data["sizeMax"];
            this.breedId = _data["breedId"];
            this.breedGroupId = _data["breedGroupId"];
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["breedTranslations"])) {
                this.breedTranslations = [] as any;
                for (let item of _data["breedTranslations"])
                    this.breedTranslations!.push(BreedTranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["breedsJudges"])) {
                this.breedsJudges = [] as any;
                for (let item of _data["breedsJudges"])
                    this.breedsJudges!.push(BreedJudgeHierarchyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreedHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["knownBreed"] = this.knownBreed;
        data["subjectToWork"] = this.subjectToWork;
        data["remark"] = this.remark;
        data["agility"] = this.agility;
        data["grooming"] = this.grooming;
        data["standardConfirmation"] = this.standardConfirmation;
        data["shortenedTail"] = this.shortenedTail;
        data["merleColorAuthorized"] = this.merleColorAuthorized;
        data["number"] = this.number;
        data["sizeMin"] = this.sizeMin;
        data["sizeMax"] = this.sizeMax;
        data["breedId"] = this.breedId;
        data["breedGroupId"] = this.breedGroupId;
        data["countryId"] = this.countryId;
        if (Array.isArray(this.breedTranslations)) {
            data["breedTranslations"] = [];
            for (let item of this.breedTranslations)
                data["breedTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.breedsJudges)) {
            data["breedsJudges"] = [];
            for (let item of this.breedsJudges)
                data["breedsJudges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreedHierarchyDto {
    code?: string | undefined;
    knownBreed?: boolean;
    subjectToWork?: boolean;
    remark?: string | undefined;
    agility?: EDifficulty;
    grooming?: EDifficulty;
    standardConfirmation?: boolean;
    shortenedTail?: boolean;
    merleColorAuthorized?: boolean;
    number?: number;
    sizeMin?: string | undefined;
    sizeMax?: string | undefined;
    breedId?: number;
    breedGroupId?: number;
    countryId?: number;
    breedTranslations?: BreedTranslationDto[] | undefined;
    breedsJudges?: BreedJudgeHierarchyDto[] | undefined;
}

export class BreedJudgeHierarchyDto implements IBreedJudgeHierarchyDto {
    breedJudgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;

    constructor(data?: IBreedJudgeHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedJudgeId = _data["breedJudgeId"];
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
        }
    }

    static fromJS(data: any): BreedJudgeHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedJudgeHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedJudgeId"] = this.breedJudgeId;
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        return data;
    }
}

export interface IBreedJudgeHierarchyDto {
    breedJudgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
}

export enum EJudgeType {
    Internship = "Internship",
    Nominated = "Nominated",
}

export class BreedGroupHierarchyJudgeDto implements IBreedGroupHierarchyJudgeDto {
    breedGroupJudgeId?: number;
    judgeId?: number;
    breedGroupId?: number;
    personId?: number;

    constructor(data?: IBreedGroupHierarchyJudgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupJudgeId = _data["breedGroupJudgeId"];
            this.judgeId = _data["judgeId"];
            this.breedGroupId = _data["breedGroupId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): BreedGroupHierarchyJudgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupHierarchyJudgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupJudgeId"] = this.breedGroupJudgeId;
        data["judgeId"] = this.judgeId;
        data["breedGroupId"] = this.breedGroupId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IBreedGroupHierarchyJudgeDto {
    breedGroupJudgeId?: number;
    judgeId?: number;
    breedGroupId?: number;
    personId?: number;
}

export class BreedGroupBreedHierarchySearch extends PaginatedSearch implements IBreedGroupBreedHierarchySearch {
    personId?: number | undefined;

    constructor(data?: IBreedGroupBreedHierarchySearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): BreedGroupBreedHierarchySearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupBreedHierarchySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedGroupBreedHierarchySearch extends IPaginatedSearch {
    personId?: number | undefined;
}

export class PaginatedResultsOfBreedGroupGridDto implements IPaginatedResultsOfBreedGroupGridDto {
    totalCount?: number;
    results?: BreedGroupGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedGroupGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedGroupGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedGroupGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedGroupGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedGroupGridDto {
    totalCount?: number;
    results?: BreedGroupGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedGroupGridDto implements IBreedGroupGridDto {
    breedGroupId?: number;
    breedGroupNumber?: number;
    name?: string | undefined;

    constructor(data?: IBreedGroupGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupNumber = _data["breedGroupNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BreedGroupGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupNumber"] = this.breedGroupNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface IBreedGroupGridDto {
    breedGroupId?: number;
    breedGroupNumber?: number;
    name?: string | undefined;
}

export class BreedGroupSearch extends PaginatedSearch implements IBreedGroupSearch {
    name?: TextSearch | undefined;
    breedGroupNumber?: NumericSearch | undefined;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IBreedGroupSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.breedGroupNumber = _data["breedGroupNumber"] ? NumericSearch.fromJS(_data["breedGroupNumber"]) : <any>undefined;
            this.languageId = _data["languageId"];
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): BreedGroupSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["breedGroupNumber"] = this.breedGroupNumber ? this.breedGroupNumber.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedGroupSearch extends IPaginatedSearch {
    name?: TextSearch | undefined;
    breedGroupNumber?: NumericSearch | undefined;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class BreedGroupDto implements IBreedGroupDto {
    breedGroupId?: number;
    breedGroupNumber?: number;
    remark?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    breedGroupTranslations?: BreedGroupTranslationDto[] | undefined;

    constructor(data?: IBreedGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupNumber = _data["breedGroupNumber"];
            this.remark = _data["remark"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["breedGroupTranslations"])) {
                this.breedGroupTranslations = [] as any;
                for (let item of _data["breedGroupTranslations"])
                    this.breedGroupTranslations!.push(BreedGroupTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreedGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupNumber"] = this.breedGroupNumber;
        data["remark"] = this.remark;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.breedGroupTranslations)) {
            data["breedGroupTranslations"] = [];
            for (let item of this.breedGroupTranslations)
                data["breedGroupTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreedGroupDto {
    breedGroupId?: number;
    breedGroupNumber?: number;
    remark?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    breedGroupTranslations?: BreedGroupTranslationDto[] | undefined;
}

export class BooleanDto implements IBooleanDto {
    value?: boolean;

    constructor(data?: IBooleanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IBooleanDto {
    value?: boolean;
}

export class BreedGroupJudgeSearch extends PaginatedSearch implements IBreedGroupJudgeSearch {
    breedGroupId?: number;
    languageId?: number;

    constructor(data?: IBreedGroupJudgeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): BreedGroupJudgeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupJudgeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedGroupJudgeSearch extends IPaginatedSearch {
    breedGroupId?: number;
    languageId?: number;
}

export class BreedGroupJudgeSaveDto implements IBreedGroupJudgeSaveDto {
    breedGroupId?: number;
    judgeIds?: number[] | undefined;

    constructor(data?: IBreedGroupJudgeSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            if (Array.isArray(_data["judgeIds"])) {
                this.judgeIds = [] as any;
                for (let item of _data["judgeIds"])
                    this.judgeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BreedGroupJudgeSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupJudgeSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        if (Array.isArray(this.judgeIds)) {
            data["judgeIds"] = [];
            for (let item of this.judgeIds)
                data["judgeIds"].push(item);
        }
        return data;
    }
}

export interface IBreedGroupJudgeSaveDto {
    breedGroupId?: number;
    judgeIds?: number[] | undefined;
}

export class BreedGroupJudgeForPersonSearch extends PaginatedSearch implements IBreedGroupJudgeForPersonSearch {
    personId?: number | undefined;
    judgeId?: number | undefined;
    languageId?: number;

    constructor(data?: IBreedGroupJudgeForPersonSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.judgeId = _data["judgeId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): BreedGroupJudgeForPersonSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupJudgeForPersonSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["judgeId"] = this.judgeId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedGroupJudgeForPersonSearch extends IPaginatedSearch {
    personId?: number | undefined;
    judgeId?: number | undefined;
    languageId?: number;
}

export class PaginatedResultsOfBreedJudgeGridDto implements IPaginatedResultsOfBreedJudgeGridDto {
    totalCount?: number;
    results?: BreedJudgeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedJudgeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedJudgeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedJudgeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedJudgeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedJudgeGridDto {
    totalCount?: number;
    results?: BreedJudgeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedJudgeGridDto implements IBreedJudgeGridDto {
    breedJudgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    breedId?: number;
    breedName?: string | undefined;
    breedGroupId?: number;
    breedGroupLabel?: string | undefined;
    breedGroupNumber?: number;
    country?: string | undefined;
    breedGroupFullName?: string | undefined;

    constructor(data?: IBreedJudgeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedJudgeId = _data["breedJudgeId"];
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.computedName = _data["computedName"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.breedId = _data["breedId"];
            this.breedName = _data["breedName"];
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupLabel = _data["breedGroupLabel"];
            this.breedGroupNumber = _data["breedGroupNumber"];
            this.country = _data["country"];
            this.breedGroupFullName = _data["breedGroupFullName"];
        }
    }

    static fromJS(data: any): BreedJudgeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedJudgeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedJudgeId"] = this.breedJudgeId;
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["computedName"] = this.computedName;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["breedId"] = this.breedId;
        data["breedName"] = this.breedName;
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupLabel"] = this.breedGroupLabel;
        data["breedGroupNumber"] = this.breedGroupNumber;
        data["country"] = this.country;
        data["breedGroupFullName"] = this.breedGroupFullName;
        return data;
    }
}

export interface IBreedJudgeGridDto {
    breedJudgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    breedId?: number;
    breedName?: string | undefined;
    breedGroupId?: number;
    breedGroupLabel?: string | undefined;
    breedGroupNumber?: number;
    country?: string | undefined;
    breedGroupFullName?: string | undefined;
}

export class SelectorSearchOfInteger extends PaginatedSearch implements ISelectorSearchOfInteger {
    selectedIds?: number[] | undefined;
    availableIds?: number[] | undefined;

    constructor(data?: ISelectorSearchOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            if (Array.isArray(_data["availableIds"])) {
                this.availableIds = [] as any;
                for (let item of _data["availableIds"])
                    this.availableIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SelectorSearchOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorSearchOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        if (Array.isArray(this.availableIds)) {
            data["availableIds"] = [];
            for (let item of this.availableIds)
                data["availableIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISelectorSearchOfInteger extends IPaginatedSearch {
    selectedIds?: number[] | undefined;
    availableIds?: number[] | undefined;
}

export class BreedJudgeSearch extends SelectorSearchOfInteger implements IBreedJudgeSearch {
    languageId?: number;
    breedId?: number | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
    lastName?: TextSearch | undefined;
    firstName?: TextSearch | undefined;

    constructor(data?: IBreedJudgeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.breedId = _data["breedId"];
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreedJudgeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedJudgeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["breedId"] = this.breedId;
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedJudgeSearch extends ISelectorSearchOfInteger {
    languageId?: number;
    breedId?: number | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
    lastName?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
}

export class SaveBreedJudgeDto implements ISaveBreedJudgeDto {
    breedJudgeId?: number;
    breedId?: number;
    breedName?: string | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
    healthPackIds?: number[] | undefined;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;

    constructor(data?: ISaveBreedJudgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedJudgeId = _data["breedJudgeId"];
            this.breedId = _data["breedId"];
            this.breedName = _data["breedName"];
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            if (Array.isArray(_data["healthPackIds"])) {
                this.healthPackIds = [] as any;
                for (let item of _data["healthPackIds"])
                    this.healthPackIds!.push(item);
            }
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveBreedJudgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBreedJudgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedJudgeId"] = this.breedJudgeId;
        data["breedId"] = this.breedId;
        data["breedName"] = this.breedName;
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        if (Array.isArray(this.healthPackIds)) {
            data["healthPackIds"] = [];
            for (let item of this.healthPackIds)
                data["healthPackIds"].push(item);
        }
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveBreedJudgeDto {
    breedJudgeId?: number;
    breedId?: number;
    breedName?: string | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
    healthPackIds?: number[] | undefined;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
}

export class BreedsColorsSearch extends PaginatedSearch implements IBreedsColorsSearch {
    languageId?: number;
    breedColorId?: number;
    colorId?: number;
    breedId?: number;
    recognizedColor?: BooleanSearch | undefined;
    authorizedBreeding?: BooleanSearch | undefined;

    constructor(data?: IBreedsColorsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.breedColorId = _data["breedColorId"];
            this.colorId = _data["colorId"];
            this.breedId = _data["breedId"];
            this.recognizedColor = _data["recognizedColor"] ? BooleanSearch.fromJS(_data["recognizedColor"]) : <any>undefined;
            this.authorizedBreeding = _data["authorizedBreeding"] ? BooleanSearch.fromJS(_data["authorizedBreeding"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BreedsColorsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedsColorsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["breedColorId"] = this.breedColorId;
        data["colorId"] = this.colorId;
        data["breedId"] = this.breedId;
        data["recognizedColor"] = this.recognizedColor ? this.recognizedColor.toJSON() : <any>undefined;
        data["authorizedBreeding"] = this.authorizedBreeding ? this.authorizedBreeding.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedsColorsSearch extends IPaginatedSearch {
    languageId?: number;
    breedColorId?: number;
    colorId?: number;
    breedId?: number;
    recognizedColor?: BooleanSearch | undefined;
    authorizedBreeding?: BooleanSearch | undefined;
}

export class PaginatedResultsOfColorDto implements IPaginatedResultsOfColorDto {
    totalCount?: number;
    results?: ColorDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfColorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ColorDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfColorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfColorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfColorDto {
    totalCount?: number;
    results?: ColorDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ColorDto implements IColorDto {
    colorId?: number;
    code?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    isMerle?: boolean;
    official?: boolean;
    colorTranslations?: ColorTranslationDto[] | undefined;

    constructor(data?: IColorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorId = _data["colorId"];
            this.code = _data["code"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.isMerle = _data["isMerle"];
            this.official = _data["official"];
            if (Array.isArray(_data["colorTranslations"])) {
                this.colorTranslations = [] as any;
                for (let item of _data["colorTranslations"])
                    this.colorTranslations!.push(ColorTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ColorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorId"] = this.colorId;
        data["code"] = this.code;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["isMerle"] = this.isMerle;
        data["official"] = this.official;
        if (Array.isArray(this.colorTranslations)) {
            data["colorTranslations"] = [];
            for (let item of this.colorTranslations)
                data["colorTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IColorDto {
    colorId?: number;
    code?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    isMerle?: boolean;
    official?: boolean;
    colorTranslations?: ColorTranslationDto[] | undefined;
}

export class ColorTranslationDto implements IColorTranslationDto {
    colorId?: number;
    languageId?: number;
    text?: string | undefined;
    colorTranslationId?: number;

    constructor(data?: IColorTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorId = _data["colorId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.colorTranslationId = _data["colorTranslationId"];
        }
    }

    static fromJS(data: any): ColorTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColorTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorId"] = this.colorId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["colorTranslationId"] = this.colorTranslationId;
        return data;
    }
}

export interface IColorTranslationDto {
    colorId?: number;
    languageId?: number;
    text?: string | undefined;
    colorTranslationId?: number;
}

export class AvailableColorForBreedSearch extends PaginatedSearch implements IAvailableColorForBreedSearch {
    languageId?: number;
    colorId?: number;
    breedId?: number;
    official?: BooleanSearch | undefined;
    officialName?: TextSearch | undefined;

    constructor(data?: IAvailableColorForBreedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.colorId = _data["colorId"];
            this.breedId = _data["breedId"];
            this.official = _data["official"] ? BooleanSearch.fromJS(_data["official"]) : <any>undefined;
            this.officialName = _data["officialName"] ? TextSearch.fromJS(_data["officialName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailableColorForBreedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableColorForBreedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["colorId"] = this.colorId;
        data["breedId"] = this.breedId;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["officialName"] = this.officialName ? this.officialName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailableColorForBreedSearch extends IPaginatedSearch {
    languageId?: number;
    colorId?: number;
    breedId?: number;
    official?: BooleanSearch | undefined;
    officialName?: TextSearch | undefined;
}

export class SaveBreedAllowedColorsDto implements ISaveBreedAllowedColorsDto {
    breedId?: number;
    colorId?: number;
    authorizedBreeding?: boolean;

    constructor(data?: ISaveBreedAllowedColorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.authorizedBreeding = _data["authorizedBreeding"];
        }
    }

    static fromJS(data: any): SaveBreedAllowedColorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBreedAllowedColorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["authorizedBreeding"] = this.authorizedBreeding;
        return data;
    }
}

export interface ISaveBreedAllowedColorsDto {
    breedId?: number;
    colorId?: number;
    authorizedBreeding?: boolean;
}

export class PaginatedResultsOfBreedWorkbookTypeDto implements IPaginatedResultsOfBreedWorkbookTypeDto {
    totalCount?: number;
    results?: BreedWorkbookTypeDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBreedWorkbookTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BreedWorkbookTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBreedWorkbookTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBreedWorkbookTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBreedWorkbookTypeDto {
    totalCount?: number;
    results?: BreedWorkbookTypeDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BreedWorkbookTypeDto implements IBreedWorkbookTypeDto {
    breedId?: number;
    breedName?: string | undefined;

    constructor(data?: IBreedWorkbookTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.breedName = _data["breedName"];
        }
    }

    static fromJS(data: any): BreedWorkbookTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedWorkbookTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["breedName"] = this.breedName;
        return data;
    }
}

export interface IBreedWorkbookTypeDto {
    breedId?: number;
    breedName?: string | undefined;
}

export class BreedWorkbookTypeSearch extends PaginatedSearch implements IBreedWorkbookTypeSearch {
    languageId?: number;
    workbookTypeId?: number;

    constructor(data?: IBreedWorkbookTypeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.workbookTypeId = _data["workbookTypeId"];
        }
    }

    static fromJS(data: any): BreedWorkbookTypeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BreedWorkbookTypeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["workbookTypeId"] = this.workbookTypeId;
        super.toJSON(data);
        return data;
    }
}

export interface IBreedWorkbookTypeSearch extends IPaginatedSearch {
    languageId?: number;
    workbookTypeId?: number;
}

export class SaveWorkbookTypeAllowedBreedsDto implements ISaveWorkbookTypeAllowedBreedsDto {
    workbookTypeId?: number;
    breedIds?: number[] | undefined;

    constructor(data?: ISaveWorkbookTypeAllowedBreedsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeId = _data["workbookTypeId"];
            if (Array.isArray(_data["breedIds"])) {
                this.breedIds = [] as any;
                for (let item of _data["breedIds"])
                    this.breedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveWorkbookTypeAllowedBreedsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkbookTypeAllowedBreedsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeId"] = this.workbookTypeId;
        if (Array.isArray(this.breedIds)) {
            data["breedIds"] = [];
            for (let item of this.breedIds)
                data["breedIds"].push(item);
        }
        return data;
    }
}

export interface ISaveWorkbookTypeAllowedBreedsDto {
    workbookTypeId?: number;
    breedIds?: number[] | undefined;
}

export class PaginatedResultsOfBroodRequestGridDto implements IPaginatedResultsOfBroodRequestGridDto {
    totalCount?: number;
    results?: BroodRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfBroodRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BroodRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfBroodRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfBroodRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfBroodRequestGridDto {
    totalCount?: number;
    results?: BroodRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class BroodRequestGridDto implements IBroodRequestGridDto {
    broodRequestId?: number;
    requestId?: number;
    requestState?: string | undefined;
    requestStateId?: number;
    personId?: number;
    contact?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    requestStateCode?: ERequestState;
    motherId?: number;
    numberOfPuppies?: number;
    protrusionDate?: Date;
    birthDate?: Date | undefined;
    request?: Request | undefined;
    mother?: string | undefined;
    invoiceNumber?: string | undefined;
    isBrcsRequest?: boolean;

    constructor(data?: IBroodRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broodRequestId = _data["broodRequestId"];
            this.requestId = _data["requestId"];
            this.requestState = _data["requestState"];
            this.requestStateId = _data["requestStateId"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.requestStateCode = _data["requestStateCode"];
            this.motherId = _data["motherId"];
            this.numberOfPuppies = _data["numberOfPuppies"];
            this.protrusionDate = _data["protrusionDate"] ? new Date(_data["protrusionDate"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.mother = _data["mother"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.isBrcsRequest = _data["isBrcsRequest"];
        }
    }

    static fromJS(data: any): BroodRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestId"] = this.broodRequestId;
        data["requestId"] = this.requestId;
        data["requestState"] = this.requestState;
        data["requestStateId"] = this.requestStateId;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["requestStateCode"] = this.requestStateCode;
        data["motherId"] = this.motherId;
        data["numberOfPuppies"] = this.numberOfPuppies;
        data["protrusionDate"] = this.protrusionDate ? this.protrusionDate.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["mother"] = this.mother;
        data["invoiceNumber"] = this.invoiceNumber;
        data["isBrcsRequest"] = this.isBrcsRequest;
        return data;
    }
}

export interface IBroodRequestGridDto {
    broodRequestId?: number;
    requestId?: number;
    requestState?: string | undefined;
    requestStateId?: number;
    personId?: number;
    contact?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    requestStateCode?: ERequestState;
    motherId?: number;
    numberOfPuppies?: number;
    protrusionDate?: Date;
    birthDate?: Date | undefined;
    request?: Request | undefined;
    mother?: string | undefined;
    invoiceNumber?: string | undefined;
    isBrcsRequest?: boolean;
}

export class Request implements IRequest {
    requestId?: number;
    requestTypeId?: number;
    parentRequestId?: number | undefined;
    requestStatusId?: number;
    previousRequestStatusId?: number | undefined;
    personId?: number;
    managerId?: number | undefined;
    sentBillReminders?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    sharepointUri?: string | undefined;
    isOnline?: boolean;
    remark?: string | undefined;
    isBlocked?: boolean;
    isBilledFromPortal?: boolean;
    executionDate?: Date | undefined;
    cegekaId?: string | undefined;
    lastStatusChangeDate?: Date | undefined;
    missingInformationRequestDate?: Date | undefined;
    person?: Person | undefined;
    manager?: User | undefined;
    parentRequest?: Request | undefined;
    requestStatus?: RequestStatus | undefined;
    previousRequestStatus?: RequestStatus | undefined;
    requestType?: RequestType | undefined;
    subRequests?: Request[] | undefined;
    dashboardTasks?: DashboardTask[] | undefined;
    invoices?: Invoice[] | undefined;
    broodRequests?: BroodRequest[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    dogOwnershipChangeRequests?: DogOwnershipChangeRequest[] | undefined;
    conditionForcedValues?: ConditionsForcedValue[] | undefined;
    verificationValues?: VerificationsValue[] | undefined;
    dogTempOwnershipChangeRequests?: DogTempOwnershipChangeRequest[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    expatriationRequests?: ExpatriationRequest[] | undefined;
    dysplasiaAppealRequests?: DysplasiaRequest[] | undefined;
    healthTestRequests?: HealthTestRequest[] | undefined;
    importRequests?: ImportRequest[] | undefined;
    kennelImportRequests?: KennelImportRequest[] | undefined;
    kennelExportRequests?: KennelExportRequest[] | undefined;
    kennelNameChangeRequests?: KennelNameChangeRequest[] | undefined;
    kennelOwnershipChangeRequests?: KennelOwnershipChangeRequest[] | undefined;
    newKennelRequests?: NewKennelRequest[] | undefined;
    pedigreeRequests?: PedigreeRequest[] | undefined;
    pedigreeDuplicataRequests?: PedigreeDuplicataRequest[] | undefined;
    membershipRequests?: MembershipRequest[] | undefined;
    titleRequests?: TitleRequest[] | undefined;
    workAttestRequests?: WorkAttestRequest[] | undefined;
    workbookRequests?: WorkbookRequest[] | undefined;
    requestActions?: RequestAction[] | undefined;
    miscellaneousRequests?: MiscellaneousRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
            this.parentRequestId = _data["parentRequestId"];
            this.requestStatusId = _data["requestStatusId"];
            this.previousRequestStatusId = _data["previousRequestStatusId"];
            this.personId = _data["personId"];
            this.managerId = _data["managerId"];
            this.sentBillReminders = _data["sentBillReminders"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.sharepointUri = _data["sharepointUri"];
            this.isOnline = _data["isOnline"];
            this.remark = _data["remark"];
            this.isBlocked = _data["isBlocked"];
            this.isBilledFromPortal = _data["isBilledFromPortal"];
            this.executionDate = _data["executionDate"] ? new Date(_data["executionDate"].toString()) : <any>undefined;
            this.cegekaId = _data["cegekaId"];
            this.lastStatusChangeDate = _data["lastStatusChangeDate"] ? new Date(_data["lastStatusChangeDate"].toString()) : <any>undefined;
            this.missingInformationRequestDate = _data["missingInformationRequestDate"] ? new Date(_data["missingInformationRequestDate"].toString()) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>undefined;
            this.parentRequest = _data["parentRequest"] ? Request.fromJS(_data["parentRequest"]) : <any>undefined;
            this.requestStatus = _data["requestStatus"] ? RequestStatus.fromJS(_data["requestStatus"]) : <any>undefined;
            this.previousRequestStatus = _data["previousRequestStatus"] ? RequestStatus.fromJS(_data["previousRequestStatus"]) : <any>undefined;
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            if (Array.isArray(_data["subRequests"])) {
                this.subRequests = [] as any;
                for (let item of _data["subRequests"])
                    this.subRequests!.push(Request.fromJS(item));
            }
            if (Array.isArray(_data["dashboardTasks"])) {
                this.dashboardTasks = [] as any;
                for (let item of _data["dashboardTasks"])
                    this.dashboardTasks!.push(DashboardTask.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
            if (Array.isArray(_data["broodRequests"])) {
                this.broodRequests = [] as any;
                for (let item of _data["broodRequests"])
                    this.broodRequests!.push(BroodRequest.fromJS(item));
            }
            if (Array.isArray(_data["competitionRequests"])) {
                this.competitionRequests = [] as any;
                for (let item of _data["competitionRequests"])
                    this.competitionRequests!.push(CompetitionRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogOwnershipChangeRequests"])) {
                this.dogOwnershipChangeRequests = [] as any;
                for (let item of _data["dogOwnershipChangeRequests"])
                    this.dogOwnershipChangeRequests!.push(DogOwnershipChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["conditionForcedValues"])) {
                this.conditionForcedValues = [] as any;
                for (let item of _data["conditionForcedValues"])
                    this.conditionForcedValues!.push(ConditionsForcedValue.fromJS(item));
            }
            if (Array.isArray(_data["verificationValues"])) {
                this.verificationValues = [] as any;
                for (let item of _data["verificationValues"])
                    this.verificationValues!.push(VerificationsValue.fromJS(item));
            }
            if (Array.isArray(_data["dogTempOwnershipChangeRequests"])) {
                this.dogTempOwnershipChangeRequests = [] as any;
                for (let item of _data["dogTempOwnershipChangeRequests"])
                    this.dogTempOwnershipChangeRequests!.push(DogTempOwnershipChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["dysplasiaRequests"])) {
                this.dysplasiaRequests = [] as any;
                for (let item of _data["dysplasiaRequests"])
                    this.dysplasiaRequests!.push(DysplasiaRequest.fromJS(item));
            }
            if (Array.isArray(_data["expatriationRequests"])) {
                this.expatriationRequests = [] as any;
                for (let item of _data["expatriationRequests"])
                    this.expatriationRequests!.push(ExpatriationRequest.fromJS(item));
            }
            if (Array.isArray(_data["dysplasiaAppealRequests"])) {
                this.dysplasiaAppealRequests = [] as any;
                for (let item of _data["dysplasiaAppealRequests"])
                    this.dysplasiaAppealRequests!.push(DysplasiaRequest.fromJS(item));
            }
            if (Array.isArray(_data["healthTestRequests"])) {
                this.healthTestRequests = [] as any;
                for (let item of _data["healthTestRequests"])
                    this.healthTestRequests!.push(HealthTestRequest.fromJS(item));
            }
            if (Array.isArray(_data["importRequests"])) {
                this.importRequests = [] as any;
                for (let item of _data["importRequests"])
                    this.importRequests!.push(ImportRequest.fromJS(item));
            }
            if (Array.isArray(_data["kennelImportRequests"])) {
                this.kennelImportRequests = [] as any;
                for (let item of _data["kennelImportRequests"])
                    this.kennelImportRequests!.push(KennelImportRequest.fromJS(item));
            }
            if (Array.isArray(_data["kennelExportRequests"])) {
                this.kennelExportRequests = [] as any;
                for (let item of _data["kennelExportRequests"])
                    this.kennelExportRequests!.push(KennelExportRequest.fromJS(item));
            }
            if (Array.isArray(_data["kennelNameChangeRequests"])) {
                this.kennelNameChangeRequests = [] as any;
                for (let item of _data["kennelNameChangeRequests"])
                    this.kennelNameChangeRequests!.push(KennelNameChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["kennelOwnershipChangeRequests"])) {
                this.kennelOwnershipChangeRequests = [] as any;
                for (let item of _data["kennelOwnershipChangeRequests"])
                    this.kennelOwnershipChangeRequests!.push(KennelOwnershipChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["newKennelRequests"])) {
                this.newKennelRequests = [] as any;
                for (let item of _data["newKennelRequests"])
                    this.newKennelRequests!.push(NewKennelRequest.fromJS(item));
            }
            if (Array.isArray(_data["pedigreeRequests"])) {
                this.pedigreeRequests = [] as any;
                for (let item of _data["pedigreeRequests"])
                    this.pedigreeRequests!.push(PedigreeRequest.fromJS(item));
            }
            if (Array.isArray(_data["pedigreeDuplicataRequests"])) {
                this.pedigreeDuplicataRequests = [] as any;
                for (let item of _data["pedigreeDuplicataRequests"])
                    this.pedigreeDuplicataRequests!.push(PedigreeDuplicataRequest.fromJS(item));
            }
            if (Array.isArray(_data["membershipRequests"])) {
                this.membershipRequests = [] as any;
                for (let item of _data["membershipRequests"])
                    this.membershipRequests!.push(MembershipRequest.fromJS(item));
            }
            if (Array.isArray(_data["titleRequests"])) {
                this.titleRequests = [] as any;
                for (let item of _data["titleRequests"])
                    this.titleRequests!.push(TitleRequest.fromJS(item));
            }
            if (Array.isArray(_data["workAttestRequests"])) {
                this.workAttestRequests = [] as any;
                for (let item of _data["workAttestRequests"])
                    this.workAttestRequests!.push(WorkAttestRequest.fromJS(item));
            }
            if (Array.isArray(_data["workbookRequests"])) {
                this.workbookRequests = [] as any;
                for (let item of _data["workbookRequests"])
                    this.workbookRequests!.push(WorkbookRequest.fromJS(item));
            }
            if (Array.isArray(_data["requestActions"])) {
                this.requestActions = [] as any;
                for (let item of _data["requestActions"])
                    this.requestActions!.push(RequestAction.fromJS(item));
            }
            if (Array.isArray(_data["miscellaneousRequests"])) {
                this.miscellaneousRequests = [] as any;
                for (let item of _data["miscellaneousRequests"])
                    this.miscellaneousRequests!.push(MiscellaneousRequest.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        data["parentRequestId"] = this.parentRequestId;
        data["requestStatusId"] = this.requestStatusId;
        data["previousRequestStatusId"] = this.previousRequestStatusId;
        data["personId"] = this.personId;
        data["managerId"] = this.managerId;
        data["sentBillReminders"] = this.sentBillReminders;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["sharepointUri"] = this.sharepointUri;
        data["isOnline"] = this.isOnline;
        data["remark"] = this.remark;
        data["isBlocked"] = this.isBlocked;
        data["isBilledFromPortal"] = this.isBilledFromPortal;
        data["executionDate"] = this.executionDate ? this.executionDate.toISOString() : <any>undefined;
        data["cegekaId"] = this.cegekaId;
        data["lastStatusChangeDate"] = this.lastStatusChangeDate ? this.lastStatusChangeDate.toISOString() : <any>undefined;
        data["missingInformationRequestDate"] = this.missingInformationRequestDate ? this.missingInformationRequestDate.toISOString() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        data["parentRequest"] = this.parentRequest ? this.parentRequest.toJSON() : <any>undefined;
        data["requestStatus"] = this.requestStatus ? this.requestStatus.toJSON() : <any>undefined;
        data["previousRequestStatus"] = this.previousRequestStatus ? this.previousRequestStatus.toJSON() : <any>undefined;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        if (Array.isArray(this.subRequests)) {
            data["subRequests"] = [];
            for (let item of this.subRequests)
                data["subRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dashboardTasks)) {
            data["dashboardTasks"] = [];
            for (let item of this.dashboardTasks)
                data["dashboardTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.broodRequests)) {
            data["broodRequests"] = [];
            for (let item of this.broodRequests)
                data["broodRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionRequests)) {
            data["competitionRequests"] = [];
            for (let item of this.competitionRequests)
                data["competitionRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogOwnershipChangeRequests)) {
            data["dogOwnershipChangeRequests"] = [];
            for (let item of this.dogOwnershipChangeRequests)
                data["dogOwnershipChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionForcedValues)) {
            data["conditionForcedValues"] = [];
            for (let item of this.conditionForcedValues)
                data["conditionForcedValues"].push(item.toJSON());
        }
        if (Array.isArray(this.verificationValues)) {
            data["verificationValues"] = [];
            for (let item of this.verificationValues)
                data["verificationValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTempOwnershipChangeRequests)) {
            data["dogTempOwnershipChangeRequests"] = [];
            for (let item of this.dogTempOwnershipChangeRequests)
                data["dogTempOwnershipChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dysplasiaRequests)) {
            data["dysplasiaRequests"] = [];
            for (let item of this.dysplasiaRequests)
                data["dysplasiaRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.expatriationRequests)) {
            data["expatriationRequests"] = [];
            for (let item of this.expatriationRequests)
                data["expatriationRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dysplasiaAppealRequests)) {
            data["dysplasiaAppealRequests"] = [];
            for (let item of this.dysplasiaAppealRequests)
                data["dysplasiaAppealRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestRequests)) {
            data["healthTestRequests"] = [];
            for (let item of this.healthTestRequests)
                data["healthTestRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.importRequests)) {
            data["importRequests"] = [];
            for (let item of this.importRequests)
                data["importRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelImportRequests)) {
            data["kennelImportRequests"] = [];
            for (let item of this.kennelImportRequests)
                data["kennelImportRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelExportRequests)) {
            data["kennelExportRequests"] = [];
            for (let item of this.kennelExportRequests)
                data["kennelExportRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelNameChangeRequests)) {
            data["kennelNameChangeRequests"] = [];
            for (let item of this.kennelNameChangeRequests)
                data["kennelNameChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelOwnershipChangeRequests)) {
            data["kennelOwnershipChangeRequests"] = [];
            for (let item of this.kennelOwnershipChangeRequests)
                data["kennelOwnershipChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.newKennelRequests)) {
            data["newKennelRequests"] = [];
            for (let item of this.newKennelRequests)
                data["newKennelRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.pedigreeRequests)) {
            data["pedigreeRequests"] = [];
            for (let item of this.pedigreeRequests)
                data["pedigreeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.pedigreeDuplicataRequests)) {
            data["pedigreeDuplicataRequests"] = [];
            for (let item of this.pedigreeDuplicataRequests)
                data["pedigreeDuplicataRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipRequests)) {
            data["membershipRequests"] = [];
            for (let item of this.membershipRequests)
                data["membershipRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.titleRequests)) {
            data["titleRequests"] = [];
            for (let item of this.titleRequests)
                data["titleRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.workAttestRequests)) {
            data["workAttestRequests"] = [];
            for (let item of this.workAttestRequests)
                data["workAttestRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.workbookRequests)) {
            data["workbookRequests"] = [];
            for (let item of this.workbookRequests)
                data["workbookRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.requestActions)) {
            data["requestActions"] = [];
            for (let item of this.requestActions)
                data["requestActions"].push(item.toJSON());
        }
        if (Array.isArray(this.miscellaneousRequests)) {
            data["miscellaneousRequests"] = [];
            for (let item of this.miscellaneousRequests)
                data["miscellaneousRequests"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRequest {
    requestId?: number;
    requestTypeId?: number;
    parentRequestId?: number | undefined;
    requestStatusId?: number;
    previousRequestStatusId?: number | undefined;
    personId?: number;
    managerId?: number | undefined;
    sentBillReminders?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    sharepointUri?: string | undefined;
    isOnline?: boolean;
    remark?: string | undefined;
    isBlocked?: boolean;
    isBilledFromPortal?: boolean;
    executionDate?: Date | undefined;
    cegekaId?: string | undefined;
    lastStatusChangeDate?: Date | undefined;
    missingInformationRequestDate?: Date | undefined;
    person?: Person | undefined;
    manager?: User | undefined;
    parentRequest?: Request | undefined;
    requestStatus?: RequestStatus | undefined;
    previousRequestStatus?: RequestStatus | undefined;
    requestType?: RequestType | undefined;
    subRequests?: Request[] | undefined;
    dashboardTasks?: DashboardTask[] | undefined;
    invoices?: Invoice[] | undefined;
    broodRequests?: BroodRequest[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    dogOwnershipChangeRequests?: DogOwnershipChangeRequest[] | undefined;
    conditionForcedValues?: ConditionsForcedValue[] | undefined;
    verificationValues?: VerificationsValue[] | undefined;
    dogTempOwnershipChangeRequests?: DogTempOwnershipChangeRequest[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    expatriationRequests?: ExpatriationRequest[] | undefined;
    dysplasiaAppealRequests?: DysplasiaRequest[] | undefined;
    healthTestRequests?: HealthTestRequest[] | undefined;
    importRequests?: ImportRequest[] | undefined;
    kennelImportRequests?: KennelImportRequest[] | undefined;
    kennelExportRequests?: KennelExportRequest[] | undefined;
    kennelNameChangeRequests?: KennelNameChangeRequest[] | undefined;
    kennelOwnershipChangeRequests?: KennelOwnershipChangeRequest[] | undefined;
    newKennelRequests?: NewKennelRequest[] | undefined;
    pedigreeRequests?: PedigreeRequest[] | undefined;
    pedigreeDuplicataRequests?: PedigreeDuplicataRequest[] | undefined;
    membershipRequests?: MembershipRequest[] | undefined;
    titleRequests?: TitleRequest[] | undefined;
    workAttestRequests?: WorkAttestRequest[] | undefined;
    workbookRequests?: WorkbookRequest[] | undefined;
    requestActions?: RequestAction[] | undefined;
    miscellaneousRequests?: MiscellaneousRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Person implements IPerson {
    personId?: number;
    personHonorificId?: number | undefined;
    deathDate?: Date | undefined;
    birthDate?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    languageId?: number;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    vatNumber?: string | undefined;
    bannedFrom?: Date | undefined;
    bannedTo?: Date | undefined;
    isBadPayer?: boolean;
    receiveNewsletterFrom?: Date | undefined;
    receiveNewsletterTo?: Date | undefined;
    as400ContactNumber?: number | undefined;
    remark?: string | undefined;
    sharepointUri?: string | undefined;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    societyName?: string | undefined;
    cegekaId?: string | undefined;
    parentPersonId?: number | undefined;
    computedName?: string | undefined;
    isKnownPerson?: boolean;
    personHonorific?: PersonHonorific | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    breeder?: Breeder | undefined;
    parentPerson?: Person | undefined;
    webUsers?: WebUser[] | undefined;
    dogBroodRequestTransientOwners?: DogBroodRequestTransientOwner[] | undefined;
    transientPedigreeRequestOwners?: TransientPedigreeRequestOwner[] | undefined;
    personActions?: PersonAction[] | undefined;
    veterinarians?: Veterinary[] | undefined;
    chartSignaturesHistories?: ChartSignaturesHistory[] | undefined;
    judges?: Judge[] | undefined;
    members?: Member[] | undefined;
    dogsOwnerships?: DogOwnership[] | undefined;
    kennelsOwnerships?: KennelOwnership[] | undefined;
    parentPeople?: Person[] | undefined;
    requests?: Request[] | undefined;
    clubsContacts?: ClubContact[] | undefined;
    dogsOwnershipsTransients?: DogOwnershipTransient[] | undefined;
    importRequestTransientOwnerships?: ImportRequestTransientOwnership[] | undefined;
    dogTempOwnershipChangeRequests?: DogTempOwnershipChangeRequest[] | undefined;
    transientNewKennelOwners?: TransientNewKennelOwner[] | undefined;
    transientKennelImportOwners?: TransientKennelImportOwner[] | undefined;
    transientOwnersKennelOwnershipChanges?: TransientOwnersKennelOwnershipChange[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    commissioner?: Commissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.personHonorificId = _data["personHonorificId"];
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageId = _data["languageId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.vatNumber = _data["vatNumber"];
            this.bannedFrom = _data["bannedFrom"] ? new Date(_data["bannedFrom"].toString()) : <any>undefined;
            this.bannedTo = _data["bannedTo"] ? new Date(_data["bannedTo"].toString()) : <any>undefined;
            this.isBadPayer = _data["isBadPayer"];
            this.receiveNewsletterFrom = _data["receiveNewsletterFrom"] ? new Date(_data["receiveNewsletterFrom"].toString()) : <any>undefined;
            this.receiveNewsletterTo = _data["receiveNewsletterTo"] ? new Date(_data["receiveNewsletterTo"].toString()) : <any>undefined;
            this.as400ContactNumber = _data["as400ContactNumber"];
            this.remark = _data["remark"];
            this.sharepointUri = _data["sharepointUri"];
            this.bcIdentifier = _data["bcIdentifier"];
            this.brcsBcIdentifier = _data["brcsBcIdentifier"];
            this.societyName = _data["societyName"];
            this.cegekaId = _data["cegekaId"];
            this.parentPersonId = _data["parentPersonId"];
            this.computedName = _data["computedName"];
            this.isKnownPerson = _data["isKnownPerson"];
            this.personHonorific = _data["personHonorific"] ? PersonHonorific.fromJS(_data["personHonorific"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.breeder = _data["breeder"] ? Breeder.fromJS(_data["breeder"]) : <any>undefined;
            this.parentPerson = _data["parentPerson"] ? Person.fromJS(_data["parentPerson"]) : <any>undefined;
            if (Array.isArray(_data["webUsers"])) {
                this.webUsers = [] as any;
                for (let item of _data["webUsers"])
                    this.webUsers!.push(WebUser.fromJS(item));
            }
            if (Array.isArray(_data["dogBroodRequestTransientOwners"])) {
                this.dogBroodRequestTransientOwners = [] as any;
                for (let item of _data["dogBroodRequestTransientOwners"])
                    this.dogBroodRequestTransientOwners!.push(DogBroodRequestTransientOwner.fromJS(item));
            }
            if (Array.isArray(_data["transientPedigreeRequestOwners"])) {
                this.transientPedigreeRequestOwners = [] as any;
                for (let item of _data["transientPedigreeRequestOwners"])
                    this.transientPedigreeRequestOwners!.push(TransientPedigreeRequestOwner.fromJS(item));
            }
            if (Array.isArray(_data["personActions"])) {
                this.personActions = [] as any;
                for (let item of _data["personActions"])
                    this.personActions!.push(PersonAction.fromJS(item));
            }
            if (Array.isArray(_data["veterinarians"])) {
                this.veterinarians = [] as any;
                for (let item of _data["veterinarians"])
                    this.veterinarians!.push(Veterinary.fromJS(item));
            }
            if (Array.isArray(_data["chartSignaturesHistories"])) {
                this.chartSignaturesHistories = [] as any;
                for (let item of _data["chartSignaturesHistories"])
                    this.chartSignaturesHistories!.push(ChartSignaturesHistory.fromJS(item));
            }
            if (Array.isArray(_data["judges"])) {
                this.judges = [] as any;
                for (let item of _data["judges"])
                    this.judges!.push(Judge.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(Member.fromJS(item));
            }
            if (Array.isArray(_data["dogsOwnerships"])) {
                this.dogsOwnerships = [] as any;
                for (let item of _data["dogsOwnerships"])
                    this.dogsOwnerships!.push(DogOwnership.fromJS(item));
            }
            if (Array.isArray(_data["kennelsOwnerships"])) {
                this.kennelsOwnerships = [] as any;
                for (let item of _data["kennelsOwnerships"])
                    this.kennelsOwnerships!.push(KennelOwnership.fromJS(item));
            }
            if (Array.isArray(_data["parentPeople"])) {
                this.parentPeople = [] as any;
                for (let item of _data["parentPeople"])
                    this.parentPeople!.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(Request.fromJS(item));
            }
            if (Array.isArray(_data["clubsContacts"])) {
                this.clubsContacts = [] as any;
                for (let item of _data["clubsContacts"])
                    this.clubsContacts!.push(ClubContact.fromJS(item));
            }
            if (Array.isArray(_data["dogsOwnershipsTransients"])) {
                this.dogsOwnershipsTransients = [] as any;
                for (let item of _data["dogsOwnershipsTransients"])
                    this.dogsOwnershipsTransients!.push(DogOwnershipTransient.fromJS(item));
            }
            if (Array.isArray(_data["importRequestTransientOwnerships"])) {
                this.importRequestTransientOwnerships = [] as any;
                for (let item of _data["importRequestTransientOwnerships"])
                    this.importRequestTransientOwnerships!.push(ImportRequestTransientOwnership.fromJS(item));
            }
            if (Array.isArray(_data["dogTempOwnershipChangeRequests"])) {
                this.dogTempOwnershipChangeRequests = [] as any;
                for (let item of _data["dogTempOwnershipChangeRequests"])
                    this.dogTempOwnershipChangeRequests!.push(DogTempOwnershipChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["transientNewKennelOwners"])) {
                this.transientNewKennelOwners = [] as any;
                for (let item of _data["transientNewKennelOwners"])
                    this.transientNewKennelOwners!.push(TransientNewKennelOwner.fromJS(item));
            }
            if (Array.isArray(_data["transientKennelImportOwners"])) {
                this.transientKennelImportOwners = [] as any;
                for (let item of _data["transientKennelImportOwners"])
                    this.transientKennelImportOwners!.push(TransientKennelImportOwner.fromJS(item));
            }
            if (Array.isArray(_data["transientOwnersKennelOwnershipChanges"])) {
                this.transientOwnersKennelOwnershipChanges = [] as any;
                for (let item of _data["transientOwnersKennelOwnershipChanges"])
                    this.transientOwnersKennelOwnershipChanges!.push(TransientOwnersKennelOwnershipChange.fromJS(item));
            }
            if (Array.isArray(_data["competitionRequests"])) {
                this.competitionRequests = [] as any;
                for (let item of _data["competitionRequests"])
                    this.competitionRequests!.push(CompetitionRequest.fromJS(item));
            }
            this.commissioner = _data["commissioner"] ? Commissioner.fromJS(_data["commissioner"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["personHonorificId"] = this.personHonorificId;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageId"] = this.languageId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["vatNumber"] = this.vatNumber;
        data["bannedFrom"] = this.bannedFrom ? this.bannedFrom.toISOString() : <any>undefined;
        data["bannedTo"] = this.bannedTo ? this.bannedTo.toISOString() : <any>undefined;
        data["isBadPayer"] = this.isBadPayer;
        data["receiveNewsletterFrom"] = this.receiveNewsletterFrom ? this.receiveNewsletterFrom.toISOString() : <any>undefined;
        data["receiveNewsletterTo"] = this.receiveNewsletterTo ? this.receiveNewsletterTo.toISOString() : <any>undefined;
        data["as400ContactNumber"] = this.as400ContactNumber;
        data["remark"] = this.remark;
        data["sharepointUri"] = this.sharepointUri;
        data["bcIdentifier"] = this.bcIdentifier;
        data["brcsBcIdentifier"] = this.brcsBcIdentifier;
        data["societyName"] = this.societyName;
        data["cegekaId"] = this.cegekaId;
        data["parentPersonId"] = this.parentPersonId;
        data["computedName"] = this.computedName;
        data["isKnownPerson"] = this.isKnownPerson;
        data["personHonorific"] = this.personHonorific ? this.personHonorific.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["breeder"] = this.breeder ? this.breeder.toJSON() : <any>undefined;
        data["parentPerson"] = this.parentPerson ? this.parentPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.webUsers)) {
            data["webUsers"] = [];
            for (let item of this.webUsers)
                data["webUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.dogBroodRequestTransientOwners)) {
            data["dogBroodRequestTransientOwners"] = [];
            for (let item of this.dogBroodRequestTransientOwners)
                data["dogBroodRequestTransientOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.transientPedigreeRequestOwners)) {
            data["transientPedigreeRequestOwners"] = [];
            for (let item of this.transientPedigreeRequestOwners)
                data["transientPedigreeRequestOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.personActions)) {
            data["personActions"] = [];
            for (let item of this.personActions)
                data["personActions"].push(item.toJSON());
        }
        if (Array.isArray(this.veterinarians)) {
            data["veterinarians"] = [];
            for (let item of this.veterinarians)
                data["veterinarians"].push(item.toJSON());
        }
        if (Array.isArray(this.chartSignaturesHistories)) {
            data["chartSignaturesHistories"] = [];
            for (let item of this.chartSignaturesHistories)
                data["chartSignaturesHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.judges)) {
            data["judges"] = [];
            for (let item of this.judges)
                data["judges"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsOwnerships)) {
            data["dogsOwnerships"] = [];
            for (let item of this.dogsOwnerships)
                data["dogsOwnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelsOwnerships)) {
            data["kennelsOwnerships"] = [];
            for (let item of this.kennelsOwnerships)
                data["kennelsOwnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.parentPeople)) {
            data["parentPeople"] = [];
            for (let item of this.parentPeople)
                data["parentPeople"].push(item.toJSON());
        }
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        if (Array.isArray(this.clubsContacts)) {
            data["clubsContacts"] = [];
            for (let item of this.clubsContacts)
                data["clubsContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsOwnershipsTransients)) {
            data["dogsOwnershipsTransients"] = [];
            for (let item of this.dogsOwnershipsTransients)
                data["dogsOwnershipsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.importRequestTransientOwnerships)) {
            data["importRequestTransientOwnerships"] = [];
            for (let item of this.importRequestTransientOwnerships)
                data["importRequestTransientOwnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTempOwnershipChangeRequests)) {
            data["dogTempOwnershipChangeRequests"] = [];
            for (let item of this.dogTempOwnershipChangeRequests)
                data["dogTempOwnershipChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.transientNewKennelOwners)) {
            data["transientNewKennelOwners"] = [];
            for (let item of this.transientNewKennelOwners)
                data["transientNewKennelOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.transientKennelImportOwners)) {
            data["transientKennelImportOwners"] = [];
            for (let item of this.transientKennelImportOwners)
                data["transientKennelImportOwners"].push(item.toJSON());
        }
        if (Array.isArray(this.transientOwnersKennelOwnershipChanges)) {
            data["transientOwnersKennelOwnershipChanges"] = [];
            for (let item of this.transientOwnersKennelOwnershipChanges)
                data["transientOwnersKennelOwnershipChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionRequests)) {
            data["competitionRequests"] = [];
            for (let item of this.competitionRequests)
                data["competitionRequests"].push(item.toJSON());
        }
        data["commissioner"] = this.commissioner ? this.commissioner.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPerson {
    personId?: number;
    personHonorificId?: number | undefined;
    deathDate?: Date | undefined;
    birthDate?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    languageId?: number;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    vatNumber?: string | undefined;
    bannedFrom?: Date | undefined;
    bannedTo?: Date | undefined;
    isBadPayer?: boolean;
    receiveNewsletterFrom?: Date | undefined;
    receiveNewsletterTo?: Date | undefined;
    as400ContactNumber?: number | undefined;
    remark?: string | undefined;
    sharepointUri?: string | undefined;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    societyName?: string | undefined;
    cegekaId?: string | undefined;
    parentPersonId?: number | undefined;
    computedName?: string | undefined;
    isKnownPerson?: boolean;
    personHonorific?: PersonHonorific | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    breeder?: Breeder | undefined;
    parentPerson?: Person | undefined;
    webUsers?: WebUser[] | undefined;
    dogBroodRequestTransientOwners?: DogBroodRequestTransientOwner[] | undefined;
    transientPedigreeRequestOwners?: TransientPedigreeRequestOwner[] | undefined;
    personActions?: PersonAction[] | undefined;
    veterinarians?: Veterinary[] | undefined;
    chartSignaturesHistories?: ChartSignaturesHistory[] | undefined;
    judges?: Judge[] | undefined;
    members?: Member[] | undefined;
    dogsOwnerships?: DogOwnership[] | undefined;
    kennelsOwnerships?: KennelOwnership[] | undefined;
    parentPeople?: Person[] | undefined;
    requests?: Request[] | undefined;
    clubsContacts?: ClubContact[] | undefined;
    dogsOwnershipsTransients?: DogOwnershipTransient[] | undefined;
    importRequestTransientOwnerships?: ImportRequestTransientOwnership[] | undefined;
    dogTempOwnershipChangeRequests?: DogTempOwnershipChangeRequest[] | undefined;
    transientNewKennelOwners?: TransientNewKennelOwner[] | undefined;
    transientKennelImportOwners?: TransientKennelImportOwner[] | undefined;
    transientOwnersKennelOwnershipChanges?: TransientOwnersKennelOwnershipChange[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    commissioner?: Commissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class PersonHonorific implements IPersonHonorific {
    personHonorificId?: number;
    code?: EPersonHonorifics;
    people?: Person[] | undefined;
    personHonorificTranslations?: PersonHonorificTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPersonHonorific) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personHonorificId = _data["personHonorificId"];
            this.code = _data["code"];
            if (Array.isArray(_data["people"])) {
                this.people = [] as any;
                for (let item of _data["people"])
                    this.people!.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["personHonorificTranslations"])) {
                this.personHonorificTranslations = [] as any;
                for (let item of _data["personHonorificTranslations"])
                    this.personHonorificTranslations!.push(PersonHonorificTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PersonHonorific {
        data = typeof data === 'object' ? data : {};
        let result = new PersonHonorific();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personHonorificId"] = this.personHonorificId;
        data["code"] = this.code;
        if (Array.isArray(this.people)) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item.toJSON());
        }
        if (Array.isArray(this.personHonorificTranslations)) {
            data["personHonorificTranslations"] = [];
            for (let item of this.personHonorificTranslations)
                data["personHonorificTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPersonHonorific {
    personHonorificId?: number;
    code?: EPersonHonorifics;
    people?: Person[] | undefined;
    personHonorificTranslations?: PersonHonorificTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EPersonHonorifics {
    Mr = "Mr",
    Mrs = "Mrs",
}

export class PersonHonorificTranslation implements IPersonHonorificTranslation {
    personHonorificTranslationId?: number;
    personHonorificId?: number;
    languageId?: number;
    text?: string | undefined;
    personHonorific?: PersonHonorific | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPersonHonorificTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personHonorificTranslationId = _data["personHonorificTranslationId"];
            this.personHonorificId = _data["personHonorificId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.personHonorific = _data["personHonorific"] ? PersonHonorific.fromJS(_data["personHonorific"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PersonHonorificTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new PersonHonorificTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personHonorificTranslationId"] = this.personHonorificTranslationId;
        data["personHonorificId"] = this.personHonorificId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["personHonorific"] = this.personHonorific ? this.personHonorific.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPersonHonorificTranslation {
    personHonorificTranslationId?: number;
    personHonorificId?: number;
    languageId?: number;
    text?: string | undefined;
    personHonorific?: PersonHonorific | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Language implements ILanguage {
    dysplasiaTypeTranslations?: DysplasiaTypeTranslation[] | undefined;
    commissionerSpokenLanguages?: CommissionerSpokenLanguage[] | undefined;
    languageId?: number;
    languageCode?: string | undefined;
    bcLanguageCode?: string | undefined;
    orderIndex?: number | undefined;
    hasTranslation?: boolean;
    countryTranslations?: CountryTranslation[] | undefined;
    countryLanguages?: CountryLanguage[] | undefined;
    dogActionsTranslations?: DogActionTranslation[] | undefined;
    personActionsTranslations?: PersonActionTranslation[] | undefined;
    languageTranslations?: LanguageTranslation[] | undefined;
    labStatusTranslations?: LabStatusTranslation[] | undefined;
    healthValueTypeTranslations?: HealthValueTypeTranslation[] | undefined;
    documentContents?: DocumentContent[] | undefined;
    translatedLanguageTranslations?: LanguageTranslation[] | undefined;
    competitionJudges?: CompetitionJudge[] | undefined;
    users?: User[] | undefined;
    translations?: Translation[] | undefined;
    clubRoleTranslations?: ClubRoleTranslation[] | undefined;
    titleTypeTranslations?: TitleTypeTranslation[] | undefined;
    userDysplasiaStatusTranslations?: UserDysplasiaStatusTranslation[] | undefined;
    neededConditionTranslations?: NeededConditionTranslation[] | undefined;
    neededVerificationsTranslation?: NeededVerificationTranslation[] | undefined;
    judgeSpokenLanguages?: JudgeSpokenLanguage[] | undefined;
    mailContents?: MailContent[] | undefined;
    departmentTranslations?: DepartmentTranslation[] | undefined;
    volunteerProfileTranslations?: VolunteerProfileTranslation[] | undefined;
    elementActionTranslations?: ElementActionTranslation[] | undefined;
    requestActionTranslations?: RequestActionTranslation[] | undefined;
    labStatusDescriptionTranslations?: LabStatusDescriptionTranslation[] | undefined;
    mailTemplateDescriptions?: MailTemplateDescriptionsTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dysplasiaTypeTranslations"])) {
                this.dysplasiaTypeTranslations = [] as any;
                for (let item of _data["dysplasiaTypeTranslations"])
                    this.dysplasiaTypeTranslations!.push(DysplasiaTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["commissionerSpokenLanguages"])) {
                this.commissionerSpokenLanguages = [] as any;
                for (let item of _data["commissionerSpokenLanguages"])
                    this.commissionerSpokenLanguages!.push(CommissionerSpokenLanguage.fromJS(item));
            }
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
            this.bcLanguageCode = _data["bcLanguageCode"];
            this.orderIndex = _data["orderIndex"];
            this.hasTranslation = _data["hasTranslation"];
            if (Array.isArray(_data["countryTranslations"])) {
                this.countryTranslations = [] as any;
                for (let item of _data["countryTranslations"])
                    this.countryTranslations!.push(CountryTranslation.fromJS(item));
            }
            if (Array.isArray(_data["countryLanguages"])) {
                this.countryLanguages = [] as any;
                for (let item of _data["countryLanguages"])
                    this.countryLanguages!.push(CountryLanguage.fromJS(item));
            }
            if (Array.isArray(_data["dogActionsTranslations"])) {
                this.dogActionsTranslations = [] as any;
                for (let item of _data["dogActionsTranslations"])
                    this.dogActionsTranslations!.push(DogActionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["personActionsTranslations"])) {
                this.personActionsTranslations = [] as any;
                for (let item of _data["personActionsTranslations"])
                    this.personActionsTranslations!.push(PersonActionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["languageTranslations"])) {
                this.languageTranslations = [] as any;
                for (let item of _data["languageTranslations"])
                    this.languageTranslations!.push(LanguageTranslation.fromJS(item));
            }
            if (Array.isArray(_data["labStatusTranslations"])) {
                this.labStatusTranslations = [] as any;
                for (let item of _data["labStatusTranslations"])
                    this.labStatusTranslations!.push(LabStatusTranslation.fromJS(item));
            }
            if (Array.isArray(_data["healthValueTypeTranslations"])) {
                this.healthValueTypeTranslations = [] as any;
                for (let item of _data["healthValueTypeTranslations"])
                    this.healthValueTypeTranslations!.push(HealthValueTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["documentContents"])) {
                this.documentContents = [] as any;
                for (let item of _data["documentContents"])
                    this.documentContents!.push(DocumentContent.fromJS(item));
            }
            if (Array.isArray(_data["translatedLanguageTranslations"])) {
                this.translatedLanguageTranslations = [] as any;
                for (let item of _data["translatedLanguageTranslations"])
                    this.translatedLanguageTranslations!.push(LanguageTranslation.fromJS(item));
            }
            if (Array.isArray(_data["competitionJudges"])) {
                this.competitionJudges = [] as any;
                for (let item of _data["competitionJudges"])
                    this.competitionJudges!.push(CompetitionJudge.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
            if (Array.isArray(_data["clubRoleTranslations"])) {
                this.clubRoleTranslations = [] as any;
                for (let item of _data["clubRoleTranslations"])
                    this.clubRoleTranslations!.push(ClubRoleTranslation.fromJS(item));
            }
            if (Array.isArray(_data["titleTypeTranslations"])) {
                this.titleTypeTranslations = [] as any;
                for (let item of _data["titleTypeTranslations"])
                    this.titleTypeTranslations!.push(TitleTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["userDysplasiaStatusTranslations"])) {
                this.userDysplasiaStatusTranslations = [] as any;
                for (let item of _data["userDysplasiaStatusTranslations"])
                    this.userDysplasiaStatusTranslations!.push(UserDysplasiaStatusTranslation.fromJS(item));
            }
            if (Array.isArray(_data["neededConditionTranslations"])) {
                this.neededConditionTranslations = [] as any;
                for (let item of _data["neededConditionTranslations"])
                    this.neededConditionTranslations!.push(NeededConditionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["neededVerificationsTranslation"])) {
                this.neededVerificationsTranslation = [] as any;
                for (let item of _data["neededVerificationsTranslation"])
                    this.neededVerificationsTranslation!.push(NeededVerificationTranslation.fromJS(item));
            }
            if (Array.isArray(_data["judgeSpokenLanguages"])) {
                this.judgeSpokenLanguages = [] as any;
                for (let item of _data["judgeSpokenLanguages"])
                    this.judgeSpokenLanguages!.push(JudgeSpokenLanguage.fromJS(item));
            }
            if (Array.isArray(_data["mailContents"])) {
                this.mailContents = [] as any;
                for (let item of _data["mailContents"])
                    this.mailContents!.push(MailContent.fromJS(item));
            }
            if (Array.isArray(_data["departmentTranslations"])) {
                this.departmentTranslations = [] as any;
                for (let item of _data["departmentTranslations"])
                    this.departmentTranslations!.push(DepartmentTranslation.fromJS(item));
            }
            if (Array.isArray(_data["volunteerProfileTranslations"])) {
                this.volunteerProfileTranslations = [] as any;
                for (let item of _data["volunteerProfileTranslations"])
                    this.volunteerProfileTranslations!.push(VolunteerProfileTranslation.fromJS(item));
            }
            if (Array.isArray(_data["elementActionTranslations"])) {
                this.elementActionTranslations = [] as any;
                for (let item of _data["elementActionTranslations"])
                    this.elementActionTranslations!.push(ElementActionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["requestActionTranslations"])) {
                this.requestActionTranslations = [] as any;
                for (let item of _data["requestActionTranslations"])
                    this.requestActionTranslations!.push(RequestActionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["labStatusDescriptionTranslations"])) {
                this.labStatusDescriptionTranslations = [] as any;
                for (let item of _data["labStatusDescriptionTranslations"])
                    this.labStatusDescriptionTranslations!.push(LabStatusDescriptionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["mailTemplateDescriptions"])) {
                this.mailTemplateDescriptions = [] as any;
                for (let item of _data["mailTemplateDescriptions"])
                    this.mailTemplateDescriptions!.push(MailTemplateDescriptionsTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dysplasiaTypeTranslations)) {
            data["dysplasiaTypeTranslations"] = [];
            for (let item of this.dysplasiaTypeTranslations)
                data["dysplasiaTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.commissionerSpokenLanguages)) {
            data["commissionerSpokenLanguages"] = [];
            for (let item of this.commissionerSpokenLanguages)
                data["commissionerSpokenLanguages"].push(item.toJSON());
        }
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        data["bcLanguageCode"] = this.bcLanguageCode;
        data["orderIndex"] = this.orderIndex;
        data["hasTranslation"] = this.hasTranslation;
        if (Array.isArray(this.countryTranslations)) {
            data["countryTranslations"] = [];
            for (let item of this.countryTranslations)
                data["countryTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.countryLanguages)) {
            data["countryLanguages"] = [];
            for (let item of this.countryLanguages)
                data["countryLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.dogActionsTranslations)) {
            data["dogActionsTranslations"] = [];
            for (let item of this.dogActionsTranslations)
                data["dogActionsTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.personActionsTranslations)) {
            data["personActionsTranslations"] = [];
            for (let item of this.personActionsTranslations)
                data["personActionsTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.languageTranslations)) {
            data["languageTranslations"] = [];
            for (let item of this.languageTranslations)
                data["languageTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.labStatusTranslations)) {
            data["labStatusTranslations"] = [];
            for (let item of this.labStatusTranslations)
                data["labStatusTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.healthValueTypeTranslations)) {
            data["healthValueTypeTranslations"] = [];
            for (let item of this.healthValueTypeTranslations)
                data["healthValueTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.documentContents)) {
            data["documentContents"] = [];
            for (let item of this.documentContents)
                data["documentContents"].push(item.toJSON());
        }
        if (Array.isArray(this.translatedLanguageTranslations)) {
            data["translatedLanguageTranslations"] = [];
            for (let item of this.translatedLanguageTranslations)
                data["translatedLanguageTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionJudges)) {
            data["competitionJudges"] = [];
            for (let item of this.competitionJudges)
                data["competitionJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (Array.isArray(this.clubRoleTranslations)) {
            data["clubRoleTranslations"] = [];
            for (let item of this.clubRoleTranslations)
                data["clubRoleTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.titleTypeTranslations)) {
            data["titleTypeTranslations"] = [];
            for (let item of this.titleTypeTranslations)
                data["titleTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.userDysplasiaStatusTranslations)) {
            data["userDysplasiaStatusTranslations"] = [];
            for (let item of this.userDysplasiaStatusTranslations)
                data["userDysplasiaStatusTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.neededConditionTranslations)) {
            data["neededConditionTranslations"] = [];
            for (let item of this.neededConditionTranslations)
                data["neededConditionTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.neededVerificationsTranslation)) {
            data["neededVerificationsTranslation"] = [];
            for (let item of this.neededVerificationsTranslation)
                data["neededVerificationsTranslation"].push(item.toJSON());
        }
        if (Array.isArray(this.judgeSpokenLanguages)) {
            data["judgeSpokenLanguages"] = [];
            for (let item of this.judgeSpokenLanguages)
                data["judgeSpokenLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.mailContents)) {
            data["mailContents"] = [];
            for (let item of this.mailContents)
                data["mailContents"].push(item.toJSON());
        }
        if (Array.isArray(this.departmentTranslations)) {
            data["departmentTranslations"] = [];
            for (let item of this.departmentTranslations)
                data["departmentTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.volunteerProfileTranslations)) {
            data["volunteerProfileTranslations"] = [];
            for (let item of this.volunteerProfileTranslations)
                data["volunteerProfileTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.elementActionTranslations)) {
            data["elementActionTranslations"] = [];
            for (let item of this.elementActionTranslations)
                data["elementActionTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.requestActionTranslations)) {
            data["requestActionTranslations"] = [];
            for (let item of this.requestActionTranslations)
                data["requestActionTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.labStatusDescriptionTranslations)) {
            data["labStatusDescriptionTranslations"] = [];
            for (let item of this.labStatusDescriptionTranslations)
                data["labStatusDescriptionTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.mailTemplateDescriptions)) {
            data["mailTemplateDescriptions"] = [];
            for (let item of this.mailTemplateDescriptions)
                data["mailTemplateDescriptions"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILanguage {
    dysplasiaTypeTranslations?: DysplasiaTypeTranslation[] | undefined;
    commissionerSpokenLanguages?: CommissionerSpokenLanguage[] | undefined;
    languageId?: number;
    languageCode?: string | undefined;
    bcLanguageCode?: string | undefined;
    orderIndex?: number | undefined;
    hasTranslation?: boolean;
    countryTranslations?: CountryTranslation[] | undefined;
    countryLanguages?: CountryLanguage[] | undefined;
    dogActionsTranslations?: DogActionTranslation[] | undefined;
    personActionsTranslations?: PersonActionTranslation[] | undefined;
    languageTranslations?: LanguageTranslation[] | undefined;
    labStatusTranslations?: LabStatusTranslation[] | undefined;
    healthValueTypeTranslations?: HealthValueTypeTranslation[] | undefined;
    documentContents?: DocumentContent[] | undefined;
    translatedLanguageTranslations?: LanguageTranslation[] | undefined;
    competitionJudges?: CompetitionJudge[] | undefined;
    users?: User[] | undefined;
    translations?: Translation[] | undefined;
    clubRoleTranslations?: ClubRoleTranslation[] | undefined;
    titleTypeTranslations?: TitleTypeTranslation[] | undefined;
    userDysplasiaStatusTranslations?: UserDysplasiaStatusTranslation[] | undefined;
    neededConditionTranslations?: NeededConditionTranslation[] | undefined;
    neededVerificationsTranslation?: NeededVerificationTranslation[] | undefined;
    judgeSpokenLanguages?: JudgeSpokenLanguage[] | undefined;
    mailContents?: MailContent[] | undefined;
    departmentTranslations?: DepartmentTranslation[] | undefined;
    volunteerProfileTranslations?: VolunteerProfileTranslation[] | undefined;
    elementActionTranslations?: ElementActionTranslation[] | undefined;
    requestActionTranslations?: RequestActionTranslation[] | undefined;
    labStatusDescriptionTranslations?: LabStatusDescriptionTranslation[] | undefined;
    mailTemplateDescriptions?: MailTemplateDescriptionsTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DysplasiaTypeTranslation implements IDysplasiaTypeTranslation {
    dysplasiaTypeTranslationId?: number;
    dysplasiaTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    dysplasiaType?: DysplasiaType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDysplasiaTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaTypeTranslationId = _data["dysplasiaTypeTranslationId"];
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.dysplasiaType = _data["dysplasiaType"] ? DysplasiaType.fromJS(_data["dysplasiaType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DysplasiaTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaTypeTranslationId"] = this.dysplasiaTypeTranslationId;
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["dysplasiaType"] = this.dysplasiaType ? this.dysplasiaType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDysplasiaTypeTranslation {
    dysplasiaTypeTranslationId?: number;
    dysplasiaTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    dysplasiaType?: DysplasiaType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DysplasiaType implements IDysplasiaType {
    dysplasiaTypeTranslations?: DysplasiaTypeTranslation[] | undefined;
    dysplasiaTypeId?: number;
    code?: EDysplasiaType;
    orderIndex?: number | undefined;
    useInRequests?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDysplasiaType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dysplasiaTypeTranslations"])) {
                this.dysplasiaTypeTranslations = [] as any;
                for (let item of _data["dysplasiaTypeTranslations"])
                    this.dysplasiaTypeTranslations!.push(DysplasiaTypeTranslation.fromJS(item));
            }
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            this.code = _data["code"];
            this.orderIndex = _data["orderIndex"];
            this.useInRequests = _data["useInRequests"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DysplasiaType {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dysplasiaTypeTranslations)) {
            data["dysplasiaTypeTranslations"] = [];
            for (let item of this.dysplasiaTypeTranslations)
                data["dysplasiaTypeTranslations"].push(item.toJSON());
        }
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        data["code"] = this.code;
        data["orderIndex"] = this.orderIndex;
        data["useInRequests"] = this.useInRequests;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDysplasiaType {
    dysplasiaTypeTranslations?: DysplasiaTypeTranslation[] | undefined;
    dysplasiaTypeId?: number;
    code?: EDysplasiaType;
    orderIndex?: number | undefined;
    useInRequests?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDysplasiaType {
    HD = "HD",
    SD = "SD",
    ED = "ED",
    Laxity = "Laxity",
    BD = "BD",
    HL = "HL",
    PL = "PL",
}

export class CommissionerSpokenLanguage implements ICommissionerSpokenLanguage {
    commissionerSpokenLanguageId?: number;
    languageId?: number;
    commissionerId?: number;
    language?: Language | undefined;
    commissioner?: Commissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICommissionerSpokenLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionerSpokenLanguageId = _data["commissionerSpokenLanguageId"];
            this.languageId = _data["languageId"];
            this.commissionerId = _data["commissionerId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.commissioner = _data["commissioner"] ? Commissioner.fromJS(_data["commissioner"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CommissionerSpokenLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionerSpokenLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commissionerSpokenLanguageId"] = this.commissionerSpokenLanguageId;
        data["languageId"] = this.languageId;
        data["commissionerId"] = this.commissionerId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["commissioner"] = this.commissioner ? this.commissioner.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICommissionerSpokenLanguage {
    commissionerSpokenLanguageId?: number;
    languageId?: number;
    commissionerId?: number;
    language?: Language | undefined;
    commissioner?: Commissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Commissioner implements ICommissioner {
    commissionerId?: number;
    personId?: number;
    commissionerExperience?: ECommissionerExperience;
    person?: Person | undefined;
    commissionerSpokenLanguages?: CommissionerSpokenLanguage[] | undefined;
    competitionCommissioners?: CompetitionCommissioner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICommissioner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionerId = _data["commissionerId"];
            this.personId = _data["personId"];
            this.commissionerExperience = _data["commissionerExperience"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["commissionerSpokenLanguages"])) {
                this.commissionerSpokenLanguages = [] as any;
                for (let item of _data["commissionerSpokenLanguages"])
                    this.commissionerSpokenLanguages!.push(CommissionerSpokenLanguage.fromJS(item));
            }
            if (Array.isArray(_data["competitionCommissioners"])) {
                this.competitionCommissioners = [] as any;
                for (let item of _data["competitionCommissioners"])
                    this.competitionCommissioners!.push(CompetitionCommissioner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Commissioner {
        data = typeof data === 'object' ? data : {};
        let result = new Commissioner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commissionerId"] = this.commissionerId;
        data["personId"] = this.personId;
        data["commissionerExperience"] = this.commissionerExperience;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.commissionerSpokenLanguages)) {
            data["commissionerSpokenLanguages"] = [];
            for (let item of this.commissionerSpokenLanguages)
                data["commissionerSpokenLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionCommissioners)) {
            data["competitionCommissioners"] = [];
            for (let item of this.competitionCommissioners)
                data["competitionCommissioners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICommissioner {
    commissionerId?: number;
    personId?: number;
    commissionerExperience?: ECommissionerExperience;
    person?: Person | undefined;
    commissionerSpokenLanguages?: CommissionerSpokenLanguage[] | undefined;
    competitionCommissioners?: CompetitionCommissioner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum ECommissionerExperience {
    None = "None",
    Small = "Small",
    ALot = "ALot",
}

export class CompetitionCommissioner implements ICompetitionCommissioner {
    competitionCommissionerId?: number;
    commissionerId?: number;
    competitionRequestId?: number;
    accountNumber?: string | undefined;
    otherLanguage?: string | undefined;
    communicationLanguageId?: number;
    carPooling?: boolean;
    carPoolingName?: string | undefined;
    hasAccepted?: boolean;
    isSelected?: boolean;
    competitionCommissionerDaysRemark?: string | undefined;
    competitionCommissionerForbiddenBreeds?: CompetitionCommissionerForbiddenBreed[] | undefined;
    competitionCommissionerCompetitionDays?: CompetitionCommissionerCompetitionDay[] | undefined;
    ringDivisionCompetitionCommissioners?: RingDivisionCompetitionCommissioner[] | undefined;
    communicationLanguage?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    commissioner?: Commissioner | undefined;
    competitionRequest?: CompetitionRequest | undefined;

    constructor(data?: ICompetitionCommissioner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionCommissionerId = _data["competitionCommissionerId"];
            this.commissionerId = _data["commissionerId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.accountNumber = _data["accountNumber"];
            this.otherLanguage = _data["otherLanguage"];
            this.communicationLanguageId = _data["communicationLanguageId"];
            this.carPooling = _data["carPooling"];
            this.carPoolingName = _data["carPoolingName"];
            this.hasAccepted = _data["hasAccepted"];
            this.isSelected = _data["isSelected"];
            this.competitionCommissionerDaysRemark = _data["competitionCommissionerDaysRemark"];
            if (Array.isArray(_data["competitionCommissionerForbiddenBreeds"])) {
                this.competitionCommissionerForbiddenBreeds = [] as any;
                for (let item of _data["competitionCommissionerForbiddenBreeds"])
                    this.competitionCommissionerForbiddenBreeds!.push(CompetitionCommissionerForbiddenBreed.fromJS(item));
            }
            if (Array.isArray(_data["competitionCommissionerCompetitionDays"])) {
                this.competitionCommissionerCompetitionDays = [] as any;
                for (let item of _data["competitionCommissionerCompetitionDays"])
                    this.competitionCommissionerCompetitionDays!.push(CompetitionCommissionerCompetitionDay.fromJS(item));
            }
            if (Array.isArray(_data["ringDivisionCompetitionCommissioners"])) {
                this.ringDivisionCompetitionCommissioners = [] as any;
                for (let item of _data["ringDivisionCompetitionCommissioners"])
                    this.ringDivisionCompetitionCommissioners!.push(RingDivisionCompetitionCommissioner.fromJS(item));
            }
            this.communicationLanguage = _data["communicationLanguage"] ? Language.fromJS(_data["communicationLanguage"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.commissioner = _data["commissioner"] ? Commissioner.fromJS(_data["commissioner"]) : <any>undefined;
            this.competitionRequest = _data["competitionRequest"] ? CompetitionRequest.fromJS(_data["competitionRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitionCommissioner {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionCommissioner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionCommissionerId"] = this.competitionCommissionerId;
        data["commissionerId"] = this.commissionerId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["accountNumber"] = this.accountNumber;
        data["otherLanguage"] = this.otherLanguage;
        data["communicationLanguageId"] = this.communicationLanguageId;
        data["carPooling"] = this.carPooling;
        data["carPoolingName"] = this.carPoolingName;
        data["hasAccepted"] = this.hasAccepted;
        data["isSelected"] = this.isSelected;
        data["competitionCommissionerDaysRemark"] = this.competitionCommissionerDaysRemark;
        if (Array.isArray(this.competitionCommissionerForbiddenBreeds)) {
            data["competitionCommissionerForbiddenBreeds"] = [];
            for (let item of this.competitionCommissionerForbiddenBreeds)
                data["competitionCommissionerForbiddenBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionCommissionerCompetitionDays)) {
            data["competitionCommissionerCompetitionDays"] = [];
            for (let item of this.competitionCommissionerCompetitionDays)
                data["competitionCommissionerCompetitionDays"].push(item.toJSON());
        }
        if (Array.isArray(this.ringDivisionCompetitionCommissioners)) {
            data["ringDivisionCompetitionCommissioners"] = [];
            for (let item of this.ringDivisionCompetitionCommissioners)
                data["ringDivisionCompetitionCommissioners"].push(item.toJSON());
        }
        data["communicationLanguage"] = this.communicationLanguage ? this.communicationLanguage.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["commissioner"] = this.commissioner ? this.commissioner.toJSON() : <any>undefined;
        data["competitionRequest"] = this.competitionRequest ? this.competitionRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompetitionCommissioner {
    competitionCommissionerId?: number;
    commissionerId?: number;
    competitionRequestId?: number;
    accountNumber?: string | undefined;
    otherLanguage?: string | undefined;
    communicationLanguageId?: number;
    carPooling?: boolean;
    carPoolingName?: string | undefined;
    hasAccepted?: boolean;
    isSelected?: boolean;
    competitionCommissionerDaysRemark?: string | undefined;
    competitionCommissionerForbiddenBreeds?: CompetitionCommissionerForbiddenBreed[] | undefined;
    competitionCommissionerCompetitionDays?: CompetitionCommissionerCompetitionDay[] | undefined;
    ringDivisionCompetitionCommissioners?: RingDivisionCompetitionCommissioner[] | undefined;
    communicationLanguage?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    commissioner?: Commissioner | undefined;
    competitionRequest?: CompetitionRequest | undefined;
}

export class CompetitionCommissionerForbiddenBreed implements ICompetitionCommissionerForbiddenBreed {
    competitionCommissionerForbiddenBreedId?: number;
    breedId?: number;
    competitionCommissionerId?: number;
    breed?: Breed | undefined;
    competitionCommissioner?: CompetitionCommissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionCommissionerForbiddenBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionCommissionerForbiddenBreedId = _data["competitionCommissionerForbiddenBreedId"];
            this.breedId = _data["breedId"];
            this.competitionCommissionerId = _data["competitionCommissionerId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.competitionCommissioner = _data["competitionCommissioner"] ? CompetitionCommissioner.fromJS(_data["competitionCommissioner"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionCommissionerForbiddenBreed {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionCommissionerForbiddenBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionCommissionerForbiddenBreedId"] = this.competitionCommissionerForbiddenBreedId;
        data["breedId"] = this.breedId;
        data["competitionCommissionerId"] = this.competitionCommissionerId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["competitionCommissioner"] = this.competitionCommissioner ? this.competitionCommissioner.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionCommissionerForbiddenBreed {
    competitionCommissionerForbiddenBreedId?: number;
    breedId?: number;
    competitionCommissionerId?: number;
    breed?: Breed | undefined;
    competitionCommissioner?: CompetitionCommissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Breed implements IBreed {
    breedId?: number;
    fciNumber?: number | undefined;
    knownAt?: Date | undefined;
    countryId?: number;
    breedGroupId?: number;
    subjectToWork?: boolean;
    agility?: EDifficulty | undefined;
    grooming?: EDifficulty | undefined;
    standardConfirmation?: boolean;
    shortenedTail?: boolean;
    sizeMin?: number | undefined;
    sizeMax?: number | undefined;
    weightMin?: number | undefined;
    weightMax?: number | undefined;
    varietyNumber?: number | undefined;
    remark?: string | undefined;
    breedNumber?: number;
    internshipDate?: Date | undefined;
    minDysplasiaAgeInMonths?: number;
    cegekaId?: string | undefined;
    userId?: number | undefined;
    officialName?: string | undefined;
    breeding?: boolean;
    user?: User | undefined;
    breedGroup?: BreedGroup | undefined;
    country?: Country | undefined;
    competitionBreeds?: CompetitionBreed[] | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
    competitionCommissionerForbiddenBreeds?: CompetitionCommissionerForbiddenBreed[] | undefined;
    breedHealthPacks?: BreedHealthPack[] | undefined;
    breedJudgeTransients?: BreedJudgeTransient[] | undefined;
    clubsBreeds?: ClubBreed[] | undefined;
    breedsColors?: BreedColor[] | undefined;
    breedsWorkbookTypes?: BreedWorkbookType[] | undefined;
    dogs?: Dog[] | undefined;
    sourceBreeds?: BreedVariety[] | undefined;
    destinationBreeds?: BreedVariety[] | undefined;
    destinationExceptions?: BreedingException[] | undefined;
    sourceExceptions?: BreedingException[] | undefined;
    breedsJudges?: BreedJudge[] | undefined;
    breedTranslations?: BreedTranslation[] | undefined;
    kennelsBreeds?: KennelBreed[] | undefined;
    transientNewKennelBreeds?: TransientNewKennelBreed[] | undefined;
    transientKennelImportBreeds?: TransientKennelImportBreed[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    ringDivisions?: RingDivision[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;

    constructor(data?: IBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.fciNumber = _data["fciNumber"];
            this.knownAt = _data["knownAt"] ? new Date(_data["knownAt"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.breedGroupId = _data["breedGroupId"];
            this.subjectToWork = _data["subjectToWork"];
            this.agility = _data["agility"];
            this.grooming = _data["grooming"];
            this.standardConfirmation = _data["standardConfirmation"];
            this.shortenedTail = _data["shortenedTail"];
            this.sizeMin = _data["sizeMin"];
            this.sizeMax = _data["sizeMax"];
            this.weightMin = _data["weightMin"];
            this.weightMax = _data["weightMax"];
            this.varietyNumber = _data["varietyNumber"];
            this.remark = _data["remark"];
            this.breedNumber = _data["breedNumber"];
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.minDysplasiaAgeInMonths = _data["minDysplasiaAgeInMonths"];
            this.cegekaId = _data["cegekaId"];
            this.userId = _data["userId"];
            this.officialName = _data["officialName"];
            this.breeding = _data["breeding"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.breedGroup = _data["breedGroup"] ? BreedGroup.fromJS(_data["breedGroup"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["competitionBreeds"])) {
                this.competitionBreeds = [] as any;
                for (let item of _data["competitionBreeds"])
                    this.competitionBreeds!.push(CompetitionBreed.fromJS(item));
            }
            if (Array.isArray(_data["expoBreedForJudges"])) {
                this.expoBreedForJudges = [] as any;
                for (let item of _data["expoBreedForJudges"])
                    this.expoBreedForJudges!.push(ExpoBreedForJudge.fromJS(item));
            }
            if (Array.isArray(_data["competitionCommissionerForbiddenBreeds"])) {
                this.competitionCommissionerForbiddenBreeds = [] as any;
                for (let item of _data["competitionCommissionerForbiddenBreeds"])
                    this.competitionCommissionerForbiddenBreeds!.push(CompetitionCommissionerForbiddenBreed.fromJS(item));
            }
            if (Array.isArray(_data["breedHealthPacks"])) {
                this.breedHealthPacks = [] as any;
                for (let item of _data["breedHealthPacks"])
                    this.breedHealthPacks!.push(BreedHealthPack.fromJS(item));
            }
            if (Array.isArray(_data["breedJudgeTransients"])) {
                this.breedJudgeTransients = [] as any;
                for (let item of _data["breedJudgeTransients"])
                    this.breedJudgeTransients!.push(BreedJudgeTransient.fromJS(item));
            }
            if (Array.isArray(_data["clubsBreeds"])) {
                this.clubsBreeds = [] as any;
                for (let item of _data["clubsBreeds"])
                    this.clubsBreeds!.push(ClubBreed.fromJS(item));
            }
            if (Array.isArray(_data["breedsColors"])) {
                this.breedsColors = [] as any;
                for (let item of _data["breedsColors"])
                    this.breedsColors!.push(BreedColor.fromJS(item));
            }
            if (Array.isArray(_data["breedsWorkbookTypes"])) {
                this.breedsWorkbookTypes = [] as any;
                for (let item of _data["breedsWorkbookTypes"])
                    this.breedsWorkbookTypes!.push(BreedWorkbookType.fromJS(item));
            }
            if (Array.isArray(_data["dogs"])) {
                this.dogs = [] as any;
                for (let item of _data["dogs"])
                    this.dogs!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["sourceBreeds"])) {
                this.sourceBreeds = [] as any;
                for (let item of _data["sourceBreeds"])
                    this.sourceBreeds!.push(BreedVariety.fromJS(item));
            }
            if (Array.isArray(_data["destinationBreeds"])) {
                this.destinationBreeds = [] as any;
                for (let item of _data["destinationBreeds"])
                    this.destinationBreeds!.push(BreedVariety.fromJS(item));
            }
            if (Array.isArray(_data["destinationExceptions"])) {
                this.destinationExceptions = [] as any;
                for (let item of _data["destinationExceptions"])
                    this.destinationExceptions!.push(BreedingException.fromJS(item));
            }
            if (Array.isArray(_data["sourceExceptions"])) {
                this.sourceExceptions = [] as any;
                for (let item of _data["sourceExceptions"])
                    this.sourceExceptions!.push(BreedingException.fromJS(item));
            }
            if (Array.isArray(_data["breedsJudges"])) {
                this.breedsJudges = [] as any;
                for (let item of _data["breedsJudges"])
                    this.breedsJudges!.push(BreedJudge.fromJS(item));
            }
            if (Array.isArray(_data["breedTranslations"])) {
                this.breedTranslations = [] as any;
                for (let item of _data["breedTranslations"])
                    this.breedTranslations!.push(BreedTranslation.fromJS(item));
            }
            if (Array.isArray(_data["kennelsBreeds"])) {
                this.kennelsBreeds = [] as any;
                for (let item of _data["kennelsBreeds"])
                    this.kennelsBreeds!.push(KennelBreed.fromJS(item));
            }
            if (Array.isArray(_data["transientNewKennelBreeds"])) {
                this.transientNewKennelBreeds = [] as any;
                for (let item of _data["transientNewKennelBreeds"])
                    this.transientNewKennelBreeds!.push(TransientNewKennelBreed.fromJS(item));
            }
            if (Array.isArray(_data["transientKennelImportBreeds"])) {
                this.transientKennelImportBreeds = [] as any;
                for (let item of _data["transientKennelImportBreeds"])
                    this.transientKennelImportBreeds!.push(TransientKennelImportBreed.fromJS(item));
            }
            if (Array.isArray(_data["dogBroodRequestsTransients"])) {
                this.dogBroodRequestsTransients = [] as any;
                for (let item of _data["dogBroodRequestsTransients"])
                    this.dogBroodRequestsTransients!.push(DogBroodRequestsTransient.fromJS(item));
            }
            if (Array.isArray(_data["ringDivisions"])) {
                this.ringDivisions = [] as any;
                for (let item of _data["ringDivisions"])
                    this.ringDivisions!.push(RingDivision.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): Breed {
        data = typeof data === 'object' ? data : {};
        let result = new Breed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["fciNumber"] = this.fciNumber;
        data["knownAt"] = this.knownAt ? this.knownAt.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["breedGroupId"] = this.breedGroupId;
        data["subjectToWork"] = this.subjectToWork;
        data["agility"] = this.agility;
        data["grooming"] = this.grooming;
        data["standardConfirmation"] = this.standardConfirmation;
        data["shortenedTail"] = this.shortenedTail;
        data["sizeMin"] = this.sizeMin;
        data["sizeMax"] = this.sizeMax;
        data["weightMin"] = this.weightMin;
        data["weightMax"] = this.weightMax;
        data["varietyNumber"] = this.varietyNumber;
        data["remark"] = this.remark;
        data["breedNumber"] = this.breedNumber;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["minDysplasiaAgeInMonths"] = this.minDysplasiaAgeInMonths;
        data["cegekaId"] = this.cegekaId;
        data["userId"] = this.userId;
        data["officialName"] = this.officialName;
        data["breeding"] = this.breeding;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["breedGroup"] = this.breedGroup ? this.breedGroup.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.competitionBreeds)) {
            data["competitionBreeds"] = [];
            for (let item of this.competitionBreeds)
                data["competitionBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.expoBreedForJudges)) {
            data["expoBreedForJudges"] = [];
            for (let item of this.expoBreedForJudges)
                data["expoBreedForJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionCommissionerForbiddenBreeds)) {
            data["competitionCommissionerForbiddenBreeds"] = [];
            for (let item of this.competitionCommissionerForbiddenBreeds)
                data["competitionCommissionerForbiddenBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.breedHealthPacks)) {
            data["breedHealthPacks"] = [];
            for (let item of this.breedHealthPacks)
                data["breedHealthPacks"].push(item.toJSON());
        }
        if (Array.isArray(this.breedJudgeTransients)) {
            data["breedJudgeTransients"] = [];
            for (let item of this.breedJudgeTransients)
                data["breedJudgeTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.clubsBreeds)) {
            data["clubsBreeds"] = [];
            for (let item of this.clubsBreeds)
                data["clubsBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.breedsColors)) {
            data["breedsColors"] = [];
            for (let item of this.breedsColors)
                data["breedsColors"].push(item.toJSON());
        }
        if (Array.isArray(this.breedsWorkbookTypes)) {
            data["breedsWorkbookTypes"] = [];
            for (let item of this.breedsWorkbookTypes)
                data["breedsWorkbookTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.dogs)) {
            data["dogs"] = [];
            for (let item of this.dogs)
                data["dogs"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceBreeds)) {
            data["sourceBreeds"] = [];
            for (let item of this.sourceBreeds)
                data["sourceBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.destinationBreeds)) {
            data["destinationBreeds"] = [];
            for (let item of this.destinationBreeds)
                data["destinationBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.destinationExceptions)) {
            data["destinationExceptions"] = [];
            for (let item of this.destinationExceptions)
                data["destinationExceptions"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceExceptions)) {
            data["sourceExceptions"] = [];
            for (let item of this.sourceExceptions)
                data["sourceExceptions"].push(item.toJSON());
        }
        if (Array.isArray(this.breedsJudges)) {
            data["breedsJudges"] = [];
            for (let item of this.breedsJudges)
                data["breedsJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.breedTranslations)) {
            data["breedTranslations"] = [];
            for (let item of this.breedTranslations)
                data["breedTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelsBreeds)) {
            data["kennelsBreeds"] = [];
            for (let item of this.kennelsBreeds)
                data["kennelsBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.transientNewKennelBreeds)) {
            data["transientNewKennelBreeds"] = [];
            for (let item of this.transientNewKennelBreeds)
                data["transientNewKennelBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.transientKennelImportBreeds)) {
            data["transientKennelImportBreeds"] = [];
            for (let item of this.transientKennelImportBreeds)
                data["transientKennelImportBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.dogBroodRequestsTransients)) {
            data["dogBroodRequestsTransients"] = [];
            for (let item of this.dogBroodRequestsTransients)
                data["dogBroodRequestsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.ringDivisions)) {
            data["ringDivisions"] = [];
            for (let item of this.ringDivisions)
                data["ringDivisions"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface IBreed {
    breedId?: number;
    fciNumber?: number | undefined;
    knownAt?: Date | undefined;
    countryId?: number;
    breedGroupId?: number;
    subjectToWork?: boolean;
    agility?: EDifficulty | undefined;
    grooming?: EDifficulty | undefined;
    standardConfirmation?: boolean;
    shortenedTail?: boolean;
    sizeMin?: number | undefined;
    sizeMax?: number | undefined;
    weightMin?: number | undefined;
    weightMax?: number | undefined;
    varietyNumber?: number | undefined;
    remark?: string | undefined;
    breedNumber?: number;
    internshipDate?: Date | undefined;
    minDysplasiaAgeInMonths?: number;
    cegekaId?: string | undefined;
    userId?: number | undefined;
    officialName?: string | undefined;
    breeding?: boolean;
    user?: User | undefined;
    breedGroup?: BreedGroup | undefined;
    country?: Country | undefined;
    competitionBreeds?: CompetitionBreed[] | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
    competitionCommissionerForbiddenBreeds?: CompetitionCommissionerForbiddenBreed[] | undefined;
    breedHealthPacks?: BreedHealthPack[] | undefined;
    breedJudgeTransients?: BreedJudgeTransient[] | undefined;
    clubsBreeds?: ClubBreed[] | undefined;
    breedsColors?: BreedColor[] | undefined;
    breedsWorkbookTypes?: BreedWorkbookType[] | undefined;
    dogs?: Dog[] | undefined;
    sourceBreeds?: BreedVariety[] | undefined;
    destinationBreeds?: BreedVariety[] | undefined;
    destinationExceptions?: BreedingException[] | undefined;
    sourceExceptions?: BreedingException[] | undefined;
    breedsJudges?: BreedJudge[] | undefined;
    breedTranslations?: BreedTranslation[] | undefined;
    kennelsBreeds?: KennelBreed[] | undefined;
    transientNewKennelBreeds?: TransientNewKennelBreed[] | undefined;
    transientKennelImportBreeds?: TransientKennelImportBreed[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    ringDivisions?: RingDivision[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;
}

export class User implements IUser {
    userId?: number;
    userProfileId?: number;
    email?: string | undefined;
    password?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    active?: boolean;
    mustResetPassword?: boolean;
    canBeBreedVeterinary?: boolean;
    languageId?: number;
    lastConnectionDate?: Date | undefined;
    language?: Language | undefined;
    userProfile?: UserProfile | undefined;
    usersInterests?: UserInterest[] | undefined;
    userDepartments?: UserDepartment[] | undefined;
    requests?: Request[] | undefined;
    userDysplasiaResults?: UserDysplasiaResult[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    dogTitlesTransients?: DogTitlesTransient[] | undefined;
    requestActions?: RequestAction[] | undefined;
    dogActions?: DogAction[] | undefined;
    dogTransients?: DogTransient[] | undefined;
    dogHealthTestValidations?: DogHealthTestValidation[] | undefined;
    breeds?: Breed[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userProfileId = _data["userProfileId"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.active = _data["active"];
            this.mustResetPassword = _data["mustResetPassword"];
            this.canBeBreedVeterinary = _data["canBeBreedVeterinary"];
            this.languageId = _data["languageId"];
            this.lastConnectionDate = _data["lastConnectionDate"] ? new Date(_data["lastConnectionDate"].toString()) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"]) : <any>undefined;
            if (Array.isArray(_data["usersInterests"])) {
                this.usersInterests = [] as any;
                for (let item of _data["usersInterests"])
                    this.usersInterests!.push(UserInterest.fromJS(item));
            }
            if (Array.isArray(_data["userDepartments"])) {
                this.userDepartments = [] as any;
                for (let item of _data["userDepartments"])
                    this.userDepartments!.push(UserDepartment.fromJS(item));
            }
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(Request.fromJS(item));
            }
            if (Array.isArray(_data["userDysplasiaResults"])) {
                this.userDysplasiaResults = [] as any;
                for (let item of _data["userDysplasiaResults"])
                    this.userDysplasiaResults!.push(UserDysplasiaResult.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValuesTransients"])) {
                this.dogsCharacteristicsValuesTransients = [] as any;
                for (let item of _data["dogsCharacteristicsValuesTransients"])
                    this.dogsCharacteristicsValuesTransients!.push(DogsCharacteristicsValuesTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogTitlesTransients"])) {
                this.dogTitlesTransients = [] as any;
                for (let item of _data["dogTitlesTransients"])
                    this.dogTitlesTransients!.push(DogTitlesTransient.fromJS(item));
            }
            if (Array.isArray(_data["requestActions"])) {
                this.requestActions = [] as any;
                for (let item of _data["requestActions"])
                    this.requestActions!.push(RequestAction.fromJS(item));
            }
            if (Array.isArray(_data["dogActions"])) {
                this.dogActions = [] as any;
                for (let item of _data["dogActions"])
                    this.dogActions!.push(DogAction.fromJS(item));
            }
            if (Array.isArray(_data["dogTransients"])) {
                this.dogTransients = [] as any;
                for (let item of _data["dogTransients"])
                    this.dogTransients!.push(DogTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestValidations"])) {
                this.dogHealthTestValidations = [] as any;
                for (let item of _data["dogHealthTestValidations"])
                    this.dogHealthTestValidations!.push(DogHealthTestValidation.fromJS(item));
            }
            if (Array.isArray(_data["breeds"])) {
                this.breeds = [] as any;
                for (let item of _data["breeds"])
                    this.breeds!.push(Breed.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userProfileId"] = this.userProfileId;
        data["email"] = this.email;
        data["password"] = this.password;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["active"] = this.active;
        data["mustResetPassword"] = this.mustResetPassword;
        data["canBeBreedVeterinary"] = this.canBeBreedVeterinary;
        data["languageId"] = this.languageId;
        data["lastConnectionDate"] = this.lastConnectionDate ? this.lastConnectionDate.toISOString() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        if (Array.isArray(this.usersInterests)) {
            data["usersInterests"] = [];
            for (let item of this.usersInterests)
                data["usersInterests"].push(item.toJSON());
        }
        if (Array.isArray(this.userDepartments)) {
            data["userDepartments"] = [];
            for (let item of this.userDepartments)
                data["userDepartments"].push(item.toJSON());
        }
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        if (Array.isArray(this.userDysplasiaResults)) {
            data["userDysplasiaResults"] = [];
            for (let item of this.userDysplasiaResults)
                data["userDysplasiaResults"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValuesTransients)) {
            data["dogsCharacteristicsValuesTransients"] = [];
            for (let item of this.dogsCharacteristicsValuesTransients)
                data["dogsCharacteristicsValuesTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTitlesTransients)) {
            data["dogTitlesTransients"] = [];
            for (let item of this.dogTitlesTransients)
                data["dogTitlesTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.requestActions)) {
            data["requestActions"] = [];
            for (let item of this.requestActions)
                data["requestActions"].push(item.toJSON());
        }
        if (Array.isArray(this.dogActions)) {
            data["dogActions"] = [];
            for (let item of this.dogActions)
                data["dogActions"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTransients)) {
            data["dogTransients"] = [];
            for (let item of this.dogTransients)
                data["dogTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestValidations)) {
            data["dogHealthTestValidations"] = [];
            for (let item of this.dogHealthTestValidations)
                data["dogHealthTestValidations"].push(item.toJSON());
        }
        if (Array.isArray(this.breeds)) {
            data["breeds"] = [];
            for (let item of this.breeds)
                data["breeds"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IUser {
    userId?: number;
    userProfileId?: number;
    email?: string | undefined;
    password?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    active?: boolean;
    mustResetPassword?: boolean;
    canBeBreedVeterinary?: boolean;
    languageId?: number;
    lastConnectionDate?: Date | undefined;
    language?: Language | undefined;
    userProfile?: UserProfile | undefined;
    usersInterests?: UserInterest[] | undefined;
    userDepartments?: UserDepartment[] | undefined;
    requests?: Request[] | undefined;
    userDysplasiaResults?: UserDysplasiaResult[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    dogTitlesTransients?: DogTitlesTransient[] | undefined;
    requestActions?: RequestAction[] | undefined;
    dogActions?: DogAction[] | undefined;
    dogTransients?: DogTransient[] | undefined;
    dogHealthTestValidations?: DogHealthTestValidation[] | undefined;
    breeds?: Breed[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class UserProfile implements IUserProfile {
    userProfileId?: number;
    code?: EUserProfile;
    mustBeUnique?: boolean;
    defaultRoute?: string | undefined;
    users?: User[] | undefined;
    userProfileTranslation?: UserProfileTranslation[] | undefined;
    userProfileActions?: UserProfileAction[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfileId = _data["userProfileId"];
            this.code = _data["code"];
            this.mustBeUnique = _data["mustBeUnique"];
            this.defaultRoute = _data["defaultRoute"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["userProfileTranslation"])) {
                this.userProfileTranslation = [] as any;
                for (let item of _data["userProfileTranslation"])
                    this.userProfileTranslation!.push(UserProfileTranslation.fromJS(item));
            }
            if (Array.isArray(_data["userProfileActions"])) {
                this.userProfileActions = [] as any;
                for (let item of _data["userProfileActions"])
                    this.userProfileActions!.push(UserProfileAction.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfileId"] = this.userProfileId;
        data["code"] = this.code;
        data["mustBeUnique"] = this.mustBeUnique;
        data["defaultRoute"] = this.defaultRoute;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.userProfileTranslation)) {
            data["userProfileTranslation"] = [];
            for (let item of this.userProfileTranslation)
                data["userProfileTranslation"].push(item.toJSON());
        }
        if (Array.isArray(this.userProfileActions)) {
            data["userProfileActions"] = [];
            for (let item of this.userProfileActions)
                data["userProfileActions"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserProfile {
    userProfileId?: number;
    code?: EUserProfile;
    mustBeUnique?: boolean;
    defaultRoute?: string | undefined;
    users?: User[] | undefined;
    userProfileTranslation?: UserProfileTranslation[] | undefined;
    userProfileActions?: UserProfileAction[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EUserProfile {
    God = "God",
    User = "User",
    Administrator = "Administrator",
    Veterinary = "Veterinary",
    GentVeterinary = "GentVeterinary",
    PresidentVeterinary = "PresidentVeterinary",
    Appeal = "Appeal",
}

export class UserProfileTranslation implements IUserProfileTranslation {
    userProfileTranslationId?: number;
    userProfileId?: number;
    languageId?: number;
    text?: string | undefined;
    userProfile?: UserProfile | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserProfileTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfileTranslationId = _data["userProfileTranslationId"];
            this.userProfileId = _data["userProfileId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserProfileTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfileTranslationId"] = this.userProfileTranslationId;
        data["userProfileId"] = this.userProfileId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserProfileTranslation {
    userProfileTranslationId?: number;
    userProfileId?: number;
    languageId?: number;
    text?: string | undefined;
    userProfile?: UserProfile | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class UserProfileAction implements IUserProfileAction {
    userProfileActionId?: number;
    actionId?: number;
    userProfileId?: number;
    permission?: EPermission;
    userProfile?: UserProfile | undefined;
    action?: Action | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserProfileAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfileActionId = _data["userProfileActionId"];
            this.actionId = _data["actionId"];
            this.userProfileId = _data["userProfileId"];
            this.permission = _data["permission"];
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"]) : <any>undefined;
            this.action = _data["action"] ? Action.fromJS(_data["action"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserProfileAction {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfileActionId"] = this.userProfileActionId;
        data["actionId"] = this.actionId;
        data["userProfileId"] = this.userProfileId;
        data["permission"] = this.permission;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserProfileAction {
    userProfileActionId?: number;
    actionId?: number;
    userProfileId?: number;
    permission?: EPermission;
    userProfile?: UserProfile | undefined;
    action?: Action | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EPermission {
    R = "R",
    RW = "RW",
    RWD = "RWD",
    E = "E",
    NONE = "NONE",
}

export class Action implements IAction {
    actionId?: number;
    module?: string | undefined;
    tab?: string | undefined;
    executable?: boolean;
    userProfileActions?: UserProfileAction[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
            this.module = _data["module"];
            this.tab = _data["tab"];
            this.executable = _data["executable"];
            if (Array.isArray(_data["userProfileActions"])) {
                this.userProfileActions = [] as any;
                for (let item of _data["userProfileActions"])
                    this.userProfileActions!.push(UserProfileAction.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        data["module"] = this.module;
        data["tab"] = this.tab;
        data["executable"] = this.executable;
        if (Array.isArray(this.userProfileActions)) {
            data["userProfileActions"] = [];
            for (let item of this.userProfileActions)
                data["userProfileActions"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IAction {
    actionId?: number;
    module?: string | undefined;
    tab?: string | undefined;
    executable?: boolean;
    userProfileActions?: UserProfileAction[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class UserInterest implements IUserInterest {
    userInterestId?: number;
    userId?: number;
    user?: User | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserInterest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userInterestId = _data["userInterestId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserInterest {
        data = typeof data === 'object' ? data : {};
        let result = new UserInterest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userInterestId"] = this.userInterestId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserInterest {
    userInterestId?: number;
    userId?: number;
    user?: User | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class UserDepartment implements IUserDepartment {
    userDepartmentId?: number;
    userId?: number;
    user?: User | undefined;
    departmentId?: number;
    department?: Department | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDepartmentId = _data["userDepartmentId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new UserDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDepartmentId"] = this.userDepartmentId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserDepartment {
    userDepartmentId?: number;
    userId?: number;
    user?: User | undefined;
    departmentId?: number;
    department?: Department | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Department implements IDepartment {
    departmentId?: number;
    code?: EDepartment;
    departmentTranslations?: DepartmentTranslation[] | undefined;
    userDepartments?: UserDepartment[] | undefined;
    departementRequestTypes?: DepartmentRequestType[] | undefined;
    dashboardTasks?: DashboardTask[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            this.code = _data["code"];
            if (Array.isArray(_data["departmentTranslations"])) {
                this.departmentTranslations = [] as any;
                for (let item of _data["departmentTranslations"])
                    this.departmentTranslations!.push(DepartmentTranslation.fromJS(item));
            }
            if (Array.isArray(_data["userDepartments"])) {
                this.userDepartments = [] as any;
                for (let item of _data["userDepartments"])
                    this.userDepartments!.push(UserDepartment.fromJS(item));
            }
            if (Array.isArray(_data["departementRequestTypes"])) {
                this.departementRequestTypes = [] as any;
                for (let item of _data["departementRequestTypes"])
                    this.departementRequestTypes!.push(DepartmentRequestType.fromJS(item));
            }
            if (Array.isArray(_data["dashboardTasks"])) {
                this.dashboardTasks = [] as any;
                for (let item of _data["dashboardTasks"])
                    this.dashboardTasks!.push(DashboardTask.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        data["code"] = this.code;
        if (Array.isArray(this.departmentTranslations)) {
            data["departmentTranslations"] = [];
            for (let item of this.departmentTranslations)
                data["departmentTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.userDepartments)) {
            data["userDepartments"] = [];
            for (let item of this.userDepartments)
                data["userDepartments"].push(item.toJSON());
        }
        if (Array.isArray(this.departementRequestTypes)) {
            data["departementRequestTypes"] = [];
            for (let item of this.departementRequestTypes)
                data["departementRequestTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.dashboardTasks)) {
            data["dashboardTasks"] = [];
            for (let item of this.dashboardTasks)
                data["dashboardTasks"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDepartment {
    departmentId?: number;
    code?: EDepartment;
    departmentTranslations?: DepartmentTranslation[] | undefined;
    userDepartments?: UserDepartment[] | undefined;
    departementRequestTypes?: DepartmentRequestType[] | undefined;
    dashboardTasks?: DashboardTask[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDepartment {
    Affix = "Affix",
    Accounting = "Accounting",
    DogUpdate = "DogUpdate",
    Pedigree = "Pedigree",
    Health = "Health",
    Sport = "Sport",
}

export class DepartmentTranslation implements IDepartmentTranslation {
    departmentTranslationId?: number;
    text?: string | undefined;
    departmentId?: number;
    department?: Department | undefined;
    languageId?: number;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDepartmentTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentTranslationId = _data["departmentTranslationId"];
            this.text = _data["text"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.languageId = _data["languageId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DepartmentTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentTranslationId"] = this.departmentTranslationId;
        data["text"] = this.text;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDepartmentTranslation {
    departmentTranslationId?: number;
    text?: string | undefined;
    departmentId?: number;
    department?: Department | undefined;
    languageId?: number;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DepartmentRequestType implements IDepartmentRequestType {
    departmentRequestTypeId?: number;
    departementId?: number;
    requestTypeId?: number;
    departement?: Department | undefined;
    requestType?: RequestType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDepartmentRequestType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentRequestTypeId = _data["departmentRequestTypeId"];
            this.departementId = _data["departementId"];
            this.requestTypeId = _data["requestTypeId"];
            this.departement = _data["departement"] ? Department.fromJS(_data["departement"]) : <any>undefined;
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DepartmentRequestType {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentRequestType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentRequestTypeId"] = this.departmentRequestTypeId;
        data["departementId"] = this.departementId;
        data["requestTypeId"] = this.requestTypeId;
        data["departement"] = this.departement ? this.departement.toJSON() : <any>undefined;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDepartmentRequestType {
    departmentRequestTypeId?: number;
    departementId?: number;
    requestTypeId?: number;
    departement?: Department | undefined;
    requestType?: RequestType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class RequestType implements IRequestType {
    requestTypeId?: number;
    requestTypeCode?: ERequestType;
    requestDescriptionNumber?: number;
    manualCreationInvolvesFees?: boolean;
    orderIndex?: number;
    requests?: Request[] | undefined;
    neededConditions?: NeededCondition[] | undefined;
    neededVerifications?: NeededVerification[] | undefined;
    requestTypeTranslations?: RequestTypeTranslation[] | undefined;
    departementRequestTypes?: DepartmentRequestType[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRequestType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestTypeId = _data["requestTypeId"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.requestDescriptionNumber = _data["requestDescriptionNumber"];
            this.manualCreationInvolvesFees = _data["manualCreationInvolvesFees"];
            this.orderIndex = _data["orderIndex"];
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(Request.fromJS(item));
            }
            if (Array.isArray(_data["neededConditions"])) {
                this.neededConditions = [] as any;
                for (let item of _data["neededConditions"])
                    this.neededConditions!.push(NeededCondition.fromJS(item));
            }
            if (Array.isArray(_data["neededVerifications"])) {
                this.neededVerifications = [] as any;
                for (let item of _data["neededVerifications"])
                    this.neededVerifications!.push(NeededVerification.fromJS(item));
            }
            if (Array.isArray(_data["requestTypeTranslations"])) {
                this.requestTypeTranslations = [] as any;
                for (let item of _data["requestTypeTranslations"])
                    this.requestTypeTranslations!.push(RequestTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["departementRequestTypes"])) {
                this.departementRequestTypes = [] as any;
                for (let item of _data["departementRequestTypes"])
                    this.departementRequestTypes!.push(DepartmentRequestType.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RequestType {
        data = typeof data === 'object' ? data : {};
        let result = new RequestType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestTypeId"] = this.requestTypeId;
        data["requestTypeCode"] = this.requestTypeCode;
        data["requestDescriptionNumber"] = this.requestDescriptionNumber;
        data["manualCreationInvolvesFees"] = this.manualCreationInvolvesFees;
        data["orderIndex"] = this.orderIndex;
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        if (Array.isArray(this.neededConditions)) {
            data["neededConditions"] = [];
            for (let item of this.neededConditions)
                data["neededConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.neededVerifications)) {
            data["neededVerifications"] = [];
            for (let item of this.neededVerifications)
                data["neededVerifications"].push(item.toJSON());
        }
        if (Array.isArray(this.requestTypeTranslations)) {
            data["requestTypeTranslations"] = [];
            for (let item of this.requestTypeTranslations)
                data["requestTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.departementRequestTypes)) {
            data["departementRequestTypes"] = [];
            for (let item of this.departementRequestTypes)
                data["departementRequestTypes"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRequestType {
    requestTypeId?: number;
    requestTypeCode?: ERequestType;
    requestDescriptionNumber?: number;
    manualCreationInvolvesFees?: boolean;
    orderIndex?: number;
    requests?: Request[] | undefined;
    neededConditions?: NeededCondition[] | undefined;
    neededVerifications?: NeededVerification[] | undefined;
    requestTypeTranslations?: RequestTypeTranslation[] | undefined;
    departementRequestTypes?: DepartmentRequestType[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class NeededCondition implements INeededCondition {
    neededConditionId?: number;
    requestTypeId?: number;
    requestStatusId?: number;
    conditionCode?: ERequestConditions;
    forcible?: boolean;
    requestStatus?: RequestStatus | undefined;
    requestType?: RequestType | undefined;
    neededConditionTranslations?: NeededConditionTranslation[] | undefined;
    conditionForcedValues?: ConditionsForcedValue[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: INeededCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neededConditionId = _data["neededConditionId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestStatusId = _data["requestStatusId"];
            this.conditionCode = _data["conditionCode"];
            this.forcible = _data["forcible"];
            this.requestStatus = _data["requestStatus"] ? RequestStatus.fromJS(_data["requestStatus"]) : <any>undefined;
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            if (Array.isArray(_data["neededConditionTranslations"])) {
                this.neededConditionTranslations = [] as any;
                for (let item of _data["neededConditionTranslations"])
                    this.neededConditionTranslations!.push(NeededConditionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["conditionForcedValues"])) {
                this.conditionForcedValues = [] as any;
                for (let item of _data["conditionForcedValues"])
                    this.conditionForcedValues!.push(ConditionsForcedValue.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): NeededCondition {
        data = typeof data === 'object' ? data : {};
        let result = new NeededCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neededConditionId"] = this.neededConditionId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestStatusId"] = this.requestStatusId;
        data["conditionCode"] = this.conditionCode;
        data["forcible"] = this.forcible;
        data["requestStatus"] = this.requestStatus ? this.requestStatus.toJSON() : <any>undefined;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        if (Array.isArray(this.neededConditionTranslations)) {
            data["neededConditionTranslations"] = [];
            for (let item of this.neededConditionTranslations)
                data["neededConditionTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.conditionForcedValues)) {
            data["conditionForcedValues"] = [];
            for (let item of this.conditionForcedValues)
                data["conditionForcedValues"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface INeededCondition {
    neededConditionId?: number;
    requestTypeId?: number;
    requestStatusId?: number;
    conditionCode?: ERequestConditions;
    forcible?: boolean;
    requestStatus?: RequestStatus | undefined;
    requestType?: RequestType | undefined;
    neededConditionTranslations?: NeededConditionTranslation[] | undefined;
    conditionForcedValues?: ConditionsForcedValue[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum ERequestConditions {
    IsDog15MonthsOld = "IsDog15MonthsOld",
    IsDogSocial = "IsDogSocial",
    IsDogAllowedForReproduction = "IsDogAllowedForReproduction",
    IsDogNotExluded = "IsDogNotExluded",
    IsTemporaryOwnerNotExcluded = "IsTemporaryOwnerNotExcluded",
    IsMeetingPast = "IsMeetingPast",
    IsDecisionAccepted = "IsDecisionAccepted",
    IsDogMinAgeForDysplasia = "IsDogMinAgeForDysplasia",
    HasOtherBilledNonPaidRequests = "HasOtherBilledNonPaidRequests",
    CatalogReceived = "CatalogReceived",
    HasMin2ShowsWithGoodResults = "HasMin2ShowsWithGoodResults",
    AreBreedsMentioned = "AreBreedsMentioned",
    AreOwnersMentionedNewkennel = "AreOwnersMentionedNewkennel",
    AreOwnersMentionedImport = "AreOwnersMentionedImport",
    AreOwnersMentioned = "AreOwnersMentioned",
    BroodRequestOwnerKennel = "BroodRequestOwnerKennel",
    BroodRequestMixBreeds = "BroodRequestMixBreeds",
    AreBreedsMentionedImport = "AreBreedsMentionedImport",
    TempRSHValidDog = "TempRSHValidDog",
    RSHValidDog = "RSHValidDog",
    BroodValidDog = "BroodValidDog",
    RISHValidDog = "RISHValidDog",
    DuplicataValidDog = "DuplicataValidDog",
    ImportValidDog = "ImportValidDog",
    DysplasiaValidDog = "DysplasiaValidDog",
    HealthTestValidDog = "HealthTestValidDog",
    WorkAttestValidDog = "WorkAttestValidDog",
    WorkbookValidDog = "WorkbookValidDog",
    TitleValidDog = "TitleValidDog",
    IsDeclarationDoneIn21Days = "IsDeclarationDoneIn21Days",
    PuppiesHaveOwners = "PuppiesHaveOwners",
    OnlyRequestWithBirthDate = "OnlyRequestWithBirthDate",
    AtLeastOnePuppy = "AtLeastOnePuppy",
    BirthDateIsSet = "BirthDateIsSet",
    JudgesValidated = "JudgesValidated",
    PuppyNumberConfirmed = "PuppyNumberConfirmed",
    As400GenealogyComplete = "As400GenealogyComplete",
    AllOwnersForeign = "AllOwnersForeign",
    TransientOwnerSelected = "TransientOwnerSelected",
    DogsMustBeBreedingAuthorised = "DogsMustBeBreedingAuthorised",
    AreBreedsSelected = "AreBreedsSelected",
    IsManagerSelected = "IsManagerSelected",
    JudgeBreedValidated = "JudgeBreedValidated",
    FatherInbreedingCompleted = "FatherInbreedingCompleted",
}

export class RequestStatus implements IRequestStatus {
    requestStatusId?: number;
    requestStateCode?: ERequestState;
    requests?: Request[] | undefined;
    requestsPreviousStatus?: Request[] | undefined;
    requestStatusTranslations?: RequestStatusTranslation[] | undefined;
    neededConditions?: NeededCondition[] | undefined;
    neededVerifications?: NeededVerification[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRequestStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestStatusId = _data["requestStatusId"];
            this.requestStateCode = _data["requestStateCode"];
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(Request.fromJS(item));
            }
            if (Array.isArray(_data["requestsPreviousStatus"])) {
                this.requestsPreviousStatus = [] as any;
                for (let item of _data["requestsPreviousStatus"])
                    this.requestsPreviousStatus!.push(Request.fromJS(item));
            }
            if (Array.isArray(_data["requestStatusTranslations"])) {
                this.requestStatusTranslations = [] as any;
                for (let item of _data["requestStatusTranslations"])
                    this.requestStatusTranslations!.push(RequestStatusTranslation.fromJS(item));
            }
            if (Array.isArray(_data["neededConditions"])) {
                this.neededConditions = [] as any;
                for (let item of _data["neededConditions"])
                    this.neededConditions!.push(NeededCondition.fromJS(item));
            }
            if (Array.isArray(_data["neededVerifications"])) {
                this.neededVerifications = [] as any;
                for (let item of _data["neededVerifications"])
                    this.neededVerifications!.push(NeededVerification.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RequestStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestStatusId"] = this.requestStatusId;
        data["requestStateCode"] = this.requestStateCode;
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        if (Array.isArray(this.requestsPreviousStatus)) {
            data["requestsPreviousStatus"] = [];
            for (let item of this.requestsPreviousStatus)
                data["requestsPreviousStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.requestStatusTranslations)) {
            data["requestStatusTranslations"] = [];
            for (let item of this.requestStatusTranslations)
                data["requestStatusTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.neededConditions)) {
            data["neededConditions"] = [];
            for (let item of this.neededConditions)
                data["neededConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.neededVerifications)) {
            data["neededVerifications"] = [];
            for (let item of this.neededVerifications)
                data["neededVerifications"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRequestStatus {
    requestStatusId?: number;
    requestStateCode?: ERequestState;
    requests?: Request[] | undefined;
    requestsPreviousStatus?: Request[] | undefined;
    requestStatusTranslations?: RequestStatusTranslation[] | undefined;
    neededConditions?: NeededCondition[] | undefined;
    neededVerifications?: NeededVerification[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class RequestStatusTranslation implements IRequestStatusTranslation {
    requestStatusTranslationId?: number;
    requestStatusId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    requestStatus?: RequestStatus | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRequestStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestStatusTranslationId = _data["requestStatusTranslationId"];
            this.requestStatusId = _data["requestStatusId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.requestStatus = _data["requestStatus"] ? RequestStatus.fromJS(_data["requestStatus"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RequestStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new RequestStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestStatusTranslationId"] = this.requestStatusTranslationId;
        data["requestStatusId"] = this.requestStatusId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["requestStatus"] = this.requestStatus ? this.requestStatus.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRequestStatusTranslation {
    requestStatusTranslationId?: number;
    requestStatusId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    requestStatus?: RequestStatus | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class NeededVerification implements INeededVerification {
    neededVerificationId?: number;
    required?: boolean;
    requestTypeId?: number;
    requestStatusId?: number;
    verificationCode?: ERequestVerification;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    requestStatus?: RequestStatus | undefined;
    requestType?: RequestType | undefined;
    neededVerificationsTranslations?: NeededVerificationTranslation[] | undefined;
    verificationValues?: VerificationsValue[] | undefined;

    constructor(data?: INeededVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neededVerificationId = _data["neededVerificationId"];
            this.required = _data["required"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestStatusId = _data["requestStatusId"];
            this.verificationCode = _data["verificationCode"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.requestStatus = _data["requestStatus"] ? RequestStatus.fromJS(_data["requestStatus"]) : <any>undefined;
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            if (Array.isArray(_data["neededVerificationsTranslations"])) {
                this.neededVerificationsTranslations = [] as any;
                for (let item of _data["neededVerificationsTranslations"])
                    this.neededVerificationsTranslations!.push(NeededVerificationTranslation.fromJS(item));
            }
            if (Array.isArray(_data["verificationValues"])) {
                this.verificationValues = [] as any;
                for (let item of _data["verificationValues"])
                    this.verificationValues!.push(VerificationsValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NeededVerification {
        data = typeof data === 'object' ? data : {};
        let result = new NeededVerification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neededVerificationId"] = this.neededVerificationId;
        data["required"] = this.required;
        data["requestTypeId"] = this.requestTypeId;
        data["requestStatusId"] = this.requestStatusId;
        data["verificationCode"] = this.verificationCode;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["requestStatus"] = this.requestStatus ? this.requestStatus.toJSON() : <any>undefined;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        if (Array.isArray(this.neededVerificationsTranslations)) {
            data["neededVerificationsTranslations"] = [];
            for (let item of this.neededVerificationsTranslations)
                data["neededVerificationsTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.verificationValues)) {
            data["verificationValues"] = [];
            for (let item of this.verificationValues)
                data["verificationValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface INeededVerification {
    neededVerificationId?: number;
    required?: boolean;
    requestTypeId?: number;
    requestStatusId?: number;
    verificationCode?: ERequestVerification;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    requestStatus?: RequestStatus | undefined;
    requestType?: RequestType | undefined;
    neededVerificationsTranslations?: NeededVerificationTranslation[] | undefined;
    verificationValues?: VerificationsValue[] | undefined;
}

export enum ERequestVerification {
    AreJudgesOk = "AreJudgesOk",
    AsleepDog = "AsleepDog",
    ExportPedigree = "ExportPedigree",
    IdentityCard = "IdentityCard",
    ImportFormular = "ImportFormular",
    InCalendar = "InCalendar",
    Is18Old = "Is18Old",
    IsCanineOk = "IsCanineOk",
    IsOldOwnerOk = "IsOldOwnerOk",
    KennelNameType = "KennelNameType",
    OriginalPedigree = "OriginalPedigree",
    ResultCopy = "ResultCopy",
    TitleDocument = "TitleDocument",
    WorkbookCopy = "WorkbookCopy",
    PedigreeReceived = "PedigreeReceived",
    BRCSHealthTestCheckd = "BRCSHealthTestCheckd",
    BRCSPuppyInbreedCheck = "BRCSPuppyInbreedCheck",
}

export class NeededVerificationTranslation implements INeededVerificationTranslation {
    neededVerificationTranslationId?: number;
    text?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    languageId?: number;
    neededVerificationId?: number;
    language?: Language | undefined;
    neededVerification?: NeededVerification | undefined;

    constructor(data?: INeededVerificationTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neededVerificationTranslationId = _data["neededVerificationTranslationId"];
            this.text = _data["text"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.languageId = _data["languageId"];
            this.neededVerificationId = _data["neededVerificationId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.neededVerification = _data["neededVerification"] ? NeededVerification.fromJS(_data["neededVerification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NeededVerificationTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new NeededVerificationTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neededVerificationTranslationId"] = this.neededVerificationTranslationId;
        data["text"] = this.text;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["languageId"] = this.languageId;
        data["neededVerificationId"] = this.neededVerificationId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["neededVerification"] = this.neededVerification ? this.neededVerification.toJSON() : <any>undefined;
        return data;
    }
}

export interface INeededVerificationTranslation {
    neededVerificationTranslationId?: number;
    text?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    languageId?: number;
    neededVerificationId?: number;
    language?: Language | undefined;
    neededVerification?: NeededVerification | undefined;
}

export class VerificationsValue implements IVerificationsValue {
    verificationsValueId?: number;
    isVerified?: boolean;
    requestId?: number;
    neededVerificationId?: number;
    request?: Request | undefined;
    neededVerification?: NeededVerification | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IVerificationsValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationsValueId = _data["verificationsValueId"];
            this.isVerified = _data["isVerified"];
            this.requestId = _data["requestId"];
            this.neededVerificationId = _data["neededVerificationId"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.neededVerification = _data["neededVerification"] ? NeededVerification.fromJS(_data["neededVerification"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): VerificationsValue {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationsValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationsValueId"] = this.verificationsValueId;
        data["isVerified"] = this.isVerified;
        data["requestId"] = this.requestId;
        data["neededVerificationId"] = this.neededVerificationId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["neededVerification"] = this.neededVerification ? this.neededVerification.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IVerificationsValue {
    verificationsValueId?: number;
    isVerified?: boolean;
    requestId?: number;
    neededVerificationId?: number;
    request?: Request | undefined;
    neededVerification?: NeededVerification | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class NeededConditionTranslation implements INeededConditionTranslation {
    neededConditionTranslationId?: number;
    neededConditionId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    neededCondition?: NeededCondition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: INeededConditionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neededConditionTranslationId = _data["neededConditionTranslationId"];
            this.neededConditionId = _data["neededConditionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.neededCondition = _data["neededCondition"] ? NeededCondition.fromJS(_data["neededCondition"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): NeededConditionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new NeededConditionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neededConditionTranslationId"] = this.neededConditionTranslationId;
        data["neededConditionId"] = this.neededConditionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["neededCondition"] = this.neededCondition ? this.neededCondition.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface INeededConditionTranslation {
    neededConditionTranslationId?: number;
    neededConditionId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    neededCondition?: NeededCondition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ConditionsForcedValue implements IConditionsForcedValue {
    conditionsForcedValueId?: number;
    neededConditionId?: number;
    requestId?: number;
    request?: Request | undefined;
    neededCondition?: NeededCondition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IConditionsForcedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionsForcedValueId = _data["conditionsForcedValueId"];
            this.neededConditionId = _data["neededConditionId"];
            this.requestId = _data["requestId"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.neededCondition = _data["neededCondition"] ? NeededCondition.fromJS(_data["neededCondition"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ConditionsForcedValue {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionsForcedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionsForcedValueId"] = this.conditionsForcedValueId;
        data["neededConditionId"] = this.neededConditionId;
        data["requestId"] = this.requestId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["neededCondition"] = this.neededCondition ? this.neededCondition.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IConditionsForcedValue {
    conditionsForcedValueId?: number;
    neededConditionId?: number;
    requestId?: number;
    request?: Request | undefined;
    neededCondition?: NeededCondition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class RequestTypeTranslation implements IRequestTypeTranslation {
    requestTypeTranslationId?: number;
    requestTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    requestType?: RequestType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRequestTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestTypeTranslationId = _data["requestTypeTranslationId"];
            this.requestTypeId = _data["requestTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.requestType = _data["requestType"] ? RequestType.fromJS(_data["requestType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RequestTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new RequestTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestTypeTranslationId"] = this.requestTypeTranslationId;
        data["requestTypeId"] = this.requestTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRequestTypeTranslation {
    requestTypeTranslationId?: number;
    requestTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    requestType?: RequestType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DashboardTask implements IDashboardTask {
    dashboardTaskId?: number;
    requestId?: number | undefined;
    managerId?: number | undefined;
    departmentId?: number | undefined;
    dashboardTaskTypeId?: number;
    closedOn?: Date | undefined;
    request?: Request | undefined;
    department?: Department | undefined;
    dashboardTaskType?: DashboardTaskType | undefined;
    manager?: User | undefined;
    dashboardTaskTranslations?: DashboardTaskTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDashboardTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardTaskId = _data["dashboardTaskId"];
            this.requestId = _data["requestId"];
            this.managerId = _data["managerId"];
            this.departmentId = _data["departmentId"];
            this.dashboardTaskTypeId = _data["dashboardTaskTypeId"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.dashboardTaskType = _data["dashboardTaskType"] ? DashboardTaskType.fromJS(_data["dashboardTaskType"]) : <any>undefined;
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>undefined;
            if (Array.isArray(_data["dashboardTaskTranslations"])) {
                this.dashboardTaskTranslations = [] as any;
                for (let item of _data["dashboardTaskTranslations"])
                    this.dashboardTaskTranslations!.push(DashboardTaskTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DashboardTask {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardTaskId"] = this.dashboardTaskId;
        data["requestId"] = this.requestId;
        data["managerId"] = this.managerId;
        data["departmentId"] = this.departmentId;
        data["dashboardTaskTypeId"] = this.dashboardTaskTypeId;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["dashboardTaskType"] = this.dashboardTaskType ? this.dashboardTaskType.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        if (Array.isArray(this.dashboardTaskTranslations)) {
            data["dashboardTaskTranslations"] = [];
            for (let item of this.dashboardTaskTranslations)
                data["dashboardTaskTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDashboardTask {
    dashboardTaskId?: number;
    requestId?: number | undefined;
    managerId?: number | undefined;
    departmentId?: number | undefined;
    dashboardTaskTypeId?: number;
    closedOn?: Date | undefined;
    request?: Request | undefined;
    department?: Department | undefined;
    dashboardTaskType?: DashboardTaskType | undefined;
    manager?: User | undefined;
    dashboardTaskTranslations?: DashboardTaskTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DashboardTaskType implements IDashboardTaskType {
    dashboardTaskTypeId?: number;
    taskTypeCode?: ETaskType;
    dashboardTasks?: DashboardTask[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDashboardTaskType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardTaskTypeId = _data["dashboardTaskTypeId"];
            this.taskTypeCode = _data["taskTypeCode"];
            if (Array.isArray(_data["dashboardTasks"])) {
                this.dashboardTasks = [] as any;
                for (let item of _data["dashboardTasks"])
                    this.dashboardTasks!.push(DashboardTask.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DashboardTaskType {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTaskType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardTaskTypeId"] = this.dashboardTaskTypeId;
        data["taskTypeCode"] = this.taskTypeCode;
        if (Array.isArray(this.dashboardTasks)) {
            data["dashboardTasks"] = [];
            for (let item of this.dashboardTasks)
                data["dashboardTasks"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDashboardTaskType {
    dashboardTaskTypeId?: number;
    taskTypeCode?: ETaskType;
    dashboardTasks?: DashboardTask[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum ETaskType {
    DeadPuppyCredit = "DeadPuppyCredit",
    MembershipTask = "MembershipTask",
    WorkbookRequestDiplomaCheckTask = "WorkbookRequestDiplomaCheckTask",
    RequestCredit = "RequestCredit",
    RequestNotPaid = "RequestNotPaid",
    InformationRequested = "InformationRequested",
    DogValidation = "DogValidation",
    BroodRequestPuppies = "BroodRequestPuppies",
    BroodRequestPuppiesPedigree = "BroodRequestPuppiesPedigree",
    RequestCancelled = "RequestCancelled",
}

export class DashboardTaskTranslation implements IDashboardTaskTranslation {
    dashboardTaskTranslationId?: number;
    dashboardTaskId?: number;
    languageId?: number;
    text?: string | undefined;
    dashboardTask?: DashboardTask | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDashboardTaskTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardTaskTranslationId = _data["dashboardTaskTranslationId"];
            this.dashboardTaskId = _data["dashboardTaskId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.dashboardTask = _data["dashboardTask"] ? DashboardTask.fromJS(_data["dashboardTask"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DashboardTaskTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTaskTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardTaskTranslationId"] = this.dashboardTaskTranslationId;
        data["dashboardTaskId"] = this.dashboardTaskId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["dashboardTask"] = this.dashboardTask ? this.dashboardTask.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDashboardTaskTranslation {
    dashboardTaskTranslationId?: number;
    dashboardTaskId?: number;
    languageId?: number;
    text?: string | undefined;
    dashboardTask?: DashboardTask | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class UserDysplasiaResult implements IUserDysplasiaResult {
    userDysplasiaResultId?: number;
    numericValue?: number | undefined;
    healthValueId?: number | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    otherRemark?: string | undefined;
    userId?: number;
    userDysplasiaStatusId?: number;
    dogDysplasiaTransientId?: number;
    userDysplasiaStatus?: UserDysplasiaStatus | undefined;
    user?: User | undefined;
    dogDysplasiaTransient?: DogDysplasiaTransient | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserDysplasiaResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDysplasiaResultId = _data["userDysplasiaResultId"];
            this.numericValue = _data["numericValue"];
            this.healthValueId = _data["healthValueId"];
            this.isRefused = _data["isRefused"];
            this.officialRemark = _data["officialRemark"];
            this.otherRemark = _data["otherRemark"];
            this.userId = _data["userId"];
            this.userDysplasiaStatusId = _data["userDysplasiaStatusId"];
            this.dogDysplasiaTransientId = _data["dogDysplasiaTransientId"];
            this.userDysplasiaStatus = _data["userDysplasiaStatus"] ? UserDysplasiaStatus.fromJS(_data["userDysplasiaStatus"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.dogDysplasiaTransient = _data["dogDysplasiaTransient"] ? DogDysplasiaTransient.fromJS(_data["dogDysplasiaTransient"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserDysplasiaResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserDysplasiaResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDysplasiaResultId"] = this.userDysplasiaResultId;
        data["numericValue"] = this.numericValue;
        data["healthValueId"] = this.healthValueId;
        data["isRefused"] = this.isRefused;
        data["officialRemark"] = this.officialRemark;
        data["otherRemark"] = this.otherRemark;
        data["userId"] = this.userId;
        data["userDysplasiaStatusId"] = this.userDysplasiaStatusId;
        data["dogDysplasiaTransientId"] = this.dogDysplasiaTransientId;
        data["userDysplasiaStatus"] = this.userDysplasiaStatus ? this.userDysplasiaStatus.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["dogDysplasiaTransient"] = this.dogDysplasiaTransient ? this.dogDysplasiaTransient.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserDysplasiaResult {
    userDysplasiaResultId?: number;
    numericValue?: number | undefined;
    healthValueId?: number | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    otherRemark?: string | undefined;
    userId?: number;
    userDysplasiaStatusId?: number;
    dogDysplasiaTransientId?: number;
    userDysplasiaStatus?: UserDysplasiaStatus | undefined;
    user?: User | undefined;
    dogDysplasiaTransient?: DogDysplasiaTransient | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class UserDysplasiaStatus implements IUserDysplasiaStatus {
    userDysplasiaStatusId?: number;
    code?: EUserDysplasiaStatus;
    userDysplasiaStatusTranslations?: UserDysplasiaStatusTranslation[] | undefined;
    userDysplasiaResult?: UserDysplasiaResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserDysplasiaStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDysplasiaStatusId = _data["userDysplasiaStatusId"];
            this.code = _data["code"];
            if (Array.isArray(_data["userDysplasiaStatusTranslations"])) {
                this.userDysplasiaStatusTranslations = [] as any;
                for (let item of _data["userDysplasiaStatusTranslations"])
                    this.userDysplasiaStatusTranslations!.push(UserDysplasiaStatusTranslation.fromJS(item));
            }
            if (Array.isArray(_data["userDysplasiaResult"])) {
                this.userDysplasiaResult = [] as any;
                for (let item of _data["userDysplasiaResult"])
                    this.userDysplasiaResult!.push(UserDysplasiaResult.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserDysplasiaStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserDysplasiaStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDysplasiaStatusId"] = this.userDysplasiaStatusId;
        data["code"] = this.code;
        if (Array.isArray(this.userDysplasiaStatusTranslations)) {
            data["userDysplasiaStatusTranslations"] = [];
            for (let item of this.userDysplasiaStatusTranslations)
                data["userDysplasiaStatusTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.userDysplasiaResult)) {
            data["userDysplasiaResult"] = [];
            for (let item of this.userDysplasiaResult)
                data["userDysplasiaResult"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserDysplasiaStatus {
    userDysplasiaStatusId?: number;
    code?: EUserDysplasiaStatus;
    userDysplasiaStatusTranslations?: UserDysplasiaStatusTranslation[] | undefined;
    userDysplasiaResult?: UserDysplasiaResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EUserDysplasiaStatus {
    Submitted = "Submitted",
    ToEvaluate = "ToEvaluate",
    ToReEvaluate = "ToReEvaluate",
}

export class UserDysplasiaStatusTranslation implements IUserDysplasiaStatusTranslation {
    userDysplasiaStatusTranslationId?: number;
    userDysplasiaStatusId?: number;
    text?: string | undefined;
    languageId?: number;
    language?: Language | undefined;
    userDysplasiaStatus?: UserDysplasiaStatus | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IUserDysplasiaStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDysplasiaStatusTranslationId = _data["userDysplasiaStatusTranslationId"];
            this.userDysplasiaStatusId = _data["userDysplasiaStatusId"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.userDysplasiaStatus = _data["userDysplasiaStatus"] ? UserDysplasiaStatus.fromJS(_data["userDysplasiaStatus"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UserDysplasiaStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new UserDysplasiaStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDysplasiaStatusTranslationId"] = this.userDysplasiaStatusTranslationId;
        data["userDysplasiaStatusId"] = this.userDysplasiaStatusId;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["userDysplasiaStatus"] = this.userDysplasiaStatus ? this.userDysplasiaStatus.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUserDysplasiaStatusTranslation {
    userDysplasiaStatusTranslationId?: number;
    userDysplasiaStatusId?: number;
    text?: string | undefined;
    languageId?: number;
    language?: Language | undefined;
    userDysplasiaStatus?: UserDysplasiaStatus | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogDysplasiaTransient implements IDogDysplasiaTransient {
    dogDysplasiaTransientId?: number;
    dysplasiaRequestId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    otherRemark?: string | undefined;
    dysplasiaRequest?: DysplasiaRequest | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    userDysplasiaResults?: UserDysplasiaResult[] | undefined;

    constructor(data?: IDogDysplasiaTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDysplasiaTransientId = _data["dogDysplasiaTransientId"];
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.isRefused = _data["isRefused"];
            this.officialRemark = _data["officialRemark"];
            this.otherRemark = _data["otherRemark"];
            this.dysplasiaRequest = _data["dysplasiaRequest"] ? DysplasiaRequest.fromJS(_data["dysplasiaRequest"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["userDysplasiaResults"])) {
                this.userDysplasiaResults = [] as any;
                for (let item of _data["userDysplasiaResults"])
                    this.userDysplasiaResults!.push(UserDysplasiaResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DogDysplasiaTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogDysplasiaTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDysplasiaTransientId"] = this.dogDysplasiaTransientId;
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["isRefused"] = this.isRefused;
        data["officialRemark"] = this.officialRemark;
        data["otherRemark"] = this.otherRemark;
        data["dysplasiaRequest"] = this.dysplasiaRequest ? this.dysplasiaRequest.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.userDysplasiaResults)) {
            data["userDysplasiaResults"] = [];
            for (let item of this.userDysplasiaResults)
                data["userDysplasiaResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDogDysplasiaTransient {
    dogDysplasiaTransientId?: number;
    dysplasiaRequestId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    otherRemark?: string | undefined;
    dysplasiaRequest?: DysplasiaRequest | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    userDysplasiaResults?: UserDysplasiaResult[] | undefined;
}

export class DysplasiaRequest implements IDysplasiaRequest {
    dysplasiaRequestId?: number;
    requestId?: number;
    dogId?: number;
    isAppeal?: boolean;
    appealRequestId?: number | undefined;
    vetId?: number | undefined;
    clinicId?: number | undefined;
    radioDate?: Date;
    remark?: string | undefined;
    position?: EDysplasiaPosition | undefined;
    commissionType?: ECommissionType | undefined;
    request?: Request | undefined;
    appealRequest?: Request | undefined;
    dog?: Dog | undefined;
    vet?: Veterinary | undefined;
    clinic?: Clinic | undefined;
    dogDysplasiaTransients?: DogDysplasiaTransient[] | undefined;
    dogDysplasias?: DogDysplasia[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDysplasiaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.isAppeal = _data["isAppeal"];
            this.appealRequestId = _data["appealRequestId"];
            this.vetId = _data["vetId"];
            this.clinicId = _data["clinicId"];
            this.radioDate = _data["radioDate"] ? new Date(_data["radioDate"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.position = _data["position"];
            this.commissionType = _data["commissionType"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.appealRequest = _data["appealRequest"] ? Request.fromJS(_data["appealRequest"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.vet = _data["vet"] ? Veterinary.fromJS(_data["vet"]) : <any>undefined;
            this.clinic = _data["clinic"] ? Clinic.fromJS(_data["clinic"]) : <any>undefined;
            if (Array.isArray(_data["dogDysplasiaTransients"])) {
                this.dogDysplasiaTransients = [] as any;
                for (let item of _data["dogDysplasiaTransients"])
                    this.dogDysplasiaTransients!.push(DogDysplasiaTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogDysplasias"])) {
                this.dogDysplasias = [] as any;
                for (let item of _data["dogDysplasias"])
                    this.dogDysplasias!.push(DogDysplasia.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DysplasiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["isAppeal"] = this.isAppeal;
        data["appealRequestId"] = this.appealRequestId;
        data["vetId"] = this.vetId;
        data["clinicId"] = this.clinicId;
        data["radioDate"] = this.radioDate ? this.radioDate.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["position"] = this.position;
        data["commissionType"] = this.commissionType;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["appealRequest"] = this.appealRequest ? this.appealRequest.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["vet"] = this.vet ? this.vet.toJSON() : <any>undefined;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>undefined;
        if (Array.isArray(this.dogDysplasiaTransients)) {
            data["dogDysplasiaTransients"] = [];
            for (let item of this.dogDysplasiaTransients)
                data["dogDysplasiaTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogDysplasias)) {
            data["dogDysplasias"] = [];
            for (let item of this.dogDysplasias)
                data["dogDysplasias"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDysplasiaRequest {
    dysplasiaRequestId?: number;
    requestId?: number;
    dogId?: number;
    isAppeal?: boolean;
    appealRequestId?: number | undefined;
    vetId?: number | undefined;
    clinicId?: number | undefined;
    radioDate?: Date;
    remark?: string | undefined;
    position?: EDysplasiaPosition | undefined;
    commissionType?: ECommissionType | undefined;
    request?: Request | undefined;
    appealRequest?: Request | undefined;
    dog?: Dog | undefined;
    vet?: Veterinary | undefined;
    clinic?: Clinic | undefined;
    dogDysplasiaTransients?: DogDysplasiaTransient[] | undefined;
    dogDysplasias?: DogDysplasia[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDysplasiaPosition {
    VeryEasy = "VeryEasy",
    Easy = "Easy",
    Hard = "Hard",
    Impossible = "Impossible",
}

export enum ECommissionType {
    ClassicCommission = "ClassicCommission",
    GentCommission = "GentCommission",
}

export class Dog implements IDog {
    dogId?: number;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    unknownMother?: boolean;
    motherDogId?: number | undefined;
    unknownFather?: boolean;
    fatherDogId?: number | undefined;
    kennelId?: number | undefined;
    breedId?: number;
    colorId?: number | undefined;
    dogTypeId?: number | undefined;
    sex?: EDogSex;
    remark?: string | undefined;
    sharepointUri?: string | undefined;
    countryId?: number | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    dockedTail?: boolean;
    awaitingValidation?: boolean;
    socialBehaviour?: boolean;
    breedingAuthorized?: boolean;
    numberOfImportTries?: number;
    workCertification?: string | undefined;
    tatoo?: string | undefined;
    cegekaId?: string | undefined;
    internalNumber?: string | undefined;
    computedName?: string | undefined;
    computedPedigree?: string | undefined;
    computedDogChip?: string | undefined;
    computedSecondDogChip?: string | undefined;
    as400Titles?: string | undefined;
    as400Pedigree?: string | undefined;
    pedigreePrintedOn?: Date | undefined;
    breed?: Breed | undefined;
    color?: Color | undefined;
    country?: Country | undefined;
    dogType?: DogType | undefined;
    father?: Dog | undefined;
    mother?: Dog | undefined;
    kennel?: Kennel | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    pedigreeRequests?: PedigreeRequest[] | undefined;
    dogChips?: DogChip[] | undefined;
    dogConditionsForcedValues?: DogConditionsForcedValue[] | undefined;
    broodRequestsFathers?: BroodRequestsFather[] | undefined;
    healthTestRequestsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    dogHealthTestValidations?: DogHealthTestValidation[] | undefined;
    coupleInbreedingsAsFather?: CoupleInbreeding[] | undefined;
    coupleInbreedingsAsMother?: CoupleInbreeding[] | undefined;
    broodRequests?: BroodRequest[] | undefined;
    expatriationRequests?: ExpatriationRequest[] | undefined;
    dogHealthTestCharacteristicValueTransients?: DogHealthTestCharacteristicValueTransient[] | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    childrenAsMother?: Dog[] | undefined;
    childrenAsFather?: Dog[] | undefined;
    dogTransients?: DogTransient[] | undefined;
    dogBroodRequestsTransientsAsFather?: DogBroodRequestsTransient[] | undefined;
    workAttestRequests?: WorkAttestRequest[] | undefined;
    pedigreeDuplicataRequests?: PedigreeDuplicataRequest[] | undefined;
    dogOwnershipChangeRequests?: DogOwnershipChangeRequest[] | undefined;
    importRequestTransientOwnerships?: ImportRequestTransientOwnership[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    dogsOwnerships?: DogOwnership[] | undefined;
    dogsOwnershipsTransients?: DogOwnershipTransient[] | undefined;
    dogTitlesTransients?: DogTitlesTransient[] | undefined;
    pedigrees?: Pedigree[] | undefined;
    dogsTitles?: DogTitle[] | undefined;
    workbooks?: Workbook[] | undefined;
    dnaResults?: DogDnaResult[] | undefined;
    dogHealthTestDnaResultTransients?: DogHealthTestDnaResultTransient[] | undefined;
    dogsCharacteristicsValues?: DogCharacteristicValue[] | undefined;
    titleRequests?: TitleRequest[] | undefined;
    workbookRequests?: WorkbookRequest[] | undefined;
    transientWorkbooks?: TransientWorkbook[] | undefined;
    dogTempOwnershipChangeRequests?: DogTempOwnershipChangeRequest[] | undefined;
    importRequests?: ImportRequest[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    dogDysplasias?: DogDysplasia[] | undefined;
    dogsBreeders?: DogsBreeder[] | undefined;
    dogActions?: DogAction[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.firstName = _data["firstName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.unknownMother = _data["unknownMother"];
            this.motherDogId = _data["motherDogId"];
            this.unknownFather = _data["unknownFather"];
            this.fatherDogId = _data["fatherDogId"];
            this.kennelId = _data["kennelId"];
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.dogTypeId = _data["dogTypeId"];
            this.sex = _data["sex"];
            this.remark = _data["remark"];
            this.sharepointUri = _data["sharepointUri"];
            this.countryId = _data["countryId"];
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionStartDate = _data["exclusionStartDate"] ? new Date(_data["exclusionStartDate"].toString()) : <any>undefined;
            this.exclusionEndDate = _data["exclusionEndDate"] ? new Date(_data["exclusionEndDate"].toString()) : <any>undefined;
            this.dockedTail = _data["dockedTail"];
            this.awaitingValidation = _data["awaitingValidation"];
            this.socialBehaviour = _data["socialBehaviour"];
            this.breedingAuthorized = _data["breedingAuthorized"];
            this.numberOfImportTries = _data["numberOfImportTries"];
            this.workCertification = _data["workCertification"];
            this.tatoo = _data["tatoo"];
            this.cegekaId = _data["cegekaId"];
            this.internalNumber = _data["internalNumber"];
            this.computedName = _data["computedName"];
            this.computedPedigree = _data["computedPedigree"];
            this.computedDogChip = _data["computedDogChip"];
            this.computedSecondDogChip = _data["computedSecondDogChip"];
            this.as400Titles = _data["as400Titles"];
            this.as400Pedigree = _data["as400Pedigree"];
            this.pedigreePrintedOn = _data["pedigreePrintedOn"] ? new Date(_data["pedigreePrintedOn"].toString()) : <any>undefined;
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.color = _data["color"] ? Color.fromJS(_data["color"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.dogType = _data["dogType"] ? DogType.fromJS(_data["dogType"]) : <any>undefined;
            this.father = _data["father"] ? Dog.fromJS(_data["father"]) : <any>undefined;
            this.mother = _data["mother"] ? Dog.fromJS(_data["mother"]) : <any>undefined;
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            if (Array.isArray(_data["healthTestSingleCharacteristicTransients"])) {
                this.healthTestSingleCharacteristicTransients = [] as any;
                for (let item of _data["healthTestSingleCharacteristicTransients"])
                    this.healthTestSingleCharacteristicTransients!.push(HealthTestSingleCharacteristicTransient.fromJS(item));
            }
            if (Array.isArray(_data["pedigreeRequests"])) {
                this.pedigreeRequests = [] as any;
                for (let item of _data["pedigreeRequests"])
                    this.pedigreeRequests!.push(PedigreeRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogChips"])) {
                this.dogChips = [] as any;
                for (let item of _data["dogChips"])
                    this.dogChips!.push(DogChip.fromJS(item));
            }
            if (Array.isArray(_data["dogConditionsForcedValues"])) {
                this.dogConditionsForcedValues = [] as any;
                for (let item of _data["dogConditionsForcedValues"])
                    this.dogConditionsForcedValues!.push(DogConditionsForcedValue.fromJS(item));
            }
            if (Array.isArray(_data["broodRequestsFathers"])) {
                this.broodRequestsFathers = [] as any;
                for (let item of _data["broodRequestsFathers"])
                    this.broodRequestsFathers!.push(BroodRequestsFather.fromJS(item));
            }
            if (Array.isArray(_data["healthTestRequestsTransients"])) {
                this.healthTestRequestsTransients = [] as any;
                for (let item of _data["healthTestRequestsTransients"])
                    this.healthTestRequestsTransients!.push(HealthTestRequestCharacteristicTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestValidations"])) {
                this.dogHealthTestValidations = [] as any;
                for (let item of _data["dogHealthTestValidations"])
                    this.dogHealthTestValidations!.push(DogHealthTestValidation.fromJS(item));
            }
            if (Array.isArray(_data["coupleInbreedingsAsFather"])) {
                this.coupleInbreedingsAsFather = [] as any;
                for (let item of _data["coupleInbreedingsAsFather"])
                    this.coupleInbreedingsAsFather!.push(CoupleInbreeding.fromJS(item));
            }
            if (Array.isArray(_data["coupleInbreedingsAsMother"])) {
                this.coupleInbreedingsAsMother = [] as any;
                for (let item of _data["coupleInbreedingsAsMother"])
                    this.coupleInbreedingsAsMother!.push(CoupleInbreeding.fromJS(item));
            }
            if (Array.isArray(_data["broodRequests"])) {
                this.broodRequests = [] as any;
                for (let item of _data["broodRequests"])
                    this.broodRequests!.push(BroodRequest.fromJS(item));
            }
            if (Array.isArray(_data["expatriationRequests"])) {
                this.expatriationRequests = [] as any;
                for (let item of _data["expatriationRequests"])
                    this.expatriationRequests!.push(ExpatriationRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestCharacteristicValueTransients"])) {
                this.dogHealthTestCharacteristicValueTransients = [] as any;
                for (let item of _data["dogHealthTestCharacteristicValueTransients"])
                    this.dogHealthTestCharacteristicValueTransients!.push(DogHealthTestCharacteristicValueTransient.fromJS(item));
            }
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(CompetitionResult.fromJS(item));
            }
            if (Array.isArray(_data["childrenAsMother"])) {
                this.childrenAsMother = [] as any;
                for (let item of _data["childrenAsMother"])
                    this.childrenAsMother!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["childrenAsFather"])) {
                this.childrenAsFather = [] as any;
                for (let item of _data["childrenAsFather"])
                    this.childrenAsFather!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["dogTransients"])) {
                this.dogTransients = [] as any;
                for (let item of _data["dogTransients"])
                    this.dogTransients!.push(DogTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogBroodRequestsTransientsAsFather"])) {
                this.dogBroodRequestsTransientsAsFather = [] as any;
                for (let item of _data["dogBroodRequestsTransientsAsFather"])
                    this.dogBroodRequestsTransientsAsFather!.push(DogBroodRequestsTransient.fromJS(item));
            }
            if (Array.isArray(_data["workAttestRequests"])) {
                this.workAttestRequests = [] as any;
                for (let item of _data["workAttestRequests"])
                    this.workAttestRequests!.push(WorkAttestRequest.fromJS(item));
            }
            if (Array.isArray(_data["pedigreeDuplicataRequests"])) {
                this.pedigreeDuplicataRequests = [] as any;
                for (let item of _data["pedigreeDuplicataRequests"])
                    this.pedigreeDuplicataRequests!.push(PedigreeDuplicataRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogOwnershipChangeRequests"])) {
                this.dogOwnershipChangeRequests = [] as any;
                for (let item of _data["dogOwnershipChangeRequests"])
                    this.dogOwnershipChangeRequests!.push(DogOwnershipChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["importRequestTransientOwnerships"])) {
                this.importRequestTransientOwnerships = [] as any;
                for (let item of _data["importRequestTransientOwnerships"])
                    this.importRequestTransientOwnerships!.push(ImportRequestTransientOwnership.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValuesTransients"])) {
                this.dogsCharacteristicsValuesTransients = [] as any;
                for (let item of _data["dogsCharacteristicsValuesTransients"])
                    this.dogsCharacteristicsValuesTransients!.push(DogsCharacteristicsValuesTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogsOwnerships"])) {
                this.dogsOwnerships = [] as any;
                for (let item of _data["dogsOwnerships"])
                    this.dogsOwnerships!.push(DogOwnership.fromJS(item));
            }
            if (Array.isArray(_data["dogsOwnershipsTransients"])) {
                this.dogsOwnershipsTransients = [] as any;
                for (let item of _data["dogsOwnershipsTransients"])
                    this.dogsOwnershipsTransients!.push(DogOwnershipTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogTitlesTransients"])) {
                this.dogTitlesTransients = [] as any;
                for (let item of _data["dogTitlesTransients"])
                    this.dogTitlesTransients!.push(DogTitlesTransient.fromJS(item));
            }
            if (Array.isArray(_data["pedigrees"])) {
                this.pedigrees = [] as any;
                for (let item of _data["pedigrees"])
                    this.pedigrees!.push(Pedigree.fromJS(item));
            }
            if (Array.isArray(_data["dogsTitles"])) {
                this.dogsTitles = [] as any;
                for (let item of _data["dogsTitles"])
                    this.dogsTitles!.push(DogTitle.fromJS(item));
            }
            if (Array.isArray(_data["workbooks"])) {
                this.workbooks = [] as any;
                for (let item of _data["workbooks"])
                    this.workbooks!.push(Workbook.fromJS(item));
            }
            if (Array.isArray(_data["dnaResults"])) {
                this.dnaResults = [] as any;
                for (let item of _data["dnaResults"])
                    this.dnaResults!.push(DogDnaResult.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestDnaResultTransients"])) {
                this.dogHealthTestDnaResultTransients = [] as any;
                for (let item of _data["dogHealthTestDnaResultTransients"])
                    this.dogHealthTestDnaResultTransients!.push(DogHealthTestDnaResultTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValues"])) {
                this.dogsCharacteristicsValues = [] as any;
                for (let item of _data["dogsCharacteristicsValues"])
                    this.dogsCharacteristicsValues!.push(DogCharacteristicValue.fromJS(item));
            }
            if (Array.isArray(_data["titleRequests"])) {
                this.titleRequests = [] as any;
                for (let item of _data["titleRequests"])
                    this.titleRequests!.push(TitleRequest.fromJS(item));
            }
            if (Array.isArray(_data["workbookRequests"])) {
                this.workbookRequests = [] as any;
                for (let item of _data["workbookRequests"])
                    this.workbookRequests!.push(WorkbookRequest.fromJS(item));
            }
            if (Array.isArray(_data["transientWorkbooks"])) {
                this.transientWorkbooks = [] as any;
                for (let item of _data["transientWorkbooks"])
                    this.transientWorkbooks!.push(TransientWorkbook.fromJS(item));
            }
            if (Array.isArray(_data["dogTempOwnershipChangeRequests"])) {
                this.dogTempOwnershipChangeRequests = [] as any;
                for (let item of _data["dogTempOwnershipChangeRequests"])
                    this.dogTempOwnershipChangeRequests!.push(DogTempOwnershipChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["importRequests"])) {
                this.importRequests = [] as any;
                for (let item of _data["importRequests"])
                    this.importRequests!.push(ImportRequest.fromJS(item));
            }
            if (Array.isArray(_data["dysplasiaRequests"])) {
                this.dysplasiaRequests = [] as any;
                for (let item of _data["dysplasiaRequests"])
                    this.dysplasiaRequests!.push(DysplasiaRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogDysplasias"])) {
                this.dogDysplasias = [] as any;
                for (let item of _data["dogDysplasias"])
                    this.dogDysplasias!.push(DogDysplasia.fromJS(item));
            }
            if (Array.isArray(_data["dogsBreeders"])) {
                this.dogsBreeders = [] as any;
                for (let item of _data["dogsBreeders"])
                    this.dogsBreeders!.push(DogsBreeder.fromJS(item));
            }
            if (Array.isArray(_data["dogActions"])) {
                this.dogActions = [] as any;
                for (let item of _data["dogActions"])
                    this.dogActions!.push(DogAction.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Dog {
        data = typeof data === 'object' ? data : {};
        let result = new Dog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["firstName"] = this.firstName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["unknownMother"] = this.unknownMother;
        data["motherDogId"] = this.motherDogId;
        data["unknownFather"] = this.unknownFather;
        data["fatherDogId"] = this.fatherDogId;
        data["kennelId"] = this.kennelId;
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["dogTypeId"] = this.dogTypeId;
        data["sex"] = this.sex;
        data["remark"] = this.remark;
        data["sharepointUri"] = this.sharepointUri;
        data["countryId"] = this.countryId;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionStartDate"] = this.exclusionStartDate ? this.exclusionStartDate.toISOString() : <any>undefined;
        data["exclusionEndDate"] = this.exclusionEndDate ? this.exclusionEndDate.toISOString() : <any>undefined;
        data["dockedTail"] = this.dockedTail;
        data["awaitingValidation"] = this.awaitingValidation;
        data["socialBehaviour"] = this.socialBehaviour;
        data["breedingAuthorized"] = this.breedingAuthorized;
        data["numberOfImportTries"] = this.numberOfImportTries;
        data["workCertification"] = this.workCertification;
        data["tatoo"] = this.tatoo;
        data["cegekaId"] = this.cegekaId;
        data["internalNumber"] = this.internalNumber;
        data["computedName"] = this.computedName;
        data["computedPedigree"] = this.computedPedigree;
        data["computedDogChip"] = this.computedDogChip;
        data["computedSecondDogChip"] = this.computedSecondDogChip;
        data["as400Titles"] = this.as400Titles;
        data["as400Pedigree"] = this.as400Pedigree;
        data["pedigreePrintedOn"] = this.pedigreePrintedOn ? this.pedigreePrintedOn.toISOString() : <any>undefined;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["dogType"] = this.dogType ? this.dogType.toJSON() : <any>undefined;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        if (Array.isArray(this.healthTestSingleCharacteristicTransients)) {
            data["healthTestSingleCharacteristicTransients"] = [];
            for (let item of this.healthTestSingleCharacteristicTransients)
                data["healthTestSingleCharacteristicTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.pedigreeRequests)) {
            data["pedigreeRequests"] = [];
            for (let item of this.pedigreeRequests)
                data["pedigreeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogChips)) {
            data["dogChips"] = [];
            for (let item of this.dogChips)
                data["dogChips"].push(item.toJSON());
        }
        if (Array.isArray(this.dogConditionsForcedValues)) {
            data["dogConditionsForcedValues"] = [];
            for (let item of this.dogConditionsForcedValues)
                data["dogConditionsForcedValues"].push(item.toJSON());
        }
        if (Array.isArray(this.broodRequestsFathers)) {
            data["broodRequestsFathers"] = [];
            for (let item of this.broodRequestsFathers)
                data["broodRequestsFathers"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestRequestsTransients)) {
            data["healthTestRequestsTransients"] = [];
            for (let item of this.healthTestRequestsTransients)
                data["healthTestRequestsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestValidations)) {
            data["dogHealthTestValidations"] = [];
            for (let item of this.dogHealthTestValidations)
                data["dogHealthTestValidations"].push(item.toJSON());
        }
        if (Array.isArray(this.coupleInbreedingsAsFather)) {
            data["coupleInbreedingsAsFather"] = [];
            for (let item of this.coupleInbreedingsAsFather)
                data["coupleInbreedingsAsFather"].push(item.toJSON());
        }
        if (Array.isArray(this.coupleInbreedingsAsMother)) {
            data["coupleInbreedingsAsMother"] = [];
            for (let item of this.coupleInbreedingsAsMother)
                data["coupleInbreedingsAsMother"].push(item.toJSON());
        }
        if (Array.isArray(this.broodRequests)) {
            data["broodRequests"] = [];
            for (let item of this.broodRequests)
                data["broodRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.expatriationRequests)) {
            data["expatriationRequests"] = [];
            for (let item of this.expatriationRequests)
                data["expatriationRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestCharacteristicValueTransients)) {
            data["dogHealthTestCharacteristicValueTransients"] = [];
            for (let item of this.dogHealthTestCharacteristicValueTransients)
                data["dogHealthTestCharacteristicValueTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        if (Array.isArray(this.childrenAsMother)) {
            data["childrenAsMother"] = [];
            for (let item of this.childrenAsMother)
                data["childrenAsMother"].push(item.toJSON());
        }
        if (Array.isArray(this.childrenAsFather)) {
            data["childrenAsFather"] = [];
            for (let item of this.childrenAsFather)
                data["childrenAsFather"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTransients)) {
            data["dogTransients"] = [];
            for (let item of this.dogTransients)
                data["dogTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogBroodRequestsTransientsAsFather)) {
            data["dogBroodRequestsTransientsAsFather"] = [];
            for (let item of this.dogBroodRequestsTransientsAsFather)
                data["dogBroodRequestsTransientsAsFather"].push(item.toJSON());
        }
        if (Array.isArray(this.workAttestRequests)) {
            data["workAttestRequests"] = [];
            for (let item of this.workAttestRequests)
                data["workAttestRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.pedigreeDuplicataRequests)) {
            data["pedigreeDuplicataRequests"] = [];
            for (let item of this.pedigreeDuplicataRequests)
                data["pedigreeDuplicataRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogOwnershipChangeRequests)) {
            data["dogOwnershipChangeRequests"] = [];
            for (let item of this.dogOwnershipChangeRequests)
                data["dogOwnershipChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.importRequestTransientOwnerships)) {
            data["importRequestTransientOwnerships"] = [];
            for (let item of this.importRequestTransientOwnerships)
                data["importRequestTransientOwnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValuesTransients)) {
            data["dogsCharacteristicsValuesTransients"] = [];
            for (let item of this.dogsCharacteristicsValuesTransients)
                data["dogsCharacteristicsValuesTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsOwnerships)) {
            data["dogsOwnerships"] = [];
            for (let item of this.dogsOwnerships)
                data["dogsOwnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsOwnershipsTransients)) {
            data["dogsOwnershipsTransients"] = [];
            for (let item of this.dogsOwnershipsTransients)
                data["dogsOwnershipsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTitlesTransients)) {
            data["dogTitlesTransients"] = [];
            for (let item of this.dogTitlesTransients)
                data["dogTitlesTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.pedigrees)) {
            data["pedigrees"] = [];
            for (let item of this.pedigrees)
                data["pedigrees"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsTitles)) {
            data["dogsTitles"] = [];
            for (let item of this.dogsTitles)
                data["dogsTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.workbooks)) {
            data["workbooks"] = [];
            for (let item of this.workbooks)
                data["workbooks"].push(item.toJSON());
        }
        if (Array.isArray(this.dnaResults)) {
            data["dnaResults"] = [];
            for (let item of this.dnaResults)
                data["dnaResults"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestDnaResultTransients)) {
            data["dogHealthTestDnaResultTransients"] = [];
            for (let item of this.dogHealthTestDnaResultTransients)
                data["dogHealthTestDnaResultTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValues)) {
            data["dogsCharacteristicsValues"] = [];
            for (let item of this.dogsCharacteristicsValues)
                data["dogsCharacteristicsValues"].push(item.toJSON());
        }
        if (Array.isArray(this.titleRequests)) {
            data["titleRequests"] = [];
            for (let item of this.titleRequests)
                data["titleRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.workbookRequests)) {
            data["workbookRequests"] = [];
            for (let item of this.workbookRequests)
                data["workbookRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.transientWorkbooks)) {
            data["transientWorkbooks"] = [];
            for (let item of this.transientWorkbooks)
                data["transientWorkbooks"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTempOwnershipChangeRequests)) {
            data["dogTempOwnershipChangeRequests"] = [];
            for (let item of this.dogTempOwnershipChangeRequests)
                data["dogTempOwnershipChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.importRequests)) {
            data["importRequests"] = [];
            for (let item of this.importRequests)
                data["importRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dysplasiaRequests)) {
            data["dysplasiaRequests"] = [];
            for (let item of this.dysplasiaRequests)
                data["dysplasiaRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogDysplasias)) {
            data["dogDysplasias"] = [];
            for (let item of this.dogDysplasias)
                data["dogDysplasias"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsBreeders)) {
            data["dogsBreeders"] = [];
            for (let item of this.dogsBreeders)
                data["dogsBreeders"].push(item.toJSON());
        }
        if (Array.isArray(this.dogActions)) {
            data["dogActions"] = [];
            for (let item of this.dogActions)
                data["dogActions"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDog {
    dogId?: number;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    unknownMother?: boolean;
    motherDogId?: number | undefined;
    unknownFather?: boolean;
    fatherDogId?: number | undefined;
    kennelId?: number | undefined;
    breedId?: number;
    colorId?: number | undefined;
    dogTypeId?: number | undefined;
    sex?: EDogSex;
    remark?: string | undefined;
    sharepointUri?: string | undefined;
    countryId?: number | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    dockedTail?: boolean;
    awaitingValidation?: boolean;
    socialBehaviour?: boolean;
    breedingAuthorized?: boolean;
    numberOfImportTries?: number;
    workCertification?: string | undefined;
    tatoo?: string | undefined;
    cegekaId?: string | undefined;
    internalNumber?: string | undefined;
    computedName?: string | undefined;
    computedPedigree?: string | undefined;
    computedDogChip?: string | undefined;
    computedSecondDogChip?: string | undefined;
    as400Titles?: string | undefined;
    as400Pedigree?: string | undefined;
    pedigreePrintedOn?: Date | undefined;
    breed?: Breed | undefined;
    color?: Color | undefined;
    country?: Country | undefined;
    dogType?: DogType | undefined;
    father?: Dog | undefined;
    mother?: Dog | undefined;
    kennel?: Kennel | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    pedigreeRequests?: PedigreeRequest[] | undefined;
    dogChips?: DogChip[] | undefined;
    dogConditionsForcedValues?: DogConditionsForcedValue[] | undefined;
    broodRequestsFathers?: BroodRequestsFather[] | undefined;
    healthTestRequestsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    dogHealthTestValidations?: DogHealthTestValidation[] | undefined;
    coupleInbreedingsAsFather?: CoupleInbreeding[] | undefined;
    coupleInbreedingsAsMother?: CoupleInbreeding[] | undefined;
    broodRequests?: BroodRequest[] | undefined;
    expatriationRequests?: ExpatriationRequest[] | undefined;
    dogHealthTestCharacteristicValueTransients?: DogHealthTestCharacteristicValueTransient[] | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    childrenAsMother?: Dog[] | undefined;
    childrenAsFather?: Dog[] | undefined;
    dogTransients?: DogTransient[] | undefined;
    dogBroodRequestsTransientsAsFather?: DogBroodRequestsTransient[] | undefined;
    workAttestRequests?: WorkAttestRequest[] | undefined;
    pedigreeDuplicataRequests?: PedigreeDuplicataRequest[] | undefined;
    dogOwnershipChangeRequests?: DogOwnershipChangeRequest[] | undefined;
    importRequestTransientOwnerships?: ImportRequestTransientOwnership[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    dogsOwnerships?: DogOwnership[] | undefined;
    dogsOwnershipsTransients?: DogOwnershipTransient[] | undefined;
    dogTitlesTransients?: DogTitlesTransient[] | undefined;
    pedigrees?: Pedigree[] | undefined;
    dogsTitles?: DogTitle[] | undefined;
    workbooks?: Workbook[] | undefined;
    dnaResults?: DogDnaResult[] | undefined;
    dogHealthTestDnaResultTransients?: DogHealthTestDnaResultTransient[] | undefined;
    dogsCharacteristicsValues?: DogCharacteristicValue[] | undefined;
    titleRequests?: TitleRequest[] | undefined;
    workbookRequests?: WorkbookRequest[] | undefined;
    transientWorkbooks?: TransientWorkbook[] | undefined;
    dogTempOwnershipChangeRequests?: DogTempOwnershipChangeRequest[] | undefined;
    importRequests?: ImportRequest[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    dogDysplasias?: DogDysplasia[] | undefined;
    dogsBreeders?: DogsBreeder[] | undefined;
    dogActions?: DogAction[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDogSex {
    Male = "Male",
    Female = "Female",
}

export class Color implements IColor {
    colorId?: number;
    code?: string | undefined;
    isMerle?: boolean | undefined;
    official?: boolean;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    dogs?: Dog[] | undefined;
    breedsColors?: BreedColor[] | undefined;
    colorTranslations?: ColorTranslation[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorId = _data["colorId"];
            this.code = _data["code"];
            this.isMerle = _data["isMerle"];
            this.official = _data["official"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            if (Array.isArray(_data["dogs"])) {
                this.dogs = [] as any;
                for (let item of _data["dogs"])
                    this.dogs!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["breedsColors"])) {
                this.breedsColors = [] as any;
                for (let item of _data["breedsColors"])
                    this.breedsColors!.push(BreedColor.fromJS(item));
            }
            if (Array.isArray(_data["colorTranslations"])) {
                this.colorTranslations = [] as any;
                for (let item of _data["colorTranslations"])
                    this.colorTranslations!.push(ColorTranslation.fromJS(item));
            }
            if (Array.isArray(_data["dogBroodRequestsTransients"])) {
                this.dogBroodRequestsTransients = [] as any;
                for (let item of _data["dogBroodRequestsTransients"])
                    this.dogBroodRequestsTransients!.push(DogBroodRequestsTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Color {
        data = typeof data === 'object' ? data : {};
        let result = new Color();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorId"] = this.colorId;
        data["code"] = this.code;
        data["isMerle"] = this.isMerle;
        data["official"] = this.official;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        if (Array.isArray(this.dogs)) {
            data["dogs"] = [];
            for (let item of this.dogs)
                data["dogs"].push(item.toJSON());
        }
        if (Array.isArray(this.breedsColors)) {
            data["breedsColors"] = [];
            for (let item of this.breedsColors)
                data["breedsColors"].push(item.toJSON());
        }
        if (Array.isArray(this.colorTranslations)) {
            data["colorTranslations"] = [];
            for (let item of this.colorTranslations)
                data["colorTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.dogBroodRequestsTransients)) {
            data["dogBroodRequestsTransients"] = [];
            for (let item of this.dogBroodRequestsTransients)
                data["dogBroodRequestsTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IColor {
    colorId?: number;
    code?: string | undefined;
    isMerle?: boolean | undefined;
    official?: boolean;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    dogs?: Dog[] | undefined;
    breedsColors?: BreedColor[] | undefined;
    colorTranslations?: ColorTranslation[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedColor implements IBreedColor {
    breedColorId?: number;
    breedId?: number;
    colorId?: number;
    breed?: Breed | undefined;
    color?: Color | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedColorId = _data["breedColorId"];
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.color = _data["color"] ? Color.fromJS(_data["color"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedColor {
        data = typeof data === 'object' ? data : {};
        let result = new BreedColor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedColorId"] = this.breedColorId;
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedColor {
    breedColorId?: number;
    breedId?: number;
    colorId?: number;
    breed?: Breed | undefined;
    color?: Color | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ColorTranslation implements IColorTranslation {
    colorTranslationId?: number;
    colorId?: number;
    languageId?: number;
    text?: string | undefined;
    color?: Color | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IColorTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorTranslationId = _data["colorTranslationId"];
            this.colorId = _data["colorId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.color = _data["color"] ? Color.fromJS(_data["color"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ColorTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ColorTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorTranslationId"] = this.colorTranslationId;
        data["colorId"] = this.colorId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IColorTranslation {
    colorTranslationId?: number;
    colorId?: number;
    languageId?: number;
    text?: string | undefined;
    color?: Color | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogBroodRequestsTransient implements IDogBroodRequestsTransient {
    dogBroodRequestsTransientId?: number;
    deceased?: boolean;
    broodRequestId?: number;
    kennelId?: number | undefined;
    breedId?: number;
    colorId?: number | undefined;
    pedigreeId?: number | undefined;
    chipNumber?: string | undefined;
    name?: string | undefined;
    fatherId?: number | undefined;
    countryPedigreePrefixId?: number | undefined;
    correspondingDogId?: number | undefined;
    labStatusId?: number | undefined;
    available?: boolean;
    certificateReceived?: boolean;
    analysisDoneOn?: Date | undefined;
    lastLabStatusUpdateDoneOn?: Date | undefined;
    documentSent?: boolean;
    dockedTail?: boolean;
    sex?: EDogSex | undefined;
    inbreeding?: number;
    broodRequest?: BroodRequest | undefined;
    countryPedigreePrefix?: CountryPedigreePrefix | undefined;
    kennel?: Kennel | undefined;
    breed?: Breed | undefined;
    color?: Color | undefined;
    pedigree?: Pedigree | undefined;
    father?: Dog | undefined;
    correspondingDog?: Dog | undefined;
    labStatus?: LabStatus | undefined;
    dogBroodRequestTransientOwners?: DogBroodRequestTransientOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogBroodRequestsTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogBroodRequestsTransientId = _data["dogBroodRequestsTransientId"];
            this.deceased = _data["deceased"];
            this.broodRequestId = _data["broodRequestId"];
            this.kennelId = _data["kennelId"];
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.pedigreeId = _data["pedigreeId"];
            this.chipNumber = _data["chipNumber"];
            this.name = _data["name"];
            this.fatherId = _data["fatherId"];
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.correspondingDogId = _data["correspondingDogId"];
            this.labStatusId = _data["labStatusId"];
            this.available = _data["available"];
            this.certificateReceived = _data["certificateReceived"];
            this.analysisDoneOn = _data["analysisDoneOn"] ? new Date(_data["analysisDoneOn"].toString()) : <any>undefined;
            this.lastLabStatusUpdateDoneOn = _data["lastLabStatusUpdateDoneOn"] ? new Date(_data["lastLabStatusUpdateDoneOn"].toString()) : <any>undefined;
            this.documentSent = _data["documentSent"];
            this.dockedTail = _data["dockedTail"];
            this.sex = _data["sex"];
            this.inbreeding = _data["inbreeding"];
            this.broodRequest = _data["broodRequest"] ? BroodRequest.fromJS(_data["broodRequest"]) : <any>undefined;
            this.countryPedigreePrefix = _data["countryPedigreePrefix"] ? CountryPedigreePrefix.fromJS(_data["countryPedigreePrefix"]) : <any>undefined;
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.color = _data["color"] ? Color.fromJS(_data["color"]) : <any>undefined;
            this.pedigree = _data["pedigree"] ? Pedigree.fromJS(_data["pedigree"]) : <any>undefined;
            this.father = _data["father"] ? Dog.fromJS(_data["father"]) : <any>undefined;
            this.correspondingDog = _data["correspondingDog"] ? Dog.fromJS(_data["correspondingDog"]) : <any>undefined;
            this.labStatus = _data["labStatus"] ? LabStatus.fromJS(_data["labStatus"]) : <any>undefined;
            if (Array.isArray(_data["dogBroodRequestTransientOwners"])) {
                this.dogBroodRequestTransientOwners = [] as any;
                for (let item of _data["dogBroodRequestTransientOwners"])
                    this.dogBroodRequestTransientOwners!.push(DogBroodRequestTransientOwner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogBroodRequestsTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestsTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogBroodRequestsTransientId"] = this.dogBroodRequestsTransientId;
        data["deceased"] = this.deceased;
        data["broodRequestId"] = this.broodRequestId;
        data["kennelId"] = this.kennelId;
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["pedigreeId"] = this.pedigreeId;
        data["chipNumber"] = this.chipNumber;
        data["name"] = this.name;
        data["fatherId"] = this.fatherId;
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["correspondingDogId"] = this.correspondingDogId;
        data["labStatusId"] = this.labStatusId;
        data["available"] = this.available;
        data["certificateReceived"] = this.certificateReceived;
        data["analysisDoneOn"] = this.analysisDoneOn ? this.analysisDoneOn.toISOString() : <any>undefined;
        data["lastLabStatusUpdateDoneOn"] = this.lastLabStatusUpdateDoneOn ? this.lastLabStatusUpdateDoneOn.toISOString() : <any>undefined;
        data["documentSent"] = this.documentSent;
        data["dockedTail"] = this.dockedTail;
        data["sex"] = this.sex;
        data["inbreeding"] = this.inbreeding;
        data["broodRequest"] = this.broodRequest ? this.broodRequest.toJSON() : <any>undefined;
        data["countryPedigreePrefix"] = this.countryPedigreePrefix ? this.countryPedigreePrefix.toJSON() : <any>undefined;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["pedigree"] = this.pedigree ? this.pedigree.toJSON() : <any>undefined;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["correspondingDog"] = this.correspondingDog ? this.correspondingDog.toJSON() : <any>undefined;
        data["labStatus"] = this.labStatus ? this.labStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.dogBroodRequestTransientOwners)) {
            data["dogBroodRequestTransientOwners"] = [];
            for (let item of this.dogBroodRequestTransientOwners)
                data["dogBroodRequestTransientOwners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogBroodRequestsTransient {
    dogBroodRequestsTransientId?: number;
    deceased?: boolean;
    broodRequestId?: number;
    kennelId?: number | undefined;
    breedId?: number;
    colorId?: number | undefined;
    pedigreeId?: number | undefined;
    chipNumber?: string | undefined;
    name?: string | undefined;
    fatherId?: number | undefined;
    countryPedigreePrefixId?: number | undefined;
    correspondingDogId?: number | undefined;
    labStatusId?: number | undefined;
    available?: boolean;
    certificateReceived?: boolean;
    analysisDoneOn?: Date | undefined;
    lastLabStatusUpdateDoneOn?: Date | undefined;
    documentSent?: boolean;
    dockedTail?: boolean;
    sex?: EDogSex | undefined;
    inbreeding?: number;
    broodRequest?: BroodRequest | undefined;
    countryPedigreePrefix?: CountryPedigreePrefix | undefined;
    kennel?: Kennel | undefined;
    breed?: Breed | undefined;
    color?: Color | undefined;
    pedigree?: Pedigree | undefined;
    father?: Dog | undefined;
    correspondingDog?: Dog | undefined;
    labStatus?: LabStatus | undefined;
    dogBroodRequestTransientOwners?: DogBroodRequestTransientOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BroodRequest implements IBroodRequest {
    broodRequestId?: number;
    requestId?: number;
    motherId?: number;
    numberOfPuppies?: number;
    numberOfPuppiesConfirmed?: boolean;
    progenusQuickDelivery?: boolean;
    protrusionDate?: Date;
    birthDate?: Date | undefined;
    labReference?: ELab;
    price?: number;
    wantSrshPedigree?: boolean;
    srshPedigreeConfirmed?: boolean;
    brcsPedigreeConfirmed?: boolean;
    number?: string | undefined;
    postalCode?: string | undefined;
    countryId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    kitsReceivedEmail?: boolean;
    isBrcsRequest?: boolean;
    isMadeInPortal?: boolean;
    isRegisteredLetter?: boolean;
    lastAwaitingFatherEmailSent?: Date | undefined;
    lastReminderEmailSent?: Date | undefined;
    lastBirthDateEmailSent?: Date | undefined;
    lastPuppyKitReminderEmailSent?: Date | undefined;
    puppyPicture1ShpDriveItemId?: string | undefined;
    puppyPicture2ShpDriveItemId?: string | undefined;
    puppyPicture3ShpDriveItemId?: string | undefined;
    billMotherGenealogyCompletion?: boolean;
    billFatherGenealogyCompletion?: boolean;
    babyDogPublication?: boolean;
    lastEmailForAvailableDnaSent?: Date | undefined;
    country?: Country | undefined;
    request?: Request | undefined;
    mother?: Dog | undefined;
    broodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    broodRequestsFathers?: BroodRequestsFather[] | undefined;
    dogConditionsForcedValues?: DogConditionsForcedValue[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBroodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broodRequestId = _data["broodRequestId"];
            this.requestId = _data["requestId"];
            this.motherId = _data["motherId"];
            this.numberOfPuppies = _data["numberOfPuppies"];
            this.numberOfPuppiesConfirmed = _data["numberOfPuppiesConfirmed"];
            this.progenusQuickDelivery = _data["progenusQuickDelivery"];
            this.protrusionDate = _data["protrusionDate"] ? new Date(_data["protrusionDate"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.labReference = _data["labReference"];
            this.price = _data["price"];
            this.wantSrshPedigree = _data["wantSrshPedigree"];
            this.srshPedigreeConfirmed = _data["srshPedigreeConfirmed"];
            this.brcsPedigreeConfirmed = _data["brcsPedigreeConfirmed"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.countryId = _data["countryId"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.kitsReceivedEmail = _data["kitsReceivedEmail"];
            this.isBrcsRequest = _data["isBrcsRequest"];
            this.isMadeInPortal = _data["isMadeInPortal"];
            this.isRegisteredLetter = _data["isRegisteredLetter"];
            this.lastAwaitingFatherEmailSent = _data["lastAwaitingFatherEmailSent"] ? new Date(_data["lastAwaitingFatherEmailSent"].toString()) : <any>undefined;
            this.lastReminderEmailSent = _data["lastReminderEmailSent"] ? new Date(_data["lastReminderEmailSent"].toString()) : <any>undefined;
            this.lastBirthDateEmailSent = _data["lastBirthDateEmailSent"] ? new Date(_data["lastBirthDateEmailSent"].toString()) : <any>undefined;
            this.lastPuppyKitReminderEmailSent = _data["lastPuppyKitReminderEmailSent"] ? new Date(_data["lastPuppyKitReminderEmailSent"].toString()) : <any>undefined;
            this.puppyPicture1ShpDriveItemId = _data["puppyPicture1ShpDriveItemId"];
            this.puppyPicture2ShpDriveItemId = _data["puppyPicture2ShpDriveItemId"];
            this.puppyPicture3ShpDriveItemId = _data["puppyPicture3ShpDriveItemId"];
            this.billMotherGenealogyCompletion = _data["billMotherGenealogyCompletion"];
            this.billFatherGenealogyCompletion = _data["billFatherGenealogyCompletion"];
            this.babyDogPublication = _data["babyDogPublication"];
            this.lastEmailForAvailableDnaSent = _data["lastEmailForAvailableDnaSent"] ? new Date(_data["lastEmailForAvailableDnaSent"].toString()) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.mother = _data["mother"] ? Dog.fromJS(_data["mother"]) : <any>undefined;
            if (Array.isArray(_data["broodRequestsTransients"])) {
                this.broodRequestsTransients = [] as any;
                for (let item of _data["broodRequestsTransients"])
                    this.broodRequestsTransients!.push(DogBroodRequestsTransient.fromJS(item));
            }
            if (Array.isArray(_data["broodRequestsFathers"])) {
                this.broodRequestsFathers = [] as any;
                for (let item of _data["broodRequestsFathers"])
                    this.broodRequestsFathers!.push(BroodRequestsFather.fromJS(item));
            }
            if (Array.isArray(_data["dogConditionsForcedValues"])) {
                this.dogConditionsForcedValues = [] as any;
                for (let item of _data["dogConditionsForcedValues"])
                    this.dogConditionsForcedValues!.push(DogConditionsForcedValue.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BroodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestId"] = this.broodRequestId;
        data["requestId"] = this.requestId;
        data["motherId"] = this.motherId;
        data["numberOfPuppies"] = this.numberOfPuppies;
        data["numberOfPuppiesConfirmed"] = this.numberOfPuppiesConfirmed;
        data["progenusQuickDelivery"] = this.progenusQuickDelivery;
        data["protrusionDate"] = this.protrusionDate ? this.protrusionDate.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["labReference"] = this.labReference;
        data["price"] = this.price;
        data["wantSrshPedigree"] = this.wantSrshPedigree;
        data["srshPedigreeConfirmed"] = this.srshPedigreeConfirmed;
        data["brcsPedigreeConfirmed"] = this.brcsPedigreeConfirmed;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["countryId"] = this.countryId;
        data["street"] = this.street;
        data["city"] = this.city;
        data["kitsReceivedEmail"] = this.kitsReceivedEmail;
        data["isBrcsRequest"] = this.isBrcsRequest;
        data["isMadeInPortal"] = this.isMadeInPortal;
        data["isRegisteredLetter"] = this.isRegisteredLetter;
        data["lastAwaitingFatherEmailSent"] = this.lastAwaitingFatherEmailSent ? this.lastAwaitingFatherEmailSent.toISOString() : <any>undefined;
        data["lastReminderEmailSent"] = this.lastReminderEmailSent ? this.lastReminderEmailSent.toISOString() : <any>undefined;
        data["lastBirthDateEmailSent"] = this.lastBirthDateEmailSent ? this.lastBirthDateEmailSent.toISOString() : <any>undefined;
        data["lastPuppyKitReminderEmailSent"] = this.lastPuppyKitReminderEmailSent ? this.lastPuppyKitReminderEmailSent.toISOString() : <any>undefined;
        data["puppyPicture1ShpDriveItemId"] = this.puppyPicture1ShpDriveItemId;
        data["puppyPicture2ShpDriveItemId"] = this.puppyPicture2ShpDriveItemId;
        data["puppyPicture3ShpDriveItemId"] = this.puppyPicture3ShpDriveItemId;
        data["billMotherGenealogyCompletion"] = this.billMotherGenealogyCompletion;
        data["billFatherGenealogyCompletion"] = this.billFatherGenealogyCompletion;
        data["babyDogPublication"] = this.babyDogPublication;
        data["lastEmailForAvailableDnaSent"] = this.lastEmailForAvailableDnaSent ? this.lastEmailForAvailableDnaSent.toISOString() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        if (Array.isArray(this.broodRequestsTransients)) {
            data["broodRequestsTransients"] = [];
            for (let item of this.broodRequestsTransients)
                data["broodRequestsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.broodRequestsFathers)) {
            data["broodRequestsFathers"] = [];
            for (let item of this.broodRequestsFathers)
                data["broodRequestsFathers"].push(item.toJSON());
        }
        if (Array.isArray(this.dogConditionsForcedValues)) {
            data["dogConditionsForcedValues"] = [];
            for (let item of this.dogConditionsForcedValues)
                data["dogConditionsForcedValues"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBroodRequest {
    broodRequestId?: number;
    requestId?: number;
    motherId?: number;
    numberOfPuppies?: number;
    numberOfPuppiesConfirmed?: boolean;
    progenusQuickDelivery?: boolean;
    protrusionDate?: Date;
    birthDate?: Date | undefined;
    labReference?: ELab;
    price?: number;
    wantSrshPedigree?: boolean;
    srshPedigreeConfirmed?: boolean;
    brcsPedigreeConfirmed?: boolean;
    number?: string | undefined;
    postalCode?: string | undefined;
    countryId?: number | undefined;
    street?: string | undefined;
    city?: string | undefined;
    kitsReceivedEmail?: boolean;
    isBrcsRequest?: boolean;
    isMadeInPortal?: boolean;
    isRegisteredLetter?: boolean;
    lastAwaitingFatherEmailSent?: Date | undefined;
    lastReminderEmailSent?: Date | undefined;
    lastBirthDateEmailSent?: Date | undefined;
    lastPuppyKitReminderEmailSent?: Date | undefined;
    puppyPicture1ShpDriveItemId?: string | undefined;
    puppyPicture2ShpDriveItemId?: string | undefined;
    puppyPicture3ShpDriveItemId?: string | undefined;
    billMotherGenealogyCompletion?: boolean;
    billFatherGenealogyCompletion?: boolean;
    babyDogPublication?: boolean;
    lastEmailForAvailableDnaSent?: Date | undefined;
    country?: Country | undefined;
    request?: Request | undefined;
    mother?: Dog | undefined;
    broodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    broodRequestsFathers?: BroodRequestsFather[] | undefined;
    dogConditionsForcedValues?: DogConditionsForcedValue[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum ELab {
    PROGENUS = "PROGENUS",
    ZOOLYX = "ZOOLYX",
}

export class Country implements ICountry {
    countryId?: number;
    isoCode?: string | undefined;
    isoAs400?: string | undefined;
    pedigreePrefix?: string | undefined;
    canineNumber?: string | undefined;
    canineStreet?: string | undefined;
    caninePostalCode?: string | undefined;
    canineCity?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    canineGlobalEmail?: string | undefined;
    emailForJudgeInCompetition?: string | undefined;
    emailForWorkAttest?: string | undefined;
    emailForBeautyJudge?: string | undefined;
    persons?: Person[] | undefined;
    labs?: Lab[] | undefined;
    dogs?: Dog[] | undefined;
    kennels?: Kennel[] | undefined;
    originKennels?: Kennel[] | undefined;
    breeds?: Breed[] | undefined;
    titles?: Title[] | undefined;
    workAttestRequests?: WorkAttestRequest[] | undefined;
    countryTranslations?: CountryTranslation[] | undefined;
    clubs?: Club[] | undefined;
    clubsTerrain?: Club[] | undefined;
    kennelExportRequests?: KennelExportRequest[] | undefined;
    countriesPedigreePrefixes?: CountryPedigreePrefix[] | undefined;
    clinics?: Clinic[] | undefined;
    kennelImportRequests?: KennelImportRequest[] | undefined;
    countryLanguages?: CountryLanguage[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.isoCode = _data["isoCode"];
            this.isoAs400 = _data["isoAs400"];
            this.pedigreePrefix = _data["pedigreePrefix"];
            this.canineNumber = _data["canineNumber"];
            this.canineStreet = _data["canineStreet"];
            this.caninePostalCode = _data["caninePostalCode"];
            this.canineCity = _data["canineCity"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.canineGlobalEmail = _data["canineGlobalEmail"];
            this.emailForJudgeInCompetition = _data["emailForJudgeInCompetition"];
            this.emailForWorkAttest = _data["emailForWorkAttest"];
            this.emailForBeautyJudge = _data["emailForBeautyJudge"];
            if (Array.isArray(_data["persons"])) {
                this.persons = [] as any;
                for (let item of _data["persons"])
                    this.persons!.push(Person.fromJS(item));
            }
            if (Array.isArray(_data["labs"])) {
                this.labs = [] as any;
                for (let item of _data["labs"])
                    this.labs!.push(Lab.fromJS(item));
            }
            if (Array.isArray(_data["dogs"])) {
                this.dogs = [] as any;
                for (let item of _data["dogs"])
                    this.dogs!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["kennels"])) {
                this.kennels = [] as any;
                for (let item of _data["kennels"])
                    this.kennels!.push(Kennel.fromJS(item));
            }
            if (Array.isArray(_data["originKennels"])) {
                this.originKennels = [] as any;
                for (let item of _data["originKennels"])
                    this.originKennels!.push(Kennel.fromJS(item));
            }
            if (Array.isArray(_data["breeds"])) {
                this.breeds = [] as any;
                for (let item of _data["breeds"])
                    this.breeds!.push(Breed.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(Title.fromJS(item));
            }
            if (Array.isArray(_data["workAttestRequests"])) {
                this.workAttestRequests = [] as any;
                for (let item of _data["workAttestRequests"])
                    this.workAttestRequests!.push(WorkAttestRequest.fromJS(item));
            }
            if (Array.isArray(_data["countryTranslations"])) {
                this.countryTranslations = [] as any;
                for (let item of _data["countryTranslations"])
                    this.countryTranslations!.push(CountryTranslation.fromJS(item));
            }
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(Club.fromJS(item));
            }
            if (Array.isArray(_data["clubsTerrain"])) {
                this.clubsTerrain = [] as any;
                for (let item of _data["clubsTerrain"])
                    this.clubsTerrain!.push(Club.fromJS(item));
            }
            if (Array.isArray(_data["kennelExportRequests"])) {
                this.kennelExportRequests = [] as any;
                for (let item of _data["kennelExportRequests"])
                    this.kennelExportRequests!.push(KennelExportRequest.fromJS(item));
            }
            if (Array.isArray(_data["countriesPedigreePrefixes"])) {
                this.countriesPedigreePrefixes = [] as any;
                for (let item of _data["countriesPedigreePrefixes"])
                    this.countriesPedigreePrefixes!.push(CountryPedigreePrefix.fromJS(item));
            }
            if (Array.isArray(_data["clinics"])) {
                this.clinics = [] as any;
                for (let item of _data["clinics"])
                    this.clinics!.push(Clinic.fromJS(item));
            }
            if (Array.isArray(_data["kennelImportRequests"])) {
                this.kennelImportRequests = [] as any;
                for (let item of _data["kennelImportRequests"])
                    this.kennelImportRequests!.push(KennelImportRequest.fromJS(item));
            }
            if (Array.isArray(_data["countryLanguages"])) {
                this.countryLanguages = [] as any;
                for (let item of _data["countryLanguages"])
                    this.countryLanguages!.push(CountryLanguage.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["isoCode"] = this.isoCode;
        data["isoAs400"] = this.isoAs400;
        data["pedigreePrefix"] = this.pedigreePrefix;
        data["canineNumber"] = this.canineNumber;
        data["canineStreet"] = this.canineStreet;
        data["caninePostalCode"] = this.caninePostalCode;
        data["canineCity"] = this.canineCity;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["canineGlobalEmail"] = this.canineGlobalEmail;
        data["emailForJudgeInCompetition"] = this.emailForJudgeInCompetition;
        data["emailForWorkAttest"] = this.emailForWorkAttest;
        data["emailForBeautyJudge"] = this.emailForBeautyJudge;
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item.toJSON());
        }
        if (Array.isArray(this.labs)) {
            data["labs"] = [];
            for (let item of this.labs)
                data["labs"].push(item.toJSON());
        }
        if (Array.isArray(this.dogs)) {
            data["dogs"] = [];
            for (let item of this.dogs)
                data["dogs"].push(item.toJSON());
        }
        if (Array.isArray(this.kennels)) {
            data["kennels"] = [];
            for (let item of this.kennels)
                data["kennels"].push(item.toJSON());
        }
        if (Array.isArray(this.originKennels)) {
            data["originKennels"] = [];
            for (let item of this.originKennels)
                data["originKennels"].push(item.toJSON());
        }
        if (Array.isArray(this.breeds)) {
            data["breeds"] = [];
            for (let item of this.breeds)
                data["breeds"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.workAttestRequests)) {
            data["workAttestRequests"] = [];
            for (let item of this.workAttestRequests)
                data["workAttestRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.countryTranslations)) {
            data["countryTranslations"] = [];
            for (let item of this.countryTranslations)
                data["countryTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.clubsTerrain)) {
            data["clubsTerrain"] = [];
            for (let item of this.clubsTerrain)
                data["clubsTerrain"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelExportRequests)) {
            data["kennelExportRequests"] = [];
            for (let item of this.kennelExportRequests)
                data["kennelExportRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.countriesPedigreePrefixes)) {
            data["countriesPedigreePrefixes"] = [];
            for (let item of this.countriesPedigreePrefixes)
                data["countriesPedigreePrefixes"].push(item.toJSON());
        }
        if (Array.isArray(this.clinics)) {
            data["clinics"] = [];
            for (let item of this.clinics)
                data["clinics"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelImportRequests)) {
            data["kennelImportRequests"] = [];
            for (let item of this.kennelImportRequests)
                data["kennelImportRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.countryLanguages)) {
            data["countryLanguages"] = [];
            for (let item of this.countryLanguages)
                data["countryLanguages"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface ICountry {
    countryId?: number;
    isoCode?: string | undefined;
    isoAs400?: string | undefined;
    pedigreePrefix?: string | undefined;
    canineNumber?: string | undefined;
    canineStreet?: string | undefined;
    caninePostalCode?: string | undefined;
    canineCity?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    canineGlobalEmail?: string | undefined;
    emailForJudgeInCompetition?: string | undefined;
    emailForWorkAttest?: string | undefined;
    emailForBeautyJudge?: string | undefined;
    persons?: Person[] | undefined;
    labs?: Lab[] | undefined;
    dogs?: Dog[] | undefined;
    kennels?: Kennel[] | undefined;
    originKennels?: Kennel[] | undefined;
    breeds?: Breed[] | undefined;
    titles?: Title[] | undefined;
    workAttestRequests?: WorkAttestRequest[] | undefined;
    countryTranslations?: CountryTranslation[] | undefined;
    clubs?: Club[] | undefined;
    clubsTerrain?: Club[] | undefined;
    kennelExportRequests?: KennelExportRequest[] | undefined;
    countriesPedigreePrefixes?: CountryPedigreePrefix[] | undefined;
    clinics?: Clinic[] | undefined;
    kennelImportRequests?: KennelImportRequest[] | undefined;
    countryLanguages?: CountryLanguage[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;
}

export class Lab implements ILab {
    labId?: number;
    cegekaId?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    email?: string | undefined;
    websiteAdress?: string | undefined;
    phoneNumber?: string | undefined;
    isProgenusLab?: boolean;
    country?: Country | undefined;
    dogDnaResults?: DogDnaResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ILab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labId = _data["labId"];
            this.cegekaId = _data["cegekaId"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.websiteAdress = _data["websiteAdress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isProgenusLab = _data["isProgenusLab"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["dogDnaResults"])) {
                this.dogDnaResults = [] as any;
                for (let item of _data["dogDnaResults"])
                    this.dogDnaResults!.push(DogDnaResult.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Lab {
        data = typeof data === 'object' ? data : {};
        let result = new Lab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labId"] = this.labId;
        data["cegekaId"] = this.cegekaId;
        data["name"] = this.name;
        data["street"] = this.street;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["websiteAdress"] = this.websiteAdress;
        data["phoneNumber"] = this.phoneNumber;
        data["isProgenusLab"] = this.isProgenusLab;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.dogDnaResults)) {
            data["dogDnaResults"] = [];
            for (let item of this.dogDnaResults)
                data["dogDnaResults"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILab {
    labId?: number;
    cegekaId?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    email?: string | undefined;
    websiteAdress?: string | undefined;
    phoneNumber?: string | undefined;
    isProgenusLab?: boolean;
    country?: Country | undefined;
    dogDnaResults?: DogDnaResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogDnaResult implements IDogDnaResult {
    dogDnaResultId?: number;
    resultIdentifier?: string | undefined;
    controlledFiliation?: boolean;
    correctFiliation?: boolean;
    labId?: number | undefined;
    labCode?: ELab | undefined;
    isag?: EIsagNorm;
    dogId?: number;
    dog?: Dog | undefined;
    lab?: Lab | undefined;
    dnaMarkersResults?: DnaMarkerResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: IDogDnaResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDnaResultId = _data["dogDnaResultId"];
            this.resultIdentifier = _data["resultIdentifier"];
            this.controlledFiliation = _data["controlledFiliation"];
            this.correctFiliation = _data["correctFiliation"];
            this.labId = _data["labId"];
            this.labCode = _data["labCode"];
            this.isag = _data["isag"];
            this.dogId = _data["dogId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.lab = _data["lab"] ? Lab.fromJS(_data["lab"]) : <any>undefined;
            if (Array.isArray(_data["dnaMarkersResults"])) {
                this.dnaMarkersResults = [] as any;
                for (let item of _data["dnaMarkersResults"])
                    this.dnaMarkersResults!.push(DnaMarkerResult.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): DogDnaResult {
        data = typeof data === 'object' ? data : {};
        let result = new DogDnaResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDnaResultId"] = this.dogDnaResultId;
        data["resultIdentifier"] = this.resultIdentifier;
        data["controlledFiliation"] = this.controlledFiliation;
        data["correctFiliation"] = this.correctFiliation;
        data["labId"] = this.labId;
        data["labCode"] = this.labCode;
        data["isag"] = this.isag;
        data["dogId"] = this.dogId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["lab"] = this.lab ? this.lab.toJSON() : <any>undefined;
        if (Array.isArray(this.dnaMarkersResults)) {
            data["dnaMarkersResults"] = [];
            for (let item of this.dnaMarkersResults)
                data["dnaMarkersResults"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IDogDnaResult {
    dogDnaResultId?: number;
    resultIdentifier?: string | undefined;
    controlledFiliation?: boolean;
    correctFiliation?: boolean;
    labId?: number | undefined;
    labCode?: ELab | undefined;
    isag?: EIsagNorm;
    dogId?: number;
    dog?: Dog | undefined;
    lab?: Lab | undefined;
    dnaMarkersResults?: DnaMarkerResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export enum EIsagNorm {
    Norm2006 = "Norm2006",
    Norm2020 = "Norm2020",
}

export class DnaMarkerResult implements IDnaMarkerResult {
    dnaMarkerResultId?: number;
    dnaMarkerId?: number;
    dogDnaResultId?: number;
    value1?: string | undefined;
    value2?: string | undefined;
    dnaMarker?: DnaMarker | undefined;
    dogDnaResult?: DogDnaResult | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDnaMarkerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dnaMarkerResultId = _data["dnaMarkerResultId"];
            this.dnaMarkerId = _data["dnaMarkerId"];
            this.dogDnaResultId = _data["dogDnaResultId"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.dnaMarker = _data["dnaMarker"] ? DnaMarker.fromJS(_data["dnaMarker"]) : <any>undefined;
            this.dogDnaResult = _data["dogDnaResult"] ? DogDnaResult.fromJS(_data["dogDnaResult"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DnaMarkerResult {
        data = typeof data === 'object' ? data : {};
        let result = new DnaMarkerResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dnaMarkerResultId"] = this.dnaMarkerResultId;
        data["dnaMarkerId"] = this.dnaMarkerId;
        data["dogDnaResultId"] = this.dogDnaResultId;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["dnaMarker"] = this.dnaMarker ? this.dnaMarker.toJSON() : <any>undefined;
        data["dogDnaResult"] = this.dogDnaResult ? this.dogDnaResult.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDnaMarkerResult {
    dnaMarkerResultId?: number;
    dnaMarkerId?: number;
    dogDnaResultId?: number;
    value1?: string | undefined;
    value2?: string | undefined;
    dnaMarker?: DnaMarker | undefined;
    dogDnaResult?: DogDnaResult | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DnaMarker implements IDnaMarker {
    dnaMarkerId?: number;
    code?: string | undefined;
    isag?: EIsagNorm;
    dnaMarkersResults?: DnaMarkerResult[] | undefined;
    healthTestDnaMarkerResultTransients?: HealthTestDnaMarkerResultTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDnaMarker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dnaMarkerId = _data["dnaMarkerId"];
            this.code = _data["code"];
            this.isag = _data["isag"];
            if (Array.isArray(_data["dnaMarkersResults"])) {
                this.dnaMarkersResults = [] as any;
                for (let item of _data["dnaMarkersResults"])
                    this.dnaMarkersResults!.push(DnaMarkerResult.fromJS(item));
            }
            if (Array.isArray(_data["healthTestDnaMarkerResultTransients"])) {
                this.healthTestDnaMarkerResultTransients = [] as any;
                for (let item of _data["healthTestDnaMarkerResultTransients"])
                    this.healthTestDnaMarkerResultTransients!.push(HealthTestDnaMarkerResultTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DnaMarker {
        data = typeof data === 'object' ? data : {};
        let result = new DnaMarker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dnaMarkerId"] = this.dnaMarkerId;
        data["code"] = this.code;
        data["isag"] = this.isag;
        if (Array.isArray(this.dnaMarkersResults)) {
            data["dnaMarkersResults"] = [];
            for (let item of this.dnaMarkersResults)
                data["dnaMarkersResults"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestDnaMarkerResultTransients)) {
            data["healthTestDnaMarkerResultTransients"] = [];
            for (let item of this.healthTestDnaMarkerResultTransients)
                data["healthTestDnaMarkerResultTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDnaMarker {
    dnaMarkerId?: number;
    code?: string | undefined;
    isag?: EIsagNorm;
    dnaMarkersResults?: DnaMarkerResult[] | undefined;
    healthTestDnaMarkerResultTransients?: HealthTestDnaMarkerResultTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthTestDnaMarkerResultTransient implements IHealthTestDnaMarkerResultTransient {
    healthTestDnaMarkerResultTransientId?: number;
    dnaMarkerId?: number;
    dogHealthTestDnaResultTransientId?: number;
    value1?: string | undefined;
    value2?: string | undefined;
    dnaMarker?: DnaMarker | undefined;
    dogHealthTestDnaResultTransient?: DogHealthTestDnaResultTransient | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthTestDnaMarkerResultTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthTestDnaMarkerResultTransientId = _data["healthTestDnaMarkerResultTransientId"];
            this.dnaMarkerId = _data["dnaMarkerId"];
            this.dogHealthTestDnaResultTransientId = _data["dogHealthTestDnaResultTransientId"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.dnaMarker = _data["dnaMarker"] ? DnaMarker.fromJS(_data["dnaMarker"]) : <any>undefined;
            this.dogHealthTestDnaResultTransient = _data["dogHealthTestDnaResultTransient"] ? DogHealthTestDnaResultTransient.fromJS(_data["dogHealthTestDnaResultTransient"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthTestDnaMarkerResultTransient {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestDnaMarkerResultTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestDnaMarkerResultTransientId"] = this.healthTestDnaMarkerResultTransientId;
        data["dnaMarkerId"] = this.dnaMarkerId;
        data["dogHealthTestDnaResultTransientId"] = this.dogHealthTestDnaResultTransientId;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["dnaMarker"] = this.dnaMarker ? this.dnaMarker.toJSON() : <any>undefined;
        data["dogHealthTestDnaResultTransient"] = this.dogHealthTestDnaResultTransient ? this.dogHealthTestDnaResultTransient.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthTestDnaMarkerResultTransient {
    healthTestDnaMarkerResultTransientId?: number;
    dnaMarkerId?: number;
    dogHealthTestDnaResultTransientId?: number;
    value1?: string | undefined;
    value2?: string | undefined;
    dnaMarker?: DnaMarker | undefined;
    dogHealthTestDnaResultTransient?: DogHealthTestDnaResultTransient | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogHealthTestDnaResultTransient implements IDogHealthTestDnaResultTransient {
    dogHealthTestDnaResultTransientId?: number;
    resultIdentifier?: string | undefined;
    controlledFiliation?: boolean;
    correctFiliation?: boolean;
    labCode?: ELab;
    dogId?: number;
    healthTestRequestId?: number;
    dog?: Dog | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    healthTestDnaMarkerResultTransients?: HealthTestDnaMarkerResultTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogHealthTestDnaResultTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogHealthTestDnaResultTransientId = _data["dogHealthTestDnaResultTransientId"];
            this.resultIdentifier = _data["resultIdentifier"];
            this.controlledFiliation = _data["controlledFiliation"];
            this.correctFiliation = _data["correctFiliation"];
            this.labCode = _data["labCode"];
            this.dogId = _data["dogId"];
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.healthTestRequest = _data["healthTestRequest"] ? HealthTestRequest.fromJS(_data["healthTestRequest"]) : <any>undefined;
            if (Array.isArray(_data["healthTestDnaMarkerResultTransients"])) {
                this.healthTestDnaMarkerResultTransients = [] as any;
                for (let item of _data["healthTestDnaMarkerResultTransients"])
                    this.healthTestDnaMarkerResultTransients!.push(HealthTestDnaMarkerResultTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogHealthTestDnaResultTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthTestDnaResultTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogHealthTestDnaResultTransientId"] = this.dogHealthTestDnaResultTransientId;
        data["resultIdentifier"] = this.resultIdentifier;
        data["controlledFiliation"] = this.controlledFiliation;
        data["correctFiliation"] = this.correctFiliation;
        data["labCode"] = this.labCode;
        data["dogId"] = this.dogId;
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["healthTestRequest"] = this.healthTestRequest ? this.healthTestRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.healthTestDnaMarkerResultTransients)) {
            data["healthTestDnaMarkerResultTransients"] = [];
            for (let item of this.healthTestDnaMarkerResultTransients)
                data["healthTestDnaMarkerResultTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogHealthTestDnaResultTransient {
    dogHealthTestDnaResultTransientId?: number;
    resultIdentifier?: string | undefined;
    controlledFiliation?: boolean;
    correctFiliation?: boolean;
    labCode?: ELab;
    dogId?: number;
    healthTestRequestId?: number;
    dog?: Dog | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    healthTestDnaMarkerResultTransients?: HealthTestDnaMarkerResultTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthTestRequest implements IHealthTestRequest {
    healthTestRequestId?: number;
    lab?: ELab;
    requestId?: number;
    dogId?: number | undefined;
    labStatusId?: number | undefined;
    whiteTest?: boolean;
    labReference?: string | undefined;
    request?: Request | undefined;
    dog?: Dog | undefined;
    labStatus?: LabStatus | undefined;
    healthTestRequestHealthPacksTransients?: HealthTestRequestHealthPackTransient[] | undefined;
    dogHealthTestCharacteristicValueTransients?: DogHealthTestCharacteristicValueTransient[] | undefined;
    dogHealthTestDnaResultTransients?: DogHealthTestDnaResultTransient[] | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthTestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.lab = _data["lab"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.labStatusId = _data["labStatusId"];
            this.whiteTest = _data["whiteTest"];
            this.labReference = _data["labReference"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.labStatus = _data["labStatus"] ? LabStatus.fromJS(_data["labStatus"]) : <any>undefined;
            if (Array.isArray(_data["healthTestRequestHealthPacksTransients"])) {
                this.healthTestRequestHealthPacksTransients = [] as any;
                for (let item of _data["healthTestRequestHealthPacksTransients"])
                    this.healthTestRequestHealthPacksTransients!.push(HealthTestRequestHealthPackTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestCharacteristicValueTransients"])) {
                this.dogHealthTestCharacteristicValueTransients = [] as any;
                for (let item of _data["dogHealthTestCharacteristicValueTransients"])
                    this.dogHealthTestCharacteristicValueTransients!.push(DogHealthTestCharacteristicValueTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestDnaResultTransients"])) {
                this.dogHealthTestDnaResultTransients = [] as any;
                for (let item of _data["dogHealthTestDnaResultTransients"])
                    this.dogHealthTestDnaResultTransients!.push(DogHealthTestDnaResultTransient.fromJS(item));
            }
            if (Array.isArray(_data["healthTestSingleCharacteristicTransients"])) {
                this.healthTestSingleCharacteristicTransients = [] as any;
                for (let item of _data["healthTestSingleCharacteristicTransients"])
                    this.healthTestSingleCharacteristicTransients!.push(HealthTestSingleCharacteristicTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthTestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["lab"] = this.lab;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["labStatusId"] = this.labStatusId;
        data["whiteTest"] = this.whiteTest;
        data["labReference"] = this.labReference;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["labStatus"] = this.labStatus ? this.labStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.healthTestRequestHealthPacksTransients)) {
            data["healthTestRequestHealthPacksTransients"] = [];
            for (let item of this.healthTestRequestHealthPacksTransients)
                data["healthTestRequestHealthPacksTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestCharacteristicValueTransients)) {
            data["dogHealthTestCharacteristicValueTransients"] = [];
            for (let item of this.dogHealthTestCharacteristicValueTransients)
                data["dogHealthTestCharacteristicValueTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestDnaResultTransients)) {
            data["dogHealthTestDnaResultTransients"] = [];
            for (let item of this.dogHealthTestDnaResultTransients)
                data["dogHealthTestDnaResultTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestSingleCharacteristicTransients)) {
            data["healthTestSingleCharacteristicTransients"] = [];
            for (let item of this.healthTestSingleCharacteristicTransients)
                data["healthTestSingleCharacteristicTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthTestRequest {
    healthTestRequestId?: number;
    lab?: ELab;
    requestId?: number;
    dogId?: number | undefined;
    labStatusId?: number | undefined;
    whiteTest?: boolean;
    labReference?: string | undefined;
    request?: Request | undefined;
    dog?: Dog | undefined;
    labStatus?: LabStatus | undefined;
    healthTestRequestHealthPacksTransients?: HealthTestRequestHealthPackTransient[] | undefined;
    dogHealthTestCharacteristicValueTransients?: DogHealthTestCharacteristicValueTransient[] | undefined;
    dogHealthTestDnaResultTransients?: DogHealthTestDnaResultTransient[] | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class LabStatus implements ILabStatus {
    labStatusId?: number;
    labStatusCode?: ELabStatus;
    labStatusTypeCode?: ELabStatusType | undefined;
    labStatusTranslations?: LabStatusTranslation[] | undefined;
    labStatusDescriptionTranslations?: LabStatusDescriptionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ILabStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labStatusId = _data["labStatusId"];
            this.labStatusCode = _data["labStatusCode"];
            this.labStatusTypeCode = _data["labStatusTypeCode"];
            if (Array.isArray(_data["labStatusTranslations"])) {
                this.labStatusTranslations = [] as any;
                for (let item of _data["labStatusTranslations"])
                    this.labStatusTranslations!.push(LabStatusTranslation.fromJS(item));
            }
            if (Array.isArray(_data["labStatusDescriptionTranslations"])) {
                this.labStatusDescriptionTranslations = [] as any;
                for (let item of _data["labStatusDescriptionTranslations"])
                    this.labStatusDescriptionTranslations!.push(LabStatusDescriptionTranslation.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LabStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LabStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labStatusId"] = this.labStatusId;
        data["labStatusCode"] = this.labStatusCode;
        data["labStatusTypeCode"] = this.labStatusTypeCode;
        if (Array.isArray(this.labStatusTranslations)) {
            data["labStatusTranslations"] = [];
            for (let item of this.labStatusTranslations)
                data["labStatusTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.labStatusDescriptionTranslations)) {
            data["labStatusDescriptionTranslations"] = [];
            for (let item of this.labStatusDescriptionTranslations)
                data["labStatusDescriptionTranslations"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILabStatus {
    labStatusId?: number;
    labStatusCode?: ELabStatus;
    labStatusTypeCode?: ELabStatusType | undefined;
    labStatusTranslations?: LabStatusTranslation[] | undefined;
    labStatusDescriptionTranslations?: LabStatusDescriptionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export enum ELabStatus {
    KitsSent = "KitsSent",
    KitsReceived = "KitsReceived",
    AwaitingNewFather = "AwaitingNewFather",
    NamingAvailable = "NamingAvailable",
    AnalysisDone = "AnalysisDone",
    AnalysisInProgress = "AnalysisInProgress",
    NewKitsReceived = "NewKitsReceived",
    Reprocessing = "Reprocessing",
    AwaitingSecondAnalysis = "AwaitingSecondAnalysis",
}

export enum ELabStatusType {
    BroodRequest = "BroodRequest",
    HealthTest = "HealthTest",
}

export class LabStatusTranslation implements ILabStatusTranslation {
    labStatusTranslationId?: number;
    languageId?: number;
    labStatusId?: number;
    text?: string | undefined;
    labStatus?: LabStatus | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ILabStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labStatusTranslationId = _data["labStatusTranslationId"];
            this.languageId = _data["languageId"];
            this.labStatusId = _data["labStatusId"];
            this.text = _data["text"];
            this.labStatus = _data["labStatus"] ? LabStatus.fromJS(_data["labStatus"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): LabStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LabStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labStatusTranslationId"] = this.labStatusTranslationId;
        data["languageId"] = this.languageId;
        data["labStatusId"] = this.labStatusId;
        data["text"] = this.text;
        data["labStatus"] = this.labStatus ? this.labStatus.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILabStatusTranslation {
    labStatusTranslationId?: number;
    languageId?: number;
    labStatusId?: number;
    text?: string | undefined;
    labStatus?: LabStatus | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class LabStatusDescriptionTranslation implements ILabStatusDescriptionTranslation {
    labStatusDescriptionTranslationId?: number;
    languageId?: number;
    labStatusId?: number;
    text?: string | undefined;
    labStatus?: LabStatus | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ILabStatusDescriptionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labStatusDescriptionTranslationId = _data["labStatusDescriptionTranslationId"];
            this.languageId = _data["languageId"];
            this.labStatusId = _data["labStatusId"];
            this.text = _data["text"];
            this.labStatus = _data["labStatus"] ? LabStatus.fromJS(_data["labStatus"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): LabStatusDescriptionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LabStatusDescriptionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labStatusDescriptionTranslationId"] = this.labStatusDescriptionTranslationId;
        data["languageId"] = this.languageId;
        data["labStatusId"] = this.labStatusId;
        data["text"] = this.text;
        data["labStatus"] = this.labStatus ? this.labStatus.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILabStatusDescriptionTranslation {
    labStatusDescriptionTranslationId?: number;
    languageId?: number;
    labStatusId?: number;
    text?: string | undefined;
    labStatus?: LabStatus | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthTestRequestHealthPackTransient implements IHealthTestRequestHealthPackTransient {
    healthTestRequestHealthPackTransientId?: number;
    healthPackId?: number;
    healthTestRequestId?: number;
    healthPack?: HealthPack | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    healthTestRequestCharacteristicsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IHealthTestRequestHealthPackTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthTestRequestHealthPackTransientId = _data["healthTestRequestHealthPackTransientId"];
            this.healthPackId = _data["healthPackId"];
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.healthPack = _data["healthPack"] ? HealthPack.fromJS(_data["healthPack"]) : <any>undefined;
            this.healthTestRequest = _data["healthTestRequest"] ? HealthTestRequest.fromJS(_data["healthTestRequest"]) : <any>undefined;
            if (Array.isArray(_data["healthTestRequestCharacteristicsTransients"])) {
                this.healthTestRequestCharacteristicsTransients = [] as any;
                for (let item of _data["healthTestRequestCharacteristicsTransients"])
                    this.healthTestRequestCharacteristicsTransients!.push(HealthTestRequestCharacteristicTransient.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthTestRequestHealthPackTransient {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestHealthPackTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestRequestHealthPackTransientId"] = this.healthTestRequestHealthPackTransientId;
        data["healthPackId"] = this.healthPackId;
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["healthPack"] = this.healthPack ? this.healthPack.toJSON() : <any>undefined;
        data["healthTestRequest"] = this.healthTestRequest ? this.healthTestRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.healthTestRequestCharacteristicsTransients)) {
            data["healthTestRequestCharacteristicsTransients"] = [];
            for (let item of this.healthTestRequestCharacteristicsTransients)
                data["healthTestRequestCharacteristicsTransients"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthTestRequestHealthPackTransient {
    healthTestRequestHealthPackTransientId?: number;
    healthPackId?: number;
    healthTestRequestId?: number;
    healthPack?: HealthPack | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    healthTestRequestCharacteristicsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class HealthPack implements IHealthPack {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    articleId?: number | undefined;
    healthPackGroupId?: number;
    lab?: ELab;
    cegekaId?: string | undefined;
    isDnaPack?: boolean;
    isFiliationPack?: boolean;
    webSiteUriFr?: string | undefined;
    webSiteUriNl?: string | undefined;
    orderIndex?: number;
    healthPackGroup?: HealthPackGroup | undefined;
    breedHealthPacks?: BreedHealthPack[] | undefined;
    healthTestRequestHealthPacksTransients?: HealthTestRequestHealthPackTransient[] | undefined;
    healthPackCharacteristics?: HealthPackCharacteristic[] | undefined;
    healthPackTranslations?: HealthPackTranslation[] | undefined;
    article?: Article | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthPack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackId = _data["healthPackId"];
            this.healthPackCode = _data["healthPackCode"];
            this.articleId = _data["articleId"];
            this.healthPackGroupId = _data["healthPackGroupId"];
            this.lab = _data["lab"];
            this.cegekaId = _data["cegekaId"];
            this.isDnaPack = _data["isDnaPack"];
            this.isFiliationPack = _data["isFiliationPack"];
            this.webSiteUriFr = _data["webSiteUriFr"];
            this.webSiteUriNl = _data["webSiteUriNl"];
            this.orderIndex = _data["orderIndex"];
            this.healthPackGroup = _data["healthPackGroup"] ? HealthPackGroup.fromJS(_data["healthPackGroup"]) : <any>undefined;
            if (Array.isArray(_data["breedHealthPacks"])) {
                this.breedHealthPacks = [] as any;
                for (let item of _data["breedHealthPacks"])
                    this.breedHealthPacks!.push(BreedHealthPack.fromJS(item));
            }
            if (Array.isArray(_data["healthTestRequestHealthPacksTransients"])) {
                this.healthTestRequestHealthPacksTransients = [] as any;
                for (let item of _data["healthTestRequestHealthPacksTransients"])
                    this.healthTestRequestHealthPacksTransients!.push(HealthTestRequestHealthPackTransient.fromJS(item));
            }
            if (Array.isArray(_data["healthPackCharacteristics"])) {
                this.healthPackCharacteristics = [] as any;
                for (let item of _data["healthPackCharacteristics"])
                    this.healthPackCharacteristics!.push(HealthPackCharacteristic.fromJS(item));
            }
            if (Array.isArray(_data["healthPackTranslations"])) {
                this.healthPackTranslations = [] as any;
                for (let item of _data["healthPackTranslations"])
                    this.healthPackTranslations!.push(HealthPackTranslation.fromJS(item));
            }
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthPack {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackId"] = this.healthPackId;
        data["healthPackCode"] = this.healthPackCode;
        data["articleId"] = this.articleId;
        data["healthPackGroupId"] = this.healthPackGroupId;
        data["lab"] = this.lab;
        data["cegekaId"] = this.cegekaId;
        data["isDnaPack"] = this.isDnaPack;
        data["isFiliationPack"] = this.isFiliationPack;
        data["webSiteUriFr"] = this.webSiteUriFr;
        data["webSiteUriNl"] = this.webSiteUriNl;
        data["orderIndex"] = this.orderIndex;
        data["healthPackGroup"] = this.healthPackGroup ? this.healthPackGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.breedHealthPacks)) {
            data["breedHealthPacks"] = [];
            for (let item of this.breedHealthPacks)
                data["breedHealthPacks"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestRequestHealthPacksTransients)) {
            data["healthTestRequestHealthPacksTransients"] = [];
            for (let item of this.healthTestRequestHealthPacksTransients)
                data["healthTestRequestHealthPacksTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.healthPackCharacteristics)) {
            data["healthPackCharacteristics"] = [];
            for (let item of this.healthPackCharacteristics)
                data["healthPackCharacteristics"].push(item.toJSON());
        }
        if (Array.isArray(this.healthPackTranslations)) {
            data["healthPackTranslations"] = [];
            for (let item of this.healthPackTranslations)
                data["healthPackTranslations"].push(item.toJSON());
        }
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthPack {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    articleId?: number | undefined;
    healthPackGroupId?: number;
    lab?: ELab;
    cegekaId?: string | undefined;
    isDnaPack?: boolean;
    isFiliationPack?: boolean;
    webSiteUriFr?: string | undefined;
    webSiteUriNl?: string | undefined;
    orderIndex?: number;
    healthPackGroup?: HealthPackGroup | undefined;
    breedHealthPacks?: BreedHealthPack[] | undefined;
    healthTestRequestHealthPacksTransients?: HealthTestRequestHealthPackTransient[] | undefined;
    healthPackCharacteristics?: HealthPackCharacteristic[] | undefined;
    healthPackTranslations?: HealthPackTranslation[] | undefined;
    article?: Article | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthPackGroup implements IHealthPackGroup {
    healthPackGroupId?: number;
    healthPackGroupCode?: string | undefined;
    cegekaId?: string | undefined;
    healthPacks?: HealthPack[] | undefined;
    healthPackGroupTranslations?: HealthPackGroupTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthPackGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackGroupId = _data["healthPackGroupId"];
            this.healthPackGroupCode = _data["healthPackGroupCode"];
            this.cegekaId = _data["cegekaId"];
            if (Array.isArray(_data["healthPacks"])) {
                this.healthPacks = [] as any;
                for (let item of _data["healthPacks"])
                    this.healthPacks!.push(HealthPack.fromJS(item));
            }
            if (Array.isArray(_data["healthPackGroupTranslations"])) {
                this.healthPackGroupTranslations = [] as any;
                for (let item of _data["healthPackGroupTranslations"])
                    this.healthPackGroupTranslations!.push(HealthPackGroupTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthPackGroup {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackGroupId"] = this.healthPackGroupId;
        data["healthPackGroupCode"] = this.healthPackGroupCode;
        data["cegekaId"] = this.cegekaId;
        if (Array.isArray(this.healthPacks)) {
            data["healthPacks"] = [];
            for (let item of this.healthPacks)
                data["healthPacks"].push(item.toJSON());
        }
        if (Array.isArray(this.healthPackGroupTranslations)) {
            data["healthPackGroupTranslations"] = [];
            for (let item of this.healthPackGroupTranslations)
                data["healthPackGroupTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthPackGroup {
    healthPackGroupId?: number;
    healthPackGroupCode?: string | undefined;
    cegekaId?: string | undefined;
    healthPacks?: HealthPack[] | undefined;
    healthPackGroupTranslations?: HealthPackGroupTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthPackGroupTranslation implements IHealthPackGroupTranslation {
    healthPackGroupTranslationId?: number;
    text?: string | undefined;
    languageId?: number;
    healthPackGroupId?: number;
    language?: Language | undefined;
    healthPackGroup?: HealthPackGroup | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthPackGroupTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackGroupTranslationId = _data["healthPackGroupTranslationId"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.healthPackGroupId = _data["healthPackGroupId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.healthPackGroup = _data["healthPackGroup"] ? HealthPackGroup.fromJS(_data["healthPackGroup"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthPackGroupTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackGroupTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackGroupTranslationId"] = this.healthPackGroupTranslationId;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["healthPackGroupId"] = this.healthPackGroupId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["healthPackGroup"] = this.healthPackGroup ? this.healthPackGroup.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthPackGroupTranslation {
    healthPackGroupTranslationId?: number;
    text?: string | undefined;
    languageId?: number;
    healthPackGroupId?: number;
    language?: Language | undefined;
    healthPackGroup?: HealthPackGroup | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedHealthPack implements IBreedHealthPack {
    breedHealthPackId?: number;
    breedId?: number;
    healthPackId?: number;
    breed?: Breed | undefined;
    healthPack?: HealthPack | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedHealthPack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedHealthPackId = _data["breedHealthPackId"];
            this.breedId = _data["breedId"];
            this.healthPackId = _data["healthPackId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.healthPack = _data["healthPack"] ? HealthPack.fromJS(_data["healthPack"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedHealthPack {
        data = typeof data === 'object' ? data : {};
        let result = new BreedHealthPack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedHealthPackId"] = this.breedHealthPackId;
        data["breedId"] = this.breedId;
        data["healthPackId"] = this.healthPackId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["healthPack"] = this.healthPack ? this.healthPack.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedHealthPack {
    breedHealthPackId?: number;
    breedId?: number;
    healthPackId?: number;
    breed?: Breed | undefined;
    healthPack?: HealthPack | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthPackCharacteristic implements IHealthPackCharacteristic {
    healthPackCharacteristicId?: number;
    healthPackId?: number;
    characteristicId?: number;
    characteristic?: Characteristic | undefined;
    healthPack?: HealthPack | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthPackCharacteristic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackCharacteristicId = _data["healthPackCharacteristicId"];
            this.healthPackId = _data["healthPackId"];
            this.characteristicId = _data["characteristicId"];
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthPack = _data["healthPack"] ? HealthPack.fromJS(_data["healthPack"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthPackCharacteristic {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackCharacteristic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackCharacteristicId"] = this.healthPackCharacteristicId;
        data["healthPackId"] = this.healthPackId;
        data["characteristicId"] = this.characteristicId;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthPack"] = this.healthPack ? this.healthPack.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthPackCharacteristic {
    healthPackCharacteristicId?: number;
    healthPackId?: number;
    characteristicId?: number;
    characteristic?: Characteristic | undefined;
    healthPack?: HealthPack | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Characteristic implements ICharacteristic {
    characteristicId?: number;
    characteristicTypeId?: number;
    code?: string | undefined;
    labCode?: string | undefined;
    remark?: string | undefined;
    dysplasiaTypeId?: number | undefined;
    articleId?: number | undefined;
    cegekaId?: string | undefined;
    orderIndex?: number;
    healthValueTypeId?: number | undefined;
    isRight?: boolean | undefined;
    characteristicType?: CharacteristicType | undefined;
    dysplasiaType?: DysplasiaType | undefined;
    healthValueType?: HealthValueType | undefined;
    article?: Article | undefined;
    lab?: ELab | undefined;
    healthPackCharacteristics?: HealthPackCharacteristic[] | undefined;
    healthTestRequestsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    characteristicsValues?: CharacteristicValue[] | undefined;
    dogsCharacteristicsValues?: DogCharacteristicValue[] | undefined;
    characteristicTranslations?: CharacteristicTranslation[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    dogDysplasiaTransients?: DogDysplasiaTransient[] | undefined;
    dogDysplasias?: DogDysplasia[] | undefined;
    dogHealthTestCharacteristicValueTransients?: DogHealthTestCharacteristicValueTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICharacteristic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicId = _data["characteristicId"];
            this.characteristicTypeId = _data["characteristicTypeId"];
            this.code = _data["code"];
            this.labCode = _data["labCode"];
            this.remark = _data["remark"];
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            this.articleId = _data["articleId"];
            this.cegekaId = _data["cegekaId"];
            this.orderIndex = _data["orderIndex"];
            this.healthValueTypeId = _data["healthValueTypeId"];
            this.isRight = _data["isRight"];
            this.characteristicType = _data["characteristicType"] ? CharacteristicType.fromJS(_data["characteristicType"]) : <any>undefined;
            this.dysplasiaType = _data["dysplasiaType"] ? DysplasiaType.fromJS(_data["dysplasiaType"]) : <any>undefined;
            this.healthValueType = _data["healthValueType"] ? HealthValueType.fromJS(_data["healthValueType"]) : <any>undefined;
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            this.lab = _data["lab"];
            if (Array.isArray(_data["healthPackCharacteristics"])) {
                this.healthPackCharacteristics = [] as any;
                for (let item of _data["healthPackCharacteristics"])
                    this.healthPackCharacteristics!.push(HealthPackCharacteristic.fromJS(item));
            }
            if (Array.isArray(_data["healthTestRequestsTransients"])) {
                this.healthTestRequestsTransients = [] as any;
                for (let item of _data["healthTestRequestsTransients"])
                    this.healthTestRequestsTransients!.push(HealthTestRequestCharacteristicTransient.fromJS(item));
            }
            if (Array.isArray(_data["healthTestSingleCharacteristicTransients"])) {
                this.healthTestSingleCharacteristicTransients = [] as any;
                for (let item of _data["healthTestSingleCharacteristicTransients"])
                    this.healthTestSingleCharacteristicTransients!.push(HealthTestSingleCharacteristicTransient.fromJS(item));
            }
            if (Array.isArray(_data["characteristicsValues"])) {
                this.characteristicsValues = [] as any;
                for (let item of _data["characteristicsValues"])
                    this.characteristicsValues!.push(CharacteristicValue.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValues"])) {
                this.dogsCharacteristicsValues = [] as any;
                for (let item of _data["dogsCharacteristicsValues"])
                    this.dogsCharacteristicsValues!.push(DogCharacteristicValue.fromJS(item));
            }
            if (Array.isArray(_data["characteristicTranslations"])) {
                this.characteristicTranslations = [] as any;
                for (let item of _data["characteristicTranslations"])
                    this.characteristicTranslations!.push(CharacteristicTranslation.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValuesTransients"])) {
                this.dogsCharacteristicsValuesTransients = [] as any;
                for (let item of _data["dogsCharacteristicsValuesTransients"])
                    this.dogsCharacteristicsValuesTransients!.push(DogsCharacteristicsValuesTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogDysplasiaTransients"])) {
                this.dogDysplasiaTransients = [] as any;
                for (let item of _data["dogDysplasiaTransients"])
                    this.dogDysplasiaTransients!.push(DogDysplasiaTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogDysplasias"])) {
                this.dogDysplasias = [] as any;
                for (let item of _data["dogDysplasias"])
                    this.dogDysplasias!.push(DogDysplasia.fromJS(item));
            }
            if (Array.isArray(_data["dogHealthTestCharacteristicValueTransients"])) {
                this.dogHealthTestCharacteristicValueTransients = [] as any;
                for (let item of _data["dogHealthTestCharacteristicValueTransients"])
                    this.dogHealthTestCharacteristicValueTransients!.push(DogHealthTestCharacteristicValueTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Characteristic {
        data = typeof data === 'object' ? data : {};
        let result = new Characteristic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicId"] = this.characteristicId;
        data["characteristicTypeId"] = this.characteristicTypeId;
        data["code"] = this.code;
        data["labCode"] = this.labCode;
        data["remark"] = this.remark;
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        data["articleId"] = this.articleId;
        data["cegekaId"] = this.cegekaId;
        data["orderIndex"] = this.orderIndex;
        data["healthValueTypeId"] = this.healthValueTypeId;
        data["isRight"] = this.isRight;
        data["characteristicType"] = this.characteristicType ? this.characteristicType.toJSON() : <any>undefined;
        data["dysplasiaType"] = this.dysplasiaType ? this.dysplasiaType.toJSON() : <any>undefined;
        data["healthValueType"] = this.healthValueType ? this.healthValueType.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["lab"] = this.lab;
        if (Array.isArray(this.healthPackCharacteristics)) {
            data["healthPackCharacteristics"] = [];
            for (let item of this.healthPackCharacteristics)
                data["healthPackCharacteristics"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestRequestsTransients)) {
            data["healthTestRequestsTransients"] = [];
            for (let item of this.healthTestRequestsTransients)
                data["healthTestRequestsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestSingleCharacteristicTransients)) {
            data["healthTestSingleCharacteristicTransients"] = [];
            for (let item of this.healthTestSingleCharacteristicTransients)
                data["healthTestSingleCharacteristicTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.characteristicsValues)) {
            data["characteristicsValues"] = [];
            for (let item of this.characteristicsValues)
                data["characteristicsValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValues)) {
            data["dogsCharacteristicsValues"] = [];
            for (let item of this.dogsCharacteristicsValues)
                data["dogsCharacteristicsValues"].push(item.toJSON());
        }
        if (Array.isArray(this.characteristicTranslations)) {
            data["characteristicTranslations"] = [];
            for (let item of this.characteristicTranslations)
                data["characteristicTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValuesTransients)) {
            data["dogsCharacteristicsValuesTransients"] = [];
            for (let item of this.dogsCharacteristicsValuesTransients)
                data["dogsCharacteristicsValuesTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogDysplasiaTransients)) {
            data["dogDysplasiaTransients"] = [];
            for (let item of this.dogDysplasiaTransients)
                data["dogDysplasiaTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogDysplasias)) {
            data["dogDysplasias"] = [];
            for (let item of this.dogDysplasias)
                data["dogDysplasias"].push(item.toJSON());
        }
        if (Array.isArray(this.dogHealthTestCharacteristicValueTransients)) {
            data["dogHealthTestCharacteristicValueTransients"] = [];
            for (let item of this.dogHealthTestCharacteristicValueTransients)
                data["dogHealthTestCharacteristicValueTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICharacteristic {
    characteristicId?: number;
    characteristicTypeId?: number;
    code?: string | undefined;
    labCode?: string | undefined;
    remark?: string | undefined;
    dysplasiaTypeId?: number | undefined;
    articleId?: number | undefined;
    cegekaId?: string | undefined;
    orderIndex?: number;
    healthValueTypeId?: number | undefined;
    isRight?: boolean | undefined;
    characteristicType?: CharacteristicType | undefined;
    dysplasiaType?: DysplasiaType | undefined;
    healthValueType?: HealthValueType | undefined;
    article?: Article | undefined;
    lab?: ELab | undefined;
    healthPackCharacteristics?: HealthPackCharacteristic[] | undefined;
    healthTestRequestsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    characteristicsValues?: CharacteristicValue[] | undefined;
    dogsCharacteristicsValues?: DogCharacteristicValue[] | undefined;
    characteristicTranslations?: CharacteristicTranslation[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    dogDysplasiaTransients?: DogDysplasiaTransient[] | undefined;
    dogDysplasias?: DogDysplasia[] | undefined;
    dogHealthTestCharacteristicValueTransients?: DogHealthTestCharacteristicValueTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CharacteristicType implements ICharacteristicType {
    characteristicTypeId?: number;
    name?: string | undefined;
    typeCode?: string | undefined;
    isLab?: boolean;
    isDysplasia?: boolean;
    characteristics?: Characteristic[] | undefined;
    characteristicTypeTranslations?: CharacteristicTypeTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICharacteristicType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicTypeId = _data["characteristicTypeId"];
            this.name = _data["name"];
            this.typeCode = _data["typeCode"];
            this.isLab = _data["isLab"];
            this.isDysplasia = _data["isDysplasia"];
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(Characteristic.fromJS(item));
            }
            if (Array.isArray(_data["characteristicTypeTranslations"])) {
                this.characteristicTypeTranslations = [] as any;
                for (let item of _data["characteristicTypeTranslations"])
                    this.characteristicTypeTranslations!.push(CharacteristicTypeTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CharacteristicType {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicTypeId"] = this.characteristicTypeId;
        data["name"] = this.name;
        data["typeCode"] = this.typeCode;
        data["isLab"] = this.isLab;
        data["isDysplasia"] = this.isDysplasia;
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item.toJSON());
        }
        if (Array.isArray(this.characteristicTypeTranslations)) {
            data["characteristicTypeTranslations"] = [];
            for (let item of this.characteristicTypeTranslations)
                data["characteristicTypeTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICharacteristicType {
    characteristicTypeId?: number;
    name?: string | undefined;
    typeCode?: string | undefined;
    isLab?: boolean;
    isDysplasia?: boolean;
    characteristics?: Characteristic[] | undefined;
    characteristicTypeTranslations?: CharacteristicTypeTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CharacteristicTypeTranslation implements ICharacteristicTypeTranslation {
    characteristicTypeTranslationId?: number;
    characteristicTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    characteristicType?: CharacteristicType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICharacteristicTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicTypeTranslationId = _data["characteristicTypeTranslationId"];
            this.characteristicTypeId = _data["characteristicTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.characteristicType = _data["characteristicType"] ? CharacteristicType.fromJS(_data["characteristicType"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CharacteristicTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicTypeTranslationId"] = this.characteristicTypeTranslationId;
        data["characteristicTypeId"] = this.characteristicTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["characteristicType"] = this.characteristicType ? this.characteristicType.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICharacteristicTypeTranslation {
    characteristicTypeTranslationId?: number;
    characteristicTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    characteristicType?: CharacteristicType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthValueType implements IHealthValueType {
    healthValueTypeId?: number;
    healthValueTypeCode?: EHealthValueType;
    canBeUsedForDysplasia?: boolean;
    healthValueTypeTranslations?: HealthValueTypeTranslation[] | undefined;
    characteristics?: Characteristic[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthValueType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueTypeId = _data["healthValueTypeId"];
            this.healthValueTypeCode = _data["healthValueTypeCode"];
            this.canBeUsedForDysplasia = _data["canBeUsedForDysplasia"];
            if (Array.isArray(_data["healthValueTypeTranslations"])) {
                this.healthValueTypeTranslations = [] as any;
                for (let item of _data["healthValueTypeTranslations"])
                    this.healthValueTypeTranslations!.push(HealthValueTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(Characteristic.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthValueType {
        data = typeof data === 'object' ? data : {};
        let result = new HealthValueType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueTypeId"] = this.healthValueTypeId;
        data["healthValueTypeCode"] = this.healthValueTypeCode;
        data["canBeUsedForDysplasia"] = this.canBeUsedForDysplasia;
        if (Array.isArray(this.healthValueTypeTranslations)) {
            data["healthValueTypeTranslations"] = [];
            for (let item of this.healthValueTypeTranslations)
                data["healthValueTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthValueType {
    healthValueTypeId?: number;
    healthValueTypeCode?: EHealthValueType;
    canBeUsedForDysplasia?: boolean;
    healthValueTypeTranslations?: HealthValueTypeTranslation[] | undefined;
    characteristics?: Characteristic[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EHealthValueType {
    Numeric = "Numeric",
    Alphanumeric = "Alphanumeric",
    ValueList = "ValueList",
}

export class HealthValueTypeTranslation implements IHealthValueTypeTranslation {
    healthValueTypeTranslationId?: number;
    healthValueTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    healthValueType?: HealthValueType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthValueTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueTypeTranslationId = _data["healthValueTypeTranslationId"];
            this.healthValueTypeId = _data["healthValueTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.healthValueType = _data["healthValueType"] ? HealthValueType.fromJS(_data["healthValueType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthValueTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new HealthValueTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueTypeTranslationId"] = this.healthValueTypeTranslationId;
        data["healthValueTypeId"] = this.healthValueTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["healthValueType"] = this.healthValueType ? this.healthValueType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthValueTypeTranslation {
    healthValueTypeTranslationId?: number;
    healthValueTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    healthValueType?: HealthValueType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Article implements IArticle {
    articleId?: number;
    articleNumber?: number;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    price?: number;
    code?: EArticleCodes | undefined;
    cegekaId?: string | undefined;
    vatCode?: EVat;
    isMiscelaneous?: boolean;
    articleTranslations?: ArticleTranslation[] | undefined;
    workbookTypes?: WorkbookType[] | undefined;
    characteristics?: Characteristic[] | undefined;
    miscellaneousRequests?: MiscellaneousRequest[] | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    healthPacks?: HealthPack[] | undefined;
    titles?: Title[] | undefined;
    unitPricePerDogSubActivities?: SubActivity[] | undefined;
    unitFciPricePerDogSubActivities?: SubActivity[] | undefined;
    fciTaxSubActivities?: SubActivity[] | undefined;
    cacTaxSubActivities?: SubActivity[] | undefined;
    classicTaxSubActivities?: SubActivity[] | undefined;
    extraTaxSubActivities?: SubActivity[] | undefined;
    participationTaxSubActivities?: SubActivity[] | undefined;
    participationFciTaxSubActivities?: SubActivity[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.articleNumber = _data["articleNumber"];
            this.bcIdentifier = _data["bcIdentifier"];
            this.brcsBcIdentifier = _data["brcsBcIdentifier"];
            this.price = _data["price"];
            this.code = _data["code"];
            this.cegekaId = _data["cegekaId"];
            this.vatCode = _data["vatCode"];
            this.isMiscelaneous = _data["isMiscelaneous"];
            if (Array.isArray(_data["articleTranslations"])) {
                this.articleTranslations = [] as any;
                for (let item of _data["articleTranslations"])
                    this.articleTranslations!.push(ArticleTranslation.fromJS(item));
            }
            if (Array.isArray(_data["workbookTypes"])) {
                this.workbookTypes = [] as any;
                for (let item of _data["workbookTypes"])
                    this.workbookTypes!.push(WorkbookType.fromJS(item));
            }
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(Characteristic.fromJS(item));
            }
            if (Array.isArray(_data["miscellaneousRequests"])) {
                this.miscellaneousRequests = [] as any;
                for (let item of _data["miscellaneousRequests"])
                    this.miscellaneousRequests!.push(MiscellaneousRequest.fromJS(item));
            }
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
            if (Array.isArray(_data["healthPacks"])) {
                this.healthPacks = [] as any;
                for (let item of _data["healthPacks"])
                    this.healthPacks!.push(HealthPack.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(Title.fromJS(item));
            }
            if (Array.isArray(_data["unitPricePerDogSubActivities"])) {
                this.unitPricePerDogSubActivities = [] as any;
                for (let item of _data["unitPricePerDogSubActivities"])
                    this.unitPricePerDogSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["unitFciPricePerDogSubActivities"])) {
                this.unitFciPricePerDogSubActivities = [] as any;
                for (let item of _data["unitFciPricePerDogSubActivities"])
                    this.unitFciPricePerDogSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["fciTaxSubActivities"])) {
                this.fciTaxSubActivities = [] as any;
                for (let item of _data["fciTaxSubActivities"])
                    this.fciTaxSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["cacTaxSubActivities"])) {
                this.cacTaxSubActivities = [] as any;
                for (let item of _data["cacTaxSubActivities"])
                    this.cacTaxSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["classicTaxSubActivities"])) {
                this.classicTaxSubActivities = [] as any;
                for (let item of _data["classicTaxSubActivities"])
                    this.classicTaxSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["extraTaxSubActivities"])) {
                this.extraTaxSubActivities = [] as any;
                for (let item of _data["extraTaxSubActivities"])
                    this.extraTaxSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["participationTaxSubActivities"])) {
                this.participationTaxSubActivities = [] as any;
                for (let item of _data["participationTaxSubActivities"])
                    this.participationTaxSubActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["participationFciTaxSubActivities"])) {
                this.participationFciTaxSubActivities = [] as any;
                for (let item of _data["participationFciTaxSubActivities"])
                    this.participationFciTaxSubActivities!.push(SubActivity.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Article {
        data = typeof data === 'object' ? data : {};
        let result = new Article();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["articleNumber"] = this.articleNumber;
        data["bcIdentifier"] = this.bcIdentifier;
        data["brcsBcIdentifier"] = this.brcsBcIdentifier;
        data["price"] = this.price;
        data["code"] = this.code;
        data["cegekaId"] = this.cegekaId;
        data["vatCode"] = this.vatCode;
        data["isMiscelaneous"] = this.isMiscelaneous;
        if (Array.isArray(this.articleTranslations)) {
            data["articleTranslations"] = [];
            for (let item of this.articleTranslations)
                data["articleTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.workbookTypes)) {
            data["workbookTypes"] = [];
            for (let item of this.workbookTypes)
                data["workbookTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item.toJSON());
        }
        if (Array.isArray(this.miscellaneousRequests)) {
            data["miscellaneousRequests"] = [];
            for (let item of this.miscellaneousRequests)
                data["miscellaneousRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        if (Array.isArray(this.healthPacks)) {
            data["healthPacks"] = [];
            for (let item of this.healthPacks)
                data["healthPacks"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.unitPricePerDogSubActivities)) {
            data["unitPricePerDogSubActivities"] = [];
            for (let item of this.unitPricePerDogSubActivities)
                data["unitPricePerDogSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.unitFciPricePerDogSubActivities)) {
            data["unitFciPricePerDogSubActivities"] = [];
            for (let item of this.unitFciPricePerDogSubActivities)
                data["unitFciPricePerDogSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.fciTaxSubActivities)) {
            data["fciTaxSubActivities"] = [];
            for (let item of this.fciTaxSubActivities)
                data["fciTaxSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.cacTaxSubActivities)) {
            data["cacTaxSubActivities"] = [];
            for (let item of this.cacTaxSubActivities)
                data["cacTaxSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.classicTaxSubActivities)) {
            data["classicTaxSubActivities"] = [];
            for (let item of this.classicTaxSubActivities)
                data["classicTaxSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.extraTaxSubActivities)) {
            data["extraTaxSubActivities"] = [];
            for (let item of this.extraTaxSubActivities)
                data["extraTaxSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.participationTaxSubActivities)) {
            data["participationTaxSubActivities"] = [];
            for (let item of this.participationTaxSubActivities)
                data["participationTaxSubActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.participationFciTaxSubActivities)) {
            data["participationFciTaxSubActivities"] = [];
            for (let item of this.participationFciTaxSubActivities)
                data["participationFciTaxSubActivities"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IArticle {
    articleId?: number;
    articleNumber?: number;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    price?: number;
    code?: EArticleCodes | undefined;
    cegekaId?: string | undefined;
    vatCode?: EVat;
    isMiscelaneous?: boolean;
    articleTranslations?: ArticleTranslation[] | undefined;
    workbookTypes?: WorkbookType[] | undefined;
    characteristics?: Characteristic[] | undefined;
    miscellaneousRequests?: MiscellaneousRequest[] | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    healthPacks?: HealthPack[] | undefined;
    titles?: Title[] | undefined;
    unitPricePerDogSubActivities?: SubActivity[] | undefined;
    unitFciPricePerDogSubActivities?: SubActivity[] | undefined;
    fciTaxSubActivities?: SubActivity[] | undefined;
    cacTaxSubActivities?: SubActivity[] | undefined;
    classicTaxSubActivities?: SubActivity[] | undefined;
    extraTaxSubActivities?: SubActivity[] | undefined;
    participationTaxSubActivities?: SubActivity[] | undefined;
    participationFciTaxSubActivities?: SubActivity[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ArticleTranslation implements IArticleTranslation {
    articleTranslationId?: number;
    articleId?: number;
    languageId?: number;
    text?: string | undefined;
    article?: Article | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IArticleTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleTranslationId = _data["articleTranslationId"];
            this.articleId = _data["articleId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ArticleTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTranslationId"] = this.articleTranslationId;
        data["articleId"] = this.articleId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IArticleTranslation {
    articleTranslationId?: number;
    articleId?: number;
    languageId?: number;
    text?: string | undefined;
    article?: Article | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class WorkbookType implements IWorkbookType {
    workbookTypeId?: number;
    workbookColorId?: number;
    hasPedigree?: boolean;
    articleId?: number | undefined;
    isSticker?: boolean;
    template?: EDocumentTemplate | undefined;
    sociabilityTest?: boolean;
    canGiveWorkCertificate?: boolean;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    workbookColor?: WorkbookColor | undefined;
    article?: Article | undefined;
    workbooks?: Workbook[] | undefined;
    breedsWorkbookTypes?: BreedWorkbookType[] | undefined;
    workbookTypeTranslations?: WorkbookTypeTranslation[] | undefined;
    transientWorkbooks?: TransientWorkbook[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkbookType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeId = _data["workbookTypeId"];
            this.workbookColorId = _data["workbookColorId"];
            this.hasPedigree = _data["hasPedigree"];
            this.articleId = _data["articleId"];
            this.isSticker = _data["isSticker"];
            this.template = _data["template"];
            this.sociabilityTest = _data["sociabilityTest"];
            this.canGiveWorkCertificate = _data["canGiveWorkCertificate"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.workbookColor = _data["workbookColor"] ? WorkbookColor.fromJS(_data["workbookColor"]) : <any>undefined;
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            if (Array.isArray(_data["workbooks"])) {
                this.workbooks = [] as any;
                for (let item of _data["workbooks"])
                    this.workbooks!.push(Workbook.fromJS(item));
            }
            if (Array.isArray(_data["breedsWorkbookTypes"])) {
                this.breedsWorkbookTypes = [] as any;
                for (let item of _data["breedsWorkbookTypes"])
                    this.breedsWorkbookTypes!.push(BreedWorkbookType.fromJS(item));
            }
            if (Array.isArray(_data["workbookTypeTranslations"])) {
                this.workbookTypeTranslations = [] as any;
                for (let item of _data["workbookTypeTranslations"])
                    this.workbookTypeTranslations!.push(WorkbookTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["transientWorkbooks"])) {
                this.transientWorkbooks = [] as any;
                for (let item of _data["transientWorkbooks"])
                    this.transientWorkbooks!.push(TransientWorkbook.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WorkbookType {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeId"] = this.workbookTypeId;
        data["workbookColorId"] = this.workbookColorId;
        data["hasPedigree"] = this.hasPedigree;
        data["articleId"] = this.articleId;
        data["isSticker"] = this.isSticker;
        data["template"] = this.template;
        data["sociabilityTest"] = this.sociabilityTest;
        data["canGiveWorkCertificate"] = this.canGiveWorkCertificate;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["workbookColor"] = this.workbookColor ? this.workbookColor.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        if (Array.isArray(this.workbooks)) {
            data["workbooks"] = [];
            for (let item of this.workbooks)
                data["workbooks"].push(item.toJSON());
        }
        if (Array.isArray(this.breedsWorkbookTypes)) {
            data["breedsWorkbookTypes"] = [];
            for (let item of this.breedsWorkbookTypes)
                data["breedsWorkbookTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.workbookTypeTranslations)) {
            data["workbookTypeTranslations"] = [];
            for (let item of this.workbookTypeTranslations)
                data["workbookTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.transientWorkbooks)) {
            data["transientWorkbooks"] = [];
            for (let item of this.transientWorkbooks)
                data["transientWorkbooks"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkbookType {
    workbookTypeId?: number;
    workbookColorId?: number;
    hasPedigree?: boolean;
    articleId?: number | undefined;
    isSticker?: boolean;
    template?: EDocumentTemplate | undefined;
    sociabilityTest?: boolean;
    canGiveWorkCertificate?: boolean;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    workbookColor?: WorkbookColor | undefined;
    article?: Article | undefined;
    workbooks?: Workbook[] | undefined;
    breedsWorkbookTypes?: BreedWorkbookType[] | undefined;
    workbookTypeTranslations?: WorkbookTypeTranslation[] | undefined;
    transientWorkbooks?: TransientWorkbook[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDocumentTemplate {
    ANNEX = "ANNEX",
    PedigreeDuplicataRequestTemplate = "PedigreeDuplicataRequestTemplate",
    FCI = "FCI",
    WORKBOOKEXECUTION = "WORKBOOKEXECUTION",
    KENNELMISSINGINFO = "KENNELMISSINGINFO",
    KENNELNEWPROPOSALS = "KENNELNEWPROPOSALS",
    KENNELAPPROVED = "KENNELAPPROVED",
    WORKATTEST = "WORKATTEST",
    TEMPOWNERAPPROVED = "TEMPOWNERAPPROVED",
    IMPORTAPPROVED = "IMPORTAPPROVED",
    HEALTHTESTFINISHED = "HEALTHTESTFINISHED",
    TITLE_APPROVED_FOR_FOREIGN_CONTACT = "TITLE_APPROVED_FOR_FOREIGN_CONTACT",
    TITLE_APPROVED_FOR_BELGIAN_CONTACT = "TITLE_APPROVED_FOR_BELGIAN_CONTACT",
    BELGIANJUDGESGRANTED = "BELGIANJUDGESGRANTED",
    BELGIANJUDGESREFUSED = "BELGIANJUDGESREFUSED",
    RSHAPPROVED = "RSHAPPROVED",
    RSH_EXPORT_ATTEST = "RSH_EXPORT_ATTEST",
    IMPORT_ATTEST = "IMPORT_ATTEST",
    RSH_EXPORT_ATTEST_EXPORT = "RSH_EXPORT_ATTEST_EXPORT",
    FOREIGNJUDGESREFUSED = "FOREIGNJUDGESREFUSED",
    FOREIGNJUDGESGRANTED = "FOREIGNJUDGESGRANTED",
    CARDMEMBERSENT = "CARDMEMBERSENT",
    MEMBERCARD = "MEMBERCARD",
    MEMBERAPPROVED = "MEMBERAPPROVED",
    MEMBERREFUSED = "MEMBERREFUSED",
    MEMBERREQUESTED = "MEMBERREQUESTED",
    MODIFIEDMEMBERSHIPAPPROVED = "MODIFIEDMEMBERSHIPAPPROVED",
    APPEAL_COMMISSION_CERTIFICATE_MALE = "APPEAL_COMMISSION_CERTIFICATE_MALE",
    APPEAL_COMMISSION_CERTIFICATE_FEMALE = "APPEAL_COMMISSION_CERTIFICATE_FEMALE",
    GENT_COMMISSION_CERTIFICATE_MALE = "GENT_COMMISSION_CERTIFICATE_MALE",
    GENT_COMMISSION_CERTIFICATE_FEMALE = "GENT_COMMISSION_CERTIFICATE_FEMALE",
    CLASSIC_COMMISSION_CERTIFICATE_MALE = "CLASSIC_COMMISSION_CERTIFICATE_MALE",
    CLASSIC_COMMISSION_CERTIFICATE_FEMALE = "CLASSIC_COMMISSION_CERTIFICATE_FEMALE",
    RISH_APPROVED = "RISH_APPROVED",
    PUPPIES_DATA = "PUPPIES_DATA",
    COMPETITION_CAC_GRANTED = "COMPETITION_CAC_GRANTED",
    COMPETITION_CACGROUP_GRANTED = "COMPETITION_CACGROUP_GRANTED",
    COMPETITION_CACIAG_GRANTED = "COMPETITION_CACIAG_GRANTED",
    COMPETITION_CAC_IOB4D_GRANTED = "COMPETITION_CAC_IOB4D_GRANTED",
    COMPETITION_CLUBMATCH4A_GRANTED = "COMPETITION_CLUBMATCH4A_GRANTED",
    COMPETITION_COURSING_RACING_CACBL_GRANTED = "COMPETITION_COURSING_RACING_CACBL_GRANTED",
    COMPETITION_CACITWITHSEVERALSECTIONS_GRANTED = "COMPETITION_CACITWITHSEVERALSECTIONS_GRANTED",
    COMPETITION_DEFINITIVE_CACCACIB_GRANTED = "COMPETITION_DEFINITIVE_CACCACIB_GRANTED",
    COMPETITION_COURSINGRACING_GRANTED = "COMPETITION_COURSINGRACING_GRANTED",
    COMPETITION_CAC_SPECIAL_BREEDS = "COMPETITION_CAC_SPECIAL_BREEDS",
    COMPETITION_TEMPCACCACIB_GRANTED = "COMPETITION_TEMPCACCACIB_GRANTED",
    COMPETITION_WGH_GRANTED = "COMPETITION_WGH_GRANTED",
    COMPETITION_GRANTED = "COMPETITION_GRANTED",
    COMPETITION_RACINGCACIL_GRANTED = "COMPETITION_RACINGCACIL_GRANTED",
    SECTION_CAC = "SECTION_CAC",
    WORKATTEST_MISSING_INFO = "WORKATTEST_MISSING_INFO",
    IMPORT_MISSING_INFO = "IMPORT_MISSING_INFO",
    RSH_MISSING_INFO = "RSH_MISSING_INFO",
    WORKBOOK_MISSING_INFO = "WORKBOOK_MISSING_INFO",
    DIPLOMA_BELIGUM = "DIPLOMA_BELIGUM",
    DIPLOMA_BELIGUM_WORK = "DIPLOMA_BELIGUM_WORK",
    DIPLOMA_LEVRIER_COURSING = "DIPLOMA_LEVRIER_COURSING",
    DIPLOMA_LEVRIER_RACING = "DIPLOMA_LEVRIER_RACING",
    DIPLOMA_OLD = "DIPLOMA_OLD",
    DIPLOMA_YOUNG = "DIPLOMA_YOUNG",
    KENNEL_MISSING_INFO = "KENNEL_MISSING_INFO",
    BROOD_MISSING_INFO = "BROOD_MISSING_INFO",
    WORKBOOK_BLUE_PEDIGREE = "WORKBOOK_BLUE_PEDIGREE",
    WORKBOOK_BLUE_NO_PEDIGREE = "WORKBOOK_BLUE_NO_PEDIGREE",
    WORKBOOK_LIGHT_BLUE_PEDIGREE = "WORKBOOK_LIGHT_BLUE_PEDIGREE",
    WORKBOOK_LIGHT_BLUE_NO_PEDIGREE = "WORKBOOK_LIGHT_BLUE_NO_PEDIGREE",
    WORKBOOK_GREEN_PEDIGREE = "WORKBOOK_GREEN_PEDIGREE",
    WORKBOOK_GREEN_NO_PEDIGREE = "WORKBOOK_GREEN_NO_PEDIGREE",
    WORKBOOK_PURPLE_PEDIGREE = "WORKBOOK_PURPLE_PEDIGREE",
    WORKBOOK_PURPLE_NO_PEDIGREE = "WORKBOOK_PURPLE_NO_PEDIGREE",
    WORKBOOK_RED_PEDIGREE = "WORKBOOK_RED_PEDIGREE",
    WORKBOOK_RED_NO_PEDIGREE = "WORKBOOK_RED_NO_PEDIGREE",
    WORKBOOK_ORANGE_PEDIGREE = "WORKBOOK_ORANGE_PEDIGREE",
    WORKBOOK_ORANGE_NO_PEDIGREE = "WORKBOOK_ORANGE_NO_PEDIGREE",
    WORKBOOK_WHITE_PEDIGREE = "WORKBOOK_WHITE_PEDIGREE",
    WORKBOOK_STICKER = "WORKBOOK_STICKER",
    WORKBOOK_STICKER_WITH_PEDIGREE = "WORKBOOK_STICKER_WITH_PEDIGREE",
    DYSPLASIAEXECUTION = "DYSPLASIAEXECUTION",
    PEDIGREE_NORMAL = "PEDIGREE_NORMAL",
    PEDIGREE_NORMAL_ELITE = "PEDIGREE_NORMAL_ELITE",
    PEDIGREE_EXPORT = "PEDIGREE_EXPORT",
    PEDIGREE_RISH_NORMAL = "PEDIGREE_RISH_NORMAL",
    PEDIGREE_RISH_ELITE = "PEDIGREE_RISH_ELITE",
    PEDIGREE_NORMAL_NO_FCI = "PEDIGREE_NORMAL_NO_FCI",
    PEDIGREE_NORMAL_ELITE_NO_FCI = "PEDIGREE_NORMAL_ELITE_NO_FCI",
    PEDIGREE_EXPORT_NO_FCI = "PEDIGREE_EXPORT_NO_FCI",
    PEDIGREE_RISH_BRCS = "PEDIGREE_RISH_BRCS",
    BILL = "BILL",
    BROODREQUESTCERTIFICATE = "BROODREQUESTCERTIFICATE",
    COMPETITION_CAC_CACIB_GRANTED = "COMPETITION_CAC_CACIB_GRANTED",
    HEALTH_TEST_CERTIFICATE = "HEALTH_TEST_CERTIFICATE",
    CAC_CERTIFICATE = "CAC_CERTIFICATE",
    BROOD_REQUEST_EXECUTION = "BROOD_REQUEST_EXECUTION",
    BROOD_REQUEST_BRCS_EXECUTION = "BROOD_REQUEST_BRCS_EXECUTION",
    DNA_CERTIFICATE = "DNA_CERTIFICATE",
    DIPLOMA_BELGIUM_EXPO = "DIPLOMA_BELGIUM_EXPO",
    DIPLOMA_FULL_BELGIUM = "DIPLOMA_FULL_BELGIUM",
    COMPETITION_MISSING_INFO = "COMPETITION_MISSING_INFO",
    TITLE_MISSING_INFO = "TITLE_MISSING_INFO",
    PEDIGREE_SAMPLE = "PEDIGREE_SAMPLE",
    DUPLICATA_REQUEST_EXECUTION = "DUPLICATA_REQUEST_EXECUTION",
    COMMISSIONER_ATTESTATION = "COMMISSIONER_ATTESTATION",
    PEDIGREE_BRCS_SAMPLE = "PEDIGREE_BRCS_SAMPLE",
}

export class WorkbookColor implements IWorkbookColor {
    workbookColorId?: number;
    colorEnumCode?: EWorkbookColor;
    code?: string | undefined;
    workbookTypes?: WorkbookType[] | undefined;
    workbookColorTranslations?: WorkbookColorTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkbookColor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookColorId = _data["workbookColorId"];
            this.colorEnumCode = _data["colorEnumCode"];
            this.code = _data["code"];
            if (Array.isArray(_data["workbookTypes"])) {
                this.workbookTypes = [] as any;
                for (let item of _data["workbookTypes"])
                    this.workbookTypes!.push(WorkbookType.fromJS(item));
            }
            if (Array.isArray(_data["workbookColorTranslations"])) {
                this.workbookColorTranslations = [] as any;
                for (let item of _data["workbookColorTranslations"])
                    this.workbookColorTranslations!.push(WorkbookColorTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WorkbookColor {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookColor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookColorId"] = this.workbookColorId;
        data["colorEnumCode"] = this.colorEnumCode;
        data["code"] = this.code;
        if (Array.isArray(this.workbookTypes)) {
            data["workbookTypes"] = [];
            for (let item of this.workbookTypes)
                data["workbookTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.workbookColorTranslations)) {
            data["workbookColorTranslations"] = [];
            for (let item of this.workbookColorTranslations)
                data["workbookColorTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkbookColor {
    workbookColorId?: number;
    colorEnumCode?: EWorkbookColor;
    code?: string | undefined;
    workbookTypes?: WorkbookType[] | undefined;
    workbookColorTranslations?: WorkbookColorTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EWorkbookColor {
    Blue = "Blue",
    Red = "Red",
    Orange = "Orange",
    Green = "Green",
    Lime = "Lime",
    Purple = "Purple",
    LightBlue = "LightBlue",
    White = "White",
    Yellow = "Yellow",
}

export class WorkbookColorTranslation implements IWorkbookColorTranslation {
    workbookColorTranslationId?: number;
    workbookColorId?: number;
    languageId?: number;
    text?: string | undefined;
    workbookColor?: WorkbookColor | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkbookColorTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookColorTranslationId = _data["workbookColorTranslationId"];
            this.workbookColorId = _data["workbookColorId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.workbookColor = _data["workbookColor"] ? WorkbookColor.fromJS(_data["workbookColor"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WorkbookColorTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookColorTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookColorTranslationId"] = this.workbookColorTranslationId;
        data["workbookColorId"] = this.workbookColorId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["workbookColor"] = this.workbookColor ? this.workbookColor.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkbookColorTranslation {
    workbookColorTranslationId?: number;
    workbookColorId?: number;
    languageId?: number;
    text?: string | undefined;
    workbookColor?: WorkbookColor | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Workbook implements IWorkbook {
    workbookId?: number;
    workbookTypeId?: number;
    dogId?: number;
    identifier?: number | undefined;
    counter?: number | undefined;
    deliveredOn?: Date | undefined;
    dog?: Dog | undefined;
    workbookType?: WorkbookType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkbook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookId = _data["workbookId"];
            this.workbookTypeId = _data["workbookTypeId"];
            this.dogId = _data["dogId"];
            this.identifier = _data["identifier"];
            this.counter = _data["counter"];
            this.deliveredOn = _data["deliveredOn"] ? new Date(_data["deliveredOn"].toString()) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.workbookType = _data["workbookType"] ? WorkbookType.fromJS(_data["workbookType"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Workbook {
        data = typeof data === 'object' ? data : {};
        let result = new Workbook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookId"] = this.workbookId;
        data["workbookTypeId"] = this.workbookTypeId;
        data["dogId"] = this.dogId;
        data["identifier"] = this.identifier;
        data["counter"] = this.counter;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["workbookType"] = this.workbookType ? this.workbookType.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkbook {
    workbookId?: number;
    workbookTypeId?: number;
    dogId?: number;
    identifier?: number | undefined;
    counter?: number | undefined;
    deliveredOn?: Date | undefined;
    dog?: Dog | undefined;
    workbookType?: WorkbookType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedWorkbookType implements IBreedWorkbookType {
    breedWorkbookTypeId?: number;
    breedId?: number;
    workbookTypeId?: number;
    breed?: Breed | undefined;
    workbookType?: WorkbookType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedWorkbookType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedWorkbookTypeId = _data["breedWorkbookTypeId"];
            this.breedId = _data["breedId"];
            this.workbookTypeId = _data["workbookTypeId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.workbookType = _data["workbookType"] ? WorkbookType.fromJS(_data["workbookType"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedWorkbookType {
        data = typeof data === 'object' ? data : {};
        let result = new BreedWorkbookType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedWorkbookTypeId"] = this.breedWorkbookTypeId;
        data["breedId"] = this.breedId;
        data["workbookTypeId"] = this.workbookTypeId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["workbookType"] = this.workbookType ? this.workbookType.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedWorkbookType {
    breedWorkbookTypeId?: number;
    breedId?: number;
    workbookTypeId?: number;
    breed?: Breed | undefined;
    workbookType?: WorkbookType | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class WorkbookTypeTranslation implements IWorkbookTypeTranslation {
    workbookTypeTranslationId?: number;
    workbookTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    workbookType?: WorkbookType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkbookTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeTranslationId = _data["workbookTypeTranslationId"];
            this.workbookTypeId = _data["workbookTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.workbookType = _data["workbookType"] ? WorkbookType.fromJS(_data["workbookType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WorkbookTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeTranslationId"] = this.workbookTypeTranslationId;
        data["workbookTypeId"] = this.workbookTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["workbookType"] = this.workbookType ? this.workbookType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkbookTypeTranslation {
    workbookTypeTranslationId?: number;
    workbookTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    workbookType?: WorkbookType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientWorkbook implements ITransientWorkbook {
    transientWorkbookId?: number;
    identifier?: number | undefined;
    counter?: number;
    dogId?: number;
    workbookTypeId?: number;
    workbookRequestId?: number;
    dog?: Dog | undefined;
    workbookType?: WorkbookType | undefined;
    workbookRequest?: WorkbookRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITransientWorkbook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientWorkbookId = _data["transientWorkbookId"];
            this.identifier = _data["identifier"];
            this.counter = _data["counter"];
            this.dogId = _data["dogId"];
            this.workbookTypeId = _data["workbookTypeId"];
            this.workbookRequestId = _data["workbookRequestId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.workbookType = _data["workbookType"] ? WorkbookType.fromJS(_data["workbookType"]) : <any>undefined;
            this.workbookRequest = _data["workbookRequest"] ? WorkbookRequest.fromJS(_data["workbookRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TransientWorkbook {
        data = typeof data === 'object' ? data : {};
        let result = new TransientWorkbook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientWorkbookId"] = this.transientWorkbookId;
        data["identifier"] = this.identifier;
        data["counter"] = this.counter;
        data["dogId"] = this.dogId;
        data["workbookTypeId"] = this.workbookTypeId;
        data["workbookRequestId"] = this.workbookRequestId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["workbookType"] = this.workbookType ? this.workbookType.toJSON() : <any>undefined;
        data["workbookRequest"] = this.workbookRequest ? this.workbookRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITransientWorkbook {
    transientWorkbookId?: number;
    identifier?: number | undefined;
    counter?: number;
    dogId?: number;
    workbookTypeId?: number;
    workbookRequestId?: number;
    dog?: Dog | undefined;
    workbookType?: WorkbookType | undefined;
    workbookRequest?: WorkbookRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class WorkbookRequest implements IWorkbookRequest {
    workbookRequestId?: number;
    requestId?: number;
    clubId?: number | undefined;
    dogId?: number;
    registeredLetter?: boolean;
    request?: Request | undefined;
    club?: Club | undefined;
    dog?: Dog | undefined;
    transientWorkbooks?: TransientWorkbook[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkbookRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookRequestId = _data["workbookRequestId"];
            this.requestId = _data["requestId"];
            this.clubId = _data["clubId"];
            this.dogId = _data["dogId"];
            this.registeredLetter = _data["registeredLetter"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.club = _data["club"] ? Club.fromJS(_data["club"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            if (Array.isArray(_data["transientWorkbooks"])) {
                this.transientWorkbooks = [] as any;
                for (let item of _data["transientWorkbooks"])
                    this.transientWorkbooks!.push(TransientWorkbook.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WorkbookRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookRequestId"] = this.workbookRequestId;
        data["requestId"] = this.requestId;
        data["clubId"] = this.clubId;
        data["dogId"] = this.dogId;
        data["registeredLetter"] = this.registeredLetter;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        if (Array.isArray(this.transientWorkbooks)) {
            data["transientWorkbooks"] = [];
            for (let item of this.transientWorkbooks)
                data["transientWorkbooks"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkbookRequest {
    workbookRequestId?: number;
    requestId?: number;
    clubId?: number | undefined;
    dogId?: number;
    registeredLetter?: boolean;
    request?: Request | undefined;
    club?: Club | undefined;
    dog?: Dog | undefined;
    transientWorkbooks?: TransientWorkbook[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Club implements IClub {
    clubId?: number;
    languageId?: number;
    countryId?: number | undefined;
    terrainCountryId?: number | undefined;
    name?: string | undefined;
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    phoneNumber?: string | undefined;
    globalEmail?: string | undefined;
    websiteAddress?: string | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    provisionalNumber?: string | undefined;
    provisionalNumberDate?: Date | undefined;
    finalNumber?: string | undefined;
    finalNumberDate?: Date | undefined;
    remark?: string | undefined;
    bcIdentifier?: string | undefined;
    societyName?: string | undefined;
    noCompetitionInvoice?: boolean;
    terrainNumber?: string | undefined;
    terrainStreet?: string | undefined;
    terrainCity?: string | undefined;
    terrainPostalCode?: string | undefined;
    terrainProvince?: string | undefined;
    cegekaId?: string | undefined;
    terrainCountry?: Country | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    clubsBreeds?: ClubBreed[] | undefined;
    workbookRequests?: WorkbookRequest[] | undefined;
    clubsSections?: ClubSection[] | undefined;
    clubsContacts?: ClubContact[] | undefined;
    clubRoleTranslations?: ClubRoleTranslation[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    judgesForClub?: JudgesForClub[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;

    constructor(data?: IClub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.languageId = _data["languageId"];
            this.countryId = _data["countryId"];
            this.terrainCountryId = _data["terrainCountryId"];
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.accountNumber = _data["accountNumber"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.phoneNumber = _data["phoneNumber"];
            this.globalEmail = _data["globalEmail"];
            this.websiteAddress = _data["websiteAddress"];
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionStartDate = _data["exclusionStartDate"] ? new Date(_data["exclusionStartDate"].toString()) : <any>undefined;
            this.exclusionEndDate = _data["exclusionEndDate"] ? new Date(_data["exclusionEndDate"].toString()) : <any>undefined;
            this.provisionalNumber = _data["provisionalNumber"];
            this.provisionalNumberDate = _data["provisionalNumberDate"] ? new Date(_data["provisionalNumberDate"].toString()) : <any>undefined;
            this.finalNumber = _data["finalNumber"];
            this.finalNumberDate = _data["finalNumberDate"] ? new Date(_data["finalNumberDate"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.bcIdentifier = _data["bcIdentifier"];
            this.societyName = _data["societyName"];
            this.noCompetitionInvoice = _data["noCompetitionInvoice"];
            this.terrainNumber = _data["terrainNumber"];
            this.terrainStreet = _data["terrainStreet"];
            this.terrainCity = _data["terrainCity"];
            this.terrainPostalCode = _data["terrainPostalCode"];
            this.terrainProvince = _data["terrainProvince"];
            this.cegekaId = _data["cegekaId"];
            this.terrainCountry = _data["terrainCountry"] ? Country.fromJS(_data["terrainCountry"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["clubsBreeds"])) {
                this.clubsBreeds = [] as any;
                for (let item of _data["clubsBreeds"])
                    this.clubsBreeds!.push(ClubBreed.fromJS(item));
            }
            if (Array.isArray(_data["workbookRequests"])) {
                this.workbookRequests = [] as any;
                for (let item of _data["workbookRequests"])
                    this.workbookRequests!.push(WorkbookRequest.fromJS(item));
            }
            if (Array.isArray(_data["clubsSections"])) {
                this.clubsSections = [] as any;
                for (let item of _data["clubsSections"])
                    this.clubsSections!.push(ClubSection.fromJS(item));
            }
            if (Array.isArray(_data["clubsContacts"])) {
                this.clubsContacts = [] as any;
                for (let item of _data["clubsContacts"])
                    this.clubsContacts!.push(ClubContact.fromJS(item));
            }
            if (Array.isArray(_data["clubRoleTranslations"])) {
                this.clubRoleTranslations = [] as any;
                for (let item of _data["clubRoleTranslations"])
                    this.clubRoleTranslations!.push(ClubRoleTranslation.fromJS(item));
            }
            if (Array.isArray(_data["competitionRequests"])) {
                this.competitionRequests = [] as any;
                for (let item of _data["competitionRequests"])
                    this.competitionRequests!.push(CompetitionRequest.fromJS(item));
            }
            if (Array.isArray(_data["judgesForClub"])) {
                this.judgesForClub = [] as any;
                for (let item of _data["judgesForClub"])
                    this.judgesForClub!.push(JudgesForClub.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): Club {
        data = typeof data === 'object' ? data : {};
        let result = new Club();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["languageId"] = this.languageId;
        data["countryId"] = this.countryId;
        data["terrainCountryId"] = this.terrainCountryId;
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["accountNumber"] = this.accountNumber;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["phoneNumber"] = this.phoneNumber;
        data["globalEmail"] = this.globalEmail;
        data["websiteAddress"] = this.websiteAddress;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionStartDate"] = this.exclusionStartDate ? this.exclusionStartDate.toISOString() : <any>undefined;
        data["exclusionEndDate"] = this.exclusionEndDate ? this.exclusionEndDate.toISOString() : <any>undefined;
        data["provisionalNumber"] = this.provisionalNumber;
        data["provisionalNumberDate"] = this.provisionalNumberDate ? this.provisionalNumberDate.toISOString() : <any>undefined;
        data["finalNumber"] = this.finalNumber;
        data["finalNumberDate"] = this.finalNumberDate ? this.finalNumberDate.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["bcIdentifier"] = this.bcIdentifier;
        data["societyName"] = this.societyName;
        data["noCompetitionInvoice"] = this.noCompetitionInvoice;
        data["terrainNumber"] = this.terrainNumber;
        data["terrainStreet"] = this.terrainStreet;
        data["terrainCity"] = this.terrainCity;
        data["terrainPostalCode"] = this.terrainPostalCode;
        data["terrainProvince"] = this.terrainProvince;
        data["cegekaId"] = this.cegekaId;
        data["terrainCountry"] = this.terrainCountry ? this.terrainCountry.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.clubsBreeds)) {
            data["clubsBreeds"] = [];
            for (let item of this.clubsBreeds)
                data["clubsBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.workbookRequests)) {
            data["workbookRequests"] = [];
            for (let item of this.workbookRequests)
                data["workbookRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.clubsSections)) {
            data["clubsSections"] = [];
            for (let item of this.clubsSections)
                data["clubsSections"].push(item.toJSON());
        }
        if (Array.isArray(this.clubsContacts)) {
            data["clubsContacts"] = [];
            for (let item of this.clubsContacts)
                data["clubsContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.clubRoleTranslations)) {
            data["clubRoleTranslations"] = [];
            for (let item of this.clubRoleTranslations)
                data["clubRoleTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionRequests)) {
            data["competitionRequests"] = [];
            for (let item of this.competitionRequests)
                data["competitionRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.judgesForClub)) {
            data["judgesForClub"] = [];
            for (let item of this.judgesForClub)
                data["judgesForClub"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface IClub {
    clubId?: number;
    languageId?: number;
    countryId?: number | undefined;
    terrainCountryId?: number | undefined;
    name?: string | undefined;
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    phoneNumber?: string | undefined;
    globalEmail?: string | undefined;
    websiteAddress?: string | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    provisionalNumber?: string | undefined;
    provisionalNumberDate?: Date | undefined;
    finalNumber?: string | undefined;
    finalNumberDate?: Date | undefined;
    remark?: string | undefined;
    bcIdentifier?: string | undefined;
    societyName?: string | undefined;
    noCompetitionInvoice?: boolean;
    terrainNumber?: string | undefined;
    terrainStreet?: string | undefined;
    terrainCity?: string | undefined;
    terrainPostalCode?: string | undefined;
    terrainProvince?: string | undefined;
    cegekaId?: string | undefined;
    terrainCountry?: Country | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    clubsBreeds?: ClubBreed[] | undefined;
    workbookRequests?: WorkbookRequest[] | undefined;
    clubsSections?: ClubSection[] | undefined;
    clubsContacts?: ClubContact[] | undefined;
    clubRoleTranslations?: ClubRoleTranslation[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    judgesForClub?: JudgesForClub[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;
}

export class ClubBreed implements IClubBreed {
    clubBreedId?: number;
    clubId?: number;
    breedId?: number;
    club?: Club | undefined;
    breed?: Breed | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClubBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubBreedId = _data["clubBreedId"];
            this.clubId = _data["clubId"];
            this.breedId = _data["breedId"];
            this.club = _data["club"] ? Club.fromJS(_data["club"]) : <any>undefined;
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClubBreed {
        data = typeof data === 'object' ? data : {};
        let result = new ClubBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubBreedId"] = this.clubBreedId;
        data["clubId"] = this.clubId;
        data["breedId"] = this.breedId;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClubBreed {
    clubBreedId?: number;
    clubId?: number;
    breedId?: number;
    club?: Club | undefined;
    breed?: Breed | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ClubSection implements IClubSection {
    clubSectionId?: number;
    clubId?: number;
    sectionId?: number;
    contactEmails?: string | undefined;
    club?: Club | undefined;
    section?: Section | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClubSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubSectionId = _data["clubSectionId"];
            this.clubId = _data["clubId"];
            this.sectionId = _data["sectionId"];
            this.contactEmails = _data["contactEmails"];
            this.club = _data["club"] ? Club.fromJS(_data["club"]) : <any>undefined;
            this.section = _data["section"] ? Section.fromJS(_data["section"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClubSection {
        data = typeof data === 'object' ? data : {};
        let result = new ClubSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubSectionId"] = this.clubSectionId;
        data["clubId"] = this.clubId;
        data["sectionId"] = this.sectionId;
        data["contactEmails"] = this.contactEmails;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClubSection {
    clubSectionId?: number;
    clubId?: number;
    sectionId?: number;
    contactEmails?: string | undefined;
    club?: Club | undefined;
    section?: Section | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Section implements ISection {
    sectionId?: number;
    code?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    isWork?: boolean;
    isBeauty?: boolean;
    isTabletAuthorized?: boolean;
    sendExcelByEmail?: boolean;
    activities?: Activity[] | undefined;
    clubsSections?: ClubSection[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ISection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.code = _data["code"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.isWork = _data["isWork"];
            this.isBeauty = _data["isBeauty"];
            this.isTabletAuthorized = _data["isTabletAuthorized"];
            this.sendExcelByEmail = _data["sendExcelByEmail"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(Activity.fromJS(item));
            }
            if (Array.isArray(_data["clubsSections"])) {
                this.clubsSections = [] as any;
                for (let item of _data["clubsSections"])
                    this.clubsSections!.push(ClubSection.fromJS(item));
            }
            if (Array.isArray(_data["competitionRequests"])) {
                this.competitionRequests = [] as any;
                for (let item of _data["competitionRequests"])
                    this.competitionRequests!.push(CompetitionRequest.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Section {
        data = typeof data === 'object' ? data : {};
        let result = new Section();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["code"] = this.code;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["isWork"] = this.isWork;
        data["isBeauty"] = this.isBeauty;
        data["isTabletAuthorized"] = this.isTabletAuthorized;
        data["sendExcelByEmail"] = this.sendExcelByEmail;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        if (Array.isArray(this.clubsSections)) {
            data["clubsSections"] = [];
            for (let item of this.clubsSections)
                data["clubsSections"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionRequests)) {
            data["competitionRequests"] = [];
            for (let item of this.competitionRequests)
                data["competitionRequests"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISection {
    sectionId?: number;
    code?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    isWork?: boolean;
    isBeauty?: boolean;
    isTabletAuthorized?: boolean;
    sendExcelByEmail?: boolean;
    activities?: Activity[] | undefined;
    clubsSections?: ClubSection[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Activity implements IActivity {
    activityId?: number;
    sectionId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    section?: Section | undefined;
    subActivities?: SubActivity[] | undefined;
    activityTranslations?: ActivityTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.sectionId = _data["sectionId"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.section = _data["section"] ? Section.fromJS(_data["section"]) : <any>undefined;
            if (Array.isArray(_data["subActivities"])) {
                this.subActivities = [] as any;
                for (let item of _data["subActivities"])
                    this.subActivities!.push(SubActivity.fromJS(item));
            }
            if (Array.isArray(_data["activityTranslations"])) {
                this.activityTranslations = [] as any;
                for (let item of _data["activityTranslations"])
                    this.activityTranslations!.push(ActivityTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["sectionId"] = this.sectionId;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        if (Array.isArray(this.subActivities)) {
            data["subActivities"] = [];
            for (let item of this.subActivities)
                data["subActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.activityTranslations)) {
            data["activityTranslations"] = [];
            for (let item of this.activityTranslations)
                data["activityTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IActivity {
    activityId?: number;
    sectionId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    section?: Section | undefined;
    subActivities?: SubActivity[] | undefined;
    activityTranslations?: ActivityTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class SubActivity implements ISubActivity {
    subActivityId?: number;
    activityId?: number;
    remark?: string | undefined;
    clubMatch?: boolean;
    cegekaId?: string | undefined;
    fciTax?: boolean;
    participationFciTax?: boolean;
    showOnPortal?: boolean;
    showType?: string | undefined;
    billingType?: EBillingType | undefined;
    unitPricePerDogArticleId?: number | undefined;
    unitFciPricePerDogArticleId?: number | undefined;
    fciTaxArticleId?: number | undefined;
    cacTaxArticleId?: number | undefined;
    classicTaxArticleId?: number | undefined;
    extraTaxArticleId?: number | undefined;
    participationTaxArticleId?: number | undefined;
    participationFciTaxArticleId?: number | undefined;
    documentType?: ECompetitionDocumentType | undefined;
    cacCacibDocumentTypes?: ECacDocumentType | undefined;
    cacDocumentType?: ESectionCacType | undefined;
    activity?: Activity | undefined;
    participationFciTaxArticle?: Article | undefined;
    unitPricePerDogArticle?: Article | undefined;
    unitFciPricePerDogArticle?: Article | undefined;
    fciTaxArticle?: Article | undefined;
    cacTaxArticle?: Article | undefined;
    classicTaxArticle?: Article | undefined;
    extraTaxArticle?: Article | undefined;
    participationTaxArticle?: Article | undefined;
    subActivityTranslations?: SubActivityTranslation[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    subActivitiesJudges?: SubActivityJudge[] | undefined;
    expos?: Expo[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ISubActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivityId = _data["subActivityId"];
            this.activityId = _data["activityId"];
            this.remark = _data["remark"];
            this.clubMatch = _data["clubMatch"];
            this.cegekaId = _data["cegekaId"];
            this.fciTax = _data["fciTax"];
            this.participationFciTax = _data["participationFciTax"];
            this.showOnPortal = _data["showOnPortal"];
            this.showType = _data["showType"];
            this.billingType = _data["billingType"];
            this.unitPricePerDogArticleId = _data["unitPricePerDogArticleId"];
            this.unitFciPricePerDogArticleId = _data["unitFciPricePerDogArticleId"];
            this.fciTaxArticleId = _data["fciTaxArticleId"];
            this.cacTaxArticleId = _data["cacTaxArticleId"];
            this.classicTaxArticleId = _data["classicTaxArticleId"];
            this.extraTaxArticleId = _data["extraTaxArticleId"];
            this.participationTaxArticleId = _data["participationTaxArticleId"];
            this.participationFciTaxArticleId = _data["participationFciTaxArticleId"];
            this.documentType = _data["documentType"];
            this.cacCacibDocumentTypes = _data["cacCacibDocumentTypes"];
            this.cacDocumentType = _data["cacDocumentType"];
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
            this.participationFciTaxArticle = _data["participationFciTaxArticle"] ? Article.fromJS(_data["participationFciTaxArticle"]) : <any>undefined;
            this.unitPricePerDogArticle = _data["unitPricePerDogArticle"] ? Article.fromJS(_data["unitPricePerDogArticle"]) : <any>undefined;
            this.unitFciPricePerDogArticle = _data["unitFciPricePerDogArticle"] ? Article.fromJS(_data["unitFciPricePerDogArticle"]) : <any>undefined;
            this.fciTaxArticle = _data["fciTaxArticle"] ? Article.fromJS(_data["fciTaxArticle"]) : <any>undefined;
            this.cacTaxArticle = _data["cacTaxArticle"] ? Article.fromJS(_data["cacTaxArticle"]) : <any>undefined;
            this.classicTaxArticle = _data["classicTaxArticle"] ? Article.fromJS(_data["classicTaxArticle"]) : <any>undefined;
            this.extraTaxArticle = _data["extraTaxArticle"] ? Article.fromJS(_data["extraTaxArticle"]) : <any>undefined;
            this.participationTaxArticle = _data["participationTaxArticle"] ? Article.fromJS(_data["participationTaxArticle"]) : <any>undefined;
            if (Array.isArray(_data["subActivityTranslations"])) {
                this.subActivityTranslations = [] as any;
                for (let item of _data["subActivityTranslations"])
                    this.subActivityTranslations!.push(SubActivityTranslation.fromJS(item));
            }
            if (Array.isArray(_data["competitionRequests"])) {
                this.competitionRequests = [] as any;
                for (let item of _data["competitionRequests"])
                    this.competitionRequests!.push(CompetitionRequest.fromJS(item));
            }
            if (Array.isArray(_data["subActivitiesJudges"])) {
                this.subActivitiesJudges = [] as any;
                for (let item of _data["subActivitiesJudges"])
                    this.subActivitiesJudges!.push(SubActivityJudge.fromJS(item));
            }
            if (Array.isArray(_data["expos"])) {
                this.expos = [] as any;
                for (let item of _data["expos"])
                    this.expos!.push(Expo.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SubActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivityId"] = this.subActivityId;
        data["activityId"] = this.activityId;
        data["remark"] = this.remark;
        data["clubMatch"] = this.clubMatch;
        data["cegekaId"] = this.cegekaId;
        data["fciTax"] = this.fciTax;
        data["participationFciTax"] = this.participationFciTax;
        data["showOnPortal"] = this.showOnPortal;
        data["showType"] = this.showType;
        data["billingType"] = this.billingType;
        data["unitPricePerDogArticleId"] = this.unitPricePerDogArticleId;
        data["unitFciPricePerDogArticleId"] = this.unitFciPricePerDogArticleId;
        data["fciTaxArticleId"] = this.fciTaxArticleId;
        data["cacTaxArticleId"] = this.cacTaxArticleId;
        data["classicTaxArticleId"] = this.classicTaxArticleId;
        data["extraTaxArticleId"] = this.extraTaxArticleId;
        data["participationTaxArticleId"] = this.participationTaxArticleId;
        data["participationFciTaxArticleId"] = this.participationFciTaxArticleId;
        data["documentType"] = this.documentType;
        data["cacCacibDocumentTypes"] = this.cacCacibDocumentTypes;
        data["cacDocumentType"] = this.cacDocumentType;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["participationFciTaxArticle"] = this.participationFciTaxArticle ? this.participationFciTaxArticle.toJSON() : <any>undefined;
        data["unitPricePerDogArticle"] = this.unitPricePerDogArticle ? this.unitPricePerDogArticle.toJSON() : <any>undefined;
        data["unitFciPricePerDogArticle"] = this.unitFciPricePerDogArticle ? this.unitFciPricePerDogArticle.toJSON() : <any>undefined;
        data["fciTaxArticle"] = this.fciTaxArticle ? this.fciTaxArticle.toJSON() : <any>undefined;
        data["cacTaxArticle"] = this.cacTaxArticle ? this.cacTaxArticle.toJSON() : <any>undefined;
        data["classicTaxArticle"] = this.classicTaxArticle ? this.classicTaxArticle.toJSON() : <any>undefined;
        data["extraTaxArticle"] = this.extraTaxArticle ? this.extraTaxArticle.toJSON() : <any>undefined;
        data["participationTaxArticle"] = this.participationTaxArticle ? this.participationTaxArticle.toJSON() : <any>undefined;
        if (Array.isArray(this.subActivityTranslations)) {
            data["subActivityTranslations"] = [];
            for (let item of this.subActivityTranslations)
                data["subActivityTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionRequests)) {
            data["competitionRequests"] = [];
            for (let item of this.competitionRequests)
                data["competitionRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.subActivitiesJudges)) {
            data["subActivitiesJudges"] = [];
            for (let item of this.subActivitiesJudges)
                data["subActivitiesJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.expos)) {
            data["expos"] = [];
            for (let item of this.expos)
                data["expos"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISubActivity {
    subActivityId?: number;
    activityId?: number;
    remark?: string | undefined;
    clubMatch?: boolean;
    cegekaId?: string | undefined;
    fciTax?: boolean;
    participationFciTax?: boolean;
    showOnPortal?: boolean;
    showType?: string | undefined;
    billingType?: EBillingType | undefined;
    unitPricePerDogArticleId?: number | undefined;
    unitFciPricePerDogArticleId?: number | undefined;
    fciTaxArticleId?: number | undefined;
    cacTaxArticleId?: number | undefined;
    classicTaxArticleId?: number | undefined;
    extraTaxArticleId?: number | undefined;
    participationTaxArticleId?: number | undefined;
    participationFciTaxArticleId?: number | undefined;
    documentType?: ECompetitionDocumentType | undefined;
    cacCacibDocumentTypes?: ECacDocumentType | undefined;
    cacDocumentType?: ESectionCacType | undefined;
    activity?: Activity | undefined;
    participationFciTaxArticle?: Article | undefined;
    unitPricePerDogArticle?: Article | undefined;
    unitFciPricePerDogArticle?: Article | undefined;
    fciTaxArticle?: Article | undefined;
    cacTaxArticle?: Article | undefined;
    classicTaxArticle?: Article | undefined;
    extraTaxArticle?: Article | undefined;
    participationTaxArticle?: Article | undefined;
    subActivityTranslations?: SubActivityTranslation[] | undefined;
    competitionRequests?: CompetitionRequest[] | undefined;
    subActivitiesJudges?: SubActivityJudge[] | undefined;
    expos?: Expo[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EBillingType {
    CAC = "CAC",
    YoungAndVeteran = "YoungAndVeteran",
    NoCAC = "NoCAC",
    Other = "Other",
}

export enum ECompetitionDocumentType {
    CAC = "CAC",
    CAC_GROUP = "CAC_GROUP",
    CAC_IAG = "CAC_IAG",
    CAC_IO4D = "CAC_IO4D",
    CLUB_MATCH_4A = "CLUB_MATCH_4A",
    CAC_IT_WITH_SEVERAL_SECTIONS = "CAC_IT_WITH_SEVERAL_SECTIONS",
    TEMP_CAC_CACIB_GRANTED = "TEMP_CAC_CACIB_GRANTED",
    TEMP_CAC_CACIB = "TEMP_CAC_CACIB",
    CAC_SPECIAL_BREEDS = "CAC_SPECIAL_BREEDS",
    CAC_IOB4D = "CAC_IOB4D",
    COURSING_RACING_CACBL = "COURSING_RACING_CACBL",
    COURSING_RACING_CACBI = "COURSING_RACING_CACBI",
    COURSING_RACING = "COURSING_RACING",
    SPECIAL_BREEDS_COURSING = "SPECIAL_BREEDS_COURSING",
    WGH = "WGH",
    COMPETITION_GRANTED = "COMPETITION_GRANTED",
    DEFINITIVE_CAC_CACIB = "DEFINITIVE_CAC_CACIB",
    COURSING_RACING_CACIL = "COURSING_RACING_CACIL",
    CAC_CACIB = "CAC_CACIB",
}

export enum ECacDocumentType {
    TEMP_CAC_CACIB = "TEMP_CAC_CACIB",
    CacSection1B_1D = "CacSection1B_1D",
    CacSection1C = "CacSection1C",
}

export enum ESectionCacType {
    CacSection1C = "CacSection1C",
    CacSections1B_1D = "CacSections1B_1D",
}

export class SubActivityTranslation implements ISubActivityTranslation {
    subActivityTranslationId?: number;
    subActivityId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ISubActivityTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivityTranslationId = _data["subActivityTranslationId"];
            this.subActivityId = _data["subActivityId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SubActivityTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivityTranslationId"] = this.subActivityTranslationId;
        data["subActivityId"] = this.subActivityId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISubActivityTranslation {
    subActivityTranslationId?: number;
    subActivityId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CompetitionRequest implements ICompetitionRequest {
    competitionRequestId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    catalogReceptionDate?: Date | undefined;
    numberParticipants?: number;
    foreignCity?: string | undefined;
    clubEmail?: string | undefined;
    extra?: string | undefined;
    requestId?: number;
    sectionId?: number | undefined;
    subActivityId?: number;
    countryId?: number | undefined;
    postalCodeId?: number | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    clubId?: number;
    shouldDouble?: boolean;
    crufts?: boolean;
    myDogShowAuthorized?: boolean;
    useTablet?: boolean;
    myDogShowBilling?: boolean;
    personId?: number | undefined;
    person?: Person | undefined;
    request?: Request | undefined;
    section?: Section | undefined;
    club?: Club | undefined;
    subActivity?: SubActivity | undefined;
    country?: Country | undefined;
    postalCode?: PostalCode | undefined;
    competition?: Competition | undefined;
    competitionsJudges?: CompetitionJudge[] | undefined;
    competitionBreedGroups?: CompetitionBreedGroup[] | undefined;
    competitionBreeds?: CompetitionBreed[] | undefined;
    competitionCommissioners?: CompetitionCommissioner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionRequestId = _data["competitionRequestId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.catalogReceptionDate = _data["catalogReceptionDate"] ? new Date(_data["catalogReceptionDate"].toString()) : <any>undefined;
            this.numberParticipants = _data["numberParticipants"];
            this.foreignCity = _data["foreignCity"];
            this.clubEmail = _data["clubEmail"];
            this.extra = _data["extra"];
            this.requestId = _data["requestId"];
            this.sectionId = _data["sectionId"];
            this.subActivityId = _data["subActivityId"];
            this.countryId = _data["countryId"];
            this.postalCodeId = _data["postalCodeId"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.clubId = _data["clubId"];
            this.shouldDouble = _data["shouldDouble"];
            this.crufts = _data["crufts"];
            this.myDogShowAuthorized = _data["myDogShowAuthorized"];
            this.useTablet = _data["useTablet"];
            this.myDogShowBilling = _data["myDogShowBilling"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.section = _data["section"] ? Section.fromJS(_data["section"]) : <any>undefined;
            this.club = _data["club"] ? Club.fromJS(_data["club"]) : <any>undefined;
            this.subActivity = _data["subActivity"] ? SubActivity.fromJS(_data["subActivity"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.postalCode = _data["postalCode"] ? PostalCode.fromJS(_data["postalCode"]) : <any>undefined;
            this.competition = _data["competition"] ? Competition.fromJS(_data["competition"]) : <any>undefined;
            if (Array.isArray(_data["competitionsJudges"])) {
                this.competitionsJudges = [] as any;
                for (let item of _data["competitionsJudges"])
                    this.competitionsJudges!.push(CompetitionJudge.fromJS(item));
            }
            if (Array.isArray(_data["competitionBreedGroups"])) {
                this.competitionBreedGroups = [] as any;
                for (let item of _data["competitionBreedGroups"])
                    this.competitionBreedGroups!.push(CompetitionBreedGroup.fromJS(item));
            }
            if (Array.isArray(_data["competitionBreeds"])) {
                this.competitionBreeds = [] as any;
                for (let item of _data["competitionBreeds"])
                    this.competitionBreeds!.push(CompetitionBreed.fromJS(item));
            }
            if (Array.isArray(_data["competitionCommissioners"])) {
                this.competitionCommissioners = [] as any;
                for (let item of _data["competitionCommissioners"])
                    this.competitionCommissioners!.push(CompetitionCommissioner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionRequestId"] = this.competitionRequestId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["catalogReceptionDate"] = this.catalogReceptionDate ? this.catalogReceptionDate.toISOString() : <any>undefined;
        data["numberParticipants"] = this.numberParticipants;
        data["foreignCity"] = this.foreignCity;
        data["clubEmail"] = this.clubEmail;
        data["extra"] = this.extra;
        data["requestId"] = this.requestId;
        data["sectionId"] = this.sectionId;
        data["subActivityId"] = this.subActivityId;
        data["countryId"] = this.countryId;
        data["postalCodeId"] = this.postalCodeId;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["clubId"] = this.clubId;
        data["shouldDouble"] = this.shouldDouble;
        data["crufts"] = this.crufts;
        data["myDogShowAuthorized"] = this.myDogShowAuthorized;
        data["useTablet"] = this.useTablet;
        data["myDogShowBilling"] = this.myDogShowBilling;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["subActivity"] = this.subActivity ? this.subActivity.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["postalCode"] = this.postalCode ? this.postalCode.toJSON() : <any>undefined;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        if (Array.isArray(this.competitionsJudges)) {
            data["competitionsJudges"] = [];
            for (let item of this.competitionsJudges)
                data["competitionsJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionBreedGroups)) {
            data["competitionBreedGroups"] = [];
            for (let item of this.competitionBreedGroups)
                data["competitionBreedGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionBreeds)) {
            data["competitionBreeds"] = [];
            for (let item of this.competitionBreeds)
                data["competitionBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionCommissioners)) {
            data["competitionCommissioners"] = [];
            for (let item of this.competitionCommissioners)
                data["competitionCommissioners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionRequest {
    competitionRequestId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    catalogReceptionDate?: Date | undefined;
    numberParticipants?: number;
    foreignCity?: string | undefined;
    clubEmail?: string | undefined;
    extra?: string | undefined;
    requestId?: number;
    sectionId?: number | undefined;
    subActivityId?: number;
    countryId?: number | undefined;
    postalCodeId?: number | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    clubId?: number;
    shouldDouble?: boolean;
    crufts?: boolean;
    myDogShowAuthorized?: boolean;
    useTablet?: boolean;
    myDogShowBilling?: boolean;
    personId?: number | undefined;
    person?: Person | undefined;
    request?: Request | undefined;
    section?: Section | undefined;
    club?: Club | undefined;
    subActivity?: SubActivity | undefined;
    country?: Country | undefined;
    postalCode?: PostalCode | undefined;
    competition?: Competition | undefined;
    competitionsJudges?: CompetitionJudge[] | undefined;
    competitionBreedGroups?: CompetitionBreedGroup[] | undefined;
    competitionBreeds?: CompetitionBreed[] | undefined;
    competitionCommissioners?: CompetitionCommissioner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class PostalCode implements IPostalCode {
    postalCodeId?: number;
    code?: number;
    locality?: string | undefined;
    isLinked?: boolean;
    township?: string | undefined;
    province?: string | undefined;
    isWallonia?: boolean;
    isFlandria?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPostalCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCodeId = _data["postalCodeId"];
            this.code = _data["code"];
            this.locality = _data["locality"];
            this.isLinked = _data["isLinked"];
            this.township = _data["township"];
            this.province = _data["province"];
            this.isWallonia = _data["isWallonia"];
            this.isFlandria = _data["isFlandria"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PostalCode {
        data = typeof data === 'object' ? data : {};
        let result = new PostalCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCodeId"] = this.postalCodeId;
        data["code"] = this.code;
        data["locality"] = this.locality;
        data["isLinked"] = this.isLinked;
        data["township"] = this.township;
        data["province"] = this.province;
        data["isWallonia"] = this.isWallonia;
        data["isFlandria"] = this.isFlandria;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPostalCode {
    postalCodeId?: number;
    code?: number;
    locality?: string | undefined;
    isLinked?: boolean;
    township?: string | undefined;
    province?: string | undefined;
    isWallonia?: boolean;
    isFlandria?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Competition implements ICompetition {
    competitionId?: number;
    competitionRequestId?: number;
    competitionStatusId?: number | undefined;
    competitionName?: string | undefined;
    hallName?: string | undefined;
    gpsCoords?: string | undefined;
    defaultTimePerDog?: number | undefined;
    dateReminderParticipationRequest?: Date | undefined;
    dateEndParticipationRequest?: Date | undefined;
    dateReminderCompetition?: Date | undefined;
    dateInformationCompetition?: Date | undefined;
    dateDeadlineCv?: Date | undefined;
    dateDeadlinePhoto?: Date | undefined;
    competitionRequest?: CompetitionRequest | undefined;
    competitionStatus?: CompetitionStatus | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    competitionDays?: CompetitionDay[] | undefined;
    competitionVolunteerProfiles?: CompetitionVolunteerProfile[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
    isImporting?: boolean;

    constructor(data?: ICompetition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.competitionStatusId = _data["competitionStatusId"];
            this.competitionName = _data["competitionName"];
            this.hallName = _data["hallName"];
            this.gpsCoords = _data["gpsCoords"];
            this.defaultTimePerDog = _data["defaultTimePerDog"];
            this.dateReminderParticipationRequest = _data["dateReminderParticipationRequest"] ? new Date(_data["dateReminderParticipationRequest"].toString()) : <any>undefined;
            this.dateEndParticipationRequest = _data["dateEndParticipationRequest"] ? new Date(_data["dateEndParticipationRequest"].toString()) : <any>undefined;
            this.dateReminderCompetition = _data["dateReminderCompetition"] ? new Date(_data["dateReminderCompetition"].toString()) : <any>undefined;
            this.dateInformationCompetition = _data["dateInformationCompetition"] ? new Date(_data["dateInformationCompetition"].toString()) : <any>undefined;
            this.dateDeadlineCv = _data["dateDeadlineCv"] ? new Date(_data["dateDeadlineCv"].toString()) : <any>undefined;
            this.dateDeadlinePhoto = _data["dateDeadlinePhoto"] ? new Date(_data["dateDeadlinePhoto"].toString()) : <any>undefined;
            this.competitionRequest = _data["competitionRequest"] ? CompetitionRequest.fromJS(_data["competitionRequest"]) : <any>undefined;
            this.competitionStatus = _data["competitionStatus"] ? CompetitionStatus.fromJS(_data["competitionStatus"]) : <any>undefined;
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(CompetitionResult.fromJS(item));
            }
            if (Array.isArray(_data["competitionDays"])) {
                this.competitionDays = [] as any;
                for (let item of _data["competitionDays"])
                    this.competitionDays!.push(CompetitionDay.fromJS(item));
            }
            if (Array.isArray(_data["competitionVolunteerProfiles"])) {
                this.competitionVolunteerProfiles = [] as any;
                for (let item of _data["competitionVolunteerProfiles"])
                    this.competitionVolunteerProfiles!.push(CompetitionVolunteerProfile.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
            this.isImporting = _data["isImporting"];
        }
    }

    static fromJS(data: any): Competition {
        data = typeof data === 'object' ? data : {};
        let result = new Competition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["competitionStatusId"] = this.competitionStatusId;
        data["competitionName"] = this.competitionName;
        data["hallName"] = this.hallName;
        data["gpsCoords"] = this.gpsCoords;
        data["defaultTimePerDog"] = this.defaultTimePerDog;
        data["dateReminderParticipationRequest"] = this.dateReminderParticipationRequest ? this.dateReminderParticipationRequest.toISOString() : <any>undefined;
        data["dateEndParticipationRequest"] = this.dateEndParticipationRequest ? this.dateEndParticipationRequest.toISOString() : <any>undefined;
        data["dateReminderCompetition"] = this.dateReminderCompetition ? this.dateReminderCompetition.toISOString() : <any>undefined;
        data["dateInformationCompetition"] = this.dateInformationCompetition ? this.dateInformationCompetition.toISOString() : <any>undefined;
        data["dateDeadlineCv"] = this.dateDeadlineCv ? this.dateDeadlineCv.toISOString() : <any>undefined;
        data["dateDeadlinePhoto"] = this.dateDeadlinePhoto ? this.dateDeadlinePhoto.toISOString() : <any>undefined;
        data["competitionRequest"] = this.competitionRequest ? this.competitionRequest.toJSON() : <any>undefined;
        data["competitionStatus"] = this.competitionStatus ? this.competitionStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionDays)) {
            data["competitionDays"] = [];
            for (let item of this.competitionDays)
                data["competitionDays"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionVolunteerProfiles)) {
            data["competitionVolunteerProfiles"] = [];
            for (let item of this.competitionVolunteerProfiles)
                data["competitionVolunteerProfiles"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        data["isImporting"] = this.isImporting;
        return data;
    }
}

export interface ICompetition {
    competitionId?: number;
    competitionRequestId?: number;
    competitionStatusId?: number | undefined;
    competitionName?: string | undefined;
    hallName?: string | undefined;
    gpsCoords?: string | undefined;
    defaultTimePerDog?: number | undefined;
    dateReminderParticipationRequest?: Date | undefined;
    dateEndParticipationRequest?: Date | undefined;
    dateReminderCompetition?: Date | undefined;
    dateInformationCompetition?: Date | undefined;
    dateDeadlineCv?: Date | undefined;
    dateDeadlinePhoto?: Date | undefined;
    competitionRequest?: CompetitionRequest | undefined;
    competitionStatus?: CompetitionStatus | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    competitionDays?: CompetitionDay[] | undefined;
    competitionVolunteerProfiles?: CompetitionVolunteerProfile[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
    isImporting?: boolean;
}

export class CompetitionStatus implements ICompetitionStatus {
    competitionStatusId?: number;
    competitionStatusCode?: ECompetitionStatus;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    competitionStatusTranslations?: CompetitionStatusTranslation[] | undefined;
    competitions?: Competition[] | undefined;

    constructor(data?: ICompetitionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionStatusId = _data["competitionStatusId"];
            this.competitionStatusCode = _data["competitionStatusCode"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["competitionStatusTranslations"])) {
                this.competitionStatusTranslations = [] as any;
                for (let item of _data["competitionStatusTranslations"])
                    this.competitionStatusTranslations!.push(CompetitionStatusTranslation.fromJS(item));
            }
            if (Array.isArray(_data["competitions"])) {
                this.competitions = [] as any;
                for (let item of _data["competitions"])
                    this.competitions!.push(Competition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionStatusId"] = this.competitionStatusId;
        data["competitionStatusCode"] = this.competitionStatusCode;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.competitionStatusTranslations)) {
            data["competitionStatusTranslations"] = [];
            for (let item of this.competitionStatusTranslations)
                data["competitionStatusTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.competitions)) {
            data["competitions"] = [];
            for (let item of this.competitions)
                data["competitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitionStatus {
    competitionStatusId?: number;
    competitionStatusCode?: ECompetitionStatus;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    competitionStatusTranslations?: CompetitionStatusTranslation[] | undefined;
    competitions?: Competition[] | undefined;
}

export enum ECompetitionStatus {
    Configuration = "Configuration",
    CandidateDefinition = "CandidateDefinition",
    AwaitingCandidateResponse = "AwaitingCandidateResponse",
    ResponseFromCandidatesToBeProcessed = "ResponseFromCandidatesToBeProcessed",
    SRSHValidation = "SRSHValidation",
    RingsConfiguration = "RingsConfiguration",
    InProgress = "InProgress",
    AttendanceToDo = "AttendanceToDo",
    Finished = "Finished",
    NotOpened = "NotOpened",
}

export class CompetitionStatusTranslation implements ICompetitionStatusTranslation {
    competitionStatusTranslationId?: number;
    competitionStatusId?: number;
    languageId?: number;
    text?: string | undefined;
    competitionStatus?: CompetitionStatus | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionStatusTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionStatusTranslationId = _data["competitionStatusTranslationId"];
            this.competitionStatusId = _data["competitionStatusId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.competitionStatus = _data["competitionStatus"] ? CompetitionStatus.fromJS(_data["competitionStatus"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionStatusTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionStatusTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionStatusTranslationId"] = this.competitionStatusTranslationId;
        data["competitionStatusId"] = this.competitionStatusId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["competitionStatus"] = this.competitionStatus ? this.competitionStatus.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionStatusTranslation {
    competitionStatusTranslationId?: number;
    competitionStatusId?: number;
    languageId?: number;
    text?: string | undefined;
    competitionStatus?: CompetitionStatus | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CompetitionResult implements ICompetitionResult {
    competitionResultId?: number;
    competitionId?: number | undefined;
    dogId?: number;
    qualificationId?: number | undefined;
    dogTitleId?: number | undefined;
    judgeId?: number | undefined;
    expoId?: number | undefined;
    comment?: string | undefined;
    result?: number | undefined;
    catalogNumber?: number | undefined;
    showClass?: string | undefined;
    standardConformed?: boolean | undefined;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;
    competition?: Competition | undefined;
    dog?: Dog | undefined;
    qualification?: Qualification | undefined;
    dogTitle?: DogTitle | undefined;
    judge?: Judge | undefined;
    expo?: Expo | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: ICompetitionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionResultId = _data["competitionResultId"];
            this.competitionId = _data["competitionId"];
            this.dogId = _data["dogId"];
            this.qualificationId = _data["qualificationId"];
            this.dogTitleId = _data["dogTitleId"];
            this.judgeId = _data["judgeId"];
            this.expoId = _data["expoId"];
            this.comment = _data["comment"];
            this.result = _data["result"];
            this.catalogNumber = _data["catalogNumber"];
            this.showClass = _data["showClass"];
            this.standardConformed = _data["standardConformed"];
            this.bestOfBreed = _data["bestOfBreed"];
            this.bestOfSex = _data["bestOfSex"];
            this.bestInShow = _data["bestInShow"];
            this.bestInGroup = _data["bestInGroup"];
            this.bestVeteran = _data["bestVeteran"];
            this.bestWorkDog = _data["bestWorkDog"];
            this.bestYouth = _data["bestYouth"];
            this.bestMinorPuppy = _data["bestMinorPuppy"];
            this.bestPuppy = _data["bestPuppy"];
            this.belgianWinner = _data["belgianWinner"];
            this.beneluxWinner = _data["beneluxWinner"];
            this.beneluxYouthWinner = _data["beneluxYouthWinner"];
            this.beneluxVeteranWinner = _data["beneluxVeteranWinner"];
            this.europeanWinner = _data["europeanWinner"];
            this.crufts = _data["crufts"];
            this.cac = _data["cac"];
            this.cacReserve = _data["cacReserve"];
            this.cacib = _data["cacib"];
            this.cacibReserve = _data["cacibReserve"];
            this.cacbl = _data["cacbl"];
            this.cacblReserve = _data["cacblReserve"];
            this.cacgpo = _data["cacgpo"];
            this.cacgpoReserve = _data["cacgpoReserve"];
            this.caciag = _data["caciag"];
            this.caciagReserve = _data["caciagReserve"];
            this.cacil = _data["cacil"];
            this.cacilReserve = _data["cacilReserve"];
            this.caciob = _data["caciob"];
            this.caciobReserve = _data["caciobReserve"];
            this.cacit = _data["cacit"];
            this.cacitReserve = _data["cacitReserve"];
            this.competition = _data["competition"] ? Competition.fromJS(_data["competition"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.dogTitle = _data["dogTitle"] ? DogTitle.fromJS(_data["dogTitle"]) : <any>undefined;
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.expo = _data["expo"] ? Expo.fromJS(_data["expo"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): CompetitionResult {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionResultId"] = this.competitionResultId;
        data["competitionId"] = this.competitionId;
        data["dogId"] = this.dogId;
        data["qualificationId"] = this.qualificationId;
        data["dogTitleId"] = this.dogTitleId;
        data["judgeId"] = this.judgeId;
        data["expoId"] = this.expoId;
        data["comment"] = this.comment;
        data["result"] = this.result;
        data["catalogNumber"] = this.catalogNumber;
        data["showClass"] = this.showClass;
        data["standardConformed"] = this.standardConformed;
        data["bestOfBreed"] = this.bestOfBreed;
        data["bestOfSex"] = this.bestOfSex;
        data["bestInShow"] = this.bestInShow;
        data["bestInGroup"] = this.bestInGroup;
        data["bestVeteran"] = this.bestVeteran;
        data["bestWorkDog"] = this.bestWorkDog;
        data["bestYouth"] = this.bestYouth;
        data["bestMinorPuppy"] = this.bestMinorPuppy;
        data["bestPuppy"] = this.bestPuppy;
        data["belgianWinner"] = this.belgianWinner;
        data["beneluxWinner"] = this.beneluxWinner;
        data["beneluxYouthWinner"] = this.beneluxYouthWinner;
        data["beneluxVeteranWinner"] = this.beneluxVeteranWinner;
        data["europeanWinner"] = this.europeanWinner;
        data["crufts"] = this.crufts;
        data["cac"] = this.cac;
        data["cacReserve"] = this.cacReserve;
        data["cacib"] = this.cacib;
        data["cacibReserve"] = this.cacibReserve;
        data["cacbl"] = this.cacbl;
        data["cacblReserve"] = this.cacblReserve;
        data["cacgpo"] = this.cacgpo;
        data["cacgpoReserve"] = this.cacgpoReserve;
        data["caciag"] = this.caciag;
        data["caciagReserve"] = this.caciagReserve;
        data["cacil"] = this.cacil;
        data["cacilReserve"] = this.cacilReserve;
        data["caciob"] = this.caciob;
        data["caciobReserve"] = this.caciobReserve;
        data["cacit"] = this.cacit;
        data["cacitReserve"] = this.cacitReserve;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["dogTitle"] = this.dogTitle ? this.dogTitle.toJSON() : <any>undefined;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["expo"] = this.expo ? this.expo.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface ICompetitionResult {
    competitionResultId?: number;
    competitionId?: number | undefined;
    dogId?: number;
    qualificationId?: number | undefined;
    dogTitleId?: number | undefined;
    judgeId?: number | undefined;
    expoId?: number | undefined;
    comment?: string | undefined;
    result?: number | undefined;
    catalogNumber?: number | undefined;
    showClass?: string | undefined;
    standardConformed?: boolean | undefined;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;
    competition?: Competition | undefined;
    dog?: Dog | undefined;
    qualification?: Qualification | undefined;
    dogTitle?: DogTitle | undefined;
    judge?: Judge | undefined;
    expo?: Expo | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class Qualification implements IQualification {
    qualificationId?: number;
    code?: EQualification;
    competitionResults?: CompetitionResult[] | undefined;
    qualificationTranslations?: QualificationTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.code = _data["code"];
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(CompetitionResult.fromJS(item));
            }
            if (Array.isArray(_data["qualificationTranslations"])) {
                this.qualificationTranslations = [] as any;
                for (let item of _data["qualificationTranslations"])
                    this.qualificationTranslations!.push(QualificationTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Qualification {
        data = typeof data === 'object' ? data : {};
        let result = new Qualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["code"] = this.code;
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        if (Array.isArray(this.qualificationTranslations)) {
            data["qualificationTranslations"] = [];
            for (let item of this.qualificationTranslations)
                data["qualificationTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IQualification {
    qualificationId?: number;
    code?: EQualification;
    competitionResults?: CompetitionResult[] | undefined;
    qualificationTranslations?: QualificationTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EQualification {
    ABS = "ABS",
    B = "B",
    DK = "DK",
    E = "E",
    I = "I",
    KNG = "KNG",
    P = "P",
    S = "S",
    TB = "TB",
    TP = "TP",
}

export class QualificationTranslation implements IQualificationTranslation {
    qualificationTranslationId?: number;
    qualificationId?: number;
    languageId?: number;
    text?: string | undefined;
    qualification?: Qualification | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IQualificationTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationTranslationId = _data["qualificationTranslationId"];
            this.qualificationId = _data["qualificationId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.qualification = _data["qualification"] ? Qualification.fromJS(_data["qualification"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): QualificationTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationTranslationId"] = this.qualificationTranslationId;
        data["qualificationId"] = this.qualificationId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IQualificationTranslation {
    qualificationTranslationId?: number;
    qualificationId?: number;
    languageId?: number;
    text?: string | undefined;
    qualification?: Qualification | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogTitle implements IDogTitle {
    dogTitleId?: number;
    dogId?: number;
    titleId?: number;
    year?: number | undefined;
    dog?: Dog | undefined;
    title?: Title | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTitleId = _data["dogTitleId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.year = _data["year"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.title = _data["title"] ? Title.fromJS(_data["title"]) : <any>undefined;
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(CompetitionResult.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogTitle {
        data = typeof data === 'object' ? data : {};
        let result = new DogTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTitleId"] = this.dogTitleId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["year"] = this.year;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogTitle {
    dogTitleId?: number;
    dogId?: number;
    titleId?: number;
    year?: number | undefined;
    dog?: Dog | undefined;
    title?: Title | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Title implements ITitle {
    titleId?: number;
    countryId?: number;
    titleTypeId?: number;
    articleId?: number | undefined;
    abreviation?: string | undefined;
    workRequired?: boolean;
    cegekaId?: string | undefined;
    country?: Country | undefined;
    titleType?: TitleType | undefined;
    canBeUsed?: boolean;
    documentTemplate?: EDocumentTemplate | undefined;
    article?: Article | undefined;
    dogsTitles?: DogTitle[] | undefined;
    titleTranslations?: TitleTranslation[] | undefined;
    titleRequests?: TitleRequest[] | undefined;
    dogTitlesTransients?: DogTitlesTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.countryId = _data["countryId"];
            this.titleTypeId = _data["titleTypeId"];
            this.articleId = _data["articleId"];
            this.abreviation = _data["abreviation"];
            this.workRequired = _data["workRequired"];
            this.cegekaId = _data["cegekaId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.titleType = _data["titleType"] ? TitleType.fromJS(_data["titleType"]) : <any>undefined;
            this.canBeUsed = _data["canBeUsed"];
            this.documentTemplate = _data["documentTemplate"];
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            if (Array.isArray(_data["dogsTitles"])) {
                this.dogsTitles = [] as any;
                for (let item of _data["dogsTitles"])
                    this.dogsTitles!.push(DogTitle.fromJS(item));
            }
            if (Array.isArray(_data["titleTranslations"])) {
                this.titleTranslations = [] as any;
                for (let item of _data["titleTranslations"])
                    this.titleTranslations!.push(TitleTranslation.fromJS(item));
            }
            if (Array.isArray(_data["titleRequests"])) {
                this.titleRequests = [] as any;
                for (let item of _data["titleRequests"])
                    this.titleRequests!.push(TitleRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogTitlesTransients"])) {
                this.dogTitlesTransients = [] as any;
                for (let item of _data["dogTitlesTransients"])
                    this.dogTitlesTransients!.push(DogTitlesTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Title {
        data = typeof data === 'object' ? data : {};
        let result = new Title();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["countryId"] = this.countryId;
        data["titleTypeId"] = this.titleTypeId;
        data["articleId"] = this.articleId;
        data["abreviation"] = this.abreviation;
        data["workRequired"] = this.workRequired;
        data["cegekaId"] = this.cegekaId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["titleType"] = this.titleType ? this.titleType.toJSON() : <any>undefined;
        data["canBeUsed"] = this.canBeUsed;
        data["documentTemplate"] = this.documentTemplate;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        if (Array.isArray(this.dogsTitles)) {
            data["dogsTitles"] = [];
            for (let item of this.dogsTitles)
                data["dogsTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.titleTranslations)) {
            data["titleTranslations"] = [];
            for (let item of this.titleTranslations)
                data["titleTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.titleRequests)) {
            data["titleRequests"] = [];
            for (let item of this.titleRequests)
                data["titleRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTitlesTransients)) {
            data["dogTitlesTransients"] = [];
            for (let item of this.dogTitlesTransients)
                data["dogTitlesTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITitle {
    titleId?: number;
    countryId?: number;
    titleTypeId?: number;
    articleId?: number | undefined;
    abreviation?: string | undefined;
    workRequired?: boolean;
    cegekaId?: string | undefined;
    country?: Country | undefined;
    titleType?: TitleType | undefined;
    canBeUsed?: boolean;
    documentTemplate?: EDocumentTemplate | undefined;
    article?: Article | undefined;
    dogsTitles?: DogTitle[] | undefined;
    titleTranslations?: TitleTranslation[] | undefined;
    titleRequests?: TitleRequest[] | undefined;
    dogTitlesTransients?: DogTitlesTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TitleType implements ITitleType {
    titleTypeId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    titleTypeTranslations?: TitleTypeTranslation[] | undefined;
    titles?: Title[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITitleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleTypeId = _data["titleTypeId"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            if (Array.isArray(_data["titleTypeTranslations"])) {
                this.titleTypeTranslations = [] as any;
                for (let item of _data["titleTypeTranslations"])
                    this.titleTypeTranslations!.push(TitleTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(Title.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TitleType {
        data = typeof data === 'object' ? data : {};
        let result = new TitleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleTypeId"] = this.titleTypeId;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        if (Array.isArray(this.titleTypeTranslations)) {
            data["titleTypeTranslations"] = [];
            for (let item of this.titleTypeTranslations)
                data["titleTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITitleType {
    titleTypeId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    titleTypeTranslations?: TitleTypeTranslation[] | undefined;
    titles?: Title[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TitleTypeTranslation implements ITitleTypeTranslation {
    titleTypeTranslationId?: number;
    titleTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITitleTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleTypeTranslationId = _data["titleTypeTranslationId"];
            this.titleTypeId = _data["titleTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TitleTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleTypeTranslationId"] = this.titleTypeTranslationId;
        data["titleTypeId"] = this.titleTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITitleTypeTranslation {
    titleTypeTranslationId?: number;
    titleTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TitleTranslation implements ITitleTranslation {
    titleTranslationId?: number;
    titleId?: number;
    languageId?: number;
    text?: string | undefined;
    title?: Title | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITitleTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleTranslationId = _data["titleTranslationId"];
            this.titleId = _data["titleId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.title = _data["title"] ? Title.fromJS(_data["title"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TitleTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleTranslationId"] = this.titleTranslationId;
        data["titleId"] = this.titleId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITitleTranslation {
    titleTranslationId?: number;
    titleId?: number;
    languageId?: number;
    text?: string | undefined;
    title?: Title | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TitleRequest implements ITitleRequest {
    titleRequestId?: number;
    requestId?: number;
    dogId?: number;
    titleId?: number;
    year?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    title?: Title | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITitleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleRequestId = _data["titleRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.year = _data["year"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.title = _data["title"] ? Title.fromJS(_data["title"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TitleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TitleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleRequestId"] = this.titleRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["year"] = this.year;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITitleRequest {
    titleRequestId?: number;
    requestId?: number;
    dogId?: number;
    titleId?: number;
    year?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    title?: Title | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogTitlesTransient implements IDogTitlesTransient {
    dogTitlesTransientId?: number;
    dogId?: number;
    titleId?: number;
    year?: number;
    managerId?: number | undefined;
    dog?: Dog | undefined;
    title?: Title | undefined;
    manager?: User | undefined;
    closedOn?: Date | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IDogTitlesTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTitlesTransientId = _data["dogTitlesTransientId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.year = _data["year"];
            this.managerId = _data["managerId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.title = _data["title"] ? Title.fromJS(_data["title"]) : <any>undefined;
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>undefined;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogTitlesTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogTitlesTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTitlesTransientId"] = this.dogTitlesTransientId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["year"] = this.year;
        data["managerId"] = this.managerId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogTitlesTransient {
    dogTitlesTransientId?: number;
    dogId?: number;
    titleId?: number;
    year?: number;
    managerId?: number | undefined;
    dog?: Dog | undefined;
    title?: Title | undefined;
    manager?: User | undefined;
    closedOn?: Date | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class Judge implements IJudge {
    judgeId?: number;
    personId?: number;
    fciNumber?: string | undefined;
    person?: Person | undefined;
    breedsJudges?: BreedJudge[] | undefined;
    breedJudgeTransients?: BreedJudgeTransient[] | undefined;
    breedGroupsJudges?: BreedGroupJudge[] | undefined;
    subActivitiesJudges?: SubActivityJudge[] | undefined;
    judgesForClub?: JudgesForClub[] | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    competitionsJudges?: CompetitionJudge[] | undefined;
    judgeSpokenLanguages?: JudgeSpokenLanguage[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: IJudge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            this.fciNumber = _data["fciNumber"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["breedsJudges"])) {
                this.breedsJudges = [] as any;
                for (let item of _data["breedsJudges"])
                    this.breedsJudges!.push(BreedJudge.fromJS(item));
            }
            if (Array.isArray(_data["breedJudgeTransients"])) {
                this.breedJudgeTransients = [] as any;
                for (let item of _data["breedJudgeTransients"])
                    this.breedJudgeTransients!.push(BreedJudgeTransient.fromJS(item));
            }
            if (Array.isArray(_data["breedGroupsJudges"])) {
                this.breedGroupsJudges = [] as any;
                for (let item of _data["breedGroupsJudges"])
                    this.breedGroupsJudges!.push(BreedGroupJudge.fromJS(item));
            }
            if (Array.isArray(_data["subActivitiesJudges"])) {
                this.subActivitiesJudges = [] as any;
                for (let item of _data["subActivitiesJudges"])
                    this.subActivitiesJudges!.push(SubActivityJudge.fromJS(item));
            }
            if (Array.isArray(_data["judgesForClub"])) {
                this.judgesForClub = [] as any;
                for (let item of _data["judgesForClub"])
                    this.judgesForClub!.push(JudgesForClub.fromJS(item));
            }
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(CompetitionResult.fromJS(item));
            }
            if (Array.isArray(_data["competitionsJudges"])) {
                this.competitionsJudges = [] as any;
                for (let item of _data["competitionsJudges"])
                    this.competitionsJudges!.push(CompetitionJudge.fromJS(item));
            }
            if (Array.isArray(_data["judgeSpokenLanguages"])) {
                this.judgeSpokenLanguages = [] as any;
                for (let item of _data["judgeSpokenLanguages"])
                    this.judgeSpokenLanguages!.push(JudgeSpokenLanguage.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): Judge {
        data = typeof data === 'object' ? data : {};
        let result = new Judge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        data["fciNumber"] = this.fciNumber;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.breedsJudges)) {
            data["breedsJudges"] = [];
            for (let item of this.breedsJudges)
                data["breedsJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.breedJudgeTransients)) {
            data["breedJudgeTransients"] = [];
            for (let item of this.breedJudgeTransients)
                data["breedJudgeTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.breedGroupsJudges)) {
            data["breedGroupsJudges"] = [];
            for (let item of this.breedGroupsJudges)
                data["breedGroupsJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.subActivitiesJudges)) {
            data["subActivitiesJudges"] = [];
            for (let item of this.subActivitiesJudges)
                data["subActivitiesJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.judgesForClub)) {
            data["judgesForClub"] = [];
            for (let item of this.judgesForClub)
                data["judgesForClub"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionsJudges)) {
            data["competitionsJudges"] = [];
            for (let item of this.competitionsJudges)
                data["competitionsJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.judgeSpokenLanguages)) {
            data["judgeSpokenLanguages"] = [];
            for (let item of this.judgeSpokenLanguages)
                data["judgeSpokenLanguages"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IJudge {
    judgeId?: number;
    personId?: number;
    fciNumber?: string | undefined;
    person?: Person | undefined;
    breedsJudges?: BreedJudge[] | undefined;
    breedJudgeTransients?: BreedJudgeTransient[] | undefined;
    breedGroupsJudges?: BreedGroupJudge[] | undefined;
    subActivitiesJudges?: SubActivityJudge[] | undefined;
    judgesForClub?: JudgesForClub[] | undefined;
    competitionResults?: CompetitionResult[] | undefined;
    competitionsJudges?: CompetitionJudge[] | undefined;
    judgeSpokenLanguages?: JudgeSpokenLanguage[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class BreedJudge implements IBreedJudge {
    breedJudgeId?: number;
    breedId?: number;
    judgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    breed?: Breed | undefined;
    judge?: Judge | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;

    constructor(data?: IBreedJudge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedJudgeId = _data["breedJudgeId"];
            this.breedId = _data["breedId"];
            this.judgeId = _data["judgeId"];
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["expoBreedForJudges"])) {
                this.expoBreedForJudges = [] as any;
                for (let item of _data["expoBreedForJudges"])
                    this.expoBreedForJudges!.push(ExpoBreedForJudge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreedJudge {
        data = typeof data === 'object' ? data : {};
        let result = new BreedJudge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedJudgeId"] = this.breedJudgeId;
        data["breedId"] = this.breedId;
        data["judgeId"] = this.judgeId;
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.expoBreedForJudges)) {
            data["expoBreedForJudges"] = [];
            for (let item of this.expoBreedForJudges)
                data["expoBreedForJudges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreedJudge {
    breedJudgeId?: number;
    breedId?: number;
    judgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    breed?: Breed | undefined;
    judge?: Judge | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
}

export class ExpoBreedForJudge implements IExpoBreedForJudge {
    expoBreedForJudgeId?: number;
    breedId?: number;
    competitionJudgeId?: number;
    breedJudgeTransientId?: number | undefined;
    expoId?: number;
    breed?: Breed | undefined;
    breedJudgeTransient?: BreedJudgeTransient | undefined;
    competitionJudge?: CompetitionJudge | undefined;
    expo?: Expo | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IExpoBreedForJudge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expoBreedForJudgeId = _data["expoBreedForJudgeId"];
            this.breedId = _data["breedId"];
            this.competitionJudgeId = _data["competitionJudgeId"];
            this.breedJudgeTransientId = _data["breedJudgeTransientId"];
            this.expoId = _data["expoId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.breedJudgeTransient = _data["breedJudgeTransient"] ? BreedJudgeTransient.fromJS(_data["breedJudgeTransient"]) : <any>undefined;
            this.competitionJudge = _data["competitionJudge"] ? CompetitionJudge.fromJS(_data["competitionJudge"]) : <any>undefined;
            this.expo = _data["expo"] ? Expo.fromJS(_data["expo"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ExpoBreedForJudge {
        data = typeof data === 'object' ? data : {};
        let result = new ExpoBreedForJudge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expoBreedForJudgeId"] = this.expoBreedForJudgeId;
        data["breedId"] = this.breedId;
        data["competitionJudgeId"] = this.competitionJudgeId;
        data["breedJudgeTransientId"] = this.breedJudgeTransientId;
        data["expoId"] = this.expoId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["breedJudgeTransient"] = this.breedJudgeTransient ? this.breedJudgeTransient.toJSON() : <any>undefined;
        data["competitionJudge"] = this.competitionJudge ? this.competitionJudge.toJSON() : <any>undefined;
        data["expo"] = this.expo ? this.expo.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IExpoBreedForJudge {
    expoBreedForJudgeId?: number;
    breedId?: number;
    competitionJudgeId?: number;
    breedJudgeTransientId?: number | undefined;
    expoId?: number;
    breed?: Breed | undefined;
    breedJudgeTransient?: BreedJudgeTransient | undefined;
    competitionJudge?: CompetitionJudge | undefined;
    expo?: Expo | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedJudgeTransient implements IBreedJudgeTransient {
    breedJudgeTransientId?: number;
    breedId?: number;
    judgeId?: number;
    judge?: Judge | undefined;
    breed?: Breed | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedJudgeTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedJudgeTransientId = _data["breedJudgeTransientId"];
            this.breedId = _data["breedId"];
            this.judgeId = _data["judgeId"];
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            if (Array.isArray(_data["expoBreedForJudges"])) {
                this.expoBreedForJudges = [] as any;
                for (let item of _data["expoBreedForJudges"])
                    this.expoBreedForJudges!.push(ExpoBreedForJudge.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedJudgeTransient {
        data = typeof data === 'object' ? data : {};
        let result = new BreedJudgeTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedJudgeTransientId"] = this.breedJudgeTransientId;
        data["breedId"] = this.breedId;
        data["judgeId"] = this.judgeId;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        if (Array.isArray(this.expoBreedForJudges)) {
            data["expoBreedForJudges"] = [];
            for (let item of this.expoBreedForJudges)
                data["expoBreedForJudges"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedJudgeTransient {
    breedJudgeTransientId?: number;
    breedId?: number;
    judgeId?: number;
    judge?: Judge | undefined;
    breed?: Breed | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CompetitionJudge implements ICompetitionJudge {
    competitionJudgeId?: number;
    judgeId?: number;
    competitionRequestId?: number;
    communicationLanguageId?: number;
    subActivityValidated?: boolean | undefined;
    breedValidated?: boolean | undefined;
    mailSent?: boolean;
    hasAccepted?: boolean;
    automatedInvitation?: boolean;
    isAutoValidated?: boolean;
    isSelected?: boolean;
    accountNumber?: string | undefined;
    otherLanguage?: string | undefined;
    comingFrom?: EJudgeComingFrom;
    comingFromText?: string | undefined;
    transportationMode?: EJudgeTransportationMode;
    transportationModeText?: string | undefined;
    judge?: Judge | undefined;
    language?: Language | undefined;
    competitionRequest?: CompetitionRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
    ringDivisions?: RingDivision[] | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;

    constructor(data?: ICompetitionJudge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionJudgeId = _data["competitionJudgeId"];
            this.judgeId = _data["judgeId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.communicationLanguageId = _data["communicationLanguageId"];
            this.subActivityValidated = _data["subActivityValidated"];
            this.breedValidated = _data["breedValidated"];
            this.mailSent = _data["mailSent"];
            this.hasAccepted = _data["hasAccepted"];
            this.automatedInvitation = _data["automatedInvitation"];
            this.isAutoValidated = _data["isAutoValidated"];
            this.isSelected = _data["isSelected"];
            this.accountNumber = _data["accountNumber"];
            this.otherLanguage = _data["otherLanguage"];
            this.comingFrom = _data["comingFrom"];
            this.comingFromText = _data["comingFromText"];
            this.transportationMode = _data["transportationMode"];
            this.transportationModeText = _data["transportationModeText"];
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.competitionRequest = _data["competitionRequest"] ? CompetitionRequest.fromJS(_data["competitionRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
            if (Array.isArray(_data["ringDivisions"])) {
                this.ringDivisions = [] as any;
                for (let item of _data["ringDivisions"])
                    this.ringDivisions!.push(RingDivision.fromJS(item));
            }
            if (Array.isArray(_data["expoBreedForJudges"])) {
                this.expoBreedForJudges = [] as any;
                for (let item of _data["expoBreedForJudges"])
                    this.expoBreedForJudges!.push(ExpoBreedForJudge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitionJudge {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionJudge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionJudgeId"] = this.competitionJudgeId;
        data["judgeId"] = this.judgeId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["communicationLanguageId"] = this.communicationLanguageId;
        data["subActivityValidated"] = this.subActivityValidated;
        data["breedValidated"] = this.breedValidated;
        data["mailSent"] = this.mailSent;
        data["hasAccepted"] = this.hasAccepted;
        data["automatedInvitation"] = this.automatedInvitation;
        data["isAutoValidated"] = this.isAutoValidated;
        data["isSelected"] = this.isSelected;
        data["accountNumber"] = this.accountNumber;
        data["otherLanguage"] = this.otherLanguage;
        data["comingFrom"] = this.comingFrom;
        data["comingFromText"] = this.comingFromText;
        data["transportationMode"] = this.transportationMode;
        data["transportationModeText"] = this.transportationModeText;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["competitionRequest"] = this.competitionRequest ? this.competitionRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        if (Array.isArray(this.ringDivisions)) {
            data["ringDivisions"] = [];
            for (let item of this.ringDivisions)
                data["ringDivisions"].push(item.toJSON());
        }
        if (Array.isArray(this.expoBreedForJudges)) {
            data["expoBreedForJudges"] = [];
            for (let item of this.expoBreedForJudges)
                data["expoBreedForJudges"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitionJudge {
    competitionJudgeId?: number;
    judgeId?: number;
    competitionRequestId?: number;
    communicationLanguageId?: number;
    subActivityValidated?: boolean | undefined;
    breedValidated?: boolean | undefined;
    mailSent?: boolean;
    hasAccepted?: boolean;
    automatedInvitation?: boolean;
    isAutoValidated?: boolean;
    isSelected?: boolean;
    accountNumber?: string | undefined;
    otherLanguage?: string | undefined;
    comingFrom?: EJudgeComingFrom;
    comingFromText?: string | undefined;
    transportationMode?: EJudgeTransportationMode;
    transportationModeText?: string | undefined;
    judge?: Judge | undefined;
    language?: Language | undefined;
    competitionRequest?: CompetitionRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
    ringDivisions?: RingDivision[] | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
}

export enum EJudgeComingFrom {
    Home = "Home",
    Other = "Other",
}

export enum EJudgeTransportationMode {
    Plane = "Plane",
    Train = "Train",
    Other = "Other",
}

export class RingDivision implements IRingDivision {
    ringDivisionId?: number;
    letter?: string;
    ringId?: number;
    timePerDog?: number;
    competitionJudgeId?: number | undefined;
    competitionJudgePresent?: boolean;
    startTime?: string | undefined;
    comissionerArrivalTime?: string | undefined;
    ring?: Ring | undefined;
    competitionJudge?: CompetitionJudge | undefined;
    ringDivisionCompetitionCommissioners?: RingDivisionCompetitionCommissioner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRingDivision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ringDivisionId = _data["ringDivisionId"];
            this.letter = _data["letter"];
            this.ringId = _data["ringId"];
            this.timePerDog = _data["timePerDog"];
            this.competitionJudgeId = _data["competitionJudgeId"];
            this.competitionJudgePresent = _data["competitionJudgePresent"];
            this.startTime = _data["startTime"];
            this.comissionerArrivalTime = _data["comissionerArrivalTime"];
            this.ring = _data["ring"] ? Ring.fromJS(_data["ring"]) : <any>undefined;
            this.competitionJudge = _data["competitionJudge"] ? CompetitionJudge.fromJS(_data["competitionJudge"]) : <any>undefined;
            if (Array.isArray(_data["ringDivisionCompetitionCommissioners"])) {
                this.ringDivisionCompetitionCommissioners = [] as any;
                for (let item of _data["ringDivisionCompetitionCommissioners"])
                    this.ringDivisionCompetitionCommissioners!.push(RingDivisionCompetitionCommissioner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RingDivision {
        data = typeof data === 'object' ? data : {};
        let result = new RingDivision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ringDivisionId"] = this.ringDivisionId;
        data["letter"] = this.letter;
        data["ringId"] = this.ringId;
        data["timePerDog"] = this.timePerDog;
        data["competitionJudgeId"] = this.competitionJudgeId;
        data["competitionJudgePresent"] = this.competitionJudgePresent;
        data["startTime"] = this.startTime;
        data["comissionerArrivalTime"] = this.comissionerArrivalTime;
        data["ring"] = this.ring ? this.ring.toJSON() : <any>undefined;
        data["competitionJudge"] = this.competitionJudge ? this.competitionJudge.toJSON() : <any>undefined;
        if (Array.isArray(this.ringDivisionCompetitionCommissioners)) {
            data["ringDivisionCompetitionCommissioners"] = [];
            for (let item of this.ringDivisionCompetitionCommissioners)
                data["ringDivisionCompetitionCommissioners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRingDivision {
    ringDivisionId?: number;
    letter?: string;
    ringId?: number;
    timePerDog?: number;
    competitionJudgeId?: number | undefined;
    competitionJudgePresent?: boolean;
    startTime?: string | undefined;
    comissionerArrivalTime?: string | undefined;
    ring?: Ring | undefined;
    competitionJudge?: CompetitionJudge | undefined;
    ringDivisionCompetitionCommissioners?: RingDivisionCompetitionCommissioner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Ring implements IRing {
    ringId?: number;
    ringNumber?: number;
    expoId?: number;
    hallName?: string | undefined;
    ringDivisions?: RingDivision[] | undefined;
    expo?: Expo | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ringId = _data["ringId"];
            this.ringNumber = _data["ringNumber"];
            this.expoId = _data["expoId"];
            this.hallName = _data["hallName"];
            if (Array.isArray(_data["ringDivisions"])) {
                this.ringDivisions = [] as any;
                for (let item of _data["ringDivisions"])
                    this.ringDivisions!.push(RingDivision.fromJS(item));
            }
            this.expo = _data["expo"] ? Expo.fromJS(_data["expo"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Ring {
        data = typeof data === 'object' ? data : {};
        let result = new Ring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ringId"] = this.ringId;
        data["ringNumber"] = this.ringNumber;
        data["expoId"] = this.expoId;
        data["hallName"] = this.hallName;
        if (Array.isArray(this.ringDivisions)) {
            data["ringDivisions"] = [];
            for (let item of this.ringDivisions)
                data["ringDivisions"].push(item.toJSON());
        }
        data["expo"] = this.expo ? this.expo.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRing {
    ringId?: number;
    ringNumber?: number;
    expoId?: number;
    hallName?: string | undefined;
    ringDivisions?: RingDivision[] | undefined;
    expo?: Expo | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Expo implements IExpo {
    expoId?: number;
    subActivityId?: number;
    competitionDayId?: number;
    name?: string | undefined;
    cruft?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    subActivity?: SubActivity | undefined;
    competitionDay?: CompetitionDay | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
    rings?: Ring[] | undefined;
    competitionResults?: CompetitionResult[] | undefined;

    constructor(data?: IExpo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expoId = _data["expoId"];
            this.subActivityId = _data["subActivityId"];
            this.competitionDayId = _data["competitionDayId"];
            this.name = _data["name"];
            this.cruft = _data["cruft"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.subActivity = _data["subActivity"] ? SubActivity.fromJS(_data["subActivity"]) : <any>undefined;
            this.competitionDay = _data["competitionDay"] ? CompetitionDay.fromJS(_data["competitionDay"]) : <any>undefined;
            if (Array.isArray(_data["expoBreedForJudges"])) {
                this.expoBreedForJudges = [] as any;
                for (let item of _data["expoBreedForJudges"])
                    this.expoBreedForJudges!.push(ExpoBreedForJudge.fromJS(item));
            }
            if (Array.isArray(_data["rings"])) {
                this.rings = [] as any;
                for (let item of _data["rings"])
                    this.rings!.push(Ring.fromJS(item));
            }
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(CompetitionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Expo {
        data = typeof data === 'object' ? data : {};
        let result = new Expo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expoId"] = this.expoId;
        data["subActivityId"] = this.subActivityId;
        data["competitionDayId"] = this.competitionDayId;
        data["name"] = this.name;
        data["cruft"] = this.cruft;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["subActivity"] = this.subActivity ? this.subActivity.toJSON() : <any>undefined;
        data["competitionDay"] = this.competitionDay ? this.competitionDay.toJSON() : <any>undefined;
        if (Array.isArray(this.expoBreedForJudges)) {
            data["expoBreedForJudges"] = [];
            for (let item of this.expoBreedForJudges)
                data["expoBreedForJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.rings)) {
            data["rings"] = [];
            for (let item of this.rings)
                data["rings"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExpo {
    expoId?: number;
    subActivityId?: number;
    competitionDayId?: number;
    name?: string | undefined;
    cruft?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    subActivity?: SubActivity | undefined;
    competitionDay?: CompetitionDay | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
    rings?: Ring[] | undefined;
    competitionResults?: CompetitionResult[] | undefined;
}

export class CompetitionDay implements ICompetitionDay {
    competitionDayId?: number;
    competitionId?: number;
    dayDate?: Date;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    expos?: Expo[] | undefined;
    competition?: Competition | undefined;
    competitionCommissionerCompetitionDays?: CompetitionCommissionerCompetitionDay[] | undefined;

    constructor(data?: ICompetitionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionDayId = _data["competitionDayId"];
            this.competitionId = _data["competitionId"];
            this.dayDate = _data["dayDate"] ? new Date(_data["dayDate"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["expos"])) {
                this.expos = [] as any;
                for (let item of _data["expos"])
                    this.expos!.push(Expo.fromJS(item));
            }
            this.competition = _data["competition"] ? Competition.fromJS(_data["competition"]) : <any>undefined;
            if (Array.isArray(_data["competitionCommissionerCompetitionDays"])) {
                this.competitionCommissionerCompetitionDays = [] as any;
                for (let item of _data["competitionCommissionerCompetitionDays"])
                    this.competitionCommissionerCompetitionDays!.push(CompetitionCommissionerCompetitionDay.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitionDay {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionDayId"] = this.competitionDayId;
        data["competitionId"] = this.competitionId;
        data["dayDate"] = this.dayDate ? this.dayDate.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.expos)) {
            data["expos"] = [];
            for (let item of this.expos)
                data["expos"].push(item.toJSON());
        }
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        if (Array.isArray(this.competitionCommissionerCompetitionDays)) {
            data["competitionCommissionerCompetitionDays"] = [];
            for (let item of this.competitionCommissionerCompetitionDays)
                data["competitionCommissionerCompetitionDays"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitionDay {
    competitionDayId?: number;
    competitionId?: number;
    dayDate?: Date;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    expos?: Expo[] | undefined;
    competition?: Competition | undefined;
    competitionCommissionerCompetitionDays?: CompetitionCommissionerCompetitionDay[] | undefined;
}

export class CompetitionCommissionerCompetitionDay implements ICompetitionCommissionerCompetitionDay {
    competitionCommissionerCompetitionDayId?: number;
    competitionCommissionerId?: number;
    competitionDayId?: number;
    competitionCommissioner?: CompetitionCommissioner | undefined;
    competitionDay?: CompetitionDay | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionCommissionerCompetitionDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionCommissionerCompetitionDayId = _data["competitionCommissionerCompetitionDayId"];
            this.competitionCommissionerId = _data["competitionCommissionerId"];
            this.competitionDayId = _data["competitionDayId"];
            this.competitionCommissioner = _data["competitionCommissioner"] ? CompetitionCommissioner.fromJS(_data["competitionCommissioner"]) : <any>undefined;
            this.competitionDay = _data["competitionDay"] ? CompetitionDay.fromJS(_data["competitionDay"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionCommissionerCompetitionDay {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionCommissionerCompetitionDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionCommissionerCompetitionDayId"] = this.competitionCommissionerCompetitionDayId;
        data["competitionCommissionerId"] = this.competitionCommissionerId;
        data["competitionDayId"] = this.competitionDayId;
        data["competitionCommissioner"] = this.competitionCommissioner ? this.competitionCommissioner.toJSON() : <any>undefined;
        data["competitionDay"] = this.competitionDay ? this.competitionDay.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionCommissionerCompetitionDay {
    competitionCommissionerCompetitionDayId?: number;
    competitionCommissionerId?: number;
    competitionDayId?: number;
    competitionCommissioner?: CompetitionCommissioner | undefined;
    competitionDay?: CompetitionDay | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class RingDivisionCompetitionCommissioner implements IRingDivisionCompetitionCommissioner {
    ringDivisionCompetitionCommissionerId?: number;
    ringDivisionId?: number;
    competitionCommissionerId?: number;
    competitionCommissionerPresent?: boolean;
    ringDivision?: RingDivision | undefined;
    competitionCommissioner?: CompetitionCommissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRingDivisionCompetitionCommissioner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ringDivisionCompetitionCommissionerId = _data["ringDivisionCompetitionCommissionerId"];
            this.ringDivisionId = _data["ringDivisionId"];
            this.competitionCommissionerId = _data["competitionCommissionerId"];
            this.competitionCommissionerPresent = _data["competitionCommissionerPresent"];
            this.ringDivision = _data["ringDivision"] ? RingDivision.fromJS(_data["ringDivision"]) : <any>undefined;
            this.competitionCommissioner = _data["competitionCommissioner"] ? CompetitionCommissioner.fromJS(_data["competitionCommissioner"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RingDivisionCompetitionCommissioner {
        data = typeof data === 'object' ? data : {};
        let result = new RingDivisionCompetitionCommissioner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ringDivisionCompetitionCommissionerId"] = this.ringDivisionCompetitionCommissionerId;
        data["ringDivisionId"] = this.ringDivisionId;
        data["competitionCommissionerId"] = this.competitionCommissionerId;
        data["competitionCommissionerPresent"] = this.competitionCommissionerPresent;
        data["ringDivision"] = this.ringDivision ? this.ringDivision.toJSON() : <any>undefined;
        data["competitionCommissioner"] = this.competitionCommissioner ? this.competitionCommissioner.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRingDivisionCompetitionCommissioner {
    ringDivisionCompetitionCommissionerId?: number;
    ringDivisionId?: number;
    competitionCommissionerId?: number;
    competitionCommissionerPresent?: boolean;
    ringDivision?: RingDivision | undefined;
    competitionCommissioner?: CompetitionCommissioner | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedGroupJudge implements IBreedGroupJudge {
    breedGroupJudgeId?: number;
    judgeId?: number;
    breedGroupId?: number;
    judge?: Judge | undefined;
    breedGroup?: BreedGroup | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;

    constructor(data?: IBreedGroupJudge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupJudgeId = _data["breedGroupJudgeId"];
            this.judgeId = _data["judgeId"];
            this.breedGroupId = _data["breedGroupId"];
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.breedGroup = _data["breedGroup"] ? BreedGroup.fromJS(_data["breedGroup"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["expoBreedForJudges"])) {
                this.expoBreedForJudges = [] as any;
                for (let item of _data["expoBreedForJudges"])
                    this.expoBreedForJudges!.push(ExpoBreedForJudge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BreedGroupJudge {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupJudge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupJudgeId"] = this.breedGroupJudgeId;
        data["judgeId"] = this.judgeId;
        data["breedGroupId"] = this.breedGroupId;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["breedGroup"] = this.breedGroup ? this.breedGroup.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.expoBreedForJudges)) {
            data["expoBreedForJudges"] = [];
            for (let item of this.expoBreedForJudges)
                data["expoBreedForJudges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBreedGroupJudge {
    breedGroupJudgeId?: number;
    judgeId?: number;
    breedGroupId?: number;
    judge?: Judge | undefined;
    breedGroup?: BreedGroup | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    expoBreedForJudges?: ExpoBreedForJudge[] | undefined;
}

export class BreedGroup implements IBreedGroup {
    breedGroupId?: number;
    breedGroupNumber?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    breeds?: Breed[] | undefined;
    breedGroupTranslations?: BreedGroupTranslation[] | undefined;
    breedGroupsJudges?: BreedGroupJudge[] | undefined;
    competitionBreedGroups?: CompetitionBreedGroup[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupId = _data["breedGroupId"];
            this.breedGroupNumber = _data["breedGroupNumber"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            if (Array.isArray(_data["breeds"])) {
                this.breeds = [] as any;
                for (let item of _data["breeds"])
                    this.breeds!.push(Breed.fromJS(item));
            }
            if (Array.isArray(_data["breedGroupTranslations"])) {
                this.breedGroupTranslations = [] as any;
                for (let item of _data["breedGroupTranslations"])
                    this.breedGroupTranslations!.push(BreedGroupTranslation.fromJS(item));
            }
            if (Array.isArray(_data["breedGroupsJudges"])) {
                this.breedGroupsJudges = [] as any;
                for (let item of _data["breedGroupsJudges"])
                    this.breedGroupsJudges!.push(BreedGroupJudge.fromJS(item));
            }
            if (Array.isArray(_data["competitionBreedGroups"])) {
                this.competitionBreedGroups = [] as any;
                for (let item of _data["competitionBreedGroups"])
                    this.competitionBreedGroups!.push(CompetitionBreedGroup.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupId"] = this.breedGroupId;
        data["breedGroupNumber"] = this.breedGroupNumber;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        if (Array.isArray(this.breeds)) {
            data["breeds"] = [];
            for (let item of this.breeds)
                data["breeds"].push(item.toJSON());
        }
        if (Array.isArray(this.breedGroupTranslations)) {
            data["breedGroupTranslations"] = [];
            for (let item of this.breedGroupTranslations)
                data["breedGroupTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.breedGroupsJudges)) {
            data["breedGroupsJudges"] = [];
            for (let item of this.breedGroupsJudges)
                data["breedGroupsJudges"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionBreedGroups)) {
            data["competitionBreedGroups"] = [];
            for (let item of this.competitionBreedGroups)
                data["competitionBreedGroups"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedGroup {
    breedGroupId?: number;
    breedGroupNumber?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    breeds?: Breed[] | undefined;
    breedGroupTranslations?: BreedGroupTranslation[] | undefined;
    breedGroupsJudges?: BreedGroupJudge[] | undefined;
    competitionBreedGroups?: CompetitionBreedGroup[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedGroupTranslation implements IBreedGroupTranslation {
    breedGroupTranslationId?: number;
    breedGroupId?: number;
    languageId?: number;
    text?: string | undefined;
    breedGroup?: BreedGroup | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedGroupTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedGroupTranslationId = _data["breedGroupTranslationId"];
            this.breedGroupId = _data["breedGroupId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.breedGroup = _data["breedGroup"] ? BreedGroup.fromJS(_data["breedGroup"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedGroupTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedGroupTranslationId"] = this.breedGroupTranslationId;
        data["breedGroupId"] = this.breedGroupId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["breedGroup"] = this.breedGroup ? this.breedGroup.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedGroupTranslation {
    breedGroupTranslationId?: number;
    breedGroupId?: number;
    languageId?: number;
    text?: string | undefined;
    breedGroup?: BreedGroup | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CompetitionBreedGroup implements ICompetitionBreedGroup {
    competitionBreedGroupId?: number;
    breedGroupId?: number;
    competitionRequestId?: number;
    competitionRequest?: CompetitionRequest | undefined;
    breedGroup?: BreedGroup | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionBreedGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionBreedGroupId = _data["competitionBreedGroupId"];
            this.breedGroupId = _data["breedGroupId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.competitionRequest = _data["competitionRequest"] ? CompetitionRequest.fromJS(_data["competitionRequest"]) : <any>undefined;
            this.breedGroup = _data["breedGroup"] ? BreedGroup.fromJS(_data["breedGroup"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionBreedGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionBreedGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionBreedGroupId"] = this.competitionBreedGroupId;
        data["breedGroupId"] = this.breedGroupId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["competitionRequest"] = this.competitionRequest ? this.competitionRequest.toJSON() : <any>undefined;
        data["breedGroup"] = this.breedGroup ? this.breedGroup.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionBreedGroup {
    competitionBreedGroupId?: number;
    breedGroupId?: number;
    competitionRequestId?: number;
    competitionRequest?: CompetitionRequest | undefined;
    breedGroup?: BreedGroup | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class SubActivityJudge implements ISubActivityJudge {
    subActivityJudgeId?: number;
    judgeId?: number;
    subActivityId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    judge?: Judge | undefined;
    subActivity?: SubActivity | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ISubActivityJudge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivityJudgeId = _data["subActivityJudgeId"];
            this.judgeId = _data["judgeId"];
            this.subActivityId = _data["subActivityId"];
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.subActivity = _data["subActivity"] ? SubActivity.fromJS(_data["subActivity"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): SubActivityJudge {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityJudge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivityJudgeId"] = this.subActivityJudgeId;
        data["judgeId"] = this.judgeId;
        data["subActivityId"] = this.subActivityId;
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["subActivity"] = this.subActivity ? this.subActivity.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ISubActivityJudge {
    subActivityJudgeId?: number;
    judgeId?: number;
    subActivityId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    judge?: Judge | undefined;
    subActivity?: SubActivity | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class JudgesForClub implements IJudgesForClub {
    judgesForClubId?: number;
    clubId?: number;
    judgeId?: number;
    isAptForBeauty?: boolean;
    isAptForWork?: boolean;
    club?: Club | undefined;
    judge?: Judge | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IJudgesForClub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgesForClubId = _data["judgesForClubId"];
            this.clubId = _data["clubId"];
            this.judgeId = _data["judgeId"];
            this.isAptForBeauty = _data["isAptForBeauty"];
            this.isAptForWork = _data["isAptForWork"];
            this.club = _data["club"] ? Club.fromJS(_data["club"]) : <any>undefined;
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): JudgesForClub {
        data = typeof data === 'object' ? data : {};
        let result = new JudgesForClub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgesForClubId"] = this.judgesForClubId;
        data["clubId"] = this.clubId;
        data["judgeId"] = this.judgeId;
        data["isAptForBeauty"] = this.isAptForBeauty;
        data["isAptForWork"] = this.isAptForWork;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IJudgesForClub {
    judgesForClubId?: number;
    clubId?: number;
    judgeId?: number;
    isAptForBeauty?: boolean;
    isAptForWork?: boolean;
    club?: Club | undefined;
    judge?: Judge | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class JudgeSpokenLanguage implements IJudgeSpokenLanguage {
    judgeSpokenLanguageId?: number;
    judgeId?: number;
    languageId?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    judge?: Judge | undefined;
    language?: Language | undefined;

    constructor(data?: IJudgeSpokenLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgeSpokenLanguageId = _data["judgeSpokenLanguageId"];
            this.judgeId = _data["judgeId"];
            this.languageId = _data["languageId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.judge = _data["judge"] ? Judge.fromJS(_data["judge"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JudgeSpokenLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeSpokenLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgeSpokenLanguageId"] = this.judgeSpokenLanguageId;
        data["judgeId"] = this.judgeId;
        data["languageId"] = this.languageId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["judge"] = this.judge ? this.judge.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJudgeSpokenLanguage {
    judgeSpokenLanguageId?: number;
    judgeId?: number;
    languageId?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    judge?: Judge | undefined;
    language?: Language | undefined;
}

export class CompetitionVolunteerProfile implements ICompetitionVolunteerProfile {
    competitionVolunteerProfileId?: number;
    volunteerProfileId?: number;
    competitionId?: number;
    kmPaymentRate?: number | undefined;
    dayPaymentRate?: number | undefined;
    hotelFoodPayment?: number | undefined;
    minimalKmForHotel?: number | undefined;
    hotelAuthorized?: boolean;
    amountForHotelFood?: number | undefined;
    amountPerExpoDays?: number | undefined;
    amountPerTravelDays?: number | undefined;
    volunteerProfile?: VolunteerProfile | undefined;
    competition?: Competition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionVolunteerProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionVolunteerProfileId = _data["competitionVolunteerProfileId"];
            this.volunteerProfileId = _data["volunteerProfileId"];
            this.competitionId = _data["competitionId"];
            this.kmPaymentRate = _data["kmPaymentRate"];
            this.dayPaymentRate = _data["dayPaymentRate"];
            this.hotelFoodPayment = _data["hotelFoodPayment"];
            this.minimalKmForHotel = _data["minimalKmForHotel"];
            this.hotelAuthorized = _data["hotelAuthorized"];
            this.amountForHotelFood = _data["amountForHotelFood"];
            this.amountPerExpoDays = _data["amountPerExpoDays"];
            this.amountPerTravelDays = _data["amountPerTravelDays"];
            this.volunteerProfile = _data["volunteerProfile"] ? VolunteerProfile.fromJS(_data["volunteerProfile"]) : <any>undefined;
            this.competition = _data["competition"] ? Competition.fromJS(_data["competition"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionVolunteerProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionVolunteerProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionVolunteerProfileId"] = this.competitionVolunteerProfileId;
        data["volunteerProfileId"] = this.volunteerProfileId;
        data["competitionId"] = this.competitionId;
        data["kmPaymentRate"] = this.kmPaymentRate;
        data["dayPaymentRate"] = this.dayPaymentRate;
        data["hotelFoodPayment"] = this.hotelFoodPayment;
        data["minimalKmForHotel"] = this.minimalKmForHotel;
        data["hotelAuthorized"] = this.hotelAuthorized;
        data["amountForHotelFood"] = this.amountForHotelFood;
        data["amountPerExpoDays"] = this.amountPerExpoDays;
        data["amountPerTravelDays"] = this.amountPerTravelDays;
        data["volunteerProfile"] = this.volunteerProfile ? this.volunteerProfile.toJSON() : <any>undefined;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionVolunteerProfile {
    competitionVolunteerProfileId?: number;
    volunteerProfileId?: number;
    competitionId?: number;
    kmPaymentRate?: number | undefined;
    dayPaymentRate?: number | undefined;
    hotelFoodPayment?: number | undefined;
    minimalKmForHotel?: number | undefined;
    hotelAuthorized?: boolean;
    amountForHotelFood?: number | undefined;
    amountPerExpoDays?: number | undefined;
    amountPerTravelDays?: number | undefined;
    volunteerProfile?: VolunteerProfile | undefined;
    competition?: Competition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class VolunteerProfile implements IVolunteerProfile {
    volunteerProfileId?: number;
    code?: EVolunteerProfile;
    volunteerProfileTranslations?: VolunteerProfileTranslation[] | undefined;
    competitionVolunteerProfiles?: CompetitionVolunteerProfile[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IVolunteerProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.volunteerProfileId = _data["volunteerProfileId"];
            this.code = _data["code"];
            if (Array.isArray(_data["volunteerProfileTranslations"])) {
                this.volunteerProfileTranslations = [] as any;
                for (let item of _data["volunteerProfileTranslations"])
                    this.volunteerProfileTranslations!.push(VolunteerProfileTranslation.fromJS(item));
            }
            if (Array.isArray(_data["competitionVolunteerProfiles"])) {
                this.competitionVolunteerProfiles = [] as any;
                for (let item of _data["competitionVolunteerProfiles"])
                    this.competitionVolunteerProfiles!.push(CompetitionVolunteerProfile.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): VolunteerProfile {
        data = typeof data === 'object' ? data : {};
        let result = new VolunteerProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volunteerProfileId"] = this.volunteerProfileId;
        data["code"] = this.code;
        if (Array.isArray(this.volunteerProfileTranslations)) {
            data["volunteerProfileTranslations"] = [];
            for (let item of this.volunteerProfileTranslations)
                data["volunteerProfileTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.competitionVolunteerProfiles)) {
            data["competitionVolunteerProfiles"] = [];
            for (let item of this.competitionVolunteerProfiles)
                data["competitionVolunteerProfiles"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IVolunteerProfile {
    volunteerProfileId?: number;
    code?: EVolunteerProfile;
    volunteerProfileTranslations?: VolunteerProfileTranslation[] | undefined;
    competitionVolunteerProfiles?: CompetitionVolunteerProfile[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EVolunteerProfile {
    Commissioneer = "Commissioneer",
    Judge = "Judge",
}

export class VolunteerProfileTranslation implements IVolunteerProfileTranslation {
    volunteerProfileTranslationId?: number;
    volunteerProfileId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    volunteerProfile?: VolunteerProfile | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IVolunteerProfileTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.volunteerProfileTranslationId = _data["volunteerProfileTranslationId"];
            this.volunteerProfileId = _data["volunteerProfileId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.volunteerProfile = _data["volunteerProfile"] ? VolunteerProfile.fromJS(_data["volunteerProfile"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): VolunteerProfileTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new VolunteerProfileTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["volunteerProfileTranslationId"] = this.volunteerProfileTranslationId;
        data["volunteerProfileId"] = this.volunteerProfileId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["volunteerProfile"] = this.volunteerProfile ? this.volunteerProfile.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IVolunteerProfileTranslation {
    volunteerProfileTranslationId?: number;
    volunteerProfileId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    volunteerProfile?: VolunteerProfile | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CompetitionBreed implements ICompetitionBreed {
    competitionBreedId?: number;
    breedId?: number;
    competitionRequestId?: number;
    breed?: Breed | undefined;
    competitionRequest?: CompetitionRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionBreedId = _data["competitionBreedId"];
            this.breedId = _data["breedId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.competitionRequest = _data["competitionRequest"] ? CompetitionRequest.fromJS(_data["competitionRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionBreed {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionBreedId"] = this.competitionBreedId;
        data["breedId"] = this.breedId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["competitionRequest"] = this.competitionRequest ? this.competitionRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionBreed {
    competitionBreedId?: number;
    breedId?: number;
    competitionRequestId?: number;
    breed?: Breed | undefined;
    competitionRequest?: CompetitionRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ActivityTranslation implements IActivityTranslation {
    activityTranslationId?: number;
    activityId?: number;
    languageId?: number;
    text?: string | undefined;
    activity?: Activity | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IActivityTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityTranslationId = _data["activityTranslationId"];
            this.activityId = _data["activityId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ActivityTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTranslationId"] = this.activityTranslationId;
        data["activityId"] = this.activityId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IActivityTranslation {
    activityTranslationId?: number;
    activityId?: number;
    languageId?: number;
    text?: string | undefined;
    activity?: Activity | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ClubContact implements IClubContact {
    clubContactId?: number;
    clubId?: number;
    clubRoleId?: number;
    personId?: number;
    club?: Club | undefined;
    clubRole?: ClubRole | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClubContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubContactId = _data["clubContactId"];
            this.clubId = _data["clubId"];
            this.clubRoleId = _data["clubRoleId"];
            this.personId = _data["personId"];
            this.club = _data["club"] ? Club.fromJS(_data["club"]) : <any>undefined;
            this.clubRole = _data["clubRole"] ? ClubRole.fromJS(_data["clubRole"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClubContact {
        data = typeof data === 'object' ? data : {};
        let result = new ClubContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubContactId"] = this.clubContactId;
        data["clubId"] = this.clubId;
        data["clubRoleId"] = this.clubRoleId;
        data["personId"] = this.personId;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["clubRole"] = this.clubRole ? this.clubRole.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClubContact {
    clubContactId?: number;
    clubId?: number;
    clubRoleId?: number;
    personId?: number;
    club?: Club | undefined;
    clubRole?: ClubRole | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ClubRole implements IClubRole {
    clubRoleId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    clubRoleCode?: EClubRoles;
    clubsContacts?: ClubContact[] | undefined;
    clubRoleTranslations?: ClubRoleTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClubRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubRoleId = _data["clubRoleId"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.clubRoleCode = _data["clubRoleCode"];
            if (Array.isArray(_data["clubsContacts"])) {
                this.clubsContacts = [] as any;
                for (let item of _data["clubsContacts"])
                    this.clubsContacts!.push(ClubContact.fromJS(item));
            }
            if (Array.isArray(_data["clubRoleTranslations"])) {
                this.clubRoleTranslations = [] as any;
                for (let item of _data["clubRoleTranslations"])
                    this.clubRoleTranslations!.push(ClubRoleTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClubRole {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubRoleId"] = this.clubRoleId;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["clubRoleCode"] = this.clubRoleCode;
        if (Array.isArray(this.clubsContacts)) {
            data["clubsContacts"] = [];
            for (let item of this.clubsContacts)
                data["clubsContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.clubRoleTranslations)) {
            data["clubRoleTranslations"] = [];
            for (let item of this.clubRoleTranslations)
                data["clubRoleTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClubRole {
    clubRoleId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    clubRoleCode?: EClubRoles;
    clubsContacts?: ClubContact[] | undefined;
    clubRoleTranslations?: ClubRoleTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EClubRoles {
    CONTACT_CLUB = "CONTACT_CLUB",
    SECRETARY = "SECRETARY",
    CHAIRMAN = "CHAIRMAN",
    TREASURER = "TREASURER",
    GENERAL_SECRETARY = "GENERAL_SECRETARY",
    DEPUTY_SECRETARY = "DEPUTY_SECRETARY",
    MATCH_SECRETARY = "MATCH_SECRETARY",
}

export class ClubRoleTranslation implements IClubRoleTranslation {
    clubRoleTranslationId?: number;
    clubRoleId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    clubRole?: ClubRole | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClubRoleTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubRoleTranslationId = _data["clubRoleTranslationId"];
            this.clubRoleId = _data["clubRoleId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.clubRole = _data["clubRole"] ? ClubRole.fromJS(_data["clubRole"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClubRoleTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRoleTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubRoleTranslationId"] = this.clubRoleTranslationId;
        data["clubRoleId"] = this.clubRoleId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["clubRole"] = this.clubRole ? this.clubRole.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClubRoleTranslation {
    clubRoleTranslationId?: number;
    clubRoleId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    clubRole?: ClubRole | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class MiscellaneousRequest implements IMiscellaneousRequest {
    miscellaneousRequestId?: number;
    requestId?: number;
    articleId?: number;
    quantity?: number;
    request?: Request | undefined;
    article?: Article | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IMiscellaneousRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.miscellaneousRequestId = _data["miscellaneousRequestId"];
            this.requestId = _data["requestId"];
            this.articleId = _data["articleId"];
            this.quantity = _data["quantity"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MiscellaneousRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MiscellaneousRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["miscellaneousRequestId"] = this.miscellaneousRequestId;
        data["requestId"] = this.requestId;
        data["articleId"] = this.articleId;
        data["quantity"] = this.quantity;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMiscellaneousRequest {
    miscellaneousRequestId?: number;
    requestId?: number;
    articleId?: number;
    quantity?: number;
    request?: Request | undefined;
    article?: Article | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class InvoiceItem implements IInvoiceItem {
    invoiceItemId?: number;
    invoiceId?: number;
    articleId?: number;
    creditMemoBcIdentifier?: string | undefined;
    article?: Article | undefined;
    invoice?: Invoice | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemId = _data["invoiceItemId"];
            this.invoiceId = _data["invoiceId"];
            this.articleId = _data["articleId"];
            this.creditMemoBcIdentifier = _data["creditMemoBcIdentifier"];
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): InvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceItemId"] = this.invoiceItemId;
        data["invoiceId"] = this.invoiceId;
        data["articleId"] = this.articleId;
        data["creditMemoBcIdentifier"] = this.creditMemoBcIdentifier;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IInvoiceItem {
    invoiceItemId?: number;
    invoiceId?: number;
    articleId?: number;
    creditMemoBcIdentifier?: string | undefined;
    article?: Article | undefined;
    invoice?: Invoice | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Invoice implements IInvoice {
    invoiceId?: number;
    requestId?: number;
    invoiceBcIdentifier?: string | undefined;
    paid?: boolean;
    alreadyPrinted?: boolean;
    totalPrice?: number;
    structuredCommunication?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    request?: Request | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.requestId = _data["requestId"];
            this.invoiceBcIdentifier = _data["invoiceBcIdentifier"];
            this.paid = _data["paid"];
            this.alreadyPrinted = _data["alreadyPrinted"];
            this.totalPrice = _data["totalPrice"];
            this.structuredCommunication = _data["structuredCommunication"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItem.fromJS(item));
            }
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["requestId"] = this.requestId;
        data["invoiceBcIdentifier"] = this.invoiceBcIdentifier;
        data["paid"] = this.paid;
        data["alreadyPrinted"] = this.alreadyPrinted;
        data["totalPrice"] = this.totalPrice;
        data["structuredCommunication"] = this.structuredCommunication;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IInvoice {
    invoiceId?: number;
    requestId?: number;
    invoiceBcIdentifier?: string | undefined;
    paid?: boolean;
    alreadyPrinted?: boolean;
    totalPrice?: number;
    structuredCommunication?: string | undefined;
    invoiceItems?: InvoiceItem[] | undefined;
    request?: Request | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthTestRequestCharacteristicTransient implements IHealthTestRequestCharacteristicTransient {
    healthTestRequestCharacteristicTransientId?: number;
    dogId?: number | undefined;
    characteristicId?: number;
    healthValueId?: number | undefined;
    value?: string | undefined;
    healthTestRequestHealthPackTransientId?: number;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    healthTestRequestHealthPackTransient?: HealthTestRequestHealthPackTransient | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IHealthTestRequestCharacteristicTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthTestRequestCharacteristicTransientId = _data["healthTestRequestCharacteristicTransientId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.value = _data["value"];
            this.healthTestRequestHealthPackTransientId = _data["healthTestRequestHealthPackTransientId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.healthTestRequestHealthPackTransient = _data["healthTestRequestHealthPackTransient"] ? HealthTestRequestHealthPackTransient.fromJS(_data["healthTestRequestHealthPackTransient"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthTestRequestCharacteristicTransient {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestCharacteristicTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestRequestCharacteristicTransientId"] = this.healthTestRequestCharacteristicTransientId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["value"] = this.value;
        data["healthTestRequestHealthPackTransientId"] = this.healthTestRequestHealthPackTransientId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["healthTestRequestHealthPackTransient"] = this.healthTestRequestHealthPackTransient ? this.healthTestRequestHealthPackTransient.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthTestRequestCharacteristicTransient {
    healthTestRequestCharacteristicTransientId?: number;
    dogId?: number | undefined;
    characteristicId?: number;
    healthValueId?: number | undefined;
    value?: string | undefined;
    healthTestRequestHealthPackTransientId?: number;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    healthTestRequestHealthPackTransient?: HealthTestRequestHealthPackTransient | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class HealthValue implements IHealthValue {
    healthValueId?: number;
    value?: string | undefined;
    remark?: string | undefined;
    lab?: ELab | undefined;
    labTestValue?: ELabTestValues | undefined;
    okForInheritance?: boolean;
    characteristicsValues?: CharacteristicValue[] | undefined;
    dogsCharacteristicsValues?: DogCharacteristicValue[] | undefined;
    healthValueTranslations?: HealthValueTranslation[] | undefined;
    usersDysplasiasResults?: UserDysplasiaResult[] | undefined;
    healthTestRequestsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueId = _data["healthValueId"];
            this.value = _data["value"];
            this.remark = _data["remark"];
            this.lab = _data["lab"];
            this.labTestValue = _data["labTestValue"];
            this.okForInheritance = _data["okForInheritance"];
            if (Array.isArray(_data["characteristicsValues"])) {
                this.characteristicsValues = [] as any;
                for (let item of _data["characteristicsValues"])
                    this.characteristicsValues!.push(CharacteristicValue.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValues"])) {
                this.dogsCharacteristicsValues = [] as any;
                for (let item of _data["dogsCharacteristicsValues"])
                    this.dogsCharacteristicsValues!.push(DogCharacteristicValue.fromJS(item));
            }
            if (Array.isArray(_data["healthValueTranslations"])) {
                this.healthValueTranslations = [] as any;
                for (let item of _data["healthValueTranslations"])
                    this.healthValueTranslations!.push(HealthValueTranslation.fromJS(item));
            }
            if (Array.isArray(_data["usersDysplasiasResults"])) {
                this.usersDysplasiasResults = [] as any;
                for (let item of _data["usersDysplasiasResults"])
                    this.usersDysplasiasResults!.push(UserDysplasiaResult.fromJS(item));
            }
            if (Array.isArray(_data["healthTestRequestsTransients"])) {
                this.healthTestRequestsTransients = [] as any;
                for (let item of _data["healthTestRequestsTransients"])
                    this.healthTestRequestsTransients!.push(HealthTestRequestCharacteristicTransient.fromJS(item));
            }
            if (Array.isArray(_data["dogsCharacteristicsValuesTransients"])) {
                this.dogsCharacteristicsValuesTransients = [] as any;
                for (let item of _data["dogsCharacteristicsValuesTransients"])
                    this.dogsCharacteristicsValuesTransients!.push(DogsCharacteristicsValuesTransient.fromJS(item));
            }
            if (Array.isArray(_data["healthTestSingleCharacteristicTransients"])) {
                this.healthTestSingleCharacteristicTransients = [] as any;
                for (let item of _data["healthTestSingleCharacteristicTransients"])
                    this.healthTestSingleCharacteristicTransients!.push(HealthTestSingleCharacteristicTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthValue {
        data = typeof data === 'object' ? data : {};
        let result = new HealthValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueId"] = this.healthValueId;
        data["value"] = this.value;
        data["remark"] = this.remark;
        data["lab"] = this.lab;
        data["labTestValue"] = this.labTestValue;
        data["okForInheritance"] = this.okForInheritance;
        if (Array.isArray(this.characteristicsValues)) {
            data["characteristicsValues"] = [];
            for (let item of this.characteristicsValues)
                data["characteristicsValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValues)) {
            data["dogsCharacteristicsValues"] = [];
            for (let item of this.dogsCharacteristicsValues)
                data["dogsCharacteristicsValues"].push(item.toJSON());
        }
        if (Array.isArray(this.healthValueTranslations)) {
            data["healthValueTranslations"] = [];
            for (let item of this.healthValueTranslations)
                data["healthValueTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.usersDysplasiasResults)) {
            data["usersDysplasiasResults"] = [];
            for (let item of this.usersDysplasiasResults)
                data["usersDysplasiasResults"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestRequestsTransients)) {
            data["healthTestRequestsTransients"] = [];
            for (let item of this.healthTestRequestsTransients)
                data["healthTestRequestsTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.dogsCharacteristicsValuesTransients)) {
            data["dogsCharacteristicsValuesTransients"] = [];
            for (let item of this.dogsCharacteristicsValuesTransients)
                data["dogsCharacteristicsValuesTransients"].push(item.toJSON());
        }
        if (Array.isArray(this.healthTestSingleCharacteristicTransients)) {
            data["healthTestSingleCharacteristicTransients"] = [];
            for (let item of this.healthTestSingleCharacteristicTransients)
                data["healthTestSingleCharacteristicTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthValue {
    healthValueId?: number;
    value?: string | undefined;
    remark?: string | undefined;
    lab?: ELab | undefined;
    labTestValue?: ELabTestValues | undefined;
    okForInheritance?: boolean;
    characteristicsValues?: CharacteristicValue[] | undefined;
    dogsCharacteristicsValues?: DogCharacteristicValue[] | undefined;
    healthValueTranslations?: HealthValueTranslation[] | undefined;
    usersDysplasiasResults?: UserDysplasiaResult[] | undefined;
    healthTestRequestsTransients?: HealthTestRequestCharacteristicTransient[] | undefined;
    dogsCharacteristicsValuesTransients?: DogsCharacteristicsValuesTransient[] | undefined;
    healthTestSingleCharacteristicTransients?: HealthTestSingleCharacteristicTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum ELabTestValues {
    CARRIER = "CARRIER",
    CLEAR = "CLEAR",
    AFFECTED = "AFFECTED",
}

export class CharacteristicValue implements ICharacteristicValue {
    characteristicValueId?: number;
    characteristicId?: number;
    healthValueId?: number;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICharacteristicValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicValueId = _data["characteristicValueId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CharacteristicValue {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicValueId"] = this.characteristicValueId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICharacteristicValue {
    characteristicValueId?: number;
    characteristicId?: number;
    healthValueId?: number;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogCharacteristicValue implements IDogCharacteristicValue {
    dogCharacteristicValueId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    invalidatedOn?: Date | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogCharacteristicValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogCharacteristicValueId = _data["dogCharacteristicValueId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.alphaValue = _data["alphaValue"];
            this.invalidatedOn = _data["invalidatedOn"] ? new Date(_data["invalidatedOn"].toString()) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogCharacteristicValue {
        data = typeof data === 'object' ? data : {};
        let result = new DogCharacteristicValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogCharacteristicValueId"] = this.dogCharacteristicValueId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["alphaValue"] = this.alphaValue;
        data["invalidatedOn"] = this.invalidatedOn ? this.invalidatedOn.toISOString() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogCharacteristicValue {
    dogCharacteristicValueId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    invalidatedOn?: Date | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthValueTranslation implements IHealthValueTranslation {
    healthValueTranslationId?: number;
    healthValueId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthValueTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueTranslationId = _data["healthValueTranslationId"];
            this.healthValueId = _data["healthValueId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthValueTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new HealthValueTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueTranslationId"] = this.healthValueTranslationId;
        data["healthValueId"] = this.healthValueId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthValueTranslation {
    healthValueTranslationId?: number;
    healthValueId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    healthValue?: HealthValue | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogsCharacteristicsValuesTransient implements IDogsCharacteristicsValuesTransient {
    dogsCharacteristicsValuesTransientId?: number;
    dogId?: number;
    managerId?: number | undefined;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    closedOn?: Date | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    manager?: User | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogsCharacteristicsValuesTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogsCharacteristicsValuesTransientId = _data["dogsCharacteristicsValuesTransientId"];
            this.dogId = _data["dogId"];
            this.managerId = _data["managerId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.alphaValue = _data["alphaValue"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogsCharacteristicsValuesTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogsCharacteristicsValuesTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogsCharacteristicsValuesTransientId"] = this.dogsCharacteristicsValuesTransientId;
        data["dogId"] = this.dogId;
        data["managerId"] = this.managerId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["alphaValue"] = this.alphaValue;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogsCharacteristicsValuesTransient {
    dogsCharacteristicsValuesTransientId?: number;
    dogId?: number;
    managerId?: number | undefined;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    closedOn?: Date | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    manager?: User | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthTestSingleCharacteristicTransient implements IHealthTestSingleCharacteristicTransient {
    healthTestSingleCharacteristicTransientId?: number;
    dogId?: number | undefined;
    characteristicId?: number;
    healthValueId?: number | undefined;
    value?: string | undefined;
    healthTestRequestId?: number;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IHealthTestSingleCharacteristicTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthTestSingleCharacteristicTransientId = _data["healthTestSingleCharacteristicTransientId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.value = _data["value"];
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.healthTestRequest = _data["healthTestRequest"] ? HealthTestRequest.fromJS(_data["healthTestRequest"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthTestSingleCharacteristicTransient {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestSingleCharacteristicTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestSingleCharacteristicTransientId"] = this.healthTestSingleCharacteristicTransientId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["value"] = this.value;
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["healthTestRequest"] = this.healthTestRequest ? this.healthTestRequest.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthTestSingleCharacteristicTransient {
    healthTestSingleCharacteristicTransientId?: number;
    dogId?: number | undefined;
    characteristicId?: number;
    healthValueId?: number | undefined;
    value?: string | undefined;
    healthTestRequestId?: number;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class CharacteristicTranslation implements ICharacteristicTranslation {
    characteristicTranslationId?: number;
    characteristicId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    characteristic?: Characteristic | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICharacteristicTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicTranslationId = _data["characteristicTranslationId"];
            this.characteristicId = _data["characteristicId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CharacteristicTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicTranslationId"] = this.characteristicTranslationId;
        data["characteristicId"] = this.characteristicId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICharacteristicTranslation {
    characteristicTranslationId?: number;
    characteristicId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    characteristic?: Characteristic | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogDysplasia implements IDogDysplasia {
    dogDysplasiaId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    dysplasiaRequestId?: number | undefined;
    radioDate?: Date | undefined;
    evaluationDate?: Date | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    dysplasiaRequest?: DysplasiaRequest | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IDogDysplasia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDysplasiaId = _data["dogDysplasiaId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.radioDate = _data["radioDate"] ? new Date(_data["radioDate"].toString()) : <any>undefined;
            this.evaluationDate = _data["evaluationDate"] ? new Date(_data["evaluationDate"].toString()) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthValue = _data["healthValue"] ? HealthValue.fromJS(_data["healthValue"]) : <any>undefined;
            this.dysplasiaRequest = _data["dysplasiaRequest"] ? DysplasiaRequest.fromJS(_data["dysplasiaRequest"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogDysplasia {
        data = typeof data === 'object' ? data : {};
        let result = new DogDysplasia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDysplasiaId"] = this.dogDysplasiaId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["radioDate"] = this.radioDate ? this.radioDate.toISOString() : <any>undefined;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthValue"] = this.healthValue ? this.healthValue.toJSON() : <any>undefined;
        data["dysplasiaRequest"] = this.dysplasiaRequest ? this.dysplasiaRequest.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogDysplasia {
    dogDysplasiaId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    dysplasiaRequestId?: number | undefined;
    radioDate?: Date | undefined;
    evaluationDate?: Date | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthValue?: HealthValue | undefined;
    dysplasiaRequest?: DysplasiaRequest | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class DogHealthTestCharacteristicValueTransient implements IDogHealthTestCharacteristicValueTransient {
    dogHealthTestCharacteristicValueTransientId?: number;
    dogId?: number;
    healthTestRequestId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogHealthTestCharacteristicValueTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogHealthTestCharacteristicValueTransientId = _data["dogHealthTestCharacteristicValueTransientId"];
            this.dogId = _data["dogId"];
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.alphaValue = _data["alphaValue"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.characteristic = _data["characteristic"] ? Characteristic.fromJS(_data["characteristic"]) : <any>undefined;
            this.healthTestRequest = _data["healthTestRequest"] ? HealthTestRequest.fromJS(_data["healthTestRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogHealthTestCharacteristicValueTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthTestCharacteristicValueTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogHealthTestCharacteristicValueTransientId"] = this.dogHealthTestCharacteristicValueTransientId;
        data["dogId"] = this.dogId;
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["alphaValue"] = this.alphaValue;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["healthTestRequest"] = this.healthTestRequest ? this.healthTestRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogHealthTestCharacteristicValueTransient {
    dogHealthTestCharacteristicValueTransientId?: number;
    dogId?: number;
    healthTestRequestId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    dog?: Dog | undefined;
    characteristic?: Characteristic | undefined;
    healthTestRequest?: HealthTestRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class HealthPackTranslation implements IHealthPackTranslation {
    healthPackTranslationId?: number;
    text?: string | undefined;
    languageId?: number;
    healthPackId?: number;
    healthPack?: HealthPack | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IHealthPackTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackTranslationId = _data["healthPackTranslationId"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.healthPackId = _data["healthPackId"];
            this.healthPack = _data["healthPack"] ? HealthPack.fromJS(_data["healthPack"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): HealthPackTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackTranslationId"] = this.healthPackTranslationId;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["healthPackId"] = this.healthPackId;
        data["healthPack"] = this.healthPack ? this.healthPack.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IHealthPackTranslation {
    healthPackTranslationId?: number;
    text?: string | undefined;
    languageId?: number;
    healthPackId?: number;
    healthPack?: HealthPack | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Kennel implements IKennel {
    kennelId?: number;
    name?: string | undefined;
    type?: EKennelType;
    fciNumber?: string | undefined;
    countryId?: number | undefined;
    originCountryId?: number | undefined;
    attributionDate?: Date | undefined;
    closingDate?: Date | undefined;
    publishingDate?: Date | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    previousKennelId?: number | undefined;
    country?: Country | undefined;
    originCountry?: Country | undefined;
    previousKennel?: Kennel | undefined;
    dogs?: Dog[] | undefined;
    kennelsOwnerships?: KennelOwnership[] | undefined;
    kennelsBreeds?: KennelBreed[] | undefined;
    previousKennels?: Kennel[] | undefined;
    kennelExportRequests?: KennelExportRequest[] | undefined;
    kennelNameChangeRequests?: KennelNameChangeRequest[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;

    constructor(data?: IKennel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelId = _data["kennelId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.fciNumber = _data["fciNumber"];
            this.countryId = _data["countryId"];
            this.originCountryId = _data["originCountryId"];
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.publishingDate = _data["publishingDate"] ? new Date(_data["publishingDate"].toString()) : <any>undefined;
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionStartDate = _data["exclusionStartDate"] ? new Date(_data["exclusionStartDate"].toString()) : <any>undefined;
            this.exclusionEndDate = _data["exclusionEndDate"] ? new Date(_data["exclusionEndDate"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.previousKennelId = _data["previousKennelId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.originCountry = _data["originCountry"] ? Country.fromJS(_data["originCountry"]) : <any>undefined;
            this.previousKennel = _data["previousKennel"] ? Kennel.fromJS(_data["previousKennel"]) : <any>undefined;
            if (Array.isArray(_data["dogs"])) {
                this.dogs = [] as any;
                for (let item of _data["dogs"])
                    this.dogs!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["kennelsOwnerships"])) {
                this.kennelsOwnerships = [] as any;
                for (let item of _data["kennelsOwnerships"])
                    this.kennelsOwnerships!.push(KennelOwnership.fromJS(item));
            }
            if (Array.isArray(_data["kennelsBreeds"])) {
                this.kennelsBreeds = [] as any;
                for (let item of _data["kennelsBreeds"])
                    this.kennelsBreeds!.push(KennelBreed.fromJS(item));
            }
            if (Array.isArray(_data["previousKennels"])) {
                this.previousKennels = [] as any;
                for (let item of _data["previousKennels"])
                    this.previousKennels!.push(Kennel.fromJS(item));
            }
            if (Array.isArray(_data["kennelExportRequests"])) {
                this.kennelExportRequests = [] as any;
                for (let item of _data["kennelExportRequests"])
                    this.kennelExportRequests!.push(KennelExportRequest.fromJS(item));
            }
            if (Array.isArray(_data["kennelNameChangeRequests"])) {
                this.kennelNameChangeRequests = [] as any;
                for (let item of _data["kennelNameChangeRequests"])
                    this.kennelNameChangeRequests!.push(KennelNameChangeRequest.fromJS(item));
            }
            if (Array.isArray(_data["dogBroodRequestsTransients"])) {
                this.dogBroodRequestsTransients = [] as any;
                for (let item of _data["dogBroodRequestsTransients"])
                    this.dogBroodRequestsTransients!.push(DogBroodRequestsTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): Kennel {
        data = typeof data === 'object' ? data : {};
        let result = new Kennel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelId"] = this.kennelId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["fciNumber"] = this.fciNumber;
        data["countryId"] = this.countryId;
        data["originCountryId"] = this.originCountryId;
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["publishingDate"] = this.publishingDate ? this.publishingDate.toISOString() : <any>undefined;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionStartDate"] = this.exclusionStartDate ? this.exclusionStartDate.toISOString() : <any>undefined;
        data["exclusionEndDate"] = this.exclusionEndDate ? this.exclusionEndDate.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["previousKennelId"] = this.previousKennelId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["originCountry"] = this.originCountry ? this.originCountry.toJSON() : <any>undefined;
        data["previousKennel"] = this.previousKennel ? this.previousKennel.toJSON() : <any>undefined;
        if (Array.isArray(this.dogs)) {
            data["dogs"] = [];
            for (let item of this.dogs)
                data["dogs"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelsOwnerships)) {
            data["kennelsOwnerships"] = [];
            for (let item of this.kennelsOwnerships)
                data["kennelsOwnerships"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelsBreeds)) {
            data["kennelsBreeds"] = [];
            for (let item of this.kennelsBreeds)
                data["kennelsBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.previousKennels)) {
            data["previousKennels"] = [];
            for (let item of this.previousKennels)
                data["previousKennels"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelExportRequests)) {
            data["kennelExportRequests"] = [];
            for (let item of this.kennelExportRequests)
                data["kennelExportRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.kennelNameChangeRequests)) {
            data["kennelNameChangeRequests"] = [];
            for (let item of this.kennelNameChangeRequests)
                data["kennelNameChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.dogBroodRequestsTransients)) {
            data["dogBroodRequestsTransients"] = [];
            for (let item of this.dogBroodRequestsTransients)
                data["dogBroodRequestsTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface IKennel {
    kennelId?: number;
    name?: string | undefined;
    type?: EKennelType;
    fciNumber?: string | undefined;
    countryId?: number | undefined;
    originCountryId?: number | undefined;
    attributionDate?: Date | undefined;
    closingDate?: Date | undefined;
    publishingDate?: Date | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    previousKennelId?: number | undefined;
    country?: Country | undefined;
    originCountry?: Country | undefined;
    previousKennel?: Kennel | undefined;
    dogs?: Dog[] | undefined;
    kennelsOwnerships?: KennelOwnership[] | undefined;
    kennelsBreeds?: KennelBreed[] | undefined;
    previousKennels?: Kennel[] | undefined;
    kennelExportRequests?: KennelExportRequest[] | undefined;
    kennelNameChangeRequests?: KennelNameChangeRequest[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    sharepointUri?: string | undefined;
}

export class KennelOwnership implements IKennelOwnership {
    kennelOwnershipId?: number;
    kennelId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
    kennel?: Kennel | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: IKennelOwnership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelOwnershipId = _data["kennelOwnershipId"];
            this.kennelId = _data["kennelId"];
            this.personId = _data["personId"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): KennelOwnership {
        data = typeof data === 'object' ? data : {};
        let result = new KennelOwnership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelOwnershipId"] = this.kennelOwnershipId;
        data["kennelId"] = this.kennelId;
        data["personId"] = this.personId;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IKennelOwnership {
    kennelOwnershipId?: number;
    kennelId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
    kennel?: Kennel | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class KennelBreed implements IKennelBreed {
    kennelBreedId?: number;
    breedId?: number;
    kennelId?: number;
    breed?: Breed | undefined;
    kennel?: Kennel | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IKennelBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelBreedId = _data["kennelBreedId"];
            this.breedId = _data["breedId"];
            this.kennelId = _data["kennelId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): KennelBreed {
        data = typeof data === 'object' ? data : {};
        let result = new KennelBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelBreedId"] = this.kennelBreedId;
        data["breedId"] = this.breedId;
        data["kennelId"] = this.kennelId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IKennelBreed {
    kennelBreedId?: number;
    breedId?: number;
    kennelId?: number;
    breed?: Breed | undefined;
    kennel?: Kennel | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class KennelExportRequest implements IKennelExportRequest {
    kennelExportRequestId?: number;
    requestId?: number;
    countryId?: number;
    kennelId?: number;
    request?: Request | undefined;
    country?: Country | undefined;
    kennel?: Kennel | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IKennelExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelExportRequestId = _data["kennelExportRequestId"];
            this.requestId = _data["requestId"];
            this.countryId = _data["countryId"];
            this.kennelId = _data["kennelId"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): KennelExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KennelExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelExportRequestId"] = this.kennelExportRequestId;
        data["requestId"] = this.requestId;
        data["countryId"] = this.countryId;
        data["kennelId"] = this.kennelId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IKennelExportRequest {
    kennelExportRequestId?: number;
    requestId?: number;
    countryId?: number;
    kennelId?: number;
    request?: Request | undefined;
    country?: Country | undefined;
    kennel?: Kennel | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class KennelNameChangeRequest implements IKennelNameChangeRequest {
    kennelNameChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    request?: Request | undefined;
    kennel?: Kennel | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IKennelNameChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelNameChangeRequestId = _data["kennelNameChangeRequestId"];
            this.requestId = _data["requestId"];
            this.kennelId = _data["kennelId"];
            this.nameOffer1 = _data["nameOffer1"];
            this.nameOffer1Type = _data["nameOffer1Type"];
            this.finalName = _data["finalName"];
            this.finalType = _data["finalType"];
            this.fciNumber = _data["fciNumber"];
            this.exportDate = _data["exportDate"] ? new Date(_data["exportDate"].toString()) : <any>undefined;
            this.exportForcedValue = _data["exportForcedValue"];
            this.tries = _data["tries"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): KennelNameChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KennelNameChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelNameChangeRequestId"] = this.kennelNameChangeRequestId;
        data["requestId"] = this.requestId;
        data["kennelId"] = this.kennelId;
        data["nameOffer1"] = this.nameOffer1;
        data["nameOffer1Type"] = this.nameOffer1Type;
        data["finalName"] = this.finalName;
        data["finalType"] = this.finalType;
        data["fciNumber"] = this.fciNumber;
        data["exportDate"] = this.exportDate ? this.exportDate.toISOString() : <any>undefined;
        data["exportForcedValue"] = this.exportForcedValue;
        data["tries"] = this.tries;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IKennelNameChangeRequest {
    kennelNameChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    request?: Request | undefined;
    kennel?: Kennel | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class WorkAttestRequest implements IWorkAttestRequest {
    workAttestRequestId?: number;
    requestId?: number;
    countryId?: number;
    dogId?: number;
    competitionDate?: Date;
    competitionPoints?: string | undefined;
    competitionJudge?: string | undefined;
    competitionCity?: string | undefined;
    competitionType?: string | undefined;
    request?: Request | undefined;
    country?: Country | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IWorkAttestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workAttestRequestId = _data["workAttestRequestId"];
            this.requestId = _data["requestId"];
            this.countryId = _data["countryId"];
            this.dogId = _data["dogId"];
            this.competitionDate = _data["competitionDate"] ? new Date(_data["competitionDate"].toString()) : <any>undefined;
            this.competitionPoints = _data["competitionPoints"];
            this.competitionJudge = _data["competitionJudge"];
            this.competitionCity = _data["competitionCity"];
            this.competitionType = _data["competitionType"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): WorkAttestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAttestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workAttestRequestId"] = this.workAttestRequestId;
        data["requestId"] = this.requestId;
        data["countryId"] = this.countryId;
        data["dogId"] = this.dogId;
        data["competitionDate"] = this.competitionDate ? this.competitionDate.toISOString() : <any>undefined;
        data["competitionPoints"] = this.competitionPoints;
        data["competitionJudge"] = this.competitionJudge;
        data["competitionCity"] = this.competitionCity;
        data["competitionType"] = this.competitionType;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IWorkAttestRequest {
    workAttestRequestId?: number;
    requestId?: number;
    countryId?: number;
    dogId?: number;
    competitionDate?: Date;
    competitionPoints?: string | undefined;
    competitionJudge?: string | undefined;
    competitionCity?: string | undefined;
    competitionType?: string | undefined;
    request?: Request | undefined;
    country?: Country | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CountryTranslation implements ICountryTranslation {
    countryTranslationId?: number;
    countryId?: number;
    languageId?: number;
    text?: string | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICountryTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryTranslationId = _data["countryTranslationId"];
            this.countryId = _data["countryId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CountryTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryTranslationId"] = this.countryTranslationId;
        data["countryId"] = this.countryId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICountryTranslation {
    countryTranslationId?: number;
    countryId?: number;
    languageId?: number;
    text?: string | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CountryPedigreePrefix implements ICountryPedigreePrefix {
    countryPedigreePrefixId?: number;
    countryId?: number;
    prefix?: string | undefined;
    nextValue?: number;
    displayPrefix?: string | undefined;
    resetEachYear?: boolean;
    fciRecognized?: boolean;
    usableOnPortal?: boolean;
    country?: Country | undefined;
    pedigrees?: Pedigree[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: ICountryPedigreePrefix) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.countryId = _data["countryId"];
            this.prefix = _data["prefix"];
            this.nextValue = _data["nextValue"];
            this.displayPrefix = _data["displayPrefix"];
            this.resetEachYear = _data["resetEachYear"];
            this.fciRecognized = _data["fciRecognized"];
            this.usableOnPortal = _data["usableOnPortal"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["pedigrees"])) {
                this.pedigrees = [] as any;
                for (let item of _data["pedigrees"])
                    this.pedigrees!.push(Pedigree.fromJS(item));
            }
            if (Array.isArray(_data["dogBroodRequestsTransients"])) {
                this.dogBroodRequestsTransients = [] as any;
                for (let item of _data["dogBroodRequestsTransients"])
                    this.dogBroodRequestsTransients!.push(DogBroodRequestsTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): CountryPedigreePrefix {
        data = typeof data === 'object' ? data : {};
        let result = new CountryPedigreePrefix();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["countryId"] = this.countryId;
        data["prefix"] = this.prefix;
        data["nextValue"] = this.nextValue;
        data["displayPrefix"] = this.displayPrefix;
        data["resetEachYear"] = this.resetEachYear;
        data["fciRecognized"] = this.fciRecognized;
        data["usableOnPortal"] = this.usableOnPortal;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.pedigrees)) {
            data["pedigrees"] = [];
            for (let item of this.pedigrees)
                data["pedigrees"].push(item.toJSON());
        }
        if (Array.isArray(this.dogBroodRequestsTransients)) {
            data["dogBroodRequestsTransients"] = [];
            for (let item of this.dogBroodRequestsTransients)
                data["dogBroodRequestsTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface ICountryPedigreePrefix {
    countryPedigreePrefixId?: number;
    countryId?: number;
    prefix?: string | undefined;
    nextValue?: number;
    displayPrefix?: string | undefined;
    resetEachYear?: boolean;
    fciRecognized?: boolean;
    usableOnPortal?: boolean;
    country?: Country | undefined;
    pedigrees?: Pedigree[] | undefined;
    dogBroodRequestsTransients?: DogBroodRequestsTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class Pedigree implements IPedigree {
    pedigreeId?: number;
    dogId?: number;
    identifier?: string | undefined;
    countryPedigreePrefixId?: number;
    attributionDate?: Date | undefined;
    dog?: Dog | undefined;
    countryPedigreePrefix?: CountryPedigreePrefix | undefined;
    dogBroodRequestsTransient?: DogBroodRequestsTransient | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPedigree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeId = _data["pedigreeId"];
            this.dogId = _data["dogId"];
            this.identifier = _data["identifier"];
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.countryPedigreePrefix = _data["countryPedigreePrefix"] ? CountryPedigreePrefix.fromJS(_data["countryPedigreePrefix"]) : <any>undefined;
            this.dogBroodRequestsTransient = _data["dogBroodRequestsTransient"] ? DogBroodRequestsTransient.fromJS(_data["dogBroodRequestsTransient"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Pedigree {
        data = typeof data === 'object' ? data : {};
        let result = new Pedigree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeId"] = this.pedigreeId;
        data["dogId"] = this.dogId;
        data["identifier"] = this.identifier;
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["countryPedigreePrefix"] = this.countryPedigreePrefix ? this.countryPedigreePrefix.toJSON() : <any>undefined;
        data["dogBroodRequestsTransient"] = this.dogBroodRequestsTransient ? this.dogBroodRequestsTransient.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPedigree {
    pedigreeId?: number;
    dogId?: number;
    identifier?: string | undefined;
    countryPedigreePrefixId?: number;
    attributionDate?: Date | undefined;
    dog?: Dog | undefined;
    countryPedigreePrefix?: CountryPedigreePrefix | undefined;
    dogBroodRequestsTransient?: DogBroodRequestsTransient | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Clinic implements IClinic {
    clinicId?: number;
    name?: string | undefined;
    languageId?: number;
    email?: string | undefined;
    siteweb?: string | undefined;
    tva?: string | undefined;
    phoneNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    clinicsVeterinaries?: ClinicVeterinary[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClinic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.name = _data["name"];
            this.languageId = _data["languageId"];
            this.email = _data["email"];
            this.siteweb = _data["siteweb"];
            this.tva = _data["tva"];
            this.phoneNumber = _data["phoneNumber"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["clinicsVeterinaries"])) {
                this.clinicsVeterinaries = [] as any;
                for (let item of _data["clinicsVeterinaries"])
                    this.clinicsVeterinaries!.push(ClinicVeterinary.fromJS(item));
            }
            if (Array.isArray(_data["dysplasiaRequests"])) {
                this.dysplasiaRequests = [] as any;
                for (let item of _data["dysplasiaRequests"])
                    this.dysplasiaRequests!.push(DysplasiaRequest.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Clinic {
        data = typeof data === 'object' ? data : {};
        let result = new Clinic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["name"] = this.name;
        data["languageId"] = this.languageId;
        data["email"] = this.email;
        data["siteweb"] = this.siteweb;
        data["tva"] = this.tva;
        data["phoneNumber"] = this.phoneNumber;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.clinicsVeterinaries)) {
            data["clinicsVeterinaries"] = [];
            for (let item of this.clinicsVeterinaries)
                data["clinicsVeterinaries"].push(item.toJSON());
        }
        if (Array.isArray(this.dysplasiaRequests)) {
            data["dysplasiaRequests"] = [];
            for (let item of this.dysplasiaRequests)
                data["dysplasiaRequests"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClinic {
    clinicId?: number;
    name?: string | undefined;
    languageId?: number;
    email?: string | undefined;
    siteweb?: string | undefined;
    tva?: string | undefined;
    phoneNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
    clinicsVeterinaries?: ClinicVeterinary[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ClinicVeterinary implements IClinicVeterinary {
    clinicVeterinaryId?: number;
    veterinaryId?: number;
    clinicId?: number;
    veterinary?: Veterinary | undefined;
    clinic?: Clinic | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClinicVeterinary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicVeterinaryId = _data["clinicVeterinaryId"];
            this.veterinaryId = _data["veterinaryId"];
            this.clinicId = _data["clinicId"];
            this.veterinary = _data["veterinary"] ? Veterinary.fromJS(_data["veterinary"]) : <any>undefined;
            this.clinic = _data["clinic"] ? Clinic.fromJS(_data["clinic"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClinicVeterinary {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicVeterinary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicVeterinaryId"] = this.clinicVeterinaryId;
        data["veterinaryId"] = this.veterinaryId;
        data["clinicId"] = this.clinicId;
        data["veterinary"] = this.veterinary ? this.veterinary.toJSON() : <any>undefined;
        data["clinic"] = this.clinic ? this.clinic.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClinicVeterinary {
    clinicVeterinaryId?: number;
    veterinaryId?: number;
    clinicId?: number;
    veterinary?: Veterinary | undefined;
    clinic?: Clinic | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Veterinary implements IVeterinary {
    veterinaryId?: number;
    personId?: number;
    veterinaryNumber?: string | undefined;
    veterinaryCompany?: string | undefined;
    isActive?: boolean;
    person?: Person | undefined;
    clinicsVeterinaries?: ClinicVeterinary[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IVeterinary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veterinaryId = _data["veterinaryId"];
            this.personId = _data["personId"];
            this.veterinaryNumber = _data["veterinaryNumber"];
            this.veterinaryCompany = _data["veterinaryCompany"];
            this.isActive = _data["isActive"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["clinicsVeterinaries"])) {
                this.clinicsVeterinaries = [] as any;
                for (let item of _data["clinicsVeterinaries"])
                    this.clinicsVeterinaries!.push(ClinicVeterinary.fromJS(item));
            }
            if (Array.isArray(_data["dysplasiaRequests"])) {
                this.dysplasiaRequests = [] as any;
                for (let item of _data["dysplasiaRequests"])
                    this.dysplasiaRequests!.push(DysplasiaRequest.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Veterinary {
        data = typeof data === 'object' ? data : {};
        let result = new Veterinary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veterinaryId"] = this.veterinaryId;
        data["personId"] = this.personId;
        data["veterinaryNumber"] = this.veterinaryNumber;
        data["veterinaryCompany"] = this.veterinaryCompany;
        data["isActive"] = this.isActive;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.clinicsVeterinaries)) {
            data["clinicsVeterinaries"] = [];
            for (let item of this.clinicsVeterinaries)
                data["clinicsVeterinaries"].push(item.toJSON());
        }
        if (Array.isArray(this.dysplasiaRequests)) {
            data["dysplasiaRequests"] = [];
            for (let item of this.dysplasiaRequests)
                data["dysplasiaRequests"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IVeterinary {
    veterinaryId?: number;
    personId?: number;
    veterinaryNumber?: string | undefined;
    veterinaryCompany?: string | undefined;
    isActive?: boolean;
    person?: Person | undefined;
    clinicsVeterinaries?: ClinicVeterinary[] | undefined;
    dysplasiaRequests?: DysplasiaRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class KennelImportRequest implements IKennelImportRequest {
    kennelImportRequestId?: number;
    requestId?: number;
    nameOffer?: string | undefined;
    nameOfferType?: EKennelType;
    countryId?: number | undefined;
    fciNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    request?: Request | undefined;
    country?: Country | undefined;
    transientKennelImportBreeds?: TransientKennelImportBreed[] | undefined;
    transientKennelImportOwners?: TransientKennelImportOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IKennelImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelImportRequestId = _data["kennelImportRequestId"];
            this.requestId = _data["requestId"];
            this.nameOffer = _data["nameOffer"];
            this.nameOfferType = _data["nameOfferType"];
            this.countryId = _data["countryId"];
            this.fciNumber = _data["fciNumber"];
            this.exportDate = _data["exportDate"] ? new Date(_data["exportDate"].toString()) : <any>undefined;
            this.exportForcedValue = _data["exportForcedValue"];
            this.tries = _data["tries"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["transientKennelImportBreeds"])) {
                this.transientKennelImportBreeds = [] as any;
                for (let item of _data["transientKennelImportBreeds"])
                    this.transientKennelImportBreeds!.push(TransientKennelImportBreed.fromJS(item));
            }
            if (Array.isArray(_data["transientKennelImportOwners"])) {
                this.transientKennelImportOwners = [] as any;
                for (let item of _data["transientKennelImportOwners"])
                    this.transientKennelImportOwners!.push(TransientKennelImportOwner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): KennelImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KennelImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelImportRequestId"] = this.kennelImportRequestId;
        data["requestId"] = this.requestId;
        data["nameOffer"] = this.nameOffer;
        data["nameOfferType"] = this.nameOfferType;
        data["countryId"] = this.countryId;
        data["fciNumber"] = this.fciNumber;
        data["exportDate"] = this.exportDate ? this.exportDate.toISOString() : <any>undefined;
        data["exportForcedValue"] = this.exportForcedValue;
        data["tries"] = this.tries;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.transientKennelImportBreeds)) {
            data["transientKennelImportBreeds"] = [];
            for (let item of this.transientKennelImportBreeds)
                data["transientKennelImportBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.transientKennelImportOwners)) {
            data["transientKennelImportOwners"] = [];
            for (let item of this.transientKennelImportOwners)
                data["transientKennelImportOwners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IKennelImportRequest {
    kennelImportRequestId?: number;
    requestId?: number;
    nameOffer?: string | undefined;
    nameOfferType?: EKennelType;
    countryId?: number | undefined;
    fciNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    request?: Request | undefined;
    country?: Country | undefined;
    transientKennelImportBreeds?: TransientKennelImportBreed[] | undefined;
    transientKennelImportOwners?: TransientKennelImportOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientKennelImportBreed implements ITransientKennelImportBreed {
    transientKennelImportBreedId?: number;
    breedId?: number;
    kennelImportRequestId?: number;
    breed?: Breed | undefined;
    kennelImportRequest?: KennelImportRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITransientKennelImportBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientKennelImportBreedId = _data["transientKennelImportBreedId"];
            this.breedId = _data["breedId"];
            this.kennelImportRequestId = _data["kennelImportRequestId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.kennelImportRequest = _data["kennelImportRequest"] ? KennelImportRequest.fromJS(_data["kennelImportRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TransientKennelImportBreed {
        data = typeof data === 'object' ? data : {};
        let result = new TransientKennelImportBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientKennelImportBreedId"] = this.transientKennelImportBreedId;
        data["breedId"] = this.breedId;
        data["kennelImportRequestId"] = this.kennelImportRequestId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["kennelImportRequest"] = this.kennelImportRequest ? this.kennelImportRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITransientKennelImportBreed {
    transientKennelImportBreedId?: number;
    breedId?: number;
    kennelImportRequestId?: number;
    breed?: Breed | undefined;
    kennelImportRequest?: KennelImportRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientKennelImportOwner implements ITransientKennelImportOwner {
    transientKennelImportOwnerId?: number;
    personId?: number;
    kennelImportRequestId?: number;
    person?: Person | undefined;
    kennelImportRequest?: KennelImportRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITransientKennelImportOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientKennelImportOwnerId = _data["transientKennelImportOwnerId"];
            this.personId = _data["personId"];
            this.kennelImportRequestId = _data["kennelImportRequestId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.kennelImportRequest = _data["kennelImportRequest"] ? KennelImportRequest.fromJS(_data["kennelImportRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TransientKennelImportOwner {
        data = typeof data === 'object' ? data : {};
        let result = new TransientKennelImportOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientKennelImportOwnerId"] = this.transientKennelImportOwnerId;
        data["personId"] = this.personId;
        data["kennelImportRequestId"] = this.kennelImportRequestId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["kennelImportRequest"] = this.kennelImportRequest ? this.kennelImportRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITransientKennelImportOwner {
    transientKennelImportOwnerId?: number;
    personId?: number;
    kennelImportRequestId?: number;
    person?: Person | undefined;
    kennelImportRequest?: KennelImportRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CountryLanguage implements ICountryLanguage {
    countryLanguageId?: number;
    languageId?: number;
    countryId?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    country?: Country | undefined;
    language?: Language | undefined;

    constructor(data?: ICountryLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryLanguageId = _data["countryLanguageId"];
            this.languageId = _data["languageId"];
            this.countryId = _data["countryId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountryLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryLanguageId"] = this.countryLanguageId;
        data["languageId"] = this.languageId;
        data["countryId"] = this.countryId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICountryLanguage {
    countryLanguageId?: number;
    languageId?: number;
    countryId?: number;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    country?: Country | undefined;
    language?: Language | undefined;
}

export class BroodRequestsFather implements IBroodRequestsFather {
    broodRequestsFatherId?: number;
    dogId?: number;
    broodRequestId?: number;
    ownerApproval?: boolean | undefined;
    broodRequest?: BroodRequest | undefined;
    dog?: Dog | undefined;
    broodRequestsFatherHistories?: BroodRequestsFatherHistories[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBroodRequestsFather) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broodRequestsFatherId = _data["broodRequestsFatherId"];
            this.dogId = _data["dogId"];
            this.broodRequestId = _data["broodRequestId"];
            this.ownerApproval = _data["ownerApproval"];
            this.broodRequest = _data["broodRequest"] ? BroodRequest.fromJS(_data["broodRequest"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            if (Array.isArray(_data["broodRequestsFatherHistories"])) {
                this.broodRequestsFatherHistories = [] as any;
                for (let item of _data["broodRequestsFatherHistories"])
                    this.broodRequestsFatherHistories!.push(BroodRequestsFatherHistories.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BroodRequestsFather {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequestsFather();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestsFatherId"] = this.broodRequestsFatherId;
        data["dogId"] = this.dogId;
        data["broodRequestId"] = this.broodRequestId;
        data["ownerApproval"] = this.ownerApproval;
        data["broodRequest"] = this.broodRequest ? this.broodRequest.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        if (Array.isArray(this.broodRequestsFatherHistories)) {
            data["broodRequestsFatherHistories"] = [];
            for (let item of this.broodRequestsFatherHistories)
                data["broodRequestsFatherHistories"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBroodRequestsFather {
    broodRequestsFatherId?: number;
    dogId?: number;
    broodRequestId?: number;
    ownerApproval?: boolean | undefined;
    broodRequest?: BroodRequest | undefined;
    dog?: Dog | undefined;
    broodRequestsFatherHistories?: BroodRequestsFatherHistories[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BroodRequestsFatherHistories implements IBroodRequestsFatherHistories {
    broodRequestsFatherHistoriesId?: number;
    broodRequestsFatherId?: number;
    linkedDogId?: number;
    broodRequestsFather?: BroodRequestsFather | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBroodRequestsFatherHistories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broodRequestsFatherHistoriesId = _data["broodRequestsFatherHistoriesId"];
            this.broodRequestsFatherId = _data["broodRequestsFatherId"];
            this.linkedDogId = _data["linkedDogId"];
            this.broodRequestsFather = _data["broodRequestsFather"] ? BroodRequestsFather.fromJS(_data["broodRequestsFather"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BroodRequestsFatherHistories {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequestsFatherHistories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestsFatherHistoriesId"] = this.broodRequestsFatherHistoriesId;
        data["broodRequestsFatherId"] = this.broodRequestsFatherId;
        data["linkedDogId"] = this.linkedDogId;
        data["broodRequestsFather"] = this.broodRequestsFather ? this.broodRequestsFather.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBroodRequestsFatherHistories {
    broodRequestsFatherHistoriesId?: number;
    broodRequestsFatherId?: number;
    linkedDogId?: number;
    broodRequestsFather?: BroodRequestsFather | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogConditionsForcedValue implements IDogConditionsForcedValue {
    dogConditionsForcedValueId?: number;
    dogId?: number;
    broodRequestId?: number;
    dogNeededConditionId?: number;
    dogNeededCondition?: DogNeededCondition | undefined;
    dog?: Dog | undefined;
    broodRequest?: BroodRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogConditionsForcedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogConditionsForcedValueId = _data["dogConditionsForcedValueId"];
            this.dogId = _data["dogId"];
            this.broodRequestId = _data["broodRequestId"];
            this.dogNeededConditionId = _data["dogNeededConditionId"];
            this.dogNeededCondition = _data["dogNeededCondition"] ? DogNeededCondition.fromJS(_data["dogNeededCondition"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.broodRequest = _data["broodRequest"] ? BroodRequest.fromJS(_data["broodRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogConditionsForcedValue {
        data = typeof data === 'object' ? data : {};
        let result = new DogConditionsForcedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogConditionsForcedValueId"] = this.dogConditionsForcedValueId;
        data["dogId"] = this.dogId;
        data["broodRequestId"] = this.broodRequestId;
        data["dogNeededConditionId"] = this.dogNeededConditionId;
        data["dogNeededCondition"] = this.dogNeededCondition ? this.dogNeededCondition.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["broodRequest"] = this.broodRequest ? this.broodRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogConditionsForcedValue {
    dogConditionsForcedValueId?: number;
    dogId?: number;
    broodRequestId?: number;
    dogNeededConditionId?: number;
    dogNeededCondition?: DogNeededCondition | undefined;
    dog?: Dog | undefined;
    broodRequest?: BroodRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogNeededCondition implements IDogNeededCondition {
    dogNeededConditionId?: number;
    conditionCode?: EDogCondition;
    forcable?: boolean;
    concernedSex?: EDogSex;
    dogConditionsForcedValues?: DogConditionsForcedValue[] | undefined;
    dogNeededConditionsTranslations?: DogNeededConditionsTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogNeededCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogNeededConditionId = _data["dogNeededConditionId"];
            this.conditionCode = _data["conditionCode"];
            this.forcable = _data["forcable"];
            this.concernedSex = _data["concernedSex"];
            if (Array.isArray(_data["dogConditionsForcedValues"])) {
                this.dogConditionsForcedValues = [] as any;
                for (let item of _data["dogConditionsForcedValues"])
                    this.dogConditionsForcedValues!.push(DogConditionsForcedValue.fromJS(item));
            }
            if (Array.isArray(_data["dogNeededConditionsTranslations"])) {
                this.dogNeededConditionsTranslations = [] as any;
                for (let item of _data["dogNeededConditionsTranslations"])
                    this.dogNeededConditionsTranslations!.push(DogNeededConditionsTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogNeededCondition {
        data = typeof data === 'object' ? data : {};
        let result = new DogNeededCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogNeededConditionId"] = this.dogNeededConditionId;
        data["conditionCode"] = this.conditionCode;
        data["forcable"] = this.forcable;
        data["concernedSex"] = this.concernedSex;
        if (Array.isArray(this.dogConditionsForcedValues)) {
            data["dogConditionsForcedValues"] = [];
            for (let item of this.dogConditionsForcedValues)
                data["dogConditionsForcedValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dogNeededConditionsTranslations)) {
            data["dogNeededConditionsTranslations"] = [];
            for (let item of this.dogNeededConditionsTranslations)
                data["dogNeededConditionsTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogNeededCondition {
    dogNeededConditionId?: number;
    conditionCode?: EDogCondition;
    forcable?: boolean;
    concernedSex?: EDogSex;
    dogConditionsForcedValues?: DogConditionsForcedValue[] | undefined;
    dogNeededConditionsTranslations?: DogNeededConditionsTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDogCondition {
    MotherAge = "MotherAge",
    MotherRecognizedColor = "MotherRecognizedColor",
    MotherHasNoOtherRequest = "MotherHasNoOtherRequest",
    MotherDnaAvailable = "MotherDnaAvailable",
    MotherOwnerChart = "MotherOwnerChart",
    FatherAge = "FatherAge",
    FatherRecognizedColor = "FatherRecognizedColor",
    FatherMerle = "FatherMerle",
    FatherDnaAvailable = "FatherDnaAvailable",
    FatherOwnerChart = "FatherOwnerChart",
    MotherFamilyTreeComplete = "MotherFamilyTreeComplete",
    FatherFamilyTreeComplete = "FatherFamilyTreeComplete",
    FatherValidDog = "FatherValidDog",
}

export class DogNeededConditionsTranslation implements IDogNeededConditionsTranslation {
    dogNeededConditionsTranslationId?: number;
    dogNeededConditionId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    dogNeededCondition?: DogNeededCondition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogNeededConditionsTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogNeededConditionsTranslationId = _data["dogNeededConditionsTranslationId"];
            this.dogNeededConditionId = _data["dogNeededConditionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.dogNeededCondition = _data["dogNeededCondition"] ? DogNeededCondition.fromJS(_data["dogNeededCondition"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogNeededConditionsTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DogNeededConditionsTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogNeededConditionsTranslationId"] = this.dogNeededConditionsTranslationId;
        data["dogNeededConditionId"] = this.dogNeededConditionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["dogNeededCondition"] = this.dogNeededCondition ? this.dogNeededCondition.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogNeededConditionsTranslation {
    dogNeededConditionsTranslationId?: number;
    dogNeededConditionId?: number;
    languageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    dogNeededCondition?: DogNeededCondition | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogBroodRequestTransientOwner implements IDogBroodRequestTransientOwner {
    dogBroodRequestTransientOwnerId?: number;
    dogBroodRequestTransientId?: number;
    personId?: number;
    dogBroodRequestsTransient?: DogBroodRequestsTransient | undefined;
    person?: Person | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IDogBroodRequestTransientOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogBroodRequestTransientOwnerId = _data["dogBroodRequestTransientOwnerId"];
            this.dogBroodRequestTransientId = _data["dogBroodRequestTransientId"];
            this.personId = _data["personId"];
            this.dogBroodRequestsTransient = _data["dogBroodRequestsTransient"] ? DogBroodRequestsTransient.fromJS(_data["dogBroodRequestsTransient"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogBroodRequestTransientOwner {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestTransientOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogBroodRequestTransientOwnerId"] = this.dogBroodRequestTransientOwnerId;
        data["dogBroodRequestTransientId"] = this.dogBroodRequestTransientId;
        data["personId"] = this.personId;
        data["dogBroodRequestsTransient"] = this.dogBroodRequestsTransient ? this.dogBroodRequestsTransient.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogBroodRequestTransientOwner {
    dogBroodRequestTransientOwnerId?: number;
    dogBroodRequestTransientId?: number;
    personId?: number;
    dogBroodRequestsTransient?: DogBroodRequestsTransient | undefined;
    person?: Person | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class DogType implements IDogType {
    dogTypeId?: number;
    code?: EDogType;
    dogs?: Dog[] | undefined;
    dogTypeTranslations?: DogTypeTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTypeId = _data["dogTypeId"];
            this.code = _data["code"];
            if (Array.isArray(_data["dogs"])) {
                this.dogs = [] as any;
                for (let item of _data["dogs"])
                    this.dogs!.push(Dog.fromJS(item));
            }
            if (Array.isArray(_data["dogTypeTranslations"])) {
                this.dogTypeTranslations = [] as any;
                for (let item of _data["dogTypeTranslations"])
                    this.dogTypeTranslations!.push(DogTypeTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogType {
        data = typeof data === 'object' ? data : {};
        let result = new DogType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTypeId"] = this.dogTypeId;
        data["code"] = this.code;
        if (Array.isArray(this.dogs)) {
            data["dogs"] = [];
            for (let item of this.dogs)
                data["dogs"].push(item.toJSON());
        }
        if (Array.isArray(this.dogTypeTranslations)) {
            data["dogTypeTranslations"] = [];
            for (let item of this.dogTypeTranslations)
                data["dogTypeTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogType {
    dogTypeId?: number;
    code?: EDogType;
    dogs?: Dog[] | undefined;
    dogTypeTranslations?: DogTypeTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EDogType {
    Puppy = "Puppy",
    ForeignDog = "ForeignDog",
    BelgianDogWithPedigree = "BelgianDogWithPedigree",
    ExpoDog = "ExpoDog",
    ImportDog = "ImportDog",
    LineageDog = "LineageDog",
    DogWithoutPedigree = "DogWithoutPedigree",
}

export class DogTypeTranslation implements IDogTypeTranslation {
    dogTypeTranslationId?: number;
    dogTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    dogType?: DogType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTypeTranslationId = _data["dogTypeTranslationId"];
            this.dogTypeId = _data["dogTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.dogType = _data["dogType"] ? DogType.fromJS(_data["dogType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DogTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTypeTranslationId"] = this.dogTypeTranslationId;
        data["dogTypeId"] = this.dogTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["dogType"] = this.dogType ? this.dogType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogTypeTranslation {
    dogTypeTranslationId?: number;
    dogTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    dogType?: DogType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class PedigreeRequest implements IPedigreeRequest {
    pedigreeRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    transientPedigreeRequestOwners?: TransientPedigreeRequestOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPedigreeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeRequestId = _data["pedigreeRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            if (Array.isArray(_data["transientPedigreeRequestOwners"])) {
                this.transientPedigreeRequestOwners = [] as any;
                for (let item of _data["transientPedigreeRequestOwners"])
                    this.transientPedigreeRequestOwners!.push(TransientPedigreeRequestOwner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PedigreeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeRequestId"] = this.pedigreeRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        if (Array.isArray(this.transientPedigreeRequestOwners)) {
            data["transientPedigreeRequestOwners"] = [];
            for (let item of this.transientPedigreeRequestOwners)
                data["transientPedigreeRequestOwners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPedigreeRequest {
    pedigreeRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    transientPedigreeRequestOwners?: TransientPedigreeRequestOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientPedigreeRequestOwner implements ITransientPedigreeRequestOwner {
    transientPedigreeRequestOwnerId?: number;
    pedigreeRequestId?: number;
    personId?: number;
    pedigreeRequest?: PedigreeRequest | undefined;
    person?: Person | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: ITransientPedigreeRequestOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientPedigreeRequestOwnerId = _data["transientPedigreeRequestOwnerId"];
            this.pedigreeRequestId = _data["pedigreeRequestId"];
            this.personId = _data["personId"];
            this.pedigreeRequest = _data["pedigreeRequest"] ? PedigreeRequest.fromJS(_data["pedigreeRequest"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransientPedigreeRequestOwner {
        data = typeof data === 'object' ? data : {};
        let result = new TransientPedigreeRequestOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientPedigreeRequestOwnerId"] = this.transientPedigreeRequestOwnerId;
        data["pedigreeRequestId"] = this.pedigreeRequestId;
        data["personId"] = this.personId;
        data["pedigreeRequest"] = this.pedigreeRequest ? this.pedigreeRequest.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransientPedigreeRequestOwner {
    transientPedigreeRequestOwnerId?: number;
    pedigreeRequestId?: number;
    personId?: number;
    pedigreeRequest?: PedigreeRequest | undefined;
    person?: Person | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class DogChip implements IDogChip {
    dogChipId?: number;
    dogId?: number | undefined;
    chipNumber?: string | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogChip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogChipId = _data["dogChipId"];
            this.dogId = _data["dogId"];
            this.chipNumber = _data["chipNumber"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogChip {
        data = typeof data === 'object' ? data : {};
        let result = new DogChip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogChipId"] = this.dogChipId;
        data["dogId"] = this.dogId;
        data["chipNumber"] = this.chipNumber;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogChip {
    dogChipId?: number;
    dogId?: number | undefined;
    chipNumber?: string | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogHealthTestValidation implements IDogHealthTestValidation {
    dogHealthTestValidationId?: number;
    userId?: number | undefined;
    dogId?: number;
    validated?: boolean | undefined;
    closedOn?: Date;
    user?: User | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogHealthTestValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogHealthTestValidationId = _data["dogHealthTestValidationId"];
            this.userId = _data["userId"];
            this.dogId = _data["dogId"];
            this.validated = _data["validated"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogHealthTestValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthTestValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogHealthTestValidationId"] = this.dogHealthTestValidationId;
        data["userId"] = this.userId;
        data["dogId"] = this.dogId;
        data["validated"] = this.validated;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogHealthTestValidation {
    dogHealthTestValidationId?: number;
    userId?: number | undefined;
    dogId?: number;
    validated?: boolean | undefined;
    closedOn?: Date;
    user?: User | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CoupleInbreeding implements ICoupleInbreeding {
    coupleInbreedingId?: number;
    fatherId?: number;
    motherId?: number;
    inbreedingPercentage?: number;
    fatherFileId?: string | undefined;
    motherFileId?: string | undefined;
    validated?: boolean;
    father?: Dog | undefined;
    mother?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICoupleInbreeding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coupleInbreedingId = _data["coupleInbreedingId"];
            this.fatherId = _data["fatherId"];
            this.motherId = _data["motherId"];
            this.inbreedingPercentage = _data["inbreedingPercentage"];
            this.fatherFileId = _data["fatherFileId"];
            this.motherFileId = _data["motherFileId"];
            this.validated = _data["validated"];
            this.father = _data["father"] ? Dog.fromJS(_data["father"]) : <any>undefined;
            this.mother = _data["mother"] ? Dog.fromJS(_data["mother"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CoupleInbreeding {
        data = typeof data === 'object' ? data : {};
        let result = new CoupleInbreeding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupleInbreedingId"] = this.coupleInbreedingId;
        data["fatherId"] = this.fatherId;
        data["motherId"] = this.motherId;
        data["inbreedingPercentage"] = this.inbreedingPercentage;
        data["fatherFileId"] = this.fatherFileId;
        data["motherFileId"] = this.motherFileId;
        data["validated"] = this.validated;
        data["father"] = this.father ? this.father.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICoupleInbreeding {
    coupleInbreedingId?: number;
    fatherId?: number;
    motherId?: number;
    inbreedingPercentage?: number;
    fatherFileId?: string | undefined;
    motherFileId?: string | undefined;
    validated?: boolean;
    father?: Dog | undefined;
    mother?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ExpatriationRequest implements IExpatriationRequest {
    expatriationRequestId?: number;
    isForeignDog?: boolean;
    requestId?: number;
    dogId?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IExpatriationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expatriationRequestId = _data["expatriationRequestId"];
            this.isForeignDog = _data["isForeignDog"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ExpatriationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExpatriationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expatriationRequestId"] = this.expatriationRequestId;
        data["isForeignDog"] = this.isForeignDog;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IExpatriationRequest {
    expatriationRequestId?: number;
    isForeignDog?: boolean;
    requestId?: number;
    dogId?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogTransient implements IDogTransient {
    dogTransientId?: number;
    dogId?: number;
    managerId?: number | undefined;
    isSportSection?: boolean | undefined;
    closedOn?: Date | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    dog?: Dog | undefined;
    manager?: User | undefined;

    constructor(data?: IDogTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTransientId = _data["dogTransientId"];
            this.dogId = _data["dogId"];
            this.managerId = _data["managerId"];
            this.isSportSection = _data["isSportSection"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.manager = _data["manager"] ? User.fromJS(_data["manager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DogTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTransientId"] = this.dogTransientId;
        data["dogId"] = this.dogId;
        data["managerId"] = this.managerId;
        data["isSportSection"] = this.isSportSection;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDogTransient {
    dogTransientId?: number;
    dogId?: number;
    managerId?: number | undefined;
    isSportSection?: boolean | undefined;
    closedOn?: Date | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    dog?: Dog | undefined;
    manager?: User | undefined;
}

export class PedigreeDuplicataRequest implements IPedigreeDuplicataRequest {
    pedigreeDuplicataRequestId?: number;
    requestId?: number;
    dogId?: number;
    isRenewal?: boolean;
    request?: Request | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPedigreeDuplicataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeDuplicataRequestId = _data["pedigreeDuplicataRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.isRenewal = _data["isRenewal"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PedigreeDuplicataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeDuplicataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeDuplicataRequestId"] = this.pedigreeDuplicataRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["isRenewal"] = this.isRenewal;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPedigreeDuplicataRequest {
    pedigreeDuplicataRequestId?: number;
    requestId?: number;
    dogId?: number;
    isRenewal?: boolean;
    request?: Request | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogOwnershipChangeRequest implements IDogOwnershipChangeRequest {
    dogOwnershipChangeRequestId?: number;
    requestId?: number;
    dogId?: number;
    export?: boolean;
    request?: Request | undefined;
    dog?: Dog | undefined;
    isRegisteredLetter?: boolean;
    dogsOwnershipsTransients?: DogOwnershipTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogOwnershipChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipChangeRequestId = _data["dogOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.export = _data["export"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.isRegisteredLetter = _data["isRegisteredLetter"];
            if (Array.isArray(_data["dogsOwnershipsTransients"])) {
                this.dogsOwnershipsTransients = [] as any;
                for (let item of _data["dogsOwnershipsTransients"])
                    this.dogsOwnershipsTransients!.push(DogOwnershipTransient.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogOwnershipChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnershipChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipChangeRequestId"] = this.dogOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["export"] = this.export;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["isRegisteredLetter"] = this.isRegisteredLetter;
        if (Array.isArray(this.dogsOwnershipsTransients)) {
            data["dogsOwnershipsTransients"] = [];
            for (let item of this.dogsOwnershipsTransients)
                data["dogsOwnershipsTransients"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogOwnershipChangeRequest {
    dogOwnershipChangeRequestId?: number;
    requestId?: number;
    dogId?: number;
    export?: boolean;
    request?: Request | undefined;
    dog?: Dog | undefined;
    isRegisteredLetter?: boolean;
    dogsOwnershipsTransients?: DogOwnershipTransient[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogOwnershipTransient implements IDogOwnershipTransient {
    dogOwnershipTransientId?: number;
    dogId?: number;
    personId?: number;
    dogOwnershipChangeRequestId?: number;
    dogOwnershipChangeRequest?: DogOwnershipChangeRequest | undefined;
    dog?: Dog | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogOwnershipTransient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipTransientId = _data["dogOwnershipTransientId"];
            this.dogId = _data["dogId"];
            this.personId = _data["personId"];
            this.dogOwnershipChangeRequestId = _data["dogOwnershipChangeRequestId"];
            this.dogOwnershipChangeRequest = _data["dogOwnershipChangeRequest"] ? DogOwnershipChangeRequest.fromJS(_data["dogOwnershipChangeRequest"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogOwnershipTransient {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnershipTransient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipTransientId"] = this.dogOwnershipTransientId;
        data["dogId"] = this.dogId;
        data["personId"] = this.personId;
        data["dogOwnershipChangeRequestId"] = this.dogOwnershipChangeRequestId;
        data["dogOwnershipChangeRequest"] = this.dogOwnershipChangeRequest ? this.dogOwnershipChangeRequest.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogOwnershipTransient {
    dogOwnershipTransientId?: number;
    dogId?: number;
    personId?: number;
    dogOwnershipChangeRequestId?: number;
    dogOwnershipChangeRequest?: DogOwnershipChangeRequest | undefined;
    dog?: Dog | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ImportRequestTransientOwnership implements IImportRequestTransientOwnership {
    importRequestTransientOwnershipId?: number;
    dogId?: number;
    personId?: number;
    importRequestId?: number;
    importRequest?: ImportRequest | undefined;
    dog?: Dog | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IImportRequestTransientOwnership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importRequestTransientOwnershipId = _data["importRequestTransientOwnershipId"];
            this.dogId = _data["dogId"];
            this.personId = _data["personId"];
            this.importRequestId = _data["importRequestId"];
            this.importRequest = _data["importRequest"] ? ImportRequest.fromJS(_data["importRequest"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ImportRequestTransientOwnership {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestTransientOwnership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequestTransientOwnershipId"] = this.importRequestTransientOwnershipId;
        data["dogId"] = this.dogId;
        data["personId"] = this.personId;
        data["importRequestId"] = this.importRequestId;
        data["importRequest"] = this.importRequest ? this.importRequest.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IImportRequestTransientOwnership {
    importRequestTransientOwnershipId?: number;
    dogId?: number;
    personId?: number;
    importRequestId?: number;
    importRequest?: ImportRequest | undefined;
    dog?: Dog | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ImportRequest implements IImportRequest {
    importRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    importRequestTransientOwnerships?: ImportRequestTransientOwnership[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IImportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importRequestId = _data["importRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            if (Array.isArray(_data["importRequestTransientOwnerships"])) {
                this.importRequestTransientOwnerships = [] as any;
                for (let item of _data["importRequestTransientOwnerships"])
                    this.importRequestTransientOwnerships!.push(ImportRequestTransientOwnership.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequestId"] = this.importRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        if (Array.isArray(this.importRequestTransientOwnerships)) {
            data["importRequestTransientOwnerships"] = [];
            for (let item of this.importRequestTransientOwnerships)
                data["importRequestTransientOwnerships"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IImportRequest {
    importRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: Request | undefined;
    dog?: Dog | undefined;
    importRequestTransientOwnerships?: ImportRequestTransientOwnership[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogOwnership implements IDogOwnership {
    dogOwnershipId?: number;
    dogId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
    isTemporaryOwner?: boolean;
    dog?: Dog | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: IDogOwnership) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipId = _data["dogOwnershipId"];
            this.dogId = _data["dogId"];
            this.personId = _data["personId"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.isTemporaryOwner = _data["isTemporaryOwner"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): DogOwnership {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnership();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipId"] = this.dogOwnershipId;
        data["dogId"] = this.dogId;
        data["personId"] = this.personId;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["isTemporaryOwner"] = this.isTemporaryOwner;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IDogOwnership {
    dogOwnershipId?: number;
    dogId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
    isTemporaryOwner?: boolean;
    dog?: Dog | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class DogTempOwnershipChangeRequest implements IDogTempOwnershipChangeRequest {
    dogTempOwnershipChangeRequestId?: number;
    requestId?: number;
    temporaryOwnerId?: number;
    dogId?: number;
    temporaryOwnerFrom?: Date;
    temporaryOwnerTo?: Date;
    request?: Request | undefined;
    temporaryOwner?: Person | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogTempOwnershipChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTempOwnershipChangeRequestId = _data["dogTempOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.temporaryOwnerId = _data["temporaryOwnerId"];
            this.dogId = _data["dogId"];
            this.temporaryOwnerFrom = _data["temporaryOwnerFrom"] ? new Date(_data["temporaryOwnerFrom"].toString()) : <any>undefined;
            this.temporaryOwnerTo = _data["temporaryOwnerTo"] ? new Date(_data["temporaryOwnerTo"].toString()) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.temporaryOwner = _data["temporaryOwner"] ? Person.fromJS(_data["temporaryOwner"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogTempOwnershipChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DogTempOwnershipChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTempOwnershipChangeRequestId"] = this.dogTempOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["temporaryOwnerId"] = this.temporaryOwnerId;
        data["dogId"] = this.dogId;
        data["temporaryOwnerFrom"] = this.temporaryOwnerFrom ? this.temporaryOwnerFrom.toISOString() : <any>undefined;
        data["temporaryOwnerTo"] = this.temporaryOwnerTo ? this.temporaryOwnerTo.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["temporaryOwner"] = this.temporaryOwner ? this.temporaryOwner.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogTempOwnershipChangeRequest {
    dogTempOwnershipChangeRequestId?: number;
    requestId?: number;
    temporaryOwnerId?: number;
    dogId?: number;
    temporaryOwnerFrom?: Date;
    temporaryOwnerTo?: Date;
    request?: Request | undefined;
    temporaryOwner?: Person | undefined;
    dog?: Dog | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogsBreeder implements IDogsBreeder {
    dogsBreederId?: number;
    dogId?: number;
    breederId?: number;
    dog?: Dog | undefined;
    breeder?: Breeder | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogsBreeder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogsBreederId = _data["dogsBreederId"];
            this.dogId = _data["dogId"];
            this.breederId = _data["breederId"];
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.breeder = _data["breeder"] ? Breeder.fromJS(_data["breeder"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogsBreeder {
        data = typeof data === 'object' ? data : {};
        let result = new DogsBreeder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogsBreederId"] = this.dogsBreederId;
        data["dogId"] = this.dogId;
        data["breederId"] = this.breederId;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["breeder"] = this.breeder ? this.breeder.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogsBreeder {
    dogsBreederId?: number;
    dogId?: number;
    breederId?: number;
    dog?: Dog | undefined;
    breeder?: Breeder | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Breeder implements IBreeder {
    breederId?: number;
    personId?: number;
    hkNumber?: string | undefined;
    webSiteUri?: string | undefined;
    person?: Person | undefined;
    dogsBreeders?: DogsBreeder[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreeder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breederId = _data["breederId"];
            this.personId = _data["personId"];
            this.hkNumber = _data["hkNumber"];
            this.webSiteUri = _data["webSiteUri"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["dogsBreeders"])) {
                this.dogsBreeders = [] as any;
                for (let item of _data["dogsBreeders"])
                    this.dogsBreeders!.push(DogsBreeder.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Breeder {
        data = typeof data === 'object' ? data : {};
        let result = new Breeder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breederId"] = this.breederId;
        data["personId"] = this.personId;
        data["hkNumber"] = this.hkNumber;
        data["webSiteUri"] = this.webSiteUri;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.dogsBreeders)) {
            data["dogsBreeders"] = [];
            for (let item of this.dogsBreeders)
                data["dogsBreeders"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreeder {
    breederId?: number;
    personId?: number;
    hkNumber?: string | undefined;
    webSiteUri?: string | undefined;
    person?: Person | undefined;
    dogsBreeders?: DogsBreeder[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogAction implements IDogAction {
    dogActionId?: number;
    userId?: number | undefined;
    dogId?: number;
    elementActionId?: number;
    actionTime?: Date;
    user?: User | undefined;
    dog?: Dog | undefined;
    elementAction?: ElementAction | undefined;
    dogActionsTranslations?: DogActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IDogAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogActionId = _data["dogActionId"];
            this.userId = _data["userId"];
            this.dogId = _data["dogId"];
            this.elementActionId = _data["elementActionId"];
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.dog = _data["dog"] ? Dog.fromJS(_data["dog"]) : <any>undefined;
            this.elementAction = _data["elementAction"] ? ElementAction.fromJS(_data["elementAction"]) : <any>undefined;
            if (Array.isArray(_data["dogActionsTranslations"])) {
                this.dogActionsTranslations = [] as any;
                for (let item of _data["dogActionsTranslations"])
                    this.dogActionsTranslations!.push(DogActionTranslation.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogAction {
        data = typeof data === 'object' ? data : {};
        let result = new DogAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogActionId"] = this.dogActionId;
        data["userId"] = this.userId;
        data["dogId"] = this.dogId;
        data["elementActionId"] = this.elementActionId;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["elementAction"] = this.elementAction ? this.elementAction.toJSON() : <any>undefined;
        if (Array.isArray(this.dogActionsTranslations)) {
            data["dogActionsTranslations"] = [];
            for (let item of this.dogActionsTranslations)
                data["dogActionsTranslations"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogAction {
    dogActionId?: number;
    userId?: number | undefined;
    dogId?: number;
    elementActionId?: number;
    actionTime?: Date;
    user?: User | undefined;
    dog?: Dog | undefined;
    elementAction?: ElementAction | undefined;
    dogActionsTranslations?: DogActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ElementAction implements IElementAction {
    elementActionId?: number;
    actionCode?: EElementActions;
    requestActions?: RequestAction[] | undefined;
    dogActions?: DogAction[] | undefined;
    personActions?: PersonAction[] | undefined;
    elementActionTranslations?: ElementActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IElementAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementActionId = _data["elementActionId"];
            this.actionCode = _data["actionCode"];
            if (Array.isArray(_data["requestActions"])) {
                this.requestActions = [] as any;
                for (let item of _data["requestActions"])
                    this.requestActions!.push(RequestAction.fromJS(item));
            }
            if (Array.isArray(_data["dogActions"])) {
                this.dogActions = [] as any;
                for (let item of _data["dogActions"])
                    this.dogActions!.push(DogAction.fromJS(item));
            }
            if (Array.isArray(_data["personActions"])) {
                this.personActions = [] as any;
                for (let item of _data["personActions"])
                    this.personActions!.push(PersonAction.fromJS(item));
            }
            if (Array.isArray(_data["elementActionTranslations"])) {
                this.elementActionTranslations = [] as any;
                for (let item of _data["elementActionTranslations"])
                    this.elementActionTranslations!.push(ElementActionTranslation.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ElementAction {
        data = typeof data === 'object' ? data : {};
        let result = new ElementAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementActionId"] = this.elementActionId;
        data["actionCode"] = this.actionCode;
        if (Array.isArray(this.requestActions)) {
            data["requestActions"] = [];
            for (let item of this.requestActions)
                data["requestActions"].push(item.toJSON());
        }
        if (Array.isArray(this.dogActions)) {
            data["dogActions"] = [];
            for (let item of this.dogActions)
                data["dogActions"].push(item.toJSON());
        }
        if (Array.isArray(this.personActions)) {
            data["personActions"] = [];
            for (let item of this.personActions)
                data["personActions"].push(item.toJSON());
        }
        if (Array.isArray(this.elementActionTranslations)) {
            data["elementActionTranslations"] = [];
            for (let item of this.elementActionTranslations)
                data["elementActionTranslations"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IElementAction {
    elementActionId?: number;
    actionCode?: EElementActions;
    requestActions?: RequestAction[] | undefined;
    dogActions?: DogAction[] | undefined;
    personActions?: PersonAction[] | undefined;
    elementActionTranslations?: ElementActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export enum EElementActions {
    StatusChange = "StatusChange",
    StatusChangePortal = "StatusChangePortal",
    Block = "Block",
    Creation = "Creation",
    Unblock = "Unblock",
    VerificationsForced = "VerificationsForced",
    ConditionForced = "ConditionForced",
    FieldModified = "FieldModified",
    FieldModifiedPortal = "FieldModifiedPortal",
    OwnerAdded = "OwnerAdded",
    OwnerRemoved = "OwnerRemoved",
    JudgeRemoved = "JudgeRemoved",
    JudgeAdded = "JudgeAdded",
    BreedAdded = "BreedAdded",
    BreedRemoved = "BreedRemoved",
    DogAdded = "DogAdded",
    DogAddedPortal = "DogAddedPortal",
    DogRemoved = "DogRemoved",
    DogRemovedPortal = "DogRemovedPortal",
    CreationPortal = "CreationPortal",
    ForcedBannedUser = "ForcedBannedUser",
    PuppyDeceased = "PuppyDeceased",
    CreditMemoCreated = "CreditMemoCreated",
    DogCreation = "DogCreation",
    PedigreeAdded = "PedigreeAdded",
    PedigreeRemoved = "PedigreeRemoved",
    TitleAdded = "TitleAdded",
    TitleRemoved = "TitleRemoved",
    ChipAdded = "ChipAdded",
    ChipRemoved = "ChipRemoved",
    ComptetitionAdded = "ComptetitionAdded",
    CompetitionRemoved = "CompetitionRemoved",
    WorkbookAdded = "WorkbookAdded",
    HealthTestAdded = "HealthTestAdded",
    BreederAdded = "BreederAdded",
    BreederRemoved = "BreederRemoved",
    CreateDogDna = "CreateDogDna",
    CreatePerson = "CreatePerson",
    CreatePersonFromSplit = "CreatePersonFromSplit",
    CreatePersonFromFusion = "CreatePersonFromFusion",
    PasswordChanged = "PasswordChanged",
    CotisationAdded = "CotisationAdded",
    CotisationRemoved = "CotisationRemoved",
    BreederInfoCreated = "BreederInfoCreated",
    BreederChartAdded = "BreederChartAdded",
    BreederChartRemoved = "BreederChartRemoved",
    MembershipInformationCreation = "MembershipInformationCreation",
    VetInformationCreation = "VetInformationCreation",
    SubActivityAdded = "SubActivityAdded",
    SubAcitvityRemoved = "SubAcitvityRemoved",
    BreedGroupAdded = "BreedGroupAdded",
    BreedGroupRemoved = "BreedGroupRemoved",
    CreateDogFromFusion = "CreateDogFromFusion",
    MissingInformationRequested = "MissingInformationRequested",
    OwnershipModified = "OwnershipModified",
    SendingNewFatherRequestToBreeder = "SendingNewFatherRequestToBreeder",
    DocumentPrinted = "DocumentPrinted",
    PuppyPedigree = "PuppyPedigree",
    PedigreeReprint = "PedigreeReprint",
    OgonePayment = "OgonePayment",
    UncancelRequest = "UncancelRequest",
    ComptetitionModified = "ComptetitionModified",
    BreedUpdated = "BreedUpdated",
    StripePayment = "StripePayment",
}

export class RequestAction implements IRequestAction {
    requestActionId?: number;
    userId?: number | undefined;
    requestId?: number;
    elementActionId?: number;
    actionTime?: Date;
    user?: User | undefined;
    request?: Request | undefined;
    elementAction?: ElementAction | undefined;
    requestActionTranslations?: RequestActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IRequestAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestActionId = _data["requestActionId"];
            this.userId = _data["userId"];
            this.requestId = _data["requestId"];
            this.elementActionId = _data["elementActionId"];
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.elementAction = _data["elementAction"] ? ElementAction.fromJS(_data["elementAction"]) : <any>undefined;
            if (Array.isArray(_data["requestActionTranslations"])) {
                this.requestActionTranslations = [] as any;
                for (let item of _data["requestActionTranslations"])
                    this.requestActionTranslations!.push(RequestActionTranslation.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestAction {
        data = typeof data === 'object' ? data : {};
        let result = new RequestAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestActionId"] = this.requestActionId;
        data["userId"] = this.userId;
        data["requestId"] = this.requestId;
        data["elementActionId"] = this.elementActionId;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["elementAction"] = this.elementAction ? this.elementAction.toJSON() : <any>undefined;
        if (Array.isArray(this.requestActionTranslations)) {
            data["requestActionTranslations"] = [];
            for (let item of this.requestActionTranslations)
                data["requestActionTranslations"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRequestAction {
    requestActionId?: number;
    userId?: number | undefined;
    requestId?: number;
    elementActionId?: number;
    actionTime?: Date;
    user?: User | undefined;
    request?: Request | undefined;
    elementAction?: ElementAction | undefined;
    requestActionTranslations?: RequestActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class RequestActionTranslation implements IRequestActionTranslation {
    requestActionTranslationId?: number;
    requestActionId?: number;
    languageId?: number;
    text?: string | undefined;
    requestAction?: RequestAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IRequestActionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestActionTranslationId = _data["requestActionTranslationId"];
            this.requestActionId = _data["requestActionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.requestAction = _data["requestAction"] ? RequestAction.fromJS(_data["requestAction"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): RequestActionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new RequestActionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestActionTranslationId"] = this.requestActionTranslationId;
        data["requestActionId"] = this.requestActionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["requestAction"] = this.requestAction ? this.requestAction.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IRequestActionTranslation {
    requestActionTranslationId?: number;
    requestActionId?: number;
    languageId?: number;
    text?: string | undefined;
    requestAction?: RequestAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class PersonAction implements IPersonAction {
    personActionId?: number;
    userId?: number | undefined;
    personId?: number;
    elementActionId?: number;
    actionTime?: Date;
    user?: User | undefined;
    person?: Person | undefined;
    elementAction?: ElementAction | undefined;
    personActionsTranslations?: PersonActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IPersonAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personActionId = _data["personActionId"];
            this.userId = _data["userId"];
            this.personId = _data["personId"];
            this.elementActionId = _data["elementActionId"];
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.elementAction = _data["elementAction"] ? ElementAction.fromJS(_data["elementAction"]) : <any>undefined;
            if (Array.isArray(_data["personActionsTranslations"])) {
                this.personActionsTranslations = [] as any;
                for (let item of _data["personActionsTranslations"])
                    this.personActionsTranslations!.push(PersonActionTranslation.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonAction {
        data = typeof data === 'object' ? data : {};
        let result = new PersonAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personActionId"] = this.personActionId;
        data["userId"] = this.userId;
        data["personId"] = this.personId;
        data["elementActionId"] = this.elementActionId;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["elementAction"] = this.elementAction ? this.elementAction.toJSON() : <any>undefined;
        if (Array.isArray(this.personActionsTranslations)) {
            data["personActionsTranslations"] = [];
            for (let item of this.personActionsTranslations)
                data["personActionsTranslations"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPersonAction {
    personActionId?: number;
    userId?: number | undefined;
    personId?: number;
    elementActionId?: number;
    actionTime?: Date;
    user?: User | undefined;
    person?: Person | undefined;
    elementAction?: ElementAction | undefined;
    personActionsTranslations?: PersonActionTranslation[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class PersonActionTranslation implements IPersonActionTranslation {
    personActionTranslationId?: number;
    personActionId?: number;
    languageId?: number;
    text?: string | undefined;
    personAction?: PersonAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IPersonActionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personActionTranslationId = _data["personActionTranslationId"];
            this.personActionId = _data["personActionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.personAction = _data["personAction"] ? PersonAction.fromJS(_data["personAction"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PersonActionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new PersonActionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personActionTranslationId"] = this.personActionTranslationId;
        data["personActionId"] = this.personActionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["personAction"] = this.personAction ? this.personAction.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPersonActionTranslation {
    personActionTranslationId?: number;
    personActionId?: number;
    languageId?: number;
    text?: string | undefined;
    personAction?: PersonAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ElementActionTranslation implements IElementActionTranslation {
    elementActionTranslationId?: number;
    elementActionId?: number;
    languageId?: number;
    text?: string | undefined;
    elementAction?: ElementAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IElementActionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementActionTranslationId = _data["elementActionTranslationId"];
            this.elementActionId = _data["elementActionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.elementAction = _data["elementAction"] ? ElementAction.fromJS(_data["elementAction"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ElementActionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new ElementActionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementActionTranslationId"] = this.elementActionTranslationId;
        data["elementActionId"] = this.elementActionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["elementAction"] = this.elementAction ? this.elementAction.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IElementActionTranslation {
    elementActionTranslationId?: number;
    elementActionId?: number;
    languageId?: number;
    text?: string | undefined;
    elementAction?: ElementAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DogActionTranslation implements IDogActionTranslation {
    dogActionTranslationId?: number;
    dogActionId?: number;
    languageId?: number;
    text?: string | undefined;
    dogAction?: DogAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDogActionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogActionTranslationId = _data["dogActionTranslationId"];
            this.dogActionId = _data["dogActionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.dogAction = _data["dogAction"] ? DogAction.fromJS(_data["dogAction"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DogActionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new DogActionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogActionTranslationId"] = this.dogActionTranslationId;
        data["dogActionId"] = this.dogActionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["dogAction"] = this.dogAction ? this.dogAction.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDogActionTranslation {
    dogActionTranslationId?: number;
    dogActionId?: number;
    languageId?: number;
    text?: string | undefined;
    dogAction?: DogAction | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedVariety implements IBreedVariety {
    breedvarietyId?: number;
    sourceBreedId?: number;
    destinationBreedId?: number;
    sourceBreed?: Breed | undefined;
    destinationBreed?: Breed | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedVariety) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedvarietyId = _data["breedvarietyId"];
            this.sourceBreedId = _data["sourceBreedId"];
            this.destinationBreedId = _data["destinationBreedId"];
            this.sourceBreed = _data["sourceBreed"] ? Breed.fromJS(_data["sourceBreed"]) : <any>undefined;
            this.destinationBreed = _data["destinationBreed"] ? Breed.fromJS(_data["destinationBreed"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedVariety {
        data = typeof data === 'object' ? data : {};
        let result = new BreedVariety();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedvarietyId"] = this.breedvarietyId;
        data["sourceBreedId"] = this.sourceBreedId;
        data["destinationBreedId"] = this.destinationBreedId;
        data["sourceBreed"] = this.sourceBreed ? this.sourceBreed.toJSON() : <any>undefined;
        data["destinationBreed"] = this.destinationBreed ? this.destinationBreed.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedVariety {
    breedvarietyId?: number;
    sourceBreedId?: number;
    destinationBreedId?: number;
    sourceBreed?: Breed | undefined;
    destinationBreed?: Breed | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedingException implements IBreedingException {
    breedingExceptionId?: number;
    sourceBreedId?: number;
    destinationBreedId?: number;
    sourceBreed?: Breed | undefined;
    destinationBreed?: Breed | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedingException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedingExceptionId = _data["breedingExceptionId"];
            this.sourceBreedId = _data["sourceBreedId"];
            this.destinationBreedId = _data["destinationBreedId"];
            this.sourceBreed = _data["sourceBreed"] ? Breed.fromJS(_data["sourceBreed"]) : <any>undefined;
            this.destinationBreed = _data["destinationBreed"] ? Breed.fromJS(_data["destinationBreed"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedingException {
        data = typeof data === 'object' ? data : {};
        let result = new BreedingException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedingExceptionId"] = this.breedingExceptionId;
        data["sourceBreedId"] = this.sourceBreedId;
        data["destinationBreedId"] = this.destinationBreedId;
        data["sourceBreed"] = this.sourceBreed ? this.sourceBreed.toJSON() : <any>undefined;
        data["destinationBreed"] = this.destinationBreed ? this.destinationBreed.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedingException {
    breedingExceptionId?: number;
    sourceBreedId?: number;
    destinationBreedId?: number;
    sourceBreed?: Breed | undefined;
    destinationBreed?: Breed | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BreedTranslation implements IBreedTranslation {
    breedTranslationId?: number;
    breedId?: number;
    languageId?: number;
    text?: string | undefined;
    breed?: Breed | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IBreedTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedTranslationId = _data["breedTranslationId"];
            this.breedId = _data["breedId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BreedTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new BreedTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedTranslationId"] = this.breedTranslationId;
        data["breedId"] = this.breedId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBreedTranslation {
    breedTranslationId?: number;
    breedId?: number;
    languageId?: number;
    text?: string | undefined;
    breed?: Breed | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientNewKennelBreed implements ITransientNewKennelBreed {
    transientNewKennelBreedId?: number;
    breedId?: number;
    newKennelRequestId?: number;
    breed?: Breed | undefined;
    newKennelRequest?: NewKennelRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITransientNewKennelBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientNewKennelBreedId = _data["transientNewKennelBreedId"];
            this.breedId = _data["breedId"];
            this.newKennelRequestId = _data["newKennelRequestId"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.newKennelRequest = _data["newKennelRequest"] ? NewKennelRequest.fromJS(_data["newKennelRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TransientNewKennelBreed {
        data = typeof data === 'object' ? data : {};
        let result = new TransientNewKennelBreed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientNewKennelBreedId"] = this.transientNewKennelBreedId;
        data["breedId"] = this.breedId;
        data["newKennelRequestId"] = this.newKennelRequestId;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["newKennelRequest"] = this.newKennelRequest ? this.newKennelRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITransientNewKennelBreed {
    transientNewKennelBreedId?: number;
    breedId?: number;
    newKennelRequestId?: number;
    breed?: Breed | undefined;
    newKennelRequest?: NewKennelRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class NewKennelRequest implements INewKennelRequest {
    newKennelRequestId?: number;
    requestId?: number;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    nameOffer2?: string | undefined;
    nameOffer2Type?: EKennelType;
    nameOffer3?: string | undefined;
    nameOffer3Type?: EKennelType;
    nameOffer4?: string | undefined;
    nameOffer4Type?: EKennelType;
    nameOffer5?: string | undefined;
    nameOffer5Type?: EKennelType;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    request?: Request | undefined;
    transientNewKennelBreeds?: TransientNewKennelBreed[] | undefined;
    transientNewKennelOwners?: TransientNewKennelOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: INewKennelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newKennelRequestId = _data["newKennelRequestId"];
            this.requestId = _data["requestId"];
            this.nameOffer1 = _data["nameOffer1"];
            this.nameOffer1Type = _data["nameOffer1Type"];
            this.nameOffer2 = _data["nameOffer2"];
            this.nameOffer2Type = _data["nameOffer2Type"];
            this.nameOffer3 = _data["nameOffer3"];
            this.nameOffer3Type = _data["nameOffer3Type"];
            this.nameOffer4 = _data["nameOffer4"];
            this.nameOffer4Type = _data["nameOffer4Type"];
            this.nameOffer5 = _data["nameOffer5"];
            this.nameOffer5Type = _data["nameOffer5Type"];
            this.finalName = _data["finalName"];
            this.finalType = _data["finalType"];
            this.fciNumber = _data["fciNumber"];
            this.exportDate = _data["exportDate"] ? new Date(_data["exportDate"].toString()) : <any>undefined;
            this.exportForcedValue = _data["exportForcedValue"];
            this.tries = _data["tries"];
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientNewKennelBreeds"])) {
                this.transientNewKennelBreeds = [] as any;
                for (let item of _data["transientNewKennelBreeds"])
                    this.transientNewKennelBreeds!.push(TransientNewKennelBreed.fromJS(item));
            }
            if (Array.isArray(_data["transientNewKennelOwners"])) {
                this.transientNewKennelOwners = [] as any;
                for (let item of _data["transientNewKennelOwners"])
                    this.transientNewKennelOwners!.push(TransientNewKennelOwner.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): NewKennelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NewKennelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newKennelRequestId"] = this.newKennelRequestId;
        data["requestId"] = this.requestId;
        data["nameOffer1"] = this.nameOffer1;
        data["nameOffer1Type"] = this.nameOffer1Type;
        data["nameOffer2"] = this.nameOffer2;
        data["nameOffer2Type"] = this.nameOffer2Type;
        data["nameOffer3"] = this.nameOffer3;
        data["nameOffer3Type"] = this.nameOffer3Type;
        data["nameOffer4"] = this.nameOffer4;
        data["nameOffer4Type"] = this.nameOffer4Type;
        data["nameOffer5"] = this.nameOffer5;
        data["nameOffer5Type"] = this.nameOffer5Type;
        data["finalName"] = this.finalName;
        data["finalType"] = this.finalType;
        data["fciNumber"] = this.fciNumber;
        data["exportDate"] = this.exportDate ? this.exportDate.toISOString() : <any>undefined;
        data["exportForcedValue"] = this.exportForcedValue;
        data["tries"] = this.tries;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientNewKennelBreeds)) {
            data["transientNewKennelBreeds"] = [];
            for (let item of this.transientNewKennelBreeds)
                data["transientNewKennelBreeds"].push(item.toJSON());
        }
        if (Array.isArray(this.transientNewKennelOwners)) {
            data["transientNewKennelOwners"] = [];
            for (let item of this.transientNewKennelOwners)
                data["transientNewKennelOwners"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface INewKennelRequest {
    newKennelRequestId?: number;
    requestId?: number;
    nameOffer1?: string | undefined;
    nameOffer1Type?: EKennelType;
    nameOffer2?: string | undefined;
    nameOffer2Type?: EKennelType;
    nameOffer3?: string | undefined;
    nameOffer3Type?: EKennelType;
    nameOffer4?: string | undefined;
    nameOffer4Type?: EKennelType;
    nameOffer5?: string | undefined;
    nameOffer5Type?: EKennelType;
    finalName?: string | undefined;
    finalType?: EKennelType;
    fciNumber?: string | undefined;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    request?: Request | undefined;
    transientNewKennelBreeds?: TransientNewKennelBreed[] | undefined;
    transientNewKennelOwners?: TransientNewKennelOwner[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientNewKennelOwner implements ITransientNewKennelOwner {
    transientNewKennelOwnerId?: number;
    personId?: number;
    newKennelRequestId?: number;
    person?: Person | undefined;
    newKennelRequest?: NewKennelRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITransientNewKennelOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientNewKennelOwnerId = _data["transientNewKennelOwnerId"];
            this.personId = _data["personId"];
            this.newKennelRequestId = _data["newKennelRequestId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.newKennelRequest = _data["newKennelRequest"] ? NewKennelRequest.fromJS(_data["newKennelRequest"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TransientNewKennelOwner {
        data = typeof data === 'object' ? data : {};
        let result = new TransientNewKennelOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientNewKennelOwnerId"] = this.transientNewKennelOwnerId;
        data["personId"] = this.personId;
        data["newKennelRequestId"] = this.newKennelRequestId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["newKennelRequest"] = this.newKennelRequest ? this.newKennelRequest.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITransientNewKennelOwner {
    transientNewKennelOwnerId?: number;
    personId?: number;
    newKennelRequestId?: number;
    person?: Person | undefined;
    newKennelRequest?: NewKennelRequest | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class LanguageTranslation implements ILanguageTranslation {
    languageTranslationId?: number;
    languageId?: number;
    translationLanguageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    translationLanguage?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ILanguageTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageTranslationId = _data["languageTranslationId"];
            this.languageId = _data["languageId"];
            this.translationLanguageId = _data["translationLanguageId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.translationLanguage = _data["translationLanguage"] ? Language.fromJS(_data["translationLanguage"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): LanguageTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageTranslationId"] = this.languageTranslationId;
        data["languageId"] = this.languageId;
        data["translationLanguageId"] = this.translationLanguageId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["translationLanguage"] = this.translationLanguage ? this.translationLanguage.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILanguageTranslation {
    languageTranslationId?: number;
    languageId?: number;
    translationLanguageId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    translationLanguage?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DocumentContent implements IDocumentContent {
    documentContentId?: number;
    recipientInfo?: string | undefined;
    content?: string | undefined;
    languageId?: number;
    documentTemplateId?: number;
    description?: string | undefined;
    documentTemplate?: DocumentTemplate | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDocumentContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentContentId = _data["documentContentId"];
            this.recipientInfo = _data["recipientInfo"];
            this.content = _data["content"];
            this.languageId = _data["languageId"];
            this.documentTemplateId = _data["documentTemplateId"];
            this.description = _data["description"];
            this.documentTemplate = _data["documentTemplate"] ? DocumentTemplate.fromJS(_data["documentTemplate"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DocumentContent {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentContentId"] = this.documentContentId;
        data["recipientInfo"] = this.recipientInfo;
        data["content"] = this.content;
        data["languageId"] = this.languageId;
        data["documentTemplateId"] = this.documentTemplateId;
        data["description"] = this.description;
        data["documentTemplate"] = this.documentTemplate ? this.documentTemplate.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDocumentContent {
    documentContentId?: number;
    recipientInfo?: string | undefined;
    content?: string | undefined;
    languageId?: number;
    documentTemplateId?: number;
    description?: string | undefined;
    documentTemplate?: DocumentTemplate | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class DocumentTemplate implements IDocumentTemplate {
    documentTemplateId?: number;
    templateCode?: EDocumentTemplate;
    printer?: string | undefined;
    isSeasonal?: boolean;
    printMethod?: EPrintMethod | undefined;
    documentContents?: DocumentContent[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateId = _data["documentTemplateId"];
            this.templateCode = _data["templateCode"];
            this.printer = _data["printer"];
            this.isSeasonal = _data["isSeasonal"];
            this.printMethod = _data["printMethod"];
            if (Array.isArray(_data["documentContents"])) {
                this.documentContents = [] as any;
                for (let item of _data["documentContents"])
                    this.documentContents!.push(DocumentContent.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): DocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateId"] = this.documentTemplateId;
        data["templateCode"] = this.templateCode;
        data["printer"] = this.printer;
        data["isSeasonal"] = this.isSeasonal;
        data["printMethod"] = this.printMethod;
        if (Array.isArray(this.documentContents)) {
            data["documentContents"] = [];
            for (let item of this.documentContents)
                data["documentContents"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDocumentTemplate {
    documentTemplateId?: number;
    templateCode?: EDocumentTemplate;
    printer?: string | undefined;
    isSeasonal?: boolean;
    printMethod?: EPrintMethod | undefined;
    documentContents?: DocumentContent[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EPrintMethod {
    ExternalApp = "ExternalApp",
    Simple = "Simple",
    RvVertical = "RvVertical",
    RVHorizontal = "RVHorizontal",
}

export class Translation implements ITranslation {
    translationId?: number;
    languageId?: number;
    translationCodeId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    translationCode?: TranslationCode | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationId = _data["translationId"];
            this.languageId = _data["languageId"];
            this.translationCodeId = _data["translationCodeId"];
            this.text = _data["text"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.translationCode = _data["translationCode"] ? TranslationCode.fromJS(_data["translationCode"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Translation {
        data = typeof data === 'object' ? data : {};
        let result = new Translation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationId"] = this.translationId;
        data["languageId"] = this.languageId;
        data["translationCodeId"] = this.translationCodeId;
        data["text"] = this.text;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["translationCode"] = this.translationCode ? this.translationCode.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITranslation {
    translationId?: number;
    languageId?: number;
    translationCodeId?: number;
    text?: string | undefined;
    language?: Language | undefined;
    translationCode?: TranslationCode | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TranslationCode implements ITranslationCode {
    translationCodeId?: number;
    code?: string | undefined;
    translations?: Translation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITranslationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationCodeId = _data["translationCodeId"];
            this.code = _data["code"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(Translation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TranslationCode {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationCodeId"] = this.translationCodeId;
        data["code"] = this.code;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITranslationCode {
    translationCodeId?: number;
    code?: string | undefined;
    translations?: Translation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class MailContent implements IMailContent {
    mailContentId?: number;
    mailTemplateId?: number;
    languageId?: number;
    subject?: string | undefined;
    body?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    language?: Language | undefined;
    mailTemplate?: MailTemplate | undefined;

    constructor(data?: IMailContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailContentId = _data["mailContentId"];
            this.mailTemplateId = _data["mailTemplateId"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.mailTemplate = _data["mailTemplate"] ? MailTemplate.fromJS(_data["mailTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailContent {
        data = typeof data === 'object' ? data : {};
        let result = new MailContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailContentId"] = this.mailContentId;
        data["mailTemplateId"] = this.mailTemplateId;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["mailTemplate"] = this.mailTemplate ? this.mailTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMailContent {
    mailContentId?: number;
    mailTemplateId?: number;
    languageId?: number;
    subject?: string | undefined;
    body?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    language?: Language | undefined;
    mailTemplate?: MailTemplate | undefined;
}

export class MailTemplate implements IMailTemplate {
    mailTemplateId?: number;
    code?: EEmailCode;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    mailContent?: MailContent[] | undefined;
    mailTemplateDescriptions?: MailTemplateDescriptionsTranslation[] | undefined;

    constructor(data?: IMailTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplateId = _data["mailTemplateId"];
            this.code = _data["code"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["mailContent"])) {
                this.mailContent = [] as any;
                for (let item of _data["mailContent"])
                    this.mailContent!.push(MailContent.fromJS(item));
            }
            if (Array.isArray(_data["mailTemplateDescriptions"])) {
                this.mailTemplateDescriptions = [] as any;
                for (let item of _data["mailTemplateDescriptions"])
                    this.mailTemplateDescriptions!.push(MailTemplateDescriptionsTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateId"] = this.mailTemplateId;
        data["code"] = this.code;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.mailContent)) {
            data["mailContent"] = [];
            for (let item of this.mailContent)
                data["mailContent"].push(item.toJSON());
        }
        if (Array.isArray(this.mailTemplateDescriptions)) {
            data["mailTemplateDescriptions"] = [];
            for (let item of this.mailTemplateDescriptions)
                data["mailTemplateDescriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailTemplate {
    mailTemplateId?: number;
    code?: EEmailCode;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    mailContent?: MailContent[] | undefined;
    mailTemplateDescriptions?: MailTemplateDescriptionsTranslation[] | undefined;
}

export enum EEmailCode {
    AskMissingInformation = "AskMissingInformation",
    AwaitingNewFather = "AwaitingNewFather",
    BillToPay = "BillToPay",
    BillReminder = "BillReminder",
    BlankDnaTest = "BlankDnaTest",
    BroodRequestKitsReceived = "BroodRequestKitsReceived",
    BroodRequestLabWork = "BroodRequestLabWork",
    BroodRequestNewOwner = "BroodRequestNewOwner",
    BroodRequestNewResult = "BroodRequestNewResult",
    BroodRequestResultReminder = "BroodRequestResultReminder",
    CanineJudgeValidation = "CanineJudgeValidation",
    CharacteristicAccepted = "CharacteristicAccepted",
    CharacteristicRefused = "CharacteristicRefused",
    CloseToDogBirthDate = "CloseToDogBirthDate",
    CompetitionAuthorizationReceived = "CompetitionAuthorizationReceived",
    CompetitionCatalogReminder = "CompetitionCatalogReminder",
    CreateC4DAccount = "CreateC4DAccount",
    CreatePortalAccount = "CreatePortalAccount",
    ClosedAffix = "ClosedAffix",
    DysplasiaClubResults = "DysplasiaClubResults",
    FatherOwnerAgreement = "FatherOwnerAgreement",
    ForeignTitleAccepted = "ForeignTitleAccepted",
    ForeignTitleRefused = "ForeignTitleRefused",
    HealthTestLabWork = "HealthTestLabWork",
    ImportExecution = "ImportExecution",
    JudgesStateUpdate = "JudgesStateUpdate",
    MembershipRequestBeingEvaluated = "MembershipRequestBeingEvaluated",
    MembershipExecution = "MembershipExecution",
    MembershipRequestOtherStatusAccepted = "MembershipRequestOtherStatusAccepted",
    MembershipRequestRefused = "MembershipRequestRefused",
    NewAffixRequest = "NewAffixRequest",
    NewOwnersRshRequest = "NewOwnersRshRequest",
    NewOwnersTempRshRequest = "NewOwnersTempRshRequest",
    OldOwnersRshRequest = "OldOwnersRshRequest",
    OldOwnersTempRshRequest = "OldOwnersTempRshRequest",
    PaidBill = "PaidBill",
    PasswordReset = "PasswordReset",
    RefusedAffix = "RefusedAffix",
    RefusedXRay = "RefusedXRay",
    RequestCreated = "RequestCreated",
    RequestExecuted = "RequestExecuted",
    WorkAttestExecution = "WorkAttestExecution",
    WorkbookExecution = "WorkbookExecution",
    DogCertificate = "DogCertificate",
    CorrectedBill = "CorrectedBill",
    BroodRequestGestation = "BroodRequestGestation",
    MembershipRenewalBillToPay = "MembershipRenewalBillToPay",
    BroodRequestExecuted = "BroodRequestExecuted",
    DysplasiaAppeal = "DysplasiaAppeal",
    RSHExecution = "RSHExecution",
    TitleRequestExecution = "TitleRequestExecution",
    TitleRequestRefused = "TitleRequestRefused",
    PuppyKitReminder = "PuppyKitReminder",
    PuppyDnaReceived = "PuppyDnaReceived",
    DogBirthday = "DogBirthday",
    RequestCancelled = "RequestCancelled",
    PedigreeSampleEmail = "PedigreeSampleEmail",
    PedigreeRequestExecuted = "PedigreeRequestExecuted",
    CompetitionImportSuccess = "CompetitionImportSuccess",
    CompetitionImportFailure = "CompetitionImportFailure",
    HealthRequestLabWork = "HealthRequestLabWork",
    ExpatriationExecutionForeignDog = "ExpatriationExecutionForeignDog",
    ExpatriationExecutionBelgianDog = "ExpatriationExecutionBelgianDog",
    CreateNewMyDogEventForCompetition = "CreateNewMyDogEventForCompetition",
    NewCompetitionAvailableInMyDogEvent = "NewCompetitionAvailableInMyDogEvent",
    ParticipationRequest = "ParticipationRequest",
    RemindJudgeCV = "RemindJudgeCV",
    RemindJudgePicture = "RemindJudgePicture",
    ThankYouSelected = "ThankYouSelected",
    ThankYouNotSelected = "ThankYouNotSelected",
    CompetitionParticipantReminder = "CompetitionParticipantReminder",
    CompetitionSelectedParticipantsReminder = "CompetitionSelectedParticipantsReminder",
    CompetitionPracticalInformationsEmail = "CompetitionPracticalInformationsEmail",
    AfterCompetitionThankYouAndAttest = "AfterCompetitionThankYouAndAttest",
    FirstBillReminder = "FirstBillReminder",
    RingReadyForConfiguration = "RingReadyForConfiguration",
    BroodRequestRefused = "BroodRequestRefused",
}

export class MailTemplateDescriptionsTranslation implements IMailTemplateDescriptionsTranslation {
    mailTemplateDescriptionsTranslationId?: number;
    mailTemplateId?: number;
    text?: string | undefined;
    languageId?: number;
    language?: Language | undefined;
    mailTemplate?: MailTemplate | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IMailTemplateDescriptionsTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplateDescriptionsTranslationId = _data["mailTemplateDescriptionsTranslationId"];
            this.mailTemplateId = _data["mailTemplateId"];
            this.text = _data["text"];
            this.languageId = _data["languageId"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.mailTemplate = _data["mailTemplate"] ? MailTemplate.fromJS(_data["mailTemplate"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MailTemplateDescriptionsTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateDescriptionsTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateDescriptionsTranslationId"] = this.mailTemplateDescriptionsTranslationId;
        data["mailTemplateId"] = this.mailTemplateId;
        data["text"] = this.text;
        data["languageId"] = this.languageId;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["mailTemplate"] = this.mailTemplate ? this.mailTemplate.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMailTemplateDescriptionsTranslation {
    mailTemplateDescriptionsTranslationId?: number;
    mailTemplateId?: number;
    text?: string | undefined;
    languageId?: number;
    language?: Language | undefined;
    mailTemplate?: MailTemplate | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class WebUser implements IWebUser {
    webUserId?: number;
    personId?: number;
    password?: string | undefined;
    mustChangePassword?: boolean;
    active?: boolean;
    lastConnectionDate?: Date | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;

    constructor(data?: IWebUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webUserId = _data["webUserId"];
            this.personId = _data["personId"];
            this.password = _data["password"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.active = _data["active"];
            this.lastConnectionDate = _data["lastConnectionDate"] ? new Date(_data["lastConnectionDate"].toString()) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): WebUser {
        data = typeof data === 'object' ? data : {};
        let result = new WebUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webUserId"] = this.webUserId;
        data["personId"] = this.personId;
        data["password"] = this.password;
        data["mustChangePassword"] = this.mustChangePassword;
        data["active"] = this.active;
        data["lastConnectionDate"] = this.lastConnectionDate ? this.lastConnectionDate.toISOString() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IWebUser {
    webUserId?: number;
    personId?: number;
    password?: string | undefined;
    mustChangePassword?: boolean;
    active?: boolean;
    lastConnectionDate?: Date | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    cegekaId?: string | undefined;
}

export class ChartSignaturesHistory implements IChartSignaturesHistory {
    chartSignaturesHistoryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    personId?: number;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IChartSignaturesHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartSignaturesHistoryId = _data["chartSignaturesHistoryId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ChartSignaturesHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSignaturesHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartSignaturesHistoryId"] = this.chartSignaturesHistoryId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IChartSignaturesHistory {
    chartSignaturesHistoryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    personId?: number;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class Member implements IMember {
    memberId?: number;
    personId?: number;
    memberNumber?: number;
    isCAMember?: boolean;
    isCEMember?: boolean;
    isCynologicCouncilMember?: boolean;
    isFCIDelegateMember?: boolean;
    isVDA?: boolean;
    isSupervisor?: boolean;
    isVolunteer?: boolean;
    isRenewalForced?: boolean | undefined;
    person?: Person | undefined;
    membershipsHistories?: MembershipHistory[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    cegekaId?: string | undefined;

    constructor(data?: IMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.personId = _data["personId"];
            this.memberNumber = _data["memberNumber"];
            this.isCAMember = _data["isCAMember"];
            this.isCEMember = _data["isCEMember"];
            this.isCynologicCouncilMember = _data["isCynologicCouncilMember"];
            this.isFCIDelegateMember = _data["isFCIDelegateMember"];
            this.isVDA = _data["isVDA"];
            this.isSupervisor = _data["isSupervisor"];
            this.isVolunteer = _data["isVolunteer"];
            this.isRenewalForced = _data["isRenewalForced"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["membershipsHistories"])) {
                this.membershipsHistories = [] as any;
                for (let item of _data["membershipsHistories"])
                    this.membershipsHistories!.push(MembershipHistory.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): Member {
        data = typeof data === 'object' ? data : {};
        let result = new Member();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["personId"] = this.personId;
        data["memberNumber"] = this.memberNumber;
        data["isCAMember"] = this.isCAMember;
        data["isCEMember"] = this.isCEMember;
        data["isCynologicCouncilMember"] = this.isCynologicCouncilMember;
        data["isFCIDelegateMember"] = this.isFCIDelegateMember;
        data["isVDA"] = this.isVDA;
        data["isSupervisor"] = this.isSupervisor;
        data["isVolunteer"] = this.isVolunteer;
        data["isRenewalForced"] = this.isRenewalForced;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.membershipsHistories)) {
            data["membershipsHistories"] = [];
            for (let item of this.membershipsHistories)
                data["membershipsHistories"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface IMember {
    memberId?: number;
    personId?: number;
    memberNumber?: number;
    isCAMember?: boolean;
    isCEMember?: boolean;
    isCynologicCouncilMember?: boolean;
    isFCIDelegateMember?: boolean;
    isVDA?: boolean;
    isSupervisor?: boolean;
    isVolunteer?: boolean;
    isRenewalForced?: boolean | undefined;
    person?: Person | undefined;
    membershipsHistories?: MembershipHistory[] | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    cegekaId?: string | undefined;
}

export class MembershipHistory implements IMembershipHistory {
    membershipHistoryId?: number;
    membershipId?: number;
    membershipTypeId?: number;
    membershipRequestId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    endOfRenewalAsked?: boolean;
    membership?: Member | undefined;
    membershipType?: MembershipType | undefined;
    membershipRequest?: MembershipRequest | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IMembershipHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipHistoryId = _data["membershipHistoryId"];
            this.membershipId = _data["membershipId"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.membershipRequestId = _data["membershipRequestId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.endOfRenewalAsked = _data["endOfRenewalAsked"];
            this.membership = _data["membership"] ? Member.fromJS(_data["membership"]) : <any>undefined;
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
            this.membershipRequest = _data["membershipRequest"] ? MembershipRequest.fromJS(_data["membershipRequest"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipHistory {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipHistoryId"] = this.membershipHistoryId;
        data["membershipId"] = this.membershipId;
        data["membershipTypeId"] = this.membershipTypeId;
        data["membershipRequestId"] = this.membershipRequestId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["endOfRenewalAsked"] = this.endOfRenewalAsked;
        data["membership"] = this.membership ? this.membership.toJSON() : <any>undefined;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        data["membershipRequest"] = this.membershipRequest ? this.membershipRequest.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMembershipHistory {
    membershipHistoryId?: number;
    membershipId?: number;
    membershipTypeId?: number;
    membershipRequestId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    endOfRenewalAsked?: boolean;
    membership?: Member | undefined;
    membershipType?: MembershipType | undefined;
    membershipRequest?: MembershipRequest | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class MembershipType implements IMembershipType {
    membershipTypeId?: number;
    code?: EMembershipType;
    membershipTypeTranslations?: MembershipTypeTranslation[] | undefined;
    membershipsHistories?: MembershipHistory[] | undefined;
    membershipRequestInitialTypes?: MembershipRequest[] | undefined;
    membershipRequestFinalTypes?: MembershipRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IMembershipType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipTypeId = _data["membershipTypeId"];
            this.code = _data["code"];
            if (Array.isArray(_data["membershipTypeTranslations"])) {
                this.membershipTypeTranslations = [] as any;
                for (let item of _data["membershipTypeTranslations"])
                    this.membershipTypeTranslations!.push(MembershipTypeTranslation.fromJS(item));
            }
            if (Array.isArray(_data["membershipsHistories"])) {
                this.membershipsHistories = [] as any;
                for (let item of _data["membershipsHistories"])
                    this.membershipsHistories!.push(MembershipHistory.fromJS(item));
            }
            if (Array.isArray(_data["membershipRequestInitialTypes"])) {
                this.membershipRequestInitialTypes = [] as any;
                for (let item of _data["membershipRequestInitialTypes"])
                    this.membershipRequestInitialTypes!.push(MembershipRequest.fromJS(item));
            }
            if (Array.isArray(_data["membershipRequestFinalTypes"])) {
                this.membershipRequestFinalTypes = [] as any;
                for (let item of _data["membershipRequestFinalTypes"])
                    this.membershipRequestFinalTypes!.push(MembershipRequest.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MembershipType {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipTypeId"] = this.membershipTypeId;
        data["code"] = this.code;
        if (Array.isArray(this.membershipTypeTranslations)) {
            data["membershipTypeTranslations"] = [];
            for (let item of this.membershipTypeTranslations)
                data["membershipTypeTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipsHistories)) {
            data["membershipsHistories"] = [];
            for (let item of this.membershipsHistories)
                data["membershipsHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipRequestInitialTypes)) {
            data["membershipRequestInitialTypes"] = [];
            for (let item of this.membershipRequestInitialTypes)
                data["membershipRequestInitialTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipRequestFinalTypes)) {
            data["membershipRequestFinalTypes"] = [];
            for (let item of this.membershipRequestFinalTypes)
                data["membershipRequestFinalTypes"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMembershipType {
    membershipTypeId?: number;
    code?: EMembershipType;
    membershipTypeTranslations?: MembershipTypeTranslation[] | undefined;
    membershipsHistories?: MembershipHistory[] | undefined;
    membershipRequestInitialTypes?: MembershipRequest[] | undefined;
    membershipRequestFinalTypes?: MembershipRequest[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export enum EMembershipType {
    Effective = "Effective",
    Protected = "Protected",
    Acceded = "Acceded",
}

export class MembershipTypeTranslation implements IMembershipTypeTranslation {
    membershipTypeTranslationId?: number;
    membershipTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    membershipType?: MembershipType | undefined;
    language?: Language | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IMembershipTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipTypeTranslationId = _data["membershipTypeTranslationId"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipTypeTranslationId"] = this.membershipTypeTranslationId;
        data["membershipTypeId"] = this.membershipTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMembershipTypeTranslation {
    membershipTypeTranslationId?: number;
    membershipTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    membershipType?: MembershipType | undefined;
    language?: Language | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class MembershipRequest implements IMembershipRequest {
    membershipRequestId?: number;
    requestId?: number;
    membershipRequestDecisionId?: number | undefined;
    membershipInitialTypeId?: number;
    membershipFinalTypeId?: number | undefined;
    membershipRequestTypeId?: number;
    meetingDate?: Date | undefined;
    request?: Request | undefined;
    membershipRequestDecision?: MembershipRequestDecision | undefined;
    membershipRequestType?: MembershipRequestType | undefined;
    membershipInitialtype?: MembershipType | undefined;
    membershipFinalType?: MembershipType | undefined;
    membershipHistory?: MembershipHistory | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IMembershipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestId = _data["membershipRequestId"];
            this.requestId = _data["requestId"];
            this.membershipRequestDecisionId = _data["membershipRequestDecisionId"];
            this.membershipInitialTypeId = _data["membershipInitialTypeId"];
            this.membershipFinalTypeId = _data["membershipFinalTypeId"];
            this.membershipRequestTypeId = _data["membershipRequestTypeId"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            this.membershipRequestDecision = _data["membershipRequestDecision"] ? MembershipRequestDecision.fromJS(_data["membershipRequestDecision"]) : <any>undefined;
            this.membershipRequestType = _data["membershipRequestType"] ? MembershipRequestType.fromJS(_data["membershipRequestType"]) : <any>undefined;
            this.membershipInitialtype = _data["membershipInitialtype"] ? MembershipType.fromJS(_data["membershipInitialtype"]) : <any>undefined;
            this.membershipFinalType = _data["membershipFinalType"] ? MembershipType.fromJS(_data["membershipFinalType"]) : <any>undefined;
            this.membershipHistory = _data["membershipHistory"] ? MembershipHistory.fromJS(_data["membershipHistory"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MembershipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestId"] = this.membershipRequestId;
        data["requestId"] = this.requestId;
        data["membershipRequestDecisionId"] = this.membershipRequestDecisionId;
        data["membershipInitialTypeId"] = this.membershipInitialTypeId;
        data["membershipFinalTypeId"] = this.membershipFinalTypeId;
        data["membershipRequestTypeId"] = this.membershipRequestTypeId;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["membershipRequestDecision"] = this.membershipRequestDecision ? this.membershipRequestDecision.toJSON() : <any>undefined;
        data["membershipRequestType"] = this.membershipRequestType ? this.membershipRequestType.toJSON() : <any>undefined;
        data["membershipInitialtype"] = this.membershipInitialtype ? this.membershipInitialtype.toJSON() : <any>undefined;
        data["membershipFinalType"] = this.membershipFinalType ? this.membershipFinalType.toJSON() : <any>undefined;
        data["membershipHistory"] = this.membershipHistory ? this.membershipHistory.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMembershipRequest {
    membershipRequestId?: number;
    requestId?: number;
    membershipRequestDecisionId?: number | undefined;
    membershipInitialTypeId?: number;
    membershipFinalTypeId?: number | undefined;
    membershipRequestTypeId?: number;
    meetingDate?: Date | undefined;
    request?: Request | undefined;
    membershipRequestDecision?: MembershipRequestDecision | undefined;
    membershipRequestType?: MembershipRequestType | undefined;
    membershipInitialtype?: MembershipType | undefined;
    membershipFinalType?: MembershipType | undefined;
    membershipHistory?: MembershipHistory | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class MembershipRequestDecision implements IMembershipRequestDecision {
    membershipRequestDecisionId?: number;
    code?: EMembershipRequestDecision;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    membershipRequestDecisionTranslations?: MembershipRequestDecisionTranslation[] | undefined;
    membershipRequests?: MembershipRequest[] | undefined;

    constructor(data?: IMembershipRequestDecision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestDecisionId = _data["membershipRequestDecisionId"];
            this.code = _data["code"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["membershipRequestDecisionTranslations"])) {
                this.membershipRequestDecisionTranslations = [] as any;
                for (let item of _data["membershipRequestDecisionTranslations"])
                    this.membershipRequestDecisionTranslations!.push(MembershipRequestDecisionTranslation.fromJS(item));
            }
            if (Array.isArray(_data["membershipRequests"])) {
                this.membershipRequests = [] as any;
                for (let item of _data["membershipRequests"])
                    this.membershipRequests!.push(MembershipRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MembershipRequestDecision {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestDecision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestDecisionId"] = this.membershipRequestDecisionId;
        data["code"] = this.code;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.membershipRequestDecisionTranslations)) {
            data["membershipRequestDecisionTranslations"] = [];
            for (let item of this.membershipRequestDecisionTranslations)
                data["membershipRequestDecisionTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipRequests)) {
            data["membershipRequests"] = [];
            for (let item of this.membershipRequests)
                data["membershipRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMembershipRequestDecision {
    membershipRequestDecisionId?: number;
    code?: EMembershipRequestDecision;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    membershipRequestDecisionTranslations?: MembershipRequestDecisionTranslation[] | undefined;
    membershipRequests?: MembershipRequest[] | undefined;
}

export enum EMembershipRequestDecision {
    Accepted = "Accepted",
    Refused = "Refused",
    OtherType = "OtherType",
}

export class MembershipRequestDecisionTranslation implements IMembershipRequestDecisionTranslation {
    membershipRequestDecisionTranslationId?: number;
    membershipRequestDecisionId?: number;
    languageId?: number;
    text?: string | undefined;
    membershipRequestDecision?: MembershipRequestDecision | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IMembershipRequestDecisionTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestDecisionTranslationId = _data["membershipRequestDecisionTranslationId"];
            this.membershipRequestDecisionId = _data["membershipRequestDecisionId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.membershipRequestDecision = _data["membershipRequestDecision"] ? MembershipRequestDecision.fromJS(_data["membershipRequestDecision"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MembershipRequestDecisionTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestDecisionTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestDecisionTranslationId"] = this.membershipRequestDecisionTranslationId;
        data["membershipRequestDecisionId"] = this.membershipRequestDecisionId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["membershipRequestDecision"] = this.membershipRequestDecision ? this.membershipRequestDecision.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMembershipRequestDecisionTranslation {
    membershipRequestDecisionTranslationId?: number;
    membershipRequestDecisionId?: number;
    languageId?: number;
    text?: string | undefined;
    membershipRequestDecision?: MembershipRequestDecision | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class MembershipRequestType implements IMembershipRequestType {
    membershipRequestTypeId?: number;
    code?: EMembershipRequestType;
    membershipRequestTypeTranslations?: MembershipRequestTypeTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    membershipRequests?: MembershipRequest[] | undefined;

    constructor(data?: IMembershipRequestType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestTypeId = _data["membershipRequestTypeId"];
            this.code = _data["code"];
            if (Array.isArray(_data["membershipRequestTypeTranslations"])) {
                this.membershipRequestTypeTranslations = [] as any;
                for (let item of _data["membershipRequestTypeTranslations"])
                    this.membershipRequestTypeTranslations!.push(MembershipRequestTypeTranslation.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["membershipRequests"])) {
                this.membershipRequests = [] as any;
                for (let item of _data["membershipRequests"])
                    this.membershipRequests!.push(MembershipRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MembershipRequestType {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestTypeId"] = this.membershipRequestTypeId;
        data["code"] = this.code;
        if (Array.isArray(this.membershipRequestTypeTranslations)) {
            data["membershipRequestTypeTranslations"] = [];
            for (let item of this.membershipRequestTypeTranslations)
                data["membershipRequestTypeTranslations"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.membershipRequests)) {
            data["membershipRequests"] = [];
            for (let item of this.membershipRequests)
                data["membershipRequests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMembershipRequestType {
    membershipRequestTypeId?: number;
    code?: EMembershipRequestType;
    membershipRequestTypeTranslations?: MembershipRequestTypeTranslation[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    membershipRequests?: MembershipRequest[] | undefined;
}

export enum EMembershipRequestType {
    NewMembership = "NewMembership",
    MembershipTypeChange = "MembershipTypeChange",
    Renewal = "Renewal",
}

export class MembershipRequestTypeTranslation implements IMembershipRequestTypeTranslation {
    membershipRequestTypeTranslationId?: number;
    membershipRequestTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    membershipRequestType?: MembershipRequestType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IMembershipRequestTypeTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestTypeTranslationId = _data["membershipRequestTypeTranslationId"];
            this.membershipRequestTypeId = _data["membershipRequestTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.membershipRequestType = _data["membershipRequestType"] ? MembershipRequestType.fromJS(_data["membershipRequestType"]) : <any>undefined;
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): MembershipRequestTypeTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestTypeTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestTypeTranslationId"] = this.membershipRequestTypeTranslationId;
        data["membershipRequestTypeId"] = this.membershipRequestTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["membershipRequestType"] = this.membershipRequestType ? this.membershipRequestType.toJSON() : <any>undefined;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IMembershipRequestTypeTranslation {
    membershipRequestTypeTranslationId?: number;
    membershipRequestTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    membershipRequestType?: MembershipRequestType | undefined;
    language?: Language | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class TransientOwnersKennelOwnershipChange implements ITransientOwnersKennelOwnershipChange {
    transientOwnersKennelOwnershipChangeId?: number;
    kennelOwnershipChangeRequestId?: number;
    personId?: number;
    kennelOwnershipChangeRequest?: KennelOwnershipChangeRequest | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ITransientOwnersKennelOwnershipChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transientOwnersKennelOwnershipChangeId = _data["transientOwnersKennelOwnershipChangeId"];
            this.kennelOwnershipChangeRequestId = _data["kennelOwnershipChangeRequestId"];
            this.personId = _data["personId"];
            this.kennelOwnershipChangeRequest = _data["kennelOwnershipChangeRequest"] ? KennelOwnershipChangeRequest.fromJS(_data["kennelOwnershipChangeRequest"]) : <any>undefined;
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): TransientOwnersKennelOwnershipChange {
        data = typeof data === 'object' ? data : {};
        let result = new TransientOwnersKennelOwnershipChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transientOwnersKennelOwnershipChangeId"] = this.transientOwnersKennelOwnershipChangeId;
        data["kennelOwnershipChangeRequestId"] = this.kennelOwnershipChangeRequestId;
        data["personId"] = this.personId;
        data["kennelOwnershipChangeRequest"] = this.kennelOwnershipChangeRequest ? this.kennelOwnershipChangeRequest.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ITransientOwnersKennelOwnershipChange {
    transientOwnersKennelOwnershipChangeId?: number;
    kennelOwnershipChangeRequestId?: number;
    personId?: number;
    kennelOwnershipChangeRequest?: KennelOwnershipChangeRequest | undefined;
    person?: Person | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class KennelOwnershipChangeRequest implements IKennelOwnershipChangeRequest {
    kennelOwnershipChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    kennel?: Kennel | undefined;
    request?: Request | undefined;
    transientOwnersKennelOwnershipChanges?: TransientOwnersKennelOwnershipChange[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IKennelOwnershipChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelOwnershipChangeRequestId = _data["kennelOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.kennelId = _data["kennelId"];
            this.exportDate = _data["exportDate"] ? new Date(_data["exportDate"].toString()) : <any>undefined;
            this.exportForcedValue = _data["exportForcedValue"];
            this.tries = _data["tries"];
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.request = _data["request"] ? Request.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientOwnersKennelOwnershipChanges"])) {
                this.transientOwnersKennelOwnershipChanges = [] as any;
                for (let item of _data["transientOwnersKennelOwnershipChanges"])
                    this.transientOwnersKennelOwnershipChanges!.push(TransientOwnersKennelOwnershipChange.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): KennelOwnershipChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new KennelOwnershipChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelOwnershipChangeRequestId"] = this.kennelOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["kennelId"] = this.kennelId;
        data["exportDate"] = this.exportDate ? this.exportDate.toISOString() : <any>undefined;
        data["exportForcedValue"] = this.exportForcedValue;
        data["tries"] = this.tries;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientOwnersKennelOwnershipChanges)) {
            data["transientOwnersKennelOwnershipChanges"] = [];
            for (let item of this.transientOwnersKennelOwnershipChanges)
                data["transientOwnersKennelOwnershipChanges"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IKennelOwnershipChangeRequest {
    kennelOwnershipChangeRequestId?: number;
    requestId?: number;
    kennelId?: number;
    exportDate?: Date | undefined;
    exportForcedValue?: boolean | undefined;
    tries?: number;
    kennel?: Kennel | undefined;
    request?: Request | undefined;
    transientOwnersKennelOwnershipChanges?: TransientOwnersKennelOwnershipChange[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class BroodRequestSearch extends PaginatedSearch implements IBroodRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    requestDate?: DateSearch | undefined;
    numberOfPuppies?: NumericSearch | undefined;
    protrusionDate?: DateSearch | undefined;
    birthDate?: DateSearch | undefined;
    mother?: TextSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    isBrcsRequest?: BooleanSearch | undefined;

    constructor(data?: IBroodRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.numberOfPuppies = _data["numberOfPuppies"] ? NumericSearch.fromJS(_data["numberOfPuppies"]) : <any>undefined;
            this.protrusionDate = _data["protrusionDate"] ? DateSearch.fromJS(_data["protrusionDate"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? DateSearch.fromJS(_data["birthDate"]) : <any>undefined;
            this.mother = _data["mother"] ? TextSearch.fromJS(_data["mother"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
            this.isBrcsRequest = _data["isBrcsRequest"] ? BooleanSearch.fromJS(_data["isBrcsRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BroodRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["numberOfPuppies"] = this.numberOfPuppies ? this.numberOfPuppies.toJSON() : <any>undefined;
        data["protrusionDate"] = this.protrusionDate ? this.protrusionDate.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        data["isBrcsRequest"] = this.isBrcsRequest ? this.isBrcsRequest.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBroodRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    requestDate?: DateSearch | undefined;
    numberOfPuppies?: NumericSearch | undefined;
    protrusionDate?: DateSearch | undefined;
    birthDate?: DateSearch | undefined;
    mother?: TextSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    isBrcsRequest?: BooleanSearch | undefined;
}

export class BroodRequestDto implements IBroodRequestDto {
    broodRequestId?: number;
    requestId?: number;
    motherId?: number;
    affix?: string | undefined;
    kennelId?: number | undefined;
    price?: number;
    userId?: number;
    labReference?: ELab;
    numberOfPuppiesConfirmed?: boolean;
    progenusQuickDelivery?: boolean;
    isRegisteredLetter?: boolean;
    wantSrshPedigree?: boolean;
    srshPedigreeConfirmed?: boolean;
    brcsPedigreeConfirmed?: boolean;
    request?: RequestDto | undefined;
    availablePuppiesCount?: number;
    otherAddress?: boolean;
    number?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    street?: string | undefined;
    billMotherGenealogyCompletion?: boolean;
    billFatherGenealogyCompletion?: boolean;
    definitiveSave?: boolean;
    numberOfPuppies?: number;
    protrusionDate?: Date;
    birthDate?: Date | undefined;
    babyDogPublication?: boolean;
    hasPuppies?: boolean;
    bornPuppies?: boolean;
    isBrcsRequest?: boolean;
    potentialFatherIds?: number[] | undefined;
    dogBroodRequestGetDto?: DogBroodRequestGetDto | undefined;

    constructor(data?: IBroodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broodRequestId = _data["broodRequestId"];
            this.requestId = _data["requestId"];
            this.motherId = _data["motherId"];
            this.affix = _data["affix"];
            this.kennelId = _data["kennelId"];
            this.price = _data["price"];
            this.userId = _data["userId"];
            this.labReference = _data["labReference"];
            this.numberOfPuppiesConfirmed = _data["numberOfPuppiesConfirmed"];
            this.progenusQuickDelivery = _data["progenusQuickDelivery"];
            this.isRegisteredLetter = _data["isRegisteredLetter"];
            this.wantSrshPedigree = _data["wantSrshPedigree"];
            this.srshPedigreeConfirmed = _data["srshPedigreeConfirmed"];
            this.brcsPedigreeConfirmed = _data["brcsPedigreeConfirmed"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.availablePuppiesCount = _data["availablePuppiesCount"];
            this.otherAddress = _data["otherAddress"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.street = _data["street"];
            this.billMotherGenealogyCompletion = _data["billMotherGenealogyCompletion"];
            this.billFatherGenealogyCompletion = _data["billFatherGenealogyCompletion"];
            this.definitiveSave = _data["definitiveSave"];
            this.numberOfPuppies = _data["numberOfPuppies"];
            this.protrusionDate = _data["protrusionDate"] ? new Date(_data["protrusionDate"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.babyDogPublication = _data["babyDogPublication"];
            this.hasPuppies = _data["hasPuppies"];
            this.bornPuppies = _data["bornPuppies"];
            this.isBrcsRequest = _data["isBrcsRequest"];
            if (Array.isArray(_data["potentialFatherIds"])) {
                this.potentialFatherIds = [] as any;
                for (let item of _data["potentialFatherIds"])
                    this.potentialFatherIds!.push(item);
            }
            this.dogBroodRequestGetDto = _data["dogBroodRequestGetDto"] ? DogBroodRequestGetDto.fromJS(_data["dogBroodRequestGetDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BroodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestId"] = this.broodRequestId;
        data["requestId"] = this.requestId;
        data["motherId"] = this.motherId;
        data["affix"] = this.affix;
        data["kennelId"] = this.kennelId;
        data["price"] = this.price;
        data["userId"] = this.userId;
        data["labReference"] = this.labReference;
        data["numberOfPuppiesConfirmed"] = this.numberOfPuppiesConfirmed;
        data["progenusQuickDelivery"] = this.progenusQuickDelivery;
        data["isRegisteredLetter"] = this.isRegisteredLetter;
        data["wantSrshPedigree"] = this.wantSrshPedigree;
        data["srshPedigreeConfirmed"] = this.srshPedigreeConfirmed;
        data["brcsPedigreeConfirmed"] = this.brcsPedigreeConfirmed;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["availablePuppiesCount"] = this.availablePuppiesCount;
        data["otherAddress"] = this.otherAddress;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["street"] = this.street;
        data["billMotherGenealogyCompletion"] = this.billMotherGenealogyCompletion;
        data["billFatherGenealogyCompletion"] = this.billFatherGenealogyCompletion;
        data["definitiveSave"] = this.definitiveSave;
        data["numberOfPuppies"] = this.numberOfPuppies;
        data["protrusionDate"] = this.protrusionDate ? this.protrusionDate.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["babyDogPublication"] = this.babyDogPublication;
        data["hasPuppies"] = this.hasPuppies;
        data["bornPuppies"] = this.bornPuppies;
        data["isBrcsRequest"] = this.isBrcsRequest;
        if (Array.isArray(this.potentialFatherIds)) {
            data["potentialFatherIds"] = [];
            for (let item of this.potentialFatherIds)
                data["potentialFatherIds"].push(item);
        }
        data["dogBroodRequestGetDto"] = this.dogBroodRequestGetDto ? this.dogBroodRequestGetDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBroodRequestDto {
    broodRequestId?: number;
    requestId?: number;
    motherId?: number;
    affix?: string | undefined;
    kennelId?: number | undefined;
    price?: number;
    userId?: number;
    labReference?: ELab;
    numberOfPuppiesConfirmed?: boolean;
    progenusQuickDelivery?: boolean;
    isRegisteredLetter?: boolean;
    wantSrshPedigree?: boolean;
    srshPedigreeConfirmed?: boolean;
    brcsPedigreeConfirmed?: boolean;
    request?: RequestDto | undefined;
    availablePuppiesCount?: number;
    otherAddress?: boolean;
    number?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    street?: string | undefined;
    billMotherGenealogyCompletion?: boolean;
    billFatherGenealogyCompletion?: boolean;
    definitiveSave?: boolean;
    numberOfPuppies?: number;
    protrusionDate?: Date;
    birthDate?: Date | undefined;
    babyDogPublication?: boolean;
    hasPuppies?: boolean;
    bornPuppies?: boolean;
    isBrcsRequest?: boolean;
    potentialFatherIds?: number[] | undefined;
    dogBroodRequestGetDto?: DogBroodRequestGetDto | undefined;
}

export class DogBroodRequestGetDto implements IDogBroodRequestGetDto {
    motherBreedId?: number;
    motherId?: number;
    birthDate?: Date | undefined;
    babyDogPublication?: boolean;
    currentLetterYear?: string;
    puppies?: DogBroodRequestsTransientDto[] | undefined;

    constructor(data?: IDogBroodRequestGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.motherBreedId = _data["motherBreedId"];
            this.motherId = _data["motherId"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.babyDogPublication = _data["babyDogPublication"];
            this.currentLetterYear = _data["currentLetterYear"];
            if (Array.isArray(_data["puppies"])) {
                this.puppies = [] as any;
                for (let item of _data["puppies"])
                    this.puppies!.push(DogBroodRequestsTransientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DogBroodRequestGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motherBreedId"] = this.motherBreedId;
        data["motherId"] = this.motherId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["babyDogPublication"] = this.babyDogPublication;
        data["currentLetterYear"] = this.currentLetterYear;
        if (Array.isArray(this.puppies)) {
            data["puppies"] = [];
            for (let item of this.puppies)
                data["puppies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDogBroodRequestGetDto {
    motherBreedId?: number;
    motherId?: number;
    birthDate?: Date | undefined;
    babyDogPublication?: boolean;
    currentLetterYear?: string;
    puppies?: DogBroodRequestsTransientDto[] | undefined;
}

export class DogBroodRequestsTransientDto implements IDogBroodRequestsTransientDto {
    dogBroodRequestsTransientId?: number;
    deceased?: boolean;
    labStatus?: ELabStatus;
    broodRequestId?: number;
    kennelId?: number | undefined;
    kennelType?: EKennelType | undefined;
    kennelName?: string | undefined;
    breedId?: number;
    colorId?: number | undefined;
    pedigreeId?: number | undefined;
    chipNumber?: string | undefined;
    name?: string | undefined;
    pedigreeNumber?: string | undefined;
    countryPedigreePrefixId?: number | undefined;
    isAlsh?: boolean;
    isBrcs?: boolean;
    fatherId?: number | undefined;
    fatherName?: string | undefined;
    sex?: string | undefined;
    puppyOwnerEmail?: string | undefined;
    available?: boolean;
    analysisDoneOn?: Date | undefined;
    lastLabStatusUpdateDoneOn?: Date | undefined;
    certificateReceived?: boolean;
    labStatusTranslation?: string | undefined;
    labStatusDescriptionTranslation?: string | undefined;
    dockedTail?: boolean;
    updatedOn?: Date;
    owners?: DogBroodRequestTransientOwnerGridDto[] | undefined;
    inbreeding?: number;
    maxExpectedInbreeding?: number;
    completeName?: string | undefined;
    correspondingDogId?: number | undefined;
    isCorrespondingDogComplete?: boolean | undefined;

    constructor(data?: IDogBroodRequestsTransientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogBroodRequestsTransientId = _data["dogBroodRequestsTransientId"];
            this.deceased = _data["deceased"];
            this.labStatus = _data["labStatus"];
            this.broodRequestId = _data["broodRequestId"];
            this.kennelId = _data["kennelId"];
            this.kennelType = _data["kennelType"];
            this.kennelName = _data["kennelName"];
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.pedigreeId = _data["pedigreeId"];
            this.chipNumber = _data["chipNumber"];
            this.name = _data["name"];
            this.pedigreeNumber = _data["pedigreeNumber"];
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.isAlsh = _data["isAlsh"];
            this.isBrcs = _data["isBrcs"];
            this.fatherId = _data["fatherId"];
            this.fatherName = _data["fatherName"];
            this.sex = _data["sex"];
            this.puppyOwnerEmail = _data["puppyOwnerEmail"];
            this.available = _data["available"];
            this.analysisDoneOn = _data["analysisDoneOn"] ? new Date(_data["analysisDoneOn"].toString()) : <any>undefined;
            this.lastLabStatusUpdateDoneOn = _data["lastLabStatusUpdateDoneOn"] ? new Date(_data["lastLabStatusUpdateDoneOn"].toString()) : <any>undefined;
            this.certificateReceived = _data["certificateReceived"];
            this.labStatusTranslation = _data["labStatusTranslation"];
            this.labStatusDescriptionTranslation = _data["labStatusDescriptionTranslation"];
            this.dockedTail = _data["dockedTail"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(DogBroodRequestTransientOwnerGridDto.fromJS(item));
            }
            this.inbreeding = _data["inbreeding"];
            this.maxExpectedInbreeding = _data["maxExpectedInbreeding"];
            this.completeName = _data["completeName"];
            this.correspondingDogId = _data["correspondingDogId"];
            this.isCorrespondingDogComplete = _data["isCorrespondingDogComplete"];
        }
    }

    static fromJS(data: any): DogBroodRequestsTransientDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestsTransientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogBroodRequestsTransientId"] = this.dogBroodRequestsTransientId;
        data["deceased"] = this.deceased;
        data["labStatus"] = this.labStatus;
        data["broodRequestId"] = this.broodRequestId;
        data["kennelId"] = this.kennelId;
        data["kennelType"] = this.kennelType;
        data["kennelName"] = this.kennelName;
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["pedigreeId"] = this.pedigreeId;
        data["chipNumber"] = this.chipNumber;
        data["name"] = this.name;
        data["pedigreeNumber"] = this.pedigreeNumber;
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["isAlsh"] = this.isAlsh;
        data["isBrcs"] = this.isBrcs;
        data["fatherId"] = this.fatherId;
        data["fatherName"] = this.fatherName;
        data["sex"] = this.sex;
        data["puppyOwnerEmail"] = this.puppyOwnerEmail;
        data["available"] = this.available;
        data["analysisDoneOn"] = this.analysisDoneOn ? this.analysisDoneOn.toISOString() : <any>undefined;
        data["lastLabStatusUpdateDoneOn"] = this.lastLabStatusUpdateDoneOn ? this.lastLabStatusUpdateDoneOn.toISOString() : <any>undefined;
        data["certificateReceived"] = this.certificateReceived;
        data["labStatusTranslation"] = this.labStatusTranslation;
        data["labStatusDescriptionTranslation"] = this.labStatusDescriptionTranslation;
        data["dockedTail"] = this.dockedTail;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item.toJSON());
        }
        data["inbreeding"] = this.inbreeding;
        data["maxExpectedInbreeding"] = this.maxExpectedInbreeding;
        data["completeName"] = this.completeName;
        data["correspondingDogId"] = this.correspondingDogId;
        data["isCorrespondingDogComplete"] = this.isCorrespondingDogComplete;
        return data;
    }
}

export interface IDogBroodRequestsTransientDto {
    dogBroodRequestsTransientId?: number;
    deceased?: boolean;
    labStatus?: ELabStatus;
    broodRequestId?: number;
    kennelId?: number | undefined;
    kennelType?: EKennelType | undefined;
    kennelName?: string | undefined;
    breedId?: number;
    colorId?: number | undefined;
    pedigreeId?: number | undefined;
    chipNumber?: string | undefined;
    name?: string | undefined;
    pedigreeNumber?: string | undefined;
    countryPedigreePrefixId?: number | undefined;
    isAlsh?: boolean;
    isBrcs?: boolean;
    fatherId?: number | undefined;
    fatherName?: string | undefined;
    sex?: string | undefined;
    puppyOwnerEmail?: string | undefined;
    available?: boolean;
    analysisDoneOn?: Date | undefined;
    lastLabStatusUpdateDoneOn?: Date | undefined;
    certificateReceived?: boolean;
    labStatusTranslation?: string | undefined;
    labStatusDescriptionTranslation?: string | undefined;
    dockedTail?: boolean;
    updatedOn?: Date;
    owners?: DogBroodRequestTransientOwnerGridDto[] | undefined;
    inbreeding?: number;
    maxExpectedInbreeding?: number;
    completeName?: string | undefined;
    correspondingDogId?: number | undefined;
    isCorrespondingDogComplete?: boolean | undefined;
}

export class DogBroodRequestTransientOwnerGridDto implements IDogBroodRequestTransientOwnerGridDto {
    personId?: number;
    computedName?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;

    constructor(data?: IDogBroodRequestTransientOwnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.computedName = _data["computedName"];
            this.email = _data["email"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): DogBroodRequestTransientOwnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestTransientOwnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["computedName"] = this.computedName;
        data["email"] = this.email;
        data["address"] = this.address;
        return data;
    }
}

export interface IDogBroodRequestTransientOwnerGridDto {
    personId?: number;
    computedName?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
}

export class DrupalBroodRequestDto implements IDrupalBroodRequestDto {
    broodRequestId?: number;
    breeder?: PersonDto | undefined;
    mother?: DogDto | undefined;
    birthDate?: Date;
    numberOfPuppies?: number;
    price?: number;
    fathers?: DogDto[] | undefined;
    puppies?: DogBroodRequestsTransientDto[] | undefined;
    otherAddress?: boolean;
    number?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    street?: string | undefined;
    definitiveSave?: boolean;

    constructor(data?: IDrupalBroodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.broodRequestId = _data["broodRequestId"];
            this.breeder = _data["breeder"] ? PersonDto.fromJS(_data["breeder"]) : <any>undefined;
            this.mother = _data["mother"] ? DogDto.fromJS(_data["mother"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.numberOfPuppies = _data["numberOfPuppies"];
            this.price = _data["price"];
            if (Array.isArray(_data["fathers"])) {
                this.fathers = [] as any;
                for (let item of _data["fathers"])
                    this.fathers!.push(DogDto.fromJS(item));
            }
            if (Array.isArray(_data["puppies"])) {
                this.puppies = [] as any;
                for (let item of _data["puppies"])
                    this.puppies!.push(DogBroodRequestsTransientDto.fromJS(item));
            }
            this.otherAddress = _data["otherAddress"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.street = _data["street"];
            this.definitiveSave = _data["definitiveSave"];
        }
    }

    static fromJS(data: any): DrupalBroodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalBroodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestId"] = this.broodRequestId;
        data["breeder"] = this.breeder ? this.breeder.toJSON() : <any>undefined;
        data["mother"] = this.mother ? this.mother.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["numberOfPuppies"] = this.numberOfPuppies;
        data["price"] = this.price;
        if (Array.isArray(this.fathers)) {
            data["fathers"] = [];
            for (let item of this.fathers)
                data["fathers"].push(item.toJSON());
        }
        if (Array.isArray(this.puppies)) {
            data["puppies"] = [];
            for (let item of this.puppies)
                data["puppies"].push(item.toJSON());
        }
        data["otherAddress"] = this.otherAddress;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["street"] = this.street;
        data["definitiveSave"] = this.definitiveSave;
        return data;
    }
}

export interface IDrupalBroodRequestDto {
    broodRequestId?: number;
    breeder?: PersonDto | undefined;
    mother?: DogDto | undefined;
    birthDate?: Date;
    numberOfPuppies?: number;
    price?: number;
    fathers?: DogDto[] | undefined;
    puppies?: DogBroodRequestsTransientDto[] | undefined;
    otherAddress?: boolean;
    number?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    street?: string | undefined;
    definitiveSave?: boolean;
}

export class PersonDto implements IPersonDto {
    personId?: number;
    personHonorificId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    languageId?: number;
    computedName?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    hkNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    remark?: string | undefined;
    email?: string | undefined;
    bannedFrom?: Date | undefined;
    bannedTo?: Date | undefined;
    isBadPayer?: boolean;
    deathDate?: Date | undefined;
    birthDate?: Date | undefined;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    societyName?: string | undefined;
    vatNumber?: string | undefined;
    bcLanguageCode?: string | undefined;
    countryIso?: string | undefined;
    address?: string | undefined;
    kennelId?: number | undefined;
    kennelName?: string | undefined;
    sharepointUri?: string | undefined;
    isKnownPerson?: boolean;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.personHonorificId = _data["personHonorificId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageId = _data["languageId"];
            this.computedName = _data["computedName"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.hkNumber = _data["hkNumber"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.remark = _data["remark"];
            this.email = _data["email"];
            this.bannedFrom = _data["bannedFrom"] ? new Date(_data["bannedFrom"].toString()) : <any>undefined;
            this.bannedTo = _data["bannedTo"] ? new Date(_data["bannedTo"].toString()) : <any>undefined;
            this.isBadPayer = _data["isBadPayer"];
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.bcIdentifier = _data["bcIdentifier"];
            this.brcsBcIdentifier = _data["brcsBcIdentifier"];
            this.societyName = _data["societyName"];
            this.vatNumber = _data["vatNumber"];
            this.bcLanguageCode = _data["bcLanguageCode"];
            this.countryIso = _data["countryIso"];
            this.address = _data["address"];
            this.kennelId = _data["kennelId"];
            this.kennelName = _data["kennelName"];
            this.sharepointUri = _data["sharepointUri"];
            this.isKnownPerson = _data["isKnownPerson"];
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["personHonorificId"] = this.personHonorificId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageId"] = this.languageId;
        data["computedName"] = this.computedName;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["hkNumber"] = this.hkNumber;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["remark"] = this.remark;
        data["email"] = this.email;
        data["bannedFrom"] = this.bannedFrom ? this.bannedFrom.toISOString() : <any>undefined;
        data["bannedTo"] = this.bannedTo ? this.bannedTo.toISOString() : <any>undefined;
        data["isBadPayer"] = this.isBadPayer;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["bcIdentifier"] = this.bcIdentifier;
        data["brcsBcIdentifier"] = this.brcsBcIdentifier;
        data["societyName"] = this.societyName;
        data["vatNumber"] = this.vatNumber;
        data["bcLanguageCode"] = this.bcLanguageCode;
        data["countryIso"] = this.countryIso;
        data["address"] = this.address;
        data["kennelId"] = this.kennelId;
        data["kennelName"] = this.kennelName;
        data["sharepointUri"] = this.sharepointUri;
        data["isKnownPerson"] = this.isKnownPerson;
        return data;
    }
}

export interface IPersonDto {
    personId?: number;
    personHonorificId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    languageId?: number;
    computedName?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    hkNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    country?: string | undefined;
    remark?: string | undefined;
    email?: string | undefined;
    bannedFrom?: Date | undefined;
    bannedTo?: Date | undefined;
    isBadPayer?: boolean;
    deathDate?: Date | undefined;
    birthDate?: Date | undefined;
    bcIdentifier?: string | undefined;
    brcsBcIdentifier?: string | undefined;
    societyName?: string | undefined;
    vatNumber?: string | undefined;
    bcLanguageCode?: string | undefined;
    countryIso?: string | undefined;
    address?: string | undefined;
    kennelId?: number | undefined;
    kennelName?: string | undefined;
    sharepointUri?: string | undefined;
    isKnownPerson?: boolean;
}

export class DogDto implements IDogDto {
    dogId?: number;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    unknownMother?: boolean;
    unknownFather?: boolean;
    motherDogId?: number | undefined;
    fatherDogId?: number | undefined;
    kennelId?: number | undefined;
    breedId?: number;
    colorId?: number | undefined;
    color?: string | undefined;
    dogTypeId?: number;
    sex?: EDogSex;
    remark?: string | undefined;
    sharepointUri?: string | undefined;
    countryId?: number | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    countryPedigreePrefixId?: number | undefined;
    dockedTail?: boolean;
    awaitingValidation?: boolean;
    receivedDna?: boolean;
    pedigreeNumber?: string | undefined;
    internalNumber?: string | undefined;
    as400Pedigree?: string | undefined;
    pedigree?: string | undefined;
    socialBehaviour?: boolean;
    breedingAuthorized?: boolean;
    numberOfImportTries?: number;
    workCertification?: string | undefined;
    dogName?: string | undefined;
    dogTypeAuthorized?: boolean;
    dogType?: string | undefined;
    tatoo?: string | undefined;
    breedName?: string | undefined;
    isFromEliteBreeder?: boolean;
    kennel?: Kennel | undefined;
    chipNumber?: string | undefined;
    secondChipNumber?: string | undefined;
    as400Titles?: string | undefined;
    isFci?: boolean;
    inbreedingPercentage?: number | undefined;

    constructor(data?: IDogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.firstName = _data["firstName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.unknownMother = _data["unknownMother"];
            this.unknownFather = _data["unknownFather"];
            this.motherDogId = _data["motherDogId"];
            this.fatherDogId = _data["fatherDogId"];
            this.kennelId = _data["kennelId"];
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.color = _data["color"];
            this.dogTypeId = _data["dogTypeId"];
            this.sex = _data["sex"];
            this.remark = _data["remark"];
            this.sharepointUri = _data["sharepointUri"];
            this.countryId = _data["countryId"];
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionStartDate = _data["exclusionStartDate"] ? new Date(_data["exclusionStartDate"].toString()) : <any>undefined;
            this.exclusionEndDate = _data["exclusionEndDate"] ? new Date(_data["exclusionEndDate"].toString()) : <any>undefined;
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.dockedTail = _data["dockedTail"];
            this.awaitingValidation = _data["awaitingValidation"];
            this.receivedDna = _data["receivedDna"];
            this.pedigreeNumber = _data["pedigreeNumber"];
            this.internalNumber = _data["internalNumber"];
            this.as400Pedigree = _data["as400Pedigree"];
            this.pedigree = _data["pedigree"];
            this.socialBehaviour = _data["socialBehaviour"];
            this.breedingAuthorized = _data["breedingAuthorized"];
            this.numberOfImportTries = _data["numberOfImportTries"];
            this.workCertification = _data["workCertification"];
            this.dogName = _data["dogName"];
            this.dogTypeAuthorized = _data["dogTypeAuthorized"];
            this.dogType = _data["dogType"];
            this.tatoo = _data["tatoo"];
            this.breedName = _data["breedName"];
            this.isFromEliteBreeder = _data["isFromEliteBreeder"];
            this.kennel = _data["kennel"] ? Kennel.fromJS(_data["kennel"]) : <any>undefined;
            this.chipNumber = _data["chipNumber"];
            this.secondChipNumber = _data["secondChipNumber"];
            this.as400Titles = _data["as400Titles"];
            this.isFci = _data["isFci"];
            this.inbreedingPercentage = _data["inbreedingPercentage"];
        }
    }

    static fromJS(data: any): DogDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["firstName"] = this.firstName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["unknownMother"] = this.unknownMother;
        data["unknownFather"] = this.unknownFather;
        data["motherDogId"] = this.motherDogId;
        data["fatherDogId"] = this.fatherDogId;
        data["kennelId"] = this.kennelId;
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["color"] = this.color;
        data["dogTypeId"] = this.dogTypeId;
        data["sex"] = this.sex;
        data["remark"] = this.remark;
        data["sharepointUri"] = this.sharepointUri;
        data["countryId"] = this.countryId;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionStartDate"] = this.exclusionStartDate ? this.exclusionStartDate.toISOString() : <any>undefined;
        data["exclusionEndDate"] = this.exclusionEndDate ? this.exclusionEndDate.toISOString() : <any>undefined;
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["dockedTail"] = this.dockedTail;
        data["awaitingValidation"] = this.awaitingValidation;
        data["receivedDna"] = this.receivedDna;
        data["pedigreeNumber"] = this.pedigreeNumber;
        data["internalNumber"] = this.internalNumber;
        data["as400Pedigree"] = this.as400Pedigree;
        data["pedigree"] = this.pedigree;
        data["socialBehaviour"] = this.socialBehaviour;
        data["breedingAuthorized"] = this.breedingAuthorized;
        data["numberOfImportTries"] = this.numberOfImportTries;
        data["workCertification"] = this.workCertification;
        data["dogName"] = this.dogName;
        data["dogTypeAuthorized"] = this.dogTypeAuthorized;
        data["dogType"] = this.dogType;
        data["tatoo"] = this.tatoo;
        data["breedName"] = this.breedName;
        data["isFromEliteBreeder"] = this.isFromEliteBreeder;
        data["kennel"] = this.kennel ? this.kennel.toJSON() : <any>undefined;
        data["chipNumber"] = this.chipNumber;
        data["secondChipNumber"] = this.secondChipNumber;
        data["as400Titles"] = this.as400Titles;
        data["isFci"] = this.isFci;
        data["inbreedingPercentage"] = this.inbreedingPercentage;
        return data;
    }
}

export interface IDogDto {
    dogId?: number;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    unknownMother?: boolean;
    unknownFather?: boolean;
    motherDogId?: number | undefined;
    fatherDogId?: number | undefined;
    kennelId?: number | undefined;
    breedId?: number;
    colorId?: number | undefined;
    color?: string | undefined;
    dogTypeId?: number;
    sex?: EDogSex;
    remark?: string | undefined;
    sharepointUri?: string | undefined;
    countryId?: number | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    countryPedigreePrefixId?: number | undefined;
    dockedTail?: boolean;
    awaitingValidation?: boolean;
    receivedDna?: boolean;
    pedigreeNumber?: string | undefined;
    internalNumber?: string | undefined;
    as400Pedigree?: string | undefined;
    pedigree?: string | undefined;
    socialBehaviour?: boolean;
    breedingAuthorized?: boolean;
    numberOfImportTries?: number;
    workCertification?: string | undefined;
    dogName?: string | undefined;
    dogTypeAuthorized?: boolean;
    dogType?: string | undefined;
    tatoo?: string | undefined;
    breedName?: string | undefined;
    isFromEliteBreeder?: boolean;
    kennel?: Kennel | undefined;
    chipNumber?: string | undefined;
    secondChipNumber?: string | undefined;
    as400Titles?: string | undefined;
    isFci?: boolean;
    inbreedingPercentage?: number | undefined;
}

export class DogAs400ConditionDto implements IDogAs400ConditionDto {
    dogId?: number;
    computedName?: string | undefined;
    motherDogId?: number | undefined;
    fatherDogId?: number | undefined;
    as400Titles?: string | undefined;

    constructor(data?: IDogAs400ConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.computedName = _data["computedName"];
            this.motherDogId = _data["motherDogId"];
            this.fatherDogId = _data["fatherDogId"];
            this.as400Titles = _data["as400Titles"];
        }
    }

    static fromJS(data: any): DogAs400ConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogAs400ConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["computedName"] = this.computedName;
        data["motherDogId"] = this.motherDogId;
        data["fatherDogId"] = this.fatherDogId;
        data["as400Titles"] = this.as400Titles;
        return data;
    }
}

export interface IDogAs400ConditionDto {
    dogId?: number;
    computedName?: string | undefined;
    motherDogId?: number | undefined;
    fatherDogId?: number | undefined;
    as400Titles?: string | undefined;
}

export class FileDto implements IFileDto {
    fileName?: string | undefined;
    fileBytes?: string | undefined;
    extension?: string | undefined;
    nameWithoutExtension?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileBytes = _data["fileBytes"];
            this.extension = _data["extension"];
            this.nameWithoutExtension = _data["nameWithoutExtension"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileBytes"] = this.fileBytes;
        data["extension"] = this.extension;
        data["nameWithoutExtension"] = this.nameWithoutExtension;
        return data;
    }
}

export interface IFileDto {
    fileName?: string | undefined;
    fileBytes?: string | undefined;
    extension?: string | undefined;
    nameWithoutExtension?: string | undefined;
}

export class BroodRequesReportDetailDto implements IBroodRequesReportDetailDto {
    dateFrom?: Date;
    dateTo?: Date;
    breedId?: number | undefined;

    constructor(data?: IBroodRequesReportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.breedId = _data["breedId"];
        }
    }

    static fromJS(data: any): BroodRequesReportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new BroodRequesReportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["breedId"] = this.breedId;
        return data;
    }
}

export interface IBroodRequesReportDetailDto {
    dateFrom?: Date;
    dateTo?: Date;
    breedId?: number | undefined;
}

export class BabyDogPublicationDto implements IBabyDogPublicationDto {
    breederComputedName?: string | undefined;
    breederCity?: string | undefined;
    availablePuppies?: number;
    birthDate?: Date;
    price?: number;
    shouldGetPictures?: boolean;
    puppyPicture1ShpDriveItemId?: string | undefined;
    puppyPicture2ShpDriveItemId?: string | undefined;
    puppyPicture3ShpDriveItemId?: string | undefined;
    sharepointUri?: string | undefined;
    requestId?: number;
    breederPhoneNumber?: string | undefined;
    breederMobileNumber?: string | undefined;
    breederEmail?: string | undefined;

    constructor(data?: IBabyDogPublicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breederComputedName = _data["breederComputedName"];
            this.breederCity = _data["breederCity"];
            this.availablePuppies = _data["availablePuppies"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.price = _data["price"];
            this.shouldGetPictures = _data["shouldGetPictures"];
            this.puppyPicture1ShpDriveItemId = _data["puppyPicture1ShpDriveItemId"];
            this.puppyPicture2ShpDriveItemId = _data["puppyPicture2ShpDriveItemId"];
            this.puppyPicture3ShpDriveItemId = _data["puppyPicture3ShpDriveItemId"];
            this.sharepointUri = _data["sharepointUri"];
            this.requestId = _data["requestId"];
            this.breederPhoneNumber = _data["breederPhoneNumber"];
            this.breederMobileNumber = _data["breederMobileNumber"];
            this.breederEmail = _data["breederEmail"];
        }
    }

    static fromJS(data: any): BabyDogPublicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BabyDogPublicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breederComputedName"] = this.breederComputedName;
        data["breederCity"] = this.breederCity;
        data["availablePuppies"] = this.availablePuppies;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["shouldGetPictures"] = this.shouldGetPictures;
        data["puppyPicture1ShpDriveItemId"] = this.puppyPicture1ShpDriveItemId;
        data["puppyPicture2ShpDriveItemId"] = this.puppyPicture2ShpDriveItemId;
        data["puppyPicture3ShpDriveItemId"] = this.puppyPicture3ShpDriveItemId;
        data["sharepointUri"] = this.sharepointUri;
        data["requestId"] = this.requestId;
        data["breederPhoneNumber"] = this.breederPhoneNumber;
        data["breederMobileNumber"] = this.breederMobileNumber;
        data["breederEmail"] = this.breederEmail;
        return data;
    }
}

export interface IBabyDogPublicationDto {
    breederComputedName?: string | undefined;
    breederCity?: string | undefined;
    availablePuppies?: number;
    birthDate?: Date;
    price?: number;
    shouldGetPictures?: boolean;
    puppyPicture1ShpDriveItemId?: string | undefined;
    puppyPicture2ShpDriveItemId?: string | undefined;
    puppyPicture3ShpDriveItemId?: string | undefined;
    sharepointUri?: string | undefined;
    requestId?: number;
    breederPhoneNumber?: string | undefined;
    breederMobileNumber?: string | undefined;
    breederEmail?: string | undefined;
}

export class PuppyGenealogyDto implements IPuppyGenealogyDto {
    fatherId?: number;
    fatherName?: string | undefined;
    genealogyList?: DogWithParentsDto[] | undefined;

    constructor(data?: IPuppyGenealogyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fatherId = _data["fatherId"];
            this.fatherName = _data["fatherName"];
            if (Array.isArray(_data["genealogyList"])) {
                this.genealogyList = [] as any;
                for (let item of _data["genealogyList"])
                    this.genealogyList!.push(DogWithParentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PuppyGenealogyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PuppyGenealogyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fatherId"] = this.fatherId;
        data["fatherName"] = this.fatherName;
        if (Array.isArray(this.genealogyList)) {
            data["genealogyList"] = [];
            for (let item of this.genealogyList)
                data["genealogyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPuppyGenealogyDto {
    fatherId?: number;
    fatherName?: string | undefined;
    genealogyList?: DogWithParentsDto[] | undefined;
}

export class DogWithParentsDto implements IDogWithParentsDto {
    parent?: string | undefined;
    child?: string | undefined;
    salt?: number;
    parentNodeId?: string | undefined;
    dogType?: EBroodRequestDogType;
    name?: string | undefined;
    firstName?: string | undefined;
    dogId?: number;
    motherDogId?: number | undefined;
    fatherDogId?: number | undefined;
    depthLevel?: number;
    sex?: EDogSex | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    pedigree?: string | undefined;
    breedName?: string | undefined;

    constructor(data?: IDogWithParentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent = _data["parent"];
            this.child = _data["child"];
            this.salt = _data["salt"];
            this.parentNodeId = _data["parentNodeId"];
            this.dogType = _data["dogType"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.dogId = _data["dogId"];
            this.motherDogId = _data["motherDogId"];
            this.fatherDogId = _data["fatherDogId"];
            this.depthLevel = _data["depthLevel"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.pedigree = _data["pedigree"];
            this.breedName = _data["breedName"];
        }
    }

    static fromJS(data: any): DogWithParentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogWithParentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent"] = this.parent;
        data["child"] = this.child;
        data["salt"] = this.salt;
        data["parentNodeId"] = this.parentNodeId;
        data["dogType"] = this.dogType;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["dogId"] = this.dogId;
        data["motherDogId"] = this.motherDogId;
        data["fatherDogId"] = this.fatherDogId;
        data["depthLevel"] = this.depthLevel;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["pedigree"] = this.pedigree;
        data["breedName"] = this.breedName;
        return data;
    }
}

export interface IDogWithParentsDto {
    parent?: string | undefined;
    child?: string | undefined;
    salt?: number;
    parentNodeId?: string | undefined;
    dogType?: EBroodRequestDogType;
    name?: string | undefined;
    firstName?: string | undefined;
    dogId?: number;
    motherDogId?: number | undefined;
    fatherDogId?: number | undefined;
    depthLevel?: number;
    sex?: EDogSex | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    pedigree?: string | undefined;
    breedName?: string | undefined;
}

export enum EBroodRequestDogType {
    Puppy = "Puppy",
    Dog = "Dog",
    Mother = "Mother",
    Father = "Father",
}

export class DogConditionDto implements IDogConditionDto {
    name?: string | undefined;
    concernedSex?: EDogSex;
    conditions?: DogConditionValueDto[] | undefined;
    dogId?: number;
    isGenealogyComplete?: boolean;

    constructor(data?: IDogConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.concernedSex = _data["concernedSex"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(DogConditionValueDto.fromJS(item));
            }
            this.dogId = _data["dogId"];
            this.isGenealogyComplete = _data["isGenealogyComplete"];
        }
    }

    static fromJS(data: any): DogConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["concernedSex"] = this.concernedSex;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        data["dogId"] = this.dogId;
        data["isGenealogyComplete"] = this.isGenealogyComplete;
        return data;
    }
}

export interface IDogConditionDto {
    name?: string | undefined;
    concernedSex?: EDogSex;
    conditions?: DogConditionValueDto[] | undefined;
    dogId?: number;
    isGenealogyComplete?: boolean;
}

export class DogConditionValueDto implements IDogConditionValueDto {
    dogNeededConditionId?: number;
    conditionCode?: EDogCondition;
    forceable?: boolean;
    label?: string | undefined;
    forced?: boolean;
    value?: boolean;

    constructor(data?: IDogConditionValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogNeededConditionId = _data["dogNeededConditionId"];
            this.conditionCode = _data["conditionCode"];
            this.forceable = _data["forceable"];
            this.label = _data["label"];
            this.forced = _data["forced"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DogConditionValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogConditionValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogNeededConditionId"] = this.dogNeededConditionId;
        data["conditionCode"] = this.conditionCode;
        data["forceable"] = this.forceable;
        data["label"] = this.label;
        data["forced"] = this.forced;
        data["value"] = this.value;
        return data;
    }
}

export interface IDogConditionValueDto {
    dogNeededConditionId?: number;
    conditionCode?: EDogCondition;
    forceable?: boolean;
    label?: string | undefined;
    forced?: boolean;
    value?: boolean;
}

export class SaveDogBroodRequestTransientDto implements ISaveDogBroodRequestTransientDto {
    puppies?: DogBroodRequestsTransientDto[] | undefined;
    definitiveSave?: boolean;

    constructor(data?: ISaveDogBroodRequestTransientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["puppies"])) {
                this.puppies = [] as any;
                for (let item of _data["puppies"])
                    this.puppies!.push(DogBroodRequestsTransientDto.fromJS(item));
            }
            this.definitiveSave = _data["definitiveSave"];
        }
    }

    static fromJS(data: any): SaveDogBroodRequestTransientDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDogBroodRequestTransientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.puppies)) {
            data["puppies"] = [];
            for (let item of this.puppies)
                data["puppies"].push(item.toJSON());
        }
        data["definitiveSave"] = this.definitiveSave;
        return data;
    }
}

export interface ISaveDogBroodRequestTransientDto {
    puppies?: DogBroodRequestsTransientDto[] | undefined;
    definitiveSave?: boolean;
}

export class PaginatedResultsOfPotentialFatherGridDto implements IPaginatedResultsOfPotentialFatherGridDto {
    totalCount?: number;
    results?: PotentialFatherGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPotentialFatherGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PotentialFatherGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPotentialFatherGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPotentialFatherGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPotentialFatherGridDto {
    totalCount?: number;
    results?: PotentialFatherGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PotentialFatherGridDto implements IPotentialFatherGridDto {
    dogId?: number;
    name?: string | undefined;
    ownerApproval?: boolean | undefined;
    breed?: string | undefined;
    color?: string | undefined;
    chip?: string | undefined;
    pedigree?: string | undefined;

    constructor(data?: IPotentialFatherGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.name = _data["name"];
            this.ownerApproval = _data["ownerApproval"];
            this.breed = _data["breed"];
            this.color = _data["color"];
            this.chip = _data["chip"];
            this.pedigree = _data["pedigree"];
        }
    }

    static fromJS(data: any): PotentialFatherGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PotentialFatherGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["name"] = this.name;
        data["ownerApproval"] = this.ownerApproval;
        data["breed"] = this.breed;
        data["color"] = this.color;
        data["chip"] = this.chip;
        data["pedigree"] = this.pedigree;
        return data;
    }
}

export interface IPotentialFatherGridDto {
    dogId?: number;
    name?: string | undefined;
    ownerApproval?: boolean | undefined;
    breed?: string | undefined;
    color?: string | undefined;
    chip?: string | undefined;
    pedigree?: string | undefined;
}

export class PotentialFathersSearch extends PaginatedSearch implements IPotentialFathersSearch {
    broodRequestId?: number;
    languageId?: number;
    name?: TextSearch | undefined;

    constructor(data?: IPotentialFathersSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.broodRequestId = _data["broodRequestId"];
            this.languageId = _data["languageId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PotentialFathersSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PotentialFathersSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broodRequestId"] = this.broodRequestId;
        data["languageId"] = this.languageId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPotentialFathersSearch extends IPaginatedSearch {
    broodRequestId?: number;
    languageId?: number;
    name?: TextSearch | undefined;
}

export class PaginatedResultsOfCalendarYearDto implements IPaginatedResultsOfCalendarYearDto {
    totalCount?: number;
    results?: CalendarYearDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCalendarYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CalendarYearDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCalendarYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCalendarYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCalendarYearDto {
    totalCount?: number;
    results?: CalendarYearDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CalendarYearDto implements ICalendarYearDto {
    calendarYearId?: number;
    year?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    namingLetter?: string;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICalendarYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarYearId = _data["calendarYearId"];
            this.year = _data["year"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.namingLetter = _data["namingLetter"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CalendarYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarYearId"] = this.calendarYearId;
        data["year"] = this.year;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["namingLetter"] = this.namingLetter;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICalendarYearDto {
    calendarYearId?: number;
    year?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    namingLetter?: string;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class CalendarYearSearch extends PaginatedSearch implements ICalendarYearSearch {

    constructor(data?: ICalendarYearSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CalendarYearSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarYearSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICalendarYearSearch extends IPaginatedSearch {
}

export class PaginatedResultsOfCharacteristicsGridDto implements IPaginatedResultsOfCharacteristicsGridDto {
    totalCount?: number;
    results?: CharacteristicsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCharacteristicsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CharacteristicsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCharacteristicsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCharacteristicsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCharacteristicsGridDto {
    totalCount?: number;
    results?: CharacteristicsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CharacteristicsGridDto implements ICharacteristicsGridDto {
    characteristicId?: number;
    characteristicTypeId?: number;
    appliedToDysplasia?: EDysplasiaType | undefined;
    code?: string | undefined;
    characteristicType?: string | undefined;
    name?: string | undefined;
    lab?: ELab | undefined;
    labName?: string | undefined;
    price?: number;
    orderIndex?: number;

    constructor(data?: ICharacteristicsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicId = _data["characteristicId"];
            this.characteristicTypeId = _data["characteristicTypeId"];
            this.appliedToDysplasia = _data["appliedToDysplasia"];
            this.code = _data["code"];
            this.characteristicType = _data["characteristicType"];
            this.name = _data["name"];
            this.lab = _data["lab"];
            this.labName = _data["labName"];
            this.price = _data["price"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): CharacteristicsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicId"] = this.characteristicId;
        data["characteristicTypeId"] = this.characteristicTypeId;
        data["appliedToDysplasia"] = this.appliedToDysplasia;
        data["code"] = this.code;
        data["characteristicType"] = this.characteristicType;
        data["name"] = this.name;
        data["lab"] = this.lab;
        data["labName"] = this.labName;
        data["price"] = this.price;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface ICharacteristicsGridDto {
    characteristicId?: number;
    characteristicTypeId?: number;
    appliedToDysplasia?: EDysplasiaType | undefined;
    code?: string | undefined;
    characteristicType?: string | undefined;
    name?: string | undefined;
    lab?: ELab | undefined;
    labName?: string | undefined;
    price?: number;
    orderIndex?: number;
}

export class CharacteristicSearch extends PaginatedSearch implements ICharacteristicSearch {
    languageId?: number;
    onlyIsLab?: boolean;
    hideDysplasia?: boolean;
    hideProgenusDna?: boolean;
    name?: TextSearch | undefined;
    code?: TextSearch | undefined;
    characteristicTypeId?: ListSearchOfNullableInteger | undefined;
    lab?: ListSearchOfNullableELab | undefined;
    customLab?: ELab | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: ICharacteristicSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.onlyIsLab = _data["onlyIsLab"];
            this.hideDysplasia = _data["hideDysplasia"];
            this.hideProgenusDna = _data["hideProgenusDna"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.code = _data["code"] ? TextSearch.fromJS(_data["code"]) : <any>undefined;
            this.characteristicTypeId = _data["characteristicTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["characteristicTypeId"]) : <any>undefined;
            this.lab = _data["lab"] ? ListSearchOfNullableELab.fromJS(_data["lab"]) : <any>undefined;
            this.customLab = _data["customLab"];
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): CharacteristicSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["onlyIsLab"] = this.onlyIsLab;
        data["hideDysplasia"] = this.hideDysplasia;
        data["hideProgenusDna"] = this.hideProgenusDna;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["characteristicTypeId"] = this.characteristicTypeId ? this.characteristicTypeId.toJSON() : <any>undefined;
        data["lab"] = this.lab ? this.lab.toJSON() : <any>undefined;
        data["customLab"] = this.customLab;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface ICharacteristicSearch extends IPaginatedSearch {
    languageId?: number;
    onlyIsLab?: boolean;
    hideDysplasia?: boolean;
    hideProgenusDna?: boolean;
    name?: TextSearch | undefined;
    code?: TextSearch | undefined;
    characteristicTypeId?: ListSearchOfNullableInteger | undefined;
    lab?: ListSearchOfNullableELab | undefined;
    customLab?: ELab | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableELab implements IFilterCriteriaBaseOfEListSearchTypeAndNullableELab {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableELab[] | undefined;
    searchMode?: EListSearchType;
    value?: ELab | undefined;
    secondaryValue?: ELab | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableELab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableELab.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableELab {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableELab' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableELab {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableELab[] | undefined;
    searchMode?: EListSearchType;
    value?: ELab | undefined;
    secondaryValue?: ELab | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfNullableELab extends FilterCriteriaBaseOfEListSearchTypeAndNullableELab implements IListSearchOfNullableELab {

    constructor(data?: IListSearchOfNullableELab) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfNullableELab {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableELab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfNullableELab extends IFilterCriteriaBaseOfEListSearchTypeAndNullableELab {
}

export class CombinableCriteriaOfEListSearchTypeAndNullableELab implements ICombinableCriteriaOfEListSearchTypeAndNullableELab {
    searchMode?: EListSearchType;
    value?: ELab | undefined;
    secondaryValue?: ELab | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableELab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableELab {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableELab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableELab {
    searchMode?: EListSearchType;
    value?: ELab | undefined;
    secondaryValue?: ELab | undefined;
}

export class CharacteristicsDto implements ICharacteristicsDto {
    characteristicId?: number;
    characteristicTypeId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    code?: string | undefined;
    labCode?: string | undefined;
    dysplasiaTypeId?: number | undefined;
    characteristicValuesIds?: number[] | undefined;
    type?: string | undefined;
    characteristicTranslations?: CharacteristicTranslationDto[] | undefined;
    lab?: ELab;
    healthValueTypeId?: number;

    constructor(data?: ICharacteristicsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicId = _data["characteristicId"];
            this.characteristicTypeId = _data["characteristicTypeId"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.code = _data["code"];
            this.labCode = _data["labCode"];
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            if (Array.isArray(_data["characteristicValuesIds"])) {
                this.characteristicValuesIds = [] as any;
                for (let item of _data["characteristicValuesIds"])
                    this.characteristicValuesIds!.push(item);
            }
            this.type = _data["type"];
            if (Array.isArray(_data["characteristicTranslations"])) {
                this.characteristicTranslations = [] as any;
                for (let item of _data["characteristicTranslations"])
                    this.characteristicTranslations!.push(CharacteristicTranslationDto.fromJS(item));
            }
            this.lab = _data["lab"];
            this.healthValueTypeId = _data["healthValueTypeId"];
        }
    }

    static fromJS(data: any): CharacteristicsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicId"] = this.characteristicId;
        data["characteristicTypeId"] = this.characteristicTypeId;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["code"] = this.code;
        data["labCode"] = this.labCode;
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        if (Array.isArray(this.characteristicValuesIds)) {
            data["characteristicValuesIds"] = [];
            for (let item of this.characteristicValuesIds)
                data["characteristicValuesIds"].push(item);
        }
        data["type"] = this.type;
        if (Array.isArray(this.characteristicTranslations)) {
            data["characteristicTranslations"] = [];
            for (let item of this.characteristicTranslations)
                data["characteristicTranslations"].push(item.toJSON());
        }
        data["lab"] = this.lab;
        data["healthValueTypeId"] = this.healthValueTypeId;
        return data;
    }
}

export interface ICharacteristicsDto {
    characteristicId?: number;
    characteristicTypeId?: number;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    code?: string | undefined;
    labCode?: string | undefined;
    dysplasiaTypeId?: number | undefined;
    characteristicValuesIds?: number[] | undefined;
    type?: string | undefined;
    characteristicTranslations?: CharacteristicTranslationDto[] | undefined;
    lab?: ELab;
    healthValueTypeId?: number;
}

export class CharacteristicTranslationDto implements ICharacteristicTranslationDto {
    characteristicId?: number;
    languageId?: number;
    text?: string | undefined;
    characteristicTranslationId?: number;

    constructor(data?: ICharacteristicTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicId = _data["characteristicId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.characteristicTranslationId = _data["characteristicTranslationId"];
        }
    }

    static fromJS(data: any): CharacteristicTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicId"] = this.characteristicId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["characteristicTranslationId"] = this.characteristicTranslationId;
        return data;
    }
}

export interface ICharacteristicTranslationDto {
    characteristicId?: number;
    languageId?: number;
    text?: string | undefined;
    characteristicTranslationId?: number;
}

export class PaginatedResultsOfCharacteristicValuesGridDto implements IPaginatedResultsOfCharacteristicValuesGridDto {
    totalCount?: number;
    results?: CharacteristicValuesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCharacteristicValuesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CharacteristicValuesGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCharacteristicValuesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCharacteristicValuesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCharacteristicValuesGridDto {
    totalCount?: number;
    results?: CharacteristicValuesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CharacteristicValuesGridDto implements ICharacteristicValuesGridDto {
    healthValueId?: number;
    value?: string | undefined;
    name?: string | undefined;
    lab?: ELab;
    okForInheritance?: boolean;

    constructor(data?: ICharacteristicValuesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueId = _data["healthValueId"];
            this.value = _data["value"];
            this.name = _data["name"];
            this.lab = _data["lab"];
            this.okForInheritance = _data["okForInheritance"];
        }
    }

    static fromJS(data: any): CharacteristicValuesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicValuesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueId"] = this.healthValueId;
        data["value"] = this.value;
        data["name"] = this.name;
        data["lab"] = this.lab;
        data["okForInheritance"] = this.okForInheritance;
        return data;
    }
}

export interface ICharacteristicValuesGridDto {
    healthValueId?: number;
    value?: string | undefined;
    name?: string | undefined;
    lab?: ELab;
    okForInheritance?: boolean;
}

export class CharacteristicValuesSearch extends PaginatedSearch implements ICharacteristicValuesSearch {
    languageId?: number;
    characteristicValuesId?: number;
    name?: TextSearch | undefined;
    lab?: ListSearchOfNullableELab | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: ICharacteristicValuesSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.characteristicValuesId = _data["characteristicValuesId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.lab = _data["lab"] ? ListSearchOfNullableELab.fromJS(_data["lab"]) : <any>undefined;
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): CharacteristicValuesSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicValuesSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["characteristicValuesId"] = this.characteristicValuesId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["lab"] = this.lab ? this.lab.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface ICharacteristicValuesSearch extends IPaginatedSearch {
    languageId?: number;
    characteristicValuesId?: number;
    name?: TextSearch | undefined;
    lab?: ListSearchOfNullableELab | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class CharacteristicValuesDto implements ICharacteristicValuesDto {
    healthValueId?: number;
    value?: string | undefined;
    remark?: string | undefined;
    lab?: ELab;
    okForInheritance?: boolean;
    characteristicValuesTranslations?: CharacteristicValuesTranslationDto[] | undefined;

    constructor(data?: ICharacteristicValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueId = _data["healthValueId"];
            this.value = _data["value"];
            this.remark = _data["remark"];
            this.lab = _data["lab"];
            this.okForInheritance = _data["okForInheritance"];
            if (Array.isArray(_data["characteristicValuesTranslations"])) {
                this.characteristicValuesTranslations = [] as any;
                for (let item of _data["characteristicValuesTranslations"])
                    this.characteristicValuesTranslations!.push(CharacteristicValuesTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CharacteristicValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueId"] = this.healthValueId;
        data["value"] = this.value;
        data["remark"] = this.remark;
        data["lab"] = this.lab;
        data["okForInheritance"] = this.okForInheritance;
        if (Array.isArray(this.characteristicValuesTranslations)) {
            data["characteristicValuesTranslations"] = [];
            for (let item of this.characteristicValuesTranslations)
                data["characteristicValuesTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICharacteristicValuesDto {
    healthValueId?: number;
    value?: string | undefined;
    remark?: string | undefined;
    lab?: ELab;
    okForInheritance?: boolean;
    characteristicValuesTranslations?: CharacteristicValuesTranslationDto[] | undefined;
}

export class CharacteristicValuesTranslationDto implements ICharacteristicValuesTranslationDto {
    healthValueId?: number;
    languageId?: number;
    text?: string | undefined;
    healthValueTranslationId?: number;

    constructor(data?: ICharacteristicValuesTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthValueId = _data["healthValueId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.healthValueTranslationId = _data["healthValueTranslationId"];
        }
    }

    static fromJS(data: any): CharacteristicValuesTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharacteristicValuesTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthValueId"] = this.healthValueId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["healthValueTranslationId"] = this.healthValueTranslationId;
        return data;
    }
}

export interface ICharacteristicValuesTranslationDto {
    healthValueId?: number;
    languageId?: number;
    text?: string | undefined;
    healthValueTranslationId?: number;
}

export class PaginatedResultsOfChartSignaturesHistoryDto implements IPaginatedResultsOfChartSignaturesHistoryDto {
    totalCount?: number;
    results?: ChartSignaturesHistoryDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfChartSignaturesHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ChartSignaturesHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfChartSignaturesHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfChartSignaturesHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfChartSignaturesHistoryDto {
    totalCount?: number;
    results?: ChartSignaturesHistoryDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ChartSignaturesHistoryDto implements IChartSignaturesHistoryDto {
    chartSignaturesHistoryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    personId?: number;

    constructor(data?: IChartSignaturesHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartSignaturesHistoryId = _data["chartSignaturesHistoryId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): ChartSignaturesHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSignaturesHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartSignaturesHistoryId"] = this.chartSignaturesHistoryId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IChartSignaturesHistoryDto {
    chartSignaturesHistoryId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    personId?: number;
}

export class ChartSignaturesHistorySearch extends PaginatedSearch implements IChartSignaturesHistorySearch {
    personId?: number;

    constructor(data?: IChartSignaturesHistorySearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): ChartSignaturesHistorySearch {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSignaturesHistorySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        super.toJSON(data);
        return data;
    }
}

export interface IChartSignaturesHistorySearch extends IPaginatedSearch {
    personId?: number;
}

export class PaginatedResultsOfClinicGridDto implements IPaginatedResultsOfClinicGridDto {
    totalCount?: number;
    results?: ClinicGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClinicGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClinicGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClinicGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClinicGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClinicGridDto {
    totalCount?: number;
    results?: ClinicGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClinicGridDto implements IClinicGridDto {
    clinicId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IClinicGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ClinicGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IClinicGridDto {
    clinicId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ClinicSearch extends PaginatedSearch implements IClinicSearch {
    languageId?: number;
    name?: TextSearch | undefined;

    constructor(data?: IClinicSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClinicSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicSearch extends IPaginatedSearch {
    languageId?: number;
    name?: TextSearch | undefined;
}

export class ClinicDto implements IClinicDto {
    clinicId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    languageId?: number;
    siteWeb?: string | undefined;
    tva?: string | undefined;
    adress?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;

    constructor(data?: IClinicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicId = _data["clinicId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.languageId = _data["languageId"];
            this.siteWeb = _data["siteWeb"];
            this.tva = _data["tva"];
            this.adress = _data["adress"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): ClinicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicId"] = this.clinicId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["languageId"] = this.languageId;
        data["siteWeb"] = this.siteWeb;
        data["tva"] = this.tva;
        data["adress"] = this.adress;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IClinicDto {
    clinicId?: number;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    languageId?: number;
    siteWeb?: string | undefined;
    tva?: string | undefined;
    adress?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
}

export class PaginatedResultsOfClubAllowedSectionsDto implements IPaginatedResultsOfClubAllowedSectionsDto {
    totalCount?: number;
    results?: ClubAllowedSectionsDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClubAllowedSectionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClubAllowedSectionsDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClubAllowedSectionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClubAllowedSectionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClubAllowedSectionsDto {
    totalCount?: number;
    results?: ClubAllowedSectionsDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClubAllowedSectionsDto implements IClubAllowedSectionsDto {
    clubSectionId?: number;
    contactEmails?: string | undefined;
    sectionId?: number;
    clubId?: number;
    sectionName?: string | undefined;

    constructor(data?: IClubAllowedSectionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubSectionId = _data["clubSectionId"];
            this.contactEmails = _data["contactEmails"];
            this.sectionId = _data["sectionId"];
            this.clubId = _data["clubId"];
            this.sectionName = _data["sectionName"];
        }
    }

    static fromJS(data: any): ClubAllowedSectionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubAllowedSectionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubSectionId"] = this.clubSectionId;
        data["contactEmails"] = this.contactEmails;
        data["sectionId"] = this.sectionId;
        data["clubId"] = this.clubId;
        data["sectionName"] = this.sectionName;
        return data;
    }
}

export interface IClubAllowedSectionsDto {
    clubSectionId?: number;
    contactEmails?: string | undefined;
    sectionId?: number;
    clubId?: number;
    sectionName?: string | undefined;
}

export class ClubAllowedSectionsSearch extends PaginatedSearch implements IClubAllowedSectionsSearch {
    languageId?: string | undefined;
    clubId?: number;
    sectionId?: number;

    constructor(data?: IClubAllowedSectionsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.clubId = _data["clubId"];
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any): ClubAllowedSectionsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubAllowedSectionsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["clubId"] = this.clubId;
        data["sectionId"] = this.sectionId;
        super.toJSON(data);
        return data;
    }
}

export interface IClubAllowedSectionsSearch extends IPaginatedSearch {
    languageId?: string | undefined;
    clubId?: number;
    sectionId?: number;
}

export class SaveNewClubAllowedSectionDto implements ISaveNewClubAllowedSectionDto {
    allowedSectionClubId?: number;
    sectionId?: number;
    clubId?: number;
    contactEmails?: string | undefined;

    constructor(data?: ISaveNewClubAllowedSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowedSectionClubId = _data["allowedSectionClubId"];
            this.sectionId = _data["sectionId"];
            this.clubId = _data["clubId"];
            this.contactEmails = _data["contactEmails"];
        }
    }

    static fromJS(data: any): SaveNewClubAllowedSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNewClubAllowedSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedSectionClubId"] = this.allowedSectionClubId;
        data["sectionId"] = this.sectionId;
        data["clubId"] = this.clubId;
        data["contactEmails"] = this.contactEmails;
        return data;
    }
}

export interface ISaveNewClubAllowedSectionDto {
    allowedSectionClubId?: number;
    sectionId?: number;
    clubId?: number;
    contactEmails?: string | undefined;
}

export class PaginatedResultsOfClubGridDto implements IPaginatedResultsOfClubGridDto {
    totalCount?: number;
    results?: ClubGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClubGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClubGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClubGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClubGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClubGridDto {
    totalCount?: number;
    results?: ClubGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClubGridDto implements IClubGridDto {
    clubId?: number;
    name?: string | undefined;
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    finalNumber?: string | undefined;
    language?: string | undefined;
    country?: string | undefined;
    globalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    websiteAddress?: string | undefined;

    constructor(data?: IClubGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.accountNumber = _data["accountNumber"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.finalNumber = _data["finalNumber"];
            this.language = _data["language"];
            this.country = _data["country"];
            this.globalEmail = _data["globalEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.websiteAddress = _data["websiteAddress"];
        }
    }

    static fromJS(data: any): ClubGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["accountNumber"] = this.accountNumber;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["finalNumber"] = this.finalNumber;
        data["language"] = this.language;
        data["country"] = this.country;
        data["globalEmail"] = this.globalEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["websiteAddress"] = this.websiteAddress;
        return data;
    }
}

export interface IClubGridDto {
    clubId?: number;
    name?: string | undefined;
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    finalNumber?: string | undefined;
    language?: string | undefined;
    country?: string | undefined;
    globalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    websiteAddress?: string | undefined;
}

export class ClubBreedSearch extends SelectorSearchOfInteger implements IClubBreedSearch {
    languageId?: number;
    breedId?: number | undefined;
    name?: TextSearch | undefined;
    vatNumber?: TextSearch | undefined;

    constructor(data?: IClubBreedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.breedId = _data["breedId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.vatNumber = _data["vatNumber"] ? TextSearch.fromJS(_data["vatNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClubBreedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubBreedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["breedId"] = this.breedId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["vatNumber"] = this.vatNumber ? this.vatNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IClubBreedSearch extends ISelectorSearchOfInteger {
    languageId?: number;
    breedId?: number | undefined;
    name?: TextSearch | undefined;
    vatNumber?: TextSearch | undefined;
}

export class PaginatedResultsOfClubCompetitionRequestGridDto implements IPaginatedResultsOfClubCompetitionRequestGridDto {
    totalCount?: number;
    results?: ClubCompetitionRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClubCompetitionRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClubCompetitionRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClubCompetitionRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClubCompetitionRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClubCompetitionRequestGridDto {
    totalCount?: number;
    results?: ClubCompetitionRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClubCompetitionRequestGridDto implements IClubCompetitionRequestGridDto {
    requestNumber?: string | undefined;
    requestType?: string | undefined;
    requestDate?: Date;
    dateFrom?: Date;
    dateTo?: Date;
    requestTypeCode?: ERequestType;
    requestState?: string | undefined;
    requestId?: number;
    subRequestId?: number;

    constructor(data?: IClubCompetitionRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.requestType = _data["requestType"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.requestTypeCode = _data["requestTypeCode"];
            this.requestState = _data["requestState"];
            this.requestId = _data["requestId"];
            this.subRequestId = _data["subRequestId"];
        }
    }

    static fromJS(data: any): ClubCompetitionRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubCompetitionRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["requestType"] = this.requestType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["requestTypeCode"] = this.requestTypeCode;
        data["requestState"] = this.requestState;
        data["requestId"] = this.requestId;
        data["subRequestId"] = this.subRequestId;
        return data;
    }
}

export interface IClubCompetitionRequestGridDto {
    requestNumber?: string | undefined;
    requestType?: string | undefined;
    requestDate?: Date;
    dateFrom?: Date;
    dateTo?: Date;
    requestTypeCode?: ERequestType;
    requestState?: string | undefined;
    requestId?: number;
    subRequestId?: number;
}

export class ClubCompetitionRequestsSearch extends PaginatedSearch implements IClubCompetitionRequestsSearch {
    languageId?: number;
    clubId?: number;

    constructor(data?: IClubCompetitionRequestsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.clubId = _data["clubId"];
        }
    }

    static fromJS(data: any): ClubCompetitionRequestsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubCompetitionRequestsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["clubId"] = this.clubId;
        super.toJSON(data);
        return data;
    }
}

export interface IClubCompetitionRequestsSearch extends IPaginatedSearch {
    languageId?: number;
    clubId?: number;
}

export class PaginatedResultsOfClubContactGridDto implements IPaginatedResultsOfClubContactGridDto {
    totalCount?: number;
    results?: ClubContactGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClubContactGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClubContactGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClubContactGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClubContactGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClubContactGridDto {
    totalCount?: number;
    results?: ClubContactGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClubContactGridDto implements IClubContactGridDto {
    personId?: number;
    clubContactId?: number;
    role?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IClubContactGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.clubContactId = _data["clubContactId"];
            this.role = _data["role"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ClubContactGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubContactGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["clubContactId"] = this.clubContactId;
        data["role"] = this.role;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IClubContactGridDto {
    personId?: number;
    clubContactId?: number;
    role?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    fullName?: string | undefined;
}

export class ClubContactSearch extends PaginatedSearch implements IClubContactSearch {
    clubId?: number;
    languageId?: number;

    constructor(data?: IClubContactSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clubId = _data["clubId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): ClubContactSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubContactSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IClubContactSearch extends IPaginatedSearch {
    clubId?: number;
    languageId?: number;
}

export class SaveClubContactDto implements ISaveClubContactDto {
    clubId?: number;
    clubRoleId?: number;
    personId?: number;

    constructor(data?: ISaveClubContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.clubRoleId = _data["clubRoleId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): SaveClubContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveClubContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["clubRoleId"] = this.clubRoleId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface ISaveClubContactDto {
    clubId?: number;
    clubRoleId?: number;
    personId?: number;
}

export class ClubSearch extends SelectorSearchOfInteger implements IClubSearch {
    languageId?: number;
    name?: TextSearch | undefined;
    finalNumber?: TextSearch | undefined;

    constructor(data?: IClubSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.finalNumber = _data["finalNumber"] ? TextSearch.fromJS(_data["finalNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClubSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["finalNumber"] = this.finalNumber ? this.finalNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IClubSearch extends ISelectorSearchOfInteger {
    languageId?: number;
    name?: TextSearch | undefined;
    finalNumber?: TextSearch | undefined;
}

export class DrupalClubDto implements IDrupalClubDto {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    chairmans?: PersonDto[] | undefined;
    secretaries?: PersonDto[] | undefined;
    breeds?: BreedGridDto[] | undefined;

    constructor(data?: IDrupalClubDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.website = _data["website"];
            if (Array.isArray(_data["chairmans"])) {
                this.chairmans = [] as any;
                for (let item of _data["chairmans"])
                    this.chairmans!.push(PersonDto.fromJS(item));
            }
            if (Array.isArray(_data["secretaries"])) {
                this.secretaries = [] as any;
                for (let item of _data["secretaries"])
                    this.secretaries!.push(PersonDto.fromJS(item));
            }
            if (Array.isArray(_data["breeds"])) {
                this.breeds = [] as any;
                for (let item of _data["breeds"])
                    this.breeds!.push(BreedGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DrupalClubDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalClubDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["website"] = this.website;
        if (Array.isArray(this.chairmans)) {
            data["chairmans"] = [];
            for (let item of this.chairmans)
                data["chairmans"].push(item.toJSON());
        }
        if (Array.isArray(this.secretaries)) {
            data["secretaries"] = [];
            for (let item of this.secretaries)
                data["secretaries"].push(item.toJSON());
        }
        if (Array.isArray(this.breeds)) {
            data["breeds"] = [];
            for (let item of this.breeds)
                data["breeds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDrupalClubDto {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    chairmans?: PersonDto[] | undefined;
    secretaries?: PersonDto[] | undefined;
    breeds?: BreedGridDto[] | undefined;
}

export class ClubDto implements IClubDto {
    name?: string | undefined;
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    remark?: string | undefined;
    phoneNumber?: string | undefined;
    globalEmail?: string | undefined;
    websiteAdresse?: string | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    provisionalNumber?: string | undefined;
    provisionalNumberDate?: Date | undefined;
    finalNumber?: string | undefined;
    finalNumberDate?: Date | undefined;
    hasLinkedBreed?: boolean;
    terrainNumber?: string | undefined;
    terrainStreet?: string | undefined;
    terrainCity?: string | undefined;
    terrainPostalCode?: string | undefined;
    terrainProvince?: string | undefined;
    clubId?: number;
    terrainCountryId?: number | undefined;
    countryId?: number | undefined;
    languageId?: number;
    bcIdentifier?: string | undefined;
    societyName?: string | undefined;
    bcLanguageCode?: string | undefined;
    countryIso?: string | undefined;
    sharepointUri?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: IClubDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.accountNumber = _data["accountNumber"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.remark = _data["remark"];
            this.phoneNumber = _data["phoneNumber"];
            this.globalEmail = _data["globalEmail"];
            this.websiteAdresse = _data["websiteAdresse"];
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionStartDate = _data["exclusionStartDate"] ? new Date(_data["exclusionStartDate"].toString()) : <any>undefined;
            this.exclusionEndDate = _data["exclusionEndDate"] ? new Date(_data["exclusionEndDate"].toString()) : <any>undefined;
            this.provisionalNumber = _data["provisionalNumber"];
            this.provisionalNumberDate = _data["provisionalNumberDate"] ? new Date(_data["provisionalNumberDate"].toString()) : <any>undefined;
            this.finalNumber = _data["finalNumber"];
            this.finalNumberDate = _data["finalNumberDate"] ? new Date(_data["finalNumberDate"].toString()) : <any>undefined;
            this.hasLinkedBreed = _data["hasLinkedBreed"];
            this.terrainNumber = _data["terrainNumber"];
            this.terrainStreet = _data["terrainStreet"];
            this.terrainCity = _data["terrainCity"];
            this.terrainPostalCode = _data["terrainPostalCode"];
            this.terrainProvince = _data["terrainProvince"];
            this.clubId = _data["clubId"];
            this.terrainCountryId = _data["terrainCountryId"];
            this.countryId = _data["countryId"];
            this.languageId = _data["languageId"];
            this.bcIdentifier = _data["bcIdentifier"];
            this.societyName = _data["societyName"];
            this.bcLanguageCode = _data["bcLanguageCode"];
            this.countryIso = _data["countryIso"];
            this.sharepointUri = _data["sharepointUri"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClubDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["accountNumber"] = this.accountNumber;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["street"] = this.street;
        data["city"] = this.city;
        data["remark"] = this.remark;
        data["phoneNumber"] = this.phoneNumber;
        data["globalEmail"] = this.globalEmail;
        data["websiteAdresse"] = this.websiteAdresse;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionStartDate"] = this.exclusionStartDate ? this.exclusionStartDate.toISOString() : <any>undefined;
        data["exclusionEndDate"] = this.exclusionEndDate ? this.exclusionEndDate.toISOString() : <any>undefined;
        data["provisionalNumber"] = this.provisionalNumber;
        data["provisionalNumberDate"] = this.provisionalNumberDate ? this.provisionalNumberDate.toISOString() : <any>undefined;
        data["finalNumber"] = this.finalNumber;
        data["finalNumberDate"] = this.finalNumberDate ? this.finalNumberDate.toISOString() : <any>undefined;
        data["hasLinkedBreed"] = this.hasLinkedBreed;
        data["terrainNumber"] = this.terrainNumber;
        data["terrainStreet"] = this.terrainStreet;
        data["terrainCity"] = this.terrainCity;
        data["terrainPostalCode"] = this.terrainPostalCode;
        data["terrainProvince"] = this.terrainProvince;
        data["clubId"] = this.clubId;
        data["terrainCountryId"] = this.terrainCountryId;
        data["countryId"] = this.countryId;
        data["languageId"] = this.languageId;
        data["bcIdentifier"] = this.bcIdentifier;
        data["societyName"] = this.societyName;
        data["bcLanguageCode"] = this.bcLanguageCode;
        data["countryIso"] = this.countryIso;
        data["sharepointUri"] = this.sharepointUri;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClubDto {
    name?: string | undefined;
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    number?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    remark?: string | undefined;
    phoneNumber?: string | undefined;
    globalEmail?: string | undefined;
    websiteAdresse?: string | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    provisionalNumber?: string | undefined;
    provisionalNumberDate?: Date | undefined;
    finalNumber?: string | undefined;
    finalNumberDate?: Date | undefined;
    hasLinkedBreed?: boolean;
    terrainNumber?: string | undefined;
    terrainStreet?: string | undefined;
    terrainCity?: string | undefined;
    terrainPostalCode?: string | undefined;
    terrainProvince?: string | undefined;
    clubId?: number;
    terrainCountryId?: number | undefined;
    countryId?: number | undefined;
    languageId?: number;
    bcIdentifier?: string | undefined;
    societyName?: string | undefined;
    bcLanguageCode?: string | undefined;
    countryIso?: string | undefined;
    sharepointUri?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class SaveClubAllowedBreedsDto implements ISaveClubAllowedBreedsDto {
    clubId?: number;
    breedIds?: number[] | undefined;

    constructor(data?: ISaveClubAllowedBreedsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            if (Array.isArray(_data["breedIds"])) {
                this.breedIds = [] as any;
                for (let item of _data["breedIds"])
                    this.breedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveClubAllowedBreedsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveClubAllowedBreedsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        if (Array.isArray(this.breedIds)) {
            data["breedIds"] = [];
            for (let item of this.breedIds)
                data["breedIds"].push(item);
        }
        return data;
    }
}

export interface ISaveClubAllowedBreedsDto {
    clubId?: number;
    breedIds?: number[] | undefined;
}

export class PaginatedResultsOfJudgesForClubGridDto implements IPaginatedResultsOfJudgesForClubGridDto {
    totalCount?: number;
    results?: JudgesForClubGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfJudgesForClubGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(JudgesForClubGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfJudgesForClubGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfJudgesForClubGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfJudgesForClubGridDto {
    totalCount?: number;
    results?: JudgesForClubGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class JudgesForClubGridDto implements IJudgesForClubGridDto {
    judgesForClubId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    isAptForBeauty?: boolean;
    isAptForWork?: boolean;

    constructor(data?: IJudgesForClubGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgesForClubId = _data["judgesForClubId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.computedName = _data["computedName"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.isAptForBeauty = _data["isAptForBeauty"];
            this.isAptForWork = _data["isAptForWork"];
        }
    }

    static fromJS(data: any): JudgesForClubGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudgesForClubGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgesForClubId"] = this.judgesForClubId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["computedName"] = this.computedName;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["isAptForBeauty"] = this.isAptForBeauty;
        data["isAptForWork"] = this.isAptForWork;
        return data;
    }
}

export interface IJudgesForClubGridDto {
    judgesForClubId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    isAptForBeauty?: boolean;
    isAptForWork?: boolean;
}

export class JudgesForClubSearch extends PaginatedSearch implements IJudgesForClubSearch {
    clubId?: number;
    languageId?: number;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;

    constructor(data?: IJudgesForClubSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clubId = _data["clubId"];
            this.languageId = _data["languageId"];
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JudgesForClubSearch {
        data = typeof data === 'object' ? data : {};
        let result = new JudgesForClubSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["languageId"] = this.languageId;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IJudgesForClubSearch extends IPaginatedSearch {
    clubId?: number;
    languageId?: number;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;
}

export class SaveClubJudgeDto implements ISaveClubJudgeDto {
    clubId?: number;
    judgeId?: number;
    isAptForBeauty?: boolean;
    isAptForWork?: boolean;

    constructor(data?: ISaveClubJudgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.judgeId = _data["judgeId"];
            this.isAptForBeauty = _data["isAptForBeauty"];
            this.isAptForWork = _data["isAptForWork"];
        }
    }

    static fromJS(data: any): SaveClubJudgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveClubJudgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["judgeId"] = this.judgeId;
        data["isAptForBeauty"] = this.isAptForBeauty;
        data["isAptForWork"] = this.isAptForWork;
        return data;
    }
}

export interface ISaveClubJudgeDto {
    clubId?: number;
    judgeId?: number;
    isAptForBeauty?: boolean;
    isAptForWork?: boolean;
}

export class PaginatedResultsOfClubRoleGridDto implements IPaginatedResultsOfClubRoleGridDto {
    totalCount?: number;
    results?: ClubRoleGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClubRoleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClubRoleGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClubRoleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClubRoleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClubRoleGridDto {
    totalCount?: number;
    results?: ClubRoleGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClubRoleGridDto implements IClubRoleGridDto {
    clubRoleId?: number;
    name?: string | undefined;

    constructor(data?: IClubRoleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubRoleId = _data["clubRoleId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClubRoleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRoleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubRoleId"] = this.clubRoleId;
        data["name"] = this.name;
        return data;
    }
}

export interface IClubRoleGridDto {
    clubRoleId?: number;
    name?: string | undefined;
}

export class ClubRoleSearch extends SelectorSearchOfInteger implements IClubRoleSearch {
    name?: TextSearch | undefined;
    languageId?: number;

    constructor(data?: IClubRoleSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): ClubRoleSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRoleSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IClubRoleSearch extends ISelectorSearchOfInteger {
    name?: TextSearch | undefined;
    languageId?: number;
}

export class ClubRoleDto implements IClubRoleDto {
    clubRoleId?: number;
    clubRoleTranslations?: ClubRoleTranslationDto[] | undefined;
    remark?: string | undefined;

    constructor(data?: IClubRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubRoleId = _data["clubRoleId"];
            if (Array.isArray(_data["clubRoleTranslations"])) {
                this.clubRoleTranslations = [] as any;
                for (let item of _data["clubRoleTranslations"])
                    this.clubRoleTranslations!.push(ClubRoleTranslationDto.fromJS(item));
            }
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): ClubRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubRoleId"] = this.clubRoleId;
        if (Array.isArray(this.clubRoleTranslations)) {
            data["clubRoleTranslations"] = [];
            for (let item of this.clubRoleTranslations)
                data["clubRoleTranslations"].push(item.toJSON());
        }
        data["remark"] = this.remark;
        return data;
    }
}

export interface IClubRoleDto {
    clubRoleId?: number;
    clubRoleTranslations?: ClubRoleTranslationDto[] | undefined;
    remark?: string | undefined;
}

export class ClubRoleTranslationDto implements IClubRoleTranslationDto {
    clubRoleId?: number;
    languageId?: number;
    text?: string | undefined;
    clubRoleTranslationId?: number;

    constructor(data?: IClubRoleTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubRoleId = _data["clubRoleId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.clubRoleTranslationId = _data["clubRoleTranslationId"];
        }
    }

    static fromJS(data: any): ClubRoleTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubRoleTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubRoleId"] = this.clubRoleId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["clubRoleTranslationId"] = this.clubRoleTranslationId;
        return data;
    }
}

export interface IClubRoleTranslationDto {
    clubRoleId?: number;
    languageId?: number;
    text?: string | undefined;
    clubRoleTranslationId?: number;
}

export class PaginatedResultsOfClubWorkbookRequestGridDto implements IPaginatedResultsOfClubWorkbookRequestGridDto {
    totalCount?: number;
    results?: ClubWorkbookRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClubWorkbookRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClubWorkbookRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClubWorkbookRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClubWorkbookRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClubWorkbookRequestGridDto {
    totalCount?: number;
    results?: ClubWorkbookRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ClubWorkbookRequestGridDto implements IClubWorkbookRequestGridDto {
    requestNumber?: string | undefined;
    requestType?: string | undefined;
    requestDate?: Date;
    requestTypeCode?: ERequestType;
    requestId?: number;
    subRequestId?: number;

    constructor(data?: IClubWorkbookRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.requestType = _data["requestType"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestTypeCode = _data["requestTypeCode"];
            this.requestId = _data["requestId"];
            this.subRequestId = _data["subRequestId"];
        }
    }

    static fromJS(data: any): ClubWorkbookRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubWorkbookRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["requestType"] = this.requestType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestTypeCode"] = this.requestTypeCode;
        data["requestId"] = this.requestId;
        data["subRequestId"] = this.subRequestId;
        return data;
    }
}

export interface IClubWorkbookRequestGridDto {
    requestNumber?: string | undefined;
    requestType?: string | undefined;
    requestDate?: Date;
    requestTypeCode?: ERequestType;
    requestId?: number;
    subRequestId?: number;
}

export class ClubWorkbookRequestSearch extends PaginatedSearch implements IClubWorkbookRequestSearch {
    languageId?: number;
    clubId?: number;

    constructor(data?: IClubWorkbookRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.clubId = _data["clubId"];
        }
    }

    static fromJS(data: any): ClubWorkbookRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ClubWorkbookRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["clubId"] = this.clubId;
        super.toJSON(data);
        return data;
    }
}

export interface IClubWorkbookRequestSearch extends IPaginatedSearch {
    languageId?: number;
    clubId?: number;
}

export class PaginatedResultsOfColorGridDto implements IPaginatedResultsOfColorGridDto {
    totalCount?: number;
    results?: ColorGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfColorGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ColorGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfColorGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfColorGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfColorGridDto {
    totalCount?: number;
    results?: ColorGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ColorGridDto implements IColorGridDto {
    colorId?: number;
    name?: string | undefined;
    code?: string | undefined;
    official?: boolean;
    isMerle?: boolean | undefined;

    constructor(data?: IColorGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorId = _data["colorId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.official = _data["official"];
            this.isMerle = _data["isMerle"];
        }
    }

    static fromJS(data: any): ColorGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ColorGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorId"] = this.colorId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["official"] = this.official;
        data["isMerle"] = this.isMerle;
        return data;
    }
}

export interface IColorGridDto {
    colorId?: number;
    name?: string | undefined;
    code?: string | undefined;
    official?: boolean;
    isMerle?: boolean | undefined;
}

export class ColorSearch extends PaginatedSearch implements IColorSearch {
    name?: TextSearch | undefined;
    official?: BooleanSearch | undefined;
    isMerle?: BooleanSearch | undefined;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IColorSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.official = _data["official"] ? BooleanSearch.fromJS(_data["official"]) : <any>undefined;
            this.isMerle = _data["isMerle"] ? BooleanSearch.fromJS(_data["isMerle"]) : <any>undefined;
            this.languageId = _data["languageId"];
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): ColorSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ColorSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["isMerle"] = this.isMerle ? this.isMerle.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IColorSearch extends IPaginatedSearch {
    name?: TextSearch | undefined;
    official?: BooleanSearch | undefined;
    isMerle?: BooleanSearch | undefined;
    languageId?: number;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class PaginatedResultsOfCompetitionGridDto implements IPaginatedResultsOfCompetitionGridDto {
    totalCount?: number;
    results?: CompetitionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCompetitionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CompetitionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCompetitionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCompetitionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCompetitionGridDto {
    totalCount?: number;
    results?: CompetitionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CompetitionGridDto implements ICompetitionGridDto {
    competitionId?: number;
    competitionRequestId?: number;
    requestNumber?: string | undefined;
    competitionName?: string | undefined;
    competitionDateFrom?: Date;
    competitionDateTo?: Date;
    city?: string | undefined;
    extra?: string | undefined;
    country?: string | undefined;
    subActivity?: string | undefined;
    clubName?: string | undefined;

    constructor(data?: ICompetitionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.requestNumber = _data["requestNumber"];
            this.competitionName = _data["competitionName"];
            this.competitionDateFrom = _data["competitionDateFrom"] ? new Date(_data["competitionDateFrom"].toString()) : <any>undefined;
            this.competitionDateTo = _data["competitionDateTo"] ? new Date(_data["competitionDateTo"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.extra = _data["extra"];
            this.country = _data["country"];
            this.subActivity = _data["subActivity"];
            this.clubName = _data["clubName"];
        }
    }

    static fromJS(data: any): CompetitionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["requestNumber"] = this.requestNumber;
        data["competitionName"] = this.competitionName;
        data["competitionDateFrom"] = this.competitionDateFrom ? this.competitionDateFrom.toISOString() : <any>undefined;
        data["competitionDateTo"] = this.competitionDateTo ? this.competitionDateTo.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["extra"] = this.extra;
        data["country"] = this.country;
        data["subActivity"] = this.subActivity;
        data["clubName"] = this.clubName;
        return data;
    }
}

export interface ICompetitionGridDto {
    competitionId?: number;
    competitionRequestId?: number;
    requestNumber?: string | undefined;
    competitionName?: string | undefined;
    competitionDateFrom?: Date;
    competitionDateTo?: Date;
    city?: string | undefined;
    extra?: string | undefined;
    country?: string | undefined;
    subActivity?: string | undefined;
    clubName?: string | undefined;
}

export class CompetitionSearch extends PaginatedSearch implements ICompetitionSearch {
    languageId?: number;
    competitionName?: TextSearch | undefined;
    requestNumber?: TextSearch | undefined;
    competitionDateFrom?: DateSearch | undefined;
    competitionDateTo?: DateSearch | undefined;
    city?: TextSearch | undefined;
    country?: TextSearch | undefined;

    constructor(data?: ICompetitionSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.competitionName = _data["competitionName"] ? TextSearch.fromJS(_data["competitionName"]) : <any>undefined;
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.competitionDateFrom = _data["competitionDateFrom"] ? DateSearch.fromJS(_data["competitionDateFrom"]) : <any>undefined;
            this.competitionDateTo = _data["competitionDateTo"] ? DateSearch.fromJS(_data["competitionDateTo"]) : <any>undefined;
            this.city = _data["city"] ? TextSearch.fromJS(_data["city"]) : <any>undefined;
            this.country = _data["country"] ? TextSearch.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["competitionName"] = this.competitionName ? this.competitionName.toJSON() : <any>undefined;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["competitionDateFrom"] = this.competitionDateFrom ? this.competitionDateFrom.toJSON() : <any>undefined;
        data["competitionDateTo"] = this.competitionDateTo ? this.competitionDateTo.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitionSearch extends IPaginatedSearch {
    languageId?: number;
    competitionName?: TextSearch | undefined;
    requestNumber?: TextSearch | undefined;
    competitionDateFrom?: DateSearch | undefined;
    competitionDateTo?: DateSearch | undefined;
    city?: TextSearch | undefined;
    country?: TextSearch | undefined;
}

export class DrupalDisplayCompetitionDto implements IDrupalDisplayCompetitionDto {
    dateFrom?: Date;
    linkTo?: string | undefined;
    activity?: string | undefined;
    subactivity?: string | undefined;
    locality?: string | undefined;
    competitionId?: number;

    constructor(data?: IDrupalDisplayCompetitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.linkTo = _data["linkTo"];
            this.activity = _data["activity"];
            this.subactivity = _data["subactivity"];
            this.locality = _data["locality"];
            this.competitionId = _data["competitionId"];
        }
    }

    static fromJS(data: any): DrupalDisplayCompetitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalDisplayCompetitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["linkTo"] = this.linkTo;
        data["activity"] = this.activity;
        data["subactivity"] = this.subactivity;
        data["locality"] = this.locality;
        data["competitionId"] = this.competitionId;
        return data;
    }
}

export interface IDrupalDisplayCompetitionDto {
    dateFrom?: Date;
    linkTo?: string | undefined;
    activity?: string | undefined;
    subactivity?: string | undefined;
    locality?: string | undefined;
    competitionId?: number;
}

export class CompetitionDto implements ICompetitionDto {
    competitionId?: number;
    competitionRequestId?: number;
    isImporting?: boolean;
    competitionRequest?: CompetitionRequestDto | undefined;
    competitionStatusId?: number | undefined;

    constructor(data?: ICompetitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.isImporting = _data["isImporting"];
            this.competitionRequest = _data["competitionRequest"] ? CompetitionRequestDto.fromJS(_data["competitionRequest"]) : <any>undefined;
            this.competitionStatusId = _data["competitionStatusId"];
        }
    }

    static fromJS(data: any): CompetitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["isImporting"] = this.isImporting;
        data["competitionRequest"] = this.competitionRequest ? this.competitionRequest.toJSON() : <any>undefined;
        data["competitionStatusId"] = this.competitionStatusId;
        return data;
    }
}

export interface ICompetitionDto {
    competitionId?: number;
    competitionRequestId?: number;
    isImporting?: boolean;
    competitionRequest?: CompetitionRequestDto | undefined;
    competitionStatusId?: number | undefined;
}

export class CompetitionRequestDto implements ICompetitionRequestDto {
    competitionRequestId?: number;
    requestId?: number;
    request?: RequestDto | undefined;
    clubSharepointUri?: string | undefined;
    clubRemark?: string | undefined;
    personEmail?: string | undefined;
    competitionName?: string | undefined;
    competitionNamePlaceHolder?: string | undefined;
    competitionId?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    foreignCity?: string | undefined;
    subActivityId?: number;
    subActivityName?: string | undefined;
    countryId?: number | undefined;
    postalCodeId?: number | undefined;
    clubId?: number;
    clubEmail?: string | undefined;
    sectionId?: number;
    activityId?: number;
    extra?: string | undefined;
    clubAddress?: string | undefined;
    otherAddress?: boolean;
    judgeIds?: number[] | undefined;
    catalogReceptionDate?: Date | undefined;
    numberParticipants?: number;
    otherAddressString?: string | undefined;
    requestState?: string | undefined;
    myDogShowAuthorized?: boolean;
    myDogShowBilling?: boolean;
    useTablet?: boolean;
    personId?: number | undefined;
    competitionVolunteerProfiles?: number[] | undefined;
    shouldDouble?: boolean;
    crufts?: boolean;

    constructor(data?: ICompetitionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionRequestId = _data["competitionRequestId"];
            this.requestId = _data["requestId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.clubSharepointUri = _data["clubSharepointUri"];
            this.clubRemark = _data["clubRemark"];
            this.personEmail = _data["personEmail"];
            this.competitionName = _data["competitionName"];
            this.competitionNamePlaceHolder = _data["competitionNamePlaceHolder"];
            this.competitionId = _data["competitionId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.foreignCity = _data["foreignCity"];
            this.subActivityId = _data["subActivityId"];
            this.subActivityName = _data["subActivityName"];
            this.countryId = _data["countryId"];
            this.postalCodeId = _data["postalCodeId"];
            this.clubId = _data["clubId"];
            this.clubEmail = _data["clubEmail"];
            this.sectionId = _data["sectionId"];
            this.activityId = _data["activityId"];
            this.extra = _data["extra"];
            this.clubAddress = _data["clubAddress"];
            this.otherAddress = _data["otherAddress"];
            if (Array.isArray(_data["judgeIds"])) {
                this.judgeIds = [] as any;
                for (let item of _data["judgeIds"])
                    this.judgeIds!.push(item);
            }
            this.catalogReceptionDate = _data["catalogReceptionDate"] ? new Date(_data["catalogReceptionDate"].toString()) : <any>undefined;
            this.numberParticipants = _data["numberParticipants"];
            this.otherAddressString = _data["otherAddressString"];
            this.requestState = _data["requestState"];
            this.myDogShowAuthorized = _data["myDogShowAuthorized"];
            this.myDogShowBilling = _data["myDogShowBilling"];
            this.useTablet = _data["useTablet"];
            this.personId = _data["personId"];
            if (Array.isArray(_data["competitionVolunteerProfiles"])) {
                this.competitionVolunteerProfiles = [] as any;
                for (let item of _data["competitionVolunteerProfiles"])
                    this.competitionVolunteerProfiles!.push(item);
            }
            this.shouldDouble = _data["shouldDouble"];
            this.crufts = _data["crufts"];
        }
    }

    static fromJS(data: any): CompetitionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionRequestId"] = this.competitionRequestId;
        data["requestId"] = this.requestId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["clubSharepointUri"] = this.clubSharepointUri;
        data["clubRemark"] = this.clubRemark;
        data["personEmail"] = this.personEmail;
        data["competitionName"] = this.competitionName;
        data["competitionNamePlaceHolder"] = this.competitionNamePlaceHolder;
        data["competitionId"] = this.competitionId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["foreignCity"] = this.foreignCity;
        data["subActivityId"] = this.subActivityId;
        data["subActivityName"] = this.subActivityName;
        data["countryId"] = this.countryId;
        data["postalCodeId"] = this.postalCodeId;
        data["clubId"] = this.clubId;
        data["clubEmail"] = this.clubEmail;
        data["sectionId"] = this.sectionId;
        data["activityId"] = this.activityId;
        data["extra"] = this.extra;
        data["clubAddress"] = this.clubAddress;
        data["otherAddress"] = this.otherAddress;
        if (Array.isArray(this.judgeIds)) {
            data["judgeIds"] = [];
            for (let item of this.judgeIds)
                data["judgeIds"].push(item);
        }
        data["catalogReceptionDate"] = this.catalogReceptionDate ? this.catalogReceptionDate.toISOString() : <any>undefined;
        data["numberParticipants"] = this.numberParticipants;
        data["otherAddressString"] = this.otherAddressString;
        data["requestState"] = this.requestState;
        data["myDogShowAuthorized"] = this.myDogShowAuthorized;
        data["myDogShowBilling"] = this.myDogShowBilling;
        data["useTablet"] = this.useTablet;
        data["personId"] = this.personId;
        if (Array.isArray(this.competitionVolunteerProfiles)) {
            data["competitionVolunteerProfiles"] = [];
            for (let item of this.competitionVolunteerProfiles)
                data["competitionVolunteerProfiles"].push(item);
        }
        data["shouldDouble"] = this.shouldDouble;
        data["crufts"] = this.crufts;
        return data;
    }
}

export interface ICompetitionRequestDto {
    competitionRequestId?: number;
    requestId?: number;
    request?: RequestDto | undefined;
    clubSharepointUri?: string | undefined;
    clubRemark?: string | undefined;
    personEmail?: string | undefined;
    competitionName?: string | undefined;
    competitionNamePlaceHolder?: string | undefined;
    competitionId?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date;
    foreignCity?: string | undefined;
    subActivityId?: number;
    subActivityName?: string | undefined;
    countryId?: number | undefined;
    postalCodeId?: number | undefined;
    clubId?: number;
    clubEmail?: string | undefined;
    sectionId?: number;
    activityId?: number;
    extra?: string | undefined;
    clubAddress?: string | undefined;
    otherAddress?: boolean;
    judgeIds?: number[] | undefined;
    catalogReceptionDate?: Date | undefined;
    numberParticipants?: number;
    otherAddressString?: string | undefined;
    requestState?: string | undefined;
    myDogShowAuthorized?: boolean;
    myDogShowBilling?: boolean;
    useTablet?: boolean;
    personId?: number | undefined;
    competitionVolunteerProfiles?: number[] | undefined;
    shouldDouble?: boolean;
    crufts?: boolean;
}

export class DrupalCompetitionDto implements IDrupalCompetitionDto {
    competitionRequestId?: number;
    judges?: DrupalJudgeDto[] | undefined;
    personEmail?: string | undefined;
    clubId?: number;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    subActivityName?: string | undefined;
    otherAddressString?: string | undefined;
    otherAddress?: boolean;
    clubEmail?: string | undefined;
    clubAddress?: string | undefined;

    constructor(data?: IDrupalCompetitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionRequestId = _data["competitionRequestId"];
            if (Array.isArray(_data["judges"])) {
                this.judges = [] as any;
                for (let item of _data["judges"])
                    this.judges!.push(DrupalJudgeDto.fromJS(item));
            }
            this.personEmail = _data["personEmail"];
            this.clubId = _data["clubId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.subActivityName = _data["subActivityName"];
            this.otherAddressString = _data["otherAddressString"];
            this.otherAddress = _data["otherAddress"];
            this.clubEmail = _data["clubEmail"];
            this.clubAddress = _data["clubAddress"];
        }
    }

    static fromJS(data: any): DrupalCompetitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalCompetitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionRequestId"] = this.competitionRequestId;
        if (Array.isArray(this.judges)) {
            data["judges"] = [];
            for (let item of this.judges)
                data["judges"].push(item.toJSON());
        }
        data["personEmail"] = this.personEmail;
        data["clubId"] = this.clubId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["subActivityName"] = this.subActivityName;
        data["otherAddressString"] = this.otherAddressString;
        data["otherAddress"] = this.otherAddress;
        data["clubEmail"] = this.clubEmail;
        data["clubAddress"] = this.clubAddress;
        return data;
    }
}

export interface IDrupalCompetitionDto {
    competitionRequestId?: number;
    judges?: DrupalJudgeDto[] | undefined;
    personEmail?: string | undefined;
    clubId?: number;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    subActivityName?: string | undefined;
    otherAddressString?: string | undefined;
    otherAddress?: boolean;
    clubEmail?: string | undefined;
    clubAddress?: string | undefined;
}

export class DrupalJudgeDto implements IDrupalJudgeDto {
    computedName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IDrupalJudgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.computedName = _data["computedName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): DrupalJudgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalJudgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computedName"] = this.computedName;
        data["email"] = this.email;
        return data;
    }
}

export interface IDrupalJudgeDto {
    computedName?: string | undefined;
    email?: string | undefined;
}

export class PaginatedResultsOfJudgeCompetitionRequestGridDto implements IPaginatedResultsOfJudgeCompetitionRequestGridDto {
    totalCount?: number;
    results?: JudgeCompetitionRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfJudgeCompetitionRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(JudgeCompetitionRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfJudgeCompetitionRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfJudgeCompetitionRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfJudgeCompetitionRequestGridDto {
    totalCount?: number;
    results?: JudgeCompetitionRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class JudgeCompetitionRequestGridDto implements IJudgeCompetitionRequestGridDto {
    judgeId?: number;
    judgeEmail?: string | undefined;
    competitionJudgeId?: number;
    personId?: number;
    country?: string | undefined;
    name?: string | undefined;
    subActivityValidated?: boolean | undefined;
    breedValidated?: boolean | undefined;
    isBelgian?: boolean;
    isBeauty?: boolean;
    isSubActivityBanned?: boolean;
    isBannedFromBreed?: boolean;
    mailSent?: boolean;

    constructor(data?: IJudgeCompetitionRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgeId = _data["judgeId"];
            this.judgeEmail = _data["judgeEmail"];
            this.competitionJudgeId = _data["competitionJudgeId"];
            this.personId = _data["personId"];
            this.country = _data["country"];
            this.name = _data["name"];
            this.subActivityValidated = _data["subActivityValidated"];
            this.breedValidated = _data["breedValidated"];
            this.isBelgian = _data["isBelgian"];
            this.isBeauty = _data["isBeauty"];
            this.isSubActivityBanned = _data["isSubActivityBanned"];
            this.isBannedFromBreed = _data["isBannedFromBreed"];
            this.mailSent = _data["mailSent"];
        }
    }

    static fromJS(data: any): JudgeCompetitionRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeCompetitionRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgeId"] = this.judgeId;
        data["judgeEmail"] = this.judgeEmail;
        data["competitionJudgeId"] = this.competitionJudgeId;
        data["personId"] = this.personId;
        data["country"] = this.country;
        data["name"] = this.name;
        data["subActivityValidated"] = this.subActivityValidated;
        data["breedValidated"] = this.breedValidated;
        data["isBelgian"] = this.isBelgian;
        data["isBeauty"] = this.isBeauty;
        data["isSubActivityBanned"] = this.isSubActivityBanned;
        data["isBannedFromBreed"] = this.isBannedFromBreed;
        data["mailSent"] = this.mailSent;
        return data;
    }
}

export interface IJudgeCompetitionRequestGridDto {
    judgeId?: number;
    judgeEmail?: string | undefined;
    competitionJudgeId?: number;
    personId?: number;
    country?: string | undefined;
    name?: string | undefined;
    subActivityValidated?: boolean | undefined;
    breedValidated?: boolean | undefined;
    isBelgian?: boolean;
    isBeauty?: boolean;
    isSubActivityBanned?: boolean;
    isBannedFromBreed?: boolean;
    mailSent?: boolean;
}

export class JudgeCompetitionRequestSearch extends PaginatedSearch implements IJudgeCompetitionRequestSearch {
    competitionRequestId?: number;

    constructor(data?: IJudgeCompetitionRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.competitionRequestId = _data["competitionRequestId"];
        }
    }

    static fromJS(data: any): JudgeCompetitionRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeCompetitionRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionRequestId"] = this.competitionRequestId;
        super.toJSON(data);
        return data;
    }
}

export interface IJudgeCompetitionRequestSearch extends IPaginatedSearch {
    competitionRequestId?: number;
}

export class JudgeValidationDto implements IJudgeValidationDto {
    competitionJudgeId?: number;
    breedValidated?: boolean | undefined;
    subActivityValidated?: boolean | undefined;

    constructor(data?: IJudgeValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionJudgeId = _data["competitionJudgeId"];
            this.breedValidated = _data["breedValidated"];
            this.subActivityValidated = _data["subActivityValidated"];
        }
    }

    static fromJS(data: any): JudgeValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionJudgeId"] = this.competitionJudgeId;
        data["breedValidated"] = this.breedValidated;
        data["subActivityValidated"] = this.subActivityValidated;
        return data;
    }
}

export interface IJudgeValidationDto {
    competitionJudgeId?: number;
    breedValidated?: boolean | undefined;
    subActivityValidated?: boolean | undefined;
}

export class PaginatedResultsOfCompetitionRequestGridDto implements IPaginatedResultsOfCompetitionRequestGridDto {
    totalCount?: number;
    results?: CompetitionRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCompetitionRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CompetitionRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCompetitionRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCompetitionRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCompetitionRequestGridDto {
    totalCount?: number;
    results?: CompetitionRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CompetitionRequestGridDto implements ICompetitionRequestGridDto {
    requestId?: number;
    competitionRequestId?: number;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    requestDate?: Date;
    dateFrom?: Date;
    dateTo?: Date;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    clubId?: number;
    clubName?: string | undefined;
    contactId?: number;
    contact?: string | undefined;
    invoiceNumber?: string | undefined;
    competitionName?: string | undefined;
    myDogShow?: boolean;
    myDogShowActionRequired?: boolean;

    constructor(data?: ICompetitionRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.isBlocked = _data["isBlocked"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.clubId = _data["clubId"];
            this.clubName = _data["clubName"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.competitionName = _data["competitionName"];
            this.myDogShow = _data["myDogShow"];
            this.myDogShowActionRequired = _data["myDogShowActionRequired"];
        }
    }

    static fromJS(data: any): CompetitionRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["isBlocked"] = this.isBlocked;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["clubId"] = this.clubId;
        data["clubName"] = this.clubName;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact;
        data["invoiceNumber"] = this.invoiceNumber;
        data["competitionName"] = this.competitionName;
        data["myDogShow"] = this.myDogShow;
        data["myDogShowActionRequired"] = this.myDogShowActionRequired;
        return data;
    }
}

export interface ICompetitionRequestGridDto {
    requestId?: number;
    competitionRequestId?: number;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    requestDate?: Date;
    dateFrom?: Date;
    dateTo?: Date;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    clubId?: number;
    clubName?: string | undefined;
    contactId?: number;
    contact?: string | undefined;
    invoiceNumber?: string | undefined;
    competitionName?: string | undefined;
    myDogShow?: boolean;
    myDogShowActionRequired?: boolean;
}

export class CompetitionRequestSearch extends PaginatedSearch implements ICompetitionRequestSearch {
    languageId?: number;
    personId?: number | undefined;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    clubName?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    dateFrom?: DateSearch | undefined;
    dateTo?: DateSearch | undefined;
    myDogShowActionRequired?: BooleanSearch | undefined;
    myDogShow?: BooleanSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: ICompetitionRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.personId = _data["personId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.clubName = _data["clubName"] ? TextSearch.fromJS(_data["clubName"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.dateFrom = _data["dateFrom"] ? DateSearch.fromJS(_data["dateFrom"]) : <any>undefined;
            this.dateTo = _data["dateTo"] ? DateSearch.fromJS(_data["dateTo"]) : <any>undefined;
            this.myDogShowActionRequired = _data["myDogShowActionRequired"] ? BooleanSearch.fromJS(_data["myDogShowActionRequired"]) : <any>undefined;
            this.myDogShow = _data["myDogShow"] ? BooleanSearch.fromJS(_data["myDogShow"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitionRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["personId"] = this.personId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["clubName"] = this.clubName ? this.clubName.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toJSON() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toJSON() : <any>undefined;
        data["myDogShowActionRequired"] = this.myDogShowActionRequired ? this.myDogShowActionRequired.toJSON() : <any>undefined;
        data["myDogShow"] = this.myDogShow ? this.myDogShow.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitionRequestSearch extends IPaginatedSearch {
    languageId?: number;
    personId?: number | undefined;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    clubName?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    dateFrom?: DateSearch | undefined;
    dateTo?: DateSearch | undefined;
    myDogShowActionRequired?: BooleanSearch | undefined;
    myDogShow?: BooleanSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class IsWorkOrBeautyDto implements IIsWorkOrBeautyDto {
    isBeauty?: boolean;
    isWork?: boolean;

    constructor(data?: IIsWorkOrBeautyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBeauty = _data["isBeauty"];
            this.isWork = _data["isWork"];
        }
    }

    static fromJS(data: any): IsWorkOrBeautyDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsWorkOrBeautyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBeauty"] = this.isBeauty;
        data["isWork"] = this.isWork;
        return data;
    }
}

export interface IIsWorkOrBeautyDto {
    isBeauty?: boolean;
    isWork?: boolean;
}

export class CompetitionRequestExpoDaysDto implements ICompetitionRequestExpoDaysDto {
    competitionId?: number;
    competitionRequestId?: number;
    competition?: CompetitionDaysCompetitionDto | undefined;

    constructor(data?: ICompetitionRequestExpoDaysDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.competitionRequestId = _data["competitionRequestId"];
            this.competition = _data["competition"] ? CompetitionDaysCompetitionDto.fromJS(_data["competition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitionRequestExpoDaysDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionRequestExpoDaysDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["competitionRequestId"] = this.competitionRequestId;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompetitionRequestExpoDaysDto {
    competitionId?: number;
    competitionRequestId?: number;
    competition?: CompetitionDaysCompetitionDto | undefined;
}

export class CompetitionDaysCompetitionDto implements ICompetitionDaysCompetitionDto {
    competitionDays?: CompetitionDaysDto[] | undefined;

    constructor(data?: ICompetitionDaysCompetitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["competitionDays"])) {
                this.competitionDays = [] as any;
                for (let item of _data["competitionDays"])
                    this.competitionDays!.push(CompetitionDaysDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitionDaysCompetitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionDaysCompetitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.competitionDays)) {
            data["competitionDays"] = [];
            for (let item of this.competitionDays)
                data["competitionDays"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompetitionDaysCompetitionDto {
    competitionDays?: CompetitionDaysDto[] | undefined;
}

export class CompetitionDaysDto implements ICompetitionDaysDto {
    competitionDayId?: number;
    competitionId?: number;
    dayDate?: Date;
    expos?: ExpoDto[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ICompetitionDaysDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionDayId = _data["competitionDayId"];
            this.competitionId = _data["competitionId"];
            this.dayDate = _data["dayDate"] ? new Date(_data["dayDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["expos"])) {
                this.expos = [] as any;
                for (let item of _data["expos"])
                    this.expos!.push(ExpoDto.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): CompetitionDaysDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionDaysDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionDayId"] = this.competitionDayId;
        data["competitionId"] = this.competitionId;
        data["dayDate"] = this.dayDate ? this.dayDate.toISOString() : <any>undefined;
        if (Array.isArray(this.expos)) {
            data["expos"] = [];
            for (let item of this.expos)
                data["expos"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ICompetitionDaysDto {
    competitionDayId?: number;
    competitionId?: number;
    dayDate?: Date;
    expos?: ExpoDto[] | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class ExpoDto implements IExpoDto {
    expoId?: number;
    subActivityId?: number;
    name?: string | undefined;
    cruft?: boolean;

    constructor(data?: IExpoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expoId = _data["expoId"];
            this.subActivityId = _data["subActivityId"];
            this.name = _data["name"];
            this.cruft = _data["cruft"];
        }
    }

    static fromJS(data: any): ExpoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expoId"] = this.expoId;
        data["subActivityId"] = this.subActivityId;
        data["name"] = this.name;
        data["cruft"] = this.cruft;
        return data;
    }
}

export interface IExpoDto {
    expoId?: number;
    subActivityId?: number;
    name?: string | undefined;
    cruft?: boolean;
}

export class CompetitionReportInfoDto implements ICompetitionReportInfoDto {
    sectionId?: number | undefined;

    constructor(data?: ICompetitionReportInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any): CompetitionReportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionReportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        return data;
    }
}

export interface ICompetitionReportInfoDto {
    sectionId?: number | undefined;
}

export class PaginatedResultsOfCompetitionResultGridDto implements IPaginatedResultsOfCompetitionResultGridDto {
    totalCount?: number;
    results?: CompetitionResultGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCompetitionResultGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CompetitionResultGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCompetitionResultGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCompetitionResultGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCompetitionResultGridDto {
    totalCount?: number;
    results?: CompetitionResultGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CompetitionResultGridDto implements ICompetitionResultGridDto {
    competitionResultId?: number;
    dog?: string | undefined;
    dogId?: number;
    judge?: string | undefined;
    judgeId?: number;
    qualification?: string | undefined;
    qualificationId?: number;
    result?: number;
    class?: string | undefined;
    expo?: string | undefined;
    catalogNumber?: number | undefined;

    constructor(data?: ICompetitionResultGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionResultId = _data["competitionResultId"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.judge = _data["judge"];
            this.judgeId = _data["judgeId"];
            this.qualification = _data["qualification"];
            this.qualificationId = _data["qualificationId"];
            this.result = _data["result"];
            this.class = _data["class"];
            this.expo = _data["expo"];
            this.catalogNumber = _data["catalogNumber"];
        }
    }

    static fromJS(data: any): CompetitionResultGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionResultGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionResultId"] = this.competitionResultId;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["judge"] = this.judge;
        data["judgeId"] = this.judgeId;
        data["qualification"] = this.qualification;
        data["qualificationId"] = this.qualificationId;
        data["result"] = this.result;
        data["class"] = this.class;
        data["expo"] = this.expo;
        data["catalogNumber"] = this.catalogNumber;
        return data;
    }
}

export interface ICompetitionResultGridDto {
    competitionResultId?: number;
    dog?: string | undefined;
    dogId?: number;
    judge?: string | undefined;
    judgeId?: number;
    qualification?: string | undefined;
    qualificationId?: number;
    result?: number;
    class?: string | undefined;
    expo?: string | undefined;
    catalogNumber?: number | undefined;
}

export class CompetitionResultSearch extends PaginatedSearch implements ICompetitionResultSearch {
    languageId?: number;
    competitionId?: number;

    constructor(data?: ICompetitionResultSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.competitionId = _data["competitionId"];
        }
    }

    static fromJS(data: any): CompetitionResultSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionResultSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["competitionId"] = this.competitionId;
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitionResultSearch extends IPaginatedSearch {
    languageId?: number;
    competitionId?: number;
}

export class CompetitionResultDto implements ICompetitionResultDto {
    competitionResultId?: number;
    competitionId?: number;
    dogId?: number;
    qualificationId?: number;
    dogTitleId?: number | undefined;
    judgeId?: number;
    result?: number;
    catalogNumber?: number | undefined;
    showClass?: string;
    standardConformed?: boolean;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;

    constructor(data?: ICompetitionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionResultId = _data["competitionResultId"];
            this.competitionId = _data["competitionId"];
            this.dogId = _data["dogId"];
            this.qualificationId = _data["qualificationId"];
            this.dogTitleId = _data["dogTitleId"];
            this.judgeId = _data["judgeId"];
            this.result = _data["result"];
            this.catalogNumber = _data["catalogNumber"];
            this.showClass = _data["showClass"];
            this.standardConformed = _data["standardConformed"];
            this.bestOfBreed = _data["bestOfBreed"];
            this.bestOfSex = _data["bestOfSex"];
            this.bestInShow = _data["bestInShow"];
            this.bestInGroup = _data["bestInGroup"];
            this.bestVeteran = _data["bestVeteran"];
            this.bestWorkDog = _data["bestWorkDog"];
            this.bestYouth = _data["bestYouth"];
            this.bestMinorPuppy = _data["bestMinorPuppy"];
            this.bestPuppy = _data["bestPuppy"];
            this.belgianWinner = _data["belgianWinner"];
            this.beneluxWinner = _data["beneluxWinner"];
            this.beneluxYouthWinner = _data["beneluxYouthWinner"];
            this.beneluxVeteranWinner = _data["beneluxVeteranWinner"];
            this.europeanWinner = _data["europeanWinner"];
            this.crufts = _data["crufts"];
            this.cac = _data["cac"];
            this.cacReserve = _data["cacReserve"];
            this.cacib = _data["cacib"];
            this.cacibReserve = _data["cacibReserve"];
            this.cacbl = _data["cacbl"];
            this.cacblReserve = _data["cacblReserve"];
            this.cacgpo = _data["cacgpo"];
            this.cacgpoReserve = _data["cacgpoReserve"];
            this.caciag = _data["caciag"];
            this.caciagReserve = _data["caciagReserve"];
            this.cacil = _data["cacil"];
            this.cacilReserve = _data["cacilReserve"];
            this.caciob = _data["caciob"];
            this.caciobReserve = _data["caciobReserve"];
            this.cacit = _data["cacit"];
            this.cacitReserve = _data["cacitReserve"];
        }
    }

    static fromJS(data: any): CompetitionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionResultId"] = this.competitionResultId;
        data["competitionId"] = this.competitionId;
        data["dogId"] = this.dogId;
        data["qualificationId"] = this.qualificationId;
        data["dogTitleId"] = this.dogTitleId;
        data["judgeId"] = this.judgeId;
        data["result"] = this.result;
        data["catalogNumber"] = this.catalogNumber;
        data["showClass"] = this.showClass;
        data["standardConformed"] = this.standardConformed;
        data["bestOfBreed"] = this.bestOfBreed;
        data["bestOfSex"] = this.bestOfSex;
        data["bestInShow"] = this.bestInShow;
        data["bestInGroup"] = this.bestInGroup;
        data["bestVeteran"] = this.bestVeteran;
        data["bestWorkDog"] = this.bestWorkDog;
        data["bestYouth"] = this.bestYouth;
        data["bestMinorPuppy"] = this.bestMinorPuppy;
        data["bestPuppy"] = this.bestPuppy;
        data["belgianWinner"] = this.belgianWinner;
        data["beneluxWinner"] = this.beneluxWinner;
        data["beneluxYouthWinner"] = this.beneluxYouthWinner;
        data["beneluxVeteranWinner"] = this.beneluxVeteranWinner;
        data["europeanWinner"] = this.europeanWinner;
        data["crufts"] = this.crufts;
        data["cac"] = this.cac;
        data["cacReserve"] = this.cacReserve;
        data["cacib"] = this.cacib;
        data["cacibReserve"] = this.cacibReserve;
        data["cacbl"] = this.cacbl;
        data["cacblReserve"] = this.cacblReserve;
        data["cacgpo"] = this.cacgpo;
        data["cacgpoReserve"] = this.cacgpoReserve;
        data["caciag"] = this.caciag;
        data["caciagReserve"] = this.caciagReserve;
        data["cacil"] = this.cacil;
        data["cacilReserve"] = this.cacilReserve;
        data["caciob"] = this.caciob;
        data["caciobReserve"] = this.caciobReserve;
        data["cacit"] = this.cacit;
        data["cacitReserve"] = this.cacitReserve;
        return data;
    }
}

export interface ICompetitionResultDto {
    competitionResultId?: number;
    competitionId?: number;
    dogId?: number;
    qualificationId?: number;
    dogTitleId?: number | undefined;
    judgeId?: number;
    result?: number;
    catalogNumber?: number | undefined;
    showClass?: string;
    standardConformed?: boolean;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;
}

export class CompetitionImportDto implements ICompetitionImportDto {
    dogId?: number | undefined;
    automaticDogCreation?: boolean | undefined;
    judgeId?: number | undefined;
    importStatus?: ECompetitionResultImportStatus;
    error?: boolean;
    isSelected?: boolean;
    isAlreadyImported?: boolean;
    automaticDogDto?: AutomaticDogDto | undefined;
    competitionId?: number;
    qualificationId?: number | undefined;
    dogTitleId?: number | undefined;
    result?: number | undefined;
    catalogNumber?: number | undefined;
    showClass?: string;
    standardConformed?: boolean;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;

    constructor(data?: ICompetitionImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.automaticDogCreation = _data["automaticDogCreation"];
            this.judgeId = _data["judgeId"];
            this.importStatus = _data["importStatus"];
            this.error = _data["error"];
            this.isSelected = _data["isSelected"];
            this.isAlreadyImported = _data["isAlreadyImported"];
            this.automaticDogDto = _data["automaticDogDto"] ? AutomaticDogDto.fromJS(_data["automaticDogDto"]) : <any>undefined;
            this.competitionId = _data["competitionId"];
            this.qualificationId = _data["qualificationId"];
            this.dogTitleId = _data["dogTitleId"];
            this.result = _data["result"];
            this.catalogNumber = _data["catalogNumber"];
            this.showClass = _data["showClass"];
            this.standardConformed = _data["standardConformed"];
            this.bestOfBreed = _data["bestOfBreed"];
            this.bestOfSex = _data["bestOfSex"];
            this.bestInShow = _data["bestInShow"];
            this.bestInGroup = _data["bestInGroup"];
            this.bestVeteran = _data["bestVeteran"];
            this.bestWorkDog = _data["bestWorkDog"];
            this.bestYouth = _data["bestYouth"];
            this.bestMinorPuppy = _data["bestMinorPuppy"];
            this.bestPuppy = _data["bestPuppy"];
            this.belgianWinner = _data["belgianWinner"];
            this.beneluxWinner = _data["beneluxWinner"];
            this.beneluxYouthWinner = _data["beneluxYouthWinner"];
            this.beneluxVeteranWinner = _data["beneluxVeteranWinner"];
            this.europeanWinner = _data["europeanWinner"];
            this.crufts = _data["crufts"];
            this.cac = _data["cac"];
            this.cacReserve = _data["cacReserve"];
            this.cacib = _data["cacib"];
            this.cacibReserve = _data["cacibReserve"];
            this.cacbl = _data["cacbl"];
            this.cacblReserve = _data["cacblReserve"];
            this.cacgpo = _data["cacgpo"];
            this.cacgpoReserve = _data["cacgpoReserve"];
            this.caciag = _data["caciag"];
            this.caciagReserve = _data["caciagReserve"];
            this.cacil = _data["cacil"];
            this.cacilReserve = _data["cacilReserve"];
            this.caciob = _data["caciob"];
            this.caciobReserve = _data["caciobReserve"];
            this.cacit = _data["cacit"];
            this.cacitReserve = _data["cacitReserve"];
        }
    }

    static fromJS(data: any): CompetitionImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["automaticDogCreation"] = this.automaticDogCreation;
        data["judgeId"] = this.judgeId;
        data["importStatus"] = this.importStatus;
        data["error"] = this.error;
        data["isSelected"] = this.isSelected;
        data["isAlreadyImported"] = this.isAlreadyImported;
        data["automaticDogDto"] = this.automaticDogDto ? this.automaticDogDto.toJSON() : <any>undefined;
        data["competitionId"] = this.competitionId;
        data["qualificationId"] = this.qualificationId;
        data["dogTitleId"] = this.dogTitleId;
        data["result"] = this.result;
        data["catalogNumber"] = this.catalogNumber;
        data["showClass"] = this.showClass;
        data["standardConformed"] = this.standardConformed;
        data["bestOfBreed"] = this.bestOfBreed;
        data["bestOfSex"] = this.bestOfSex;
        data["bestInShow"] = this.bestInShow;
        data["bestInGroup"] = this.bestInGroup;
        data["bestVeteran"] = this.bestVeteran;
        data["bestWorkDog"] = this.bestWorkDog;
        data["bestYouth"] = this.bestYouth;
        data["bestMinorPuppy"] = this.bestMinorPuppy;
        data["bestPuppy"] = this.bestPuppy;
        data["belgianWinner"] = this.belgianWinner;
        data["beneluxWinner"] = this.beneluxWinner;
        data["beneluxYouthWinner"] = this.beneluxYouthWinner;
        data["beneluxVeteranWinner"] = this.beneluxVeteranWinner;
        data["europeanWinner"] = this.europeanWinner;
        data["crufts"] = this.crufts;
        data["cac"] = this.cac;
        data["cacReserve"] = this.cacReserve;
        data["cacib"] = this.cacib;
        data["cacibReserve"] = this.cacibReserve;
        data["cacbl"] = this.cacbl;
        data["cacblReserve"] = this.cacblReserve;
        data["cacgpo"] = this.cacgpo;
        data["cacgpoReserve"] = this.cacgpoReserve;
        data["caciag"] = this.caciag;
        data["caciagReserve"] = this.caciagReserve;
        data["cacil"] = this.cacil;
        data["cacilReserve"] = this.cacilReserve;
        data["caciob"] = this.caciob;
        data["caciobReserve"] = this.caciobReserve;
        data["cacit"] = this.cacit;
        data["cacitReserve"] = this.cacitReserve;
        return data;
    }
}

export interface ICompetitionImportDto {
    dogId?: number | undefined;
    automaticDogCreation?: boolean | undefined;
    judgeId?: number | undefined;
    importStatus?: ECompetitionResultImportStatus;
    error?: boolean;
    isSelected?: boolean;
    isAlreadyImported?: boolean;
    automaticDogDto?: AutomaticDogDto | undefined;
    competitionId?: number;
    qualificationId?: number | undefined;
    dogTitleId?: number | undefined;
    result?: number | undefined;
    catalogNumber?: number | undefined;
    showClass?: string;
    standardConformed?: boolean;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;
}

export enum ECompetitionResultImportStatus {
    ALREADY_IMPORTED = "ALREADY_IMPORTED",
    OK = "OK",
    NOK_DOG_MISSING = "NOK_DOG_MISSING",
    NOK_JUDGE_MISSING = "NOK_JUDGE_MISSING",
    NOK_DOG_MISSING_CANNOT_CREATE = "NOK_DOG_MISSING_CANNOT_CREATE",
    NOK_INFORMATION_MISSING = "NOK_INFORMATION_MISSING",
}

export class AutomaticDogDto implements IAutomaticDogDto {
    dogId?: number | undefined;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    breedId?: number;
    colorId?: number;
    dogTypeId?: number;
    sex?: EDogSex;
    chipNumber?: string | undefined;
    tatoo?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerLastName?: string | undefined;
    ownerEmail?: string | undefined;
    countryId?: number;

    constructor(data?: IAutomaticDogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.firstName = _data["firstName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.breedId = _data["breedId"];
            this.colorId = _data["colorId"];
            this.dogTypeId = _data["dogTypeId"];
            this.sex = _data["sex"];
            this.chipNumber = _data["chipNumber"];
            this.tatoo = _data["tatoo"];
            this.ownerFirstName = _data["ownerFirstName"];
            this.ownerLastName = _data["ownerLastName"];
            this.ownerEmail = _data["ownerEmail"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): AutomaticDogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticDogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["firstName"] = this.firstName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["breedId"] = this.breedId;
        data["colorId"] = this.colorId;
        data["dogTypeId"] = this.dogTypeId;
        data["sex"] = this.sex;
        data["chipNumber"] = this.chipNumber;
        data["tatoo"] = this.tatoo;
        data["ownerFirstName"] = this.ownerFirstName;
        data["ownerLastName"] = this.ownerLastName;
        data["ownerEmail"] = this.ownerEmail;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IAutomaticDogDto {
    dogId?: number | undefined;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    breedId?: number;
    colorId?: number;
    dogTypeId?: number;
    sex?: EDogSex;
    chipNumber?: string | undefined;
    tatoo?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerLastName?: string | undefined;
    ownerEmail?: string | undefined;
    countryId?: number;
}

export class PaginatedResultsOfCountryGridDto implements IPaginatedResultsOfCountryGridDto {
    totalCount?: number;
    results?: CountryGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCountryGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CountryGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCountryGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCountryGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCountryGridDto {
    totalCount?: number;
    results?: CountryGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CountryGridDto implements ICountryGridDto {
    countryId?: number;
    isoCode?: string | undefined;
    isoAs400?: string | undefined;
    name?: string | undefined;
    emailForBeautyJudge?: string | undefined;
    flagLink?: string | undefined;

    constructor(data?: ICountryGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.isoCode = _data["isoCode"];
            this.isoAs400 = _data["isoAs400"];
            this.name = _data["name"];
            this.emailForBeautyJudge = _data["emailForBeautyJudge"];
            this.flagLink = _data["flagLink"];
        }
    }

    static fromJS(data: any): CountryGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["isoCode"] = this.isoCode;
        data["isoAs400"] = this.isoAs400;
        data["name"] = this.name;
        data["emailForBeautyJudge"] = this.emailForBeautyJudge;
        data["flagLink"] = this.flagLink;
        return data;
    }
}

export interface ICountryGridDto {
    countryId?: number;
    isoCode?: string | undefined;
    isoAs400?: string | undefined;
    name?: string | undefined;
    emailForBeautyJudge?: string | undefined;
    flagLink?: string | undefined;
}

export class CountrySearch extends PaginatedSearch implements ICountrySearch {
    name?: TextSearch | undefined;
    isoCode?: TextSearch | undefined;
    languageId?: number;

    constructor(data?: ICountrySearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.isoCode = _data["isoCode"] ? TextSearch.fromJS(_data["isoCode"]) : <any>undefined;
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): CountrySearch {
        data = typeof data === 'object' ? data : {};
        let result = new CountrySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["isoCode"] = this.isoCode ? this.isoCode.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ICountrySearch extends IPaginatedSearch {
    name?: TextSearch | undefined;
    isoCode?: TextSearch | undefined;
    languageId?: number;
}

export class CountryDto implements ICountryDto {
    countryId?: number;
    countryTranslations?: CountryTranslationDto[] | undefined;
    languageIds?: number[] | undefined;
    isoCode?: string | undefined;
    isoAs400?: string | undefined;
    canineNumber?: string | undefined;
    canineStreet?: string | undefined;
    caninePostalCode?: string | undefined;
    canineCity?: string | undefined;
    canineGlobalEmail?: string | undefined;
    emailForJudgeInCompetition?: string | undefined;
    emailForWorkAttest?: string | undefined;
    emailForBeautyJudge?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    flagLink?: string | undefined;
    sharepointUri?: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            if (Array.isArray(_data["countryTranslations"])) {
                this.countryTranslations = [] as any;
                for (let item of _data["countryTranslations"])
                    this.countryTranslations!.push(CountryTranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.isoCode = _data["isoCode"];
            this.isoAs400 = _data["isoAs400"];
            this.canineNumber = _data["canineNumber"];
            this.canineStreet = _data["canineStreet"];
            this.caninePostalCode = _data["caninePostalCode"];
            this.canineCity = _data["canineCity"];
            this.canineGlobalEmail = _data["canineGlobalEmail"];
            this.emailForJudgeInCompetition = _data["emailForJudgeInCompetition"];
            this.emailForWorkAttest = _data["emailForWorkAttest"];
            this.emailForBeautyJudge = _data["emailForBeautyJudge"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.flagLink = _data["flagLink"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        if (Array.isArray(this.countryTranslations)) {
            data["countryTranslations"] = [];
            for (let item of this.countryTranslations)
                data["countryTranslations"].push(item.toJSON());
        }
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["isoCode"] = this.isoCode;
        data["isoAs400"] = this.isoAs400;
        data["canineNumber"] = this.canineNumber;
        data["canineStreet"] = this.canineStreet;
        data["caninePostalCode"] = this.caninePostalCode;
        data["canineCity"] = this.canineCity;
        data["canineGlobalEmail"] = this.canineGlobalEmail;
        data["emailForJudgeInCompetition"] = this.emailForJudgeInCompetition;
        data["emailForWorkAttest"] = this.emailForWorkAttest;
        data["emailForBeautyJudge"] = this.emailForBeautyJudge;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["flagLink"] = this.flagLink;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface ICountryDto {
    countryId?: number;
    countryTranslations?: CountryTranslationDto[] | undefined;
    languageIds?: number[] | undefined;
    isoCode?: string | undefined;
    isoAs400?: string | undefined;
    canineNumber?: string | undefined;
    canineStreet?: string | undefined;
    caninePostalCode?: string | undefined;
    canineCity?: string | undefined;
    canineGlobalEmail?: string | undefined;
    emailForJudgeInCompetition?: string | undefined;
    emailForWorkAttest?: string | undefined;
    emailForBeautyJudge?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    flagLink?: string | undefined;
    sharepointUri?: string | undefined;
}

export class CountryTranslationDto implements ICountryTranslationDto {
    languageId?: number;
    countryId?: number;
    text?: string | undefined;
    breedTranslationId?: number;

    constructor(data?: ICountryTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.countryId = _data["countryId"];
            this.text = _data["text"];
            this.breedTranslationId = _data["breedTranslationId"];
        }
    }

    static fromJS(data: any): CountryTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["countryId"] = this.countryId;
        data["text"] = this.text;
        data["breedTranslationId"] = this.breedTranslationId;
        return data;
    }
}

export interface ICountryTranslationDto {
    languageId?: number;
    countryId?: number;
    text?: string | undefined;
    breedTranslationId?: number;
}

export class PaginatedResultsOfCoupleInbreedingGridDto implements IPaginatedResultsOfCoupleInbreedingGridDto {
    totalCount?: number;
    results?: CoupleInbreedingGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCoupleInbreedingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CoupleInbreedingGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCoupleInbreedingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCoupleInbreedingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCoupleInbreedingGridDto {
    totalCount?: number;
    results?: CoupleInbreedingGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CoupleInbreedingGridDto implements ICoupleInbreedingGridDto {
    coupleInbreedingId?: number;
    fatherId?: number;
    motherId?: number;
    motherName?: string | undefined;
    fatherName?: string | undefined;
    inbreedingPercentage?: number;
    hasFile?: boolean;

    constructor(data?: ICoupleInbreedingGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coupleInbreedingId = _data["coupleInbreedingId"];
            this.fatherId = _data["fatherId"];
            this.motherId = _data["motherId"];
            this.motherName = _data["motherName"];
            this.fatherName = _data["fatherName"];
            this.inbreedingPercentage = _data["inbreedingPercentage"];
            this.hasFile = _data["hasFile"];
        }
    }

    static fromJS(data: any): CoupleInbreedingGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoupleInbreedingGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupleInbreedingId"] = this.coupleInbreedingId;
        data["fatherId"] = this.fatherId;
        data["motherId"] = this.motherId;
        data["motherName"] = this.motherName;
        data["fatherName"] = this.fatherName;
        data["inbreedingPercentage"] = this.inbreedingPercentage;
        data["hasFile"] = this.hasFile;
        return data;
    }
}

export interface ICoupleInbreedingGridDto {
    coupleInbreedingId?: number;
    fatherId?: number;
    motherId?: number;
    motherName?: string | undefined;
    fatherName?: string | undefined;
    inbreedingPercentage?: number;
    hasFile?: boolean;
}

export class CoupleInbreedingSearch extends PaginatedSearch implements ICoupleInbreedingSearch {
    dogId?: number;

    constructor(data?: ICoupleInbreedingSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): CoupleInbreedingSearch {
        data = typeof data === 'object' ? data : {};
        let result = new CoupleInbreedingSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface ICoupleInbreedingSearch extends IPaginatedSearch {
    dogId?: number;
}

export class CoupleInbreedingDto implements ICoupleInbreedingDto {
    coupleInbreedingId?: number;
    fatherId?: number;
    motherId?: number;
    inbreedingPercentage?: number;
    inbreedingProof?: string | undefined;
    validated?: boolean;

    constructor(data?: ICoupleInbreedingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coupleInbreedingId = _data["coupleInbreedingId"];
            this.fatherId = _data["fatherId"];
            this.motherId = _data["motherId"];
            this.inbreedingPercentage = _data["inbreedingPercentage"];
            this.inbreedingProof = _data["inbreedingProof"];
            this.validated = _data["validated"];
        }
    }

    static fromJS(data: any): CoupleInbreedingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoupleInbreedingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupleInbreedingId"] = this.coupleInbreedingId;
        data["fatherId"] = this.fatherId;
        data["motherId"] = this.motherId;
        data["inbreedingPercentage"] = this.inbreedingPercentage;
        data["inbreedingProof"] = this.inbreedingProof;
        data["validated"] = this.validated;
        return data;
    }
}

export interface ICoupleInbreedingDto {
    coupleInbreedingId?: number;
    fatherId?: number;
    motherId?: number;
    inbreedingPercentage?: number;
    inbreedingProof?: string | undefined;
    validated?: boolean;
}

export class PaginatedResultsOfDashboardTaskGridDto implements IPaginatedResultsOfDashboardTaskGridDto {
    totalCount?: number;
    results?: DashboardTaskGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDashboardTaskGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DashboardTaskGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDashboardTaskGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDashboardTaskGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDashboardTaskGridDto {
    totalCount?: number;
    results?: DashboardTaskGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DashboardTaskGridDto implements IDashboardTaskGridDto {
    requestNumber?: string | undefined;
    requestId?: number;
    requestTypeId?: number;
    dashboardTaskId?: number;
    requestDate?: Date;
    requestState?: string | undefined;
    requestType?: string | undefined;
    contact?: string | undefined;
    personId?: number;
    requestTypeCode?: ERequestType;
    containsPuppiesToTreat?: boolean;
    allPuppiesToTreat?: boolean;
    readyToBill?: boolean;
    subTasks?: DashboardSubTaskGridDto[] | undefined;

    constructor(data?: IDashboardTaskGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestNumber = _data["requestNumber"];
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
            this.dashboardTaskId = _data["dashboardTaskId"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestState = _data["requestState"];
            this.requestType = _data["requestType"];
            this.contact = _data["contact"];
            this.personId = _data["personId"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.containsPuppiesToTreat = _data["containsPuppiesToTreat"];
            this.allPuppiesToTreat = _data["allPuppiesToTreat"];
            this.readyToBill = _data["readyToBill"];
            if (Array.isArray(_data["subTasks"])) {
                this.subTasks = [] as any;
                for (let item of _data["subTasks"])
                    this.subTasks!.push(DashboardSubTaskGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardTaskGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTaskGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNumber"] = this.requestNumber;
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        data["dashboardTaskId"] = this.dashboardTaskId;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestState"] = this.requestState;
        data["requestType"] = this.requestType;
        data["contact"] = this.contact;
        data["personId"] = this.personId;
        data["requestTypeCode"] = this.requestTypeCode;
        data["containsPuppiesToTreat"] = this.containsPuppiesToTreat;
        data["allPuppiesToTreat"] = this.allPuppiesToTreat;
        data["readyToBill"] = this.readyToBill;
        if (Array.isArray(this.subTasks)) {
            data["subTasks"] = [];
            for (let item of this.subTasks)
                data["subTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardTaskGridDto {
    requestNumber?: string | undefined;
    requestId?: number;
    requestTypeId?: number;
    dashboardTaskId?: number;
    requestDate?: Date;
    requestState?: string | undefined;
    requestType?: string | undefined;
    contact?: string | undefined;
    personId?: number;
    requestTypeCode?: ERequestType;
    containsPuppiesToTreat?: boolean;
    allPuppiesToTreat?: boolean;
    readyToBill?: boolean;
    subTasks?: DashboardSubTaskGridDto[] | undefined;
}

export class DashboardSubTaskGridDto implements IDashboardSubTaskGridDto {
    task?: string | undefined;
    closedOn?: Date | undefined;
    dashboardTaskId?: number;

    constructor(data?: IDashboardSubTaskGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.task = _data["task"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.dashboardTaskId = _data["dashboardTaskId"];
        }
    }

    static fromJS(data: any): DashboardSubTaskGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSubTaskGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["task"] = this.task;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["dashboardTaskId"] = this.dashboardTaskId;
        return data;
    }
}

export interface IDashboardSubTaskGridDto {
    task?: string | undefined;
    closedOn?: Date | undefined;
    dashboardTaskId?: number;
}

export class DashboardSearch extends PaginatedSearch implements IDashboardSearch {
    languageId?: number;
    assigned?: boolean;
    department?: EDepartment | undefined;
    taskType?: ETaskType | undefined;
    requestNumber?: TextSearch | undefined;
    containsPuppiesToTreat?: BooleanSearch | undefined;
    allPuppiesToTreat?: BooleanSearch | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    readyToBill?: BooleanSearch | undefined;

    constructor(data?: IDashboardSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.assigned = _data["assigned"];
            this.department = _data["department"];
            this.taskType = _data["taskType"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.containsPuppiesToTreat = _data["containsPuppiesToTreat"] ? BooleanSearch.fromJS(_data["containsPuppiesToTreat"]) : <any>undefined;
            this.allPuppiesToTreat = _data["allPuppiesToTreat"] ? BooleanSearch.fromJS(_data["allPuppiesToTreat"]) : <any>undefined;
            this.requestTypeId = _data["requestTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["requestTypeId"]) : <any>undefined;
            this.readyToBill = _data["readyToBill"] ? BooleanSearch.fromJS(_data["readyToBill"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["assigned"] = this.assigned;
        data["department"] = this.department;
        data["taskType"] = this.taskType;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["containsPuppiesToTreat"] = this.containsPuppiesToTreat ? this.containsPuppiesToTreat.toJSON() : <any>undefined;
        data["allPuppiesToTreat"] = this.allPuppiesToTreat ? this.allPuppiesToTreat.toJSON() : <any>undefined;
        data["requestTypeId"] = this.requestTypeId ? this.requestTypeId.toJSON() : <any>undefined;
        data["readyToBill"] = this.readyToBill ? this.readyToBill.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardSearch extends IPaginatedSearch {
    languageId?: number;
    assigned?: boolean;
    department?: EDepartment | undefined;
    taskType?: ETaskType | undefined;
    requestNumber?: TextSearch | undefined;
    containsPuppiesToTreat?: BooleanSearch | undefined;
    allPuppiesToTreat?: BooleanSearch | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    readyToBill?: BooleanSearch | undefined;
}

export class PaginatedResultsOfDashboardSubTaskGridDto implements IPaginatedResultsOfDashboardSubTaskGridDto {
    totalCount?: number;
    results?: DashboardSubTaskGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDashboardSubTaskGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DashboardSubTaskGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDashboardSubTaskGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDashboardSubTaskGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDashboardSubTaskGridDto {
    totalCount?: number;
    results?: DashboardSubTaskGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DashboardDogSearch extends PaginatedSearch implements IDashboardDogSearch {
    languageId?: number;
    assigned?: boolean;
    showClosed?: boolean;
    task?: TextSearch | undefined;

    constructor(data?: IDashboardDogSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.assigned = _data["assigned"];
            this.showClosed = _data["showClosed"];
            this.task = _data["task"] ? TextSearch.fromJS(_data["task"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardDogSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDogSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["assigned"] = this.assigned;
        data["showClosed"] = this.showClosed;
        data["task"] = this.task ? this.task.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardDogSearch extends IPaginatedSearch {
    languageId?: number;
    assigned?: boolean;
    showClosed?: boolean;
    task?: TextSearch | undefined;
}

export class PaginatedResultsOfDocumentTemplateGridDto implements IPaginatedResultsOfDocumentTemplateGridDto {
    totalCount?: number;
    results?: DocumentTemplateGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDocumentTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DocumentTemplateGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDocumentTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDocumentTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDocumentTemplateGridDto {
    totalCount?: number;
    results?: DocumentTemplateGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DocumentTemplateGridDto implements IDocumentTemplateGridDto {
    documentTemplateId?: number;
    templateCode?: EDocumentTemplate;
    description?: string | undefined;
    frContent?: boolean;
    enContent?: boolean;
    nlcontent?: boolean;

    constructor(data?: IDocumentTemplateGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateId = _data["documentTemplateId"];
            this.templateCode = _data["templateCode"];
            this.description = _data["description"];
            this.frContent = _data["frContent"];
            this.enContent = _data["enContent"];
            this.nlcontent = _data["nlcontent"];
        }
    }

    static fromJS(data: any): DocumentTemplateGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateId"] = this.documentTemplateId;
        data["templateCode"] = this.templateCode;
        data["description"] = this.description;
        data["frContent"] = this.frContent;
        data["enContent"] = this.enContent;
        data["nlcontent"] = this.nlcontent;
        return data;
    }
}

export interface IDocumentTemplateGridDto {
    documentTemplateId?: number;
    templateCode?: EDocumentTemplate;
    description?: string | undefined;
    frContent?: boolean;
    enContent?: boolean;
    nlcontent?: boolean;
}

export class DocumentTemplateSearch extends PaginatedSearch implements IDocumentTemplateSearch {
    templateCode?: ListSearchOfNullableEDocumentTemplate | undefined;
    description?: TextSearch | undefined;
    frContent?: BooleanSearch | undefined;
    enContent?: BooleanSearch | undefined;
    nlcontent?: BooleanSearch | undefined;

    constructor(data?: IDocumentTemplateSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.templateCode = _data["templateCode"] ? ListSearchOfNullableEDocumentTemplate.fromJS(_data["templateCode"]) : <any>undefined;
            this.description = _data["description"] ? TextSearch.fromJS(_data["description"]) : <any>undefined;
            this.frContent = _data["frContent"] ? BooleanSearch.fromJS(_data["frContent"]) : <any>undefined;
            this.enContent = _data["enContent"] ? BooleanSearch.fromJS(_data["enContent"]) : <any>undefined;
            this.nlcontent = _data["nlcontent"] ? BooleanSearch.fromJS(_data["nlcontent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTemplateSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateCode"] = this.templateCode ? this.templateCode.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["frContent"] = this.frContent ? this.frContent.toJSON() : <any>undefined;
        data["enContent"] = this.enContent ? this.enContent.toJSON() : <any>undefined;
        data["nlcontent"] = this.nlcontent ? this.nlcontent.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentTemplateSearch extends IPaginatedSearch {
    templateCode?: ListSearchOfNullableEDocumentTemplate | undefined;
    description?: TextSearch | undefined;
    frContent?: BooleanSearch | undefined;
    enContent?: BooleanSearch | undefined;
    nlcontent?: BooleanSearch | undefined;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate implements IFilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate[] | undefined;
    searchMode?: EListSearchType;
    value?: EDocumentTemplate | undefined;
    secondaryValue?: EDocumentTemplate | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate[] | undefined;
    searchMode?: EListSearchType;
    value?: EDocumentTemplate | undefined;
    secondaryValue?: EDocumentTemplate | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfNullableEDocumentTemplate extends FilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate implements IListSearchOfNullableEDocumentTemplate {

    constructor(data?: IListSearchOfNullableEDocumentTemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfNullableEDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableEDocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfNullableEDocumentTemplate extends IFilterCriteriaBaseOfEListSearchTypeAndNullableEDocumentTemplate {
}

export class CombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate implements ICombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate {
    searchMode?: EListSearchType;
    value?: EDocumentTemplate | undefined;
    secondaryValue?: EDocumentTemplate | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableEDocumentTemplate {
    searchMode?: EListSearchType;
    value?: EDocumentTemplate | undefined;
    secondaryValue?: EDocumentTemplate | undefined;
}

export class DocumentTemplateDto implements IDocumentTemplateDto {
    documentTemplateId?: number;
    templateCode?: EDocumentTemplate;
    printer?: string | undefined;
    paperDecoration?: EPaperDecorationType;
    printMethod?: EPrintMethod | undefined;
    documentContent?: DocumentContentDto[] | undefined;

    constructor(data?: IDocumentTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateId = _data["documentTemplateId"];
            this.templateCode = _data["templateCode"];
            this.printer = _data["printer"];
            this.paperDecoration = _data["paperDecoration"];
            this.printMethod = _data["printMethod"];
            if (Array.isArray(_data["documentContent"])) {
                this.documentContent = [] as any;
                for (let item of _data["documentContent"])
                    this.documentContent!.push(DocumentContentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateId"] = this.documentTemplateId;
        data["templateCode"] = this.templateCode;
        data["printer"] = this.printer;
        data["paperDecoration"] = this.paperDecoration;
        data["printMethod"] = this.printMethod;
        if (Array.isArray(this.documentContent)) {
            data["documentContent"] = [];
            for (let item of this.documentContent)
                data["documentContent"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentTemplateDto {
    documentTemplateId?: number;
    templateCode?: EDocumentTemplate;
    printer?: string | undefined;
    paperDecoration?: EPaperDecorationType;
    printMethod?: EPrintMethod | undefined;
    documentContent?: DocumentContentDto[] | undefined;
}

export enum EPaperDecorationType {
    Season = "Season",
    Health = "Health",
    General = "General",
    Sport = "Sport",
}

export class DocumentContentDto implements IDocumentContentDto {
    documentContentId?: number;
    recipientInfo?: string | undefined;
    content?: string | undefined;
    description?: string | undefined;
    languageId?: number;
    documentTemplateId?: number;

    constructor(data?: IDocumentContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentContentId = _data["documentContentId"];
            this.recipientInfo = _data["recipientInfo"];
            this.content = _data["content"];
            this.description = _data["description"];
            this.languageId = _data["languageId"];
            this.documentTemplateId = _data["documentTemplateId"];
        }
    }

    static fromJS(data: any): DocumentContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentContentId"] = this.documentContentId;
        data["recipientInfo"] = this.recipientInfo;
        data["content"] = this.content;
        data["description"] = this.description;
        data["languageId"] = this.languageId;
        data["documentTemplateId"] = this.documentTemplateId;
        return data;
    }
}

export interface IDocumentContentDto {
    documentContentId?: number;
    recipientInfo?: string | undefined;
    content?: string | undefined;
    description?: string | undefined;
    languageId?: number;
    documentTemplateId?: number;
}

export class PaginatedResultsOfPersonGridDto implements IPaginatedResultsOfPersonGridDto {
    totalCount?: number;
    results?: PersonGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonGridDto {
    totalCount?: number;
    results?: PersonGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonGridDto implements IPersonGridDto {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    isBreeder?: boolean;
    isMember?: boolean;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    email?: string | undefined;
    parentPersonId?: number | undefined;
    computedName?: string | undefined;
    isKnownPerson?: boolean;
    webAccess?: boolean;

    constructor(data?: IPersonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.isBreeder = _data["isBreeder"];
            this.isMember = _data["isMember"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.email = _data["email"];
            this.parentPersonId = _data["parentPersonId"];
            this.computedName = _data["computedName"];
            this.isKnownPerson = _data["isKnownPerson"];
            this.webAccess = _data["webAccess"];
        }
    }

    static fromJS(data: any): PersonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["isBreeder"] = this.isBreeder;
        data["isMember"] = this.isMember;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["email"] = this.email;
        data["parentPersonId"] = this.parentPersonId;
        data["computedName"] = this.computedName;
        data["isKnownPerson"] = this.isKnownPerson;
        data["webAccess"] = this.webAccess;
        return data;
    }
}

export interface IPersonGridDto {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    isBreeder?: boolean;
    isMember?: boolean;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    email?: string | undefined;
    parentPersonId?: number | undefined;
    computedName?: string | undefined;
    isKnownPerson?: boolean;
    webAccess?: boolean;
}

export class DogBaseSearch extends PaginatedSearch implements IDogBaseSearch {
    dogId?: number;
    languageId?: number;
    currentOwners?: boolean;
    showTemporaryOwners?: boolean;

    constructor(data?: IDogBaseSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
            this.currentOwners = _data["currentOwners"];
            this.showTemporaryOwners = _data["showTemporaryOwners"];
        }
    }

    static fromJS(data: any): DogBaseSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogBaseSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        data["currentOwners"] = this.currentOwners;
        data["showTemporaryOwners"] = this.showTemporaryOwners;
        super.toJSON(data);
        return data;
    }
}

export interface IDogBaseSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
    currentOwners?: boolean;
    showTemporaryOwners?: boolean;
}

export class PaginatedResultsOfDogBreederGridDto implements IPaginatedResultsOfDogBreederGridDto {
    totalCount?: number;
    results?: DogBreederGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogBreederGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogBreederGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogBreederGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogBreederGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogBreederGridDto {
    totalCount?: number;
    results?: DogBreederGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogBreederGridDto implements IDogBreederGridDto {
    kennelsOwnersDogsOwnershipId?: number;
    breederId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;

    constructor(data?: IDogBreederGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelsOwnersDogsOwnershipId = _data["kennelsOwnersDogsOwnershipId"];
            this.breederId = _data["breederId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.computedName = _data["computedName"];
            this.email = _data["email"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): DogBreederGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogBreederGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelsOwnersDogsOwnershipId"] = this.kennelsOwnersDogsOwnershipId;
        data["breederId"] = this.breederId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["computedName"] = this.computedName;
        data["email"] = this.email;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface IDogBreederGridDto {
    kennelsOwnersDogsOwnershipId?: number;
    breederId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export class SaveBreederDto implements ISaveBreederDto {
    breederId?: number;
    personId?: number;
    hkNumber?: string | undefined;
    vatNumber?: string | undefined;
    firmNameInvoicing?: string | undefined;
    webSiteUri?: string | undefined;
    bannedFrom?: Date | undefined;
    bannedTo?: Date | undefined;

    constructor(data?: ISaveBreederDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breederId = _data["breederId"];
            this.personId = _data["personId"];
            this.hkNumber = _data["hkNumber"];
            this.vatNumber = _data["vatNumber"];
            this.firmNameInvoicing = _data["firmNameInvoicing"];
            this.webSiteUri = _data["webSiteUri"];
            this.bannedFrom = _data["bannedFrom"] ? new Date(_data["bannedFrom"].toString()) : <any>undefined;
            this.bannedTo = _data["bannedTo"] ? new Date(_data["bannedTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveBreederDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBreederDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breederId"] = this.breederId;
        data["personId"] = this.personId;
        data["hkNumber"] = this.hkNumber;
        data["vatNumber"] = this.vatNumber;
        data["firmNameInvoicing"] = this.firmNameInvoicing;
        data["webSiteUri"] = this.webSiteUri;
        data["bannedFrom"] = this.bannedFrom ? this.bannedFrom.toISOString() : <any>undefined;
        data["bannedTo"] = this.bannedTo ? this.bannedTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveBreederDto {
    breederId?: number;
    personId?: number;
    hkNumber?: string | undefined;
    vatNumber?: string | undefined;
    firmNameInvoicing?: string | undefined;
    webSiteUri?: string | undefined;
    bannedFrom?: Date | undefined;
    bannedTo?: Date | undefined;
}

export class GetDogBreederParameters implements IGetDogBreederParameters {
    personId?: number | undefined;
    breederId?: number | undefined;

    constructor(data?: IGetDogBreederParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.breederId = _data["breederId"];
        }
    }

    static fromJS(data: any): GetDogBreederParameters {
        data = typeof data === 'object' ? data : {};
        let result = new GetDogBreederParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["breederId"] = this.breederId;
        return data;
    }
}

export interface IGetDogBreederParameters {
    personId?: number | undefined;
    breederId?: number | undefined;
}

export class PaginatedResultsOfDogBroodRequestGridDto implements IPaginatedResultsOfDogBroodRequestGridDto {
    totalCount?: number;
    results?: DogBroodRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogBroodRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogBroodRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogBroodRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogBroodRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogBroodRequestGridDto {
    totalCount?: number;
    results?: DogBroodRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogBroodRequestGridDto implements IDogBroodRequestGridDto {
    birthDate?: Date | undefined;
    requestNumber?: string | undefined;
    broodRequestId?: number;
    breeder?: string | undefined;
    breederId?: number;
    dogTypeInRequest?: EBroodRequestDogType;
    requestStatus?: string | undefined;

    constructor(data?: IDogBroodRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.requestNumber = _data["requestNumber"];
            this.broodRequestId = _data["broodRequestId"];
            this.breeder = _data["breeder"];
            this.breederId = _data["breederId"];
            this.dogTypeInRequest = _data["dogTypeInRequest"];
            this.requestStatus = _data["requestStatus"];
        }
    }

    static fromJS(data: any): DogBroodRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["requestNumber"] = this.requestNumber;
        data["broodRequestId"] = this.broodRequestId;
        data["breeder"] = this.breeder;
        data["breederId"] = this.breederId;
        data["dogTypeInRequest"] = this.dogTypeInRequest;
        data["requestStatus"] = this.requestStatus;
        return data;
    }
}

export interface IDogBroodRequestGridDto {
    birthDate?: Date | undefined;
    requestNumber?: string | undefined;
    broodRequestId?: number;
    breeder?: string | undefined;
    breederId?: number;
    dogTypeInRequest?: EBroodRequestDogType;
    requestStatus?: string | undefined;
}

export class DogBroodRequestSearch extends PaginatedSearch implements IDogBroodRequestSearch {
    dogId?: number;
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    breeder?: TextSearch | undefined;
    birthDate?: DateSearch | undefined;

    constructor(data?: IDogBroodRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.breeder = _data["breeder"] ? TextSearch.fromJS(_data["breeder"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? DateSearch.fromJS(_data["birthDate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DogBroodRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogBroodRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["breeder"] = this.breeder ? this.breeder.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDogBroodRequestSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    breeder?: TextSearch | undefined;
    birthDate?: DateSearch | undefined;
}

export class PaginatedResultsOfDogChipGridDto implements IPaginatedResultsOfDogChipGridDto {
    totalCount?: number;
    results?: DogChipGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogChipGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogChipGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogChipGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogChipGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogChipGridDto {
    totalCount?: number;
    results?: DogChipGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogChipGridDto implements IDogChipGridDto {
    dogChipId?: number;
    dogId?: number;
    chipNumber?: string | undefined;
    createdOn?: Date;

    constructor(data?: IDogChipGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogChipId = _data["dogChipId"];
            this.dogId = _data["dogId"];
            this.chipNumber = _data["chipNumber"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogChipGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogChipGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogChipId"] = this.dogChipId;
        data["dogId"] = this.dogId;
        data["chipNumber"] = this.chipNumber;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogChipGridDto {
    dogChipId?: number;
    dogId?: number;
    chipNumber?: string | undefined;
    createdOn?: Date;
}

export class DogChipSearch extends PaginatedSearch implements IDogChipSearch {
    dogId?: number;

    constructor(data?: IDogChipSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): DogChipSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogChipSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface IDogChipSearch extends IPaginatedSearch {
    dogId?: number;
}

export class DogChipDto implements IDogChipDto {
    dogId?: number;
    chipNumber?: string | undefined;
    dogChipId?: number;

    constructor(data?: IDogChipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.chipNumber = _data["chipNumber"];
            this.dogChipId = _data["dogChipId"];
        }
    }

    static fromJS(data: any): DogChipDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogChipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["chipNumber"] = this.chipNumber;
        data["dogChipId"] = this.dogChipId;
        return data;
    }
}

export interface IDogChipDto {
    dogId?: number;
    chipNumber?: string | undefined;
    dogChipId?: number;
}

export class PaginatedResultsOfDogGridDto implements IPaginatedResultsOfDogGridDto {
    totalCount?: number;
    results?: DogGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogGridDto {
    totalCount?: number;
    results?: DogGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogGridDto implements IDogGridDto {
    dogId?: number;
    computedName?: string | undefined;
    pedigrees?: string[] | undefined;
    pedigree?: string | undefined;
    dogChip?: string | undefined;
    secondDogChip?: string | undefined;
    colorId?: number;
    color?: string | undefined;
    breedId?: number;
    breedName?: string | undefined;
    sex?: EDogSex;
    isDead?: boolean;
    isExcluded?: boolean;
    type?: string | undefined;
    dogTypeId?: number;
    birthDate?: Date | undefined;
    dogTransientId?: number | undefined;
    closedOn?: Date | undefined;
    deathDate?: Date | undefined;

    constructor(data?: IDogGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.computedName = _data["computedName"];
            if (Array.isArray(_data["pedigrees"])) {
                this.pedigrees = [] as any;
                for (let item of _data["pedigrees"])
                    this.pedigrees!.push(item);
            }
            this.pedigree = _data["pedigree"];
            this.dogChip = _data["dogChip"];
            this.secondDogChip = _data["secondDogChip"];
            this.colorId = _data["colorId"];
            this.color = _data["color"];
            this.breedId = _data["breedId"];
            this.breedName = _data["breedName"];
            this.sex = _data["sex"];
            this.isDead = _data["isDead"];
            this.isExcluded = _data["isExcluded"];
            this.type = _data["type"];
            this.dogTypeId = _data["dogTypeId"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.dogTransientId = _data["dogTransientId"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["computedName"] = this.computedName;
        if (Array.isArray(this.pedigrees)) {
            data["pedigrees"] = [];
            for (let item of this.pedigrees)
                data["pedigrees"].push(item);
        }
        data["pedigree"] = this.pedigree;
        data["dogChip"] = this.dogChip;
        data["secondDogChip"] = this.secondDogChip;
        data["colorId"] = this.colorId;
        data["color"] = this.color;
        data["breedId"] = this.breedId;
        data["breedName"] = this.breedName;
        data["sex"] = this.sex;
        data["isDead"] = this.isDead;
        data["isExcluded"] = this.isExcluded;
        data["type"] = this.type;
        data["dogTypeId"] = this.dogTypeId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["dogTransientId"] = this.dogTransientId;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogGridDto {
    dogId?: number;
    computedName?: string | undefined;
    pedigrees?: string[] | undefined;
    pedigree?: string | undefined;
    dogChip?: string | undefined;
    secondDogChip?: string | undefined;
    colorId?: number;
    color?: string | undefined;
    breedId?: number;
    breedName?: string | undefined;
    sex?: EDogSex;
    isDead?: boolean;
    isExcluded?: boolean;
    type?: string | undefined;
    dogTypeId?: number;
    birthDate?: Date | undefined;
    dogTransientId?: number | undefined;
    closedOn?: Date | undefined;
    deathDate?: Date | undefined;
}

export class DogSearch extends PaginatedSearch implements IDogSearch {
    languageId?: number;
    computedName?: TextSearch | undefined;
    color?: TextSearch | undefined;
    breedName?: TextSearch | undefined;
    pedigree?: TextSearch | undefined;
    sex?: ListSearchOfNullableEDogSex | undefined;
    dogTypeId?: ListSearchOfNullableInteger | undefined;
    identificationNumber?: TextSearch | undefined;
    birthDate?: DateSearch | undefined;
    personId?: number | undefined;
    selectOnlyMales?: boolean | undefined;
    compatibleDogId?: number | undefined;
    isBroodRequest?: boolean | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
    excludeExpoDogs?: boolean | undefined;
    checkbreedAuthorized?: boolean | undefined;

    constructor(data?: IDogSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.computedName = _data["computedName"] ? TextSearch.fromJS(_data["computedName"]) : <any>undefined;
            this.color = _data["color"] ? TextSearch.fromJS(_data["color"]) : <any>undefined;
            this.breedName = _data["breedName"] ? TextSearch.fromJS(_data["breedName"]) : <any>undefined;
            this.pedigree = _data["pedigree"] ? TextSearch.fromJS(_data["pedigree"]) : <any>undefined;
            this.sex = _data["sex"] ? ListSearchOfNullableEDogSex.fromJS(_data["sex"]) : <any>undefined;
            this.dogTypeId = _data["dogTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["dogTypeId"]) : <any>undefined;
            this.identificationNumber = _data["identificationNumber"] ? TextSearch.fromJS(_data["identificationNumber"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? DateSearch.fromJS(_data["birthDate"]) : <any>undefined;
            this.personId = _data["personId"];
            this.selectOnlyMales = _data["selectOnlyMales"];
            this.compatibleDogId = _data["compatibleDogId"];
            this.isBroodRequest = _data["isBroodRequest"];
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
            this.excludeExpoDogs = _data["excludeExpoDogs"];
            this.checkbreedAuthorized = _data["checkbreedAuthorized"];
        }
    }

    static fromJS(data: any): DogSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["computedName"] = this.computedName ? this.computedName.toJSON() : <any>undefined;
        data["color"] = this.color ? this.color.toJSON() : <any>undefined;
        data["breedName"] = this.breedName ? this.breedName.toJSON() : <any>undefined;
        data["pedigree"] = this.pedigree ? this.pedigree.toJSON() : <any>undefined;
        data["sex"] = this.sex ? this.sex.toJSON() : <any>undefined;
        data["dogTypeId"] = this.dogTypeId ? this.dogTypeId.toJSON() : <any>undefined;
        data["identificationNumber"] = this.identificationNumber ? this.identificationNumber.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["selectOnlyMales"] = this.selectOnlyMales;
        data["compatibleDogId"] = this.compatibleDogId;
        data["isBroodRequest"] = this.isBroodRequest;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        data["excludeExpoDogs"] = this.excludeExpoDogs;
        data["checkbreedAuthorized"] = this.checkbreedAuthorized;
        super.toJSON(data);
        return data;
    }
}

export interface IDogSearch extends IPaginatedSearch {
    languageId?: number;
    computedName?: TextSearch | undefined;
    color?: TextSearch | undefined;
    breedName?: TextSearch | undefined;
    pedigree?: TextSearch | undefined;
    sex?: ListSearchOfNullableEDogSex | undefined;
    dogTypeId?: ListSearchOfNullableInteger | undefined;
    identificationNumber?: TextSearch | undefined;
    birthDate?: DateSearch | undefined;
    personId?: number | undefined;
    selectOnlyMales?: boolean | undefined;
    compatibleDogId?: number | undefined;
    isBroodRequest?: boolean | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
    excludeExpoDogs?: boolean | undefined;
    checkbreedAuthorized?: boolean | undefined;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex implements IFilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableEDogSex[] | undefined;
    searchMode?: EListSearchType;
    value?: EDogSex | undefined;
    secondaryValue?: EDogSex | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableEDogSex.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableEDogSex[] | undefined;
    searchMode?: EListSearchType;
    value?: EDogSex | undefined;
    secondaryValue?: EDogSex | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfNullableEDogSex extends FilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex implements IListSearchOfNullableEDogSex {

    constructor(data?: IListSearchOfNullableEDogSex) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfNullableEDogSex {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableEDogSex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfNullableEDogSex extends IFilterCriteriaBaseOfEListSearchTypeAndNullableEDogSex {
}

export class CombinableCriteriaOfEListSearchTypeAndNullableEDogSex implements ICombinableCriteriaOfEListSearchTypeAndNullableEDogSex {
    searchMode?: EListSearchType;
    value?: EDogSex | undefined;
    secondaryValue?: EDogSex | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableEDogSex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableEDogSex {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableEDogSex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableEDogSex {
    searchMode?: EListSearchType;
    value?: EDogSex | undefined;
    secondaryValue?: EDogSex | undefined;
}

export class ShpDocumentDto implements IShpDocumentDto {
    fileName?: string | undefined;
    docType?: string | undefined;
    date?: Date | undefined;
    visibleOnELocket?: boolean;
    driveItemId?: string | undefined;
    extension?: string | undefined;
    nameWithoutExtension?: string | undefined;

    constructor(data?: IShpDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.docType = _data["docType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.visibleOnELocket = _data["visibleOnELocket"];
            this.driveItemId = _data["driveItemId"];
            this.extension = _data["extension"];
            this.nameWithoutExtension = _data["nameWithoutExtension"];
        }
    }

    static fromJS(data: any): ShpDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShpDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["docType"] = this.docType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["visibleOnELocket"] = this.visibleOnELocket;
        data["driveItemId"] = this.driveItemId;
        data["extension"] = this.extension;
        data["nameWithoutExtension"] = this.nameWithoutExtension;
        return data;
    }
}

export interface IShpDocumentDto {
    fileName?: string | undefined;
    docType?: string | undefined;
    date?: Date | undefined;
    visibleOnELocket?: boolean;
    driveItemId?: string | undefined;
    extension?: string | undefined;
    nameWithoutExtension?: string | undefined;
}

export class DogFusionDto implements IDogFusionDto {
    fusedDog?: DogDto | undefined;
    dogId1?: number;
    dogId2?: number;

    constructor(data?: IDogFusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fusedDog = _data["fusedDog"] ? DogDto.fromJS(_data["fusedDog"]) : <any>undefined;
            this.dogId1 = _data["dogId1"];
            this.dogId2 = _data["dogId2"];
        }
    }

    static fromJS(data: any): DogFusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogFusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fusedDog"] = this.fusedDog ? this.fusedDog.toJSON() : <any>undefined;
        data["dogId1"] = this.dogId1;
        data["dogId2"] = this.dogId2;
        return data;
    }
}

export interface IDogFusionDto {
    fusedDog?: DogDto | undefined;
    dogId1?: number;
    dogId2?: number;
}

export class DogFusionComparisonDto implements IDogFusionComparisonDto {
    dog1?: DogDto | undefined;
    dog2?: DogDto | undefined;
    dog1HasKennel?: boolean;
    dog2HasKennel?: boolean;
    dog1HasRequests?: boolean;
    dog2HasRequests?: boolean;
    dog1HasTitles?: boolean;
    dog2HasTitles?: boolean;
    dog1HasWorkbooks?: boolean;
    dog2HasWorkbooks?: boolean;
    dog1HasDysplasias?: boolean;
    dog2HasDysplasias?: boolean;
    dog1HasHealthTest?: boolean;
    dog2HasHealthTest?: boolean;
    dog1HasDnaTest?: boolean;
    dog2HasDnaTest?: boolean;
    dnaTestsIdentical?: boolean;

    constructor(data?: IDogFusionComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dog1 = _data["dog1"] ? DogDto.fromJS(_data["dog1"]) : <any>undefined;
            this.dog2 = _data["dog2"] ? DogDto.fromJS(_data["dog2"]) : <any>undefined;
            this.dog1HasKennel = _data["dog1HasKennel"];
            this.dog2HasKennel = _data["dog2HasKennel"];
            this.dog1HasRequests = _data["dog1HasRequests"];
            this.dog2HasRequests = _data["dog2HasRequests"];
            this.dog1HasTitles = _data["dog1HasTitles"];
            this.dog2HasTitles = _data["dog2HasTitles"];
            this.dog1HasWorkbooks = _data["dog1HasWorkbooks"];
            this.dog2HasWorkbooks = _data["dog2HasWorkbooks"];
            this.dog1HasDysplasias = _data["dog1HasDysplasias"];
            this.dog2HasDysplasias = _data["dog2HasDysplasias"];
            this.dog1HasHealthTest = _data["dog1HasHealthTest"];
            this.dog2HasHealthTest = _data["dog2HasHealthTest"];
            this.dog1HasDnaTest = _data["dog1HasDnaTest"];
            this.dog2HasDnaTest = _data["dog2HasDnaTest"];
            this.dnaTestsIdentical = _data["dnaTestsIdentical"];
        }
    }

    static fromJS(data: any): DogFusionComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogFusionComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dog1"] = this.dog1 ? this.dog1.toJSON() : <any>undefined;
        data["dog2"] = this.dog2 ? this.dog2.toJSON() : <any>undefined;
        data["dog1HasKennel"] = this.dog1HasKennel;
        data["dog2HasKennel"] = this.dog2HasKennel;
        data["dog1HasRequests"] = this.dog1HasRequests;
        data["dog2HasRequests"] = this.dog2HasRequests;
        data["dog1HasTitles"] = this.dog1HasTitles;
        data["dog2HasTitles"] = this.dog2HasTitles;
        data["dog1HasWorkbooks"] = this.dog1HasWorkbooks;
        data["dog2HasWorkbooks"] = this.dog2HasWorkbooks;
        data["dog1HasDysplasias"] = this.dog1HasDysplasias;
        data["dog2HasDysplasias"] = this.dog2HasDysplasias;
        data["dog1HasHealthTest"] = this.dog1HasHealthTest;
        data["dog2HasHealthTest"] = this.dog2HasHealthTest;
        data["dog1HasDnaTest"] = this.dog1HasDnaTest;
        data["dog2HasDnaTest"] = this.dog2HasDnaTest;
        data["dnaTestsIdentical"] = this.dnaTestsIdentical;
        return data;
    }
}

export interface IDogFusionComparisonDto {
    dog1?: DogDto | undefined;
    dog2?: DogDto | undefined;
    dog1HasKennel?: boolean;
    dog2HasKennel?: boolean;
    dog1HasRequests?: boolean;
    dog2HasRequests?: boolean;
    dog1HasTitles?: boolean;
    dog2HasTitles?: boolean;
    dog1HasWorkbooks?: boolean;
    dog2HasWorkbooks?: boolean;
    dog1HasDysplasias?: boolean;
    dog2HasDysplasias?: boolean;
    dog1HasHealthTest?: boolean;
    dog2HasHealthTest?: boolean;
    dog1HasDnaTest?: boolean;
    dog2HasDnaTest?: boolean;
    dnaTestsIdentical?: boolean;
}

export class DrupalDogDto implements IDrupalDogDto {
    dogId?: number;
    isSportSection?: boolean | undefined;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    personId?: number | undefined;
    breedId?: number;
    dogTypeId?: number | undefined;
    colorId?: number | undefined;
    sex?: EDogSex;
    sharepointUri?: string | undefined;
    dogName?: string | undefined;
    tatoo?: string | undefined;
    breedName?: string | undefined;
    chipNumber?: string | undefined;
    countryPrefixId?: number | undefined;
    pedigree?: string | undefined;
    kennelName?: string | undefined;
    kennelType?: EKennelType | undefined;
    hasAdnProfile?: boolean;
    withoutOwnership?: boolean;

    constructor(data?: IDrupalDogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.isSportSection = _data["isSportSection"];
            this.firstName = _data["firstName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.breedId = _data["breedId"];
            this.dogTypeId = _data["dogTypeId"];
            this.colorId = _data["colorId"];
            this.sex = _data["sex"];
            this.sharepointUri = _data["sharepointUri"];
            this.dogName = _data["dogName"];
            this.tatoo = _data["tatoo"];
            this.breedName = _data["breedName"];
            this.chipNumber = _data["chipNumber"];
            this.countryPrefixId = _data["countryPrefixId"];
            this.pedigree = _data["pedigree"];
            this.kennelName = _data["kennelName"];
            this.kennelType = _data["kennelType"];
            this.hasAdnProfile = _data["hasAdnProfile"];
            this.withoutOwnership = _data["withoutOwnership"];
        }
    }

    static fromJS(data: any): DrupalDogDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalDogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["isSportSection"] = this.isSportSection;
        data["firstName"] = this.firstName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["breedId"] = this.breedId;
        data["dogTypeId"] = this.dogTypeId;
        data["colorId"] = this.colorId;
        data["sex"] = this.sex;
        data["sharepointUri"] = this.sharepointUri;
        data["dogName"] = this.dogName;
        data["tatoo"] = this.tatoo;
        data["breedName"] = this.breedName;
        data["chipNumber"] = this.chipNumber;
        data["countryPrefixId"] = this.countryPrefixId;
        data["pedigree"] = this.pedigree;
        data["kennelName"] = this.kennelName;
        data["kennelType"] = this.kennelType;
        data["hasAdnProfile"] = this.hasAdnProfile;
        data["withoutOwnership"] = this.withoutOwnership;
        return data;
    }
}

export interface IDrupalDogDto {
    dogId?: number;
    isSportSection?: boolean | undefined;
    firstName?: string | undefined;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    personId?: number | undefined;
    breedId?: number;
    dogTypeId?: number | undefined;
    colorId?: number | undefined;
    sex?: EDogSex;
    sharepointUri?: string | undefined;
    dogName?: string | undefined;
    tatoo?: string | undefined;
    breedName?: string | undefined;
    chipNumber?: string | undefined;
    countryPrefixId?: number | undefined;
    pedigree?: string | undefined;
    kennelName?: string | undefined;
    kennelType?: EKennelType | undefined;
    hasAdnProfile?: boolean;
    withoutOwnership?: boolean;
}

export class FullDogNameKennelDto implements IFullDogNameKennelDto {
    name?: string | undefined;
    isPrefix?: boolean;

    constructor(data?: IFullDogNameKennelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrefix = _data["isPrefix"];
        }
    }

    static fromJS(data: any): FullDogNameKennelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullDogNameKennelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrefix"] = this.isPrefix;
        return data;
    }
}

export interface IFullDogNameKennelDto {
    name?: string | undefined;
    isPrefix?: boolean;
}

export class PaginatedResultsOfDogDnaMarkersGridDto implements IPaginatedResultsOfDogDnaMarkersGridDto {
    totalCount?: number;
    results?: DogDnaMarkersGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogDnaMarkersGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogDnaMarkersGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogDnaMarkersGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogDnaMarkersGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogDnaMarkersGridDto {
    totalCount?: number;
    results?: DogDnaMarkersGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogDnaMarkersGridDto implements IDogDnaMarkersGridDto {
    dnaMarkerResultId?: number;
    marker?: string | undefined;
    value1?: string | undefined;
    value2?: string | undefined;
    isag?: EIsagNorm;

    constructor(data?: IDogDnaMarkersGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dnaMarkerResultId = _data["dnaMarkerResultId"];
            this.marker = _data["marker"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.isag = _data["isag"];
        }
    }

    static fromJS(data: any): DogDnaMarkersGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogDnaMarkersGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dnaMarkerResultId"] = this.dnaMarkerResultId;
        data["marker"] = this.marker;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["isag"] = this.isag;
        return data;
    }
}

export interface IDogDnaMarkersGridDto {
    dnaMarkerResultId?: number;
    marker?: string | undefined;
    value1?: string | undefined;
    value2?: string | undefined;
    isag?: EIsagNorm;
}

export class DogDnaSearch extends PaginatedSearch implements IDogDnaSearch {
    dogId?: number;
    isag?: EIsagNorm;

    constructor(data?: IDogDnaSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.isag = _data["isag"];
        }
    }

    static fromJS(data: any): DogDnaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogDnaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["isag"] = this.isag;
        super.toJSON(data);
        return data;
    }
}

export interface IDogDnaSearch extends IPaginatedSearch {
    dogId?: number;
    isag?: EIsagNorm;
}

export class DnaMarkerResultDto implements IDnaMarkerResultDto {
    dnaMarkerResultId?: number;
    dnaMarkerId?: number;
    dogDnaResultId?: number;
    value1?: string | undefined;
    value2?: string | undefined;
    marker?: string | undefined;

    constructor(data?: IDnaMarkerResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dnaMarkerResultId = _data["dnaMarkerResultId"];
            this.dnaMarkerId = _data["dnaMarkerId"];
            this.dogDnaResultId = _data["dogDnaResultId"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.marker = _data["marker"];
        }
    }

    static fromJS(data: any): DnaMarkerResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DnaMarkerResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dnaMarkerResultId"] = this.dnaMarkerResultId;
        data["dnaMarkerId"] = this.dnaMarkerId;
        data["dogDnaResultId"] = this.dogDnaResultId;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["marker"] = this.marker;
        return data;
    }
}

export interface IDnaMarkerResultDto {
    dnaMarkerResultId?: number;
    dnaMarkerId?: number;
    dogDnaResultId?: number;
    value1?: string | undefined;
    value2?: string | undefined;
    marker?: string | undefined;
}

export class MarkerListDto implements IMarkerListDto {
    markers?: DnaMarkerResultDto[] | undefined;

    constructor(data?: IMarkerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["markers"])) {
                this.markers = [] as any;
                for (let item of _data["markers"])
                    this.markers!.push(DnaMarkerResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.markers)) {
            data["markers"] = [];
            for (let item of this.markers)
                data["markers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkerListDto {
    markers?: DnaMarkerResultDto[] | undefined;
}

export class DogDnaResultDto implements IDogDnaResultDto {
    dogDnaResultId?: number;
    resultIdentifier?: string | undefined;
    controlledFiliation?: boolean;
    correctFiliation?: boolean;
    labId?: number;
    dogId?: number;
    sharepointUri?: string | undefined;
    isag?: EIsagNorm;

    constructor(data?: IDogDnaResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDnaResultId = _data["dogDnaResultId"];
            this.resultIdentifier = _data["resultIdentifier"];
            this.controlledFiliation = _data["controlledFiliation"];
            this.correctFiliation = _data["correctFiliation"];
            this.labId = _data["labId"];
            this.dogId = _data["dogId"];
            this.sharepointUri = _data["sharepointUri"];
            this.isag = _data["isag"];
        }
    }

    static fromJS(data: any): DogDnaResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogDnaResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDnaResultId"] = this.dogDnaResultId;
        data["resultIdentifier"] = this.resultIdentifier;
        data["controlledFiliation"] = this.controlledFiliation;
        data["correctFiliation"] = this.correctFiliation;
        data["labId"] = this.labId;
        data["dogId"] = this.dogId;
        data["sharepointUri"] = this.sharepointUri;
        data["isag"] = this.isag;
        return data;
    }
}

export interface IDogDnaResultDto {
    dogDnaResultId?: number;
    resultIdentifier?: string | undefined;
    controlledFiliation?: boolean;
    correctFiliation?: boolean;
    labId?: number;
    dogId?: number;
    sharepointUri?: string | undefined;
    isag?: EIsagNorm;
}

export class PaginatedResultsOfDogDysplasiaGridDto implements IPaginatedResultsOfDogDysplasiaGridDto {
    totalCount?: number;
    results?: DogDysplasiaGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogDysplasiaGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogDysplasiaGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogDysplasiaGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogDysplasiaGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogDysplasiaGridDto {
    totalCount?: number;
    results?: DogDysplasiaGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogDysplasiaGridDto implements IDogDysplasiaGridDto {
    dogDysplasiaId?: number;
    dogId?: number;
    characteristicId?: number;
    characteristic?: string | undefined;
    characteristicValueId?: number | undefined;
    healthValue?: string | undefined;
    numericValue?: number | undefined;
    dysplasiaRequestId?: number;
    requestNumber?: string | undefined;
    createdOn?: Date;
    value?: string | undefined;

    constructor(data?: IDogDysplasiaGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDysplasiaId = _data["dogDysplasiaId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.characteristic = _data["characteristic"];
            this.characteristicValueId = _data["characteristicValueId"];
            this.healthValue = _data["healthValue"];
            this.numericValue = _data["numericValue"];
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.requestNumber = _data["requestNumber"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DogDysplasiaGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogDysplasiaGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDysplasiaId"] = this.dogDysplasiaId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["characteristic"] = this.characteristic;
        data["characteristicValueId"] = this.characteristicValueId;
        data["healthValue"] = this.healthValue;
        data["numericValue"] = this.numericValue;
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["requestNumber"] = this.requestNumber;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IDogDysplasiaGridDto {
    dogDysplasiaId?: number;
    dogId?: number;
    characteristicId?: number;
    characteristic?: string | undefined;
    characteristicValueId?: number | undefined;
    healthValue?: string | undefined;
    numericValue?: number | undefined;
    dysplasiaRequestId?: number;
    requestNumber?: string | undefined;
    createdOn?: Date;
    value?: string | undefined;
}

export class DogDysplasiaSearch extends PaginatedSearch implements IDogDysplasiaSearch {
    languageId?: number;
    dogId?: number;

    constructor(data?: IDogDysplasiaSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): DogDysplasiaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogDysplasiaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface IDogDysplasiaSearch extends IPaginatedSearch {
    languageId?: number;
    dogId?: number;
}

export class DogDysplasiaDto implements IDogDysplasiaDto {
    dogDysplasiaId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    value?: string | undefined;
    numericValue?: number | undefined;
    dysplasiaRequestId?: number | undefined;
    healthValueType?: EHealthValueType;
    dysplasiaType?: EDysplasiaType | undefined;
    isRight?: boolean | undefined;
    radioDate?: Date | undefined;
    evaluationDate?: Date | undefined;
    createdOn?: Date | undefined;

    constructor(data?: IDogDysplasiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDysplasiaId = _data["dogDysplasiaId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.value = _data["value"];
            this.numericValue = _data["numericValue"];
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.healthValueType = _data["healthValueType"];
            this.dysplasiaType = _data["dysplasiaType"];
            this.isRight = _data["isRight"];
            this.radioDate = _data["radioDate"] ? new Date(_data["radioDate"].toString()) : <any>undefined;
            this.evaluationDate = _data["evaluationDate"] ? new Date(_data["evaluationDate"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogDysplasiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogDysplasiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDysplasiaId"] = this.dogDysplasiaId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["value"] = this.value;
        data["numericValue"] = this.numericValue;
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["healthValueType"] = this.healthValueType;
        data["dysplasiaType"] = this.dysplasiaType;
        data["isRight"] = this.isRight;
        data["radioDate"] = this.radioDate ? this.radioDate.toISOString() : <any>undefined;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogDysplasiaDto {
    dogDysplasiaId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    value?: string | undefined;
    numericValue?: number | undefined;
    dysplasiaRequestId?: number | undefined;
    healthValueType?: EHealthValueType;
    dysplasiaType?: EDysplasiaType | undefined;
    isRight?: boolean | undefined;
    radioDate?: Date | undefined;
    evaluationDate?: Date | undefined;
    createdOn?: Date | undefined;
}

export class PaginatedResultsOfDogHealthTestGridDto implements IPaginatedResultsOfDogHealthTestGridDto {
    totalCount?: number;
    results?: DogHealthTestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogHealthTestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogHealthTestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogHealthTestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogHealthTestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogHealthTestGridDto {
    totalCount?: number;
    results?: DogHealthTestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogHealthTestGridDto implements IDogHealthTestGridDto {
    dogCharacteristicValueId?: number;
    characteristic?: string | undefined;
    characteristicType?: string | undefined;
    value?: string | undefined;
    numericValue?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date | undefined;
    createdOn?: Date;
    invalidatedOn?: Date | undefined;

    constructor(data?: IDogHealthTestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogCharacteristicValueId = _data["dogCharacteristicValueId"];
            this.characteristic = _data["characteristic"];
            this.characteristicType = _data["characteristicType"];
            this.value = _data["value"];
            this.numericValue = _data["numericValue"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.invalidatedOn = _data["invalidatedOn"] ? new Date(_data["invalidatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogHealthTestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthTestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogCharacteristicValueId"] = this.dogCharacteristicValueId;
        data["characteristic"] = this.characteristic;
        data["characteristicType"] = this.characteristicType;
        data["value"] = this.value;
        data["numericValue"] = this.numericValue;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["invalidatedOn"] = this.invalidatedOn ? this.invalidatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogHealthTestGridDto {
    dogCharacteristicValueId?: number;
    characteristic?: string | undefined;
    characteristicType?: string | undefined;
    value?: string | undefined;
    numericValue?: number | undefined;
    dateFrom?: Date;
    dateTo?: Date | undefined;
    createdOn?: Date;
    invalidatedOn?: Date | undefined;
}

export class DogHealthSearch extends PaginatedSearch implements IDogHealthSearch {
    dogId?: number;
    languageId?: number;
    characteristic?: TextSearch | undefined;
    value?: TextSearch | undefined;
    showInvalid?: boolean | undefined;

    constructor(data?: IDogHealthSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
            this.characteristic = _data["characteristic"] ? TextSearch.fromJS(_data["characteristic"]) : <any>undefined;
            this.value = _data["value"] ? TextSearch.fromJS(_data["value"]) : <any>undefined;
            this.showInvalid = _data["showInvalid"];
        }
    }

    static fromJS(data: any): DogHealthSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        data["characteristic"] = this.characteristic ? this.characteristic.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["showInvalid"] = this.showInvalid;
        super.toJSON(data);
        return data;
    }
}

export interface IDogHealthSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
    characteristic?: TextSearch | undefined;
    value?: TextSearch | undefined;
    showInvalid?: boolean | undefined;
}

export class SaveDogCharacteristicDto implements ISaveDogCharacteristicDto {
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    characteristicFile?: string | undefined;

    constructor(data?: ISaveDogCharacteristicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.alphaValue = _data["alphaValue"];
            this.characteristicFile = _data["characteristicFile"];
        }
    }

    static fromJS(data: any): SaveDogCharacteristicDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDogCharacteristicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["alphaValue"] = this.alphaValue;
        data["characteristicFile"] = this.characteristicFile;
        return data;
    }
}

export interface ISaveDogCharacteristicDto {
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    characteristicFile?: string | undefined;
}

export class PaginatedResultsOfDogHealthTestValidationGridDto implements IPaginatedResultsOfDogHealthTestValidationGridDto {
    totalCount?: number;
    results?: DogHealthTestValidationGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogHealthTestValidationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogHealthTestValidationGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogHealthTestValidationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogHealthTestValidationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogHealthTestValidationGridDto {
    totalCount?: number;
    results?: DogHealthTestValidationGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogHealthTestValidationGridDto implements IDogHealthTestValidationGridDto {
    dogHealthTestValidationId?: number;
    dogId?: number;
    dog?: string | undefined;
    sharepointUri?: string | undefined;
    closedOn?: Date;
    validated?: boolean;

    constructor(data?: IDogHealthTestValidationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogHealthTestValidationId = _data["dogHealthTestValidationId"];
            this.dogId = _data["dogId"];
            this.dog = _data["dog"];
            this.sharepointUri = _data["sharepointUri"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.validated = _data["validated"];
        }
    }

    static fromJS(data: any): DogHealthTestValidationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthTestValidationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogHealthTestValidationId"] = this.dogHealthTestValidationId;
        data["dogId"] = this.dogId;
        data["dog"] = this.dog;
        data["sharepointUri"] = this.sharepointUri;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["validated"] = this.validated;
        return data;
    }
}

export interface IDogHealthTestValidationGridDto {
    dogHealthTestValidationId?: number;
    dogId?: number;
    dog?: string | undefined;
    sharepointUri?: string | undefined;
    closedOn?: Date;
    validated?: boolean;
}

export class DogHealthTestValidationSearch extends PaginatedSearch implements IDogHealthTestValidationSearch {
    searchValidated?: boolean;
    searchUnassigned?: boolean;

    constructor(data?: IDogHealthTestValidationSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchValidated = _data["searchValidated"];
            this.searchUnassigned = _data["searchUnassigned"];
        }
    }

    static fromJS(data: any): DogHealthTestValidationSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogHealthTestValidationSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchValidated"] = this.searchValidated;
        data["searchUnassigned"] = this.searchUnassigned;
        super.toJSON(data);
        return data;
    }
}

export interface IDogHealthTestValidationSearch extends IPaginatedSearch {
    searchValidated?: boolean;
    searchUnassigned?: boolean;
}

export class PaginatedResultsOfDogHistoryActionGridDto implements IPaginatedResultsOfDogHistoryActionGridDto {
    totalCount?: number;
    results?: DogHistoryActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogHistoryActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogHistoryActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogHistoryActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogHistoryActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogHistoryActionGridDto {
    totalCount?: number;
    results?: DogHistoryActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogHistoryActionGridDto implements IDogHistoryActionGridDto {
    actionTime?: Date;
    action?: string | undefined;

    constructor(data?: IDogHistoryActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): DogHistoryActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogHistoryActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface IDogHistoryActionGridDto {
    actionTime?: Date;
    action?: string | undefined;
}

export class PaginatedResultsOfRequestGridDto implements IPaginatedResultsOfRequestGridDto {
    totalCount?: number;
    results?: RequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfRequestGridDto {
    totalCount?: number;
    results?: RequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class RequestGridDto implements IRequestGridDto {
    requestId?: number;
    requestTypeId?: number;
    requestType?: string | undefined;
    requestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequest?: string | undefined;
    parentRequestTypeCode?: ERequestType | undefined;
    requestDate?: Date;
    requestStateId?: number;
    requestState?: string | undefined;
    requestStateCode?: ERequestState;
    requestTypeCode?: ERequestType;
    contact?: string | undefined;
    personId?: number | undefined;
    subRequestId?: number | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestType = _data["requestType"];
            this.requestNumber = _data["requestNumber"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequest = _data["parentRequest"];
            this.parentRequestTypeCode = _data["parentRequestTypeCode"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.contact = _data["contact"];
            this.personId = _data["personId"];
            this.subRequestId = _data["subRequestId"];
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): RequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestType"] = this.requestType;
        data["requestNumber"] = this.requestNumber;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequest"] = this.parentRequest;
        data["parentRequestTypeCode"] = this.parentRequestTypeCode;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["requestStateCode"] = this.requestStateCode;
        data["requestTypeCode"] = this.requestTypeCode;
        data["contact"] = this.contact;
        data["personId"] = this.personId;
        data["subRequestId"] = this.subRequestId;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IRequestGridDto {
    requestId?: number;
    requestTypeId?: number;
    requestType?: string | undefined;
    requestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequest?: string | undefined;
    parentRequestTypeCode?: ERequestType | undefined;
    requestDate?: Date;
    requestStateId?: number;
    requestState?: string | undefined;
    requestStateCode?: ERequestState;
    requestTypeCode?: ERequestType;
    contact?: string | undefined;
    personId?: number | undefined;
    subRequestId?: number | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class PaginatedResultsOfDogOwnerGridDto implements IPaginatedResultsOfDogOwnerGridDto {
    totalCount?: number;
    results?: DogOwnerGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogOwnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogOwnerGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogOwnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogOwnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogOwnerGridDto {
    totalCount?: number;
    results?: DogOwnerGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogOwnerGridDto implements IDogOwnerGridDto {
    dogOwnershipId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    isTemporaryOwner?: boolean;

    constructor(data?: IDogOwnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipId = _data["dogOwnershipId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.computedName = _data["computedName"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.isTemporaryOwner = _data["isTemporaryOwner"];
        }
    }

    static fromJS(data: any): DogOwnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipId"] = this.dogOwnershipId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["computedName"] = this.computedName;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["isTemporaryOwner"] = this.isTemporaryOwner;
        return data;
    }
}

export interface IDogOwnerGridDto {
    dogOwnershipId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    computedName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    isTemporaryOwner?: boolean;
}

export class SaveNewOwnerDto implements ISaveNewOwnerDto {
    dogOwnershipId?: number;
    personName?: string | undefined;
    dogId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;

    constructor(data?: ISaveNewOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipId = _data["dogOwnershipId"];
            this.personName = _data["personName"];
            this.dogId = _data["dogId"];
            this.personId = _data["personId"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveNewOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNewOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipId"] = this.dogOwnershipId;
        data["personName"] = this.personName;
        data["dogId"] = this.dogId;
        data["personId"] = this.personId;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveNewOwnerDto {
    dogOwnershipId?: number;
    personName?: string | undefined;
    dogId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
}

export class PaginatedResultsOfDogOwnershipChangeGridDto implements IPaginatedResultsOfDogOwnershipChangeGridDto {
    totalCount?: number;
    results?: DogOwnershipChangeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogOwnershipChangeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogOwnershipChangeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogOwnershipChangeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogOwnershipChangeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogOwnershipChangeGridDto {
    totalCount?: number;
    results?: DogOwnershipChangeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogOwnershipChangeGridDto implements IDogOwnershipChangeGridDto {
    dogOwnershipChangeRequestId?: number;
    requestId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    requestStateId?: number;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    kennelName?: string | undefined;
    export?: boolean;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IDogOwnershipChangeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipChangeRequestId = _data["dogOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestStateCode = _data["requestStateCode"];
            this.requestState = _data["requestState"];
            this.requestStateId = _data["requestStateId"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.kennelName = _data["kennelName"];
            this.export = _data["export"];
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): DogOwnershipChangeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnershipChangeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipChangeRequestId"] = this.dogOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestStateCode"] = this.requestStateCode;
        data["requestState"] = this.requestState;
        data["requestStateId"] = this.requestStateId;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["kennelName"] = this.kennelName;
        data["export"] = this.export;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IDogOwnershipChangeGridDto {
    dogOwnershipChangeRequestId?: number;
    requestId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    requestStateId?: number;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    kennelName?: string | undefined;
    export?: boolean;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class DogOwnershipChangeSearch extends PaginatedSearch implements IDogOwnershipChangeSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    contact?: TextSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    export?: BooleanSearch | undefined;
    isBlocked?: BooleanSearch | undefined;

    constructor(data?: IDogOwnershipChangeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.export = _data["export"] ? BooleanSearch.fromJS(_data["export"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DogOwnershipChangeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnershipChangeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["export"] = this.export ? this.export.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDogOwnershipChangeSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    contact?: TextSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    export?: BooleanSearch | undefined;
    isBlocked?: BooleanSearch | undefined;
}

export class DogOwnershipChangeRequestDto implements IDogOwnershipChangeRequestDto {
    dogOwnershipChangeRequestId?: number;
    requestId?: number;
    dogId?: number;
    export?: boolean;
    platform?: EPlatform;
    dogSharepointUri?: string | undefined;
    isRegisteredLetter?: boolean;
    ownerIds?: number[] | undefined;
    request?: RequestDto | undefined;

    constructor(data?: IDogOwnershipChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipChangeRequestId = _data["dogOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.export = _data["export"];
            this.platform = _data["platform"];
            this.dogSharepointUri = _data["dogSharepointUri"];
            this.isRegisteredLetter = _data["isRegisteredLetter"];
            if (Array.isArray(_data["ownerIds"])) {
                this.ownerIds = [] as any;
                for (let item of _data["ownerIds"])
                    this.ownerIds!.push(item);
            }
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DogOwnershipChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogOwnershipChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipChangeRequestId"] = this.dogOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["export"] = this.export;
        data["platform"] = this.platform;
        data["dogSharepointUri"] = this.dogSharepointUri;
        data["isRegisteredLetter"] = this.isRegisteredLetter;
        if (Array.isArray(this.ownerIds)) {
            data["ownerIds"] = [];
            for (let item of this.ownerIds)
                data["ownerIds"].push(item);
        }
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDogOwnershipChangeRequestDto {
    dogOwnershipChangeRequestId?: number;
    requestId?: number;
    dogId?: number;
    export?: boolean;
    platform?: EPlatform;
    dogSharepointUri?: string | undefined;
    isRegisteredLetter?: boolean;
    ownerIds?: number[] | undefined;
    request?: RequestDto | undefined;
}

export class PaginatedResultsOfDogPedigreeGridDto implements IPaginatedResultsOfDogPedigreeGridDto {
    totalCount?: number;
    results?: DogPedigreeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogPedigreeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogPedigreeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogPedigreeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogPedigreeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogPedigreeGridDto {
    totalCount?: number;
    results?: DogPedigreeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogPedigreeGridDto implements IDogPedigreeGridDto {
    pedigreeId?: number;
    dogId?: number;
    no?: number;
    prefix?: string | undefined;
    identifier?: string | undefined;
    country?: string | undefined;
    countryId?: number;
    isBelgian?: boolean;
    attributionDate?: Date | undefined;

    constructor(data?: IDogPedigreeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeId = _data["pedigreeId"];
            this.dogId = _data["dogId"];
            this.no = _data["no"];
            this.prefix = _data["prefix"];
            this.identifier = _data["identifier"];
            this.country = _data["country"];
            this.countryId = _data["countryId"];
            this.isBelgian = _data["isBelgian"];
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DogPedigreeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogPedigreeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeId"] = this.pedigreeId;
        data["dogId"] = this.dogId;
        data["no"] = this.no;
        data["prefix"] = this.prefix;
        data["identifier"] = this.identifier;
        data["country"] = this.country;
        data["countryId"] = this.countryId;
        data["isBelgian"] = this.isBelgian;
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDogPedigreeGridDto {
    pedigreeId?: number;
    dogId?: number;
    no?: number;
    prefix?: string | undefined;
    identifier?: string | undefined;
    country?: string | undefined;
    countryId?: number;
    isBelgian?: boolean;
    attributionDate?: Date | undefined;
}

export class DogPedigreeSearch extends PaginatedSearch implements IDogPedigreeSearch {
    dogId?: number;
    languageId?: number;

    constructor(data?: IDogPedigreeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): DogPedigreeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogPedigreeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IDogPedigreeSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
}

export class SaveNewPedigreeDto implements ISaveNewPedigreeDto {
    pedigreeId?: number;
    countryPedigreePrefixId?: number;
    countryId?: number;
    dogId?: number;
    identifier?: string | undefined;
    attributionDate?: Date | undefined;

    constructor(data?: ISaveNewPedigreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeId = _data["pedigreeId"];
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.countryId = _data["countryId"];
            this.dogId = _data["dogId"];
            this.identifier = _data["identifier"];
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveNewPedigreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNewPedigreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeId"] = this.pedigreeId;
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["countryId"] = this.countryId;
        data["dogId"] = this.dogId;
        data["identifier"] = this.identifier;
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveNewPedigreeDto {
    pedigreeId?: number;
    countryPedigreePrefixId?: number;
    countryId?: number;
    dogId?: number;
    identifier?: string | undefined;
    attributionDate?: Date | undefined;
}

export class PaginatedResultsOfDogPersonRelatedGridDto implements IPaginatedResultsOfDogPersonRelatedGridDto {
    totalCount?: number;
    results?: DogPersonRelatedGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogPersonRelatedGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogPersonRelatedGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogPersonRelatedGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogPersonRelatedGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogPersonRelatedGridDto {
    totalCount?: number;
    results?: DogPersonRelatedGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogPersonRelatedGridDto implements IDogPersonRelatedGridDto {
    dogOwnershipId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;

    constructor(data?: IDogPersonRelatedGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogOwnershipId = _data["dogOwnershipId"];
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): DogPersonRelatedGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogPersonRelatedGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogOwnershipId"] = this.dogOwnershipId;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface IDogPersonRelatedGridDto {
    dogOwnershipId?: number;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export class DogPersonRelatedSearch extends PaginatedSearch implements IDogPersonRelatedSearch {
    dogId?: number;
    languageId?: number;
    isOwner?: boolean;

    constructor(data?: IDogPersonRelatedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any): DogPersonRelatedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogPersonRelatedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        data["isOwner"] = this.isOwner;
        super.toJSON(data);
        return data;
    }
}

export interface IDogPersonRelatedSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
    isOwner?: boolean;
}

export class PaginatedResultsOfDogCompetitionResultGridDto implements IPaginatedResultsOfDogCompetitionResultGridDto {
    totalCount?: number;
    results?: DogCompetitionResultGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogCompetitionResultGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogCompetitionResultGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogCompetitionResultGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogCompetitionResultGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogCompetitionResultGridDto {
    totalCount?: number;
    results?: DogCompetitionResultGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogCompetitionResultGridDto implements IDogCompetitionResultGridDto {
    competitionResultId?: number;
    isLinkedToTitle?: boolean;
    judge?: string | undefined;
    titleId?: number | undefined;
    competition?: string | undefined;
    dogId?: number;
    result?: number;
    showClass?: string;
    qualification?: string | undefined;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    expo?: string | undefined;
    dateFrom?: Date | undefined;
    catalogNumber?: number | undefined;

    constructor(data?: IDogCompetitionResultGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionResultId = _data["competitionResultId"];
            this.isLinkedToTitle = _data["isLinkedToTitle"];
            this.judge = _data["judge"];
            this.titleId = _data["titleId"];
            this.competition = _data["competition"];
            this.dogId = _data["dogId"];
            this.result = _data["result"];
            this.showClass = _data["showClass"];
            this.qualification = _data["qualification"];
            this.cac = _data["cac"];
            this.cacReserve = _data["cacReserve"];
            this.cacib = _data["cacib"];
            this.cacibReserve = _data["cacibReserve"];
            this.expo = _data["expo"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.catalogNumber = _data["catalogNumber"];
        }
    }

    static fromJS(data: any): DogCompetitionResultGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogCompetitionResultGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionResultId"] = this.competitionResultId;
        data["isLinkedToTitle"] = this.isLinkedToTitle;
        data["judge"] = this.judge;
        data["titleId"] = this.titleId;
        data["competition"] = this.competition;
        data["dogId"] = this.dogId;
        data["result"] = this.result;
        data["showClass"] = this.showClass;
        data["qualification"] = this.qualification;
        data["cac"] = this.cac;
        data["cacReserve"] = this.cacReserve;
        data["cacib"] = this.cacib;
        data["cacibReserve"] = this.cacibReserve;
        data["expo"] = this.expo;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["catalogNumber"] = this.catalogNumber;
        return data;
    }
}

export interface IDogCompetitionResultGridDto {
    competitionResultId?: number;
    isLinkedToTitle?: boolean;
    judge?: string | undefined;
    titleId?: number | undefined;
    competition?: string | undefined;
    dogId?: number;
    result?: number;
    showClass?: string;
    qualification?: string | undefined;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    expo?: string | undefined;
    dateFrom?: Date | undefined;
    catalogNumber?: number | undefined;
}

export class DogCompetitionResultSearch extends PaginatedSearch implements IDogCompetitionResultSearch {
    dogId?: number;
    isLinkedToTitle?: BooleanSearch | undefined;
    competition?: TextSearch | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IDogCompetitionResultSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.isLinkedToTitle = _data["isLinkedToTitle"] ? BooleanSearch.fromJS(_data["isLinkedToTitle"]) : <any>undefined;
            this.competition = _data["competition"] ? TextSearch.fromJS(_data["competition"]) : <any>undefined;
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): DogCompetitionResultSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogCompetitionResultSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["isLinkedToTitle"] = this.isLinkedToTitle ? this.isLinkedToTitle.toJSON() : <any>undefined;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IDogCompetitionResultSearch extends IPaginatedSearch {
    dogId?: number;
    isLinkedToTitle?: BooleanSearch | undefined;
    competition?: TextSearch | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class SaveNewResultDto implements ISaveNewResultDto {
    competitionResultId?: number;
    competitionId?: number | undefined;
    qualificationId?: number;
    judgeId?: number | undefined;
    dogId?: number;
    comment?: string | undefined;
    result?: number;
    catalogNumber?: number | undefined;
    showClass?: string;
    standardConformed?: boolean;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;

    constructor(data?: ISaveNewResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionResultId = _data["competitionResultId"];
            this.competitionId = _data["competitionId"];
            this.qualificationId = _data["qualificationId"];
            this.judgeId = _data["judgeId"];
            this.dogId = _data["dogId"];
            this.comment = _data["comment"];
            this.result = _data["result"];
            this.catalogNumber = _data["catalogNumber"];
            this.showClass = _data["showClass"];
            this.standardConformed = _data["standardConformed"];
            this.bestOfBreed = _data["bestOfBreed"];
            this.bestOfSex = _data["bestOfSex"];
            this.bestInShow = _data["bestInShow"];
            this.bestInGroup = _data["bestInGroup"];
            this.bestVeteran = _data["bestVeteran"];
            this.bestWorkDog = _data["bestWorkDog"];
            this.bestYouth = _data["bestYouth"];
            this.bestMinorPuppy = _data["bestMinorPuppy"];
            this.bestPuppy = _data["bestPuppy"];
            this.belgianWinner = _data["belgianWinner"];
            this.beneluxWinner = _data["beneluxWinner"];
            this.beneluxYouthWinner = _data["beneluxYouthWinner"];
            this.beneluxVeteranWinner = _data["beneluxVeteranWinner"];
            this.europeanWinner = _data["europeanWinner"];
            this.crufts = _data["crufts"];
            this.cac = _data["cac"];
            this.cacReserve = _data["cacReserve"];
            this.cacib = _data["cacib"];
            this.cacibReserve = _data["cacibReserve"];
            this.cacbl = _data["cacbl"];
            this.cacblReserve = _data["cacblReserve"];
            this.cacgpo = _data["cacgpo"];
            this.cacgpoReserve = _data["cacgpoReserve"];
            this.caciag = _data["caciag"];
            this.caciagReserve = _data["caciagReserve"];
            this.cacil = _data["cacil"];
            this.cacilReserve = _data["cacilReserve"];
            this.caciob = _data["caciob"];
            this.caciobReserve = _data["caciobReserve"];
            this.cacit = _data["cacit"];
            this.cacitReserve = _data["cacitReserve"];
        }
    }

    static fromJS(data: any): SaveNewResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNewResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionResultId"] = this.competitionResultId;
        data["competitionId"] = this.competitionId;
        data["qualificationId"] = this.qualificationId;
        data["judgeId"] = this.judgeId;
        data["dogId"] = this.dogId;
        data["comment"] = this.comment;
        data["result"] = this.result;
        data["catalogNumber"] = this.catalogNumber;
        data["showClass"] = this.showClass;
        data["standardConformed"] = this.standardConformed;
        data["bestOfBreed"] = this.bestOfBreed;
        data["bestOfSex"] = this.bestOfSex;
        data["bestInShow"] = this.bestInShow;
        data["bestInGroup"] = this.bestInGroup;
        data["bestVeteran"] = this.bestVeteran;
        data["bestWorkDog"] = this.bestWorkDog;
        data["bestYouth"] = this.bestYouth;
        data["bestMinorPuppy"] = this.bestMinorPuppy;
        data["bestPuppy"] = this.bestPuppy;
        data["belgianWinner"] = this.belgianWinner;
        data["beneluxWinner"] = this.beneluxWinner;
        data["beneluxYouthWinner"] = this.beneluxYouthWinner;
        data["beneluxVeteranWinner"] = this.beneluxVeteranWinner;
        data["europeanWinner"] = this.europeanWinner;
        data["crufts"] = this.crufts;
        data["cac"] = this.cac;
        data["cacReserve"] = this.cacReserve;
        data["cacib"] = this.cacib;
        data["cacibReserve"] = this.cacibReserve;
        data["cacbl"] = this.cacbl;
        data["cacblReserve"] = this.cacblReserve;
        data["cacgpo"] = this.cacgpo;
        data["cacgpoReserve"] = this.cacgpoReserve;
        data["caciag"] = this.caciag;
        data["caciagReserve"] = this.caciagReserve;
        data["cacil"] = this.cacil;
        data["cacilReserve"] = this.cacilReserve;
        data["caciob"] = this.caciob;
        data["caciobReserve"] = this.caciobReserve;
        data["cacit"] = this.cacit;
        data["cacitReserve"] = this.cacitReserve;
        return data;
    }
}

export interface ISaveNewResultDto {
    competitionResultId?: number;
    competitionId?: number | undefined;
    qualificationId?: number;
    judgeId?: number | undefined;
    dogId?: number;
    comment?: string | undefined;
    result?: number;
    catalogNumber?: number | undefined;
    showClass?: string;
    standardConformed?: boolean;
    bestOfBreed?: boolean;
    bestOfSex?: boolean;
    bestInShow?: boolean;
    bestInGroup?: boolean;
    bestVeteran?: boolean;
    bestWorkDog?: boolean;
    bestYouth?: boolean;
    bestMinorPuppy?: boolean;
    bestPuppy?: boolean;
    belgianWinner?: boolean;
    beneluxWinner?: boolean;
    beneluxYouthWinner?: boolean;
    beneluxVeteranWinner?: boolean;
    europeanWinner?: boolean;
    crufts?: boolean;
    cac?: boolean;
    cacReserve?: boolean;
    cacib?: boolean;
    cacibReserve?: boolean;
    cacbl?: boolean;
    cacblReserve?: boolean;
    cacgpo?: boolean;
    cacgpoReserve?: boolean;
    caciag?: boolean;
    caciagReserve?: boolean;
    cacil?: boolean;
    cacilReserve?: boolean;
    caciob?: boolean;
    caciobReserve?: boolean;
    cacit?: boolean;
    cacitReserve?: boolean;
}

export class PaginatedResultsOfDogsBreederGridDto implements IPaginatedResultsOfDogsBreederGridDto {
    totalCount?: number;
    results?: DogsBreederGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogsBreederGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogsBreederGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogsBreederGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogsBreederGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogsBreederGridDto {
    totalCount?: number;
    results?: DogsBreederGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogsBreederGridDto implements IDogsBreederGridDto {
    dogsBreederId?: number;
    personName?: string | undefined;
    personId?: number;
    dogName?: string | undefined;
    dogId?: number;

    constructor(data?: IDogsBreederGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogsBreederId = _data["dogsBreederId"];
            this.personName = _data["personName"];
            this.personId = _data["personId"];
            this.dogName = _data["dogName"];
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): DogsBreederGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogsBreederGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogsBreederId"] = this.dogsBreederId;
        data["personName"] = this.personName;
        data["personId"] = this.personId;
        data["dogName"] = this.dogName;
        data["dogId"] = this.dogId;
        return data;
    }
}

export interface IDogsBreederGridDto {
    dogsBreederId?: number;
    personName?: string | undefined;
    personId?: number;
    dogName?: string | undefined;
    dogId?: number;
}

export class DogsBreederSearch extends PaginatedSearch implements IDogsBreederSearch {
    personId?: number | undefined;
    dogId?: number | undefined;

    constructor(data?: IDogsBreederSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): DogsBreederSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogsBreederSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface IDogsBreederSearch extends IPaginatedSearch {
    personId?: number | undefined;
    dogId?: number | undefined;
}

export class DogBreederSaveDto implements IDogBreederSaveDto {
    dogsBreederId?: number;
    personId?: number;
    dogId?: number;

    constructor(data?: IDogBreederSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogsBreederId = _data["dogsBreederId"];
            this.personId = _data["personId"];
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): DogBreederSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogBreederSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogsBreederId"] = this.dogsBreederId;
        data["personId"] = this.personId;
        data["dogId"] = this.dogId;
        return data;
    }
}

export interface IDogBreederSaveDto {
    dogsBreederId?: number;
    personId?: number;
    dogId?: number;
}

export class AvailablePeopleSearch extends PaginatedSearch implements IAvailablePeopleSearch {
    dogId?: number;

    constructor(data?: IAvailablePeopleSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): AvailablePeopleSearch {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePeopleSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailablePeopleSearch extends IPaginatedSearch {
    dogId?: number;
}

export class PaginatedResultsOfTransientCharacteristicGridDto implements IPaginatedResultsOfTransientCharacteristicGridDto {
    totalCount?: number;
    results?: TransientCharacteristicGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTransientCharacteristicGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransientCharacteristicGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTransientCharacteristicGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTransientCharacteristicGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTransientCharacteristicGridDto {
    totalCount?: number;
    results?: TransientCharacteristicGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TransientCharacteristicGridDto implements ITransientCharacteristicGridDto {
    dogsCharacteristicsValuesTransientId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number;
    closedOn?: Date | undefined;
    dog?: string | undefined;
    characteristic?: string | undefined;
    characteristicType?: string | undefined;
    healthValue?: string | undefined;
    sharepointUri?: string | undefined;

    constructor(data?: ITransientCharacteristicGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogsCharacteristicsValuesTransientId = _data["dogsCharacteristicsValuesTransientId"];
            this.dogId = _data["dogId"];
            this.characteristicId = _data["characteristicId"];
            this.healthValueId = _data["healthValueId"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.dog = _data["dog"];
            this.characteristic = _data["characteristic"];
            this.characteristicType = _data["characteristicType"];
            this.healthValue = _data["healthValue"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): TransientCharacteristicGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransientCharacteristicGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogsCharacteristicsValuesTransientId"] = this.dogsCharacteristicsValuesTransientId;
        data["dogId"] = this.dogId;
        data["characteristicId"] = this.characteristicId;
        data["healthValueId"] = this.healthValueId;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["dog"] = this.dog;
        data["characteristic"] = this.characteristic;
        data["characteristicType"] = this.characteristicType;
        data["healthValue"] = this.healthValue;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface ITransientCharacteristicGridDto {
    dogsCharacteristicsValuesTransientId?: number;
    dogId?: number;
    characteristicId?: number;
    healthValueId?: number;
    closedOn?: Date | undefined;
    dog?: string | undefined;
    characteristic?: string | undefined;
    characteristicType?: string | undefined;
    healthValue?: string | undefined;
    sharepointUri?: string | undefined;
}

export class TransientCharacteristicsSearch extends PaginatedSearch implements ITransientCharacteristicsSearch {
    languageId?: number;
    dogId?: number | undefined;
    searchUnassignedCharacteristics?: boolean;
    hideClosed?: boolean;

    constructor(data?: ITransientCharacteristicsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.dogId = _data["dogId"];
            this.searchUnassignedCharacteristics = _data["searchUnassignedCharacteristics"];
            this.hideClosed = _data["hideClosed"];
        }
    }

    static fromJS(data: any): TransientCharacteristicsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TransientCharacteristicsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["dogId"] = this.dogId;
        data["searchUnassignedCharacteristics"] = this.searchUnassignedCharacteristics;
        data["hideClosed"] = this.hideClosed;
        super.toJSON(data);
        return data;
    }
}

export interface ITransientCharacteristicsSearch extends IPaginatedSearch {
    languageId?: number;
    dogId?: number | undefined;
    searchUnassignedCharacteristics?: boolean;
    hideClosed?: boolean;
}

export class TransientCharacteristicByDogSearch extends PaginatedSearch implements ITransientCharacteristicByDogSearch {
    dogId?: number;
    languageId?: number;

    constructor(data?: ITransientCharacteristicByDogSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): TransientCharacteristicByDogSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TransientCharacteristicByDogSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ITransientCharacteristicByDogSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
}

export class PaginatedResultsOfDogTitlesGridDto implements IPaginatedResultsOfDogTitlesGridDto {
    totalCount?: number;
    results?: DogTitlesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogTitlesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogTitlesGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogTitlesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogTitlesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogTitlesGridDto {
    totalCount?: number;
    results?: DogTitlesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogTitlesGridDto implements IDogTitlesGridDto {
    dogTitleId?: number;
    titleId?: number;
    titleName?: string | undefined;
    titleType?: string | undefined;
    titleTypeId?: number;
    country?: string | undefined;
    year?: number | undefined;
    abreviation?: string | undefined;
    createdOn?: Date;
    competitionResults?: DogCompetitionResultGridDto[] | undefined;

    constructor(data?: IDogTitlesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTitleId = _data["dogTitleId"];
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.titleType = _data["titleType"];
            this.titleTypeId = _data["titleTypeId"];
            this.country = _data["country"];
            this.year = _data["year"];
            this.abreviation = _data["abreviation"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["competitionResults"])) {
                this.competitionResults = [] as any;
                for (let item of _data["competitionResults"])
                    this.competitionResults!.push(DogCompetitionResultGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DogTitlesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogTitlesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTitleId"] = this.dogTitleId;
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["titleType"] = this.titleType;
        data["titleTypeId"] = this.titleTypeId;
        data["country"] = this.country;
        data["year"] = this.year;
        data["abreviation"] = this.abreviation;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.competitionResults)) {
            data["competitionResults"] = [];
            for (let item of this.competitionResults)
                data["competitionResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDogTitlesGridDto {
    dogTitleId?: number;
    titleId?: number;
    titleName?: string | undefined;
    titleType?: string | undefined;
    titleTypeId?: number;
    country?: string | undefined;
    year?: number | undefined;
    abreviation?: string | undefined;
    createdOn?: Date;
    competitionResults?: DogCompetitionResultGridDto[] | undefined;
}

export class DogTitleSearch extends PaginatedSearch implements IDogTitleSearch {
    languageId?: number;
    dogId?: number;
    titleType?: TextSearch | undefined;
    year?: NumericSearch | undefined;

    constructor(data?: IDogTitleSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.dogId = _data["dogId"];
            this.titleType = _data["titleType"] ? TextSearch.fromJS(_data["titleType"]) : <any>undefined;
            this.year = _data["year"] ? NumericSearch.fromJS(_data["year"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DogTitleSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogTitleSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["dogId"] = this.dogId;
        data["titleType"] = this.titleType ? this.titleType.toJSON() : <any>undefined;
        data["year"] = this.year ? this.year.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDogTitleSearch extends IPaginatedSearch {
    languageId?: number;
    dogId?: number;
    titleType?: TextSearch | undefined;
    year?: NumericSearch | undefined;
}

export class As400TitleDto implements IAs400TitleDto {
    dogId?: number;
    as400Titles?: string | undefined;

    constructor(data?: IAs400TitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.as400Titles = _data["as400Titles"];
        }
    }

    static fromJS(data: any): As400TitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new As400TitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["as400Titles"] = this.as400Titles;
        return data;
    }
}

export interface IAs400TitleDto {
    dogId?: number;
    as400Titles?: string | undefined;
}

export class SaveNewDogTitleDto implements ISaveNewDogTitleDto {
    dogTitleId?: number;
    dogId?: number;
    titleId?: number;
    year?: number | undefined;
    resultIds?: number[] | undefined;

    constructor(data?: ISaveNewDogTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTitleId = _data["dogTitleId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.year = _data["year"];
            if (Array.isArray(_data["resultIds"])) {
                this.resultIds = [] as any;
                for (let item of _data["resultIds"])
                    this.resultIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveNewDogTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNewDogTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTitleId"] = this.dogTitleId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["year"] = this.year;
        if (Array.isArray(this.resultIds)) {
            data["resultIds"] = [];
            for (let item of this.resultIds)
                data["resultIds"].push(item);
        }
        return data;
    }
}

export interface ISaveNewDogTitleDto {
    dogTitleId?: number;
    dogId?: number;
    titleId?: number;
    year?: number | undefined;
    resultIds?: number[] | undefined;
}

export class PaginatedResultsOfTransientOwnerGridDto implements IPaginatedResultsOfTransientOwnerGridDto {
    totalCount?: number;
    results?: TransientOwnerGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTransientOwnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransientOwnerGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTransientOwnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTransientOwnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTransientOwnerGridDto {
    totalCount?: number;
    results?: TransientOwnerGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TransientOwnerGridDto implements ITransientOwnerGridDto {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ITransientOwnerGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): TransientOwnerGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransientOwnerGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ITransientOwnerGridDto {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class TransientOwnerSearch extends PaginatedSearch implements ITransientOwnerSearch {
    dogId?: number;
    languageId?: number;
    dogOwnershipChangeRequestId?: number;

    constructor(data?: ITransientOwnerSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
            this.dogOwnershipChangeRequestId = _data["dogOwnershipChangeRequestId"];
        }
    }

    static fromJS(data: any): TransientOwnerSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TransientOwnerSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        data["dogOwnershipChangeRequestId"] = this.dogOwnershipChangeRequestId;
        super.toJSON(data);
        return data;
    }
}

export interface ITransientOwnerSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
    dogOwnershipChangeRequestId?: number;
}

export class PaginatedResultsOfWorkbookGridDto implements IPaginatedResultsOfWorkbookGridDto {
    totalCount?: number;
    results?: WorkbookGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfWorkbookGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WorkbookGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfWorkbookGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfWorkbookGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfWorkbookGridDto {
    totalCount?: number;
    results?: WorkbookGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class WorkbookGridDto implements IWorkbookGridDto {
    workbookId?: number;
    workbookType?: string | undefined;
    workbookTypeId?: number;
    identifier?: number;
    counter?: number;
    withPedigree?: boolean;
    deliveredOn?: Date;

    constructor(data?: IWorkbookGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookId = _data["workbookId"];
            this.workbookType = _data["workbookType"];
            this.workbookTypeId = _data["workbookTypeId"];
            this.identifier = _data["identifier"];
            this.counter = _data["counter"];
            this.withPedigree = _data["withPedigree"];
            this.deliveredOn = _data["deliveredOn"] ? new Date(_data["deliveredOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkbookGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookId"] = this.workbookId;
        data["workbookType"] = this.workbookType;
        data["workbookTypeId"] = this.workbookTypeId;
        data["identifier"] = this.identifier;
        data["counter"] = this.counter;
        data["withPedigree"] = this.withPedigree;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWorkbookGridDto {
    workbookId?: number;
    workbookType?: string | undefined;
    workbookTypeId?: number;
    identifier?: number;
    counter?: number;
    withPedigree?: boolean;
    deliveredOn?: Date;
}

export class DogWorkbookSearch extends PaginatedSearch implements IDogWorkbookSearch {
    languageId?: number;
    dogId?: number;

    constructor(data?: IDogWorkbookSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): DogWorkbookSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogWorkbookSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface IDogWorkbookSearch extends IPaginatedSearch {
    languageId?: number;
    dogId?: number;
}

export class SaveNewWorkbookDto implements ISaveNewWorkbookDto {
    workbookTypeId?: number;
    dogId?: number;
    identifier?: number;
    counter?: number;
    deliveredOn?: Date;

    constructor(data?: ISaveNewWorkbookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeId = _data["workbookTypeId"];
            this.dogId = _data["dogId"];
            this.identifier = _data["identifier"];
            this.counter = _data["counter"];
            this.deliveredOn = _data["deliveredOn"] ? new Date(_data["deliveredOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveNewWorkbookDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNewWorkbookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeId"] = this.workbookTypeId;
        data["dogId"] = this.dogId;
        data["identifier"] = this.identifier;
        data["counter"] = this.counter;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveNewWorkbookDto {
    workbookTypeId?: number;
    dogId?: number;
    identifier?: number;
    counter?: number;
    deliveredOn?: Date;
}

export class NewWorkbookInformationDto implements INewWorkbookInformationDto {
    identifier?: number;
    counter?: number;

    constructor(data?: INewWorkbookInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.counter = _data["counter"];
        }
    }

    static fromJS(data: any): NewWorkbookInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewWorkbookInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["counter"] = this.counter;
        return data;
    }
}

export interface INewWorkbookInformationDto {
    identifier?: number;
    counter?: number;
}

export class PaginatedResultsOfDysplasiaGridDto implements IPaginatedResultsOfDysplasiaGridDto {
    totalCount?: number;
    results?: DysplasiaGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDysplasiaGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DysplasiaGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDysplasiaGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDysplasiaGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDysplasiaGridDto {
    totalCount?: number;
    results?: DysplasiaGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DysplasiaGridDto implements IDysplasiaGridDto {
    dysplasiaRequestId?: number;
    requestDate?: Date;
    requestNumber?: string | undefined;
    birthDate?: Date;
    breed?: string | undefined;
    breedId?: number;
    dysplasiaTypeIdsChecked?: number[] | undefined;
    reEvaluation?: boolean;

    constructor(data?: IDysplasiaGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestNumber = _data["requestNumber"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.breed = _data["breed"];
            this.breedId = _data["breedId"];
            if (Array.isArray(_data["dysplasiaTypeIdsChecked"])) {
                this.dysplasiaTypeIdsChecked = [] as any;
                for (let item of _data["dysplasiaTypeIdsChecked"])
                    this.dysplasiaTypeIdsChecked!.push(item);
            }
            this.reEvaluation = _data["reEvaluation"];
        }
    }

    static fromJS(data: any): DysplasiaGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestNumber"] = this.requestNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["breed"] = this.breed;
        data["breedId"] = this.breedId;
        if (Array.isArray(this.dysplasiaTypeIdsChecked)) {
            data["dysplasiaTypeIdsChecked"] = [];
            for (let item of this.dysplasiaTypeIdsChecked)
                data["dysplasiaTypeIdsChecked"].push(item);
        }
        data["reEvaluation"] = this.reEvaluation;
        return data;
    }
}

export interface IDysplasiaGridDto {
    dysplasiaRequestId?: number;
    requestDate?: Date;
    requestNumber?: string | undefined;
    birthDate?: Date;
    breed?: string | undefined;
    breedId?: number;
    dysplasiaTypeIdsChecked?: number[] | undefined;
    reEvaluation?: boolean;
}

export class DysplasiaSearch extends PaginatedSearch implements IDysplasiaSearch {
    languageId?: number;
    isAppeal?: boolean;
    commissionType?: ECommissionType | undefined;

    constructor(data?: IDysplasiaSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.isAppeal = _data["isAppeal"];
            this.commissionType = _data["commissionType"];
        }
    }

    static fromJS(data: any): DysplasiaSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["isAppeal"] = this.isAppeal;
        data["commissionType"] = this.commissionType;
        super.toJSON(data);
        return data;
    }
}

export interface IDysplasiaSearch extends IPaginatedSearch {
    languageId?: number;
    isAppeal?: boolean;
    commissionType?: ECommissionType | undefined;
}

export class DysplasiaDto implements IDysplasiaDto {
    dysplasiaRequestId?: number;
    requestId?: number;
    birthDate?: Date;
    breed?: string | undefined;
    isAppeal?: boolean;
    appealRequestId?: number | undefined;
    commissionType?: ECommissionType | undefined;
    position?: EDysplasiaPosition | undefined;
    positionTranslated?: string | undefined;
    definitiveSave?: boolean;
    request?: RequestDto | undefined;
    dysplasiaTypesChecked?: number[] | undefined;
    transientDysplasiaTypes?: TransientDysplasiaTypeDto[] | undefined;
    sharepointUri?: string | undefined;
    remark?: string | undefined;

    constructor(data?: IDysplasiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.requestId = _data["requestId"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.breed = _data["breed"];
            this.isAppeal = _data["isAppeal"];
            this.appealRequestId = _data["appealRequestId"];
            this.commissionType = _data["commissionType"];
            this.position = _data["position"];
            this.positionTranslated = _data["positionTranslated"];
            this.definitiveSave = _data["definitiveSave"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["dysplasiaTypesChecked"])) {
                this.dysplasiaTypesChecked = [] as any;
                for (let item of _data["dysplasiaTypesChecked"])
                    this.dysplasiaTypesChecked!.push(item);
            }
            if (Array.isArray(_data["transientDysplasiaTypes"])) {
                this.transientDysplasiaTypes = [] as any;
                for (let item of _data["transientDysplasiaTypes"])
                    this.transientDysplasiaTypes!.push(TransientDysplasiaTypeDto.fromJS(item));
            }
            this.sharepointUri = _data["sharepointUri"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): DysplasiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["requestId"] = this.requestId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["breed"] = this.breed;
        data["isAppeal"] = this.isAppeal;
        data["appealRequestId"] = this.appealRequestId;
        data["commissionType"] = this.commissionType;
        data["position"] = this.position;
        data["positionTranslated"] = this.positionTranslated;
        data["definitiveSave"] = this.definitiveSave;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.dysplasiaTypesChecked)) {
            data["dysplasiaTypesChecked"] = [];
            for (let item of this.dysplasiaTypesChecked)
                data["dysplasiaTypesChecked"].push(item);
        }
        if (Array.isArray(this.transientDysplasiaTypes)) {
            data["transientDysplasiaTypes"] = [];
            for (let item of this.transientDysplasiaTypes)
                data["transientDysplasiaTypes"].push(item.toJSON());
        }
        data["sharepointUri"] = this.sharepointUri;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IDysplasiaDto {
    dysplasiaRequestId?: number;
    requestId?: number;
    birthDate?: Date;
    breed?: string | undefined;
    isAppeal?: boolean;
    appealRequestId?: number | undefined;
    commissionType?: ECommissionType | undefined;
    position?: EDysplasiaPosition | undefined;
    positionTranslated?: string | undefined;
    definitiveSave?: boolean;
    request?: RequestDto | undefined;
    dysplasiaTypesChecked?: number[] | undefined;
    transientDysplasiaTypes?: TransientDysplasiaTypeDto[] | undefined;
    sharepointUri?: string | undefined;
    remark?: string | undefined;
}

export class TransientDysplasiaTypeDto implements ITransientDysplasiaTypeDto {
    dysplasiaTypeId?: number | undefined;
    dysplasiaType?: string | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    transientDysplasias?: TransientDysplasiaDto[] | undefined;
    allVetNotesFinished?: boolean;
    orderIndex?: number | undefined;
    characteristicOrderIndex?: number | undefined;

    constructor(data?: ITransientDysplasiaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            this.dysplasiaType = _data["dysplasiaType"];
            this.isRefused = _data["isRefused"];
            this.officialRemark = _data["officialRemark"];
            if (Array.isArray(_data["transientDysplasias"])) {
                this.transientDysplasias = [] as any;
                for (let item of _data["transientDysplasias"])
                    this.transientDysplasias!.push(TransientDysplasiaDto.fromJS(item));
            }
            this.allVetNotesFinished = _data["allVetNotesFinished"];
            this.orderIndex = _data["orderIndex"];
            this.characteristicOrderIndex = _data["characteristicOrderIndex"];
        }
    }

    static fromJS(data: any): TransientDysplasiaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransientDysplasiaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        data["dysplasiaType"] = this.dysplasiaType;
        data["isRefused"] = this.isRefused;
        data["officialRemark"] = this.officialRemark;
        if (Array.isArray(this.transientDysplasias)) {
            data["transientDysplasias"] = [];
            for (let item of this.transientDysplasias)
                data["transientDysplasias"].push(item.toJSON());
        }
        data["allVetNotesFinished"] = this.allVetNotesFinished;
        data["orderIndex"] = this.orderIndex;
        data["characteristicOrderIndex"] = this.characteristicOrderIndex;
        return data;
    }
}

export interface ITransientDysplasiaTypeDto {
    dysplasiaTypeId?: number | undefined;
    dysplasiaType?: string | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    transientDysplasias?: TransientDysplasiaDto[] | undefined;
    allVetNotesFinished?: boolean;
    orderIndex?: number | undefined;
    characteristicOrderIndex?: number | undefined;
}

export class TransientDysplasiaDto implements ITransientDysplasiaDto {
    dogDysplasiaTransientId?: number;
    userDysplasiaResultId?: number;
    isCharacteristicValue?: boolean;
    characteristicId?: number;
    characteristicName?: string | undefined;
    type?: EHealthValueType;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    otherRemark?: string | undefined;

    constructor(data?: ITransientDysplasiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogDysplasiaTransientId = _data["dogDysplasiaTransientId"];
            this.userDysplasiaResultId = _data["userDysplasiaResultId"];
            this.isCharacteristicValue = _data["isCharacteristicValue"];
            this.characteristicId = _data["characteristicId"];
            this.characteristicName = _data["characteristicName"];
            this.type = _data["type"];
            this.healthValueId = _data["healthValueId"];
            this.numericValue = _data["numericValue"];
            this.alphaValue = _data["alphaValue"];
            this.otherRemark = _data["otherRemark"];
        }
    }

    static fromJS(data: any): TransientDysplasiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransientDysplasiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogDysplasiaTransientId"] = this.dogDysplasiaTransientId;
        data["userDysplasiaResultId"] = this.userDysplasiaResultId;
        data["isCharacteristicValue"] = this.isCharacteristicValue;
        data["characteristicId"] = this.characteristicId;
        data["characteristicName"] = this.characteristicName;
        data["type"] = this.type;
        data["healthValueId"] = this.healthValueId;
        data["numericValue"] = this.numericValue;
        data["alphaValue"] = this.alphaValue;
        data["otherRemark"] = this.otherRemark;
        return data;
    }
}

export interface ITransientDysplasiaDto {
    dogDysplasiaTransientId?: number;
    userDysplasiaResultId?: number;
    isCharacteristicValue?: boolean;
    characteristicId?: number;
    characteristicName?: string | undefined;
    type?: EHealthValueType;
    healthValueId?: number | undefined;
    numericValue?: number | undefined;
    alphaValue?: string | undefined;
    otherRemark?: string | undefined;
}

export class DysplasiaTypeDto implements IDysplasiaTypeDto {
    dysplasiaTypeId?: number;
    code?: EDysplasiaType;

    constructor(data?: IDysplasiaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): DysplasiaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        data["code"] = this.code;
        return data;
    }
}

export interface IDysplasiaTypeDto {
    dysplasiaTypeId?: number;
    code?: EDysplasiaType;
}

export class ComissionPageInfoDto implements IComissionPageInfoDto {
    displayName?: string | undefined;
    commissionType?: ECommissionType | undefined;
    isAppeal?: boolean;

    constructor(data?: IComissionPageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.commissionType = _data["commissionType"];
            this.isAppeal = _data["isAppeal"];
        }
    }

    static fromJS(data: any): ComissionPageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComissionPageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["commissionType"] = this.commissionType;
        data["isAppeal"] = this.isAppeal;
        return data;
    }
}

export interface IComissionPageInfoDto {
    displayName?: string | undefined;
    commissionType?: ECommissionType | undefined;
    isAppeal?: boolean;
}

export class DysplasiaReportInfoDto implements IDysplasiaReportInfoDto {
    breedId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    languageId?: number;

    constructor(data?: IDysplasiaReportInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedId = _data["breedId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): DysplasiaReportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaReportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedId"] = this.breedId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IDysplasiaReportInfoDto {
    breedId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    languageId?: number;
}

export class PaginatedResultsOfUserDysplasiaResultGridDto implements IPaginatedResultsOfUserDysplasiaResultGridDto {
    totalCount?: number;
    results?: UserDysplasiaResultGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserDysplasiaResultGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserDysplasiaResultGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserDysplasiaResultGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserDysplasiaResultGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfUserDysplasiaResultGridDto {
    totalCount?: number;
    results?: UserDysplasiaResultGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class UserDysplasiaResultGridDto implements IUserDysplasiaResultGridDto {
    userDysplasiaResultId?: number;
    numericValue?: number | undefined;
    healthValueId?: number | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    otherRemark?: string | undefined;
    userId?: number;
    userDysplasiaStatusId?: number;
    dogDysplasiaTransientId?: number;
    orderIndex?: number;
    veterinary?: string | undefined;
    characteristicTranslation?: string | undefined;
    healthValue?: string | undefined;

    constructor(data?: IUserDysplasiaResultGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDysplasiaResultId = _data["userDysplasiaResultId"];
            this.numericValue = _data["numericValue"];
            this.healthValueId = _data["healthValueId"];
            this.isRefused = _data["isRefused"];
            this.officialRemark = _data["officialRemark"];
            this.otherRemark = _data["otherRemark"];
            this.userId = _data["userId"];
            this.userDysplasiaStatusId = _data["userDysplasiaStatusId"];
            this.dogDysplasiaTransientId = _data["dogDysplasiaTransientId"];
            this.orderIndex = _data["orderIndex"];
            this.veterinary = _data["veterinary"];
            this.characteristicTranslation = _data["characteristicTranslation"];
            this.healthValue = _data["healthValue"];
        }
    }

    static fromJS(data: any): UserDysplasiaResultGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDysplasiaResultGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDysplasiaResultId"] = this.userDysplasiaResultId;
        data["numericValue"] = this.numericValue;
        data["healthValueId"] = this.healthValueId;
        data["isRefused"] = this.isRefused;
        data["officialRemark"] = this.officialRemark;
        data["otherRemark"] = this.otherRemark;
        data["userId"] = this.userId;
        data["userDysplasiaStatusId"] = this.userDysplasiaStatusId;
        data["dogDysplasiaTransientId"] = this.dogDysplasiaTransientId;
        data["orderIndex"] = this.orderIndex;
        data["veterinary"] = this.veterinary;
        data["characteristicTranslation"] = this.characteristicTranslation;
        data["healthValue"] = this.healthValue;
        return data;
    }
}

export interface IUserDysplasiaResultGridDto {
    userDysplasiaResultId?: number;
    numericValue?: number | undefined;
    healthValueId?: number | undefined;
    isRefused?: boolean;
    officialRemark?: string | undefined;
    otherRemark?: string | undefined;
    userId?: number;
    userDysplasiaStatusId?: number;
    dogDysplasiaTransientId?: number;
    orderIndex?: number;
    veterinary?: string | undefined;
    characteristicTranslation?: string | undefined;
    healthValue?: string | undefined;
}

export class UserDysplasiaResultSearch extends PaginatedSearch implements IUserDysplasiaResultSearch {
    dysplasiaTypeId?: number | undefined;
    characteristicId?: number | undefined;
    dysplasiaRequestId?: number;

    constructor(data?: IUserDysplasiaResultSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dysplasiaTypeId = _data["dysplasiaTypeId"];
            this.characteristicId = _data["characteristicId"];
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
        }
    }

    static fromJS(data: any): UserDysplasiaResultSearch {
        data = typeof data === 'object' ? data : {};
        let result = new UserDysplasiaResultSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaTypeId"] = this.dysplasiaTypeId;
        data["characteristicId"] = this.characteristicId;
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDysplasiaResultSearch extends IPaginatedSearch {
    dysplasiaTypeId?: number | undefined;
    characteristicId?: number | undefined;
    dysplasiaRequestId?: number;
}

export class PaginatedResultsOfDysplasiaRequestGridDto implements IPaginatedResultsOfDysplasiaRequestGridDto {
    totalCount?: number;
    results?: DysplasiaRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDysplasiaRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DysplasiaRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDysplasiaRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDysplasiaRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDysplasiaRequestGridDto {
    totalCount?: number;
    results?: DysplasiaRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DysplasiaRequestGridDto implements IDysplasiaRequestGridDto {
    requestId?: number;
    dysplasiaRequestId?: number;
    dogId?: number;
    dogName?: string | undefined;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    parentRequestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequestType?: ERequestType | undefined;
    requestDate?: Date;
    isAppeal?: boolean;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    requestStateId?: number;
    contactId?: number;
    contact?: string | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: IDysplasiaRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.dogId = _data["dogId"];
            this.dogName = _data["dogName"];
            this.isBlocked = _data["isBlocked"];
            this.requestNumber = _data["requestNumber"];
            this.parentRequestNumber = _data["parentRequestNumber"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestType = _data["parentRequestType"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isAppeal = _data["isAppeal"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestState = _data["requestState"];
            this.requestStateId = _data["requestStateId"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): DysplasiaRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["dogId"] = this.dogId;
        data["dogName"] = this.dogName;
        data["isBlocked"] = this.isBlocked;
        data["requestNumber"] = this.requestNumber;
        data["parentRequestNumber"] = this.parentRequestNumber;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestType"] = this.parentRequestType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isAppeal"] = this.isAppeal;
        data["requestStateCode"] = this.requestStateCode;
        data["requestState"] = this.requestState;
        data["requestStateId"] = this.requestStateId;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IDysplasiaRequestGridDto {
    requestId?: number;
    dysplasiaRequestId?: number;
    dogId?: number;
    dogName?: string | undefined;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    parentRequestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequestType?: ERequestType | undefined;
    requestDate?: Date;
    isAppeal?: boolean;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    requestStateId?: number;
    contactId?: number;
    contact?: string | undefined;
    invoiceNumber?: string | undefined;
}

export class DysplasiaRequestSearch extends PaginatedSearch implements IDysplasiaRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IDysplasiaRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DysplasiaRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDysplasiaRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class DysplasiaRequestDto implements IDysplasiaRequestDto {
    dysplasiaRequestId?: number;
    requestId?: number;
    dogId?: number;
    isAppeal?: boolean;
    appealRequestId?: number | undefined;
    remark?: string | undefined;
    position?: EDysplasiaPosition | undefined;
    commissionType?: ECommissionType | undefined;
    request?: RequestDto | undefined;
    radioDate?: Date;
    dogSharepointUri?: string | undefined;
    typeIdsChecked?: number[] | undefined;
    vetId?: number | undefined;
    clinicId?: number | undefined;
    transientDysplasiaTypes?: TransientDysplasiaTypeDto[] | undefined;

    constructor(data?: IDysplasiaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dysplasiaRequestId = _data["dysplasiaRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.isAppeal = _data["isAppeal"];
            this.appealRequestId = _data["appealRequestId"];
            this.remark = _data["remark"];
            this.position = _data["position"];
            this.commissionType = _data["commissionType"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.radioDate = _data["radioDate"] ? new Date(_data["radioDate"].toString()) : <any>undefined;
            this.dogSharepointUri = _data["dogSharepointUri"];
            if (Array.isArray(_data["typeIdsChecked"])) {
                this.typeIdsChecked = [] as any;
                for (let item of _data["typeIdsChecked"])
                    this.typeIdsChecked!.push(item);
            }
            this.vetId = _data["vetId"];
            this.clinicId = _data["clinicId"];
            if (Array.isArray(_data["transientDysplasiaTypes"])) {
                this.transientDysplasiaTypes = [] as any;
                for (let item of _data["transientDysplasiaTypes"])
                    this.transientDysplasiaTypes!.push(TransientDysplasiaTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DysplasiaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DysplasiaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dysplasiaRequestId"] = this.dysplasiaRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["isAppeal"] = this.isAppeal;
        data["appealRequestId"] = this.appealRequestId;
        data["remark"] = this.remark;
        data["position"] = this.position;
        data["commissionType"] = this.commissionType;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["radioDate"] = this.radioDate ? this.radioDate.toISOString() : <any>undefined;
        data["dogSharepointUri"] = this.dogSharepointUri;
        if (Array.isArray(this.typeIdsChecked)) {
            data["typeIdsChecked"] = [];
            for (let item of this.typeIdsChecked)
                data["typeIdsChecked"].push(item);
        }
        data["vetId"] = this.vetId;
        data["clinicId"] = this.clinicId;
        if (Array.isArray(this.transientDysplasiaTypes)) {
            data["transientDysplasiaTypes"] = [];
            for (let item of this.transientDysplasiaTypes)
                data["transientDysplasiaTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDysplasiaRequestDto {
    dysplasiaRequestId?: number;
    requestId?: number;
    dogId?: number;
    isAppeal?: boolean;
    appealRequestId?: number | undefined;
    remark?: string | undefined;
    position?: EDysplasiaPosition | undefined;
    commissionType?: ECommissionType | undefined;
    request?: RequestDto | undefined;
    radioDate?: Date;
    dogSharepointUri?: string | undefined;
    typeIdsChecked?: number[] | undefined;
    vetId?: number | undefined;
    clinicId?: number | undefined;
    transientDysplasiaTypes?: TransientDysplasiaTypeDto[] | undefined;
}

export class PaginatedResultsOfEmailGridDto implements IPaginatedResultsOfEmailGridDto {
    totalCount?: number;
    results?: EmailGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfEmailGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EmailGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfEmailGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfEmailGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfEmailGridDto {
    totalCount?: number;
    results?: EmailGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class EmailGridDto implements IEmailGridDto {
    mailTemplateId?: number;
    mailTemplateDescription?: string | undefined;
    code?: EEmailCode | undefined;
    codeString?: string | undefined;
    subject?: string | undefined;
    frContent?: boolean;
    enContent?: boolean;
    nlcontent?: boolean;

    constructor(data?: IEmailGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplateId = _data["mailTemplateId"];
            this.mailTemplateDescription = _data["mailTemplateDescription"];
            this.code = _data["code"];
            this.codeString = _data["codeString"];
            this.subject = _data["subject"];
            this.frContent = _data["frContent"];
            this.enContent = _data["enContent"];
            this.nlcontent = _data["nlcontent"];
        }
    }

    static fromJS(data: any): EmailGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateId"] = this.mailTemplateId;
        data["mailTemplateDescription"] = this.mailTemplateDescription;
        data["code"] = this.code;
        data["codeString"] = this.codeString;
        data["subject"] = this.subject;
        data["frContent"] = this.frContent;
        data["enContent"] = this.enContent;
        data["nlcontent"] = this.nlcontent;
        return data;
    }
}

export interface IEmailGridDto {
    mailTemplateId?: number;
    mailTemplateDescription?: string | undefined;
    code?: EEmailCode | undefined;
    codeString?: string | undefined;
    subject?: string | undefined;
    frContent?: boolean;
    enContent?: boolean;
    nlcontent?: boolean;
}

export class EmailSearch extends PaginatedSearch implements IEmailSearch {
    code?: ListSearchOfNullableEEmailCode | undefined;
    subject?: TextSearch | undefined;

    constructor(data?: IEmailSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] ? ListSearchOfNullableEEmailCode.fromJS(_data["code"]) : <any>undefined;
            this.subject = _data["subject"] ? TextSearch.fromJS(_data["subject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailSearch {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailSearch extends IPaginatedSearch {
    code?: ListSearchOfNullableEEmailCode | undefined;
    subject?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode implements IFilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableEEmailCode[] | undefined;
    searchMode?: EListSearchType;
    value?: EEmailCode | undefined;
    secondaryValue?: EEmailCode | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndNullableEEmailCode.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode {
    criterias?: CombinableCriteriaOfEListSearchTypeAndNullableEEmailCode[] | undefined;
    searchMode?: EListSearchType;
    value?: EEmailCode | undefined;
    secondaryValue?: EEmailCode | undefined;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfNullableEEmailCode extends FilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode implements IListSearchOfNullableEEmailCode {

    constructor(data?: IListSearchOfNullableEEmailCode) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfNullableEEmailCode {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfNullableEEmailCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfNullableEEmailCode extends IFilterCriteriaBaseOfEListSearchTypeAndNullableEEmailCode {
}

export class CombinableCriteriaOfEListSearchTypeAndNullableEEmailCode implements ICombinableCriteriaOfEListSearchTypeAndNullableEEmailCode {
    searchMode?: EListSearchType;
    value?: EEmailCode | undefined;
    secondaryValue?: EEmailCode | undefined;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndNullableEEmailCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndNullableEEmailCode {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndNullableEEmailCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndNullableEEmailCode {
    searchMode?: EListSearchType;
    value?: EEmailCode | undefined;
    secondaryValue?: EEmailCode | undefined;
}

export class EmailDto implements IEmailDto {
    mailTemplateId?: number;
    code?: EEmailCode;
    mailContent?: MailContentDto[] | undefined;
    mailDescription?: string | undefined;

    constructor(data?: IEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplateId = _data["mailTemplateId"];
            this.code = _data["code"];
            if (Array.isArray(_data["mailContent"])) {
                this.mailContent = [] as any;
                for (let item of _data["mailContent"])
                    this.mailContent!.push(MailContentDto.fromJS(item));
            }
            this.mailDescription = _data["mailDescription"];
        }
    }

    static fromJS(data: any): EmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateId"] = this.mailTemplateId;
        data["code"] = this.code;
        if (Array.isArray(this.mailContent)) {
            data["mailContent"] = [];
            for (let item of this.mailContent)
                data["mailContent"].push(item.toJSON());
        }
        data["mailDescription"] = this.mailDescription;
        return data;
    }
}

export interface IEmailDto {
    mailTemplateId?: number;
    code?: EEmailCode;
    mailContent?: MailContentDto[] | undefined;
    mailDescription?: string | undefined;
}

export class MailContentDto implements IMailContentDto {
    mailTemplateId?: number;
    languageId?: number;
    body?: string | undefined;
    subject?: string | undefined;
    mailContentId?: number;

    constructor(data?: IMailContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailTemplateId = _data["mailTemplateId"];
            this.languageId = _data["languageId"];
            this.body = _data["body"];
            this.subject = _data["subject"];
            this.mailContentId = _data["mailContentId"];
        }
    }

    static fromJS(data: any): MailContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailTemplateId"] = this.mailTemplateId;
        data["languageId"] = this.languageId;
        data["body"] = this.body;
        data["subject"] = this.subject;
        data["mailContentId"] = this.mailContentId;
        return data;
    }
}

export interface IMailContentDto {
    mailTemplateId?: number;
    languageId?: number;
    body?: string | undefined;
    subject?: string | undefined;
    mailContentId?: number;
}

export class FileDownload implements IFileDownload {
    fileName?: string | undefined;
    base64Content?: string | undefined;

    constructor(data?: IFileDownload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.base64Content = _data["base64Content"];
        }
    }

    static fromJS(data: any): FileDownload {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["base64Content"] = this.base64Content;
        return data;
    }
}

export interface IFileDownload {
    fileName?: string | undefined;
    base64Content?: string | undefined;
}

export class PaginatedResultsOfExpatriationRequestGridDto implements IPaginatedResultsOfExpatriationRequestGridDto {
    totalCount?: number;
    results?: ExpatriationRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfExpatriationRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ExpatriationRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfExpatriationRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfExpatriationRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfExpatriationRequestGridDto {
    totalCount?: number;
    results?: ExpatriationRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ExpatriationRequestGridDto implements IExpatriationRequestGridDto {
    expatriationRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IExpatriationRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expatriationRequestId = _data["expatriationRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): ExpatriationRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpatriationRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expatriationRequestId"] = this.expatriationRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IExpatriationRequestGridDto {
    expatriationRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class ExpatriationRequestSearchDto extends PaginatedSearch implements IExpatriationRequestSearchDto {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IExpatriationRequestSearchDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpatriationRequestSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpatriationRequestSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IExpatriationRequestSearchDto extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class ExpatriationRequestDto implements IExpatriationRequestDto {
    expatriationRequestId?: number;
    requestId?: number;
    dogId?: number;
    isForeignDog?: boolean;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: IExpatriationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expatriationRequestId = _data["expatriationRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.isForeignDog = _data["isForeignDog"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): ExpatriationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpatriationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expatriationRequestId"] = this.expatriationRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["isForeignDog"] = this.isForeignDog;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface IExpatriationRequestDto {
    expatriationRequestId?: number;
    requestId?: number;
    dogId?: number;
    isForeignDog?: boolean;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;
}

export class PaginatedResultsOfHealthPackGridDto implements IPaginatedResultsOfHealthPackGridDto {
    totalCount?: number;
    results?: HealthPackGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfHealthPackGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(HealthPackGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfHealthPackGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfHealthPackGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfHealthPackGridDto {
    totalCount?: number;
    results?: HealthPackGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class HealthPackGridDto implements IHealthPackGridDto {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    articleName?: string | undefined;
    articleId?: number;
    healthPackGroupName?: string | undefined;
    healthPackGroupId?: number;
    lab?: ELab;
    orderIndex?: number;

    constructor(data?: IHealthPackGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackId = _data["healthPackId"];
            this.healthPackCode = _data["healthPackCode"];
            this.articleName = _data["articleName"];
            this.articleId = _data["articleId"];
            this.healthPackGroupName = _data["healthPackGroupName"];
            this.healthPackGroupId = _data["healthPackGroupId"];
            this.lab = _data["lab"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): HealthPackGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackId"] = this.healthPackId;
        data["healthPackCode"] = this.healthPackCode;
        data["articleName"] = this.articleName;
        data["articleId"] = this.articleId;
        data["healthPackGroupName"] = this.healthPackGroupName;
        data["healthPackGroupId"] = this.healthPackGroupId;
        data["lab"] = this.lab;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface IHealthPackGridDto {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    articleName?: string | undefined;
    articleId?: number;
    healthPackGroupName?: string | undefined;
    healthPackGroupId?: number;
    lab?: ELab;
    orderIndex?: number;
}

export class HealthPackSearch extends PaginatedSearch implements IHealthPackSearch {
    healthPackCode?: TextSearch | undefined;
    articleName?: TextSearch | undefined;
    lab?: ListSearchOfNullableELab | undefined;
    healthPackGroupId?: ListSearchOfNullableInteger | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IHealthPackSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthPackCode = _data["healthPackCode"] ? TextSearch.fromJS(_data["healthPackCode"]) : <any>undefined;
            this.articleName = _data["articleName"] ? TextSearch.fromJS(_data["articleName"]) : <any>undefined;
            this.lab = _data["lab"] ? ListSearchOfNullableELab.fromJS(_data["lab"]) : <any>undefined;
            this.healthPackGroupId = _data["healthPackGroupId"] ? ListSearchOfNullableInteger.fromJS(_data["healthPackGroupId"]) : <any>undefined;
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): HealthPackSearch {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackCode"] = this.healthPackCode ? this.healthPackCode.toJSON() : <any>undefined;
        data["articleName"] = this.articleName ? this.articleName.toJSON() : <any>undefined;
        data["lab"] = this.lab ? this.lab.toJSON() : <any>undefined;
        data["healthPackGroupId"] = this.healthPackGroupId ? this.healthPackGroupId.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IHealthPackSearch extends IPaginatedSearch {
    healthPackCode?: TextSearch | undefined;
    articleName?: TextSearch | undefined;
    lab?: ListSearchOfNullableELab | undefined;
    healthPackGroupId?: ListSearchOfNullableInteger | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class HealthPackDto implements IHealthPackDto {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    articleId?: number;
    healthPackGroupId?: number;
    webSiteUriFr?: string | undefined;
    webSiteUriNl?: string | undefined;
    lab?: ELab;
    characteristicIds?: number[] | undefined;
    healthPackTranslations?: HealthPackTranslationDto[] | undefined;

    constructor(data?: IHealthPackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackId = _data["healthPackId"];
            this.healthPackCode = _data["healthPackCode"];
            this.articleId = _data["articleId"];
            this.healthPackGroupId = _data["healthPackGroupId"];
            this.webSiteUriFr = _data["webSiteUriFr"];
            this.webSiteUriNl = _data["webSiteUriNl"];
            this.lab = _data["lab"];
            if (Array.isArray(_data["characteristicIds"])) {
                this.characteristicIds = [] as any;
                for (let item of _data["characteristicIds"])
                    this.characteristicIds!.push(item);
            }
            if (Array.isArray(_data["healthPackTranslations"])) {
                this.healthPackTranslations = [] as any;
                for (let item of _data["healthPackTranslations"])
                    this.healthPackTranslations!.push(HealthPackTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthPackDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackId"] = this.healthPackId;
        data["healthPackCode"] = this.healthPackCode;
        data["articleId"] = this.articleId;
        data["healthPackGroupId"] = this.healthPackGroupId;
        data["webSiteUriFr"] = this.webSiteUriFr;
        data["webSiteUriNl"] = this.webSiteUriNl;
        data["lab"] = this.lab;
        if (Array.isArray(this.characteristicIds)) {
            data["characteristicIds"] = [];
            for (let item of this.characteristicIds)
                data["characteristicIds"].push(item);
        }
        if (Array.isArray(this.healthPackTranslations)) {
            data["healthPackTranslations"] = [];
            for (let item of this.healthPackTranslations)
                data["healthPackTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthPackDto {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    articleId?: number;
    healthPackGroupId?: number;
    webSiteUriFr?: string | undefined;
    webSiteUriNl?: string | undefined;
    lab?: ELab;
    characteristicIds?: number[] | undefined;
    healthPackTranslations?: HealthPackTranslationDto[] | undefined;
}

export class HealthPackTranslationDto implements IHealthPackTranslationDto {
    colorId?: number;
    languageId?: number;
    text?: string | undefined;
    colorTranslationId?: number;

    constructor(data?: IHealthPackTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorId = _data["colorId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.colorTranslationId = _data["colorTranslationId"];
        }
    }

    static fromJS(data: any): HealthPackTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthPackTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorId"] = this.colorId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["colorTranslationId"] = this.colorTranslationId;
        return data;
    }
}

export interface IHealthPackTranslationDto {
    colorId?: number;
    languageId?: number;
    text?: string | undefined;
    colorTranslationId?: number;
}

export class PaginatedResultsOfHealthTestRequestGridDto implements IPaginatedResultsOfHealthTestRequestGridDto {
    totalCount?: number;
    results?: HealthTestRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfHealthTestRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(HealthTestRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfHealthTestRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfHealthTestRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfHealthTestRequestGridDto {
    totalCount?: number;
    results?: HealthTestRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class HealthTestRequestGridDto implements IHealthTestRequestGridDto {
    requestId?: number;
    healthTestRequestId?: number;
    dogId?: number;
    dogName?: string | undefined;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    parentRequestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequestType?: ERequestType | undefined;
    requestDate?: Date;
    isAppeal?: boolean;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    requestStateId?: number;
    contactId?: number;
    contact?: string | undefined;
    invoiceNumber?: string | undefined;
    lab?: ELab;

    constructor(data?: IHealthTestRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.dogId = _data["dogId"];
            this.dogName = _data["dogName"];
            this.isBlocked = _data["isBlocked"];
            this.requestNumber = _data["requestNumber"];
            this.parentRequestNumber = _data["parentRequestNumber"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestType = _data["parentRequestType"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isAppeal = _data["isAppeal"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestState = _data["requestState"];
            this.requestStateId = _data["requestStateId"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.lab = _data["lab"];
        }
    }

    static fromJS(data: any): HealthTestRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["dogId"] = this.dogId;
        data["dogName"] = this.dogName;
        data["isBlocked"] = this.isBlocked;
        data["requestNumber"] = this.requestNumber;
        data["parentRequestNumber"] = this.parentRequestNumber;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestType"] = this.parentRequestType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isAppeal"] = this.isAppeal;
        data["requestStateCode"] = this.requestStateCode;
        data["requestState"] = this.requestState;
        data["requestStateId"] = this.requestStateId;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact;
        data["invoiceNumber"] = this.invoiceNumber;
        data["lab"] = this.lab;
        return data;
    }
}

export interface IHealthTestRequestGridDto {
    requestId?: number;
    healthTestRequestId?: number;
    dogId?: number;
    dogName?: string | undefined;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    parentRequestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequestType?: ERequestType | undefined;
    requestDate?: Date;
    isAppeal?: boolean;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    requestStateId?: number;
    contactId?: number;
    contact?: string | undefined;
    invoiceNumber?: string | undefined;
    lab?: ELab;
}

export class HealthTestRequestSearch extends PaginatedSearch implements IHealthTestRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    lab?: ListSearchOfELab | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceSearch?: TextSearch | undefined;

    constructor(data?: IHealthTestRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.lab = _data["lab"] ? ListSearchOfELab.fromJS(_data["lab"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceSearch = _data["invoiceSearch"] ? TextSearch.fromJS(_data["invoiceSearch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthTestRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["lab"] = this.lab ? this.lab.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceSearch"] = this.invoiceSearch ? this.invoiceSearch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IHealthTestRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    lab?: ListSearchOfELab | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceSearch?: TextSearch | undefined;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndELab implements IFilterCriteriaBaseOfEListSearchTypeAndELab {
    criterias?: CombinableCriteriaOfEListSearchTypeAndELab[] | undefined;
    searchMode?: EListSearchType;
    value?: ELab;
    secondaryValue?: ELab;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndELab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndELab.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndELab {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndELab' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndELab {
    criterias?: CombinableCriteriaOfEListSearchTypeAndELab[] | undefined;
    searchMode?: EListSearchType;
    value?: ELab;
    secondaryValue?: ELab;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfELab extends FilterCriteriaBaseOfEListSearchTypeAndELab implements IListSearchOfELab {

    constructor(data?: IListSearchOfELab) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfELab {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfELab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfELab extends IFilterCriteriaBaseOfEListSearchTypeAndELab {
}

export class CombinableCriteriaOfEListSearchTypeAndELab implements ICombinableCriteriaOfEListSearchTypeAndELab {
    searchMode?: EListSearchType;
    value?: ELab;
    secondaryValue?: ELab;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndELab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndELab {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndELab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndELab {
    searchMode?: EListSearchType;
    value?: ELab;
    secondaryValue?: ELab;
}

export class BaseHealthTestRequestSearch extends PaginatedSearch implements IBaseHealthTestRequestSearch {
    healthTestRequestId?: number;
    languageId?: number;
    hideDnaTest?: boolean;

    constructor(data?: IBaseHealthTestRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.languageId = _data["languageId"];
            this.hideDnaTest = _data["hideDnaTest"];
        }
    }

    static fromJS(data: any): BaseHealthTestRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BaseHealthTestRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["languageId"] = this.languageId;
        data["hideDnaTest"] = this.hideDnaTest;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseHealthTestRequestSearch extends IPaginatedSearch {
    healthTestRequestId?: number;
    languageId?: number;
    hideDnaTest?: boolean;
}

export class HealthTestRequestDto implements IHealthTestRequestDto {
    healthTestRequestId?: number;
    requestId?: number;
    dogId?: number | undefined;
    labStatusId?: number | undefined;
    lab?: ELab;
    whiteTest?: boolean;
    request?: RequestDto | undefined;
    healthPackIds?: number[] | undefined;
    singleHealthTestIds?: number[] | undefined;

    constructor(data?: IHealthTestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.labStatusId = _data["labStatusId"];
            this.lab = _data["lab"];
            this.whiteTest = _data["whiteTest"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["healthPackIds"])) {
                this.healthPackIds = [] as any;
                for (let item of _data["healthPackIds"])
                    this.healthPackIds!.push(item);
            }
            if (Array.isArray(_data["singleHealthTestIds"])) {
                this.singleHealthTestIds = [] as any;
                for (let item of _data["singleHealthTestIds"])
                    this.singleHealthTestIds!.push(item);
            }
        }
    }

    static fromJS(data: any): HealthTestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["labStatusId"] = this.labStatusId;
        data["lab"] = this.lab;
        data["whiteTest"] = this.whiteTest;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.healthPackIds)) {
            data["healthPackIds"] = [];
            for (let item of this.healthPackIds)
                data["healthPackIds"].push(item);
        }
        if (Array.isArray(this.singleHealthTestIds)) {
            data["singleHealthTestIds"] = [];
            for (let item of this.singleHealthTestIds)
                data["singleHealthTestIds"].push(item);
        }
        return data;
    }
}

export interface IHealthTestRequestDto {
    healthTestRequestId?: number;
    requestId?: number;
    dogId?: number | undefined;
    labStatusId?: number | undefined;
    lab?: ELab;
    whiteTest?: boolean;
    request?: RequestDto | undefined;
    healthPackIds?: number[] | undefined;
    singleHealthTestIds?: number[] | undefined;
}

export class BlockedHealthTestDto implements IBlockedHealthTestDto {
    blockedSingleHealthTestsIds?: number[] | undefined;
    blockedHealthTestPackIds?: number[] | undefined;

    constructor(data?: IBlockedHealthTestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blockedSingleHealthTestsIds"])) {
                this.blockedSingleHealthTestsIds = [] as any;
                for (let item of _data["blockedSingleHealthTestsIds"])
                    this.blockedSingleHealthTestsIds!.push(item);
            }
            if (Array.isArray(_data["blockedHealthTestPackIds"])) {
                this.blockedHealthTestPackIds = [] as any;
                for (let item of _data["blockedHealthTestPackIds"])
                    this.blockedHealthTestPackIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BlockedHealthTestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedHealthTestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blockedSingleHealthTestsIds)) {
            data["blockedSingleHealthTestsIds"] = [];
            for (let item of this.blockedSingleHealthTestsIds)
                data["blockedSingleHealthTestsIds"].push(item);
        }
        if (Array.isArray(this.blockedHealthTestPackIds)) {
            data["blockedHealthTestPackIds"] = [];
            for (let item of this.blockedHealthTestPackIds)
                data["blockedHealthTestPackIds"].push(item);
        }
        return data;
    }
}

export interface IBlockedHealthTestDto {
    blockedSingleHealthTestsIds?: number[] | undefined;
    blockedHealthTestPackIds?: number[] | undefined;
}

export class PaginatedResultsOfHealthTestRequestPackGridDto implements IPaginatedResultsOfHealthTestRequestPackGridDto {
    totalCount?: number;
    results?: HealthTestRequestPackGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfHealthTestRequestPackGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(HealthTestRequestPackGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfHealthTestRequestPackGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfHealthTestRequestPackGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfHealthTestRequestPackGridDto {
    totalCount?: number;
    results?: HealthTestRequestPackGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class HealthTestRequestPackGridDto implements IHealthTestRequestPackGridDto {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    healthPackName?: string | undefined;
    orderIndex?: number;
    healthTestPackCharacteristics?: HealthTestRequestCharacteristicGridDto[] | undefined;

    constructor(data?: IHealthTestRequestPackGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthPackId = _data["healthPackId"];
            this.healthPackCode = _data["healthPackCode"];
            this.healthPackName = _data["healthPackName"];
            this.orderIndex = _data["orderIndex"];
            if (Array.isArray(_data["healthTestPackCharacteristics"])) {
                this.healthTestPackCharacteristics = [] as any;
                for (let item of _data["healthTestPackCharacteristics"])
                    this.healthTestPackCharacteristics!.push(HealthTestRequestCharacteristicGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthTestRequestPackGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestPackGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthPackId"] = this.healthPackId;
        data["healthPackCode"] = this.healthPackCode;
        data["healthPackName"] = this.healthPackName;
        data["orderIndex"] = this.orderIndex;
        if (Array.isArray(this.healthTestPackCharacteristics)) {
            data["healthTestPackCharacteristics"] = [];
            for (let item of this.healthTestPackCharacteristics)
                data["healthTestPackCharacteristics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthTestRequestPackGridDto {
    healthPackId?: number;
    healthPackCode?: string | undefined;
    healthPackName?: string | undefined;
    orderIndex?: number;
    healthTestPackCharacteristics?: HealthTestRequestCharacteristicGridDto[] | undefined;
}

export class HealthTestRequestCharacteristicGridDto implements IHealthTestRequestCharacteristicGridDto {
    characteristicName?: string | undefined;
    characteristicCode?: string | undefined;
    characteristicId?: number;

    constructor(data?: IHealthTestRequestCharacteristicGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicName = _data["characteristicName"];
            this.characteristicCode = _data["characteristicCode"];
            this.characteristicId = _data["characteristicId"];
        }
    }

    static fromJS(data: any): HealthTestRequestCharacteristicGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthTestRequestCharacteristicGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicName"] = this.characteristicName;
        data["characteristicCode"] = this.characteristicCode;
        data["characteristicId"] = this.characteristicId;
        return data;
    }
}

export interface IHealthTestRequestCharacteristicGridDto {
    characteristicName?: string | undefined;
    characteristicCode?: string | undefined;
    characteristicId?: number;
}

export class HealthRequestPacksSearch extends PaginatedSearch implements IHealthRequestPacksSearch {
    lab?: ELab;
    dogId?: number | undefined;
    healthTestRequestId?: number | undefined;
    languageId?: number;

    constructor(data?: IHealthRequestPacksSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lab = _data["lab"];
            this.dogId = _data["dogId"];
            this.healthTestRequestId = _data["healthTestRequestId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): HealthRequestPacksSearch {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRequestPacksSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lab"] = this.lab;
        data["dogId"] = this.dogId;
        data["healthTestRequestId"] = this.healthTestRequestId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IHealthRequestPacksSearch extends IPaginatedSearch {
    lab?: ELab;
    dogId?: number | undefined;
    healthTestRequestId?: number | undefined;
    languageId?: number;
}

export class PaginatedResultsOfImportRequestGridDto implements IPaginatedResultsOfImportRequestGridDto {
    totalCount?: number;
    results?: ImportRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfImportRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ImportRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfImportRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfImportRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfImportRequestGridDto {
    totalCount?: number;
    results?: ImportRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ImportRequestGridDto implements IImportRequestGridDto {
    importRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    kennelName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IImportRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importRequestId = _data["importRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.kennelName = _data["kennelName"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): ImportRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequestId"] = this.importRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["kennelName"] = this.kennelName;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IImportRequestGridDto {
    importRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    kennelName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class ImportRequestSearch extends PaginatedSearch implements IImportRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IImportRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImportRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IImportRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class ImportRequestDto implements IImportRequestDto {
    importRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: RequestDto | undefined;
    transientOwnerIds?: number[] | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: IImportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importRequestId = _data["importRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientOwnerIds"])) {
                this.transientOwnerIds = [] as any;
                for (let item of _data["transientOwnerIds"])
                    this.transientOwnerIds!.push(item);
            }
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): ImportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequestId"] = this.importRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientOwnerIds)) {
            data["transientOwnerIds"] = [];
            for (let item of this.transientOwnerIds)
                data["transientOwnerIds"].push(item);
        }
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface IImportRequestDto {
    importRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: RequestDto | undefined;
    transientOwnerIds?: number[] | undefined;
    dogSharepointUri?: string | undefined;
}

export class PaginatedResultsOfImportRequestTransientOwnersGridDto implements IPaginatedResultsOfImportRequestTransientOwnersGridDto {
    totalCount?: number;
    results?: ImportRequestTransientOwnersGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfImportRequestTransientOwnersGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ImportRequestTransientOwnersGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfImportRequestTransientOwnersGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfImportRequestTransientOwnersGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfImportRequestTransientOwnersGridDto {
    totalCount?: number;
    results?: ImportRequestTransientOwnersGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ImportRequestTransientOwnersGridDto implements IImportRequestTransientOwnersGridDto {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IImportRequestTransientOwnersGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): ImportRequestTransientOwnersGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestTransientOwnersGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IImportRequestTransientOwnersGridDto {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class ImportRequestTransientOwnersSearch extends PaginatedSearch implements IImportRequestTransientOwnersSearch {
    importRequestId?: number;
    dogId?: number;

    constructor(data?: IImportRequestTransientOwnersSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.importRequestId = _data["importRequestId"];
            this.dogId = _data["dogId"];
        }
    }

    static fromJS(data: any): ImportRequestTransientOwnersSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestTransientOwnersSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequestId"] = this.importRequestId;
        data["dogId"] = this.dogId;
        super.toJSON(data);
        return data;
    }
}

export interface IImportRequestTransientOwnersSearch extends IPaginatedSearch {
    importRequestId?: number;
    dogId?: number;
}

export class JudgeSearch extends PaginatedSearch implements IJudgeSearch {
    languageId?: number;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IJudgeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): JudgeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IJudgeSearch extends IPaginatedSearch {
    languageId?: number;
    firstName?: TextSearch | undefined;
    lastName?: TextSearch | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class JudgeInformationDto implements IJudgeInformationDto {
    judgeId?: number;
    fciNumber?: string | undefined;
    personId?: number;
    spokenLanguageIds?: number[] | undefined;

    constructor(data?: IJudgeInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.judgeId = _data["judgeId"];
            this.fciNumber = _data["fciNumber"];
            this.personId = _data["personId"];
            if (Array.isArray(_data["spokenLanguageIds"])) {
                this.spokenLanguageIds = [] as any;
                for (let item of _data["spokenLanguageIds"])
                    this.spokenLanguageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): JudgeInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["judgeId"] = this.judgeId;
        data["fciNumber"] = this.fciNumber;
        data["personId"] = this.personId;
        if (Array.isArray(this.spokenLanguageIds)) {
            data["spokenLanguageIds"] = [];
            for (let item of this.spokenLanguageIds)
                data["spokenLanguageIds"].push(item);
        }
        return data;
    }
}

export interface IJudgeInformationDto {
    judgeId?: number;
    fciNumber?: string | undefined;
    personId?: number;
    spokenLanguageIds?: number[] | undefined;
}

export class PaginatedResultsOfJudgeTransientBreedGridDto implements IPaginatedResultsOfJudgeTransientBreedGridDto {
    totalCount?: number;
    results?: JudgeTransientBreedGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfJudgeTransientBreedGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(JudgeTransientBreedGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfJudgeTransientBreedGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfJudgeTransientBreedGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfJudgeTransientBreedGridDto {
    totalCount?: number;
    results?: JudgeTransientBreedGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class JudgeTransientBreedGridDto implements IJudgeTransientBreedGridDto {
    breedJudgeTransientId?: number;
    breedId?: number;
    judgeId?: number;
    personId?: number;
    breedName?: string | undefined;
    judgeName?: string | undefined;
    breedGroupName?: string | undefined;

    constructor(data?: IJudgeTransientBreedGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breedJudgeTransientId = _data["breedJudgeTransientId"];
            this.breedId = _data["breedId"];
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            this.breedName = _data["breedName"];
            this.judgeName = _data["judgeName"];
            this.breedGroupName = _data["breedGroupName"];
        }
    }

    static fromJS(data: any): JudgeTransientBreedGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeTransientBreedGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedJudgeTransientId"] = this.breedJudgeTransientId;
        data["breedId"] = this.breedId;
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        data["breedName"] = this.breedName;
        data["judgeName"] = this.judgeName;
        data["breedGroupName"] = this.breedGroupName;
        return data;
    }
}

export interface IJudgeTransientBreedGridDto {
    breedJudgeTransientId?: number;
    breedId?: number;
    judgeId?: number;
    personId?: number;
    breedName?: string | undefined;
    judgeName?: string | undefined;
    breedGroupName?: string | undefined;
}

export class JudgeTransientBreedSearch extends PaginatedSearch implements IJudgeTransientBreedSearch {
    breedName?: TextSearch | undefined;
    judgeName?: TextSearch | undefined;
    breedGroupName?: TextSearch | undefined;

    constructor(data?: IJudgeTransientBreedSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.breedName = _data["breedName"] ? TextSearch.fromJS(_data["breedName"]) : <any>undefined;
            this.judgeName = _data["judgeName"] ? TextSearch.fromJS(_data["judgeName"]) : <any>undefined;
            this.breedGroupName = _data["breedGroupName"] ? TextSearch.fromJS(_data["breedGroupName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JudgeTransientBreedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new JudgeTransientBreedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breedName"] = this.breedName ? this.breedName.toJSON() : <any>undefined;
        data["judgeName"] = this.judgeName ? this.judgeName.toJSON() : <any>undefined;
        data["breedGroupName"] = this.breedGroupName ? this.breedGroupName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IJudgeTransientBreedSearch extends IPaginatedSearch {
    breedName?: TextSearch | undefined;
    judgeName?: TextSearch | undefined;
    breedGroupName?: TextSearch | undefined;
}

export class PaginatedResultsOfKennelGridDto implements IPaginatedResultsOfKennelGridDto {
    totalCount?: number;
    results?: KennelGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfKennelGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KennelGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfKennelGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfKennelGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfKennelGridDto {
    totalCount?: number;
    results?: KennelGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class KennelGridDto implements IKennelGridDto {
    kennelId?: number;
    name?: string | undefined;
    type?: EKennelType;
    country?: string | undefined;
    countryId?: number;
    fciNumber?: string | undefined;
    attributionDate?: Date | undefined;
    closingDate?: Date | undefined;
    owners?: string[] | undefined;
    isClosed?: boolean;

    constructor(data?: IKennelGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelId = _data["kennelId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.country = _data["country"];
            this.countryId = _data["countryId"];
            this.fciNumber = _data["fciNumber"];
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(item);
            }
            this.isClosed = _data["isClosed"];
        }
    }

    static fromJS(data: any): KennelGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelId"] = this.kennelId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["country"] = this.country;
        data["countryId"] = this.countryId;
        data["fciNumber"] = this.fciNumber;
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item);
        }
        data["isClosed"] = this.isClosed;
        return data;
    }
}

export interface IKennelGridDto {
    kennelId?: number;
    name?: string | undefined;
    type?: EKennelType;
    country?: string | undefined;
    countryId?: number;
    fciNumber?: string | undefined;
    attributionDate?: Date | undefined;
    closingDate?: Date | undefined;
    owners?: string[] | undefined;
    isClosed?: boolean;
}

export class KennelSearch extends PaginatedSearch implements IKennelSearch {
    languageCode?: string | undefined;
    name?: TextSearch | undefined;
    owner?: TextSearch | undefined;
    fciNumber?: TextSearch | undefined;

    constructor(data?: IKennelSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.owner = _data["owner"] ? TextSearch.fromJS(_data["owner"]) : <any>undefined;
            this.fciNumber = _data["fciNumber"] ? TextSearch.fromJS(_data["fciNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KennelSearch {
        data = typeof data === 'object' ? data : {};
        let result = new KennelSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["fciNumber"] = this.fciNumber ? this.fciNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IKennelSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    name?: TextSearch | undefined;
    owner?: TextSearch | undefined;
    fciNumber?: TextSearch | undefined;
}

export class KennelDto implements IKennelDto {
    kennelId?: number;
    name?: string | undefined;
    type?: EKennelType;
    fciNumber?: string | undefined;
    requestAffix?: string | undefined;
    attributionDate?: Date | undefined;
    closingDate?: Date | undefined;
    publishingDate?: Date | undefined;
    countryId?: number | undefined;
    originCountryId?: number | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    previousKennelId?: number | undefined;
    remark?: string | undefined;
    isClosed?: boolean;
    sharepointUri?: string | undefined;

    constructor(data?: IKennelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelId = _data["kennelId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.fciNumber = _data["fciNumber"];
            this.requestAffix = _data["requestAffix"];
            this.attributionDate = _data["attributionDate"] ? new Date(_data["attributionDate"].toString()) : <any>undefined;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : <any>undefined;
            this.publishingDate = _data["publishingDate"] ? new Date(_data["publishingDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.originCountryId = _data["originCountryId"];
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionStartDate = _data["exclusionStartDate"] ? new Date(_data["exclusionStartDate"].toString()) : <any>undefined;
            this.exclusionEndDate = _data["exclusionEndDate"] ? new Date(_data["exclusionEndDate"].toString()) : <any>undefined;
            this.previousKennelId = _data["previousKennelId"];
            this.remark = _data["remark"];
            this.isClosed = _data["isClosed"];
            this.sharepointUri = _data["sharepointUri"];
        }
    }

    static fromJS(data: any): KennelDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelId"] = this.kennelId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["fciNumber"] = this.fciNumber;
        data["requestAffix"] = this.requestAffix;
        data["attributionDate"] = this.attributionDate ? this.attributionDate.toISOString() : <any>undefined;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : <any>undefined;
        data["publishingDate"] = this.publishingDate ? this.publishingDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["originCountryId"] = this.originCountryId;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionStartDate"] = this.exclusionStartDate ? this.exclusionStartDate.toISOString() : <any>undefined;
        data["exclusionEndDate"] = this.exclusionEndDate ? this.exclusionEndDate.toISOString() : <any>undefined;
        data["previousKennelId"] = this.previousKennelId;
        data["remark"] = this.remark;
        data["isClosed"] = this.isClosed;
        data["sharepointUri"] = this.sharepointUri;
        return data;
    }
}

export interface IKennelDto {
    kennelId?: number;
    name?: string | undefined;
    type?: EKennelType;
    fciNumber?: string | undefined;
    requestAffix?: string | undefined;
    attributionDate?: Date | undefined;
    closingDate?: Date | undefined;
    publishingDate?: Date | undefined;
    countryId?: number | undefined;
    originCountryId?: number | undefined;
    exclusionReason?: string | undefined;
    exclusionStartDate?: Date | undefined;
    exclusionEndDate?: Date | undefined;
    previousKennelId?: number | undefined;
    remark?: string | undefined;
    isClosed?: boolean;
    sharepointUri?: string | undefined;
}

export class SaveKennelOwnerDto implements ISaveKennelOwnerDto {
    kennelOwnershipId?: number;
    kennelId?: number;
    personId?: number;
    personName?: string | undefined;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;

    constructor(data?: ISaveKennelOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelOwnershipId = _data["kennelOwnershipId"];
            this.kennelId = _data["kennelId"];
            this.personId = _data["personId"];
            this.personName = _data["personName"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveKennelOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveKennelOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelOwnershipId"] = this.kennelOwnershipId;
        data["kennelId"] = this.kennelId;
        data["personId"] = this.personId;
        data["personName"] = this.personName;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveKennelOwnerDto {
    kennelOwnershipId?: number;
    kennelId?: number;
    personId?: number;
    personName?: string | undefined;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
}

export class KennelSaveBreedsDto implements IKennelSaveBreedsDto {
    kennelId?: number;
    breedIds?: number[] | undefined;

    constructor(data?: IKennelSaveBreedsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelId = _data["kennelId"];
            if (Array.isArray(_data["breedIds"])) {
                this.breedIds = [] as any;
                for (let item of _data["breedIds"])
                    this.breedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): KennelSaveBreedsDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelSaveBreedsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelId"] = this.kennelId;
        if (Array.isArray(this.breedIds)) {
            data["breedIds"] = [];
            for (let item of this.breedIds)
                data["breedIds"].push(item);
        }
        return data;
    }
}

export interface IKennelSaveBreedsDto {
    kennelId?: number;
    breedIds?: number[] | undefined;
}

export class PaginatedResultsOfKennelDogDto implements IPaginatedResultsOfKennelDogDto {
    totalCount?: number;
    results?: KennelDogDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfKennelDogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KennelDogDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfKennelDogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfKennelDogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfKennelDogDto {
    totalCount?: number;
    results?: KennelDogDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class KennelDogDto implements IKennelDogDto {
    dogId?: number;
    kennelType?: EKennelType;
    breed?: string | undefined;
    breedId?: number;
    color?: string | undefined;
    colorId?: number;
    dogChip?: string | undefined;
    pedigree?: string | undefined;
    name?: string | undefined;
    breedGroup?: string | undefined;
    breedGroupId?: number;

    constructor(data?: IKennelDogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.kennelType = _data["kennelType"];
            this.breed = _data["breed"];
            this.breedId = _data["breedId"];
            this.color = _data["color"];
            this.colorId = _data["colorId"];
            this.dogChip = _data["dogChip"];
            this.pedigree = _data["pedigree"];
            this.name = _data["name"];
            this.breedGroup = _data["breedGroup"];
            this.breedGroupId = _data["breedGroupId"];
        }
    }

    static fromJS(data: any): KennelDogDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelDogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["kennelType"] = this.kennelType;
        data["breed"] = this.breed;
        data["breedId"] = this.breedId;
        data["color"] = this.color;
        data["colorId"] = this.colorId;
        data["dogChip"] = this.dogChip;
        data["pedigree"] = this.pedigree;
        data["name"] = this.name;
        data["breedGroup"] = this.breedGroup;
        data["breedGroupId"] = this.breedGroupId;
        return data;
    }
}

export interface IKennelDogDto {
    dogId?: number;
    kennelType?: EKennelType;
    breed?: string | undefined;
    breedId?: number;
    color?: string | undefined;
    colorId?: number;
    dogChip?: string | undefined;
    pedigree?: string | undefined;
    name?: string | undefined;
    breedGroup?: string | undefined;
    breedGroupId?: number;
}

export class KennelDogSearch extends PaginatedSearch implements IKennelDogSearch {
    languageId?: number;
    kennelId?: number;

    constructor(data?: IKennelDogSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.kennelId = _data["kennelId"];
        }
    }

    static fromJS(data: any): KennelDogSearch {
        data = typeof data === 'object' ? data : {};
        let result = new KennelDogSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["kennelId"] = this.kennelId;
        super.toJSON(data);
        return data;
    }
}

export interface IKennelDogSearch extends IPaginatedSearch {
    languageId?: number;
    kennelId?: number;
}

export class PaginatedResultsOfKennelOwnerDto implements IPaginatedResultsOfKennelOwnerDto {
    totalCount?: number;
    results?: KennelOwnerDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfKennelOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(KennelOwnerDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfKennelOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfKennelOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfKennelOwnerDto {
    totalCount?: number;
    results?: KennelOwnerDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class KennelOwnerDto implements IKennelOwnerDto {
    kennelOwnershipId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
    name?: string | undefined;

    constructor(data?: IKennelOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelOwnershipId = _data["kennelOwnershipId"];
            this.personId = _data["personId"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): KennelOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new KennelOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelOwnershipId"] = this.kennelOwnershipId;
        data["personId"] = this.personId;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IKennelOwnerDto {
    kennelOwnershipId?: number;
    personId?: number;
    ownerFrom?: Date | undefined;
    ownerTo?: Date | undefined;
    name?: string | undefined;
}

export class KennelOwnerSearch extends PaginatedSearch implements IKennelOwnerSearch {
    kennelId?: number;

    constructor(data?: IKennelOwnerSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kennelId = _data["kennelId"];
        }
    }

    static fromJS(data: any): KennelOwnerSearch {
        data = typeof data === 'object' ? data : {};
        let result = new KennelOwnerSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelId"] = this.kennelId;
        super.toJSON(data);
        return data;
    }
}

export interface IKennelOwnerSearch extends IPaginatedSearch {
    kennelId?: number;
}

export class LanguageDto implements ILanguageDto {
    languageId?: number;
    languageCode?: string | undefined;
    bcLanguageCode?: string | undefined;
    orderIndex?: number | undefined;
    hasTranslation?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    languageTranslations?: LanguageTranslationDto[] | undefined;

    constructor(data?: ILanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
            this.bcLanguageCode = _data["bcLanguageCode"];
            this.orderIndex = _data["orderIndex"];
            this.hasTranslation = _data["hasTranslation"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["languageTranslations"])) {
                this.languageTranslations = [] as any;
                for (let item of _data["languageTranslations"])
                    this.languageTranslations!.push(LanguageTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        data["bcLanguageCode"] = this.bcLanguageCode;
        data["orderIndex"] = this.orderIndex;
        data["hasTranslation"] = this.hasTranslation;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.languageTranslations)) {
            data["languageTranslations"] = [];
            for (let item of this.languageTranslations)
                data["languageTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILanguageDto {
    languageId?: number;
    languageCode?: string | undefined;
    bcLanguageCode?: string | undefined;
    orderIndex?: number | undefined;
    hasTranslation?: boolean;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    languageTranslations?: LanguageTranslationDto[] | undefined;
}

export class LanguageTranslationDto implements ILanguageTranslationDto {
    languageTranslationId?: number;
    languageId?: number;
    translationLanguageId?: number;
    text?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;

    constructor(data?: ILanguageTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageTranslationId = _data["languageTranslationId"];
            this.languageId = _data["languageId"];
            this.translationLanguageId = _data["translationLanguageId"];
            this.text = _data["text"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): LanguageTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageTranslationId"] = this.languageTranslationId;
        data["languageId"] = this.languageId;
        data["translationLanguageId"] = this.translationLanguageId;
        data["text"] = this.text;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface ILanguageTranslationDto {
    languageTranslationId?: number;
    languageId?: number;
    translationLanguageId?: number;
    text?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
}

export class PaginatedResultsOfLanguageGridDto implements IPaginatedResultsOfLanguageGridDto {
    totalCount?: number;
    results?: LanguageGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfLanguageGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LanguageGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfLanguageGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfLanguageGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfLanguageGridDto {
    totalCount?: number;
    results?: LanguageGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class LanguageGridDto implements ILanguageGridDto {
    languageId?: number;
    languageCode?: string | undefined;
    name?: string | undefined;

    constructor(data?: ILanguageGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.languageCode = _data["languageCode"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LanguageGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["languageCode"] = this.languageCode;
        data["name"] = this.name;
        return data;
    }
}

export interface ILanguageGridDto {
    languageId?: number;
    languageCode?: string | undefined;
    name?: string | undefined;
}

export class LanguageSearchDto extends PaginatedSearch implements ILanguageSearchDto {
    languageCode?: TextSearch | undefined;
    name?: TextSearch | undefined;
    languageId?: number;

    constructor(data?: ILanguageSearchDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"] ? TextSearch.fromJS(_data["languageCode"]) : <any>undefined;
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): LanguageSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode ? this.languageCode.toJSON() : <any>undefined;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ILanguageSearchDto extends IPaginatedSearch {
    languageCode?: TextSearch | undefined;
    name?: TextSearch | undefined;
    languageId?: number;
}

export class LinkedRequestsSearch extends PaginatedSearch implements ILinkedRequestsSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    masterRequestId?: number;

    constructor(data?: ILinkedRequestsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestTypeId = _data["requestTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["requestTypeId"]) : <any>undefined;
            this.masterRequestId = _data["masterRequestId"];
        }
    }

    static fromJS(data: any): LinkedRequestsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedRequestsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestTypeId"] = this.requestTypeId ? this.requestTypeId.toJSON() : <any>undefined;
        data["masterRequestId"] = this.masterRequestId;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkedRequestsSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    masterRequestId?: number;
}

export class PaginatedResultsOfMailLogGridDto implements IPaginatedResultsOfMailLogGridDto {
    totalCount?: number;
    results?: MailLogGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMailLogGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MailLogGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMailLogGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMailLogGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfMailLogGridDto {
    totalCount?: number;
    results?: MailLogGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class MailLogGridDto implements IMailLogGridDto {
    mailLogId?: number;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    replyTo?: string | undefined;
    attachments?: string | undefined;
    forceRecipients?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    failed?: boolean;
    errorMessage?: string | undefined;
    sentOn?: Date;

    constructor(data?: IMailLogGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailLogId = _data["mailLogId"];
            this.to = _data["to"];
            this.cc = _data["cc"];
            this.bcc = _data["bcc"];
            this.replyTo = _data["replyTo"];
            this.attachments = _data["attachments"];
            this.forceRecipients = _data["forceRecipients"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.failed = _data["failed"];
            this.errorMessage = _data["errorMessage"];
            this.sentOn = _data["sentOn"] ? new Date(_data["sentOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MailLogGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailLogGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailLogId"] = this.mailLogId;
        data["to"] = this.to;
        data["cc"] = this.cc;
        data["bcc"] = this.bcc;
        data["replyTo"] = this.replyTo;
        data["attachments"] = this.attachments;
        data["forceRecipients"] = this.forceRecipients;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["failed"] = this.failed;
        data["errorMessage"] = this.errorMessage;
        data["sentOn"] = this.sentOn ? this.sentOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMailLogGridDto {
    mailLogId?: number;
    to?: string | undefined;
    cc?: string | undefined;
    bcc?: string | undefined;
    replyTo?: string | undefined;
    attachments?: string | undefined;
    forceRecipients?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    failed?: boolean;
    errorMessage?: string | undefined;
    sentOn?: Date;
}

export class MailSearch extends PaginatedSearch implements IMailSearch {
    requestId?: number | undefined;
    to?: TextSearch | undefined;
    cc?: TextSearch | undefined;
    bcc?: TextSearch | undefined;
    replyTo?: TextSearch | undefined;
    attachments?: TextSearch | undefined;
    forceRecipients?: TextSearch | undefined;
    subject?: TextSearch | undefined;
    body?: TextSearch | undefined;
    sentOn?: DateSearch | undefined;

    constructor(data?: IMailSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestId = _data["requestId"];
            this.to = _data["to"] ? TextSearch.fromJS(_data["to"]) : <any>undefined;
            this.cc = _data["cc"] ? TextSearch.fromJS(_data["cc"]) : <any>undefined;
            this.bcc = _data["bcc"] ? TextSearch.fromJS(_data["bcc"]) : <any>undefined;
            this.replyTo = _data["replyTo"] ? TextSearch.fromJS(_data["replyTo"]) : <any>undefined;
            this.attachments = _data["attachments"] ? TextSearch.fromJS(_data["attachments"]) : <any>undefined;
            this.forceRecipients = _data["forceRecipients"] ? TextSearch.fromJS(_data["forceRecipients"]) : <any>undefined;
            this.subject = _data["subject"] ? TextSearch.fromJS(_data["subject"]) : <any>undefined;
            this.body = _data["body"] ? TextSearch.fromJS(_data["body"]) : <any>undefined;
            this.sentOn = _data["sentOn"] ? DateSearch.fromJS(_data["sentOn"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailSearch {
        data = typeof data === 'object' ? data : {};
        let result = new MailSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["to"] = this.to ? this.to.toJSON() : <any>undefined;
        data["cc"] = this.cc ? this.cc.toJSON() : <any>undefined;
        data["bcc"] = this.bcc ? this.bcc.toJSON() : <any>undefined;
        data["replyTo"] = this.replyTo ? this.replyTo.toJSON() : <any>undefined;
        data["attachments"] = this.attachments ? this.attachments.toJSON() : <any>undefined;
        data["forceRecipients"] = this.forceRecipients ? this.forceRecipients.toJSON() : <any>undefined;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["body"] = this.body ? this.body.toJSON() : <any>undefined;
        data["sentOn"] = this.sentOn ? this.sentOn.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMailSearch extends IPaginatedSearch {
    requestId?: number | undefined;
    to?: TextSearch | undefined;
    cc?: TextSearch | undefined;
    bcc?: TextSearch | undefined;
    replyTo?: TextSearch | undefined;
    attachments?: TextSearch | undefined;
    forceRecipients?: TextSearch | undefined;
    subject?: TextSearch | undefined;
    body?: TextSearch | undefined;
    sentOn?: DateSearch | undefined;
}

export class PaginatedResultsOfPersonMembershipHistoryGridDto implements IPaginatedResultsOfPersonMembershipHistoryGridDto {
    totalCount?: number;
    results?: PersonMembershipHistoryGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonMembershipHistoryGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonMembershipHistoryGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonMembershipHistoryGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonMembershipHistoryGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonMembershipHistoryGridDto {
    totalCount?: number;
    results?: PersonMembershipHistoryGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonMembershipHistoryGridDto implements IPersonMembershipHistoryGridDto {
    membershipHistoryId?: number;
    membershipTypeId?: number;
    membershipRequestId?: number | undefined;
    requestNumber?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    membershipType?: string | undefined;
    endOfRenewalAsked?: boolean;

    constructor(data?: IPersonMembershipHistoryGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipHistoryId = _data["membershipHistoryId"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.membershipRequestId = _data["membershipRequestId"];
            this.requestNumber = _data["requestNumber"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.membershipType = _data["membershipType"];
            this.endOfRenewalAsked = _data["endOfRenewalAsked"];
        }
    }

    static fromJS(data: any): PersonMembershipHistoryGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonMembershipHistoryGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipHistoryId"] = this.membershipHistoryId;
        data["membershipTypeId"] = this.membershipTypeId;
        data["membershipRequestId"] = this.membershipRequestId;
        data["requestNumber"] = this.requestNumber;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["membershipType"] = this.membershipType;
        data["endOfRenewalAsked"] = this.endOfRenewalAsked;
        return data;
    }
}

export interface IPersonMembershipHistoryGridDto {
    membershipHistoryId?: number;
    membershipTypeId?: number;
    membershipRequestId?: number | undefined;
    requestNumber?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    membershipType?: string | undefined;
    endOfRenewalAsked?: boolean;
}

export class BasePersonSearch extends PaginatedSearch implements IBasePersonSearch {
    personId?: number;
    languageId?: number;

    constructor(data?: IBasePersonSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): BasePersonSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BasePersonSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IBasePersonSearch extends IPaginatedSearch {
    personId?: number;
    languageId?: number;
}

export class SaveMembershipHistoryDto implements ISaveMembershipHistoryDto {
    membershipHistoryId?: number;
    membershipId?: number;
    membershipTypeId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    personId?: number;

    constructor(data?: ISaveMembershipHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipHistoryId = _data["membershipHistoryId"];
            this.membershipId = _data["membershipId"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): SaveMembershipHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMembershipHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipHistoryId"] = this.membershipHistoryId;
        data["membershipId"] = this.membershipId;
        data["membershipTypeId"] = this.membershipTypeId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        return data;
    }
}

export interface ISaveMembershipHistoryDto {
    membershipHistoryId?: number;
    membershipId?: number;
    membershipTypeId?: number;
    dateFrom?: Date;
    dateTo?: Date;
    personId?: number;
}

export class PaginatedResultsOfMembershipRenewalGridDto implements IPaginatedResultsOfMembershipRenewalGridDto {
    totalCount?: number;
    results?: MembershipRenewalGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMembershipRenewalGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MembershipRenewalGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMembershipRenewalGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMembershipRenewalGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfMembershipRenewalGridDto {
    totalCount?: number;
    results?: MembershipRenewalGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class MembershipRenewalGridDto implements IMembershipRenewalGridDto {
    memberId?: number;
    personId?: number;
    membershipTypeId?: number;
    endOfRenewalAsked?: boolean;
    isRenewalForced?: boolean | undefined;
    member?: string | undefined;
    deathDate?: Date | undefined;
    autoRenewal?: boolean;

    constructor(data?: IMembershipRenewalGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.personId = _data["personId"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.endOfRenewalAsked = _data["endOfRenewalAsked"];
            this.isRenewalForced = _data["isRenewalForced"];
            this.member = _data["member"];
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.autoRenewal = _data["autoRenewal"];
        }
    }

    static fromJS(data: any): MembershipRenewalGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRenewalGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["personId"] = this.personId;
        data["membershipTypeId"] = this.membershipTypeId;
        data["endOfRenewalAsked"] = this.endOfRenewalAsked;
        data["isRenewalForced"] = this.isRenewalForced;
        data["member"] = this.member;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["autoRenewal"] = this.autoRenewal;
        return data;
    }
}

export interface IMembershipRenewalGridDto {
    memberId?: number;
    personId?: number;
    membershipTypeId?: number;
    endOfRenewalAsked?: boolean;
    isRenewalForced?: boolean | undefined;
    member?: string | undefined;
    deathDate?: Date | undefined;
    autoRenewal?: boolean;
}

export class MembershipRenewalSearch extends PaginatedSearch implements IMembershipRenewalSearch {

    constructor(data?: IMembershipRenewalSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MembershipRenewalSearch {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRenewalSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMembershipRenewalSearch extends IPaginatedSearch {
}

export class PaginatedResultsOfMembershipRequestGridDto implements IPaginatedResultsOfMembershipRequestGridDto {
    totalCount?: number;
    results?: MembershipRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMembershipRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MembershipRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMembershipRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMembershipRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfMembershipRequestGridDto {
    totalCount?: number;
    results?: MembershipRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class MembershipRequestGridDto implements IMembershipRequestGridDto {
    membershipRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    membershipType?: string | undefined;
    membershipTypeId?: number;
    membershipRequestType?: string | undefined;
    membershipRequestTypeId?: number;
    invoiceNumber?: string | undefined;

    constructor(data?: IMembershipRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestId = _data["membershipRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.membershipType = _data["membershipType"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.membershipRequestType = _data["membershipRequestType"];
            this.membershipRequestTypeId = _data["membershipRequestTypeId"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): MembershipRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestId"] = this.membershipRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["membershipType"] = this.membershipType;
        data["membershipTypeId"] = this.membershipTypeId;
        data["membershipRequestType"] = this.membershipRequestType;
        data["membershipRequestTypeId"] = this.membershipRequestTypeId;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IMembershipRequestGridDto {
    membershipRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    membershipType?: string | undefined;
    membershipTypeId?: number;
    membershipRequestType?: string | undefined;
    membershipRequestTypeId?: number;
    invoiceNumber?: string | undefined;
}

export class MembershipRequestSearch extends PaginatedSearch implements IMembershipRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    membershipRequestTypeId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IMembershipRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.membershipRequestTypeId = _data["membershipRequestTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["membershipRequestTypeId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["membershipRequestTypeId"] = this.membershipRequestTypeId ? this.membershipRequestTypeId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMembershipRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    membershipRequestTypeId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class MembershipRequestDto implements IMembershipRequestDto {
    membershipRequestId?: number;
    requestId?: number;
    membershipRequestDecisionId?: number | undefined;
    membershipInitialTypeId?: number;
    membershipFinalTypeId?: number | undefined;
    membershipRequestTypeId?: number;
    meetingDate?: Date | undefined;
    request?: RequestDto | undefined;

    constructor(data?: IMembershipRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipRequestId = _data["membershipRequestId"];
            this.requestId = _data["requestId"];
            this.membershipRequestDecisionId = _data["membershipRequestDecisionId"];
            this.membershipInitialTypeId = _data["membershipInitialTypeId"];
            this.membershipFinalTypeId = _data["membershipFinalTypeId"];
            this.membershipRequestTypeId = _data["membershipRequestTypeId"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipRequestId"] = this.membershipRequestId;
        data["requestId"] = this.requestId;
        data["membershipRequestDecisionId"] = this.membershipRequestDecisionId;
        data["membershipInitialTypeId"] = this.membershipInitialTypeId;
        data["membershipFinalTypeId"] = this.membershipFinalTypeId;
        data["membershipRequestTypeId"] = this.membershipRequestTypeId;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMembershipRequestDto {
    membershipRequestId?: number;
    requestId?: number;
    membershipRequestDecisionId?: number | undefined;
    membershipInitialTypeId?: number;
    membershipFinalTypeId?: number | undefined;
    membershipRequestTypeId?: number;
    meetingDate?: Date | undefined;
    request?: RequestDto | undefined;
}

export class PaginatedResultsOfMiscellaneousRequestGridDto implements IPaginatedResultsOfMiscellaneousRequestGridDto {
    totalCount?: number;
    results?: MiscellaneousRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfMiscellaneousRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MiscellaneousRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfMiscellaneousRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfMiscellaneousRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfMiscellaneousRequestGridDto {
    totalCount?: number;
    results?: MiscellaneousRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class MiscellaneousRequestGridDto implements IMiscellaneousRequestGridDto {
    miscellaneousRequestId?: number;
    requestId?: number;
    requestStateId?: number;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequest?: string | undefined;
    parentRequestTypeCode?: ERequestType;
    personId?: number;
    contact?: string | undefined;
    article?: string | undefined;
    articleId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    price?: number;
    invoiceNumber?: string | undefined;

    constructor(data?: IMiscellaneousRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.miscellaneousRequestId = _data["miscellaneousRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateId = _data["requestStateId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestState = _data["requestState"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequest = _data["parentRequest"];
            this.parentRequestTypeCode = _data["parentRequestTypeCode"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.article = _data["article"];
            this.articleId = _data["articleId"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.price = _data["price"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): MiscellaneousRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new MiscellaneousRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["miscellaneousRequestId"] = this.miscellaneousRequestId;
        data["requestId"] = this.requestId;
        data["requestStateId"] = this.requestStateId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestState"] = this.requestState;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequest"] = this.parentRequest;
        data["parentRequestTypeCode"] = this.parentRequestTypeCode;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["article"] = this.article;
        data["articleId"] = this.articleId;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["price"] = this.price;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IMiscellaneousRequestGridDto {
    miscellaneousRequestId?: number;
    requestId?: number;
    requestStateId?: number;
    requestStateCode?: ERequestState;
    requestState?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequest?: string | undefined;
    parentRequestTypeCode?: ERequestType;
    personId?: number;
    contact?: string | undefined;
    article?: string | undefined;
    articleId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    price?: number;
    invoiceNumber?: string | undefined;
}

export class MiscellaneousRequestSearch extends PaginatedSearch implements IMiscellaneousRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    article?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IMiscellaneousRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.article = _data["article"] ? TextSearch.fromJS(_data["article"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MiscellaneousRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new MiscellaneousRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMiscellaneousRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    article?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class MiscellaneousRequestDto implements IMiscellaneousRequestDto {
    miscellaneousRequestId?: number;
    requestId?: number;
    articleId?: number;
    quantity?: number;
    request?: RequestDto | undefined;

    constructor(data?: IMiscellaneousRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.miscellaneousRequestId = _data["miscellaneousRequestId"];
            this.requestId = _data["requestId"];
            this.articleId = _data["articleId"];
            this.quantity = _data["quantity"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MiscellaneousRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MiscellaneousRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["miscellaneousRequestId"] = this.miscellaneousRequestId;
        data["requestId"] = this.requestId;
        data["articleId"] = this.articleId;
        data["quantity"] = this.quantity;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMiscellaneousRequestDto {
    miscellaneousRequestId?: number;
    requestId?: number;
    articleId?: number;
    quantity?: number;
    request?: RequestDto | undefined;
}

export class PaginatedResultsOfPedigreeDuplicataRequestGridDto implements IPaginatedResultsOfPedigreeDuplicataRequestGridDto {
    totalCount?: number;
    results?: PedigreeDuplicataRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPedigreeDuplicataRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PedigreeDuplicataRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPedigreeDuplicataRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPedigreeDuplicataRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPedigreeDuplicataRequestGridDto {
    totalCount?: number;
    results?: PedigreeDuplicataRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PedigreeDuplicataRequestGridDto implements IPedigreeDuplicataRequestGridDto {
    pedigreeDuplicataRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    dogName?: string | undefined;
    kennelName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
    isRenewal?: boolean;

    constructor(data?: IPedigreeDuplicataRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeDuplicataRequestId = _data["pedigreeDuplicataRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.dogName = _data["dogName"];
            this.kennelName = _data["kennelName"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.isRenewal = _data["isRenewal"];
        }
    }

    static fromJS(data: any): PedigreeDuplicataRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeDuplicataRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeDuplicataRequestId"] = this.pedigreeDuplicataRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["dogName"] = this.dogName;
        data["kennelName"] = this.kennelName;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        data["isRenewal"] = this.isRenewal;
        return data;
    }
}

export interface IPedigreeDuplicataRequestGridDto {
    pedigreeDuplicataRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    dogName?: string | undefined;
    kennelName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
    isRenewal?: boolean;
}

export class PedigreeDuplicataRequestSearch extends PaginatedSearch implements IPedigreeDuplicataRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    isRenewal?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IPedigreeDuplicataRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.isRenewal = _data["isRenewal"] ? BooleanSearch.fromJS(_data["isRenewal"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PedigreeDuplicataRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeDuplicataRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["isRenewal"] = this.isRenewal ? this.isRenewal.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPedigreeDuplicataRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    isRenewal?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class PedigreeDuplicataRequestDto implements IPedigreeDuplicataRequestDto {
    pedigreeDuplicataRequestId?: number;
    requestId?: number;
    dogId?: number;
    isRenewal?: boolean;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: IPedigreeDuplicataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeDuplicataRequestId = _data["pedigreeDuplicataRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.isRenewal = _data["isRenewal"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): PedigreeDuplicataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeDuplicataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeDuplicataRequestId"] = this.pedigreeDuplicataRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["isRenewal"] = this.isRenewal;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface IPedigreeDuplicataRequestDto {
    pedigreeDuplicataRequestId?: number;
    requestId?: number;
    dogId?: number;
    isRenewal?: boolean;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;
}

export class DrupalPedigreeDuplicataRequestDto implements IDrupalPedigreeDuplicataRequestDto {
    pedigreeDuplicataRequestId?: number;
    dogId?: number;
    request?: RequestDto | undefined;

    constructor(data?: IDrupalPedigreeDuplicataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeDuplicataRequestId = _data["pedigreeDuplicataRequestId"];
            this.dogId = _data["dogId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DrupalPedigreeDuplicataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalPedigreeDuplicataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeDuplicataRequestId"] = this.pedigreeDuplicataRequestId;
        data["dogId"] = this.dogId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDrupalPedigreeDuplicataRequestDto {
    pedigreeDuplicataRequestId?: number;
    dogId?: number;
    request?: RequestDto | undefined;
}

export class PaginatedResultsOfCountryPedigreePrefixGridDto implements IPaginatedResultsOfCountryPedigreePrefixGridDto {
    totalCount?: number;
    results?: CountryPedigreePrefixGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfCountryPedigreePrefixGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CountryPedigreePrefixGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfCountryPedigreePrefixGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfCountryPedigreePrefixGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfCountryPedigreePrefixGridDto {
    totalCount?: number;
    results?: CountryPedigreePrefixGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class CountryPedigreePrefixGridDto implements ICountryPedigreePrefixGridDto {
    countryPedigreePrefixId?: number;
    countryId?: number;
    prefix?: string | undefined;
    nextValue?: number;
    fciRecognized?: boolean;

    constructor(data?: ICountryPedigreePrefixGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.countryId = _data["countryId"];
            this.prefix = _data["prefix"];
            this.nextValue = _data["nextValue"];
            this.fciRecognized = _data["fciRecognized"];
        }
    }

    static fromJS(data: any): CountryPedigreePrefixGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryPedigreePrefixGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["countryId"] = this.countryId;
        data["prefix"] = this.prefix;
        data["nextValue"] = this.nextValue;
        data["fciRecognized"] = this.fciRecognized;
        return data;
    }
}

export interface ICountryPedigreePrefixGridDto {
    countryPedigreePrefixId?: number;
    countryId?: number;
    prefix?: string | undefined;
    nextValue?: number;
    fciRecognized?: boolean;
}

export class PedigreePrefixSearch extends PaginatedSearch implements IPedigreePrefixSearch {
    countryId?: number;

    constructor(data?: IPedigreePrefixSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): PedigreePrefixSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreePrefixSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        super.toJSON(data);
        return data;
    }
}

export interface IPedigreePrefixSearch extends IPaginatedSearch {
    countryId?: number;
}

export class SavePedigreePrefixDto implements ISavePedigreePrefixDto {
    countryPedigreePrefixId?: number;
    countryId?: number;
    prefix?: string | undefined;
    fciRecognized?: boolean;

    constructor(data?: ISavePedigreePrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryPedigreePrefixId = _data["countryPedigreePrefixId"];
            this.countryId = _data["countryId"];
            this.prefix = _data["prefix"];
            this.fciRecognized = _data["fciRecognized"];
        }
    }

    static fromJS(data: any): SavePedigreePrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavePedigreePrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryPedigreePrefixId"] = this.countryPedigreePrefixId;
        data["countryId"] = this.countryId;
        data["prefix"] = this.prefix;
        data["fciRecognized"] = this.fciRecognized;
        return data;
    }
}

export interface ISavePedigreePrefixDto {
    countryPedigreePrefixId?: number;
    countryId?: number;
    prefix?: string | undefined;
    fciRecognized?: boolean;
}

export class PaginatedResultsOfPedigreeRequestGridDto implements IPaginatedResultsOfPedigreeRequestGridDto {
    totalCount?: number;
    results?: PedigreeRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPedigreeRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PedigreeRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPedigreeRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPedigreeRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPedigreeRequestGridDto {
    totalCount?: number;
    results?: PedigreeRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PedigreeRequestGridDto implements IPedigreeRequestGridDto {
    pedigreeRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    kennelName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IPedigreeRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeRequestId = _data["pedigreeRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.kennelName = _data["kennelName"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): PedigreeRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeRequestId"] = this.pedigreeRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["kennelName"] = this.kennelName;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IPedigreeRequestGridDto {
    pedigreeRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    kennelName?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class PedigreeRequestSearch extends PaginatedSearch implements IPedigreeRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IPedigreeRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PedigreeRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPedigreeRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class PedigreeRequestDto implements IPedigreeRequestDto {
    pedigreeRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: RequestDto | undefined;
    transientOwnerIds?: number[] | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: IPedigreeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pedigreeRequestId = _data["pedigreeRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientOwnerIds"])) {
                this.transientOwnerIds = [] as any;
                for (let item of _data["transientOwnerIds"])
                    this.transientOwnerIds!.push(item);
            }
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): PedigreeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PedigreeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pedigreeRequestId"] = this.pedigreeRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientOwnerIds)) {
            data["transientOwnerIds"] = [];
            for (let item of this.transientOwnerIds)
                data["transientOwnerIds"].push(item);
        }
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface IPedigreeRequestDto {
    pedigreeRequestId?: number;
    requestId?: number;
    dogId?: number;
    request?: RequestDto | undefined;
    transientOwnerIds?: number[] | undefined;
    dogSharepointUri?: string | undefined;
}

export class PaginatedResultsOfUserProfileActionGridDto implements IPaginatedResultsOfUserProfileActionGridDto {
    totalCount?: number;
    results?: UserProfileActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserProfileActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserProfileActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserProfileActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserProfileActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfUserProfileActionGridDto {
    totalCount?: number;
    results?: UserProfileActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class UserProfileActionGridDto implements IUserProfileActionGridDto {
    module?: string | undefined;
    tab?: string | undefined;
    actionId?: number | undefined;
    userProfileId?: number | undefined;
    executable?: boolean;
    permission?: EPermission | undefined;

    constructor(data?: IUserProfileActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"];
            this.tab = _data["tab"];
            this.actionId = _data["actionId"];
            this.userProfileId = _data["userProfileId"];
            this.executable = _data["executable"];
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): UserProfileActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module;
        data["tab"] = this.tab;
        data["actionId"] = this.actionId;
        data["userProfileId"] = this.userProfileId;
        data["executable"] = this.executable;
        data["permission"] = this.permission;
        return data;
    }
}

export interface IUserProfileActionGridDto {
    module?: string | undefined;
    tab?: string | undefined;
    actionId?: number | undefined;
    userProfileId?: number | undefined;
    executable?: boolean;
    permission?: EPermission | undefined;
}

export class UserProfileActionSearch extends PaginatedSearch implements IUserProfileActionSearch {
    userProfileId?: number | undefined;

    constructor(data?: IUserProfileActionSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userProfileId = _data["userProfileId"];
        }
    }

    static fromJS(data: any): UserProfileActionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileActionSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfileId"] = this.userProfileId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserProfileActionSearch extends IPaginatedSearch {
    userProfileId?: number | undefined;
}

export class PaginatedResultsOfPersonActionGridDto implements IPaginatedResultsOfPersonActionGridDto {
    totalCount?: number;
    results?: PersonActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonActionGridDto {
    totalCount?: number;
    results?: PersonActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonActionGridDto implements IPersonActionGridDto {
    actionTime?: Date;
    action?: string | undefined;

    constructor(data?: IPersonActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): PersonActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface IPersonActionGridDto {
    actionTime?: Date;
    action?: string | undefined;
}

export class PersonSearch extends PaginatedSearch implements IPersonSearch {
    languageId?: number;
    kennelId?: number | undefined;
    computedName?: TextSearch | undefined;
    email?: TextSearch | undefined;
    phoneNumber?: TextSearch | undefined;
    mobilePhoneNumber?: TextSearch | undefined;
    postalCode?: TextSearch | undefined;
    isMember?: BooleanSearch | undefined;
    isKnownPerson?: BooleanSearch | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;

    constructor(data?: IPersonSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.kennelId = _data["kennelId"];
            this.computedName = _data["computedName"] ? TextSearch.fromJS(_data["computedName"]) : <any>undefined;
            this.email = _data["email"] ? TextSearch.fromJS(_data["email"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"] ? TextSearch.fromJS(_data["phoneNumber"]) : <any>undefined;
            this.mobilePhoneNumber = _data["mobilePhoneNumber"] ? TextSearch.fromJS(_data["mobilePhoneNumber"]) : <any>undefined;
            this.postalCode = _data["postalCode"] ? TextSearch.fromJS(_data["postalCode"]) : <any>undefined;
            this.isMember = _data["isMember"] ? BooleanSearch.fromJS(_data["isMember"]) : <any>undefined;
            this.isKnownPerson = _data["isKnownPerson"] ? BooleanSearch.fromJS(_data["isKnownPerson"]) : <any>undefined;
            if (Array.isArray(_data["selectedIds"])) {
                this.selectedIds = [] as any;
                for (let item of _data["selectedIds"])
                    this.selectedIds!.push(item);
            }
            this.excludeSelectedIds = _data["excludeSelectedIds"];
        }
    }

    static fromJS(data: any): PersonSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["kennelId"] = this.kennelId;
        data["computedName"] = this.computedName ? this.computedName.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber ? this.phoneNumber.toJSON() : <any>undefined;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber ? this.mobilePhoneNumber.toJSON() : <any>undefined;
        data["postalCode"] = this.postalCode ? this.postalCode.toJSON() : <any>undefined;
        data["isMember"] = this.isMember ? this.isMember.toJSON() : <any>undefined;
        data["isKnownPerson"] = this.isKnownPerson ? this.isKnownPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedIds)) {
            data["selectedIds"] = [];
            for (let item of this.selectedIds)
                data["selectedIds"].push(item);
        }
        data["excludeSelectedIds"] = this.excludeSelectedIds;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonSearch extends IPaginatedSearch {
    languageId?: number;
    kennelId?: number | undefined;
    computedName?: TextSearch | undefined;
    email?: TextSearch | undefined;
    phoneNumber?: TextSearch | undefined;
    mobilePhoneNumber?: TextSearch | undefined;
    postalCode?: TextSearch | undefined;
    isMember?: BooleanSearch | undefined;
    isKnownPerson?: BooleanSearch | undefined;
    selectedIds?: number[] | undefined;
    excludeSelectedIds?: boolean;
}

export class PaginatedResultsOfPersonWithValidationsGridDto implements IPaginatedResultsOfPersonWithValidationsGridDto {
    totalCount?: number;
    results?: PersonWithValidationsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonWithValidationsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonWithValidationsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonWithValidationsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonWithValidationsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonWithValidationsGridDto {
    totalCount?: number;
    results?: PersonWithValidationsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonWithValidationsGridDto extends PersonGridDto implements IPersonWithValidationsGridDto {
    isKennelOwner?: boolean;
    isNotBelgian?: boolean;
    isOwnerOfSpecificKennel?: boolean;

    constructor(data?: IPersonWithValidationsGridDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isKennelOwner = _data["isKennelOwner"];
            this.isNotBelgian = _data["isNotBelgian"];
            this.isOwnerOfSpecificKennel = _data["isOwnerOfSpecificKennel"];
        }
    }

    static fromJS(data: any): PersonWithValidationsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonWithValidationsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isKennelOwner"] = this.isKennelOwner;
        data["isNotBelgian"] = this.isNotBelgian;
        data["isOwnerOfSpecificKennel"] = this.isOwnerOfSpecificKennel;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonWithValidationsGridDto extends IPersonGridDto {
    isKennelOwner?: boolean;
    isNotBelgian?: boolean;
    isOwnerOfSpecificKennel?: boolean;
}

export class PaginatedResultsOfDogPersonGridDto implements IPaginatedResultsOfDogPersonGridDto {
    totalCount?: number;
    results?: DogPersonGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogPersonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogPersonGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogPersonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogPersonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogPersonGridDto {
    totalCount?: number;
    results?: DogPersonGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogPersonGridDto implements IDogPersonGridDto {
    dogId?: number;
    name?: string | undefined;
    breedName?: string | undefined;
    sex?: EDogSex;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    dogChip?: string | undefined;

    constructor(data?: IDogPersonGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.name = _data["name"];
            this.breedName = _data["breedName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
            this.dogChip = _data["dogChip"];
        }
    }

    static fromJS(data: any): DogPersonGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DogPersonGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["name"] = this.name;
        data["breedName"] = this.breedName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["dogChip"] = this.dogChip;
        return data;
    }
}

export interface IDogPersonGridDto {
    dogId?: number;
    name?: string | undefined;
    breedName?: string | undefined;
    sex?: EDogSex;
    birthDate?: Date | undefined;
    deathDate?: Date | undefined;
    dogChip?: string | undefined;
}

export class PersonDogsSearch extends PaginatedSearch implements IPersonDogsSearch {
    personId?: number;
    hideDead?: boolean;

    constructor(data?: IPersonDogsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.hideDead = _data["hideDead"];
        }
    }

    static fromJS(data: any): PersonDogsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDogsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["hideDead"] = this.hideDead;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonDogsSearch extends IPaginatedSearch {
    personId?: number;
    hideDead?: boolean;
}

export class CommissionerDto implements ICommissionerDto {
    commissionerId?: number;
    personId?: number;
    commissionerExperience?: ECommissionerExperience | undefined;
    spokenLanguageIds?: number[] | undefined;

    constructor(data?: ICommissionerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionerId = _data["commissionerId"];
            this.personId = _data["personId"];
            this.commissionerExperience = _data["commissionerExperience"];
            if (Array.isArray(_data["spokenLanguageIds"])) {
                this.spokenLanguageIds = [] as any;
                for (let item of _data["spokenLanguageIds"])
                    this.spokenLanguageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CommissionerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commissionerId"] = this.commissionerId;
        data["personId"] = this.personId;
        data["commissionerExperience"] = this.commissionerExperience;
        if (Array.isArray(this.spokenLanguageIds)) {
            data["spokenLanguageIds"] = [];
            for (let item of this.spokenLanguageIds)
                data["spokenLanguageIds"].push(item);
        }
        return data;
    }
}

export interface ICommissionerDto {
    commissionerId?: number;
    personId?: number;
    commissionerExperience?: ECommissionerExperience | undefined;
    spokenLanguageIds?: number[] | undefined;
}

export class SplitPersonDto implements ISplitPersonDto {
    originalId?: number;
    originalPerson?: PersonDto | undefined;
    copyPerson?: PersonDto | undefined;
    copyPersonMember?: boolean;
    copyPersonJudge?: boolean;
    copyPersonVet?: boolean;

    constructor(data?: ISplitPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalId = _data["originalId"];
            this.originalPerson = _data["originalPerson"] ? PersonDto.fromJS(_data["originalPerson"]) : <any>undefined;
            this.copyPerson = _data["copyPerson"] ? PersonDto.fromJS(_data["copyPerson"]) : <any>undefined;
            this.copyPersonMember = _data["copyPersonMember"];
            this.copyPersonJudge = _data["copyPersonJudge"];
            this.copyPersonVet = _data["copyPersonVet"];
        }
    }

    static fromJS(data: any): SplitPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplitPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalId"] = this.originalId;
        data["originalPerson"] = this.originalPerson ? this.originalPerson.toJSON() : <any>undefined;
        data["copyPerson"] = this.copyPerson ? this.copyPerson.toJSON() : <any>undefined;
        data["copyPersonMember"] = this.copyPersonMember;
        data["copyPersonJudge"] = this.copyPersonJudge;
        data["copyPersonVet"] = this.copyPersonVet;
        return data;
    }
}

export interface ISplitPersonDto {
    originalId?: number;
    originalPerson?: PersonDto | undefined;
    copyPerson?: PersonDto | undefined;
    copyPersonMember?: boolean;
    copyPersonJudge?: boolean;
    copyPersonVet?: boolean;
}

export class PersonFusionDto implements IPersonFusionDto {
    fusion?: PersonDto | undefined;
    personId1?: number;
    personId2?: number;
    portalPersonId?: number | undefined;
    membershipPersonId?: number | undefined;
    judgePersonId?: number | undefined;
    commissionerPersonId?: number | undefined;
    vetPersonId?: number | undefined;
    membershipDisabled?: boolean;
    judgeDisabled?: boolean;
    commissionerDisabled?: boolean;
    vetDisabled?: boolean;
    portalDisabled?: boolean;
    breederPersonId?: number | undefined;
    breederDisabled?: boolean;

    constructor(data?: IPersonFusionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fusion = _data["fusion"] ? PersonDto.fromJS(_data["fusion"]) : <any>undefined;
            this.personId1 = _data["personId1"];
            this.personId2 = _data["personId2"];
            this.portalPersonId = _data["portalPersonId"];
            this.membershipPersonId = _data["membershipPersonId"];
            this.judgePersonId = _data["judgePersonId"];
            this.commissionerPersonId = _data["commissionerPersonId"];
            this.vetPersonId = _data["vetPersonId"];
            this.membershipDisabled = _data["membershipDisabled"];
            this.judgeDisabled = _data["judgeDisabled"];
            this.commissionerDisabled = _data["commissionerDisabled"];
            this.vetDisabled = _data["vetDisabled"];
            this.portalDisabled = _data["portalDisabled"];
            this.breederPersonId = _data["breederPersonId"];
            this.breederDisabled = _data["breederDisabled"];
        }
    }

    static fromJS(data: any): PersonFusionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonFusionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fusion"] = this.fusion ? this.fusion.toJSON() : <any>undefined;
        data["personId1"] = this.personId1;
        data["personId2"] = this.personId2;
        data["portalPersonId"] = this.portalPersonId;
        data["membershipPersonId"] = this.membershipPersonId;
        data["judgePersonId"] = this.judgePersonId;
        data["commissionerPersonId"] = this.commissionerPersonId;
        data["vetPersonId"] = this.vetPersonId;
        data["membershipDisabled"] = this.membershipDisabled;
        data["judgeDisabled"] = this.judgeDisabled;
        data["commissionerDisabled"] = this.commissionerDisabled;
        data["vetDisabled"] = this.vetDisabled;
        data["portalDisabled"] = this.portalDisabled;
        data["breederPersonId"] = this.breederPersonId;
        data["breederDisabled"] = this.breederDisabled;
        return data;
    }
}

export interface IPersonFusionDto {
    fusion?: PersonDto | undefined;
    personId1?: number;
    personId2?: number;
    portalPersonId?: number | undefined;
    membershipPersonId?: number | undefined;
    judgePersonId?: number | undefined;
    commissionerPersonId?: number | undefined;
    vetPersonId?: number | undefined;
    membershipDisabled?: boolean;
    judgeDisabled?: boolean;
    commissionerDisabled?: boolean;
    vetDisabled?: boolean;
    portalDisabled?: boolean;
    breederPersonId?: number | undefined;
    breederDisabled?: boolean;
}

export class PersonFusionComparisonDto implements IPersonFusionComparisonDto {
    fusingPerson1?: PersonDto | undefined;
    fusingPerson2?: PersonDto | undefined;
    fusingPerson1HasDogs?: boolean;
    fusingPerson2HasDogs?: boolean;
    fusingPerson1BreederHasDogs?: boolean;
    fusingPerson2BreederHasDogs?: boolean;
    fusingPerson1HasRequests?: boolean;
    fusingPerson2HasRequests?: boolean;
    fusingPerson1HasKennel?: boolean;
    fusingPerson2HasKennel?: boolean;

    constructor(data?: IPersonFusionComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fusingPerson1 = _data["fusingPerson1"] ? PersonDto.fromJS(_data["fusingPerson1"]) : <any>undefined;
            this.fusingPerson2 = _data["fusingPerson2"] ? PersonDto.fromJS(_data["fusingPerson2"]) : <any>undefined;
            this.fusingPerson1HasDogs = _data["fusingPerson1HasDogs"];
            this.fusingPerson2HasDogs = _data["fusingPerson2HasDogs"];
            this.fusingPerson1BreederHasDogs = _data["fusingPerson1BreederHasDogs"];
            this.fusingPerson2BreederHasDogs = _data["fusingPerson2BreederHasDogs"];
            this.fusingPerson1HasRequests = _data["fusingPerson1HasRequests"];
            this.fusingPerson2HasRequests = _data["fusingPerson2HasRequests"];
            this.fusingPerson1HasKennel = _data["fusingPerson1HasKennel"];
            this.fusingPerson2HasKennel = _data["fusingPerson2HasKennel"];
        }
    }

    static fromJS(data: any): PersonFusionComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonFusionComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fusingPerson1"] = this.fusingPerson1 ? this.fusingPerson1.toJSON() : <any>undefined;
        data["fusingPerson2"] = this.fusingPerson2 ? this.fusingPerson2.toJSON() : <any>undefined;
        data["fusingPerson1HasDogs"] = this.fusingPerson1HasDogs;
        data["fusingPerson2HasDogs"] = this.fusingPerson2HasDogs;
        data["fusingPerson1BreederHasDogs"] = this.fusingPerson1BreederHasDogs;
        data["fusingPerson2BreederHasDogs"] = this.fusingPerson2BreederHasDogs;
        data["fusingPerson1HasRequests"] = this.fusingPerson1HasRequests;
        data["fusingPerson2HasRequests"] = this.fusingPerson2HasRequests;
        data["fusingPerson1HasKennel"] = this.fusingPerson1HasKennel;
        data["fusingPerson2HasKennel"] = this.fusingPerson2HasKennel;
        return data;
    }
}

export interface IPersonFusionComparisonDto {
    fusingPerson1?: PersonDto | undefined;
    fusingPerson2?: PersonDto | undefined;
    fusingPerson1HasDogs?: boolean;
    fusingPerson2HasDogs?: boolean;
    fusingPerson1BreederHasDogs?: boolean;
    fusingPerson2BreederHasDogs?: boolean;
    fusingPerson1HasRequests?: boolean;
    fusingPerson2HasRequests?: boolean;
    fusingPerson1HasKennel?: boolean;
    fusingPerson2HasKennel?: boolean;
}

export class MembershipDto implements IMembershipDto {
    membershipId?: number;
    personId?: number;
    memberNumber?: number;
    isCAMember?: boolean;
    isCEMember?: boolean;
    isCynologicCouncilMember?: boolean;
    isFCIDelegateMember?: boolean;
    isVDA?: boolean;
    isSupervisor?: boolean;
    isVolunteer?: boolean;

    constructor(data?: IMembershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.membershipId = _data["membershipId"];
            this.personId = _data["personId"];
            this.memberNumber = _data["memberNumber"];
            this.isCAMember = _data["isCAMember"];
            this.isCEMember = _data["isCEMember"];
            this.isCynologicCouncilMember = _data["isCynologicCouncilMember"];
            this.isFCIDelegateMember = _data["isFCIDelegateMember"];
            this.isVDA = _data["isVDA"];
            this.isSupervisor = _data["isSupervisor"];
            this.isVolunteer = _data["isVolunteer"];
        }
    }

    static fromJS(data: any): MembershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["membershipId"] = this.membershipId;
        data["personId"] = this.personId;
        data["memberNumber"] = this.memberNumber;
        data["isCAMember"] = this.isCAMember;
        data["isCEMember"] = this.isCEMember;
        data["isCynologicCouncilMember"] = this.isCynologicCouncilMember;
        data["isFCIDelegateMember"] = this.isFCIDelegateMember;
        data["isVDA"] = this.isVDA;
        data["isSupervisor"] = this.isSupervisor;
        data["isVolunteer"] = this.isVolunteer;
        return data;
    }
}

export interface IMembershipDto {
    membershipId?: number;
    personId?: number;
    memberNumber?: number;
    isCAMember?: boolean;
    isCEMember?: boolean;
    isCynologicCouncilMember?: boolean;
    isFCIDelegateMember?: boolean;
    isVDA?: boolean;
    isSupervisor?: boolean;
    isVolunteer?: boolean;
}

export class VeterinaryDto implements IVeterinaryDto {
    veterinaryId?: number;
    personId?: number;
    veterinaryNumber?: string | undefined;
    veterinaryCompany?: string | undefined;
    isVet?: boolean;
    personSharepointUri?: string | undefined;
    isActive?: boolean;

    constructor(data?: IVeterinaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veterinaryId = _data["veterinaryId"];
            this.personId = _data["personId"];
            this.veterinaryNumber = _data["veterinaryNumber"];
            this.veterinaryCompany = _data["veterinaryCompany"];
            this.isVet = _data["isVet"];
            this.personSharepointUri = _data["personSharepointUri"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): VeterinaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new VeterinaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veterinaryId"] = this.veterinaryId;
        data["personId"] = this.personId;
        data["veterinaryNumber"] = this.veterinaryNumber;
        data["veterinaryCompany"] = this.veterinaryCompany;
        data["isVet"] = this.isVet;
        data["personSharepointUri"] = this.personSharepointUri;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IVeterinaryDto {
    veterinaryId?: number;
    personId?: number;
    veterinaryNumber?: string | undefined;
    veterinaryCompany?: string | undefined;
    isVet?: boolean;
    personSharepointUri?: string | undefined;
    isActive?: boolean;
}

export class BreedGroupsJudgeSaveDto implements IBreedGroupsJudgeSaveDto {
    breedGroupIds?: number[] | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;

    constructor(data?: IBreedGroupsJudgeSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["breedGroupIds"])) {
                this.breedGroupIds = [] as any;
                for (let item of _data["breedGroupIds"])
                    this.breedGroupIds!.push(item);
            }
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): BreedGroupsJudgeSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreedGroupsJudgeSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.breedGroupIds)) {
            data["breedGroupIds"] = [];
            for (let item of this.breedGroupIds)
                data["breedGroupIds"].push(item);
        }
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IBreedGroupsJudgeSaveDto {
    breedGroupIds?: number[] | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
}

export class PaginatedResultsOfPersonFileGridDto implements IPaginatedResultsOfPersonFileGridDto {
    totalCount?: number;
    results?: PersonFileGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonFileGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonFileGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonFileGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonFileGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonFileGridDto {
    totalCount?: number;
    results?: PersonFileGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonFileGridDto implements IPersonFileGridDto {
    requestId?: number;
    requestType?: string | undefined;
    requestState?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestTypeCode?: ERequestType;
    subRequestId?: number;

    constructor(data?: IPersonFileGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestType = _data["requestType"];
            this.requestState = _data["requestState"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestTypeCode = _data["requestTypeCode"];
            this.subRequestId = _data["subRequestId"];
        }
    }

    static fromJS(data: any): PersonFileGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonFileGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestType"] = this.requestType;
        data["requestState"] = this.requestState;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestTypeCode"] = this.requestTypeCode;
        data["subRequestId"] = this.subRequestId;
        return data;
    }
}

export interface IPersonFileGridDto {
    requestId?: number;
    requestType?: string | undefined;
    requestState?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestTypeCode?: ERequestType;
    subRequestId?: number;
}

export class PersonFileSearch extends PaginatedSearch implements IPersonFileSearch {
    personId?: number;
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    requestState?: TextSearch | undefined;
    requestType?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;

    constructor(data?: IPersonFileSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.requestState = _data["requestState"] ? TextSearch.fromJS(_data["requestState"]) : <any>undefined;
            this.requestType = _data["requestType"] ? TextSearch.fromJS(_data["requestType"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonFileSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PersonFileSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["requestState"] = this.requestState ? this.requestState.toJSON() : <any>undefined;
        data["requestType"] = this.requestType ? this.requestType.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonFileSearch extends IPaginatedSearch {
    personId?: number;
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    requestState?: TextSearch | undefined;
    requestType?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
}

export class PaginatedResultsOfPersonDogsGridDto implements IPaginatedResultsOfPersonDogsGridDto {
    totalCount?: number;
    results?: PersonDogsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonDogsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonDogsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonDogsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonDogsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonDogsGridDto {
    totalCount?: number;
    results?: PersonDogsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonDogsGridDto implements IPersonDogsGridDto {
    dogId?: number;
    computedName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date;
    deathDate?: Date | undefined;

    constructor(data?: IPersonDogsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogId = _data["dogId"];
            this.computedName = _data["computedName"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonDogsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDogsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["computedName"] = this.computedName;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPersonDogsGridDto {
    dogId?: number;
    computedName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date;
    deathDate?: Date | undefined;
}

export class PaginatedResultsOfPersonJudgesGridDto implements IPaginatedResultsOfPersonJudgesGridDto {
    totalCount?: number;
    results?: any[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonJudgesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(item);
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonJudgesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonJudgesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item);
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonJudgesGridDto {
    totalCount?: number;
    results?: any[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PaginatedResultsOfPersonKennelsGridDto implements IPaginatedResultsOfPersonKennelsGridDto {
    totalCount?: number;
    results?: PersonKennelsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPersonKennelsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PersonKennelsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPersonKennelsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPersonKennelsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPersonKennelsGridDto {
    totalCount?: number;
    results?: PersonKennelsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PersonKennelsGridDto implements IPersonKennelsGridDto {
    kennelId?: number;
    kennelName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date | undefined;

    constructor(data?: IPersonKennelsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kennelId = _data["kennelId"];
            this.kennelName = _data["kennelName"];
            this.ownerFrom = _data["ownerFrom"] ? new Date(_data["ownerFrom"].toString()) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? new Date(_data["ownerTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonKennelsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonKennelsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kennelId"] = this.kennelId;
        data["kennelName"] = this.kennelName;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toISOString() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPersonKennelsGridDto {
    kennelId?: number;
    kennelName?: string | undefined;
    ownerFrom?: Date;
    ownerTo?: Date | undefined;
}

export class PersonKennelsSearch extends PaginatedSearch implements IPersonKennelsSearch {
    personId?: number;
    firstName?: TextSearch | undefined;
    ownerFrom?: DateSearch | undefined;
    ownerTo?: DateSearch | undefined;

    constructor(data?: IPersonKennelsSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.ownerFrom = _data["ownerFrom"] ? DateSearch.fromJS(_data["ownerFrom"]) : <any>undefined;
            this.ownerTo = _data["ownerTo"] ? DateSearch.fromJS(_data["ownerTo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonKennelsSearch {
        data = typeof data === 'object' ? data : {};
        let result = new PersonKennelsSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["ownerFrom"] = this.ownerFrom ? this.ownerFrom.toJSON() : <any>undefined;
        data["ownerTo"] = this.ownerTo ? this.ownerTo.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonKennelsSearch extends IPaginatedSearch {
    personId?: number;
    firstName?: TextSearch | undefined;
    ownerFrom?: DateSearch | undefined;
    ownerTo?: DateSearch | undefined;
}

export class ReferentialItemDto implements IReferentialItemDto {
    displayValue?: string | undefined;
    keyValue?: string | undefined;
    idValue?: string | undefined;

    constructor(data?: IReferentialItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayValue = _data["displayValue"];
            this.keyValue = _data["keyValue"];
            this.idValue = _data["idValue"];
        }
    }

    static fromJS(data: any): ReferentialItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferentialItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayValue"] = this.displayValue;
        data["keyValue"] = this.keyValue;
        data["idValue"] = this.idValue;
        return data;
    }
}

export interface IReferentialItemDto {
    displayValue?: string | undefined;
    keyValue?: string | undefined;
    idValue?: string | undefined;
}

export class PaginatedResultsOfPeopleReferentialItem implements IPaginatedResultsOfPeopleReferentialItem {
    totalCount?: number;
    results?: PeopleReferentialItem[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfPeopleReferentialItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PeopleReferentialItem.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfPeopleReferentialItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfPeopleReferentialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfPeopleReferentialItem {
    totalCount?: number;
    results?: PeopleReferentialItem[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class PeopleReferentialItem extends ReferentialItemDto implements IPeopleReferentialItem {
    personId?: number;
    computedName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;

    constructor(data?: IPeopleReferentialItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personId = _data["personId"];
            this.computedName = _data["computedName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): PeopleReferentialItem {
        data = typeof data === 'object' ? data : {};
        let result = new PeopleReferentialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["computedName"] = this.computedName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        super.toJSON(data);
        return data;
    }
}

export interface IPeopleReferentialItem extends IReferentialItemDto {
    personId?: number;
    computedName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export class SearchPeopleReferentialQuery implements ISearchPeopleReferentialQuery {
    sObj?: PaginatedSearch | undefined;
    isBelgian?: boolean | undefined;
    clubId?: number | undefined;
    personId?: number | undefined;
    dogId?: number | undefined;
    kennelId?: number | undefined;
    filterBreeder?: boolean | undefined;
    languageId?: number | undefined;

    constructor(data?: ISearchPeopleReferentialQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sObj = _data["sObj"] ? PaginatedSearch.fromJS(_data["sObj"]) : <any>undefined;
            this.isBelgian = _data["isBelgian"];
            this.clubId = _data["clubId"];
            this.personId = _data["personId"];
            this.dogId = _data["dogId"];
            this.kennelId = _data["kennelId"];
            this.filterBreeder = _data["filterBreeder"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): SearchPeopleReferentialQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPeopleReferentialQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sObj"] = this.sObj ? this.sObj.toJSON() : <any>undefined;
        data["isBelgian"] = this.isBelgian;
        data["clubId"] = this.clubId;
        data["personId"] = this.personId;
        data["dogId"] = this.dogId;
        data["kennelId"] = this.kennelId;
        data["filterBreeder"] = this.filterBreeder;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface ISearchPeopleReferentialQuery {
    sObj?: PaginatedSearch | undefined;
    isBelgian?: boolean | undefined;
    clubId?: number | undefined;
    personId?: number | undefined;
    dogId?: number | undefined;
    kennelId?: number | undefined;
    filterBreeder?: boolean | undefined;
    languageId?: number | undefined;
}

export class GetCountriesReferentialQuery implements IGetCountriesReferentialQuery {
    includeBelgium?: boolean;

    constructor(data?: IGetCountriesReferentialQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeBelgium = _data["includeBelgium"];
        }
    }

    static fromJS(data: any): GetCountriesReferentialQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountriesReferentialQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeBelgium"] = this.includeBelgium;
        return data;
    }
}

export interface IGetCountriesReferentialQuery {
    includeBelgium?: boolean;
}

export class PaginatedResultsOfDogReferentialItem implements IPaginatedResultsOfDogReferentialItem {
    totalCount?: number;
    results?: DogReferentialItem[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDogReferentialItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DogReferentialItem.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDogReferentialItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDogReferentialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDogReferentialItem {
    totalCount?: number;
    results?: DogReferentialItem[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DogReferentialItem extends ReferentialItemDto implements IDogReferentialItem {
    dogId?: number;
    dogType?: EDogType | undefined;
    sex?: EDogSex | undefined;
    pedigrees?: string[] | undefined;
    dogChip?: string | undefined;
    secondDogChip?: string | undefined;
    pedigree?: string | undefined;
    remark?: string | undefined;

    constructor(data?: IDogReferentialItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.dogType = _data["dogType"];
            this.sex = _data["sex"];
            if (Array.isArray(_data["pedigrees"])) {
                this.pedigrees = [] as any;
                for (let item of _data["pedigrees"])
                    this.pedigrees!.push(item);
            }
            this.dogChip = _data["dogChip"];
            this.secondDogChip = _data["secondDogChip"];
            this.pedigree = _data["pedigree"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): DogReferentialItem {
        data = typeof data === 'object' ? data : {};
        let result = new DogReferentialItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["dogType"] = this.dogType;
        data["sex"] = this.sex;
        if (Array.isArray(this.pedigrees)) {
            data["pedigrees"] = [];
            for (let item of this.pedigrees)
                data["pedigrees"].push(item);
        }
        data["dogChip"] = this.dogChip;
        data["secondDogChip"] = this.secondDogChip;
        data["pedigree"] = this.pedigree;
        data["remark"] = this.remark;
        super.toJSON(data);
        return data;
    }
}

export interface IDogReferentialItem extends IReferentialItemDto {
    dogId?: number;
    dogType?: EDogType | undefined;
    sex?: EDogSex | undefined;
    pedigrees?: string[] | undefined;
    dogChip?: string | undefined;
    secondDogChip?: string | undefined;
    pedigree?: string | undefined;
    remark?: string | undefined;
}

export class SearchDogReferentialQuery implements ISearchDogReferentialQuery {
    sObj?: PaginatedSearch | undefined;
    dogId?: number | undefined;
    sex?: EDogSex | undefined;
    removeId?: number | undefined;
    isForPedigree?: boolean | undefined;
    isForTempRSH?: boolean | undefined;
    isForBroodRequest?: boolean | undefined;
    filterBreeds?: boolean | undefined;
    excludeExpoDogs?: boolean | undefined;
    types?: EDogType[] | undefined;
    removeMultipleIds?: (number | undefined)[] | undefined;

    constructor(data?: ISearchDogReferentialQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sObj = _data["sObj"] ? PaginatedSearch.fromJS(_data["sObj"]) : <any>undefined;
            this.dogId = _data["dogId"];
            this.sex = _data["sex"];
            this.removeId = _data["removeId"];
            this.isForPedigree = _data["isForPedigree"];
            this.isForTempRSH = _data["isForTempRSH"];
            this.isForBroodRequest = _data["isForBroodRequest"];
            this.filterBreeds = _data["filterBreeds"];
            this.excludeExpoDogs = _data["excludeExpoDogs"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["removeMultipleIds"])) {
                this.removeMultipleIds = [] as any;
                for (let item of _data["removeMultipleIds"])
                    this.removeMultipleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchDogReferentialQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchDogReferentialQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sObj"] = this.sObj ? this.sObj.toJSON() : <any>undefined;
        data["dogId"] = this.dogId;
        data["sex"] = this.sex;
        data["removeId"] = this.removeId;
        data["isForPedigree"] = this.isForPedigree;
        data["isForTempRSH"] = this.isForTempRSH;
        data["isForBroodRequest"] = this.isForBroodRequest;
        data["filterBreeds"] = this.filterBreeds;
        data["excludeExpoDogs"] = this.excludeExpoDogs;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.removeMultipleIds)) {
            data["removeMultipleIds"] = [];
            for (let item of this.removeMultipleIds)
                data["removeMultipleIds"].push(item);
        }
        return data;
    }
}

export interface ISearchDogReferentialQuery {
    sObj?: PaginatedSearch | undefined;
    dogId?: number | undefined;
    sex?: EDogSex | undefined;
    removeId?: number | undefined;
    isForPedigree?: boolean | undefined;
    isForTempRSH?: boolean | undefined;
    isForBroodRequest?: boolean | undefined;
    filterBreeds?: boolean | undefined;
    excludeExpoDogs?: boolean | undefined;
    types?: EDogType[] | undefined;
    removeMultipleIds?: (number | undefined)[] | undefined;
}

export class PaginatedResultsOfReprintPedigreePuppiesGridDto implements IPaginatedResultsOfReprintPedigreePuppiesGridDto {
    totalCount?: number;
    results?: ReprintPedigreePuppiesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfReprintPedigreePuppiesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReprintPedigreePuppiesGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfReprintPedigreePuppiesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfReprintPedigreePuppiesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfReprintPedigreePuppiesGridDto {
    totalCount?: number;
    results?: ReprintPedigreePuppiesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class ReprintPedigreePuppiesGridDto implements IReprintPedigreePuppiesGridDto {
    dogName?: string | undefined;
    dogId?: number;
    createdOn?: string | undefined;

    constructor(data?: IReprintPedigreePuppiesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogName = _data["dogName"];
            this.dogId = _data["dogId"];
            this.createdOn = _data["createdOn"];
        }
    }

    static fromJS(data: any): ReprintPedigreePuppiesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReprintPedigreePuppiesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogName"] = this.dogName;
        data["dogId"] = this.dogId;
        data["createdOn"] = this.createdOn;
        return data;
    }
}

export interface IReprintPedigreePuppiesGridDto {
    dogName?: string | undefined;
    dogId?: number;
    createdOn?: string | undefined;
}

export class ReprintPuppiesSearch extends PaginatedSearch implements IReprintPuppiesSearch {

    constructor(data?: IReprintPuppiesSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ReprintPuppiesSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ReprintPuppiesSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IReprintPuppiesSearch extends IPaginatedSearch {
}

export class PaginatedResultsOfRequestHistoryActionGridDto implements IPaginatedResultsOfRequestHistoryActionGridDto {
    totalCount?: number;
    results?: RequestHistoryActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfRequestHistoryActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RequestHistoryActionGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfRequestHistoryActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfRequestHistoryActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfRequestHistoryActionGridDto {
    totalCount?: number;
    results?: RequestHistoryActionGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class RequestHistoryActionGridDto implements IRequestHistoryActionGridDto {
    actionTime?: Date;
    action?: string | undefined;

    constructor(data?: IRequestHistoryActionGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): RequestHistoryActionGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestHistoryActionGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface IRequestHistoryActionGridDto {
    actionTime?: Date;
    action?: string | undefined;
}

export class BaseRequestSearch extends PaginatedSearch implements IBaseRequestSearch {
    requestId?: number;
    languageId?: number;

    constructor(data?: IBaseRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestId = _data["requestId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): BaseRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseRequestSearch extends IPaginatedSearch {
    requestId?: number;
    languageId?: number;
}

export class RequestSearch extends PaginatedSearch implements IRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    invoiceNumber?: TextSearch | undefined;
    isBlocked?: BooleanSearch | undefined;

    constructor(data?: IRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.requestTypeId = _data["requestTypeId"] ? ListSearchOfNullableInteger.fromJS(_data["requestTypeId"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["requestTypeId"] = this.requestTypeId ? this.requestTypeId.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    requestTypeId?: ListSearchOfNullableInteger | undefined;
    invoiceNumber?: TextSearch | undefined;
    isBlocked?: BooleanSearch | undefined;
}

export class ResultOfString implements IResultOfString {
    isFailure?: boolean;
    isSuccess?: boolean;
    error?: string | undefined;
    value?: string | undefined;

    constructor(data?: IResultOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFailure = _data["IsFailure"];
            this.isSuccess = _data["IsSuccess"];
            this.error = _data["Error"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): ResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResultOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsFailure"] = this.isFailure;
        data["IsSuccess"] = this.isSuccess;
        data["Error"] = this.error;
        data["Value"] = this.value;
        return data;
    }
}

export interface IResultOfString {
    isFailure?: boolean;
    isSuccess?: boolean;
    error?: string | undefined;
    value?: string | undefined;
}

export class ShpDocumentContentDto extends ShpDocumentDto implements IShpDocumentContentDto {
    fileContent?: string | undefined;

    constructor(data?: IShpDocumentContentDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): ShpDocumentContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShpDocumentContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileContent"] = this.fileContent;
        super.toJSON(data);
        return data;
    }
}

export interface IShpDocumentContentDto extends IShpDocumentDto {
    fileContent?: string | undefined;
}

export class PaginatedResultsOfDrupalRequestGridDto implements IPaginatedResultsOfDrupalRequestGridDto {
    totalCount?: number;
    results?: DrupalRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfDrupalRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DrupalRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfDrupalRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfDrupalRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfDrupalRequestGridDto {
    totalCount?: number;
    results?: DrupalRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class DrupalRequestGridDto implements IDrupalRequestGridDto {
    requestId?: number;
    requestTypeId?: number;
    requestTypeCode?: ERequestType;
    requestType?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date | undefined;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    isBlocked?: boolean;

    constructor(data?: IDrupalRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.requestType = _data["requestType"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.isBlocked = _data["isBlocked"];
        }
    }

    static fromJS(data: any): DrupalRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestTypeCode"] = this.requestTypeCode;
        data["requestType"] = this.requestType;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["isBlocked"] = this.isBlocked;
        return data;
    }
}

export interface IDrupalRequestGridDto {
    requestId?: number;
    requestTypeId?: number;
    requestTypeCode?: ERequestType;
    requestType?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date | undefined;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    isBlocked?: boolean;
}

export class DrupalRequestSearch extends PaginatedSearch implements IDrupalRequestSearch {
    active?: boolean;
    userId?: number;
    brcs?: boolean;

    constructor(data?: IDrupalRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.brcs = _data["brcs"];
        }
    }

    static fromJS(data: any): DrupalRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["brcs"] = this.brcs;
        super.toJSON(data);
        return data;
    }
}

export interface IDrupalRequestSearch extends IPaginatedSearch {
    active?: boolean;
    userId?: number;
    brcs?: boolean;
}

export class InvoiceDto implements IInvoiceDto {
    invoiceId?: number;
    requestId?: number;
    invoiceBcIdentifier?: string | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    totalPrice?: number;
    totalPriceCents?: number;
    structuredCommunication?: string | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.requestId = _data["requestId"];
            this.invoiceBcIdentifier = _data["invoiceBcIdentifier"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            this.totalPrice = _data["totalPrice"];
            this.totalPriceCents = _data["totalPriceCents"];
            this.structuredCommunication = _data["structuredCommunication"];
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["requestId"] = this.requestId;
        data["invoiceBcIdentifier"] = this.invoiceBcIdentifier;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["totalPriceCents"] = this.totalPriceCents;
        data["structuredCommunication"] = this.structuredCommunication;
        return data;
    }
}

export interface IInvoiceDto {
    invoiceId?: number;
    requestId?: number;
    invoiceBcIdentifier?: string | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    totalPrice?: number;
    totalPriceCents?: number;
    structuredCommunication?: string | undefined;
}

export class InvoiceItemDto implements IInvoiceItemDto {
    invoiceItemId?: number;
    articleId?: number;
    creditMemoBcIdentifier?: string | undefined;
    articleTranslations?: ArticleTranslationDto[] | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemId = _data["invoiceItemId"];
            this.articleId = _data["articleId"];
            this.creditMemoBcIdentifier = _data["creditMemoBcIdentifier"];
            if (Array.isArray(_data["articleTranslations"])) {
                this.articleTranslations = [] as any;
                for (let item of _data["articleTranslations"])
                    this.articleTranslations!.push(ArticleTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceItemId"] = this.invoiceItemId;
        data["articleId"] = this.articleId;
        data["creditMemoBcIdentifier"] = this.creditMemoBcIdentifier;
        if (Array.isArray(this.articleTranslations)) {
            data["articleTranslations"] = [];
            for (let item of this.articleTranslations)
                data["articleTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvoiceItemDto {
    invoiceItemId?: number;
    articleId?: number;
    creditMemoBcIdentifier?: string | undefined;
    articleTranslations?: ArticleTranslationDto[] | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    srshIban?: string | undefined;
    structuredCommunication?: string | undefined;
    totalPrice?: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.srshIban = _data["srshIban"];
            this.structuredCommunication = _data["structuredCommunication"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["srshIban"] = this.srshIban;
        data["structuredCommunication"] = this.structuredCommunication;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    srshIban?: string | undefined;
    structuredCommunication?: string | undefined;
    totalPrice?: number;
}

export class DrupalRequestTypeDto implements IDrupalRequestTypeDto {
    name?: string | undefined;
    requestTypeCode?: ERequestType;

    constructor(data?: IDrupalRequestTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.requestTypeCode = _data["requestTypeCode"];
        }
    }

    static fromJS(data: any): DrupalRequestTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalRequestTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["requestTypeCode"] = this.requestTypeCode;
        return data;
    }
}

export interface IDrupalRequestTypeDto {
    name?: string | undefined;
    requestTypeCode?: ERequestType;
}

export class QuickUpdateRequestStatusIdCommand implements IQuickUpdateRequestStatusIdCommand {
    requestId?: number;
    requestStatusId?: number | undefined;
    requestStatus?: ERequestState | undefined;
    isAutomatic?: boolean;
    plaform?: EPlatform;
    languageId?: number;

    constructor(data?: IQuickUpdateRequestStatusIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatus = _data["requestStatus"];
            this.isAutomatic = _data["isAutomatic"];
            this.plaform = _data["plaform"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): QuickUpdateRequestStatusIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new QuickUpdateRequestStatusIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatus"] = this.requestStatus;
        data["isAutomatic"] = this.isAutomatic;
        data["plaform"] = this.plaform;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IQuickUpdateRequestStatusIdCommand {
    requestId?: number;
    requestStatusId?: number | undefined;
    requestStatus?: ERequestState | undefined;
    isAutomatic?: boolean;
    plaform?: EPlatform;
    languageId?: number;
}

export class UpdateRequestStatusIdCommand implements IUpdateRequestStatusIdCommand {
    requestId?: number;
    requestStatusId?: number | undefined;
    requestStatus?: ERequestState | undefined;
    isAutomatic?: boolean;
    plaform?: EPlatform;
    languageId?: number;

    constructor(data?: IUpdateRequestStatusIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatus = _data["requestStatus"];
            this.isAutomatic = _data["isAutomatic"];
            this.plaform = _data["plaform"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): UpdateRequestStatusIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestStatusIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatus"] = this.requestStatus;
        data["isAutomatic"] = this.isAutomatic;
        data["plaform"] = this.plaform;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface IUpdateRequestStatusIdCommand {
    requestId?: number;
    requestStatusId?: number | undefined;
    requestStatus?: ERequestState | undefined;
    isAutomatic?: boolean;
    plaform?: EPlatform;
    languageId?: number;
}

export class RequestMenuDto implements IRequestMenuDto {
    requestId?: number;
    requestTypeId?: number;
    requestType?: string | undefined;
    requestTypeCode?: ERequestType;
    requestStateId?: number;
    previousRequestStatusId?: number;
    requestStatus?: string | undefined;
    requestStatusCode?: ERequestState;
    personId?: number;
    personEmail?: string | undefined;
    personName?: string | undefined;
    personAddress?: string | undefined;
    requestDescription?: string | undefined;
    isBlocked?: boolean;
    managerId?: number | undefined;
    manager?: string | undefined;

    constructor(data?: IRequestMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestType = _data["requestType"];
            this.requestTypeCode = _data["requestTypeCode"];
            this.requestStateId = _data["requestStateId"];
            this.previousRequestStatusId = _data["previousRequestStatusId"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusCode = _data["requestStatusCode"];
            this.personId = _data["personId"];
            this.personEmail = _data["personEmail"];
            this.personName = _data["personName"];
            this.personAddress = _data["personAddress"];
            this.requestDescription = _data["requestDescription"];
            this.isBlocked = _data["isBlocked"];
            this.managerId = _data["managerId"];
            this.manager = _data["manager"];
        }
    }

    static fromJS(data: any): RequestMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestType"] = this.requestType;
        data["requestTypeCode"] = this.requestTypeCode;
        data["requestStateId"] = this.requestStateId;
        data["previousRequestStatusId"] = this.previousRequestStatusId;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusCode"] = this.requestStatusCode;
        data["personId"] = this.personId;
        data["personEmail"] = this.personEmail;
        data["personName"] = this.personName;
        data["personAddress"] = this.personAddress;
        data["requestDescription"] = this.requestDescription;
        data["isBlocked"] = this.isBlocked;
        data["managerId"] = this.managerId;
        data["manager"] = this.manager;
        return data;
    }
}

export interface IRequestMenuDto {
    requestId?: number;
    requestTypeId?: number;
    requestType?: string | undefined;
    requestTypeCode?: ERequestType;
    requestStateId?: number;
    previousRequestStatusId?: number;
    requestStatus?: string | undefined;
    requestStatusCode?: ERequestState;
    personId?: number;
    personEmail?: string | undefined;
    personName?: string | undefined;
    personAddress?: string | undefined;
    requestDescription?: string | undefined;
    isBlocked?: boolean;
    managerId?: number | undefined;
    manager?: string | undefined;
}

export class SubRequestInfoDto implements ISubRequestInfoDto {
    subRequestId?: number;
    requestType?: ERequestType;

    constructor(data?: ISubRequestInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subRequestId = _data["subRequestId"];
            this.requestType = _data["requestType"];
        }
    }

    static fromJS(data: any): SubRequestInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubRequestInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subRequestId"] = this.subRequestId;
        data["requestType"] = this.requestType;
        return data;
    }
}

export interface ISubRequestInfoDto {
    subRequestId?: number;
    requestType?: ERequestType;
}

export class RequestInfoDto implements IRequestInfoDto {
    requestTypeCode?: ERequestType;
    requestId?: number | undefined;
    parentRequestId?: number | undefined;
    isRequestBlocked?: boolean;
    isMasterRequestBlocked?: boolean;
    requestStateCode?: ERequestState;
    masterRequestId?: number | undefined;
    masterRequestTypeCode?: ERequestType | undefined;
    requestTypeId?: number;
    masterRequestStateCode?: ERequestState | undefined;
    masterSubRequestId?: number | undefined;
    subRequestCount?: number;
    requestDisplayName?: string | undefined;
    masterRequestNumber?: string | undefined;
    masterRequestDisplayName?: any | undefined;
    requestNumber?: string | undefined;
    hasWarning?: boolean;

    constructor(data?: IRequestInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestTypeCode = _data["requestTypeCode"];
            this.requestId = _data["requestId"];
            this.parentRequestId = _data["parentRequestId"];
            this.isRequestBlocked = _data["isRequestBlocked"];
            this.isMasterRequestBlocked = _data["isMasterRequestBlocked"];
            this.requestStateCode = _data["requestStateCode"];
            this.masterRequestId = _data["masterRequestId"];
            this.masterRequestTypeCode = _data["masterRequestTypeCode"];
            this.requestTypeId = _data["requestTypeId"];
            this.masterRequestStateCode = _data["masterRequestStateCode"];
            this.masterSubRequestId = _data["masterSubRequestId"];
            this.subRequestCount = _data["subRequestCount"];
            this.requestDisplayName = _data["requestDisplayName"];
            this.masterRequestNumber = _data["masterRequestNumber"];
            this.masterRequestDisplayName = _data["masterRequestDisplayName"];
            this.requestNumber = _data["requestNumber"];
            this.hasWarning = _data["hasWarning"];
        }
    }

    static fromJS(data: any): RequestInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestTypeCode"] = this.requestTypeCode;
        data["requestId"] = this.requestId;
        data["parentRequestId"] = this.parentRequestId;
        data["isRequestBlocked"] = this.isRequestBlocked;
        data["isMasterRequestBlocked"] = this.isMasterRequestBlocked;
        data["requestStateCode"] = this.requestStateCode;
        data["masterRequestId"] = this.masterRequestId;
        data["masterRequestTypeCode"] = this.masterRequestTypeCode;
        data["requestTypeId"] = this.requestTypeId;
        data["masterRequestStateCode"] = this.masterRequestStateCode;
        data["masterSubRequestId"] = this.masterSubRequestId;
        data["subRequestCount"] = this.subRequestCount;
        data["requestDisplayName"] = this.requestDisplayName;
        data["masterRequestNumber"] = this.masterRequestNumber;
        data["masterRequestDisplayName"] = this.masterRequestDisplayName;
        data["requestNumber"] = this.requestNumber;
        data["hasWarning"] = this.hasWarning;
        return data;
    }
}

export interface IRequestInfoDto {
    requestTypeCode?: ERequestType;
    requestId?: number | undefined;
    parentRequestId?: number | undefined;
    isRequestBlocked?: boolean;
    isMasterRequestBlocked?: boolean;
    requestStateCode?: ERequestState;
    masterRequestId?: number | undefined;
    masterRequestTypeCode?: ERequestType | undefined;
    requestTypeId?: number;
    masterRequestStateCode?: ERequestState | undefined;
    masterSubRequestId?: number | undefined;
    subRequestCount?: number;
    requestDisplayName?: string | undefined;
    masterRequestNumber?: string | undefined;
    masterRequestDisplayName?: any | undefined;
    requestNumber?: string | undefined;
    hasWarning?: boolean;
}

export class VerificationsValueDto implements IVerificationsValueDto {
    verificationsValueId?: number;
    required?: boolean;
    isVerified?: boolean;
    neededVerificationId?: number;
    label?: string | undefined;
    verificationCode?: ERequestVerification;
    requestStatusLabel?: string | undefined;
    requestStatus?: ERequestState;
    requestStatusId?: number;
    isCurrent?: boolean;

    constructor(data?: IVerificationsValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationsValueId = _data["verificationsValueId"];
            this.required = _data["required"];
            this.isVerified = _data["isVerified"];
            this.neededVerificationId = _data["neededVerificationId"];
            this.label = _data["label"];
            this.verificationCode = _data["verificationCode"];
            this.requestStatusLabel = _data["requestStatusLabel"];
            this.requestStatus = _data["requestStatus"];
            this.requestStatusId = _data["requestStatusId"];
            this.isCurrent = _data["isCurrent"];
        }
    }

    static fromJS(data: any): VerificationsValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationsValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationsValueId"] = this.verificationsValueId;
        data["required"] = this.required;
        data["isVerified"] = this.isVerified;
        data["neededVerificationId"] = this.neededVerificationId;
        data["label"] = this.label;
        data["verificationCode"] = this.verificationCode;
        data["requestStatusLabel"] = this.requestStatusLabel;
        data["requestStatus"] = this.requestStatus;
        data["requestStatusId"] = this.requestStatusId;
        data["isCurrent"] = this.isCurrent;
        return data;
    }
}

export interface IVerificationsValueDto {
    verificationsValueId?: number;
    required?: boolean;
    isVerified?: boolean;
    neededVerificationId?: number;
    label?: string | undefined;
    verificationCode?: ERequestVerification;
    requestStatusLabel?: string | undefined;
    requestStatus?: ERequestState;
    requestStatusId?: number;
    isCurrent?: boolean;
}

export class NeededConditionDto implements INeededConditionDto {
    neededConditionId?: number;
    label?: string | undefined;
    forced?: boolean;
    requestStatusLabel?: string | undefined;
    requestStatusId?: number;
    requestStatusCode?: ERequestState;
    value?: boolean;
    conditionCode?: ERequestConditions;
    forcible?: boolean;

    constructor(data?: INeededConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neededConditionId = _data["neededConditionId"];
            this.label = _data["label"];
            this.forced = _data["forced"];
            this.requestStatusLabel = _data["requestStatusLabel"];
            this.requestStatusId = _data["requestStatusId"];
            this.requestStatusCode = _data["requestStatusCode"];
            this.value = _data["value"];
            this.conditionCode = _data["conditionCode"];
            this.forcible = _data["forcible"];
        }
    }

    static fromJS(data: any): NeededConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NeededConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neededConditionId"] = this.neededConditionId;
        data["label"] = this.label;
        data["forced"] = this.forced;
        data["requestStatusLabel"] = this.requestStatusLabel;
        data["requestStatusId"] = this.requestStatusId;
        data["requestStatusCode"] = this.requestStatusCode;
        data["value"] = this.value;
        data["conditionCode"] = this.conditionCode;
        data["forcible"] = this.forcible;
        return data;
    }
}

export interface INeededConditionDto {
    neededConditionId?: number;
    label?: string | undefined;
    forced?: boolean;
    requestStatusLabel?: string | undefined;
    requestStatusId?: number;
    requestStatusCode?: ERequestState;
    value?: boolean;
    conditionCode?: ERequestConditions;
    forcible?: boolean;
}

export class PaginatedResultsOfSectionLinkedActivitiesDto implements IPaginatedResultsOfSectionLinkedActivitiesDto {
    totalCount?: number;
    results?: SectionLinkedActivitiesDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSectionLinkedActivitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SectionLinkedActivitiesDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSectionLinkedActivitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSectionLinkedActivitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfSectionLinkedActivitiesDto {
    totalCount?: number;
    results?: SectionLinkedActivitiesDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class SectionLinkedActivitiesDto implements ISectionLinkedActivitiesDto {
    activityId?: number;
    activityName?: string | undefined;

    constructor(data?: ISectionLinkedActivitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.activityName = _data["activityName"];
        }
    }

    static fromJS(data: any): SectionLinkedActivitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionLinkedActivitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        return data;
    }
}

export interface ISectionLinkedActivitiesDto {
    activityId?: number;
    activityName?: string | undefined;
}

export class SectionLinkedActivitiesSearch extends PaginatedSearch implements ISectionLinkedActivitiesSearch {
    languageCode?: string | undefined;
    sectionId?: number;

    constructor(data?: ISectionLinkedActivitiesSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.sectionId = _data["sectionId"];
        }
    }

    static fromJS(data: any): SectionLinkedActivitiesSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SectionLinkedActivitiesSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["sectionId"] = this.sectionId;
        super.toJSON(data);
        return data;
    }
}

export interface ISectionLinkedActivitiesSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    sectionId?: number;
}

export class PaginatedResultsOfSectionsGridDto implements IPaginatedResultsOfSectionsGridDto {
    totalCount?: number;
    results?: SectionsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSectionsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SectionsGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSectionsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSectionsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfSectionsGridDto {
    totalCount?: number;
    results?: SectionsGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class SectionsGridDto implements ISectionsGridDto {
    sectionId?: number;
    code?: string | undefined;
    isWork?: boolean;
    isBeauty?: boolean;

    constructor(data?: ISectionsGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.code = _data["code"];
            this.isWork = _data["isWork"];
            this.isBeauty = _data["isBeauty"];
        }
    }

    static fromJS(data: any): SectionsGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionsGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["code"] = this.code;
        data["isWork"] = this.isWork;
        data["isBeauty"] = this.isBeauty;
        return data;
    }
}

export interface ISectionsGridDto {
    sectionId?: number;
    code?: string | undefined;
    isWork?: boolean;
    isBeauty?: boolean;
}

export class SectionSearch extends PaginatedSearch implements ISectionSearch {
    languageCode?: string | undefined;
    code?: TextSearch | undefined;

    constructor(data?: ISectionSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.code = _data["code"] ? TextSearch.fromJS(_data["code"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SectionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SectionSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISectionSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    code?: TextSearch | undefined;
}

export class SectionDto implements ISectionDto {
    sectionId?: number;
    code?: string | undefined;
    remark?: string | undefined;
    isWork?: boolean;
    isBeauty?: boolean;
    sectionType?: ESectionType | undefined;
    cegekaId?: string | undefined;

    constructor(data?: ISectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.code = _data["code"];
            this.remark = _data["remark"];
            this.isWork = _data["isWork"];
            this.isBeauty = _data["isBeauty"];
            this.sectionType = _data["sectionType"];
            this.cegekaId = _data["cegekaId"];
        }
    }

    static fromJS(data: any): SectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["code"] = this.code;
        data["remark"] = this.remark;
        data["isWork"] = this.isWork;
        data["isBeauty"] = this.isBeauty;
        data["sectionType"] = this.sectionType;
        data["cegekaId"] = this.cegekaId;
        return data;
    }
}

export interface ISectionDto {
    sectionId?: number;
    code?: string | undefined;
    remark?: string | undefined;
    isWork?: boolean;
    isBeauty?: boolean;
    sectionType?: ESectionType | undefined;
    cegekaId?: string | undefined;
}

export enum ESectionType {
    SPORT = "SPORT",
    BEAUTY = "BEAUTY",
}

export class StripeSessionDto implements IStripeSessionDto {
    sessionId?: string | undefined;
    sessionUrl?: string | undefined;

    constructor(data?: IStripeSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.sessionUrl = _data["sessionUrl"];
        }
    }

    static fromJS(data: any): StripeSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["sessionUrl"] = this.sessionUrl;
        return data;
    }
}

export interface IStripeSessionDto {
    sessionId?: string | undefined;
    sessionUrl?: string | undefined;
}

export class CheckoutItemDto implements ICheckoutItemDto {
    price?: number;
    name?: string | undefined;
    quantity?: number;
    previousLocation?: string | undefined;
    invoiceStructuredCommunication?: string | undefined;
    successUrl?: string | undefined;

    constructor(data?: ICheckoutItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.previousLocation = _data["previousLocation"];
            this.invoiceStructuredCommunication = _data["invoiceStructuredCommunication"];
            this.successUrl = _data["successUrl"];
        }
    }

    static fromJS(data: any): CheckoutItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["previousLocation"] = this.previousLocation;
        data["invoiceStructuredCommunication"] = this.invoiceStructuredCommunication;
        data["successUrl"] = this.successUrl;
        return data;
    }
}

export interface ICheckoutItemDto {
    price?: number;
    name?: string | undefined;
    quantity?: number;
    previousLocation?: string | undefined;
    invoiceStructuredCommunication?: string | undefined;
    successUrl?: string | undefined;
}

export class PaginatedResultsOfSubActivityGridDto implements IPaginatedResultsOfSubActivityGridDto {
    totalCount?: number;
    results?: SubActivityGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSubActivityGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SubActivityGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSubActivityGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSubActivityGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfSubActivityGridDto {
    totalCount?: number;
    results?: SubActivityGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class SubActivityGridDto implements ISubActivityGridDto {
    subActivityId?: number;
    activityId?: number;
    activity?: string | undefined;
    name?: string | undefined;
    showType?: string | undefined;

    constructor(data?: ISubActivityGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivityId = _data["subActivityId"];
            this.activityId = _data["activityId"];
            this.activity = _data["activity"];
            this.name = _data["name"];
            this.showType = _data["showType"];
        }
    }

    static fromJS(data: any): SubActivityGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivityId"] = this.subActivityId;
        data["activityId"] = this.activityId;
        data["activity"] = this.activity;
        data["name"] = this.name;
        data["showType"] = this.showType;
        return data;
    }
}

export interface ISubActivityGridDto {
    subActivityId?: number;
    activityId?: number;
    activity?: string | undefined;
    name?: string | undefined;
    showType?: string | undefined;
}

export class SubActivitySearch extends PaginatedSearch implements ISubActivitySearch {
    activityId?: number | undefined;
    languageId?: number;
    name?: TextSearch | undefined;
    activity?: TextSearch | undefined;

    constructor(data?: ISubActivitySearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.activityId = _data["activityId"];
            this.languageId = _data["languageId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.activity = _data["activity"] ? TextSearch.fromJS(_data["activity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubActivitySearch {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivitySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["languageId"] = this.languageId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISubActivitySearch extends IPaginatedSearch {
    activityId?: number | undefined;
    languageId?: number;
    name?: TextSearch | undefined;
    activity?: TextSearch | undefined;
}

export class SubActivityDetailDto implements ISubActivityDetailDto {
    subActivityTranslations?: SubActivityTranslationDto[] | undefined;
    subActivityId?: number;
    activityId?: number;
    clubMatch?: boolean;
    documentType?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    isCac?: boolean;
    fciTax?: boolean;
    showType?: string | undefined;
    participationFciTax?: boolean;
    showOnPortal?: boolean;

    constructor(data?: ISubActivityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subActivityTranslations"])) {
                this.subActivityTranslations = [] as any;
                for (let item of _data["subActivityTranslations"])
                    this.subActivityTranslations!.push(SubActivityTranslationDto.fromJS(item));
            }
            this.subActivityId = _data["subActivityId"];
            this.activityId = _data["activityId"];
            this.clubMatch = _data["clubMatch"];
            this.documentType = _data["documentType"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.isCac = _data["isCac"];
            this.fciTax = _data["fciTax"];
            this.showType = _data["showType"];
            this.participationFciTax = _data["participationFciTax"];
            this.showOnPortal = _data["showOnPortal"];
        }
    }

    static fromJS(data: any): SubActivityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subActivityTranslations)) {
            data["subActivityTranslations"] = [];
            for (let item of this.subActivityTranslations)
                data["subActivityTranslations"].push(item.toJSON());
        }
        data["subActivityId"] = this.subActivityId;
        data["activityId"] = this.activityId;
        data["clubMatch"] = this.clubMatch;
        data["documentType"] = this.documentType;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["isCac"] = this.isCac;
        data["fciTax"] = this.fciTax;
        data["showType"] = this.showType;
        data["participationFciTax"] = this.participationFciTax;
        data["showOnPortal"] = this.showOnPortal;
        return data;
    }
}

export interface ISubActivityDetailDto {
    subActivityTranslations?: SubActivityTranslationDto[] | undefined;
    subActivityId?: number;
    activityId?: number;
    clubMatch?: boolean;
    documentType?: string | undefined;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    isCac?: boolean;
    fciTax?: boolean;
    showType?: string | undefined;
    participationFciTax?: boolean;
    showOnPortal?: boolean;
}

export class SubActivityTranslationDto implements ISubActivityTranslationDto {
    languageId?: number;
    subActivityId?: number;
    subActivityTranslationId?: number;
    text?: string | undefined;

    constructor(data?: ISubActivityTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.subActivityId = _data["subActivityId"];
            this.subActivityTranslationId = _data["subActivityTranslationId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SubActivityTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["subActivityId"] = this.subActivityId;
        data["subActivityTranslationId"] = this.subActivityTranslationId;
        data["text"] = this.text;
        return data;
    }
}

export interface ISubActivityTranslationDto {
    languageId?: number;
    subActivityId?: number;
    subActivityTranslationId?: number;
    text?: string | undefined;
}

export class PaginatedResultsOfSubActivityJudgeGridDto implements IPaginatedResultsOfSubActivityJudgeGridDto {
    totalCount?: number;
    results?: SubActivityJudgeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfSubActivityJudgeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SubActivityJudgeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfSubActivityJudgeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfSubActivityJudgeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfSubActivityJudgeGridDto {
    totalCount?: number;
    results?: SubActivityJudgeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class SubActivityJudgeGridDto implements ISubActivityJudgeGridDto {
    subActivityJudgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    subActivityId?: number;
    activityId?: number;
    remark?: string | undefined;
    activity?: string | undefined;
    name?: string | undefined;
    judgeId?: number;

    constructor(data?: ISubActivityJudgeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivityJudgeId = _data["subActivityJudgeId"];
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
            this.personId = _data["personId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.language = _data["language"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.subActivityId = _data["subActivityId"];
            this.activityId = _data["activityId"];
            this.remark = _data["remark"];
            this.activity = _data["activity"];
            this.name = _data["name"];
            this.judgeId = _data["judgeId"];
        }
    }

    static fromJS(data: any): SubActivityJudgeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityJudgeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivityJudgeId"] = this.subActivityJudgeId;
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        data["personId"] = this.personId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["language"] = this.language;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["subActivityId"] = this.subActivityId;
        data["activityId"] = this.activityId;
        data["remark"] = this.remark;
        data["activity"] = this.activity;
        data["name"] = this.name;
        data["judgeId"] = this.judgeId;
        return data;
    }
}

export interface ISubActivityJudgeGridDto {
    subActivityJudgeId?: number;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    language?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    subActivityId?: number;
    activityId?: number;
    remark?: string | undefined;
    activity?: string | undefined;
    name?: string | undefined;
    judgeId?: number;
}

export class SubActivityJudgeSearch extends SelectorSearchOfInteger implements ISubActivityJudgeSearch {
    languageId?: number;
    subActivityId?: number | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
    lastName?: TextSearch | undefined;
    firstName?: TextSearch | undefined;

    constructor(data?: ISubActivityJudgeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.subActivityId = _data["subActivityId"];
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            this.lastName = _data["lastName"] ? TextSearch.fromJS(_data["lastName"]) : <any>undefined;
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubActivityJudgeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SubActivityJudgeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["subActivityId"] = this.subActivityId;
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISubActivityJudgeSearch extends ISelectorSearchOfInteger {
    languageId?: number;
    subActivityId?: number | undefined;
    judgeId?: number | undefined;
    personId?: number | undefined;
    lastName?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
}

export class SaveSubActivityJudgeDto implements ISaveSubActivityJudgeDto {
    subActivityId?: number;
    judgeId?: number | undefined;
    personId?: number | undefined;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;

    constructor(data?: ISaveSubActivityJudgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subActivityId = _data["subActivityId"];
            this.judgeId = _data["judgeId"];
            this.personId = _data["personId"];
            this.judgeType = _data["judgeType"];
            this.nominationDate = _data["nominationDate"] ? new Date(_data["nominationDate"].toString()) : <any>undefined;
            this.internshipDate = _data["internshipDate"] ? new Date(_data["internshipDate"].toString()) : <any>undefined;
            this.excludedFrom = _data["excludedFrom"] ? new Date(_data["excludedFrom"].toString()) : <any>undefined;
            this.excludedTo = _data["excludedTo"] ? new Date(_data["excludedTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveSubActivityJudgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSubActivityJudgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subActivityId"] = this.subActivityId;
        data["judgeId"] = this.judgeId;
        data["personId"] = this.personId;
        data["judgeType"] = this.judgeType;
        data["nominationDate"] = this.nominationDate ? this.nominationDate.toISOString() : <any>undefined;
        data["internshipDate"] = this.internshipDate ? this.internshipDate.toISOString() : <any>undefined;
        data["excludedFrom"] = this.excludedFrom ? this.excludedFrom.toISOString() : <any>undefined;
        data["excludedTo"] = this.excludedTo ? this.excludedTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISaveSubActivityJudgeDto {
    subActivityId?: number;
    judgeId?: number | undefined;
    personId?: number | undefined;
    judgeType?: EJudgeType;
    nominationDate?: Date | undefined;
    internshipDate?: Date | undefined;
    excludedFrom?: Date | undefined;
    excludedTo?: Date | undefined;
}

export class SystemVersionDto implements ISystemVersionDto {
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
    drupalHideCompetitionRequest?: boolean;

    constructor(data?: ISystemVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationVersion = _data["applicationVersion"];
            this.environment = _data["environment"];
            this.database = _data["database"];
            this.drupalHideCompetitionRequest = _data["drupalHideCompetitionRequest"];
        }
    }

    static fromJS(data: any): SystemVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationVersion"] = this.applicationVersion;
        data["environment"] = this.environment;
        data["database"] = this.database;
        data["drupalHideCompetitionRequest"] = this.drupalHideCompetitionRequest;
        return data;
    }
}

export interface ISystemVersionDto {
    applicationVersion?: string | undefined;
    environment?: string | undefined;
    database?: string | undefined;
    drupalHideCompetitionRequest?: boolean;
}

export class ErrorDetails implements IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    errorCode?: ESRSHExceptions | undefined;
    exceptionType?: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
            this.errorCode = _data["errorCode"];
            this.exceptionType = _data["exceptionType"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        data["errorCode"] = this.errorCode;
        data["exceptionType"] = this.exceptionType;
        return data;
    }
}

export interface IErrorDetails {
    statusCode?: number;
    message?: string | undefined;
    stackTrace?: string | undefined;
    errorCode?: ESRSHExceptions | undefined;
    exceptionType?: string | undefined;
}

export enum ESRSHExceptions {
    ConstraintViolation = "ConstraintViolation",
    PedigreeNoTooHigh = "PedigreeNoTooHigh",
    VerificationsNotComplete = "VerificationsNotComplete",
    ConditionsNotComplete = "ConditionsNotComplete",
    EmailTemplateError = "EmailTemplateError",
    LoginError = "LoginError",
    OperationUnauthorized = "OperationUnauthorized",
    AtLeastOneOwnerIsNotBelgian = "AtLeastOneOwnerIsNotBelgian",
    DogGenealogyTreeConstraints = "DogGenealogyTreeConstraints",
    DogGenealogyBreedConstraints = "DogGenealogyBreedConstraints",
    DogGenealogyBreedConstraintsMother = "DogGenealogyBreedConstraintsMother",
    DogGenealogyBreedConstraintsFather = "DogGenealogyBreedConstraintsFather",
    DysplasiaTypeHasNoCharacteristic = "DysplasiaTypeHasNoCharacteristic",
    NoRequestFound = "NoRequestFound",
    MoreThanOneRequestFound = "MoreThanOneRequestFound",
    NavError = "NavError",
    UnauthorizedType = "UnauthorizedType",
    UserInactive = "UserInactive",
    NotAllPotentialFatherOwnersHaveApproved = "NotAllPotentialFatherOwnersHaveApproved",
    NotAllDogValidationsAreChecked = "NotAllDogValidationsAreChecked",
    OneOrMoreJudgesExluded = "OneOrMoreJudgesExluded",
    MaxNumberOfProfileUserExeeded = "MaxNumberOfProfileUserExeeded",
    PDFConversionError = "PDFConversionError",
    NoBCIdentifierError = "NoBCIdentifierError",
    DatabaseError = "DatabaseError",
    RequestTypeNotFoundForCondition = "RequestTypeNotFoundForCondition",
    DogMustHaveABirthDate = "DogMustHaveABirthDate",
    ChipAlreadyUsed = "ChipAlreadyUsed",
    PuppyInvalidName = "PuppyInvalidName",
    MissingBreedFCINumber = "MissingBreedFCINumber",
    ZoolyxPhoneNumberRequired = "ZoolyxPhoneNumberRequired",
    ZoolyxError = "ZoolyxError",
    DogHasNoColor = "DogHasNoColor",
    FatherAlreadyExists = "FatherAlreadyExists",
    NoAvailableWordTemplate = "NoAvailableWordTemplate",
    DogHasNoParents = "DogHasNoParents",
    SharePointListDoesNotExist = "SharePointListDoesNotExist",
    UserDoesNotExist = "UserDoesNotExist",
    UserHasNoPortalAccount = "UserHasNoPortalAccount",
    MultipleMatchingEmail = "MultipleMatchingEmail",
    EmailAlreadyInUse = "EmailAlreadyInUse",
    UserAlreadyHasPortalAccount = "UserAlreadyHasPortalAccount",
    SiteTermSetDoesNotExist = "SiteTermSetDoesNotExist",
    TermSetDoesNotExist = "TermSetDoesNotExist",
    NoDocument = "NoDocument",
    AzureBlobStorageError = "AzureBlobStorageError",
    RequestNotFound = "RequestNotFound",
    InvoiceMissingError = "InvoiceMissingError",
    RequestMissingInformation = "RequestMissingInformation",
    BroodRequestAnalysisOngoing = "BroodRequestAnalysisOngoing",
    BroodRequestPuppyIncomplete = "BroodRequestPuppyIncomplete",
    OnlyOneBroodRequestForBirthDate = "OnlyOneBroodRequestForBirthDate",
    PedigreeIdentifierExists = "PedigreeIdentifierExists",
    SubRequestUpdateError = "SubRequestUpdateError",
    EmailLinkedToMultipleAccountsPleaseContactSRSH = "EmailLinkedToMultipleAccountsPleaseContactSRSH",
    NotAlllJudgesValidated = "NotAlllJudgesValidated",
    NothingFound = "NothingFound",
    PedigreeGenerationError = "PedigreeGenerationError",
    OldPasswordIncorrect = "OldPasswordIncorrect",
    BroodRequestAtLeastOnePedigreeIncomplete = "BroodRequestAtLeastOnePedigreeIncomplete",
    NoRequestSelected = "NoRequestSelected",
    BroodRequestPuppyIncompleteCertificate = "BroodRequestPuppyIncompleteCertificate",
    FatherInformationIsNull = "FatherInformationIsNull",
    ReprintAlreadyRunning = "ReprintAlreadyRunning",
    ChangeUnauthorized = "ChangeUnauthorized",
    InvalidLanguageCode = "InvalidLanguageCode",
    DogNameAlreadyTakenInKennel = "DogNameAlreadyTakenInKennel",
    DogHasNoDnaResultError = "DogHasNoDnaResultError",
    CharacteristicAlreadyExists = "CharacteristicAlreadyExists",
    AtLeastOneFileExistsInBothSharepoints = "AtLeastOneFileExistsInBothSharepoints",
    InvalidVatNumber = "InvalidVatNumber",
    DogChipTooLong = "DogChipTooLong",
    TitleAlreadyExists = "TitleAlreadyExists",
    SHPMaximumRetryAttempted = "SHPMaximumRetryAttempted",
    DogChipExists = "DogChipExists",
    TwoPedigreesWithSameCountry = "TwoPedigreesWithSameCountry",
    DogChipInformationMissingInImportFile = "DogChipInformationMissingInImportFile",
    NonBreedableBreedError = "NonBreedableBreedError",
    UniqueKeyException = "UniqueKeyException",
    ImpossibleActionError = "ImpossibleActionError",
    PuppiesNamesMustDiffer = "PuppiesNamesMustDiffer",
    UserBanned = "UserBanned",
    CompetitionImportInProgress = "CompetitionImportInProgress",
    CannotUseKnownPerson = "CannotUseKnownPerson",
    CannotDeleteTranslatedLanguage = "CannotDeleteTranslatedLanguage",
    SectionIsNotAuthorizedForTabletUse = "SectionIsNotAuthorizedForTabletUse",
    FCIAlreadyInUse = "FCIAlreadyInUse",
    SectionIsNotAuthorizedForMyExpo = "SectionIsNotAuthorizedForMyExpo",
    RequestAlreadyExists = "RequestAlreadyExists",
}

export class IngenicoSettings implements IIngenicoSettings {
    paymentUrl?: string | undefined;
    sha1Key?: string | undefined;
    psId?: string | undefined;

    constructor(data?: IIngenicoSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentUrl = _data["paymentUrl"];
            this.sha1Key = _data["sha1Key"];
            this.psId = _data["psId"];
        }
    }

    static fromJS(data: any): IngenicoSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IngenicoSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentUrl"] = this.paymentUrl;
        data["sha1Key"] = this.sha1Key;
        data["psId"] = this.psId;
        return data;
    }
}

export interface IIngenicoSettings {
    paymentUrl?: string | undefined;
    sha1Key?: string | undefined;
    psId?: string | undefined;
}

export class PaginatedResultsOfTempRSHRequestGridDto implements IPaginatedResultsOfTempRSHRequestGridDto {
    totalCount?: number;
    results?: TempRSHRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTempRSHRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TempRSHRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTempRSHRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTempRSHRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTempRSHRequestGridDto {
    totalCount?: number;
    results?: TempRSHRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TempRSHRequestGridDto implements ITempRSHRequestGridDto {
    dogTempOwnershipChangeRequestId?: number;
    requestId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestState?: string | undefined;
    requestStateId?: number;
    requestStateCode?: ERequestState;
    contactId?: number;
    contact?: string | undefined;
    dogId?: number;
    dog?: string | undefined;
    temporaryOwnerId?: number;
    temporaryOwner?: string | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: ITempRSHRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTempOwnershipChangeRequestId = _data["dogTempOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestState = _data["requestState"];
            this.requestStateId = _data["requestStateId"];
            this.requestStateCode = _data["requestStateCode"];
            this.contactId = _data["contactId"];
            this.contact = _data["contact"];
            this.dogId = _data["dogId"];
            this.dog = _data["dog"];
            this.temporaryOwnerId = _data["temporaryOwnerId"];
            this.temporaryOwner = _data["temporaryOwner"];
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): TempRSHRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TempRSHRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTempOwnershipChangeRequestId"] = this.dogTempOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestState"] = this.requestState;
        data["requestStateId"] = this.requestStateId;
        data["requestStateCode"] = this.requestStateCode;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact;
        data["dogId"] = this.dogId;
        data["dog"] = this.dog;
        data["temporaryOwnerId"] = this.temporaryOwnerId;
        data["temporaryOwner"] = this.temporaryOwner;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface ITempRSHRequestGridDto {
    dogTempOwnershipChangeRequestId?: number;
    requestId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    requestState?: string | undefined;
    requestStateId?: number;
    requestStateCode?: ERequestState;
    contactId?: number;
    contact?: string | undefined;
    dogId?: number;
    dog?: string | undefined;
    temporaryOwnerId?: number;
    temporaryOwner?: string | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class TempRSHRequestSearch extends PaginatedSearch implements ITempRSHRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    temporaryOwner?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;

    constructor(data?: ITempRSHRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
            this.temporaryOwner = _data["temporaryOwner"] ? TextSearch.fromJS(_data["temporaryOwner"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TempRSHRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TempRSHRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        data["temporaryOwner"] = this.temporaryOwner ? this.temporaryOwner.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITempRSHRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    temporaryOwner?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
}

export class TempRSHRequestDto implements ITempRSHRequestDto {
    dogTempOwnershipChangeRequestId?: number;
    requestId?: number;
    temporaryOwnerId?: number;
    temporaryOwnerEmail?: string | undefined;
    dogId?: number;
    temporaryOwnerFrom?: Date;
    temporaryOwnerTo?: Date;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: ITempRSHRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTempOwnershipChangeRequestId = _data["dogTempOwnershipChangeRequestId"];
            this.requestId = _data["requestId"];
            this.temporaryOwnerId = _data["temporaryOwnerId"];
            this.temporaryOwnerEmail = _data["temporaryOwnerEmail"];
            this.dogId = _data["dogId"];
            this.temporaryOwnerFrom = _data["temporaryOwnerFrom"] ? new Date(_data["temporaryOwnerFrom"].toString()) : <any>undefined;
            this.temporaryOwnerTo = _data["temporaryOwnerTo"] ? new Date(_data["temporaryOwnerTo"].toString()) : <any>undefined;
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): TempRSHRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TempRSHRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTempOwnershipChangeRequestId"] = this.dogTempOwnershipChangeRequestId;
        data["requestId"] = this.requestId;
        data["temporaryOwnerId"] = this.temporaryOwnerId;
        data["temporaryOwnerEmail"] = this.temporaryOwnerEmail;
        data["dogId"] = this.dogId;
        data["temporaryOwnerFrom"] = this.temporaryOwnerFrom ? this.temporaryOwnerFrom.toISOString() : <any>undefined;
        data["temporaryOwnerTo"] = this.temporaryOwnerTo ? this.temporaryOwnerTo.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface ITempRSHRequestDto {
    dogTempOwnershipChangeRequestId?: number;
    requestId?: number;
    temporaryOwnerId?: number;
    temporaryOwnerEmail?: string | undefined;
    dogId?: number;
    temporaryOwnerFrom?: Date;
    temporaryOwnerTo?: Date;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;
}

export class PaginatedResultsOfTitlesGridDto implements IPaginatedResultsOfTitlesGridDto {
    totalCount?: number;
    results?: TitlesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTitlesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TitlesGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTitlesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTitlesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTitlesGridDto {
    totalCount?: number;
    results?: TitlesGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TitlesGridDto implements ITitlesGridDto {
    titleId?: number;
    name?: string | undefined;
    abreviation?: string | undefined;
    type?: string | undefined;
    titleTypeId?: number;
    workRequired?: boolean;
    canBeUsed?: boolean;

    constructor(data?: ITitlesGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.name = _data["name"];
            this.abreviation = _data["abreviation"];
            this.type = _data["type"];
            this.titleTypeId = _data["titleTypeId"];
            this.workRequired = _data["workRequired"];
            this.canBeUsed = _data["canBeUsed"];
        }
    }

    static fromJS(data: any): TitlesGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitlesGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["abreviation"] = this.abreviation;
        data["type"] = this.type;
        data["titleTypeId"] = this.titleTypeId;
        data["workRequired"] = this.workRequired;
        data["canBeUsed"] = this.canBeUsed;
        return data;
    }
}

export interface ITitlesGridDto {
    titleId?: number;
    name?: string | undefined;
    abreviation?: string | undefined;
    type?: string | undefined;
    titleTypeId?: number;
    workRequired?: boolean;
    canBeUsed?: boolean;
}

export class TitleSearch extends PaginatedSearch implements ITitleSearch {
    languageId?: number;
    countryId?: number;
    type?: TextSearch | undefined;

    constructor(data?: ITitleSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.countryId = _data["countryId"];
            this.type = _data["type"] ? TextSearch.fromJS(_data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TitleSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TitleSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["countryId"] = this.countryId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITitleSearch extends IPaginatedSearch {
    languageId?: number;
    countryId?: number;
    type?: TextSearch | undefined;
}

export class TitleDto implements ITitleDto {
    titleId?: number;
    titleTranslations?: TitleTranslationDto[] | undefined;
    countryId?: number;
    abreviation?: string | undefined;
    titleTypeId?: number;
    workRequired?: boolean;
    articleId?: number | undefined;

    constructor(data?: ITitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            if (Array.isArray(_data["titleTranslations"])) {
                this.titleTranslations = [] as any;
                for (let item of _data["titleTranslations"])
                    this.titleTranslations!.push(TitleTranslationDto.fromJS(item));
            }
            this.countryId = _data["countryId"];
            this.abreviation = _data["abreviation"];
            this.titleTypeId = _data["titleTypeId"];
            this.workRequired = _data["workRequired"];
            this.articleId = _data["articleId"];
        }
    }

    static fromJS(data: any): TitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        if (Array.isArray(this.titleTranslations)) {
            data["titleTranslations"] = [];
            for (let item of this.titleTranslations)
                data["titleTranslations"].push(item.toJSON());
        }
        data["countryId"] = this.countryId;
        data["abreviation"] = this.abreviation;
        data["titleTypeId"] = this.titleTypeId;
        data["workRequired"] = this.workRequired;
        data["articleId"] = this.articleId;
        return data;
    }
}

export interface ITitleDto {
    titleId?: number;
    titleTranslations?: TitleTranslationDto[] | undefined;
    countryId?: number;
    abreviation?: string | undefined;
    titleTypeId?: number;
    workRequired?: boolean;
    articleId?: number | undefined;
}

export class TitleTranslationDto implements ITitleTranslationDto {
    languageId?: number;
    text?: string | undefined;
    titleTranslationId?: number;

    constructor(data?: ITitleTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.titleTranslationId = _data["titleTranslationId"];
        }
    }

    static fromJS(data: any): TitleTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["titleTranslationId"] = this.titleTranslationId;
        return data;
    }
}

export interface ITitleTranslationDto {
    languageId?: number;
    text?: string | undefined;
    titleTranslationId?: number;
}

export class PaginatedResultsOfTitlesRequestGridDto implements IPaginatedResultsOfTitlesRequestGridDto {
    totalCount?: number;
    results?: TitlesRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTitlesRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TitlesRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTitlesRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTitlesRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTitlesRequestGridDto {
    totalCount?: number;
    results?: TitlesRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TitlesRequestGridDto implements ITitlesRequestGridDto {
    titleRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    title?: string | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: ITitlesRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleRequestId = _data["titleRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.requestStateId = _data["requestStateId"];
            this.requestState = _data["requestState"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): TitlesRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitlesRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleRequestId"] = this.titleRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["requestStateId"] = this.requestStateId;
        data["requestState"] = this.requestState;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface ITitlesRequestGridDto {
    titleRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    requestStateId?: number;
    requestState?: string | undefined;
    personId?: number;
    contact?: string | undefined;
    dog?: string | undefined;
    dogId?: number;
    requestNumber?: string | undefined;
    requestDate?: Date;
    title?: string | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class TitlesRequestSearch extends PaginatedSearch implements ITitlesRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    title?: TextSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;

    constructor(data?: ITitlesRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.title = _data["title"] ? TextSearch.fromJS(_data["title"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TitlesRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TitlesRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITitlesRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    title?: TextSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
}

export class TitleRequestDto implements ITitleRequestDto {
    titleRequestId?: number;
    requestId?: number;
    dogId?: number;
    titleId?: number;
    titleCountryId?: number;
    year?: number;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: ITitleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleRequestId = _data["titleRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.titleCountryId = _data["titleCountryId"];
            this.year = _data["year"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): TitleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleRequestId"] = this.titleRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["titleCountryId"] = this.titleCountryId;
        data["year"] = this.year;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface ITitleRequestDto {
    titleRequestId?: number;
    requestId?: number;
    dogId?: number;
    titleId?: number;
    titleCountryId?: number;
    year?: number;
    request?: RequestDto | undefined;
    dogSharepointUri?: string | undefined;
}

export class DrupalTitleRequestDto implements IDrupalTitleRequestDto {
    titleRequestId?: number;
    dogId?: number;
    titleId?: number;
    year?: number;
    requestId?: number;
    request?: RequestDto | undefined;

    constructor(data?: IDrupalTitleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleRequestId = _data["titleRequestId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.year = _data["year"];
            this.requestId = _data["requestId"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DrupalTitleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalTitleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleRequestId"] = this.titleRequestId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["year"] = this.year;
        data["requestId"] = this.requestId;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDrupalTitleRequestDto {
    titleRequestId?: number;
    dogId?: number;
    titleId?: number;
    year?: number;
    requestId?: number;
    request?: RequestDto | undefined;
}

export class PaginatedResultsOfTitleTypeGridDto implements IPaginatedResultsOfTitleTypeGridDto {
    totalCount?: number;
    results?: TitleTypeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTitleTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TitleTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTitleTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTitleTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTitleTypeGridDto {
    totalCount?: number;
    results?: TitleTypeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TitleTypeGridDto implements ITitleTypeGridDto {
    titleTypeId?: number;
    name?: string | undefined;

    constructor(data?: ITitleTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleTypeId = _data["titleTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TitleTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleTypeId"] = this.titleTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITitleTypeGridDto {
    titleTypeId?: number;
    name?: string | undefined;
}

export class TitleTypeSearch extends PaginatedSearch implements ITitleTypeSearch {
    name?: TextSearch | undefined;
    languageId?: number;

    constructor(data?: ITitleTypeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): TitleTypeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTypeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ITitleTypeSearch extends IPaginatedSearch {
    name?: TextSearch | undefined;
    languageId?: number;
}

export class TitleTypeDto implements ITitleTypeDto {
    titleTypeId?: number;
    cegekaId?: string | undefined;
    remark?: string | undefined;
    translations?: TitleTypeTranslationDto[] | undefined;

    constructor(data?: ITitleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleTypeId = _data["titleTypeId"];
            this.cegekaId = _data["cegekaId"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(TitleTypeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TitleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleTypeId"] = this.titleTypeId;
        data["cegekaId"] = this.cegekaId;
        data["remark"] = this.remark;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITitleTypeDto {
    titleTypeId?: number;
    cegekaId?: string | undefined;
    remark?: string | undefined;
    translations?: TitleTypeTranslationDto[] | undefined;
}

export class TitleTypeTranslationDto implements ITitleTypeTranslationDto {
    titleTypeId?: number;
    languageId?: number;
    remark?: string | undefined;
    text?: string | undefined;

    constructor(data?: ITitleTypeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleTypeId = _data["titleTypeId"];
            this.languageId = _data["languageId"];
            this.remark = _data["remark"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): TitleTypeTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleTypeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleTypeId"] = this.titleTypeId;
        data["languageId"] = this.languageId;
        data["remark"] = this.remark;
        data["text"] = this.text;
        return data;
    }
}

export interface ITitleTypeTranslationDto {
    titleTypeId?: number;
    languageId?: number;
    remark?: string | undefined;
    text?: string | undefined;
}

export class PaginatedResultsOfTransientDogTitleGridDto implements IPaginatedResultsOfTransientDogTitleGridDto {
    totalCount?: number;
    results?: TransientDogTitleGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTransientDogTitleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransientDogTitleGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTransientDogTitleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTransientDogTitleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTransientDogTitleGridDto {
    totalCount?: number;
    results?: TransientDogTitleGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TransientDogTitleGridDto implements ITransientDogTitleGridDto {
    dogTitlesTransientId?: number;
    dogId?: number;
    titleId?: number;
    countryId?: number;
    managerId?: number | undefined;
    closedOn?: Date | undefined;
    sharepointUri?: string | undefined;
    dog?: string | undefined;
    country?: string | undefined;
    title?: string | undefined;
    year?: number;

    constructor(data?: ITransientDogTitleGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dogTitlesTransientId = _data["dogTitlesTransientId"];
            this.dogId = _data["dogId"];
            this.titleId = _data["titleId"];
            this.countryId = _data["countryId"];
            this.managerId = _data["managerId"];
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : <any>undefined;
            this.sharepointUri = _data["sharepointUri"];
            this.dog = _data["dog"];
            this.country = _data["country"];
            this.title = _data["title"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): TransientDogTitleGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransientDogTitleGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogTitlesTransientId"] = this.dogTitlesTransientId;
        data["dogId"] = this.dogId;
        data["titleId"] = this.titleId;
        data["countryId"] = this.countryId;
        data["managerId"] = this.managerId;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : <any>undefined;
        data["sharepointUri"] = this.sharepointUri;
        data["dog"] = this.dog;
        data["country"] = this.country;
        data["title"] = this.title;
        data["year"] = this.year;
        return data;
    }
}

export interface ITransientDogTitleGridDto {
    dogTitlesTransientId?: number;
    dogId?: number;
    titleId?: number;
    countryId?: number;
    managerId?: number | undefined;
    closedOn?: Date | undefined;
    sharepointUri?: string | undefined;
    dog?: string | undefined;
    country?: string | undefined;
    title?: string | undefined;
    year?: number;
}

export class DogsTransientTitlesSearch extends PaginatedSearch implements IDogsTransientTitlesSearch {
    searchUnassignedTitles?: boolean;
    languageId?: number;
    hideClosed?: boolean;

    constructor(data?: IDogsTransientTitlesSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchUnassignedTitles = _data["searchUnassignedTitles"];
            this.languageId = _data["languageId"];
            this.hideClosed = _data["hideClosed"];
        }
    }

    static fromJS(data: any): DogsTransientTitlesSearch {
        data = typeof data === 'object' ? data : {};
        let result = new DogsTransientTitlesSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchUnassignedTitles"] = this.searchUnassignedTitles;
        data["languageId"] = this.languageId;
        data["hideClosed"] = this.hideClosed;
        super.toJSON(data);
        return data;
    }
}

export interface IDogsTransientTitlesSearch extends IPaginatedSearch {
    searchUnassignedTitles?: boolean;
    languageId?: number;
    hideClosed?: boolean;
}

export class TransientDogTitleByDogSearch extends PaginatedSearch implements ITransientDogTitleByDogSearch {
    dogId?: number;
    languageId?: number;

    constructor(data?: ITransientDogTitleByDogSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): TransientDogTitleByDogSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TransientDogTitleByDogSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ITransientDogTitleByDogSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
}

export class PaginatedResultsOfTransientWorkbookGridDto implements IPaginatedResultsOfTransientWorkbookGridDto {
    totalCount?: number;
    results?: TransientWorkbookGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTransientWorkbookGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransientWorkbookGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTransientWorkbookGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTransientWorkbookGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTransientWorkbookGridDto {
    totalCount?: number;
    results?: TransientWorkbookGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TransientWorkbookGridDto implements ITransientWorkbookGridDto {
    identifier?: number | undefined;
    counter?: number;
    workbookTypeId?: number;
    workbookType?: string | undefined;

    constructor(data?: ITransientWorkbookGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.counter = _data["counter"];
            this.workbookTypeId = _data["workbookTypeId"];
            this.workbookType = _data["workbookType"];
        }
    }

    static fromJS(data: any): TransientWorkbookGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransientWorkbookGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["counter"] = this.counter;
        data["workbookTypeId"] = this.workbookTypeId;
        data["workbookType"] = this.workbookType;
        return data;
    }
}

export interface ITransientWorkbookGridDto {
    identifier?: number | undefined;
    counter?: number;
    workbookTypeId?: number;
    workbookType?: string | undefined;
}

export class TransientWorkbookSearch extends PaginatedSearch implements ITransientWorkbookSearch {
    dogId?: number;
    languageId?: number;

    constructor(data?: ITransientWorkbookSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dogId = _data["dogId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): TransientWorkbookSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TransientWorkbookSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dogId"] = this.dogId;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface ITransientWorkbookSearch extends IPaginatedSearch {
    dogId?: number;
    languageId?: number;
}

export class TranslationDto implements ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;

    constructor(data?: ITranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.translationCode = _data["translationCode"];
            this.text = _data["text"];
            this.translationId = _data["translationId"];
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): TranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["translationCode"] = this.translationCode;
        data["text"] = this.text;
        data["translationId"] = this.translationId;
        data["languageId"] = this.languageId;
        return data;
    }
}

export interface ITranslationDto {
    languageCode?: string | undefined;
    translationCode?: string | undefined;
    text?: string | undefined;
    translationId?: number;
    languageId?: number;
}

export class UpdateTranslationCommand implements IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;

    constructor(data?: IUpdateTranslationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.translationId = _data["translationId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UpdateTranslationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTranslationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["translationId"] = this.translationId;
        data["text"] = this.text;
        return data;
    }
}

export interface IUpdateTranslationCommand {
    translationId?: number;
    text?: string | undefined;
}

export class PaginatedResultsOfTranslationDto implements IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfTranslationDto {
    totalCount?: number;
    results?: TranslationDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class TranslationSearch extends PaginatedSearch implements ITranslationSearch {
    languageCode?: string | undefined;
    text?: TextSearch | undefined;
    translationCode?: TextSearch | undefined;
    languageId?: ListSearchOfNullableInteger | undefined;

    constructor(data?: ITranslationSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageCode = _data["languageCode"];
            this.text = _data["text"] ? TextSearch.fromJS(_data["text"]) : <any>undefined;
            this.translationCode = _data["translationCode"] ? TextSearch.fromJS(_data["translationCode"]) : <any>undefined;
            this.languageId = _data["languageId"] ? ListSearchOfNullableInteger.fromJS(_data["languageId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TranslationSearch {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        data["translationCode"] = this.translationCode ? this.translationCode.toJSON() : <any>undefined;
        data["languageId"] = this.languageId ? this.languageId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITranslationSearch extends IPaginatedSearch {
    languageCode?: string | undefined;
    text?: TextSearch | undefined;
    translationCode?: TextSearch | undefined;
    languageId?: ListSearchOfNullableInteger | undefined;
}

export class PaginatedResultsOfUserGridDto implements IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(UserGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfUserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfUserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfUserGridDto {
    totalCount?: number;
    results?: UserGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class UserGridDto implements IUserGridDto {
    userId?: number;
    active?: boolean;
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    languageId?: number;
    userProfileId?: number;
    userProfile?: string | undefined;
    computedName?: string | undefined;

    constructor(data?: IUserGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.active = _data["active"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.languageId = _data["languageId"];
            this.userProfileId = _data["userProfileId"];
            this.userProfile = _data["userProfile"];
            this.computedName = _data["computedName"];
        }
    }

    static fromJS(data: any): UserGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["active"] = this.active;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["language"] = this.language;
        data["languageId"] = this.languageId;
        data["userProfileId"] = this.userProfileId;
        data["userProfile"] = this.userProfile;
        data["computedName"] = this.computedName;
        return data;
    }
}

export interface IUserGridDto {
    userId?: number;
    active?: boolean;
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    languageId?: number;
    userProfileId?: number;
    userProfile?: string | undefined;
    computedName?: string | undefined;
}

export class UserSearch extends PaginatedSearch implements IUserSearch {
    computedName?: TextSearch | undefined;
    name?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
    email?: TextSearch | undefined;
    userProfileId?: ListSearchOfNullableInteger | undefined;

    constructor(data?: IUserSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.computedName = _data["computedName"] ? TextSearch.fromJS(_data["computedName"]) : <any>undefined;
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.firstName = _data["firstName"] ? TextSearch.fromJS(_data["firstName"]) : <any>undefined;
            this.email = _data["email"] ? TextSearch.fromJS(_data["email"]) : <any>undefined;
            this.userProfileId = _data["userProfileId"] ? ListSearchOfNullableInteger.fromJS(_data["userProfileId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSearch {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computedName"] = this.computedName ? this.computedName.toJSON() : <any>undefined;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["userProfileId"] = this.userProfileId ? this.userProfileId.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSearch extends IPaginatedSearch {
    computedName?: TextSearch | undefined;
    name?: TextSearch | undefined;
    firstName?: TextSearch | undefined;
    email?: TextSearch | undefined;
    userProfileId?: ListSearchOfNullableInteger | undefined;
}

export class UserDto implements IUserDto {
    userId?: number;
    userProfileId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    active?: boolean;
    mustResetPassword?: boolean;
    defaultRoute?: string | undefined;
    mustChangePassword?: boolean;
    languageId?: number | undefined;
    password?: string | undefined;
    languageCode?: string | undefined;
    token?: string | undefined;
    departments?: number[] | undefined;
    profile?: EUserProfile | undefined;
    platform?: EPlatform;
    personId?: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userProfileId = _data["userProfileId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.active = _data["active"];
            this.mustResetPassword = _data["mustResetPassword"];
            this.defaultRoute = _data["defaultRoute"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.languageId = _data["languageId"];
            this.password = _data["password"];
            this.languageCode = _data["languageCode"];
            this.token = _data["token"];
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            this.profile = _data["profile"];
            this.platform = _data["platform"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userProfileId"] = this.userProfileId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["active"] = this.active;
        data["mustResetPassword"] = this.mustResetPassword;
        data["defaultRoute"] = this.defaultRoute;
        data["mustChangePassword"] = this.mustChangePassword;
        data["languageId"] = this.languageId;
        data["password"] = this.password;
        data["languageCode"] = this.languageCode;
        data["token"] = this.token;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        data["profile"] = this.profile;
        data["platform"] = this.platform;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUserDto {
    userId?: number;
    userProfileId?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    active?: boolean;
    mustResetPassword?: boolean;
    defaultRoute?: string | undefined;
    mustChangePassword?: boolean;
    languageId?: number | undefined;
    password?: string | undefined;
    languageCode?: string | undefined;
    token?: string | undefined;
    departments?: number[] | undefined;
    profile?: EUserProfile | undefined;
    platform?: EPlatform;
    personId?: number | undefined;
}

export class AuthenticateCommand implements IAuthenticateCommand {
    email?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean | undefined;
    platform?: EPlatform;
    formatStringForLogRequest?: string | undefined;

    constructor(data?: IAuthenticateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
            this.platform = _data["platform"];
            this.formatStringForLogRequest = _data["formatStringForLogRequest"];
        }
    }

    static fromJS(data: any): AuthenticateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        data["platform"] = this.platform;
        data["formatStringForLogRequest"] = this.formatStringForLogRequest;
        return data;
    }
}

export interface IAuthenticateCommand {
    email?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean | undefined;
    platform?: EPlatform;
    formatStringForLogRequest?: string | undefined;
}

export class UserProfileActionDto implements IUserProfileActionDto {
    module?: string | undefined;
    tab?: string | undefined;
    permission?: EPermission;

    constructor(data?: IUserProfileActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"];
            this.tab = _data["tab"];
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): UserProfileActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module;
        data["tab"] = this.tab;
        data["permission"] = this.permission;
        return data;
    }
}

export interface IUserProfileActionDto {
    module?: string | undefined;
    tab?: string | undefined;
    permission?: EPermission;
}

export class PaginatedResultsOfVeterinaryClinicDto implements IPaginatedResultsOfVeterinaryClinicDto {
    totalCount?: number;
    results?: VeterinaryClinicDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfVeterinaryClinicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(VeterinaryClinicDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfVeterinaryClinicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfVeterinaryClinicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfVeterinaryClinicDto {
    totalCount?: number;
    results?: VeterinaryClinicDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class VeterinaryClinicDto implements IVeterinaryClinicDto {
    clinicVeterinaryId?: number;
    veterinaryId?: number;
    clinicId?: number;
    clinicName?: string | undefined;
    name?: string | undefined;
    veterinaryPersonId?: number;

    constructor(data?: IVeterinaryClinicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicVeterinaryId = _data["clinicVeterinaryId"];
            this.veterinaryId = _data["veterinaryId"];
            this.clinicId = _data["clinicId"];
            this.clinicName = _data["clinicName"];
            this.name = _data["name"];
            this.veterinaryPersonId = _data["veterinaryPersonId"];
        }
    }

    static fromJS(data: any): VeterinaryClinicDto {
        data = typeof data === 'object' ? data : {};
        let result = new VeterinaryClinicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicVeterinaryId"] = this.clinicVeterinaryId;
        data["veterinaryId"] = this.veterinaryId;
        data["clinicId"] = this.clinicId;
        data["clinicName"] = this.clinicName;
        data["name"] = this.name;
        data["veterinaryPersonId"] = this.veterinaryPersonId;
        return data;
    }
}

export interface IVeterinaryClinicDto {
    clinicVeterinaryId?: number;
    veterinaryId?: number;
    clinicId?: number;
    clinicName?: string | undefined;
    name?: string | undefined;
    veterinaryPersonId?: number;
}

export class VeterinaryClinicSearch extends PaginatedSearch implements IVeterinaryClinicSearch {
    languageId?: number;
    clinicVeterinaryId?: number;
    veterinaryId?: number;
    name?: TextSearch | undefined;
    clinicId?: number;

    constructor(data?: IVeterinaryClinicSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.clinicVeterinaryId = _data["clinicVeterinaryId"];
            this.veterinaryId = _data["veterinaryId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
            this.clinicId = _data["clinicId"];
        }
    }

    static fromJS(data: any): VeterinaryClinicSearch {
        data = typeof data === 'object' ? data : {};
        let result = new VeterinaryClinicSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["clinicVeterinaryId"] = this.clinicVeterinaryId;
        data["veterinaryId"] = this.veterinaryId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["clinicId"] = this.clinicId;
        super.toJSON(data);
        return data;
    }
}

export interface IVeterinaryClinicSearch extends IPaginatedSearch {
    languageId?: number;
    clinicVeterinaryId?: number;
    veterinaryId?: number;
    name?: TextSearch | undefined;
    clinicId?: number;
}

export class SaveVeterinaryClinicDto implements ISaveVeterinaryClinicDto {
    veterinaryId?: number;
    clinicId?: number;

    constructor(data?: ISaveVeterinaryClinicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veterinaryId = _data["veterinaryId"];
            this.clinicId = _data["clinicId"];
        }
    }

    static fromJS(data: any): SaveVeterinaryClinicDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveVeterinaryClinicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veterinaryId"] = this.veterinaryId;
        data["clinicId"] = this.clinicId;
        return data;
    }
}

export interface ISaveVeterinaryClinicDto {
    veterinaryId?: number;
    clinicId?: number;
}

export class PaginatedResultsOfVeterinaryGridDto implements IPaginatedResultsOfVeterinaryGridDto {
    totalCount?: number;
    results?: VeterinaryGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfVeterinaryGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(VeterinaryGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfVeterinaryGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfVeterinaryGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfVeterinaryGridDto {
    totalCount?: number;
    results?: VeterinaryGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class VeterinaryGridDto implements IVeterinaryGridDto {
    veterinaryId?: number;
    personId?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;

    constructor(data?: IVeterinaryGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.veterinaryId = _data["veterinaryId"];
            this.personId = _data["personId"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VeterinaryGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new VeterinaryGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veterinaryId"] = this.veterinaryId;
        data["personId"] = this.personId;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["name"] = this.name;
        return data;
    }
}

export interface IVeterinaryGridDto {
    veterinaryId?: number;
    personId?: number;
    lastName?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
}

export class AvailableVeterinaryForClinicSearch extends PaginatedSearch implements IAvailableVeterinaryForClinicSearch {
    languageId?: number;
    veterinaryId?: number;
    clinicId?: number;
    personId?: number;
    name?: TextSearch | undefined;

    constructor(data?: IAvailableVeterinaryForClinicSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.veterinaryId = _data["veterinaryId"];
            this.clinicId = _data["clinicId"];
            this.personId = _data["personId"];
            this.name = _data["name"] ? TextSearch.fromJS(_data["name"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailableVeterinaryForClinicSearch {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableVeterinaryForClinicSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["veterinaryId"] = this.veterinaryId;
        data["clinicId"] = this.clinicId;
        data["personId"] = this.personId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailableVeterinaryForClinicSearch extends IPaginatedSearch {
    languageId?: number;
    veterinaryId?: number;
    clinicId?: number;
    personId?: number;
    name?: TextSearch | undefined;
}

export class PaginatedResultsOfClinicDto implements IPaginatedResultsOfClinicDto {
    totalCount?: number;
    results?: ClinicDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfClinicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ClinicDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfClinicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfClinicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfClinicDto {
    totalCount?: number;
    results?: ClinicDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class VeterinarySearch extends PaginatedSearch implements IVeterinarySearch {
    veterinaryId?: number;

    constructor(data?: IVeterinarySearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.veterinaryId = _data["veterinaryId"];
        }
    }

    static fromJS(data: any): VeterinarySearch {
        data = typeof data === 'object' ? data : {};
        let result = new VeterinarySearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["veterinaryId"] = this.veterinaryId;
        super.toJSON(data);
        return data;
    }
}

export interface IVeterinarySearch extends IPaginatedSearch {
    veterinaryId?: number;
}

export class WebUserDto implements IWebUserDto {
    webUserId?: number;
    personId?: number;
    mustChangePassword?: boolean;
    active?: boolean;
    password?: string | undefined;
    lastConnectionDate?: Date | undefined;

    constructor(data?: IWebUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webUserId = _data["webUserId"];
            this.personId = _data["personId"];
            this.mustChangePassword = _data["mustChangePassword"];
            this.active = _data["active"];
            this.password = _data["password"];
            this.lastConnectionDate = _data["lastConnectionDate"] ? new Date(_data["lastConnectionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WebUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webUserId"] = this.webUserId;
        data["personId"] = this.personId;
        data["mustChangePassword"] = this.mustChangePassword;
        data["active"] = this.active;
        data["password"] = this.password;
        data["lastConnectionDate"] = this.lastConnectionDate ? this.lastConnectionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWebUserDto {
    webUserId?: number;
    personId?: number;
    mustChangePassword?: boolean;
    active?: boolean;
    password?: string | undefined;
    lastConnectionDate?: Date | undefined;
}

export class DrupalWebUserDto implements IDrupalWebUserDto {
    personId?: number;
    personHonorificId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    languageId?: number;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    remark?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IDrupalWebUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.personHonorificId = _data["personHonorificId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageId = _data["languageId"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.remark = _data["remark"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): DrupalWebUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalWebUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["personHonorificId"] = this.personHonorificId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageId"] = this.languageId;
        data["phoneNumber"] = this.phoneNumber;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["number"] = this.number;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["remark"] = this.remark;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IDrupalWebUserDto {
    personId?: number;
    personHonorificId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    languageId?: number;
    phoneNumber?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    number?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    remark?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export class PaginatedResultsOfWorkAttestRequestGridDto implements IPaginatedResultsOfWorkAttestRequestGridDto {
    totalCount?: number;
    results?: WorkAttestRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfWorkAttestRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WorkAttestRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfWorkAttestRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfWorkAttestRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfWorkAttestRequestGridDto {
    totalCount?: number;
    results?: WorkAttestRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class WorkAttestRequestGridDto implements IWorkAttestRequestGridDto {
    workAttestRequestId?: number;
    requestId?: number;
    requestState?: string | undefined;
    requestStateId?: number;
    requestStateCode?: ERequestState;
    personId?: number;
    contact?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    dog?: string | undefined;
    dogId?: number;
    competitionDate?: Date;
    competitionCountry?: string | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;

    constructor(data?: IWorkAttestRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workAttestRequestId = _data["workAttestRequestId"];
            this.requestId = _data["requestId"];
            this.requestState = _data["requestState"];
            this.requestStateId = _data["requestStateId"];
            this.requestStateCode = _data["requestStateCode"];
            this.personId = _data["personId"];
            this.contact = _data["contact"];
            this.requestNumber = _data["requestNumber"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.dog = _data["dog"];
            this.dogId = _data["dogId"];
            this.competitionDate = _data["competitionDate"] ? new Date(_data["competitionDate"].toString()) : <any>undefined;
            this.competitionCountry = _data["competitionCountry"];
            this.isBlocked = _data["isBlocked"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): WorkAttestRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAttestRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workAttestRequestId"] = this.workAttestRequestId;
        data["requestId"] = this.requestId;
        data["requestState"] = this.requestState;
        data["requestStateId"] = this.requestStateId;
        data["requestStateCode"] = this.requestStateCode;
        data["personId"] = this.personId;
        data["contact"] = this.contact;
        data["requestNumber"] = this.requestNumber;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["dog"] = this.dog;
        data["dogId"] = this.dogId;
        data["competitionDate"] = this.competitionDate ? this.competitionDate.toISOString() : <any>undefined;
        data["competitionCountry"] = this.competitionCountry;
        data["isBlocked"] = this.isBlocked;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IWorkAttestRequestGridDto {
    workAttestRequestId?: number;
    requestId?: number;
    requestState?: string | undefined;
    requestStateId?: number;
    requestStateCode?: ERequestState;
    personId?: number;
    contact?: string | undefined;
    requestNumber?: string | undefined;
    requestDate?: Date;
    dog?: string | undefined;
    dogId?: number;
    competitionDate?: Date;
    competitionCountry?: string | undefined;
    isBlocked?: boolean;
    invoiceNumber?: string | undefined;
}

export class WorkAttestRequestSearch extends PaginatedSearch implements IWorkAttestRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    competitionCountry?: TextSearch | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IWorkAttestRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.dog = _data["dog"] ? TextSearch.fromJS(_data["dog"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.competitionCountry = _data["competitionCountry"] ? TextSearch.fromJS(_data["competitionCountry"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkAttestRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAttestRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dog"] = this.dog ? this.dog.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["competitionCountry"] = this.competitionCountry ? this.competitionCountry.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkAttestRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    dog?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    competitionCountry?: TextSearch | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class WorkAttestationRequestDto implements IWorkAttestationRequestDto {
    request?: RequestDto | undefined;
    requestId?: number;
    workAttestationRequestId?: number;
    dogId?: number;
    competitionDate?: Date;
    competitionCountryId?: number;
    competitionPoints?: string | undefined;
    competitionJudge?: string | undefined;
    competitionCity?: string | undefined;
    competitionCountry?: string | undefined;
    competitionType?: string | undefined;
    dogSharepointUri?: string | undefined;

    constructor(data?: IWorkAttestationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            this.requestId = _data["requestId"];
            this.workAttestationRequestId = _data["workAttestationRequestId"];
            this.dogId = _data["dogId"];
            this.competitionDate = _data["competitionDate"] ? new Date(_data["competitionDate"].toString()) : <any>undefined;
            this.competitionCountryId = _data["competitionCountryId"];
            this.competitionPoints = _data["competitionPoints"];
            this.competitionJudge = _data["competitionJudge"];
            this.competitionCity = _data["competitionCity"];
            this.competitionCountry = _data["competitionCountry"];
            this.competitionType = _data["competitionType"];
            this.dogSharepointUri = _data["dogSharepointUri"];
        }
    }

    static fromJS(data: any): WorkAttestationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAttestationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["requestId"] = this.requestId;
        data["workAttestationRequestId"] = this.workAttestationRequestId;
        data["dogId"] = this.dogId;
        data["competitionDate"] = this.competitionDate ? this.competitionDate.toISOString() : <any>undefined;
        data["competitionCountryId"] = this.competitionCountryId;
        data["competitionPoints"] = this.competitionPoints;
        data["competitionJudge"] = this.competitionJudge;
        data["competitionCity"] = this.competitionCity;
        data["competitionCountry"] = this.competitionCountry;
        data["competitionType"] = this.competitionType;
        data["dogSharepointUri"] = this.dogSharepointUri;
        return data;
    }
}

export interface IWorkAttestationRequestDto {
    request?: RequestDto | undefined;
    requestId?: number;
    workAttestationRequestId?: number;
    dogId?: number;
    competitionDate?: Date;
    competitionCountryId?: number;
    competitionPoints?: string | undefined;
    competitionJudge?: string | undefined;
    competitionCity?: string | undefined;
    competitionCountry?: string | undefined;
    competitionType?: string | undefined;
    dogSharepointUri?: string | undefined;
}

export class WorkbookIconDto implements IWorkbookIconDto {
    hasPedigree?: boolean;
    color?: string | undefined;

    constructor(data?: IWorkbookIconDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasPedigree = _data["hasPedigree"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): WorkbookIconDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookIconDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasPedigree"] = this.hasPedigree;
        data["color"] = this.color;
        return data;
    }
}

export interface IWorkbookIconDto {
    hasPedigree?: boolean;
    color?: string | undefined;
}

export class PaginatedResultsOfWorkbookRequestGridDto implements IPaginatedResultsOfWorkbookRequestGridDto {
    totalCount?: number;
    results?: WorkbookRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfWorkbookRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WorkbookRequestGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfWorkbookRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfWorkbookRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfWorkbookRequestGridDto {
    totalCount?: number;
    results?: WorkbookRequestGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class WorkbookRequestGridDto implements IWorkbookRequestGridDto {
    workbookRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    personId?: number;
    dogId?: number;
    clubId?: number;
    requestStateId?: number;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    parentRequestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequestType?: ERequestType | undefined;
    requestDate?: Date;
    requestState?: string | undefined;
    dog?: string | undefined;
    contact?: string | undefined;
    club?: string | undefined;
    workbook?: string | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: IWorkbookRequestGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookRequestId = _data["workbookRequestId"];
            this.requestId = _data["requestId"];
            this.requestStateCode = _data["requestStateCode"];
            this.personId = _data["personId"];
            this.dogId = _data["dogId"];
            this.clubId = _data["clubId"];
            this.requestStateId = _data["requestStateId"];
            this.isBlocked = _data["isBlocked"];
            this.requestNumber = _data["requestNumber"];
            this.parentRequestNumber = _data["parentRequestNumber"];
            this.parentRequestId = _data["parentRequestId"];
            this.parentRequestType = _data["parentRequestType"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.requestState = _data["requestState"];
            this.dog = _data["dog"];
            this.contact = _data["contact"];
            this.club = _data["club"];
            this.workbook = _data["workbook"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): WorkbookRequestGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookRequestGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookRequestId"] = this.workbookRequestId;
        data["requestId"] = this.requestId;
        data["requestStateCode"] = this.requestStateCode;
        data["personId"] = this.personId;
        data["dogId"] = this.dogId;
        data["clubId"] = this.clubId;
        data["requestStateId"] = this.requestStateId;
        data["isBlocked"] = this.isBlocked;
        data["requestNumber"] = this.requestNumber;
        data["parentRequestNumber"] = this.parentRequestNumber;
        data["parentRequestId"] = this.parentRequestId;
        data["parentRequestType"] = this.parentRequestType;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestState"] = this.requestState;
        data["dog"] = this.dog;
        data["contact"] = this.contact;
        data["club"] = this.club;
        data["workbook"] = this.workbook;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IWorkbookRequestGridDto {
    workbookRequestId?: number;
    requestId?: number;
    requestStateCode?: ERequestState;
    personId?: number;
    dogId?: number;
    clubId?: number;
    requestStateId?: number;
    isBlocked?: boolean;
    requestNumber?: string | undefined;
    parentRequestNumber?: string | undefined;
    parentRequestId?: number | undefined;
    parentRequestType?: ERequestType | undefined;
    requestDate?: Date;
    requestState?: string | undefined;
    dog?: string | undefined;
    contact?: string | undefined;
    club?: string | undefined;
    workbook?: string | undefined;
    invoiceNumber?: string | undefined;
}

export class WorkbookRequestSearch extends PaginatedSearch implements IWorkbookRequestSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    club?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;

    constructor(data?: IWorkbookRequestSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.languageId = _data["languageId"];
            this.requestNumber = _data["requestNumber"] ? TextSearch.fromJS(_data["requestNumber"]) : <any>undefined;
            this.contact = _data["contact"] ? TextSearch.fromJS(_data["contact"]) : <any>undefined;
            this.club = _data["club"] ? TextSearch.fromJS(_data["club"]) : <any>undefined;
            this.requestDate = _data["requestDate"] ? DateSearch.fromJS(_data["requestDate"]) : <any>undefined;
            this.requestStateId = _data["requestStateId"] ? ListSearchOfNullableInteger.fromJS(_data["requestStateId"]) : <any>undefined;
            this.isBlocked = _data["isBlocked"] ? BooleanSearch.fromJS(_data["isBlocked"]) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"] ? TextSearch.fromJS(_data["invoiceNumber"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkbookRequestSearch {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookRequestSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["requestNumber"] = this.requestNumber ? this.requestNumber.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toJSON() : <any>undefined;
        data["requestStateId"] = this.requestStateId ? this.requestStateId.toJSON() : <any>undefined;
        data["isBlocked"] = this.isBlocked ? this.isBlocked.toJSON() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber ? this.invoiceNumber.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkbookRequestSearch extends IPaginatedSearch {
    languageId?: number;
    requestNumber?: TextSearch | undefined;
    contact?: TextSearch | undefined;
    club?: TextSearch | undefined;
    requestDate?: DateSearch | undefined;
    requestStateId?: ListSearchOfNullableInteger | undefined;
    isBlocked?: BooleanSearch | undefined;
    invoiceNumber?: TextSearch | undefined;
}

export class WorkbookRequestDto implements IWorkbookRequestDto {
    workbookRequestId?: number;
    requestId?: number;
    dogId?: number;
    clubId?: number | undefined;
    dogSharepointUri?: string | undefined;
    registeredLetter?: boolean;
    request?: RequestDto | undefined;
    transientWorkbooksGridDtos?: TransientWorkbookGridDto[] | undefined;

    constructor(data?: IWorkbookRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookRequestId = _data["workbookRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.clubId = _data["clubId"];
            this.dogSharepointUri = _data["dogSharepointUri"];
            this.registeredLetter = _data["registeredLetter"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientWorkbooksGridDtos"])) {
                this.transientWorkbooksGridDtos = [] as any;
                for (let item of _data["transientWorkbooksGridDtos"])
                    this.transientWorkbooksGridDtos!.push(TransientWorkbookGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbookRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookRequestId"] = this.workbookRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["clubId"] = this.clubId;
        data["dogSharepointUri"] = this.dogSharepointUri;
        data["registeredLetter"] = this.registeredLetter;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientWorkbooksGridDtos)) {
            data["transientWorkbooksGridDtos"] = [];
            for (let item of this.transientWorkbooksGridDtos)
                data["transientWorkbooksGridDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkbookRequestDto {
    workbookRequestId?: number;
    requestId?: number;
    dogId?: number;
    clubId?: number | undefined;
    dogSharepointUri?: string | undefined;
    registeredLetter?: boolean;
    request?: RequestDto | undefined;
    transientWorkbooksGridDtos?: TransientWorkbookGridDto[] | undefined;
}

export class DrupalWorkbookRequestDto implements IDrupalWorkbookRequestDto {
    workbookRequestId?: number;
    requestId?: number;
    dogId?: number;
    clubId?: number | undefined;
    registeredLetter?: boolean;
    request?: RequestDto | undefined;
    transientWorkbooksGridDtos?: TransientWorkbookGridDto[] | undefined;

    constructor(data?: IDrupalWorkbookRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookRequestId = _data["workbookRequestId"];
            this.requestId = _data["requestId"];
            this.dogId = _data["dogId"];
            this.clubId = _data["clubId"];
            this.registeredLetter = _data["registeredLetter"];
            this.request = _data["request"] ? RequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["transientWorkbooksGridDtos"])) {
                this.transientWorkbooksGridDtos = [] as any;
                for (let item of _data["transientWorkbooksGridDtos"])
                    this.transientWorkbooksGridDtos!.push(TransientWorkbookGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DrupalWorkbookRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrupalWorkbookRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookRequestId"] = this.workbookRequestId;
        data["requestId"] = this.requestId;
        data["dogId"] = this.dogId;
        data["clubId"] = this.clubId;
        data["registeredLetter"] = this.registeredLetter;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.transientWorkbooksGridDtos)) {
            data["transientWorkbooksGridDtos"] = [];
            for (let item of this.transientWorkbooksGridDtos)
                data["transientWorkbooksGridDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDrupalWorkbookRequestDto {
    workbookRequestId?: number;
    requestId?: number;
    dogId?: number;
    clubId?: number | undefined;
    registeredLetter?: boolean;
    request?: RequestDto | undefined;
    transientWorkbooksGridDtos?: TransientWorkbookGridDto[] | undefined;
}

export class PaginatedResultsOfWorkbookTypeGridDto implements IPaginatedResultsOfWorkbookTypeGridDto {
    totalCount?: number;
    results?: WorkbookTypeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;

    constructor(data?: IPaginatedResultsOfWorkbookTypeGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WorkbookTypeGridDto.fromJS(item));
            }
            if (Array.isArray(_data["aggregateResults"])) {
                this.aggregateResults = [] as any;
                for (let item of _data["aggregateResults"])
                    this.aggregateResults!.push(IAggregateResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedResultsOfWorkbookTypeGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultsOfWorkbookTypeGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateResults)) {
            data["aggregateResults"] = [];
            for (let item of this.aggregateResults)
                data["aggregateResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedResultsOfWorkbookTypeGridDto {
    totalCount?: number;
    results?: WorkbookTypeGridDto[] | undefined;
    aggregateResults?: IAggregateResult[] | undefined;
}

export class WorkbookTypeSearch extends SelectorSearchOfInteger implements IWorkbookTypeSearch {
    workbookColorId?: ListSearchOfInteger | undefined;
    description?: TextSearch | undefined;
    hasPedigree?: BooleanSearch | undefined;
    canGiveWorkCertificate?: BooleanSearch | undefined;
    languageId?: number;

    constructor(data?: IWorkbookTypeSearch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workbookColorId = _data["workbookColorId"] ? ListSearchOfInteger.fromJS(_data["workbookColorId"]) : <any>undefined;
            this.description = _data["description"] ? TextSearch.fromJS(_data["description"]) : <any>undefined;
            this.hasPedigree = _data["hasPedigree"] ? BooleanSearch.fromJS(_data["hasPedigree"]) : <any>undefined;
            this.canGiveWorkCertificate = _data["canGiveWorkCertificate"] ? BooleanSearch.fromJS(_data["canGiveWorkCertificate"]) : <any>undefined;
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): WorkbookTypeSearch {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookTypeSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookColorId"] = this.workbookColorId ? this.workbookColorId.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["hasPedigree"] = this.hasPedigree ? this.hasPedigree.toJSON() : <any>undefined;
        data["canGiveWorkCertificate"] = this.canGiveWorkCertificate ? this.canGiveWorkCertificate.toJSON() : <any>undefined;
        data["languageId"] = this.languageId;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkbookTypeSearch extends ISelectorSearchOfInteger {
    workbookColorId?: ListSearchOfInteger | undefined;
    description?: TextSearch | undefined;
    hasPedigree?: BooleanSearch | undefined;
    canGiveWorkCertificate?: BooleanSearch | undefined;
    languageId?: number;
}

export abstract class FilterCriteriaBaseOfEListSearchTypeAndInteger implements IFilterCriteriaBaseOfEListSearchTypeAndInteger {
    criterias?: CombinableCriteriaOfEListSearchTypeAndInteger[] | undefined;
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;

    constructor(data?: IFilterCriteriaBaseOfEListSearchTypeAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["criterias"])) {
                this.criterias = [] as any;
                for (let item of _data["criterias"])
                    this.criterias!.push(CombinableCriteriaOfEListSearchTypeAndInteger.fromJS(item));
            }
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
            if (Array.isArray(_data["availableSearchTypes"])) {
                this.availableSearchTypes = [] as any;
                for (let item of _data["availableSearchTypes"])
                    this.availableSearchTypes!.push(item);
            }
            this.defaultSearchType = _data["defaultSearchType"];
        }
    }

    static fromJS(data: any): FilterCriteriaBaseOfEListSearchTypeAndInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterCriteriaBaseOfEListSearchTypeAndInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criterias)) {
            data["criterias"] = [];
            for (let item of this.criterias)
                data["criterias"].push(item.toJSON());
        }
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        if (Array.isArray(this.availableSearchTypes)) {
            data["availableSearchTypes"] = [];
            for (let item of this.availableSearchTypes)
                data["availableSearchTypes"].push(item);
        }
        data["defaultSearchType"] = this.defaultSearchType;
        return data;
    }
}

export interface IFilterCriteriaBaseOfEListSearchTypeAndInteger {
    criterias?: CombinableCriteriaOfEListSearchTypeAndInteger[] | undefined;
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;
    availableSearchTypes?: string[] | undefined;
    defaultSearchType?: string | undefined;
}

export class ListSearchOfInteger extends FilterCriteriaBaseOfEListSearchTypeAndInteger implements IListSearchOfInteger {

    constructor(data?: IListSearchOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ListSearchOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ListSearchOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IListSearchOfInteger extends IFilterCriteriaBaseOfEListSearchTypeAndInteger {
}

export class CombinableCriteriaOfEListSearchTypeAndInteger implements ICombinableCriteriaOfEListSearchTypeAndInteger {
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;

    constructor(data?: ICombinableCriteriaOfEListSearchTypeAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchMode = _data["searchMode"];
            this.value = _data["value"];
            this.secondaryValue = _data["secondaryValue"];
        }
    }

    static fromJS(data: any): CombinableCriteriaOfEListSearchTypeAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new CombinableCriteriaOfEListSearchTypeAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchMode"] = this.searchMode;
        data["value"] = this.value;
        data["secondaryValue"] = this.secondaryValue;
        return data;
    }
}

export interface ICombinableCriteriaOfEListSearchTypeAndInteger {
    searchMode?: EListSearchType;
    value?: number;
    secondaryValue?: number;
}

export class WorkbookTypeDto implements IWorkbookTypeDto {
    workbookTypeId?: number;
    name?: string | undefined;
    workbookColorId?: number;
    articleId?: number;
    hasPedigree?: boolean;
    canGiveWorkCertificate?: boolean;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    sociabilityTest?: boolean;
    isSticker?: boolean;
    template?: EDocumentTemplate | undefined;
    workbookTypeTranslations?: WorkbookTypeTranslationDto[] | undefined;

    constructor(data?: IWorkbookTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeId = _data["workbookTypeId"];
            this.name = _data["name"];
            this.workbookColorId = _data["workbookColorId"];
            this.articleId = _data["articleId"];
            this.hasPedigree = _data["hasPedigree"];
            this.canGiveWorkCertificate = _data["canGiveWorkCertificate"];
            this.remark = _data["remark"];
            this.cegekaId = _data["cegekaId"];
            this.sociabilityTest = _data["sociabilityTest"];
            this.isSticker = _data["isSticker"];
            this.template = _data["template"];
            if (Array.isArray(_data["workbookTypeTranslations"])) {
                this.workbookTypeTranslations = [] as any;
                for (let item of _data["workbookTypeTranslations"])
                    this.workbookTypeTranslations!.push(WorkbookTypeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkbookTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeId"] = this.workbookTypeId;
        data["name"] = this.name;
        data["workbookColorId"] = this.workbookColorId;
        data["articleId"] = this.articleId;
        data["hasPedigree"] = this.hasPedigree;
        data["canGiveWorkCertificate"] = this.canGiveWorkCertificate;
        data["remark"] = this.remark;
        data["cegekaId"] = this.cegekaId;
        data["sociabilityTest"] = this.sociabilityTest;
        data["isSticker"] = this.isSticker;
        data["template"] = this.template;
        if (Array.isArray(this.workbookTypeTranslations)) {
            data["workbookTypeTranslations"] = [];
            for (let item of this.workbookTypeTranslations)
                data["workbookTypeTranslations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkbookTypeDto {
    workbookTypeId?: number;
    name?: string | undefined;
    workbookColorId?: number;
    articleId?: number;
    hasPedigree?: boolean;
    canGiveWorkCertificate?: boolean;
    remark?: string | undefined;
    cegekaId?: string | undefined;
    sociabilityTest?: boolean;
    isSticker?: boolean;
    template?: EDocumentTemplate | undefined;
    workbookTypeTranslations?: WorkbookTypeTranslationDto[] | undefined;
}

export class WorkbookTypeTranslationDto implements IWorkbookTypeTranslationDto {
    workbookTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    workbookTypeTranslationId?: number;

    constructor(data?: IWorkbookTypeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookTypeId = _data["workbookTypeId"];
            this.languageId = _data["languageId"];
            this.text = _data["text"];
            this.workbookTypeTranslationId = _data["workbookTypeTranslationId"];
        }
    }

    static fromJS(data: any): WorkbookTypeTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkbookTypeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookTypeId"] = this.workbookTypeId;
        data["languageId"] = this.languageId;
        data["text"] = this.text;
        data["workbookTypeTranslationId"] = this.workbookTypeTranslationId;
        return data;
    }
}

export interface IWorkbookTypeTranslationDto {
    workbookTypeId?: number;
    languageId?: number;
    text?: string | undefined;
    workbookTypeTranslationId?: number;
}

export class ZoolyxAuthenticateCommand implements IZoolyxAuthenticateCommand {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IZoolyxAuthenticateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ZoolyxAuthenticateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ZoolyxAuthenticateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IZoolyxAuthenticateCommand {
    username?: string | undefined;
    password?: string | undefined;
}

export class TestDateDto implements ITestDateDto {
    dateTime?: Date;

    constructor(data?: ITestDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TestDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITestDateDto {
    dateTime?: Date;
}

export class HealthCheckViewModel implements IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: string | undefined;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;

    constructor(data?: IHealthCheckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalStatus = _data["globalStatus"];
            this.checkTime = _data["checkTime"];
            this.worstExecutionTime = _data["worstExecutionTime"];
            this.totalExecutionTime = _data["totalExecutionTime"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HealthCheckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalStatus"] = this.globalStatus;
        data["checkTime"] = this.checkTime;
        data["worstExecutionTime"] = this.worstExecutionTime;
        data["totalExecutionTime"] = this.totalExecutionTime;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHealthCheckViewModel {
    globalStatus?: string | undefined;
    checkTime?: string | undefined;
    worstExecutionTime?: string | undefined;
    totalExecutionTime?: string | undefined;
    entries?: HealthCheckEntryViewModel[] | undefined;
}

export class HealthCheckEntryViewModel implements IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;

    constructor(data?: IHealthCheckEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusDescription = _data["statusDescription"];
            this.executionTime = _data["executionTime"];
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (<any>this.context)![key] = _data["context"][key] !== undefined ? _data["context"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HealthCheckEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusDescription"] = this.statusDescription;
        data["executionTime"] = this.executionTime;
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (<any>data["context"])[key] = (<any>this.context)[key];
            }
        }
        return data;
    }
}

export interface IHealthCheckEntryViewModel {
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    statusDescription?: string | undefined;
    executionTime?: string | undefined;
    context?: { [key: string]: string[]; } | undefined;
}

export class ClientApiKey implements IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;

    constructor(data?: IClientApiKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.apiKey = _data["apiKey"];
            this.hashedApiKey = _data["hashedApiKey"];
        }
    }

    static fromJS(data: any): ClientApiKey {
        data = typeof data === 'object' ? data : {};
        let result = new ClientApiKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["apiKey"] = this.apiKey;
        data["hashedApiKey"] = this.hashedApiKey;
        return data;
    }
}

export interface IClientApiKey {
    clientName?: string | undefined;
    clientId?: string | undefined;
    apiKey?: string | undefined;
    hashedApiKey?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

export type SetAbortControllerFn = (ctrl: AbortController) => void;

export interface Configuration {
  basePath?: string; // override base path
  headers?: HeadersInit;
  beforeRequest?(context: RequestInit): Promise<RequestInit >;
  afterRequest?(response: Response): Promise<Response | void>;
}

export type Json = any;
export type HTTPMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE" | "OPTIONS";
export type HTTPHeaders = { [key: string]: string };